
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1ohhe", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $10356f2eee2d90cc$export$ffb0004e005737fa; }, function (v) { return $10356f2eee2d90cc$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $10356f2eee2d90cc$export$34b9dba7ce09269b; }, function (v) { return $10356f2eee2d90cc$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $10356f2eee2d90cc$export$25062201e9e25d76; }, function (v) { return $10356f2eee2d90cc$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $10356f2eee2d90cc$export$ffb0004e005737fa;
var $10356f2eee2d90cc$export$34b9dba7ce09269b;
var $10356f2eee2d90cc$export$25062201e9e25d76;
'use strict';

var $aEMJz = parcelRequire("aEMJz");
var $10356f2eee2d90cc$var$k = Symbol.for("react.element"), $10356f2eee2d90cc$var$l = Symbol.for("react.fragment"), $10356f2eee2d90cc$var$m = Object.prototype.hasOwnProperty, $10356f2eee2d90cc$var$n = $aEMJz.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $10356f2eee2d90cc$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $10356f2eee2d90cc$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$10356f2eee2d90cc$var$m.call(a, b) && !$10356f2eee2d90cc$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $10356f2eee2d90cc$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $10356f2eee2d90cc$var$n.current
    };
}
$10356f2eee2d90cc$export$ffb0004e005737fa = $10356f2eee2d90cc$var$l;
$10356f2eee2d90cc$export$34b9dba7ce09269b = $10356f2eee2d90cc$var$q;
$10356f2eee2d90cc$export$25062201e9e25d76 = $10356f2eee2d90cc$var$q;

});
parcelRegister("aEMJz", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gB01t"));

});
parcelRegister("gB01t", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $c1501e8a6a69fb42$export$dca3b0875bd9a954; }, function (v) { return $c1501e8a6a69fb42$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $c1501e8a6a69fb42$export$16fa2f45be04daa8; }, function (v) { return $c1501e8a6a69fb42$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $c1501e8a6a69fb42$export$ffb0004e005737fa; }, function (v) { return $c1501e8a6a69fb42$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $c1501e8a6a69fb42$export$e2c29f18771995cb; }, function (v) { return $c1501e8a6a69fb42$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $c1501e8a6a69fb42$export$221d75b3f55bb0bd; }, function (v) { return $c1501e8a6a69fb42$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $c1501e8a6a69fb42$export$5f8d39834fd61797; }, function (v) { return $c1501e8a6a69fb42$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $c1501e8a6a69fb42$export$74bf444e3cd11ea5; }, function (v) { return $c1501e8a6a69fb42$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c1501e8a6a69fb42$export$ae55be85d98224ed; }, function (v) { return $c1501e8a6a69fb42$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $c1501e8a6a69fb42$export$3ba232387fd5d6dd; }, function (v) { return $c1501e8a6a69fb42$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $c1501e8a6a69fb42$export$e530037191fcd5d7; }, function (v) { return $c1501e8a6a69fb42$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $c1501e8a6a69fb42$export$fd42f52fd3ae1109; }, function (v) { return $c1501e8a6a69fb42$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $c1501e8a6a69fb42$export$c8a8987d4410bf2d; }, function (v) { return $c1501e8a6a69fb42$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $c1501e8a6a69fb42$export$d38cd72104c1f0e9; }, function (v) { return $c1501e8a6a69fb42$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $c1501e8a6a69fb42$export$7d1e3a5e95ceca43; }, function (v) { return $c1501e8a6a69fb42$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $c1501e8a6a69fb42$export$257a8862b851cb5b; }, function (v) { return $c1501e8a6a69fb42$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $c1501e8a6a69fb42$export$a8257692ac88316c; }, function (v) { return $c1501e8a6a69fb42$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $c1501e8a6a69fb42$export$488013bae63b21da; }, function (v) { return $c1501e8a6a69fb42$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $c1501e8a6a69fb42$export$7c73462e0d25e514; }, function (v) { return $c1501e8a6a69fb42$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $c1501e8a6a69fb42$export$7568632d0d33d16d; }, function (v) { return $c1501e8a6a69fb42$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $c1501e8a6a69fb42$export$88948ce120ea2619; }, function (v) { return $c1501e8a6a69fb42$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $c1501e8a6a69fb42$export$35808ee640e87ca7; }, function (v) { return $c1501e8a6a69fb42$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $c1501e8a6a69fb42$export$fae74005e78b1a27; }, function (v) { return $c1501e8a6a69fb42$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $c1501e8a6a69fb42$export$dc8fbce3eb94dc1e; }, function (v) { return $c1501e8a6a69fb42$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $c1501e8a6a69fb42$export$6a7bc4e911dc01cf; }, function (v) { return $c1501e8a6a69fb42$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $c1501e8a6a69fb42$export$6d9c69b0de29b591; }, function (v) { return $c1501e8a6a69fb42$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $c1501e8a6a69fb42$export$f680877a34711e37; }, function (v) { return $c1501e8a6a69fb42$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $c1501e8a6a69fb42$export$d5a552a76deda3c2; }, function (v) { return $c1501e8a6a69fb42$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $c1501e8a6a69fb42$export$aaabe4eda9ed9969; }, function (v) { return $c1501e8a6a69fb42$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $c1501e8a6a69fb42$export$e5c5a5f917a5871c; }, function (v) { return $c1501e8a6a69fb42$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $c1501e8a6a69fb42$export$1538c33de8887b59; }, function (v) { return $c1501e8a6a69fb42$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $c1501e8a6a69fb42$export$13e3392192263954; }, function (v) { return $c1501e8a6a69fb42$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $c1501e8a6a69fb42$export$b8f5890fc79d6aca; }, function (v) { return $c1501e8a6a69fb42$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $c1501e8a6a69fb42$export$60241385465d0a34; }, function (v) { return $c1501e8a6a69fb42$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $c1501e8a6a69fb42$export$306c0aa65ff9ec16; }, function (v) { return $c1501e8a6a69fb42$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $c1501e8a6a69fb42$export$7b286972b8d8ccbf; }, function (v) { return $c1501e8a6a69fb42$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $c1501e8a6a69fb42$export$83d89fbfd8236492; }, function (v) { return $c1501e8a6a69fb42$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c1501e8a6a69fb42$export$dca3b0875bd9a954;
var $c1501e8a6a69fb42$export$16fa2f45be04daa8;
var $c1501e8a6a69fb42$export$ffb0004e005737fa;
var $c1501e8a6a69fb42$export$e2c29f18771995cb;
var $c1501e8a6a69fb42$export$221d75b3f55bb0bd;
var $c1501e8a6a69fb42$export$5f8d39834fd61797;
var $c1501e8a6a69fb42$export$74bf444e3cd11ea5;
var $c1501e8a6a69fb42$export$ae55be85d98224ed;
var $c1501e8a6a69fb42$export$3ba232387fd5d6dd;
var $c1501e8a6a69fb42$export$e530037191fcd5d7;
var $c1501e8a6a69fb42$export$fd42f52fd3ae1109;
var $c1501e8a6a69fb42$export$c8a8987d4410bf2d;
var $c1501e8a6a69fb42$export$d38cd72104c1f0e9;
var $c1501e8a6a69fb42$export$7d1e3a5e95ceca43;
var $c1501e8a6a69fb42$export$257a8862b851cb5b;
var $c1501e8a6a69fb42$export$a8257692ac88316c;
var $c1501e8a6a69fb42$export$488013bae63b21da;
var $c1501e8a6a69fb42$export$7c73462e0d25e514;
var $c1501e8a6a69fb42$export$7568632d0d33d16d;
var $c1501e8a6a69fb42$export$88948ce120ea2619;
var $c1501e8a6a69fb42$export$35808ee640e87ca7;
var $c1501e8a6a69fb42$export$fae74005e78b1a27;
var $c1501e8a6a69fb42$export$dc8fbce3eb94dc1e;
var $c1501e8a6a69fb42$export$6a7bc4e911dc01cf;
var $c1501e8a6a69fb42$export$6d9c69b0de29b591;
var $c1501e8a6a69fb42$export$f680877a34711e37;
var $c1501e8a6a69fb42$export$d5a552a76deda3c2;
var $c1501e8a6a69fb42$export$aaabe4eda9ed9969;
var $c1501e8a6a69fb42$export$e5c5a5f917a5871c;
var $c1501e8a6a69fb42$export$1538c33de8887b59;
var $c1501e8a6a69fb42$export$13e3392192263954;
var $c1501e8a6a69fb42$export$b8f5890fc79d6aca;
var $c1501e8a6a69fb42$export$60241385465d0a34;
var $c1501e8a6a69fb42$export$306c0aa65ff9ec16;
var $c1501e8a6a69fb42$export$7b286972b8d8ccbf;
var $c1501e8a6a69fb42$export$83d89fbfd8236492;
'use strict';
var $c1501e8a6a69fb42$var$l = Symbol.for("react.element"), $c1501e8a6a69fb42$var$n = Symbol.for("react.portal"), $c1501e8a6a69fb42$var$p = Symbol.for("react.fragment"), $c1501e8a6a69fb42$var$q = Symbol.for("react.strict_mode"), $c1501e8a6a69fb42$var$r = Symbol.for("react.profiler"), $c1501e8a6a69fb42$var$t = Symbol.for("react.provider"), $c1501e8a6a69fb42$var$u = Symbol.for("react.context"), $c1501e8a6a69fb42$var$v = Symbol.for("react.forward_ref"), $c1501e8a6a69fb42$var$w = Symbol.for("react.suspense"), $c1501e8a6a69fb42$var$x = Symbol.for("react.memo"), $c1501e8a6a69fb42$var$y = Symbol.for("react.lazy"), $c1501e8a6a69fb42$var$z = Symbol.iterator;
function $c1501e8a6a69fb42$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c1501e8a6a69fb42$var$z && a[$c1501e8a6a69fb42$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c1501e8a6a69fb42$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $c1501e8a6a69fb42$var$C = Object.assign, $c1501e8a6a69fb42$var$D = {};
function $c1501e8a6a69fb42$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $c1501e8a6a69fb42$var$D;
    this.updater = e || $c1501e8a6a69fb42$var$B;
}
$c1501e8a6a69fb42$var$E.prototype.isReactComponent = {};
$c1501e8a6a69fb42$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$c1501e8a6a69fb42$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $c1501e8a6a69fb42$var$F() {}
$c1501e8a6a69fb42$var$F.prototype = $c1501e8a6a69fb42$var$E.prototype;
function $c1501e8a6a69fb42$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $c1501e8a6a69fb42$var$D;
    this.updater = e || $c1501e8a6a69fb42$var$B;
}
var $c1501e8a6a69fb42$var$H = $c1501e8a6a69fb42$var$G.prototype = new $c1501e8a6a69fb42$var$F;
$c1501e8a6a69fb42$var$H.constructor = $c1501e8a6a69fb42$var$G;
$c1501e8a6a69fb42$var$C($c1501e8a6a69fb42$var$H, $c1501e8a6a69fb42$var$E.prototype);
$c1501e8a6a69fb42$var$H.isPureReactComponent = !0;
var $c1501e8a6a69fb42$var$I = Array.isArray, $c1501e8a6a69fb42$var$J = Object.prototype.hasOwnProperty, $c1501e8a6a69fb42$var$K = {
    current: null
}, $c1501e8a6a69fb42$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $c1501e8a6a69fb42$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$c1501e8a6a69fb42$var$J.call(b, d) && !$c1501e8a6a69fb42$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $c1501e8a6a69fb42$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $c1501e8a6a69fb42$var$K.current
    };
}
function $c1501e8a6a69fb42$var$N(a, b) {
    return {
        $$typeof: $c1501e8a6a69fb42$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $c1501e8a6a69fb42$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $c1501e8a6a69fb42$var$l;
}
function $c1501e8a6a69fb42$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $c1501e8a6a69fb42$var$P = /\/+/g;
function $c1501e8a6a69fb42$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $c1501e8a6a69fb42$var$escape("" + a.key) : b.toString(36);
}
function $c1501e8a6a69fb42$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $c1501e8a6a69fb42$var$l:
                case $c1501e8a6a69fb42$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $c1501e8a6a69fb42$var$Q(h, 0) : d, $c1501e8a6a69fb42$var$I(c) ? (e = "", null != a && (e = a.replace($c1501e8a6a69fb42$var$P, "$&/") + "/"), $c1501e8a6a69fb42$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($c1501e8a6a69fb42$var$O(c) && (c = $c1501e8a6a69fb42$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($c1501e8a6a69fb42$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($c1501e8a6a69fb42$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $c1501e8a6a69fb42$var$Q(k, g);
        h += $c1501e8a6a69fb42$var$R(k, b, e, f, c);
    }
    else if (f = $c1501e8a6a69fb42$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $c1501e8a6a69fb42$var$Q(k, g++), h += $c1501e8a6a69fb42$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $c1501e8a6a69fb42$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $c1501e8a6a69fb42$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $c1501e8a6a69fb42$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $c1501e8a6a69fb42$var$U = {
    current: null
}, $c1501e8a6a69fb42$var$V = {
    transition: null
}, $c1501e8a6a69fb42$var$W = {
    ReactCurrentDispatcher: $c1501e8a6a69fb42$var$U,
    ReactCurrentBatchConfig: $c1501e8a6a69fb42$var$V,
    ReactCurrentOwner: $c1501e8a6a69fb42$var$K
};
function $c1501e8a6a69fb42$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$c1501e8a6a69fb42$export$dca3b0875bd9a954 = {
    map: $c1501e8a6a69fb42$var$S,
    forEach: function(a, b, e) {
        $c1501e8a6a69fb42$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $c1501e8a6a69fb42$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $c1501e8a6a69fb42$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$c1501e8a6a69fb42$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$c1501e8a6a69fb42$export$16fa2f45be04daa8 = $c1501e8a6a69fb42$var$E;
$c1501e8a6a69fb42$export$ffb0004e005737fa = $c1501e8a6a69fb42$var$p;
$c1501e8a6a69fb42$export$e2c29f18771995cb = $c1501e8a6a69fb42$var$r;
$c1501e8a6a69fb42$export$221d75b3f55bb0bd = $c1501e8a6a69fb42$var$G;
$c1501e8a6a69fb42$export$5f8d39834fd61797 = $c1501e8a6a69fb42$var$q;
$c1501e8a6a69fb42$export$74bf444e3cd11ea5 = $c1501e8a6a69fb42$var$w;
$c1501e8a6a69fb42$export$ae55be85d98224ed = $c1501e8a6a69fb42$var$W;
$c1501e8a6a69fb42$export$3ba232387fd5d6dd = $c1501e8a6a69fb42$var$X;
$c1501e8a6a69fb42$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $c1501e8a6a69fb42$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $c1501e8a6a69fb42$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$c1501e8a6a69fb42$var$J.call(b, f) && !$c1501e8a6a69fb42$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $c1501e8a6a69fb42$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$c1501e8a6a69fb42$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $c1501e8a6a69fb42$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $c1501e8a6a69fb42$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$c1501e8a6a69fb42$export$c8a8987d4410bf2d = $c1501e8a6a69fb42$var$M;
$c1501e8a6a69fb42$export$d38cd72104c1f0e9 = function(a) {
    var b = $c1501e8a6a69fb42$var$M.bind(null, a);
    b.type = a;
    return b;
};
$c1501e8a6a69fb42$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$c1501e8a6a69fb42$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $c1501e8a6a69fb42$var$v,
        render: a
    };
};
$c1501e8a6a69fb42$export$a8257692ac88316c = $c1501e8a6a69fb42$var$O;
$c1501e8a6a69fb42$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $c1501e8a6a69fb42$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $c1501e8a6a69fb42$var$T
    };
};
$c1501e8a6a69fb42$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $c1501e8a6a69fb42$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$c1501e8a6a69fb42$export$7568632d0d33d16d = function(a) {
    var b = $c1501e8a6a69fb42$var$V.transition;
    $c1501e8a6a69fb42$var$V.transition = {};
    try {
        a();
    } finally{
        $c1501e8a6a69fb42$var$V.transition = b;
    }
};
$c1501e8a6a69fb42$export$88948ce120ea2619 = $c1501e8a6a69fb42$var$X;
$c1501e8a6a69fb42$export$35808ee640e87ca7 = function(a, b) {
    return $c1501e8a6a69fb42$var$U.current.useCallback(a, b);
};
$c1501e8a6a69fb42$export$fae74005e78b1a27 = function(a) {
    return $c1501e8a6a69fb42$var$U.current.useContext(a);
};
$c1501e8a6a69fb42$export$dc8fbce3eb94dc1e = function() {};
$c1501e8a6a69fb42$export$6a7bc4e911dc01cf = function(a) {
    return $c1501e8a6a69fb42$var$U.current.useDeferredValue(a);
};
$c1501e8a6a69fb42$export$6d9c69b0de29b591 = function(a, b) {
    return $c1501e8a6a69fb42$var$U.current.useEffect(a, b);
};
$c1501e8a6a69fb42$export$f680877a34711e37 = function() {
    return $c1501e8a6a69fb42$var$U.current.useId();
};
$c1501e8a6a69fb42$export$d5a552a76deda3c2 = function(a, b, e) {
    return $c1501e8a6a69fb42$var$U.current.useImperativeHandle(a, b, e);
};
$c1501e8a6a69fb42$export$aaabe4eda9ed9969 = function(a, b) {
    return $c1501e8a6a69fb42$var$U.current.useInsertionEffect(a, b);
};
$c1501e8a6a69fb42$export$e5c5a5f917a5871c = function(a, b) {
    return $c1501e8a6a69fb42$var$U.current.useLayoutEffect(a, b);
};
$c1501e8a6a69fb42$export$1538c33de8887b59 = function(a, b) {
    return $c1501e8a6a69fb42$var$U.current.useMemo(a, b);
};
$c1501e8a6a69fb42$export$13e3392192263954 = function(a, b, e) {
    return $c1501e8a6a69fb42$var$U.current.useReducer(a, b, e);
};
$c1501e8a6a69fb42$export$b8f5890fc79d6aca = function(a) {
    return $c1501e8a6a69fb42$var$U.current.useRef(a);
};
$c1501e8a6a69fb42$export$60241385465d0a34 = function(a) {
    return $c1501e8a6a69fb42$var$U.current.useState(a);
};
$c1501e8a6a69fb42$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $c1501e8a6a69fb42$var$U.current.useSyncExternalStore(a, b, e);
};
$c1501e8a6a69fb42$export$7b286972b8d8ccbf = function() {
    return $c1501e8a6a69fb42$var$U.current.useTransition();
};
$c1501e8a6a69fb42$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("f1oJI", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $aefa23277c986a08$export$ae55be85d98224ed; }, function (v) { return $aefa23277c986a08$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $aefa23277c986a08$export$d39a5bbd09211389; }, function (v) { return $aefa23277c986a08$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $aefa23277c986a08$export$882461b6382ed46c; }, function (v) { return $aefa23277c986a08$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $aefa23277c986a08$export$466bfc07425424d5; }, function (v) { return $aefa23277c986a08$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $aefa23277c986a08$export$cd75ccfd720a3cd4; }, function (v) { return $aefa23277c986a08$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $aefa23277c986a08$export$fa8d919ba61d84db; }, function (v) { return $aefa23277c986a08$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $aefa23277c986a08$export$757ceba2d55c277e; }, function (v) { return $aefa23277c986a08$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $aefa23277c986a08$export$b3890eb0ae9dca99; }, function (v) { return $aefa23277c986a08$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $aefa23277c986a08$export$502457920280e6be; }, function (v) { return $aefa23277c986a08$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $aefa23277c986a08$export$c78a37762a8d58e1; }, function (v) { return $aefa23277c986a08$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $aefa23277c986a08$export$dc54d992c10e8a18; }, function (v) { return $aefa23277c986a08$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $aefa23277c986a08$export$83d89fbfd8236492; }, function (v) { return $aefa23277c986a08$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $aefa23277c986a08$export$ae55be85d98224ed;
var $aefa23277c986a08$export$d39a5bbd09211389;
var $aefa23277c986a08$export$882461b6382ed46c;
var $aefa23277c986a08$export$466bfc07425424d5;
var $aefa23277c986a08$export$cd75ccfd720a3cd4;
var $aefa23277c986a08$export$fa8d919ba61d84db;
var $aefa23277c986a08$export$757ceba2d55c277e;
var $aefa23277c986a08$export$b3890eb0ae9dca99;
var $aefa23277c986a08$export$502457920280e6be;
var $aefa23277c986a08$export$c78a37762a8d58e1;
var $aefa23277c986a08$export$dc54d992c10e8a18;
var $aefa23277c986a08$export$83d89fbfd8236492;
'use strict';

var $aEMJz = parcelRequire("aEMJz");

var $8fzia = parcelRequire("8fzia");
function $aefa23277c986a08$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $aefa23277c986a08$var$da = new Set, $aefa23277c986a08$var$ea = {};
function $aefa23277c986a08$var$fa(a, b) {
    $aefa23277c986a08$var$ha(a, b);
    $aefa23277c986a08$var$ha(a + "Capture", b);
}
function $aefa23277c986a08$var$ha(a, b) {
    $aefa23277c986a08$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$aefa23277c986a08$var$da.add(b[a]);
}
var $aefa23277c986a08$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $aefa23277c986a08$var$ja = Object.prototype.hasOwnProperty, $aefa23277c986a08$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $aefa23277c986a08$var$la = {}, $aefa23277c986a08$var$ma = {};
function $aefa23277c986a08$var$oa(a) {
    if ($aefa23277c986a08$var$ja.call($aefa23277c986a08$var$ma, a)) return !0;
    if ($aefa23277c986a08$var$ja.call($aefa23277c986a08$var$la, a)) return !1;
    if ($aefa23277c986a08$var$ka.test(a)) return $aefa23277c986a08$var$ma[a] = !0;
    $aefa23277c986a08$var$la[a] = !0;
    return !1;
}
function $aefa23277c986a08$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $aefa23277c986a08$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $aefa23277c986a08$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $aefa23277c986a08$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $aefa23277c986a08$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $aefa23277c986a08$var$z[a] = new $aefa23277c986a08$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $aefa23277c986a08$var$z[b] = new $aefa23277c986a08$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $aefa23277c986a08$var$z[a] = new $aefa23277c986a08$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $aefa23277c986a08$var$z[a] = new $aefa23277c986a08$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $aefa23277c986a08$var$z[a] = new $aefa23277c986a08$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $aefa23277c986a08$var$z[a] = new $aefa23277c986a08$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $aefa23277c986a08$var$z[a] = new $aefa23277c986a08$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $aefa23277c986a08$var$z[a] = new $aefa23277c986a08$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $aefa23277c986a08$var$z[a] = new $aefa23277c986a08$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $aefa23277c986a08$var$ra = /[\-:]([a-z])/g;
function $aefa23277c986a08$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($aefa23277c986a08$var$ra, $aefa23277c986a08$var$sa);
    $aefa23277c986a08$var$z[b] = new $aefa23277c986a08$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($aefa23277c986a08$var$ra, $aefa23277c986a08$var$sa);
    $aefa23277c986a08$var$z[b] = new $aefa23277c986a08$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($aefa23277c986a08$var$ra, $aefa23277c986a08$var$sa);
    $aefa23277c986a08$var$z[b] = new $aefa23277c986a08$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $aefa23277c986a08$var$z[a] = new $aefa23277c986a08$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$aefa23277c986a08$var$z.xlinkHref = new $aefa23277c986a08$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $aefa23277c986a08$var$z[a] = new $aefa23277c986a08$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $aefa23277c986a08$var$ta(a, b, c, d) {
    var e = $aefa23277c986a08$var$z.hasOwnProperty(b) ? $aefa23277c986a08$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $aefa23277c986a08$var$qa(b, c, e, d) && (c = null), d || null === e ? $aefa23277c986a08$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $aefa23277c986a08$var$ua = $aEMJz.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $aefa23277c986a08$var$va = Symbol.for("react.element"), $aefa23277c986a08$var$wa = Symbol.for("react.portal"), $aefa23277c986a08$var$ya = Symbol.for("react.fragment"), $aefa23277c986a08$var$za = Symbol.for("react.strict_mode"), $aefa23277c986a08$var$Aa = Symbol.for("react.profiler"), $aefa23277c986a08$var$Ba = Symbol.for("react.provider"), $aefa23277c986a08$var$Ca = Symbol.for("react.context"), $aefa23277c986a08$var$Da = Symbol.for("react.forward_ref"), $aefa23277c986a08$var$Ea = Symbol.for("react.suspense"), $aefa23277c986a08$var$Fa = Symbol.for("react.suspense_list"), $aefa23277c986a08$var$Ga = Symbol.for("react.memo"), $aefa23277c986a08$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $aefa23277c986a08$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $aefa23277c986a08$var$Ja = Symbol.iterator;
function $aefa23277c986a08$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $aefa23277c986a08$var$Ja && a[$aefa23277c986a08$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $aefa23277c986a08$var$A = Object.assign, $aefa23277c986a08$var$La;
function $aefa23277c986a08$var$Ma(a) {
    if (void 0 === $aefa23277c986a08$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $aefa23277c986a08$var$La = b && b[1] || "";
    }
    return "\n" + $aefa23277c986a08$var$La + a;
}
var $aefa23277c986a08$var$Na = !1;
function $aefa23277c986a08$var$Oa(a, b) {
    if (!a || $aefa23277c986a08$var$Na) return "";
    $aefa23277c986a08$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $aefa23277c986a08$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $aefa23277c986a08$var$Ma(a) : "";
}
function $aefa23277c986a08$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $aefa23277c986a08$var$Ma(a.type);
        case 16:
            return $aefa23277c986a08$var$Ma("Lazy");
        case 13:
            return $aefa23277c986a08$var$Ma("Suspense");
        case 19:
            return $aefa23277c986a08$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $aefa23277c986a08$var$Oa(a.type, !1), a;
        case 11:
            return a = $aefa23277c986a08$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $aefa23277c986a08$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $aefa23277c986a08$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $aefa23277c986a08$var$ya:
            return "Fragment";
        case $aefa23277c986a08$var$wa:
            return "Portal";
        case $aefa23277c986a08$var$Aa:
            return "Profiler";
        case $aefa23277c986a08$var$za:
            return "StrictMode";
        case $aefa23277c986a08$var$Ea:
            return "Suspense";
        case $aefa23277c986a08$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $aefa23277c986a08$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $aefa23277c986a08$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $aefa23277c986a08$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $aefa23277c986a08$var$Ga:
            return b = a.displayName || null, null !== b ? b : $aefa23277c986a08$var$Qa(a.type) || "Memo";
        case $aefa23277c986a08$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $aefa23277c986a08$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $aefa23277c986a08$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $aefa23277c986a08$var$Qa(b);
        case 8:
            return b === $aefa23277c986a08$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $aefa23277c986a08$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $aefa23277c986a08$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $aefa23277c986a08$var$Ua(a) {
    var b = $aefa23277c986a08$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $aefa23277c986a08$var$Va(a) {
    a._valueTracker || (a._valueTracker = $aefa23277c986a08$var$Ua(a));
}
function $aefa23277c986a08$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $aefa23277c986a08$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $aefa23277c986a08$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $aefa23277c986a08$var$Ya(a, b) {
    var c = b.checked;
    return $aefa23277c986a08$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $aefa23277c986a08$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $aefa23277c986a08$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $aefa23277c986a08$var$ab(a, b) {
    b = b.checked;
    null != b && $aefa23277c986a08$var$ta(a, "checked", b, !1);
}
function $aefa23277c986a08$var$bb(a, b) {
    $aefa23277c986a08$var$ab(a, b);
    var c = $aefa23277c986a08$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $aefa23277c986a08$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $aefa23277c986a08$var$cb(a, b.type, $aefa23277c986a08$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $aefa23277c986a08$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $aefa23277c986a08$var$cb(a, b, c) {
    if ("number" !== b || $aefa23277c986a08$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $aefa23277c986a08$var$eb = Array.isArray;
function $aefa23277c986a08$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $aefa23277c986a08$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $aefa23277c986a08$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($aefa23277c986a08$var$p(91));
    return $aefa23277c986a08$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $aefa23277c986a08$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($aefa23277c986a08$var$p(92));
            if ($aefa23277c986a08$var$eb(c)) {
                if (1 < c.length) throw Error($aefa23277c986a08$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $aefa23277c986a08$var$Sa(c)
    };
}
function $aefa23277c986a08$var$ib(a, b) {
    var c = $aefa23277c986a08$var$Sa(b.value), d = $aefa23277c986a08$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $aefa23277c986a08$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $aefa23277c986a08$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $aefa23277c986a08$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $aefa23277c986a08$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $aefa23277c986a08$var$mb, $aefa23277c986a08$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $aefa23277c986a08$var$mb = $aefa23277c986a08$var$mb || document.createElement("div");
        $aefa23277c986a08$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $aefa23277c986a08$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $aefa23277c986a08$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $aefa23277c986a08$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $aefa23277c986a08$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($aefa23277c986a08$var$pb).forEach(function(a) {
    $aefa23277c986a08$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $aefa23277c986a08$var$pb[b] = $aefa23277c986a08$var$pb[a];
    });
});
function $aefa23277c986a08$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $aefa23277c986a08$var$pb.hasOwnProperty(a) && $aefa23277c986a08$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $aefa23277c986a08$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $aefa23277c986a08$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $aefa23277c986a08$var$tb = $aefa23277c986a08$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $aefa23277c986a08$var$ub(a, b) {
    if (b) {
        if ($aefa23277c986a08$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($aefa23277c986a08$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($aefa23277c986a08$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($aefa23277c986a08$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($aefa23277c986a08$var$p(62));
    }
}
function $aefa23277c986a08$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $aefa23277c986a08$var$wb = null;
function $aefa23277c986a08$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $aefa23277c986a08$var$yb = null, $aefa23277c986a08$var$zb = null, $aefa23277c986a08$var$Ab = null;
function $aefa23277c986a08$var$Bb(a) {
    if (a = $aefa23277c986a08$var$Cb(a)) {
        if ("function" !== typeof $aefa23277c986a08$var$yb) throw Error($aefa23277c986a08$var$p(280));
        var b = a.stateNode;
        b && (b = $aefa23277c986a08$var$Db(b), $aefa23277c986a08$var$yb(a.stateNode, a.type, b));
    }
}
function $aefa23277c986a08$var$Eb(a) {
    $aefa23277c986a08$var$zb ? $aefa23277c986a08$var$Ab ? $aefa23277c986a08$var$Ab.push(a) : $aefa23277c986a08$var$Ab = [
        a
    ] : $aefa23277c986a08$var$zb = a;
}
function $aefa23277c986a08$var$Fb() {
    if ($aefa23277c986a08$var$zb) {
        var a = $aefa23277c986a08$var$zb, b = $aefa23277c986a08$var$Ab;
        $aefa23277c986a08$var$Ab = $aefa23277c986a08$var$zb = null;
        $aefa23277c986a08$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$aefa23277c986a08$var$Bb(b[a]);
    }
}
function $aefa23277c986a08$var$Gb(a, b) {
    return a(b);
}
function $aefa23277c986a08$var$Hb() {}
var $aefa23277c986a08$var$Ib = !1;
function $aefa23277c986a08$var$Jb(a, b, c) {
    if ($aefa23277c986a08$var$Ib) return a(b, c);
    $aefa23277c986a08$var$Ib = !0;
    try {
        return $aefa23277c986a08$var$Gb(a, b, c);
    } finally{
        if ($aefa23277c986a08$var$Ib = !1, null !== $aefa23277c986a08$var$zb || null !== $aefa23277c986a08$var$Ab) $aefa23277c986a08$var$Hb(), $aefa23277c986a08$var$Fb();
    }
}
function $aefa23277c986a08$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $aefa23277c986a08$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($aefa23277c986a08$var$p(231, b, typeof c));
    return c;
}
var $aefa23277c986a08$var$Lb = !1;
if ($aefa23277c986a08$var$ia) try {
    var $aefa23277c986a08$var$Mb = {};
    Object.defineProperty($aefa23277c986a08$var$Mb, "passive", {
        get: function() {
            $aefa23277c986a08$var$Lb = !0;
        }
    });
    window.addEventListener("test", $aefa23277c986a08$var$Mb, $aefa23277c986a08$var$Mb);
    window.removeEventListener("test", $aefa23277c986a08$var$Mb, $aefa23277c986a08$var$Mb);
} catch (a) {
    $aefa23277c986a08$var$Lb = !1;
}
function $aefa23277c986a08$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $aefa23277c986a08$var$Ob = !1, $aefa23277c986a08$var$Pb = null, $aefa23277c986a08$var$Qb = !1, $aefa23277c986a08$var$Rb = null, $aefa23277c986a08$var$Sb = {
    onError: function(a) {
        $aefa23277c986a08$var$Ob = !0;
        $aefa23277c986a08$var$Pb = a;
    }
};
function $aefa23277c986a08$var$Tb(a, b, c, d, e, f, g, h, k) {
    $aefa23277c986a08$var$Ob = !1;
    $aefa23277c986a08$var$Pb = null;
    $aefa23277c986a08$var$Nb.apply($aefa23277c986a08$var$Sb, arguments);
}
function $aefa23277c986a08$var$Ub(a, b, c, d, e, f, g, h, k) {
    $aefa23277c986a08$var$Tb.apply(this, arguments);
    if ($aefa23277c986a08$var$Ob) {
        if ($aefa23277c986a08$var$Ob) {
            var l = $aefa23277c986a08$var$Pb;
            $aefa23277c986a08$var$Ob = !1;
            $aefa23277c986a08$var$Pb = null;
        } else throw Error($aefa23277c986a08$var$p(198));
        $aefa23277c986a08$var$Qb || ($aefa23277c986a08$var$Qb = !0, $aefa23277c986a08$var$Rb = l);
    }
}
function $aefa23277c986a08$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $aefa23277c986a08$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $aefa23277c986a08$var$Xb(a) {
    if ($aefa23277c986a08$var$Vb(a) !== a) throw Error($aefa23277c986a08$var$p(188));
}
function $aefa23277c986a08$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $aefa23277c986a08$var$Vb(a);
        if (null === b) throw Error($aefa23277c986a08$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $aefa23277c986a08$var$Xb(e), a;
                if (f === d) return $aefa23277c986a08$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($aefa23277c986a08$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($aefa23277c986a08$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($aefa23277c986a08$var$p(190));
    }
    if (3 !== c.tag) throw Error($aefa23277c986a08$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $aefa23277c986a08$var$Zb(a) {
    a = $aefa23277c986a08$var$Yb(a);
    return null !== a ? $aefa23277c986a08$var$$b(a) : null;
}
function $aefa23277c986a08$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $aefa23277c986a08$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $aefa23277c986a08$var$ac = $8fzia.unstable_scheduleCallback, $aefa23277c986a08$var$bc = $8fzia.unstable_cancelCallback, $aefa23277c986a08$var$cc = $8fzia.unstable_shouldYield, $aefa23277c986a08$var$dc = $8fzia.unstable_requestPaint, $aefa23277c986a08$var$B = $8fzia.unstable_now, $aefa23277c986a08$var$ec = $8fzia.unstable_getCurrentPriorityLevel, $aefa23277c986a08$var$fc = $8fzia.unstable_ImmediatePriority, $aefa23277c986a08$var$gc = $8fzia.unstable_UserBlockingPriority, $aefa23277c986a08$var$hc = $8fzia.unstable_NormalPriority, $aefa23277c986a08$var$ic = $8fzia.unstable_LowPriority, $aefa23277c986a08$var$jc = $8fzia.unstable_IdlePriority, $aefa23277c986a08$var$kc = null, $aefa23277c986a08$var$lc = null;
function $aefa23277c986a08$var$mc(a) {
    if ($aefa23277c986a08$var$lc && "function" === typeof $aefa23277c986a08$var$lc.onCommitFiberRoot) try {
        $aefa23277c986a08$var$lc.onCommitFiberRoot($aefa23277c986a08$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $aefa23277c986a08$var$oc = Math.clz32 ? Math.clz32 : $aefa23277c986a08$var$nc, $aefa23277c986a08$var$pc = Math.log, $aefa23277c986a08$var$qc = Math.LN2;
function $aefa23277c986a08$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($aefa23277c986a08$var$pc(a) / $aefa23277c986a08$var$qc | 0) | 0;
}
var $aefa23277c986a08$var$rc = 64, $aefa23277c986a08$var$sc = 4194304;
function $aefa23277c986a08$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $aefa23277c986a08$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $aefa23277c986a08$var$tc(h) : (f &= g, 0 !== f && (d = $aefa23277c986a08$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $aefa23277c986a08$var$tc(g) : 0 !== f && (d = $aefa23277c986a08$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $aefa23277c986a08$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $aefa23277c986a08$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $aefa23277c986a08$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $aefa23277c986a08$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $aefa23277c986a08$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $aefa23277c986a08$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $aefa23277c986a08$var$yc() {
    var a = $aefa23277c986a08$var$rc;
    $aefa23277c986a08$var$rc <<= 1;
    0 === ($aefa23277c986a08$var$rc & 4194240) && ($aefa23277c986a08$var$rc = 64);
    return a;
}
function $aefa23277c986a08$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $aefa23277c986a08$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $aefa23277c986a08$var$oc(b);
    a[b] = c;
}
function $aefa23277c986a08$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $aefa23277c986a08$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $aefa23277c986a08$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $aefa23277c986a08$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $aefa23277c986a08$var$C = 0;
function $aefa23277c986a08$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $aefa23277c986a08$var$Ec, $aefa23277c986a08$var$Fc, $aefa23277c986a08$var$Gc, $aefa23277c986a08$var$Hc, $aefa23277c986a08$var$Ic, $aefa23277c986a08$var$Jc = !1, $aefa23277c986a08$var$Kc = [], $aefa23277c986a08$var$Lc = null, $aefa23277c986a08$var$Mc = null, $aefa23277c986a08$var$Nc = null, $aefa23277c986a08$var$Oc = new Map, $aefa23277c986a08$var$Pc = new Map, $aefa23277c986a08$var$Qc = [], $aefa23277c986a08$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $aefa23277c986a08$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $aefa23277c986a08$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $aefa23277c986a08$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $aefa23277c986a08$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $aefa23277c986a08$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $aefa23277c986a08$var$Pc.delete(b.pointerId);
    }
}
function $aefa23277c986a08$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $aefa23277c986a08$var$Cb(b), null !== b && $aefa23277c986a08$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $aefa23277c986a08$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $aefa23277c986a08$var$Lc = $aefa23277c986a08$var$Tc($aefa23277c986a08$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $aefa23277c986a08$var$Mc = $aefa23277c986a08$var$Tc($aefa23277c986a08$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $aefa23277c986a08$var$Nc = $aefa23277c986a08$var$Tc($aefa23277c986a08$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $aefa23277c986a08$var$Oc.set(f, $aefa23277c986a08$var$Tc($aefa23277c986a08$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $aefa23277c986a08$var$Pc.set(f, $aefa23277c986a08$var$Tc($aefa23277c986a08$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $aefa23277c986a08$var$Vc(a) {
    var b = $aefa23277c986a08$var$Wc(a.target);
    if (null !== b) {
        var c = $aefa23277c986a08$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $aefa23277c986a08$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $aefa23277c986a08$var$Ic(a.priority, function() {
                        $aefa23277c986a08$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $aefa23277c986a08$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $aefa23277c986a08$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $aefa23277c986a08$var$wb = d;
            c.target.dispatchEvent(d);
            $aefa23277c986a08$var$wb = null;
        } else return b = $aefa23277c986a08$var$Cb(c), null !== b && $aefa23277c986a08$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $aefa23277c986a08$var$Zc(a, b, c) {
    $aefa23277c986a08$var$Xc(a) && c.delete(b);
}
function $aefa23277c986a08$var$$c() {
    $aefa23277c986a08$var$Jc = !1;
    null !== $aefa23277c986a08$var$Lc && $aefa23277c986a08$var$Xc($aefa23277c986a08$var$Lc) && ($aefa23277c986a08$var$Lc = null);
    null !== $aefa23277c986a08$var$Mc && $aefa23277c986a08$var$Xc($aefa23277c986a08$var$Mc) && ($aefa23277c986a08$var$Mc = null);
    null !== $aefa23277c986a08$var$Nc && $aefa23277c986a08$var$Xc($aefa23277c986a08$var$Nc) && ($aefa23277c986a08$var$Nc = null);
    $aefa23277c986a08$var$Oc.forEach($aefa23277c986a08$var$Zc);
    $aefa23277c986a08$var$Pc.forEach($aefa23277c986a08$var$Zc);
}
function $aefa23277c986a08$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $aefa23277c986a08$var$Jc || ($aefa23277c986a08$var$Jc = !0, $8fzia.unstable_scheduleCallback($8fzia.unstable_NormalPriority, $aefa23277c986a08$var$$c)));
}
function $aefa23277c986a08$var$bd(a) {
    function b(b) {
        return $aefa23277c986a08$var$ad(b, a);
    }
    if (0 < $aefa23277c986a08$var$Kc.length) {
        $aefa23277c986a08$var$ad($aefa23277c986a08$var$Kc[0], a);
        for(var c = 1; c < $aefa23277c986a08$var$Kc.length; c++){
            var d = $aefa23277c986a08$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $aefa23277c986a08$var$Lc && $aefa23277c986a08$var$ad($aefa23277c986a08$var$Lc, a);
    null !== $aefa23277c986a08$var$Mc && $aefa23277c986a08$var$ad($aefa23277c986a08$var$Mc, a);
    null !== $aefa23277c986a08$var$Nc && $aefa23277c986a08$var$ad($aefa23277c986a08$var$Nc, a);
    $aefa23277c986a08$var$Oc.forEach(b);
    $aefa23277c986a08$var$Pc.forEach(b);
    for(c = 0; c < $aefa23277c986a08$var$Qc.length; c++)d = $aefa23277c986a08$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $aefa23277c986a08$var$Qc.length && (c = $aefa23277c986a08$var$Qc[0], null === c.blockedOn);)$aefa23277c986a08$var$Vc(c), null === c.blockedOn && $aefa23277c986a08$var$Qc.shift();
}
var $aefa23277c986a08$var$cd = $aefa23277c986a08$var$ua.ReactCurrentBatchConfig, $aefa23277c986a08$var$dd = !0;
function $aefa23277c986a08$var$ed(a, b, c, d) {
    var e = $aefa23277c986a08$var$C, f = $aefa23277c986a08$var$cd.transition;
    $aefa23277c986a08$var$cd.transition = null;
    try {
        $aefa23277c986a08$var$C = 1, $aefa23277c986a08$var$fd(a, b, c, d);
    } finally{
        $aefa23277c986a08$var$C = e, $aefa23277c986a08$var$cd.transition = f;
    }
}
function $aefa23277c986a08$var$gd(a, b, c, d) {
    var e = $aefa23277c986a08$var$C, f = $aefa23277c986a08$var$cd.transition;
    $aefa23277c986a08$var$cd.transition = null;
    try {
        $aefa23277c986a08$var$C = 4, $aefa23277c986a08$var$fd(a, b, c, d);
    } finally{
        $aefa23277c986a08$var$C = e, $aefa23277c986a08$var$cd.transition = f;
    }
}
function $aefa23277c986a08$var$fd(a, b, c, d) {
    if ($aefa23277c986a08$var$dd) {
        var e = $aefa23277c986a08$var$Yc(a, b, c, d);
        if (null === e) $aefa23277c986a08$var$hd(a, b, d, $aefa23277c986a08$var$id, c), $aefa23277c986a08$var$Sc(a, d);
        else if ($aefa23277c986a08$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($aefa23277c986a08$var$Sc(a, d), b & 4 && -1 < $aefa23277c986a08$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $aefa23277c986a08$var$Cb(e);
                null !== f && $aefa23277c986a08$var$Ec(f);
                f = $aefa23277c986a08$var$Yc(a, b, c, d);
                null === f && $aefa23277c986a08$var$hd(a, b, d, $aefa23277c986a08$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $aefa23277c986a08$var$hd(a, b, d, null, c);
    }
}
var $aefa23277c986a08$var$id = null;
function $aefa23277c986a08$var$Yc(a, b, c, d) {
    $aefa23277c986a08$var$id = null;
    a = $aefa23277c986a08$var$xb(d);
    a = $aefa23277c986a08$var$Wc(a);
    if (null !== a) {
        if (b = $aefa23277c986a08$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $aefa23277c986a08$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $aefa23277c986a08$var$id = a;
    return null;
}
function $aefa23277c986a08$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($aefa23277c986a08$var$ec()){
                case $aefa23277c986a08$var$fc:
                    return 1;
                case $aefa23277c986a08$var$gc:
                    return 4;
                case $aefa23277c986a08$var$hc:
                case $aefa23277c986a08$var$ic:
                    return 16;
                case $aefa23277c986a08$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $aefa23277c986a08$var$kd = null, $aefa23277c986a08$var$ld = null, $aefa23277c986a08$var$md = null;
function $aefa23277c986a08$var$nd() {
    if ($aefa23277c986a08$var$md) return $aefa23277c986a08$var$md;
    var a, b = $aefa23277c986a08$var$ld, c = b.length, d, e = "value" in $aefa23277c986a08$var$kd ? $aefa23277c986a08$var$kd.value : $aefa23277c986a08$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $aefa23277c986a08$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $aefa23277c986a08$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $aefa23277c986a08$var$pd() {
    return !0;
}
function $aefa23277c986a08$var$qd() {
    return !1;
}
function $aefa23277c986a08$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $aefa23277c986a08$var$pd : $aefa23277c986a08$var$qd;
        this.isPropagationStopped = $aefa23277c986a08$var$qd;
        return this;
    }
    $aefa23277c986a08$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $aefa23277c986a08$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $aefa23277c986a08$var$pd);
        },
        persist: function() {},
        isPersistent: $aefa23277c986a08$var$pd
    });
    return b;
}
var $aefa23277c986a08$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $aefa23277c986a08$var$td = $aefa23277c986a08$var$rd($aefa23277c986a08$var$sd), $aefa23277c986a08$var$ud = $aefa23277c986a08$var$A({}, $aefa23277c986a08$var$sd, {
    view: 0,
    detail: 0
}), $aefa23277c986a08$var$vd = $aefa23277c986a08$var$rd($aefa23277c986a08$var$ud), $aefa23277c986a08$var$wd, $aefa23277c986a08$var$xd, $aefa23277c986a08$var$yd, $aefa23277c986a08$var$Ad = $aefa23277c986a08$var$A({}, $aefa23277c986a08$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $aefa23277c986a08$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $aefa23277c986a08$var$yd && ($aefa23277c986a08$var$yd && "mousemove" === a.type ? ($aefa23277c986a08$var$wd = a.screenX - $aefa23277c986a08$var$yd.screenX, $aefa23277c986a08$var$xd = a.screenY - $aefa23277c986a08$var$yd.screenY) : $aefa23277c986a08$var$xd = $aefa23277c986a08$var$wd = 0, $aefa23277c986a08$var$yd = a);
        return $aefa23277c986a08$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $aefa23277c986a08$var$xd;
    }
}), $aefa23277c986a08$var$Bd = $aefa23277c986a08$var$rd($aefa23277c986a08$var$Ad), $aefa23277c986a08$var$Cd = $aefa23277c986a08$var$A({}, $aefa23277c986a08$var$Ad, {
    dataTransfer: 0
}), $aefa23277c986a08$var$Dd = $aefa23277c986a08$var$rd($aefa23277c986a08$var$Cd), $aefa23277c986a08$var$Ed = $aefa23277c986a08$var$A({}, $aefa23277c986a08$var$ud, {
    relatedTarget: 0
}), $aefa23277c986a08$var$Fd = $aefa23277c986a08$var$rd($aefa23277c986a08$var$Ed), $aefa23277c986a08$var$Gd = $aefa23277c986a08$var$A({}, $aefa23277c986a08$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $aefa23277c986a08$var$Hd = $aefa23277c986a08$var$rd($aefa23277c986a08$var$Gd), $aefa23277c986a08$var$Id = $aefa23277c986a08$var$A({}, $aefa23277c986a08$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $aefa23277c986a08$var$Jd = $aefa23277c986a08$var$rd($aefa23277c986a08$var$Id), $aefa23277c986a08$var$Kd = $aefa23277c986a08$var$A({}, $aefa23277c986a08$var$sd, {
    data: 0
}), $aefa23277c986a08$var$Ld = $aefa23277c986a08$var$rd($aefa23277c986a08$var$Kd), $aefa23277c986a08$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $aefa23277c986a08$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $aefa23277c986a08$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $aefa23277c986a08$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $aefa23277c986a08$var$Od[a]) ? !!b[a] : !1;
}
function $aefa23277c986a08$var$zd() {
    return $aefa23277c986a08$var$Pd;
}
var $aefa23277c986a08$var$Qd = $aefa23277c986a08$var$A({}, $aefa23277c986a08$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $aefa23277c986a08$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $aefa23277c986a08$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $aefa23277c986a08$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $aefa23277c986a08$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $aefa23277c986a08$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $aefa23277c986a08$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $aefa23277c986a08$var$Rd = $aefa23277c986a08$var$rd($aefa23277c986a08$var$Qd), $aefa23277c986a08$var$Sd = $aefa23277c986a08$var$A({}, $aefa23277c986a08$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $aefa23277c986a08$var$Td = $aefa23277c986a08$var$rd($aefa23277c986a08$var$Sd), $aefa23277c986a08$var$Ud = $aefa23277c986a08$var$A({}, $aefa23277c986a08$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $aefa23277c986a08$var$zd
}), $aefa23277c986a08$var$Vd = $aefa23277c986a08$var$rd($aefa23277c986a08$var$Ud), $aefa23277c986a08$var$Wd = $aefa23277c986a08$var$A({}, $aefa23277c986a08$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $aefa23277c986a08$var$Xd = $aefa23277c986a08$var$rd($aefa23277c986a08$var$Wd), $aefa23277c986a08$var$Yd = $aefa23277c986a08$var$A({}, $aefa23277c986a08$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $aefa23277c986a08$var$Zd = $aefa23277c986a08$var$rd($aefa23277c986a08$var$Yd), $aefa23277c986a08$var$$d = [
    9,
    13,
    27,
    32
], $aefa23277c986a08$var$ae = $aefa23277c986a08$var$ia && "CompositionEvent" in window, $aefa23277c986a08$var$be = null;
$aefa23277c986a08$var$ia && "documentMode" in document && ($aefa23277c986a08$var$be = document.documentMode);
var $aefa23277c986a08$var$ce = $aefa23277c986a08$var$ia && "TextEvent" in window && !$aefa23277c986a08$var$be, $aefa23277c986a08$var$de = $aefa23277c986a08$var$ia && (!$aefa23277c986a08$var$ae || $aefa23277c986a08$var$be && 8 < $aefa23277c986a08$var$be && 11 >= $aefa23277c986a08$var$be), $aefa23277c986a08$var$ee = String.fromCharCode(32), $aefa23277c986a08$var$fe = !1;
function $aefa23277c986a08$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $aefa23277c986a08$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $aefa23277c986a08$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $aefa23277c986a08$var$ie = !1;
function $aefa23277c986a08$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $aefa23277c986a08$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $aefa23277c986a08$var$fe = !0;
            return $aefa23277c986a08$var$ee;
        case "textInput":
            return a = b.data, a === $aefa23277c986a08$var$ee && $aefa23277c986a08$var$fe ? null : a;
        default:
            return null;
    }
}
function $aefa23277c986a08$var$ke(a, b) {
    if ($aefa23277c986a08$var$ie) return "compositionend" === a || !$aefa23277c986a08$var$ae && $aefa23277c986a08$var$ge(a, b) ? (a = $aefa23277c986a08$var$nd(), $aefa23277c986a08$var$md = $aefa23277c986a08$var$ld = $aefa23277c986a08$var$kd = null, $aefa23277c986a08$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $aefa23277c986a08$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $aefa23277c986a08$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $aefa23277c986a08$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$aefa23277c986a08$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $aefa23277c986a08$var$ne(a, b, c, d) {
    $aefa23277c986a08$var$Eb(d);
    b = $aefa23277c986a08$var$oe(b, "onChange");
    0 < b.length && (c = new $aefa23277c986a08$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $aefa23277c986a08$var$pe = null, $aefa23277c986a08$var$qe = null;
function $aefa23277c986a08$var$re(a) {
    $aefa23277c986a08$var$se(a, 0);
}
function $aefa23277c986a08$var$te(a) {
    var b = $aefa23277c986a08$var$ue(a);
    if ($aefa23277c986a08$var$Wa(b)) return a;
}
function $aefa23277c986a08$var$ve(a, b) {
    if ("change" === a) return b;
}
var $aefa23277c986a08$var$we = !1;
if ($aefa23277c986a08$var$ia) {
    var $aefa23277c986a08$var$xe;
    if ($aefa23277c986a08$var$ia) {
        var $aefa23277c986a08$var$ye = "oninput" in document;
        if (!$aefa23277c986a08$var$ye) {
            var $aefa23277c986a08$var$ze = document.createElement("div");
            $aefa23277c986a08$var$ze.setAttribute("oninput", "return;");
            $aefa23277c986a08$var$ye = "function" === typeof $aefa23277c986a08$var$ze.oninput;
        }
        $aefa23277c986a08$var$xe = $aefa23277c986a08$var$ye;
    } else $aefa23277c986a08$var$xe = !1;
    $aefa23277c986a08$var$we = $aefa23277c986a08$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $aefa23277c986a08$var$Ae() {
    $aefa23277c986a08$var$pe && ($aefa23277c986a08$var$pe.detachEvent("onpropertychange", $aefa23277c986a08$var$Be), $aefa23277c986a08$var$qe = $aefa23277c986a08$var$pe = null);
}
function $aefa23277c986a08$var$Be(a) {
    if ("value" === a.propertyName && $aefa23277c986a08$var$te($aefa23277c986a08$var$qe)) {
        var b = [];
        $aefa23277c986a08$var$ne(b, $aefa23277c986a08$var$qe, a, $aefa23277c986a08$var$xb(a));
        $aefa23277c986a08$var$Jb($aefa23277c986a08$var$re, b);
    }
}
function $aefa23277c986a08$var$Ce(a, b, c) {
    "focusin" === a ? ($aefa23277c986a08$var$Ae(), $aefa23277c986a08$var$pe = b, $aefa23277c986a08$var$qe = c, $aefa23277c986a08$var$pe.attachEvent("onpropertychange", $aefa23277c986a08$var$Be)) : "focusout" === a && $aefa23277c986a08$var$Ae();
}
function $aefa23277c986a08$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $aefa23277c986a08$var$te($aefa23277c986a08$var$qe);
}
function $aefa23277c986a08$var$Ee(a, b) {
    if ("click" === a) return $aefa23277c986a08$var$te(b);
}
function $aefa23277c986a08$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $aefa23277c986a08$var$te(b);
}
function $aefa23277c986a08$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $aefa23277c986a08$var$He = "function" === typeof Object.is ? Object.is : $aefa23277c986a08$var$Ge;
function $aefa23277c986a08$var$Ie(a, b) {
    if ($aefa23277c986a08$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$aefa23277c986a08$var$ja.call(b, e) || !$aefa23277c986a08$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $aefa23277c986a08$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $aefa23277c986a08$var$Ke(a, b) {
    var c = $aefa23277c986a08$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $aefa23277c986a08$var$Je(c);
    }
}
function $aefa23277c986a08$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $aefa23277c986a08$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $aefa23277c986a08$var$Me() {
    for(var a = window, b = $aefa23277c986a08$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $aefa23277c986a08$var$Xa(a.document);
    }
    return b;
}
function $aefa23277c986a08$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $aefa23277c986a08$var$Oe(a) {
    var b = $aefa23277c986a08$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $aefa23277c986a08$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $aefa23277c986a08$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $aefa23277c986a08$var$Ke(c, f);
                var g = $aefa23277c986a08$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $aefa23277c986a08$var$Pe = $aefa23277c986a08$var$ia && "documentMode" in document && 11 >= document.documentMode, $aefa23277c986a08$var$Qe = null, $aefa23277c986a08$var$Re = null, $aefa23277c986a08$var$Se = null, $aefa23277c986a08$var$Te = !1;
function $aefa23277c986a08$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $aefa23277c986a08$var$Te || null == $aefa23277c986a08$var$Qe || $aefa23277c986a08$var$Qe !== $aefa23277c986a08$var$Xa(d) || (d = $aefa23277c986a08$var$Qe, "selectionStart" in d && $aefa23277c986a08$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $aefa23277c986a08$var$Se && $aefa23277c986a08$var$Ie($aefa23277c986a08$var$Se, d) || ($aefa23277c986a08$var$Se = d, d = $aefa23277c986a08$var$oe($aefa23277c986a08$var$Re, "onSelect"), 0 < d.length && (b = new $aefa23277c986a08$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $aefa23277c986a08$var$Qe)));
}
function $aefa23277c986a08$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $aefa23277c986a08$var$We = {
    animationend: $aefa23277c986a08$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $aefa23277c986a08$var$Ve("Animation", "AnimationIteration"),
    animationstart: $aefa23277c986a08$var$Ve("Animation", "AnimationStart"),
    transitionend: $aefa23277c986a08$var$Ve("Transition", "TransitionEnd")
}, $aefa23277c986a08$var$Xe = {}, $aefa23277c986a08$var$Ye = {};
$aefa23277c986a08$var$ia && ($aefa23277c986a08$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $aefa23277c986a08$var$We.animationend.animation, delete $aefa23277c986a08$var$We.animationiteration.animation, delete $aefa23277c986a08$var$We.animationstart.animation), "TransitionEvent" in window || delete $aefa23277c986a08$var$We.transitionend.transition);
function $aefa23277c986a08$var$Ze(a) {
    if ($aefa23277c986a08$var$Xe[a]) return $aefa23277c986a08$var$Xe[a];
    if (!$aefa23277c986a08$var$We[a]) return a;
    var b = $aefa23277c986a08$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $aefa23277c986a08$var$Ye) return $aefa23277c986a08$var$Xe[a] = b[c];
    return a;
}
var $aefa23277c986a08$var$$e = $aefa23277c986a08$var$Ze("animationend"), $aefa23277c986a08$var$af = $aefa23277c986a08$var$Ze("animationiteration"), $aefa23277c986a08$var$bf = $aefa23277c986a08$var$Ze("animationstart"), $aefa23277c986a08$var$cf = $aefa23277c986a08$var$Ze("transitionend"), $aefa23277c986a08$var$df = new Map, $aefa23277c986a08$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $aefa23277c986a08$var$ff(a, b) {
    $aefa23277c986a08$var$df.set(a, b);
    $aefa23277c986a08$var$fa(b, [
        a
    ]);
}
for(var $aefa23277c986a08$var$gf = 0; $aefa23277c986a08$var$gf < $aefa23277c986a08$var$ef.length; $aefa23277c986a08$var$gf++){
    var $aefa23277c986a08$var$hf = $aefa23277c986a08$var$ef[$aefa23277c986a08$var$gf], $aefa23277c986a08$var$jf = $aefa23277c986a08$var$hf.toLowerCase(), $aefa23277c986a08$var$kf = $aefa23277c986a08$var$hf[0].toUpperCase() + $aefa23277c986a08$var$hf.slice(1);
    $aefa23277c986a08$var$ff($aefa23277c986a08$var$jf, "on" + $aefa23277c986a08$var$kf);
}
$aefa23277c986a08$var$ff($aefa23277c986a08$var$$e, "onAnimationEnd");
$aefa23277c986a08$var$ff($aefa23277c986a08$var$af, "onAnimationIteration");
$aefa23277c986a08$var$ff($aefa23277c986a08$var$bf, "onAnimationStart");
$aefa23277c986a08$var$ff("dblclick", "onDoubleClick");
$aefa23277c986a08$var$ff("focusin", "onFocus");
$aefa23277c986a08$var$ff("focusout", "onBlur");
$aefa23277c986a08$var$ff($aefa23277c986a08$var$cf, "onTransitionEnd");
$aefa23277c986a08$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$aefa23277c986a08$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$aefa23277c986a08$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$aefa23277c986a08$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$aefa23277c986a08$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$aefa23277c986a08$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$aefa23277c986a08$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$aefa23277c986a08$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$aefa23277c986a08$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$aefa23277c986a08$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $aefa23277c986a08$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $aefa23277c986a08$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($aefa23277c986a08$var$lf));
function $aefa23277c986a08$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $aefa23277c986a08$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $aefa23277c986a08$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $aefa23277c986a08$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $aefa23277c986a08$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($aefa23277c986a08$var$Qb) throw a = $aefa23277c986a08$var$Rb, $aefa23277c986a08$var$Qb = !1, $aefa23277c986a08$var$Rb = null, a;
}
function $aefa23277c986a08$var$D(a, b) {
    var c = b[$aefa23277c986a08$var$of];
    void 0 === c && (c = b[$aefa23277c986a08$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($aefa23277c986a08$var$pf(b, a, 2, !1), c.add(d));
}
function $aefa23277c986a08$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $aefa23277c986a08$var$pf(c, a, d, b);
}
var $aefa23277c986a08$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $aefa23277c986a08$var$sf(a) {
    if (!a[$aefa23277c986a08$var$rf]) {
        a[$aefa23277c986a08$var$rf] = !0;
        $aefa23277c986a08$var$da.forEach(function(b) {
            "selectionchange" !== b && ($aefa23277c986a08$var$mf.has(b) || $aefa23277c986a08$var$qf(b, !1, a), $aefa23277c986a08$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$aefa23277c986a08$var$rf] || (b[$aefa23277c986a08$var$rf] = !0, $aefa23277c986a08$var$qf("selectionchange", !1, b));
    }
}
function $aefa23277c986a08$var$pf(a, b, c, d) {
    switch($aefa23277c986a08$var$jd(b)){
        case 1:
            var e = $aefa23277c986a08$var$ed;
            break;
        case 4:
            e = $aefa23277c986a08$var$gd;
            break;
        default:
            e = $aefa23277c986a08$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$aefa23277c986a08$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $aefa23277c986a08$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $aefa23277c986a08$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $aefa23277c986a08$var$Jb(function() {
        var d = f, e = $aefa23277c986a08$var$xb(c), g = [];
        a: {
            var h = $aefa23277c986a08$var$df.get(a);
            if (void 0 !== h) {
                var k = $aefa23277c986a08$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $aefa23277c986a08$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $aefa23277c986a08$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $aefa23277c986a08$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $aefa23277c986a08$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $aefa23277c986a08$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $aefa23277c986a08$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $aefa23277c986a08$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $aefa23277c986a08$var$Vd;
                        break;
                    case $aefa23277c986a08$var$$e:
                    case $aefa23277c986a08$var$af:
                    case $aefa23277c986a08$var$bf:
                        k = $aefa23277c986a08$var$Hd;
                        break;
                    case $aefa23277c986a08$var$cf:
                        k = $aefa23277c986a08$var$Xd;
                        break;
                    case "scroll":
                        k = $aefa23277c986a08$var$vd;
                        break;
                    case "wheel":
                        k = $aefa23277c986a08$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $aefa23277c986a08$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $aefa23277c986a08$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $aefa23277c986a08$var$Kb(w, x), null != F && t.push($aefa23277c986a08$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $aefa23277c986a08$var$wb && (n = c.relatedTarget || c.fromElement) && ($aefa23277c986a08$var$Wc(n) || n[$aefa23277c986a08$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $aefa23277c986a08$var$Wc(n) : null, null !== n && (J = $aefa23277c986a08$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $aefa23277c986a08$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $aefa23277c986a08$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $aefa23277c986a08$var$ue(k);
                        u = null == n ? h : $aefa23277c986a08$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $aefa23277c986a08$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $aefa23277c986a08$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $aefa23277c986a08$var$vf(F))u++;
                            for(; 0 < w - u;)t = $aefa23277c986a08$var$vf(t), w--;
                            for(; 0 < u - w;)x = $aefa23277c986a08$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $aefa23277c986a08$var$vf(t);
                                x = $aefa23277c986a08$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $aefa23277c986a08$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $aefa23277c986a08$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $aefa23277c986a08$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $aefa23277c986a08$var$ve;
                else if ($aefa23277c986a08$var$me(h)) {
                    if ($aefa23277c986a08$var$we) na = $aefa23277c986a08$var$Fe;
                    else {
                        na = $aefa23277c986a08$var$De;
                        var xa = $aefa23277c986a08$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $aefa23277c986a08$var$Ee);
                if (na && (na = na(a, d))) {
                    $aefa23277c986a08$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $aefa23277c986a08$var$cb(h, "number", h.value);
            }
            xa = d ? $aefa23277c986a08$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($aefa23277c986a08$var$me(xa) || "true" === xa.contentEditable) $aefa23277c986a08$var$Qe = xa, $aefa23277c986a08$var$Re = d, $aefa23277c986a08$var$Se = null;
                    break;
                case "focusout":
                    $aefa23277c986a08$var$Se = $aefa23277c986a08$var$Re = $aefa23277c986a08$var$Qe = null;
                    break;
                case "mousedown":
                    $aefa23277c986a08$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $aefa23277c986a08$var$Te = !1;
                    $aefa23277c986a08$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($aefa23277c986a08$var$Pe) break;
                case "keydown":
                case "keyup":
                    $aefa23277c986a08$var$Ue(g, c, e);
            }
            var $a;
            if ($aefa23277c986a08$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $aefa23277c986a08$var$ie ? $aefa23277c986a08$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($aefa23277c986a08$var$de && "ko" !== c.locale && ($aefa23277c986a08$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $aefa23277c986a08$var$ie && ($a = $aefa23277c986a08$var$nd()) : ($aefa23277c986a08$var$kd = e, $aefa23277c986a08$var$ld = "value" in $aefa23277c986a08$var$kd ? $aefa23277c986a08$var$kd.value : $aefa23277c986a08$var$kd.textContent, $aefa23277c986a08$var$ie = !0)), xa = $aefa23277c986a08$var$oe(d, ba), 0 < xa.length && (ba = new $aefa23277c986a08$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $aefa23277c986a08$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $aefa23277c986a08$var$ce ? $aefa23277c986a08$var$je(a, c) : $aefa23277c986a08$var$ke(a, c)) d = $aefa23277c986a08$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $aefa23277c986a08$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $aefa23277c986a08$var$se(g, b);
    });
}
function $aefa23277c986a08$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $aefa23277c986a08$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $aefa23277c986a08$var$Kb(a, c), null != f && d.unshift($aefa23277c986a08$var$tf(a, f, e)), f = $aefa23277c986a08$var$Kb(a, b), null != f && d.push($aefa23277c986a08$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $aefa23277c986a08$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $aefa23277c986a08$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $aefa23277c986a08$var$Kb(c, f), null != k && g.unshift($aefa23277c986a08$var$tf(c, k, h))) : e || (k = $aefa23277c986a08$var$Kb(c, f), null != k && g.push($aefa23277c986a08$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $aefa23277c986a08$var$xf = /\r\n?/g, $aefa23277c986a08$var$yf = /\u0000|\uFFFD/g;
function $aefa23277c986a08$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($aefa23277c986a08$var$xf, "\n").replace($aefa23277c986a08$var$yf, "");
}
function $aefa23277c986a08$var$Af(a, b, c) {
    b = $aefa23277c986a08$var$zf(b);
    if ($aefa23277c986a08$var$zf(a) !== b && c) throw Error($aefa23277c986a08$var$p(425));
}
function $aefa23277c986a08$var$Bf() {}
var $aefa23277c986a08$var$Cf = null, $aefa23277c986a08$var$Df = null;
function $aefa23277c986a08$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $aefa23277c986a08$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $aefa23277c986a08$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $aefa23277c986a08$var$Hf = "function" === typeof Promise ? Promise : void 0, $aefa23277c986a08$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $aefa23277c986a08$var$Hf ? function(a) {
    return $aefa23277c986a08$var$Hf.resolve(null).then(a).catch($aefa23277c986a08$var$If);
} : $aefa23277c986a08$var$Ff;
function $aefa23277c986a08$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $aefa23277c986a08$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $aefa23277c986a08$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $aefa23277c986a08$var$bd(b);
}
function $aefa23277c986a08$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $aefa23277c986a08$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $aefa23277c986a08$var$Nf = Math.random().toString(36).slice(2), $aefa23277c986a08$var$Of = "__reactFiber$" + $aefa23277c986a08$var$Nf, $aefa23277c986a08$var$Pf = "__reactProps$" + $aefa23277c986a08$var$Nf, $aefa23277c986a08$var$uf = "__reactContainer$" + $aefa23277c986a08$var$Nf, $aefa23277c986a08$var$of = "__reactEvents$" + $aefa23277c986a08$var$Nf, $aefa23277c986a08$var$Qf = "__reactListeners$" + $aefa23277c986a08$var$Nf, $aefa23277c986a08$var$Rf = "__reactHandles$" + $aefa23277c986a08$var$Nf;
function $aefa23277c986a08$var$Wc(a) {
    var b = a[$aefa23277c986a08$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$aefa23277c986a08$var$uf] || c[$aefa23277c986a08$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $aefa23277c986a08$var$Mf(a); null !== a;){
                if (c = a[$aefa23277c986a08$var$Of]) return c;
                a = $aefa23277c986a08$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $aefa23277c986a08$var$Cb(a) {
    a = a[$aefa23277c986a08$var$Of] || a[$aefa23277c986a08$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $aefa23277c986a08$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($aefa23277c986a08$var$p(33));
}
function $aefa23277c986a08$var$Db(a) {
    return a[$aefa23277c986a08$var$Pf] || null;
}
var $aefa23277c986a08$var$Sf = [], $aefa23277c986a08$var$Tf = -1;
function $aefa23277c986a08$var$Uf(a) {
    return {
        current: a
    };
}
function $aefa23277c986a08$var$E(a) {
    0 > $aefa23277c986a08$var$Tf || (a.current = $aefa23277c986a08$var$Sf[$aefa23277c986a08$var$Tf], $aefa23277c986a08$var$Sf[$aefa23277c986a08$var$Tf] = null, $aefa23277c986a08$var$Tf--);
}
function $aefa23277c986a08$var$G(a, b) {
    $aefa23277c986a08$var$Tf++;
    $aefa23277c986a08$var$Sf[$aefa23277c986a08$var$Tf] = a.current;
    a.current = b;
}
var $aefa23277c986a08$var$Vf = {}, $aefa23277c986a08$var$H = $aefa23277c986a08$var$Uf($aefa23277c986a08$var$Vf), $aefa23277c986a08$var$Wf = $aefa23277c986a08$var$Uf(!1), $aefa23277c986a08$var$Xf = $aefa23277c986a08$var$Vf;
function $aefa23277c986a08$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $aefa23277c986a08$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $aefa23277c986a08$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $aefa23277c986a08$var$$f() {
    $aefa23277c986a08$var$E($aefa23277c986a08$var$Wf);
    $aefa23277c986a08$var$E($aefa23277c986a08$var$H);
}
function $aefa23277c986a08$var$ag(a, b, c) {
    if ($aefa23277c986a08$var$H.current !== $aefa23277c986a08$var$Vf) throw Error($aefa23277c986a08$var$p(168));
    $aefa23277c986a08$var$G($aefa23277c986a08$var$H, b);
    $aefa23277c986a08$var$G($aefa23277c986a08$var$Wf, c);
}
function $aefa23277c986a08$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($aefa23277c986a08$var$p(108, $aefa23277c986a08$var$Ra(a) || "Unknown", e));
    return $aefa23277c986a08$var$A({}, c, d);
}
function $aefa23277c986a08$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $aefa23277c986a08$var$Vf;
    $aefa23277c986a08$var$Xf = $aefa23277c986a08$var$H.current;
    $aefa23277c986a08$var$G($aefa23277c986a08$var$H, a);
    $aefa23277c986a08$var$G($aefa23277c986a08$var$Wf, $aefa23277c986a08$var$Wf.current);
    return !0;
}
function $aefa23277c986a08$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($aefa23277c986a08$var$p(169));
    c ? (a = $aefa23277c986a08$var$bg(a, b, $aefa23277c986a08$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $aefa23277c986a08$var$E($aefa23277c986a08$var$Wf), $aefa23277c986a08$var$E($aefa23277c986a08$var$H), $aefa23277c986a08$var$G($aefa23277c986a08$var$H, a)) : $aefa23277c986a08$var$E($aefa23277c986a08$var$Wf);
    $aefa23277c986a08$var$G($aefa23277c986a08$var$Wf, c);
}
var $aefa23277c986a08$var$eg = null, $aefa23277c986a08$var$fg = !1, $aefa23277c986a08$var$gg = !1;
function $aefa23277c986a08$var$hg(a) {
    null === $aefa23277c986a08$var$eg ? $aefa23277c986a08$var$eg = [
        a
    ] : $aefa23277c986a08$var$eg.push(a);
}
function $aefa23277c986a08$var$ig(a) {
    $aefa23277c986a08$var$fg = !0;
    $aefa23277c986a08$var$hg(a);
}
function $aefa23277c986a08$var$jg() {
    if (!$aefa23277c986a08$var$gg && null !== $aefa23277c986a08$var$eg) {
        $aefa23277c986a08$var$gg = !0;
        var a = 0, b = $aefa23277c986a08$var$C;
        try {
            var c = $aefa23277c986a08$var$eg;
            for($aefa23277c986a08$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $aefa23277c986a08$var$eg = null;
            $aefa23277c986a08$var$fg = !1;
        } catch (e) {
            throw null !== $aefa23277c986a08$var$eg && ($aefa23277c986a08$var$eg = $aefa23277c986a08$var$eg.slice(a + 1)), $aefa23277c986a08$var$ac($aefa23277c986a08$var$fc, $aefa23277c986a08$var$jg), e;
        } finally{
            $aefa23277c986a08$var$C = b, $aefa23277c986a08$var$gg = !1;
        }
    }
    return null;
}
var $aefa23277c986a08$var$kg = [], $aefa23277c986a08$var$lg = 0, $aefa23277c986a08$var$mg = null, $aefa23277c986a08$var$ng = 0, $aefa23277c986a08$var$og = [], $aefa23277c986a08$var$pg = 0, $aefa23277c986a08$var$qg = null, $aefa23277c986a08$var$rg = 1, $aefa23277c986a08$var$sg = "";
function $aefa23277c986a08$var$tg(a, b) {
    $aefa23277c986a08$var$kg[$aefa23277c986a08$var$lg++] = $aefa23277c986a08$var$ng;
    $aefa23277c986a08$var$kg[$aefa23277c986a08$var$lg++] = $aefa23277c986a08$var$mg;
    $aefa23277c986a08$var$mg = a;
    $aefa23277c986a08$var$ng = b;
}
function $aefa23277c986a08$var$ug(a, b, c) {
    $aefa23277c986a08$var$og[$aefa23277c986a08$var$pg++] = $aefa23277c986a08$var$rg;
    $aefa23277c986a08$var$og[$aefa23277c986a08$var$pg++] = $aefa23277c986a08$var$sg;
    $aefa23277c986a08$var$og[$aefa23277c986a08$var$pg++] = $aefa23277c986a08$var$qg;
    $aefa23277c986a08$var$qg = a;
    var d = $aefa23277c986a08$var$rg;
    a = $aefa23277c986a08$var$sg;
    var e = 32 - $aefa23277c986a08$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $aefa23277c986a08$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $aefa23277c986a08$var$rg = 1 << 32 - $aefa23277c986a08$var$oc(b) + e | c << e | d;
        $aefa23277c986a08$var$sg = f + a;
    } else $aefa23277c986a08$var$rg = 1 << f | c << e | d, $aefa23277c986a08$var$sg = a;
}
function $aefa23277c986a08$var$vg(a) {
    null !== a.return && ($aefa23277c986a08$var$tg(a, 1), $aefa23277c986a08$var$ug(a, 1, 0));
}
function $aefa23277c986a08$var$wg(a) {
    for(; a === $aefa23277c986a08$var$mg;)$aefa23277c986a08$var$mg = $aefa23277c986a08$var$kg[--$aefa23277c986a08$var$lg], $aefa23277c986a08$var$kg[$aefa23277c986a08$var$lg] = null, $aefa23277c986a08$var$ng = $aefa23277c986a08$var$kg[--$aefa23277c986a08$var$lg], $aefa23277c986a08$var$kg[$aefa23277c986a08$var$lg] = null;
    for(; a === $aefa23277c986a08$var$qg;)$aefa23277c986a08$var$qg = $aefa23277c986a08$var$og[--$aefa23277c986a08$var$pg], $aefa23277c986a08$var$og[$aefa23277c986a08$var$pg] = null, $aefa23277c986a08$var$sg = $aefa23277c986a08$var$og[--$aefa23277c986a08$var$pg], $aefa23277c986a08$var$og[$aefa23277c986a08$var$pg] = null, $aefa23277c986a08$var$rg = $aefa23277c986a08$var$og[--$aefa23277c986a08$var$pg], $aefa23277c986a08$var$og[$aefa23277c986a08$var$pg] = null;
}
var $aefa23277c986a08$var$xg = null, $aefa23277c986a08$var$yg = null, $aefa23277c986a08$var$I = !1, $aefa23277c986a08$var$zg = null;
function $aefa23277c986a08$var$Ag(a, b) {
    var c = $aefa23277c986a08$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $aefa23277c986a08$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $aefa23277c986a08$var$xg = a, $aefa23277c986a08$var$yg = $aefa23277c986a08$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $aefa23277c986a08$var$xg = a, $aefa23277c986a08$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $aefa23277c986a08$var$qg ? {
                id: $aefa23277c986a08$var$rg,
                overflow: $aefa23277c986a08$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $aefa23277c986a08$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $aefa23277c986a08$var$xg = a, $aefa23277c986a08$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $aefa23277c986a08$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $aefa23277c986a08$var$Eg(a) {
    if ($aefa23277c986a08$var$I) {
        var b = $aefa23277c986a08$var$yg;
        if (b) {
            var c = b;
            if (!$aefa23277c986a08$var$Cg(a, b)) {
                if ($aefa23277c986a08$var$Dg(a)) throw Error($aefa23277c986a08$var$p(418));
                b = $aefa23277c986a08$var$Lf(c.nextSibling);
                var d = $aefa23277c986a08$var$xg;
                b && $aefa23277c986a08$var$Cg(a, b) ? $aefa23277c986a08$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $aefa23277c986a08$var$I = !1, $aefa23277c986a08$var$xg = a);
            }
        } else {
            if ($aefa23277c986a08$var$Dg(a)) throw Error($aefa23277c986a08$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $aefa23277c986a08$var$I = !1;
            $aefa23277c986a08$var$xg = a;
        }
    }
}
function $aefa23277c986a08$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $aefa23277c986a08$var$xg = a;
}
function $aefa23277c986a08$var$Gg(a) {
    if (a !== $aefa23277c986a08$var$xg) return !1;
    if (!$aefa23277c986a08$var$I) return $aefa23277c986a08$var$Fg(a), $aefa23277c986a08$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$aefa23277c986a08$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $aefa23277c986a08$var$yg)) {
        if ($aefa23277c986a08$var$Dg(a)) throw $aefa23277c986a08$var$Hg(), Error($aefa23277c986a08$var$p(418));
        for(; b;)$aefa23277c986a08$var$Ag(a, b), b = $aefa23277c986a08$var$Lf(b.nextSibling);
    }
    $aefa23277c986a08$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($aefa23277c986a08$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $aefa23277c986a08$var$yg = $aefa23277c986a08$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $aefa23277c986a08$var$yg = null;
        }
    } else $aefa23277c986a08$var$yg = $aefa23277c986a08$var$xg ? $aefa23277c986a08$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $aefa23277c986a08$var$Hg() {
    for(var a = $aefa23277c986a08$var$yg; a;)a = $aefa23277c986a08$var$Lf(a.nextSibling);
}
function $aefa23277c986a08$var$Ig() {
    $aefa23277c986a08$var$yg = $aefa23277c986a08$var$xg = null;
    $aefa23277c986a08$var$I = !1;
}
function $aefa23277c986a08$var$Jg(a) {
    null === $aefa23277c986a08$var$zg ? $aefa23277c986a08$var$zg = [
        a
    ] : $aefa23277c986a08$var$zg.push(a);
}
var $aefa23277c986a08$var$Kg = $aefa23277c986a08$var$ua.ReactCurrentBatchConfig;
function $aefa23277c986a08$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($aefa23277c986a08$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($aefa23277c986a08$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($aefa23277c986a08$var$p(284));
        if (!c._owner) throw Error($aefa23277c986a08$var$p(290, a));
    }
    return a;
}
function $aefa23277c986a08$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($aefa23277c986a08$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $aefa23277c986a08$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $aefa23277c986a08$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $aefa23277c986a08$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $aefa23277c986a08$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $aefa23277c986a08$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $aefa23277c986a08$var$Ha && $aefa23277c986a08$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $aefa23277c986a08$var$Lg(a, b, c), d.return = a, d;
        d = $aefa23277c986a08$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $aefa23277c986a08$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $aefa23277c986a08$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $aefa23277c986a08$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $aefa23277c986a08$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $aefa23277c986a08$var$va:
                    return c = $aefa23277c986a08$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $aefa23277c986a08$var$Lg(a, null, b), c.return = a, c;
                case $aefa23277c986a08$var$wa:
                    return b = $aefa23277c986a08$var$Sg(b, a.mode, c), b.return = a, b;
                case $aefa23277c986a08$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($aefa23277c986a08$var$eb(b) || $aefa23277c986a08$var$Ka(b)) return b = $aefa23277c986a08$var$Tg(b, a.mode, c, null), b.return = a, b;
            $aefa23277c986a08$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $aefa23277c986a08$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $aefa23277c986a08$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $aefa23277c986a08$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($aefa23277c986a08$var$eb(c) || $aefa23277c986a08$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $aefa23277c986a08$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $aefa23277c986a08$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $aefa23277c986a08$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $aefa23277c986a08$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($aefa23277c986a08$var$eb(d) || $aefa23277c986a08$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $aefa23277c986a08$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $aefa23277c986a08$var$I && $aefa23277c986a08$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $aefa23277c986a08$var$I && $aefa23277c986a08$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $aefa23277c986a08$var$I && $aefa23277c986a08$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $aefa23277c986a08$var$Ka(h);
        if ("function" !== typeof l) throw Error($aefa23277c986a08$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($aefa23277c986a08$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $aefa23277c986a08$var$I && $aefa23277c986a08$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $aefa23277c986a08$var$I && $aefa23277c986a08$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $aefa23277c986a08$var$I && $aefa23277c986a08$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $aefa23277c986a08$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $aefa23277c986a08$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $aefa23277c986a08$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $aefa23277c986a08$var$Ha && $aefa23277c986a08$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $aefa23277c986a08$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $aefa23277c986a08$var$ya ? (d = $aefa23277c986a08$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $aefa23277c986a08$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $aefa23277c986a08$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $aefa23277c986a08$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $aefa23277c986a08$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $aefa23277c986a08$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($aefa23277c986a08$var$eb(f)) return n(a, d, f, h);
            if ($aefa23277c986a08$var$Ka(f)) return t(a, d, f, h);
            $aefa23277c986a08$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $aefa23277c986a08$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $aefa23277c986a08$var$Ug = $aefa23277c986a08$var$Og(!0), $aefa23277c986a08$var$Vg = $aefa23277c986a08$var$Og(!1), $aefa23277c986a08$var$Wg = $aefa23277c986a08$var$Uf(null), $aefa23277c986a08$var$Xg = null, $aefa23277c986a08$var$Yg = null, $aefa23277c986a08$var$Zg = null;
function $aefa23277c986a08$var$$g() {
    $aefa23277c986a08$var$Zg = $aefa23277c986a08$var$Yg = $aefa23277c986a08$var$Xg = null;
}
function $aefa23277c986a08$var$ah(a) {
    var b = $aefa23277c986a08$var$Wg.current;
    $aefa23277c986a08$var$E($aefa23277c986a08$var$Wg);
    a._currentValue = b;
}
function $aefa23277c986a08$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $aefa23277c986a08$var$ch(a, b) {
    $aefa23277c986a08$var$Xg = a;
    $aefa23277c986a08$var$Zg = $aefa23277c986a08$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($aefa23277c986a08$var$dh = !0), a.firstContext = null);
}
function $aefa23277c986a08$var$eh(a) {
    var b = a._currentValue;
    if ($aefa23277c986a08$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $aefa23277c986a08$var$Yg) {
            if (null === $aefa23277c986a08$var$Xg) throw Error($aefa23277c986a08$var$p(308));
            $aefa23277c986a08$var$Yg = a;
            $aefa23277c986a08$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $aefa23277c986a08$var$Yg = $aefa23277c986a08$var$Yg.next = a;
    }
    return b;
}
var $aefa23277c986a08$var$fh = null;
function $aefa23277c986a08$var$gh(a) {
    null === $aefa23277c986a08$var$fh ? $aefa23277c986a08$var$fh = [
        a
    ] : $aefa23277c986a08$var$fh.push(a);
}
function $aefa23277c986a08$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $aefa23277c986a08$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $aefa23277c986a08$var$ih(a, d);
}
function $aefa23277c986a08$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $aefa23277c986a08$var$jh = !1;
function $aefa23277c986a08$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $aefa23277c986a08$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $aefa23277c986a08$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $aefa23277c986a08$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($aefa23277c986a08$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $aefa23277c986a08$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $aefa23277c986a08$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $aefa23277c986a08$var$ih(a, c);
}
function $aefa23277c986a08$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $aefa23277c986a08$var$Cc(a, c);
    }
}
function $aefa23277c986a08$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $aefa23277c986a08$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $aefa23277c986a08$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $aefa23277c986a08$var$A({}, q, r);
                            break a;
                        case 2:
                            $aefa23277c986a08$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $aefa23277c986a08$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $aefa23277c986a08$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($aefa23277c986a08$var$p(191, e));
            e.call(d);
        }
    }
}
var $aefa23277c986a08$var$th = {}, $aefa23277c986a08$var$uh = $aefa23277c986a08$var$Uf($aefa23277c986a08$var$th), $aefa23277c986a08$var$vh = $aefa23277c986a08$var$Uf($aefa23277c986a08$var$th), $aefa23277c986a08$var$wh = $aefa23277c986a08$var$Uf($aefa23277c986a08$var$th);
function $aefa23277c986a08$var$xh(a) {
    if (a === $aefa23277c986a08$var$th) throw Error($aefa23277c986a08$var$p(174));
    return a;
}
function $aefa23277c986a08$var$yh(a, b) {
    $aefa23277c986a08$var$G($aefa23277c986a08$var$wh, b);
    $aefa23277c986a08$var$G($aefa23277c986a08$var$vh, a);
    $aefa23277c986a08$var$G($aefa23277c986a08$var$uh, $aefa23277c986a08$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $aefa23277c986a08$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $aefa23277c986a08$var$lb(b, a);
    }
    $aefa23277c986a08$var$E($aefa23277c986a08$var$uh);
    $aefa23277c986a08$var$G($aefa23277c986a08$var$uh, b);
}
function $aefa23277c986a08$var$zh() {
    $aefa23277c986a08$var$E($aefa23277c986a08$var$uh);
    $aefa23277c986a08$var$E($aefa23277c986a08$var$vh);
    $aefa23277c986a08$var$E($aefa23277c986a08$var$wh);
}
function $aefa23277c986a08$var$Ah(a) {
    $aefa23277c986a08$var$xh($aefa23277c986a08$var$wh.current);
    var b = $aefa23277c986a08$var$xh($aefa23277c986a08$var$uh.current);
    var c = $aefa23277c986a08$var$lb(b, a.type);
    b !== c && ($aefa23277c986a08$var$G($aefa23277c986a08$var$vh, a), $aefa23277c986a08$var$G($aefa23277c986a08$var$uh, c));
}
function $aefa23277c986a08$var$Bh(a) {
    $aefa23277c986a08$var$vh.current === a && ($aefa23277c986a08$var$E($aefa23277c986a08$var$uh), $aefa23277c986a08$var$E($aefa23277c986a08$var$vh));
}
var $aefa23277c986a08$var$L = $aefa23277c986a08$var$Uf(0);
function $aefa23277c986a08$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $aefa23277c986a08$var$Dh = [];
function $aefa23277c986a08$var$Eh() {
    for(var a = 0; a < $aefa23277c986a08$var$Dh.length; a++)$aefa23277c986a08$var$Dh[a]._workInProgressVersionPrimary = null;
    $aefa23277c986a08$var$Dh.length = 0;
}
var $aefa23277c986a08$var$Fh = $aefa23277c986a08$var$ua.ReactCurrentDispatcher, $aefa23277c986a08$var$Gh = $aefa23277c986a08$var$ua.ReactCurrentBatchConfig, $aefa23277c986a08$var$Hh = 0, $aefa23277c986a08$var$M = null, $aefa23277c986a08$var$N = null, $aefa23277c986a08$var$O = null, $aefa23277c986a08$var$Ih = !1, $aefa23277c986a08$var$Jh = !1, $aefa23277c986a08$var$Kh = 0, $aefa23277c986a08$var$Lh = 0;
function $aefa23277c986a08$var$P() {
    throw Error($aefa23277c986a08$var$p(321));
}
function $aefa23277c986a08$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$aefa23277c986a08$var$He(a[c], b[c])) return !1;
    return !0;
}
function $aefa23277c986a08$var$Nh(a, b, c, d, e, f) {
    $aefa23277c986a08$var$Hh = f;
    $aefa23277c986a08$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $aefa23277c986a08$var$Fh.current = null === a || null === a.memoizedState ? $aefa23277c986a08$var$Oh : $aefa23277c986a08$var$Ph;
    a = c(d, e);
    if ($aefa23277c986a08$var$Jh) {
        f = 0;
        do {
            $aefa23277c986a08$var$Jh = !1;
            $aefa23277c986a08$var$Kh = 0;
            if (25 <= f) throw Error($aefa23277c986a08$var$p(301));
            f += 1;
            $aefa23277c986a08$var$O = $aefa23277c986a08$var$N = null;
            b.updateQueue = null;
            $aefa23277c986a08$var$Fh.current = $aefa23277c986a08$var$Qh;
            a = c(d, e);
        }while ($aefa23277c986a08$var$Jh);
    }
    $aefa23277c986a08$var$Fh.current = $aefa23277c986a08$var$Rh;
    b = null !== $aefa23277c986a08$var$N && null !== $aefa23277c986a08$var$N.next;
    $aefa23277c986a08$var$Hh = 0;
    $aefa23277c986a08$var$O = $aefa23277c986a08$var$N = $aefa23277c986a08$var$M = null;
    $aefa23277c986a08$var$Ih = !1;
    if (b) throw Error($aefa23277c986a08$var$p(300));
    return a;
}
function $aefa23277c986a08$var$Sh() {
    var a = 0 !== $aefa23277c986a08$var$Kh;
    $aefa23277c986a08$var$Kh = 0;
    return a;
}
function $aefa23277c986a08$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $aefa23277c986a08$var$O ? $aefa23277c986a08$var$M.memoizedState = $aefa23277c986a08$var$O = a : $aefa23277c986a08$var$O = $aefa23277c986a08$var$O.next = a;
    return $aefa23277c986a08$var$O;
}
function $aefa23277c986a08$var$Uh() {
    if (null === $aefa23277c986a08$var$N) {
        var a = $aefa23277c986a08$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $aefa23277c986a08$var$N.next;
    var b = null === $aefa23277c986a08$var$O ? $aefa23277c986a08$var$M.memoizedState : $aefa23277c986a08$var$O.next;
    if (null !== b) $aefa23277c986a08$var$O = b, $aefa23277c986a08$var$N = a;
    else {
        if (null === a) throw Error($aefa23277c986a08$var$p(310));
        $aefa23277c986a08$var$N = a;
        a = {
            memoizedState: $aefa23277c986a08$var$N.memoizedState,
            baseState: $aefa23277c986a08$var$N.baseState,
            baseQueue: $aefa23277c986a08$var$N.baseQueue,
            queue: $aefa23277c986a08$var$N.queue,
            next: null
        };
        null === $aefa23277c986a08$var$O ? $aefa23277c986a08$var$M.memoizedState = $aefa23277c986a08$var$O = a : $aefa23277c986a08$var$O = $aefa23277c986a08$var$O.next = a;
    }
    return $aefa23277c986a08$var$O;
}
function $aefa23277c986a08$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $aefa23277c986a08$var$Wh(a) {
    var b = $aefa23277c986a08$var$Uh(), c = b.queue;
    if (null === c) throw Error($aefa23277c986a08$var$p(311));
    c.lastRenderedReducer = a;
    var d = $aefa23277c986a08$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($aefa23277c986a08$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $aefa23277c986a08$var$M.lanes |= m;
                $aefa23277c986a08$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $aefa23277c986a08$var$He(d, b.memoizedState) || ($aefa23277c986a08$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $aefa23277c986a08$var$M.lanes |= f, $aefa23277c986a08$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $aefa23277c986a08$var$Xh(a) {
    var b = $aefa23277c986a08$var$Uh(), c = b.queue;
    if (null === c) throw Error($aefa23277c986a08$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $aefa23277c986a08$var$He(f, b.memoizedState) || ($aefa23277c986a08$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $aefa23277c986a08$var$Yh() {}
function $aefa23277c986a08$var$Zh(a, b) {
    var c = $aefa23277c986a08$var$M, d = $aefa23277c986a08$var$Uh(), e = b(), f = !$aefa23277c986a08$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $aefa23277c986a08$var$dh = !0);
    d = d.queue;
    $aefa23277c986a08$var$$h($aefa23277c986a08$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $aefa23277c986a08$var$O && $aefa23277c986a08$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $aefa23277c986a08$var$bi(9, $aefa23277c986a08$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $aefa23277c986a08$var$Q) throw Error($aefa23277c986a08$var$p(349));
        0 !== ($aefa23277c986a08$var$Hh & 30) || $aefa23277c986a08$var$di(c, b, e);
    }
    return e;
}
function $aefa23277c986a08$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $aefa23277c986a08$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $aefa23277c986a08$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $aefa23277c986a08$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $aefa23277c986a08$var$ei(b) && $aefa23277c986a08$var$fi(a);
}
function $aefa23277c986a08$var$ai(a, b, c) {
    return c(function() {
        $aefa23277c986a08$var$ei(b) && $aefa23277c986a08$var$fi(a);
    });
}
function $aefa23277c986a08$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$aefa23277c986a08$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $aefa23277c986a08$var$fi(a) {
    var b = $aefa23277c986a08$var$ih(a, 1);
    null !== b && $aefa23277c986a08$var$gi(b, a, 1, -1);
}
function $aefa23277c986a08$var$hi(a) {
    var b = $aefa23277c986a08$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $aefa23277c986a08$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $aefa23277c986a08$var$ii.bind(null, $aefa23277c986a08$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $aefa23277c986a08$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $aefa23277c986a08$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $aefa23277c986a08$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $aefa23277c986a08$var$ji() {
    return $aefa23277c986a08$var$Uh().memoizedState;
}
function $aefa23277c986a08$var$ki(a, b, c, d) {
    var e = $aefa23277c986a08$var$Th();
    $aefa23277c986a08$var$M.flags |= a;
    e.memoizedState = $aefa23277c986a08$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $aefa23277c986a08$var$li(a, b, c, d) {
    var e = $aefa23277c986a08$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $aefa23277c986a08$var$N) {
        var g = $aefa23277c986a08$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $aefa23277c986a08$var$Mh(d, g.deps)) {
            e.memoizedState = $aefa23277c986a08$var$bi(b, c, f, d);
            return;
        }
    }
    $aefa23277c986a08$var$M.flags |= a;
    e.memoizedState = $aefa23277c986a08$var$bi(1 | b, c, f, d);
}
function $aefa23277c986a08$var$mi(a, b) {
    return $aefa23277c986a08$var$ki(8390656, 8, a, b);
}
function $aefa23277c986a08$var$$h(a, b) {
    return $aefa23277c986a08$var$li(2048, 8, a, b);
}
function $aefa23277c986a08$var$ni(a, b) {
    return $aefa23277c986a08$var$li(4, 2, a, b);
}
function $aefa23277c986a08$var$oi(a, b) {
    return $aefa23277c986a08$var$li(4, 4, a, b);
}
function $aefa23277c986a08$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $aefa23277c986a08$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $aefa23277c986a08$var$li(4, 4, $aefa23277c986a08$var$pi.bind(null, b, a), c);
}
function $aefa23277c986a08$var$ri() {}
function $aefa23277c986a08$var$si(a, b) {
    var c = $aefa23277c986a08$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $aefa23277c986a08$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $aefa23277c986a08$var$ti(a, b) {
    var c = $aefa23277c986a08$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $aefa23277c986a08$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $aefa23277c986a08$var$ui(a, b, c) {
    if (0 === ($aefa23277c986a08$var$Hh & 21)) return a.baseState && (a.baseState = !1, $aefa23277c986a08$var$dh = !0), a.memoizedState = c;
    $aefa23277c986a08$var$He(c, b) || (c = $aefa23277c986a08$var$yc(), $aefa23277c986a08$var$M.lanes |= c, $aefa23277c986a08$var$rh |= c, a.baseState = !0);
    return b;
}
function $aefa23277c986a08$var$vi(a, b) {
    var c = $aefa23277c986a08$var$C;
    $aefa23277c986a08$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $aefa23277c986a08$var$Gh.transition;
    $aefa23277c986a08$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $aefa23277c986a08$var$C = c, $aefa23277c986a08$var$Gh.transition = d;
    }
}
function $aefa23277c986a08$var$wi() {
    return $aefa23277c986a08$var$Uh().memoizedState;
}
function $aefa23277c986a08$var$xi(a, b, c) {
    var d = $aefa23277c986a08$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($aefa23277c986a08$var$zi(a)) $aefa23277c986a08$var$Ai(b, c);
    else if (c = $aefa23277c986a08$var$hh(a, b, c, d), null !== c) {
        var e = $aefa23277c986a08$var$R();
        $aefa23277c986a08$var$gi(c, a, d, e);
        $aefa23277c986a08$var$Bi(c, b, d);
    }
}
function $aefa23277c986a08$var$ii(a, b, c) {
    var d = $aefa23277c986a08$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($aefa23277c986a08$var$zi(a)) $aefa23277c986a08$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($aefa23277c986a08$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $aefa23277c986a08$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $aefa23277c986a08$var$hh(a, b, e, d);
        null !== c && (e = $aefa23277c986a08$var$R(), $aefa23277c986a08$var$gi(c, a, d, e), $aefa23277c986a08$var$Bi(c, b, d));
    }
}
function $aefa23277c986a08$var$zi(a) {
    var b = a.alternate;
    return a === $aefa23277c986a08$var$M || null !== b && b === $aefa23277c986a08$var$M;
}
function $aefa23277c986a08$var$Ai(a, b) {
    $aefa23277c986a08$var$Jh = $aefa23277c986a08$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $aefa23277c986a08$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $aefa23277c986a08$var$Cc(a, c);
    }
}
var $aefa23277c986a08$var$Rh = {
    readContext: $aefa23277c986a08$var$eh,
    useCallback: $aefa23277c986a08$var$P,
    useContext: $aefa23277c986a08$var$P,
    useEffect: $aefa23277c986a08$var$P,
    useImperativeHandle: $aefa23277c986a08$var$P,
    useInsertionEffect: $aefa23277c986a08$var$P,
    useLayoutEffect: $aefa23277c986a08$var$P,
    useMemo: $aefa23277c986a08$var$P,
    useReducer: $aefa23277c986a08$var$P,
    useRef: $aefa23277c986a08$var$P,
    useState: $aefa23277c986a08$var$P,
    useDebugValue: $aefa23277c986a08$var$P,
    useDeferredValue: $aefa23277c986a08$var$P,
    useTransition: $aefa23277c986a08$var$P,
    useMutableSource: $aefa23277c986a08$var$P,
    useSyncExternalStore: $aefa23277c986a08$var$P,
    useId: $aefa23277c986a08$var$P,
    unstable_isNewReconciler: !1
}, $aefa23277c986a08$var$Oh = {
    readContext: $aefa23277c986a08$var$eh,
    useCallback: function(a, b) {
        $aefa23277c986a08$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $aefa23277c986a08$var$eh,
    useEffect: $aefa23277c986a08$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $aefa23277c986a08$var$ki(4194308, 4, $aefa23277c986a08$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $aefa23277c986a08$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $aefa23277c986a08$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $aefa23277c986a08$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $aefa23277c986a08$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $aefa23277c986a08$var$xi.bind(null, $aefa23277c986a08$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $aefa23277c986a08$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $aefa23277c986a08$var$hi,
    useDebugValue: $aefa23277c986a08$var$ri,
    useDeferredValue: function(a) {
        return $aefa23277c986a08$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $aefa23277c986a08$var$hi(!1), b = a[0];
        a = $aefa23277c986a08$var$vi.bind(null, a[1]);
        $aefa23277c986a08$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $aefa23277c986a08$var$M, e = $aefa23277c986a08$var$Th();
        if ($aefa23277c986a08$var$I) {
            if (void 0 === c) throw Error($aefa23277c986a08$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $aefa23277c986a08$var$Q) throw Error($aefa23277c986a08$var$p(349));
            0 !== ($aefa23277c986a08$var$Hh & 30) || $aefa23277c986a08$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $aefa23277c986a08$var$mi($aefa23277c986a08$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $aefa23277c986a08$var$bi(9, $aefa23277c986a08$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $aefa23277c986a08$var$Th(), b = $aefa23277c986a08$var$Q.identifierPrefix;
        if ($aefa23277c986a08$var$I) {
            var c = $aefa23277c986a08$var$sg;
            var d = $aefa23277c986a08$var$rg;
            c = (d & ~(1 << 32 - $aefa23277c986a08$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $aefa23277c986a08$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $aefa23277c986a08$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $aefa23277c986a08$var$Ph = {
    readContext: $aefa23277c986a08$var$eh,
    useCallback: $aefa23277c986a08$var$si,
    useContext: $aefa23277c986a08$var$eh,
    useEffect: $aefa23277c986a08$var$$h,
    useImperativeHandle: $aefa23277c986a08$var$qi,
    useInsertionEffect: $aefa23277c986a08$var$ni,
    useLayoutEffect: $aefa23277c986a08$var$oi,
    useMemo: $aefa23277c986a08$var$ti,
    useReducer: $aefa23277c986a08$var$Wh,
    useRef: $aefa23277c986a08$var$ji,
    useState: function() {
        return $aefa23277c986a08$var$Wh($aefa23277c986a08$var$Vh);
    },
    useDebugValue: $aefa23277c986a08$var$ri,
    useDeferredValue: function(a) {
        var b = $aefa23277c986a08$var$Uh();
        return $aefa23277c986a08$var$ui(b, $aefa23277c986a08$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $aefa23277c986a08$var$Wh($aefa23277c986a08$var$Vh)[0], b = $aefa23277c986a08$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $aefa23277c986a08$var$Yh,
    useSyncExternalStore: $aefa23277c986a08$var$Zh,
    useId: $aefa23277c986a08$var$wi,
    unstable_isNewReconciler: !1
}, $aefa23277c986a08$var$Qh = {
    readContext: $aefa23277c986a08$var$eh,
    useCallback: $aefa23277c986a08$var$si,
    useContext: $aefa23277c986a08$var$eh,
    useEffect: $aefa23277c986a08$var$$h,
    useImperativeHandle: $aefa23277c986a08$var$qi,
    useInsertionEffect: $aefa23277c986a08$var$ni,
    useLayoutEffect: $aefa23277c986a08$var$oi,
    useMemo: $aefa23277c986a08$var$ti,
    useReducer: $aefa23277c986a08$var$Xh,
    useRef: $aefa23277c986a08$var$ji,
    useState: function() {
        return $aefa23277c986a08$var$Xh($aefa23277c986a08$var$Vh);
    },
    useDebugValue: $aefa23277c986a08$var$ri,
    useDeferredValue: function(a) {
        var b = $aefa23277c986a08$var$Uh();
        return null === $aefa23277c986a08$var$N ? b.memoizedState = a : $aefa23277c986a08$var$ui(b, $aefa23277c986a08$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $aefa23277c986a08$var$Xh($aefa23277c986a08$var$Vh)[0], b = $aefa23277c986a08$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $aefa23277c986a08$var$Yh,
    useSyncExternalStore: $aefa23277c986a08$var$Zh,
    useId: $aefa23277c986a08$var$wi,
    unstable_isNewReconciler: !1
};
function $aefa23277c986a08$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $aefa23277c986a08$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $aefa23277c986a08$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $aefa23277c986a08$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $aefa23277c986a08$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $aefa23277c986a08$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $aefa23277c986a08$var$R(), e = $aefa23277c986a08$var$yi(a), f = $aefa23277c986a08$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $aefa23277c986a08$var$nh(a, f, e);
        null !== b && ($aefa23277c986a08$var$gi(b, a, e, d), $aefa23277c986a08$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $aefa23277c986a08$var$R(), e = $aefa23277c986a08$var$yi(a), f = $aefa23277c986a08$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $aefa23277c986a08$var$nh(a, f, e);
        null !== b && ($aefa23277c986a08$var$gi(b, a, e, d), $aefa23277c986a08$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $aefa23277c986a08$var$R(), d = $aefa23277c986a08$var$yi(a), e = $aefa23277c986a08$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $aefa23277c986a08$var$nh(a, e, d);
        null !== b && ($aefa23277c986a08$var$gi(b, a, d, c), $aefa23277c986a08$var$oh(b, a, d));
    }
};
function $aefa23277c986a08$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$aefa23277c986a08$var$Ie(c, d) || !$aefa23277c986a08$var$Ie(e, f) : !0;
}
function $aefa23277c986a08$var$Gi(a, b, c) {
    var d = !1, e = $aefa23277c986a08$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $aefa23277c986a08$var$eh(f) : (e = $aefa23277c986a08$var$Zf(b) ? $aefa23277c986a08$var$Xf : $aefa23277c986a08$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $aefa23277c986a08$var$Yf(a, e) : $aefa23277c986a08$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $aefa23277c986a08$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $aefa23277c986a08$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $aefa23277c986a08$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $aefa23277c986a08$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $aefa23277c986a08$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $aefa23277c986a08$var$eh(f) : (f = $aefa23277c986a08$var$Zf(b) ? $aefa23277c986a08$var$Xf : $aefa23277c986a08$var$H.current, e.context = $aefa23277c986a08$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($aefa23277c986a08$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $aefa23277c986a08$var$Ei.enqueueReplaceState(e, e.state, null), $aefa23277c986a08$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $aefa23277c986a08$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $aefa23277c986a08$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $aefa23277c986a08$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $aefa23277c986a08$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $aefa23277c986a08$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $aefa23277c986a08$var$Ni(a, b, c) {
    c = $aefa23277c986a08$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $aefa23277c986a08$var$Oi || ($aefa23277c986a08$var$Oi = !0, $aefa23277c986a08$var$Pi = d);
        $aefa23277c986a08$var$Li(a, b);
    };
    return c;
}
function $aefa23277c986a08$var$Qi(a, b, c) {
    c = $aefa23277c986a08$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $aefa23277c986a08$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $aefa23277c986a08$var$Li(a, b);
        "function" !== typeof d && (null === $aefa23277c986a08$var$Ri ? $aefa23277c986a08$var$Ri = new Set([
            this
        ]) : $aefa23277c986a08$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $aefa23277c986a08$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $aefa23277c986a08$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $aefa23277c986a08$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $aefa23277c986a08$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $aefa23277c986a08$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $aefa23277c986a08$var$mh(-1, 1), b.tag = 2, $aefa23277c986a08$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $aefa23277c986a08$var$Wi = $aefa23277c986a08$var$ua.ReactCurrentOwner, $aefa23277c986a08$var$dh = !1;
function $aefa23277c986a08$var$Xi(a, b, c, d) {
    b.child = null === a ? $aefa23277c986a08$var$Vg(b, null, c, d) : $aefa23277c986a08$var$Ug(b, a.child, c, d);
}
function $aefa23277c986a08$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $aefa23277c986a08$var$ch(b, e);
    d = $aefa23277c986a08$var$Nh(a, b, c, d, f, e);
    c = $aefa23277c986a08$var$Sh();
    if (null !== a && !$aefa23277c986a08$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $aefa23277c986a08$var$Zi(a, b, e);
    $aefa23277c986a08$var$I && c && $aefa23277c986a08$var$vg(b);
    b.flags |= 1;
    $aefa23277c986a08$var$Xi(a, b, d, e);
    return b.child;
}
function $aefa23277c986a08$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$aefa23277c986a08$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $aefa23277c986a08$var$bj(a, b, f, d, e);
        a = $aefa23277c986a08$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $aefa23277c986a08$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $aefa23277c986a08$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $aefa23277c986a08$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $aefa23277c986a08$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($aefa23277c986a08$var$Ie(f, d) && a.ref === b.ref) {
            if ($aefa23277c986a08$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($aefa23277c986a08$var$dh = !0);
            else return b.lanes = a.lanes, $aefa23277c986a08$var$Zi(a, b, e);
        }
    }
    return $aefa23277c986a08$var$cj(a, b, c, d, e);
}
function $aefa23277c986a08$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $aefa23277c986a08$var$G($aefa23277c986a08$var$ej, $aefa23277c986a08$var$fj), $aefa23277c986a08$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $aefa23277c986a08$var$G($aefa23277c986a08$var$ej, $aefa23277c986a08$var$fj), $aefa23277c986a08$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $aefa23277c986a08$var$G($aefa23277c986a08$var$ej, $aefa23277c986a08$var$fj);
            $aefa23277c986a08$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $aefa23277c986a08$var$G($aefa23277c986a08$var$ej, $aefa23277c986a08$var$fj), $aefa23277c986a08$var$fj |= d;
    $aefa23277c986a08$var$Xi(a, b, e, c);
    return b.child;
}
function $aefa23277c986a08$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $aefa23277c986a08$var$cj(a, b, c, d, e) {
    var f = $aefa23277c986a08$var$Zf(c) ? $aefa23277c986a08$var$Xf : $aefa23277c986a08$var$H.current;
    f = $aefa23277c986a08$var$Yf(b, f);
    $aefa23277c986a08$var$ch(b, e);
    c = $aefa23277c986a08$var$Nh(a, b, c, d, f, e);
    d = $aefa23277c986a08$var$Sh();
    if (null !== a && !$aefa23277c986a08$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $aefa23277c986a08$var$Zi(a, b, e);
    $aefa23277c986a08$var$I && d && $aefa23277c986a08$var$vg(b);
    b.flags |= 1;
    $aefa23277c986a08$var$Xi(a, b, c, e);
    return b.child;
}
function $aefa23277c986a08$var$hj(a, b, c, d, e) {
    if ($aefa23277c986a08$var$Zf(c)) {
        var f = !0;
        $aefa23277c986a08$var$cg(b);
    } else f = !1;
    $aefa23277c986a08$var$ch(b, e);
    if (null === b.stateNode) $aefa23277c986a08$var$ij(a, b), $aefa23277c986a08$var$Gi(b, c, d), $aefa23277c986a08$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $aefa23277c986a08$var$eh(l) : (l = $aefa23277c986a08$var$Zf(c) ? $aefa23277c986a08$var$Xf : $aefa23277c986a08$var$H.current, l = $aefa23277c986a08$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $aefa23277c986a08$var$Hi(b, g, d, l);
        $aefa23277c986a08$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $aefa23277c986a08$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $aefa23277c986a08$var$Wf.current || $aefa23277c986a08$var$jh ? ("function" === typeof m && ($aefa23277c986a08$var$Di(b, c, m, d), k = b.memoizedState), (h = $aefa23277c986a08$var$jh || $aefa23277c986a08$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $aefa23277c986a08$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $aefa23277c986a08$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $aefa23277c986a08$var$eh(k) : (k = $aefa23277c986a08$var$Zf(c) ? $aefa23277c986a08$var$Xf : $aefa23277c986a08$var$H.current, k = $aefa23277c986a08$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $aefa23277c986a08$var$Hi(b, g, d, k);
        $aefa23277c986a08$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $aefa23277c986a08$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $aefa23277c986a08$var$Wf.current || $aefa23277c986a08$var$jh ? ("function" === typeof y && ($aefa23277c986a08$var$Di(b, c, y, d), n = b.memoizedState), (l = $aefa23277c986a08$var$jh || $aefa23277c986a08$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $aefa23277c986a08$var$jj(a, b, c, d, f, e);
}
function $aefa23277c986a08$var$jj(a, b, c, d, e, f) {
    $aefa23277c986a08$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $aefa23277c986a08$var$dg(b, c, !1), $aefa23277c986a08$var$Zi(a, b, f);
    d = b.stateNode;
    $aefa23277c986a08$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $aefa23277c986a08$var$Ug(b, a.child, null, f), b.child = $aefa23277c986a08$var$Ug(b, null, h, f)) : $aefa23277c986a08$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $aefa23277c986a08$var$dg(b, c, !0);
    return b.child;
}
function $aefa23277c986a08$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $aefa23277c986a08$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $aefa23277c986a08$var$ag(a, b.context, !1);
    $aefa23277c986a08$var$yh(a, b.containerInfo);
}
function $aefa23277c986a08$var$lj(a, b, c, d, e) {
    $aefa23277c986a08$var$Ig();
    $aefa23277c986a08$var$Jg(e);
    b.flags |= 256;
    $aefa23277c986a08$var$Xi(a, b, c, d);
    return b.child;
}
var $aefa23277c986a08$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $aefa23277c986a08$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $aefa23277c986a08$var$oj(a, b, c) {
    var d = b.pendingProps, e = $aefa23277c986a08$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $aefa23277c986a08$var$G($aefa23277c986a08$var$L, e & 1);
    if (null === a) {
        $aefa23277c986a08$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $aefa23277c986a08$var$pj(g, d, 0, null), a = $aefa23277c986a08$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $aefa23277c986a08$var$nj(c), b.memoizedState = $aefa23277c986a08$var$mj, a) : $aefa23277c986a08$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $aefa23277c986a08$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $aefa23277c986a08$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $aefa23277c986a08$var$Pg(h, f) : (f = $aefa23277c986a08$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $aefa23277c986a08$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $aefa23277c986a08$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $aefa23277c986a08$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $aefa23277c986a08$var$qj(a, b) {
    b = $aefa23277c986a08$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $aefa23277c986a08$var$sj(a, b, c, d) {
    null !== d && $aefa23277c986a08$var$Jg(d);
    $aefa23277c986a08$var$Ug(b, a.child, null, c);
    a = $aefa23277c986a08$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $aefa23277c986a08$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $aefa23277c986a08$var$Ki(Error($aefa23277c986a08$var$p(422))), $aefa23277c986a08$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $aefa23277c986a08$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $aefa23277c986a08$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $aefa23277c986a08$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $aefa23277c986a08$var$nj(g);
        b.memoizedState = $aefa23277c986a08$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $aefa23277c986a08$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($aefa23277c986a08$var$p(419));
        d = $aefa23277c986a08$var$Ki(f, d, void 0);
        return $aefa23277c986a08$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($aefa23277c986a08$var$dh || h) {
        d = $aefa23277c986a08$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $aefa23277c986a08$var$ih(a, e), $aefa23277c986a08$var$gi(d, a, e, -1));
        }
        $aefa23277c986a08$var$tj();
        d = $aefa23277c986a08$var$Ki(Error($aefa23277c986a08$var$p(421)));
        return $aefa23277c986a08$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $aefa23277c986a08$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $aefa23277c986a08$var$yg = $aefa23277c986a08$var$Lf(e.nextSibling);
    $aefa23277c986a08$var$xg = b;
    $aefa23277c986a08$var$I = !0;
    $aefa23277c986a08$var$zg = null;
    null !== a && ($aefa23277c986a08$var$og[$aefa23277c986a08$var$pg++] = $aefa23277c986a08$var$rg, $aefa23277c986a08$var$og[$aefa23277c986a08$var$pg++] = $aefa23277c986a08$var$sg, $aefa23277c986a08$var$og[$aefa23277c986a08$var$pg++] = $aefa23277c986a08$var$qg, $aefa23277c986a08$var$rg = a.id, $aefa23277c986a08$var$sg = a.overflow, $aefa23277c986a08$var$qg = b);
    b = $aefa23277c986a08$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $aefa23277c986a08$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $aefa23277c986a08$var$bh(a.return, b, c);
}
function $aefa23277c986a08$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $aefa23277c986a08$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $aefa23277c986a08$var$Xi(a, b, d.children, c);
    d = $aefa23277c986a08$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $aefa23277c986a08$var$vj(a, c, b);
            else if (19 === a.tag) $aefa23277c986a08$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $aefa23277c986a08$var$G($aefa23277c986a08$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $aefa23277c986a08$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $aefa23277c986a08$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $aefa23277c986a08$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $aefa23277c986a08$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $aefa23277c986a08$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $aefa23277c986a08$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $aefa23277c986a08$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $aefa23277c986a08$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($aefa23277c986a08$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $aefa23277c986a08$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $aefa23277c986a08$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $aefa23277c986a08$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $aefa23277c986a08$var$kj(b);
            $aefa23277c986a08$var$Ig();
            break;
        case 5:
            $aefa23277c986a08$var$Ah(b);
            break;
        case 1:
            $aefa23277c986a08$var$Zf(b.type) && $aefa23277c986a08$var$cg(b);
            break;
        case 4:
            $aefa23277c986a08$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $aefa23277c986a08$var$G($aefa23277c986a08$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $aefa23277c986a08$var$G($aefa23277c986a08$var$L, $aefa23277c986a08$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $aefa23277c986a08$var$oj(a, b, c);
                $aefa23277c986a08$var$G($aefa23277c986a08$var$L, $aefa23277c986a08$var$L.current & 1);
                a = $aefa23277c986a08$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $aefa23277c986a08$var$G($aefa23277c986a08$var$L, $aefa23277c986a08$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $aefa23277c986a08$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $aefa23277c986a08$var$G($aefa23277c986a08$var$L, $aefa23277c986a08$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $aefa23277c986a08$var$dj(a, b, c);
    }
    return $aefa23277c986a08$var$Zi(a, b, c);
}
var $aefa23277c986a08$var$zj, $aefa23277c986a08$var$Aj, $aefa23277c986a08$var$Bj, $aefa23277c986a08$var$Cj;
$aefa23277c986a08$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$aefa23277c986a08$var$Aj = function() {};
$aefa23277c986a08$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $aefa23277c986a08$var$xh($aefa23277c986a08$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $aefa23277c986a08$var$Ya(a, e);
                d = $aefa23277c986a08$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $aefa23277c986a08$var$A({}, e, {
                    value: void 0
                });
                d = $aefa23277c986a08$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $aefa23277c986a08$var$gb(a, e);
                d = $aefa23277c986a08$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $aefa23277c986a08$var$Bf);
        }
        $aefa23277c986a08$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($aefa23277c986a08$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($aefa23277c986a08$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $aefa23277c986a08$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$aefa23277c986a08$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $aefa23277c986a08$var$Dj(a, b) {
    if (!$aefa23277c986a08$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $aefa23277c986a08$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $aefa23277c986a08$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $aefa23277c986a08$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $aefa23277c986a08$var$S(b), null;
        case 1:
            return $aefa23277c986a08$var$Zf(b.type) && $aefa23277c986a08$var$$f(), $aefa23277c986a08$var$S(b), null;
        case 3:
            d = b.stateNode;
            $aefa23277c986a08$var$zh();
            $aefa23277c986a08$var$E($aefa23277c986a08$var$Wf);
            $aefa23277c986a08$var$E($aefa23277c986a08$var$H);
            $aefa23277c986a08$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $aefa23277c986a08$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $aefa23277c986a08$var$zg && ($aefa23277c986a08$var$Fj($aefa23277c986a08$var$zg), $aefa23277c986a08$var$zg = null));
            $aefa23277c986a08$var$Aj(a, b);
            $aefa23277c986a08$var$S(b);
            return null;
        case 5:
            $aefa23277c986a08$var$Bh(b);
            var e = $aefa23277c986a08$var$xh($aefa23277c986a08$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $aefa23277c986a08$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($aefa23277c986a08$var$p(166));
                    $aefa23277c986a08$var$S(b);
                    return null;
                }
                a = $aefa23277c986a08$var$xh($aefa23277c986a08$var$uh.current);
                if ($aefa23277c986a08$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$aefa23277c986a08$var$Of] = b;
                    d[$aefa23277c986a08$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $aefa23277c986a08$var$D("cancel", d);
                            $aefa23277c986a08$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $aefa23277c986a08$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $aefa23277c986a08$var$lf.length; e++)$aefa23277c986a08$var$D($aefa23277c986a08$var$lf[e], d);
                            break;
                        case "source":
                            $aefa23277c986a08$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $aefa23277c986a08$var$D("error", d);
                            $aefa23277c986a08$var$D("load", d);
                            break;
                        case "details":
                            $aefa23277c986a08$var$D("toggle", d);
                            break;
                        case "input":
                            $aefa23277c986a08$var$Za(d, f);
                            $aefa23277c986a08$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $aefa23277c986a08$var$D("invalid", d);
                            break;
                        case "textarea":
                            $aefa23277c986a08$var$hb(d, f), $aefa23277c986a08$var$D("invalid", d);
                    }
                    $aefa23277c986a08$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $aefa23277c986a08$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $aefa23277c986a08$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $aefa23277c986a08$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $aefa23277c986a08$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $aefa23277c986a08$var$Va(d);
                            $aefa23277c986a08$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $aefa23277c986a08$var$Va(d);
                            $aefa23277c986a08$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $aefa23277c986a08$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $aefa23277c986a08$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$aefa23277c986a08$var$Of] = b;
                    a[$aefa23277c986a08$var$Pf] = d;
                    $aefa23277c986a08$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $aefa23277c986a08$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $aefa23277c986a08$var$D("cancel", a);
                                $aefa23277c986a08$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $aefa23277c986a08$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $aefa23277c986a08$var$lf.length; e++)$aefa23277c986a08$var$D($aefa23277c986a08$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $aefa23277c986a08$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $aefa23277c986a08$var$D("error", a);
                                $aefa23277c986a08$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $aefa23277c986a08$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $aefa23277c986a08$var$Za(a, d);
                                e = $aefa23277c986a08$var$Ya(a, d);
                                $aefa23277c986a08$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $aefa23277c986a08$var$A({}, d, {
                                    value: void 0
                                });
                                $aefa23277c986a08$var$D("invalid", a);
                                break;
                            case "textarea":
                                $aefa23277c986a08$var$hb(a, d);
                                e = $aefa23277c986a08$var$gb(a, d);
                                $aefa23277c986a08$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $aefa23277c986a08$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $aefa23277c986a08$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $aefa23277c986a08$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $aefa23277c986a08$var$ob(a, k) : "number" === typeof k && $aefa23277c986a08$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($aefa23277c986a08$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $aefa23277c986a08$var$D("scroll", a) : null != k && $aefa23277c986a08$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $aefa23277c986a08$var$Va(a);
                                $aefa23277c986a08$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $aefa23277c986a08$var$Va(a);
                                $aefa23277c986a08$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $aefa23277c986a08$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $aefa23277c986a08$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $aefa23277c986a08$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $aefa23277c986a08$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $aefa23277c986a08$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $aefa23277c986a08$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($aefa23277c986a08$var$p(166));
                c = $aefa23277c986a08$var$xh($aefa23277c986a08$var$wh.current);
                $aefa23277c986a08$var$xh($aefa23277c986a08$var$uh.current);
                if ($aefa23277c986a08$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$aefa23277c986a08$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $aefa23277c986a08$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $aefa23277c986a08$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $aefa23277c986a08$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$aefa23277c986a08$var$Of] = b, b.stateNode = d;
            }
            $aefa23277c986a08$var$S(b);
            return null;
        case 13:
            $aefa23277c986a08$var$E($aefa23277c986a08$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($aefa23277c986a08$var$I && null !== $aefa23277c986a08$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $aefa23277c986a08$var$Hg(), $aefa23277c986a08$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $aefa23277c986a08$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($aefa23277c986a08$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($aefa23277c986a08$var$p(317));
                        f[$aefa23277c986a08$var$Of] = b;
                    } else $aefa23277c986a08$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $aefa23277c986a08$var$S(b);
                    f = !1;
                } else null !== $aefa23277c986a08$var$zg && ($aefa23277c986a08$var$Fj($aefa23277c986a08$var$zg), $aefa23277c986a08$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($aefa23277c986a08$var$L.current & 1) ? 0 === $aefa23277c986a08$var$T && ($aefa23277c986a08$var$T = 3) : $aefa23277c986a08$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $aefa23277c986a08$var$S(b);
            return null;
        case 4:
            return $aefa23277c986a08$var$zh(), $aefa23277c986a08$var$Aj(a, b), null === a && $aefa23277c986a08$var$sf(b.stateNode.containerInfo), $aefa23277c986a08$var$S(b), null;
        case 10:
            return $aefa23277c986a08$var$ah(b.type._context), $aefa23277c986a08$var$S(b), null;
        case 17:
            return $aefa23277c986a08$var$Zf(b.type) && $aefa23277c986a08$var$$f(), $aefa23277c986a08$var$S(b), null;
        case 19:
            $aefa23277c986a08$var$E($aefa23277c986a08$var$L);
            f = b.memoizedState;
            if (null === f) return $aefa23277c986a08$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $aefa23277c986a08$var$Dj(f, !1);
                else {
                    if (0 !== $aefa23277c986a08$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $aefa23277c986a08$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $aefa23277c986a08$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $aefa23277c986a08$var$G($aefa23277c986a08$var$L, $aefa23277c986a08$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $aefa23277c986a08$var$B() > $aefa23277c986a08$var$Gj && (b.flags |= 128, d = !0, $aefa23277c986a08$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $aefa23277c986a08$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $aefa23277c986a08$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$aefa23277c986a08$var$I) return $aefa23277c986a08$var$S(b), null;
                    } else 2 * $aefa23277c986a08$var$B() - f.renderingStartTime > $aefa23277c986a08$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $aefa23277c986a08$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $aefa23277c986a08$var$B(), b.sibling = null, c = $aefa23277c986a08$var$L.current, $aefa23277c986a08$var$G($aefa23277c986a08$var$L, d ? c & 1 | 2 : c & 1), b;
            $aefa23277c986a08$var$S(b);
            return null;
        case 22:
        case 23:
            return $aefa23277c986a08$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($aefa23277c986a08$var$fj & 1073741824) && ($aefa23277c986a08$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $aefa23277c986a08$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($aefa23277c986a08$var$p(156, b.tag));
}
function $aefa23277c986a08$var$Ij(a, b) {
    $aefa23277c986a08$var$wg(b);
    switch(b.tag){
        case 1:
            return $aefa23277c986a08$var$Zf(b.type) && $aefa23277c986a08$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $aefa23277c986a08$var$zh(), $aefa23277c986a08$var$E($aefa23277c986a08$var$Wf), $aefa23277c986a08$var$E($aefa23277c986a08$var$H), $aefa23277c986a08$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $aefa23277c986a08$var$Bh(b), null;
        case 13:
            $aefa23277c986a08$var$E($aefa23277c986a08$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($aefa23277c986a08$var$p(340));
                $aefa23277c986a08$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $aefa23277c986a08$var$E($aefa23277c986a08$var$L), null;
        case 4:
            return $aefa23277c986a08$var$zh(), null;
        case 10:
            return $aefa23277c986a08$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $aefa23277c986a08$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $aefa23277c986a08$var$Jj = !1, $aefa23277c986a08$var$U = !1, $aefa23277c986a08$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $aefa23277c986a08$var$V = null;
function $aefa23277c986a08$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $aefa23277c986a08$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $aefa23277c986a08$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $aefa23277c986a08$var$W(a, b, d);
    }
}
var $aefa23277c986a08$var$Nj = !1;
function $aefa23277c986a08$var$Oj(a, b) {
    $aefa23277c986a08$var$Cf = $aefa23277c986a08$var$dd;
    a = $aefa23277c986a08$var$Me();
    if ($aefa23277c986a08$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $aefa23277c986a08$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $aefa23277c986a08$var$dd = !1;
    for($aefa23277c986a08$var$V = b; null !== $aefa23277c986a08$var$V;)if (b = $aefa23277c986a08$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $aefa23277c986a08$var$V = a;
    else for(; null !== $aefa23277c986a08$var$V;){
        b = $aefa23277c986a08$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $aefa23277c986a08$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($aefa23277c986a08$var$p(163));
            }
        } catch (F) {
            $aefa23277c986a08$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $aefa23277c986a08$var$V = a;
            break;
        }
        $aefa23277c986a08$var$V = b.return;
    }
    n = $aefa23277c986a08$var$Nj;
    $aefa23277c986a08$var$Nj = !1;
    return n;
}
function $aefa23277c986a08$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $aefa23277c986a08$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $aefa23277c986a08$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $aefa23277c986a08$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $aefa23277c986a08$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $aefa23277c986a08$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$aefa23277c986a08$var$Of], delete b[$aefa23277c986a08$var$Pf], delete b[$aefa23277c986a08$var$of], delete b[$aefa23277c986a08$var$Qf], delete b[$aefa23277c986a08$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $aefa23277c986a08$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $aefa23277c986a08$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $aefa23277c986a08$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $aefa23277c986a08$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $aefa23277c986a08$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($aefa23277c986a08$var$Vj(a, b, c), a = a.sibling; null !== a;)$aefa23277c986a08$var$Vj(a, b, c), a = a.sibling;
}
function $aefa23277c986a08$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($aefa23277c986a08$var$Wj(a, b, c), a = a.sibling; null !== a;)$aefa23277c986a08$var$Wj(a, b, c), a = a.sibling;
}
var $aefa23277c986a08$var$X = null, $aefa23277c986a08$var$Xj = !1;
function $aefa23277c986a08$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$aefa23277c986a08$var$Zj(a, b, c), c = c.sibling;
}
function $aefa23277c986a08$var$Zj(a, b, c) {
    if ($aefa23277c986a08$var$lc && "function" === typeof $aefa23277c986a08$var$lc.onCommitFiberUnmount) try {
        $aefa23277c986a08$var$lc.onCommitFiberUnmount($aefa23277c986a08$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $aefa23277c986a08$var$U || $aefa23277c986a08$var$Lj(c, b);
        case 6:
            var d = $aefa23277c986a08$var$X, e = $aefa23277c986a08$var$Xj;
            $aefa23277c986a08$var$X = null;
            $aefa23277c986a08$var$Yj(a, b, c);
            $aefa23277c986a08$var$X = d;
            $aefa23277c986a08$var$Xj = e;
            null !== $aefa23277c986a08$var$X && ($aefa23277c986a08$var$Xj ? (a = $aefa23277c986a08$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $aefa23277c986a08$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $aefa23277c986a08$var$X && ($aefa23277c986a08$var$Xj ? (a = $aefa23277c986a08$var$X, c = c.stateNode, 8 === a.nodeType ? $aefa23277c986a08$var$Kf(a.parentNode, c) : 1 === a.nodeType && $aefa23277c986a08$var$Kf(a, c), $aefa23277c986a08$var$bd(a)) : $aefa23277c986a08$var$Kf($aefa23277c986a08$var$X, c.stateNode));
            break;
        case 4:
            d = $aefa23277c986a08$var$X;
            e = $aefa23277c986a08$var$Xj;
            $aefa23277c986a08$var$X = c.stateNode.containerInfo;
            $aefa23277c986a08$var$Xj = !0;
            $aefa23277c986a08$var$Yj(a, b, c);
            $aefa23277c986a08$var$X = d;
            $aefa23277c986a08$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$aefa23277c986a08$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $aefa23277c986a08$var$Mj(c, b, g) : 0 !== (f & 4) && $aefa23277c986a08$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $aefa23277c986a08$var$Yj(a, b, c);
            break;
        case 1:
            if (!$aefa23277c986a08$var$U && ($aefa23277c986a08$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $aefa23277c986a08$var$W(c, b, h);
            }
            $aefa23277c986a08$var$Yj(a, b, c);
            break;
        case 21:
            $aefa23277c986a08$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($aefa23277c986a08$var$U = (d = $aefa23277c986a08$var$U) || null !== c.memoizedState, $aefa23277c986a08$var$Yj(a, b, c), $aefa23277c986a08$var$U = d) : $aefa23277c986a08$var$Yj(a, b, c);
            break;
        default:
            $aefa23277c986a08$var$Yj(a, b, c);
    }
}
function $aefa23277c986a08$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $aefa23277c986a08$var$Kj);
        b.forEach(function(b) {
            var d = $aefa23277c986a08$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $aefa23277c986a08$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $aefa23277c986a08$var$X = h.stateNode;
                        $aefa23277c986a08$var$Xj = !1;
                        break a;
                    case 3:
                        $aefa23277c986a08$var$X = h.stateNode.containerInfo;
                        $aefa23277c986a08$var$Xj = !0;
                        break a;
                    case 4:
                        $aefa23277c986a08$var$X = h.stateNode.containerInfo;
                        $aefa23277c986a08$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $aefa23277c986a08$var$X) throw Error($aefa23277c986a08$var$p(160));
            $aefa23277c986a08$var$Zj(f, g, e);
            $aefa23277c986a08$var$X = null;
            $aefa23277c986a08$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $aefa23277c986a08$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$aefa23277c986a08$var$dk(b, a), b = b.sibling;
}
function $aefa23277c986a08$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $aefa23277c986a08$var$ck(b, a);
            $aefa23277c986a08$var$ek(a);
            if (d & 4) {
                try {
                    $aefa23277c986a08$var$Pj(3, a, a.return), $aefa23277c986a08$var$Qj(3, a);
                } catch (t) {
                    $aefa23277c986a08$var$W(a, a.return, t);
                }
                try {
                    $aefa23277c986a08$var$Pj(5, a, a.return);
                } catch (t) {
                    $aefa23277c986a08$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $aefa23277c986a08$var$ck(b, a);
            $aefa23277c986a08$var$ek(a);
            d & 512 && null !== c && $aefa23277c986a08$var$Lj(c, c.return);
            break;
        case 5:
            $aefa23277c986a08$var$ck(b, a);
            $aefa23277c986a08$var$ek(a);
            d & 512 && null !== c && $aefa23277c986a08$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $aefa23277c986a08$var$ob(e, "");
                } catch (t) {
                    $aefa23277c986a08$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $aefa23277c986a08$var$ab(e, f);
                    $aefa23277c986a08$var$vb(h, g);
                    var l = $aefa23277c986a08$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $aefa23277c986a08$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $aefa23277c986a08$var$nb(e, q) : "children" === m ? $aefa23277c986a08$var$ob(e, q) : $aefa23277c986a08$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $aefa23277c986a08$var$bb(e, f);
                            break;
                        case "textarea":
                            $aefa23277c986a08$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $aefa23277c986a08$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $aefa23277c986a08$var$fb(e, !!f.multiple, f.defaultValue, !0) : $aefa23277c986a08$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$aefa23277c986a08$var$Pf] = f;
                } catch (t) {
                    $aefa23277c986a08$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $aefa23277c986a08$var$ck(b, a);
            $aefa23277c986a08$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($aefa23277c986a08$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $aefa23277c986a08$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $aefa23277c986a08$var$ck(b, a);
            $aefa23277c986a08$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $aefa23277c986a08$var$bd(b.containerInfo);
            } catch (t) {
                $aefa23277c986a08$var$W(a, a.return, t);
            }
            break;
        case 4:
            $aefa23277c986a08$var$ck(b, a);
            $aefa23277c986a08$var$ek(a);
            break;
        case 13:
            $aefa23277c986a08$var$ck(b, a);
            $aefa23277c986a08$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($aefa23277c986a08$var$fk = $aefa23277c986a08$var$B()));
            d & 4 && $aefa23277c986a08$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($aefa23277c986a08$var$U = (l = $aefa23277c986a08$var$U) || m, $aefa23277c986a08$var$ck(b, a), $aefa23277c986a08$var$U = l) : $aefa23277c986a08$var$ck(b, a);
            $aefa23277c986a08$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($aefa23277c986a08$var$V = a, m = a.child; null !== m;){
                    for(q = $aefa23277c986a08$var$V = m; null !== $aefa23277c986a08$var$V;){
                        r = $aefa23277c986a08$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $aefa23277c986a08$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $aefa23277c986a08$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $aefa23277c986a08$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $aefa23277c986a08$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $aefa23277c986a08$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $aefa23277c986a08$var$V = y) : $aefa23277c986a08$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $aefa23277c986a08$var$rb("display", g));
                            } catch (t) {
                                $aefa23277c986a08$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $aefa23277c986a08$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $aefa23277c986a08$var$ck(b, a);
            $aefa23277c986a08$var$ek(a);
            d & 4 && $aefa23277c986a08$var$ak(a);
            break;
        case 21:
            break;
        default:
            $aefa23277c986a08$var$ck(b, a), $aefa23277c986a08$var$ek(a);
    }
}
function $aefa23277c986a08$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($aefa23277c986a08$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($aefa23277c986a08$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($aefa23277c986a08$var$ob(e, ""), d.flags &= -33);
                    var f = $aefa23277c986a08$var$Uj(a);
                    $aefa23277c986a08$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $aefa23277c986a08$var$Uj(a);
                    $aefa23277c986a08$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($aefa23277c986a08$var$p(161));
            }
        } catch (k) {
            $aefa23277c986a08$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $aefa23277c986a08$var$hk(a, b, c) {
    $aefa23277c986a08$var$V = a;
    $aefa23277c986a08$var$ik(a, b, c);
}
function $aefa23277c986a08$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $aefa23277c986a08$var$V;){
        var e = $aefa23277c986a08$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $aefa23277c986a08$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $aefa23277c986a08$var$U;
                h = $aefa23277c986a08$var$Jj;
                var l = $aefa23277c986a08$var$U;
                $aefa23277c986a08$var$Jj = g;
                if (($aefa23277c986a08$var$U = k) && !l) for($aefa23277c986a08$var$V = e; null !== $aefa23277c986a08$var$V;)g = $aefa23277c986a08$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $aefa23277c986a08$var$jk(e) : null !== k ? (k.return = g, $aefa23277c986a08$var$V = k) : $aefa23277c986a08$var$jk(e);
                for(; null !== f;)$aefa23277c986a08$var$V = f, $aefa23277c986a08$var$ik(f, b, c), f = f.sibling;
                $aefa23277c986a08$var$V = e;
                $aefa23277c986a08$var$Jj = h;
                $aefa23277c986a08$var$U = l;
            }
            $aefa23277c986a08$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $aefa23277c986a08$var$V = f) : $aefa23277c986a08$var$kk(a, b, c);
    }
}
function $aefa23277c986a08$var$kk(a) {
    for(; null !== $aefa23277c986a08$var$V;){
        var b = $aefa23277c986a08$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $aefa23277c986a08$var$U || $aefa23277c986a08$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$aefa23277c986a08$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $aefa23277c986a08$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $aefa23277c986a08$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $aefa23277c986a08$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $aefa23277c986a08$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($aefa23277c986a08$var$p(163));
                }
                $aefa23277c986a08$var$U || b.flags & 512 && $aefa23277c986a08$var$Rj(b);
            } catch (r) {
                $aefa23277c986a08$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $aefa23277c986a08$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $aefa23277c986a08$var$V = c;
            break;
        }
        $aefa23277c986a08$var$V = b.return;
    }
}
function $aefa23277c986a08$var$gk(a) {
    for(; null !== $aefa23277c986a08$var$V;){
        var b = $aefa23277c986a08$var$V;
        if (b === a) {
            $aefa23277c986a08$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $aefa23277c986a08$var$V = c;
            break;
        }
        $aefa23277c986a08$var$V = b.return;
    }
}
function $aefa23277c986a08$var$jk(a) {
    for(; null !== $aefa23277c986a08$var$V;){
        var b = $aefa23277c986a08$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $aefa23277c986a08$var$Qj(4, b);
                    } catch (k) {
                        $aefa23277c986a08$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $aefa23277c986a08$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $aefa23277c986a08$var$Rj(b);
                    } catch (k) {
                        $aefa23277c986a08$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $aefa23277c986a08$var$Rj(b);
                    } catch (k) {
                        $aefa23277c986a08$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $aefa23277c986a08$var$W(b, b.return, k);
        }
        if (b === a) {
            $aefa23277c986a08$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $aefa23277c986a08$var$V = h;
            break;
        }
        $aefa23277c986a08$var$V = b.return;
    }
}
var $aefa23277c986a08$var$lk = Math.ceil, $aefa23277c986a08$var$mk = $aefa23277c986a08$var$ua.ReactCurrentDispatcher, $aefa23277c986a08$var$nk = $aefa23277c986a08$var$ua.ReactCurrentOwner, $aefa23277c986a08$var$ok = $aefa23277c986a08$var$ua.ReactCurrentBatchConfig, $aefa23277c986a08$var$K = 0, $aefa23277c986a08$var$Q = null, $aefa23277c986a08$var$Y = null, $aefa23277c986a08$var$Z = 0, $aefa23277c986a08$var$fj = 0, $aefa23277c986a08$var$ej = $aefa23277c986a08$var$Uf(0), $aefa23277c986a08$var$T = 0, $aefa23277c986a08$var$pk = null, $aefa23277c986a08$var$rh = 0, $aefa23277c986a08$var$qk = 0, $aefa23277c986a08$var$rk = 0, $aefa23277c986a08$var$sk = null, $aefa23277c986a08$var$tk = null, $aefa23277c986a08$var$fk = 0, $aefa23277c986a08$var$Gj = Infinity, $aefa23277c986a08$var$uk = null, $aefa23277c986a08$var$Oi = !1, $aefa23277c986a08$var$Pi = null, $aefa23277c986a08$var$Ri = null, $aefa23277c986a08$var$vk = !1, $aefa23277c986a08$var$wk = null, $aefa23277c986a08$var$xk = 0, $aefa23277c986a08$var$yk = 0, $aefa23277c986a08$var$zk = null, $aefa23277c986a08$var$Ak = -1, $aefa23277c986a08$var$Bk = 0;
function $aefa23277c986a08$var$R() {
    return 0 !== ($aefa23277c986a08$var$K & 6) ? $aefa23277c986a08$var$B() : -1 !== $aefa23277c986a08$var$Ak ? $aefa23277c986a08$var$Ak : $aefa23277c986a08$var$Ak = $aefa23277c986a08$var$B();
}
function $aefa23277c986a08$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($aefa23277c986a08$var$K & 2) && 0 !== $aefa23277c986a08$var$Z) return $aefa23277c986a08$var$Z & -$aefa23277c986a08$var$Z;
    if (null !== $aefa23277c986a08$var$Kg.transition) return 0 === $aefa23277c986a08$var$Bk && ($aefa23277c986a08$var$Bk = $aefa23277c986a08$var$yc()), $aefa23277c986a08$var$Bk;
    a = $aefa23277c986a08$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $aefa23277c986a08$var$jd(a.type);
    return a;
}
function $aefa23277c986a08$var$gi(a, b, c, d) {
    if (50 < $aefa23277c986a08$var$yk) throw $aefa23277c986a08$var$yk = 0, $aefa23277c986a08$var$zk = null, Error($aefa23277c986a08$var$p(185));
    $aefa23277c986a08$var$Ac(a, c, d);
    if (0 === ($aefa23277c986a08$var$K & 2) || a !== $aefa23277c986a08$var$Q) a === $aefa23277c986a08$var$Q && (0 === ($aefa23277c986a08$var$K & 2) && ($aefa23277c986a08$var$qk |= c), 4 === $aefa23277c986a08$var$T && $aefa23277c986a08$var$Ck(a, $aefa23277c986a08$var$Z)), $aefa23277c986a08$var$Dk(a, d), 1 === c && 0 === $aefa23277c986a08$var$K && 0 === (b.mode & 1) && ($aefa23277c986a08$var$Gj = $aefa23277c986a08$var$B() + 500, $aefa23277c986a08$var$fg && $aefa23277c986a08$var$jg());
}
function $aefa23277c986a08$var$Dk(a, b) {
    var c = a.callbackNode;
    $aefa23277c986a08$var$wc(a, b);
    var d = $aefa23277c986a08$var$uc(a, a === $aefa23277c986a08$var$Q ? $aefa23277c986a08$var$Z : 0);
    if (0 === d) null !== c && $aefa23277c986a08$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $aefa23277c986a08$var$bc(c);
        if (1 === b) 0 === a.tag ? $aefa23277c986a08$var$ig($aefa23277c986a08$var$Ek.bind(null, a)) : $aefa23277c986a08$var$hg($aefa23277c986a08$var$Ek.bind(null, a)), $aefa23277c986a08$var$Jf(function() {
            0 === ($aefa23277c986a08$var$K & 6) && $aefa23277c986a08$var$jg();
        }), c = null;
        else {
            switch($aefa23277c986a08$var$Dc(d)){
                case 1:
                    c = $aefa23277c986a08$var$fc;
                    break;
                case 4:
                    c = $aefa23277c986a08$var$gc;
                    break;
                case 16:
                    c = $aefa23277c986a08$var$hc;
                    break;
                case 536870912:
                    c = $aefa23277c986a08$var$jc;
                    break;
                default:
                    c = $aefa23277c986a08$var$hc;
            }
            c = $aefa23277c986a08$var$Fk(c, $aefa23277c986a08$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $aefa23277c986a08$var$Gk(a, b) {
    $aefa23277c986a08$var$Ak = -1;
    $aefa23277c986a08$var$Bk = 0;
    if (0 !== ($aefa23277c986a08$var$K & 6)) throw Error($aefa23277c986a08$var$p(327));
    var c = a.callbackNode;
    if ($aefa23277c986a08$var$Hk() && a.callbackNode !== c) return null;
    var d = $aefa23277c986a08$var$uc(a, a === $aefa23277c986a08$var$Q ? $aefa23277c986a08$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $aefa23277c986a08$var$Ik(a, d);
    else {
        b = d;
        var e = $aefa23277c986a08$var$K;
        $aefa23277c986a08$var$K |= 2;
        var f = $aefa23277c986a08$var$Jk();
        if ($aefa23277c986a08$var$Q !== a || $aefa23277c986a08$var$Z !== b) $aefa23277c986a08$var$uk = null, $aefa23277c986a08$var$Gj = $aefa23277c986a08$var$B() + 500, $aefa23277c986a08$var$Kk(a, b);
        for(;;)try {
            $aefa23277c986a08$var$Lk();
            break;
        } catch (h) {
            $aefa23277c986a08$var$Mk(a, h);
        }
        $aefa23277c986a08$var$$g();
        $aefa23277c986a08$var$mk.current = f;
        $aefa23277c986a08$var$K = e;
        null !== $aefa23277c986a08$var$Y ? b = 0 : ($aefa23277c986a08$var$Q = null, $aefa23277c986a08$var$Z = 0, b = $aefa23277c986a08$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $aefa23277c986a08$var$xc(a), 0 !== e && (d = e, b = $aefa23277c986a08$var$Nk(a, e)));
        if (1 === b) throw c = $aefa23277c986a08$var$pk, $aefa23277c986a08$var$Kk(a, 0), $aefa23277c986a08$var$Ck(a, d), $aefa23277c986a08$var$Dk(a, $aefa23277c986a08$var$B()), c;
        if (6 === b) $aefa23277c986a08$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$aefa23277c986a08$var$Ok(e) && (b = $aefa23277c986a08$var$Ik(a, d), 2 === b && (f = $aefa23277c986a08$var$xc(a), 0 !== f && (d = f, b = $aefa23277c986a08$var$Nk(a, f))), 1 === b)) throw c = $aefa23277c986a08$var$pk, $aefa23277c986a08$var$Kk(a, 0), $aefa23277c986a08$var$Ck(a, d), $aefa23277c986a08$var$Dk(a, $aefa23277c986a08$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($aefa23277c986a08$var$p(345));
                case 2:
                    $aefa23277c986a08$var$Pk(a, $aefa23277c986a08$var$tk, $aefa23277c986a08$var$uk);
                    break;
                case 3:
                    $aefa23277c986a08$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $aefa23277c986a08$var$fk + 500 - $aefa23277c986a08$var$B(), 10 < b)) {
                        if (0 !== $aefa23277c986a08$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $aefa23277c986a08$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $aefa23277c986a08$var$Ff($aefa23277c986a08$var$Pk.bind(null, a, $aefa23277c986a08$var$tk, $aefa23277c986a08$var$uk), b);
                        break;
                    }
                    $aefa23277c986a08$var$Pk(a, $aefa23277c986a08$var$tk, $aefa23277c986a08$var$uk);
                    break;
                case 4:
                    $aefa23277c986a08$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $aefa23277c986a08$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $aefa23277c986a08$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $aefa23277c986a08$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $aefa23277c986a08$var$Ff($aefa23277c986a08$var$Pk.bind(null, a, $aefa23277c986a08$var$tk, $aefa23277c986a08$var$uk), d);
                        break;
                    }
                    $aefa23277c986a08$var$Pk(a, $aefa23277c986a08$var$tk, $aefa23277c986a08$var$uk);
                    break;
                case 5:
                    $aefa23277c986a08$var$Pk(a, $aefa23277c986a08$var$tk, $aefa23277c986a08$var$uk);
                    break;
                default:
                    throw Error($aefa23277c986a08$var$p(329));
            }
        }
    }
    $aefa23277c986a08$var$Dk(a, $aefa23277c986a08$var$B());
    return a.callbackNode === c ? $aefa23277c986a08$var$Gk.bind(null, a) : null;
}
function $aefa23277c986a08$var$Nk(a, b) {
    var c = $aefa23277c986a08$var$sk;
    a.current.memoizedState.isDehydrated && ($aefa23277c986a08$var$Kk(a, b).flags |= 256);
    a = $aefa23277c986a08$var$Ik(a, b);
    2 !== a && (b = $aefa23277c986a08$var$tk, $aefa23277c986a08$var$tk = c, null !== b && $aefa23277c986a08$var$Fj(b));
    return a;
}
function $aefa23277c986a08$var$Fj(a) {
    null === $aefa23277c986a08$var$tk ? $aefa23277c986a08$var$tk = a : $aefa23277c986a08$var$tk.push.apply($aefa23277c986a08$var$tk, a);
}
function $aefa23277c986a08$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$aefa23277c986a08$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $aefa23277c986a08$var$Ck(a, b) {
    b &= ~$aefa23277c986a08$var$rk;
    b &= ~$aefa23277c986a08$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $aefa23277c986a08$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $aefa23277c986a08$var$Ek(a) {
    if (0 !== ($aefa23277c986a08$var$K & 6)) throw Error($aefa23277c986a08$var$p(327));
    $aefa23277c986a08$var$Hk();
    var b = $aefa23277c986a08$var$uc(a, 0);
    if (0 === (b & 1)) return $aefa23277c986a08$var$Dk(a, $aefa23277c986a08$var$B()), null;
    var c = $aefa23277c986a08$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $aefa23277c986a08$var$xc(a);
        0 !== d && (b = d, c = $aefa23277c986a08$var$Nk(a, d));
    }
    if (1 === c) throw c = $aefa23277c986a08$var$pk, $aefa23277c986a08$var$Kk(a, 0), $aefa23277c986a08$var$Ck(a, b), $aefa23277c986a08$var$Dk(a, $aefa23277c986a08$var$B()), c;
    if (6 === c) throw Error($aefa23277c986a08$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $aefa23277c986a08$var$Pk(a, $aefa23277c986a08$var$tk, $aefa23277c986a08$var$uk);
    $aefa23277c986a08$var$Dk(a, $aefa23277c986a08$var$B());
    return null;
}
function $aefa23277c986a08$var$Qk(a, b) {
    var c = $aefa23277c986a08$var$K;
    $aefa23277c986a08$var$K |= 1;
    try {
        return a(b);
    } finally{
        $aefa23277c986a08$var$K = c, 0 === $aefa23277c986a08$var$K && ($aefa23277c986a08$var$Gj = $aefa23277c986a08$var$B() + 500, $aefa23277c986a08$var$fg && $aefa23277c986a08$var$jg());
    }
}
function $aefa23277c986a08$var$Rk(a) {
    null !== $aefa23277c986a08$var$wk && 0 === $aefa23277c986a08$var$wk.tag && 0 === ($aefa23277c986a08$var$K & 6) && $aefa23277c986a08$var$Hk();
    var b = $aefa23277c986a08$var$K;
    $aefa23277c986a08$var$K |= 1;
    var c = $aefa23277c986a08$var$ok.transition, d = $aefa23277c986a08$var$C;
    try {
        if ($aefa23277c986a08$var$ok.transition = null, $aefa23277c986a08$var$C = 1, a) return a();
    } finally{
        $aefa23277c986a08$var$C = d, $aefa23277c986a08$var$ok.transition = c, $aefa23277c986a08$var$K = b, 0 === ($aefa23277c986a08$var$K & 6) && $aefa23277c986a08$var$jg();
    }
}
function $aefa23277c986a08$var$Hj() {
    $aefa23277c986a08$var$fj = $aefa23277c986a08$var$ej.current;
    $aefa23277c986a08$var$E($aefa23277c986a08$var$ej);
}
function $aefa23277c986a08$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $aefa23277c986a08$var$Gf(c));
    if (null !== $aefa23277c986a08$var$Y) for(c = $aefa23277c986a08$var$Y.return; null !== c;){
        var d = c;
        $aefa23277c986a08$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $aefa23277c986a08$var$$f();
                break;
            case 3:
                $aefa23277c986a08$var$zh();
                $aefa23277c986a08$var$E($aefa23277c986a08$var$Wf);
                $aefa23277c986a08$var$E($aefa23277c986a08$var$H);
                $aefa23277c986a08$var$Eh();
                break;
            case 5:
                $aefa23277c986a08$var$Bh(d);
                break;
            case 4:
                $aefa23277c986a08$var$zh();
                break;
            case 13:
                $aefa23277c986a08$var$E($aefa23277c986a08$var$L);
                break;
            case 19:
                $aefa23277c986a08$var$E($aefa23277c986a08$var$L);
                break;
            case 10:
                $aefa23277c986a08$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $aefa23277c986a08$var$Hj();
        }
        c = c.return;
    }
    $aefa23277c986a08$var$Q = a;
    $aefa23277c986a08$var$Y = a = $aefa23277c986a08$var$Pg(a.current, null);
    $aefa23277c986a08$var$Z = $aefa23277c986a08$var$fj = b;
    $aefa23277c986a08$var$T = 0;
    $aefa23277c986a08$var$pk = null;
    $aefa23277c986a08$var$rk = $aefa23277c986a08$var$qk = $aefa23277c986a08$var$rh = 0;
    $aefa23277c986a08$var$tk = $aefa23277c986a08$var$sk = null;
    if (null !== $aefa23277c986a08$var$fh) {
        for(b = 0; b < $aefa23277c986a08$var$fh.length; b++)if (c = $aefa23277c986a08$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $aefa23277c986a08$var$fh = null;
    }
    return a;
}
function $aefa23277c986a08$var$Mk(a, b) {
    do {
        var c = $aefa23277c986a08$var$Y;
        try {
            $aefa23277c986a08$var$$g();
            $aefa23277c986a08$var$Fh.current = $aefa23277c986a08$var$Rh;
            if ($aefa23277c986a08$var$Ih) {
                for(var d = $aefa23277c986a08$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $aefa23277c986a08$var$Ih = !1;
            }
            $aefa23277c986a08$var$Hh = 0;
            $aefa23277c986a08$var$O = $aefa23277c986a08$var$N = $aefa23277c986a08$var$M = null;
            $aefa23277c986a08$var$Jh = !1;
            $aefa23277c986a08$var$Kh = 0;
            $aefa23277c986a08$var$nk.current = null;
            if (null === c || null === c.return) {
                $aefa23277c986a08$var$T = 1;
                $aefa23277c986a08$var$pk = b;
                $aefa23277c986a08$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $aefa23277c986a08$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $aefa23277c986a08$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $aefa23277c986a08$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $aefa23277c986a08$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $aefa23277c986a08$var$Si(f, l, b);
                            $aefa23277c986a08$var$tj();
                            break a;
                        }
                        k = Error($aefa23277c986a08$var$p(426));
                    }
                } else if ($aefa23277c986a08$var$I && h.mode & 1) {
                    var J = $aefa23277c986a08$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $aefa23277c986a08$var$Vi(J, g, h, f, b);
                        $aefa23277c986a08$var$Jg($aefa23277c986a08$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $aefa23277c986a08$var$Ji(k, h);
                4 !== $aefa23277c986a08$var$T && ($aefa23277c986a08$var$T = 2);
                null === $aefa23277c986a08$var$sk ? $aefa23277c986a08$var$sk = [
                    f
                ] : $aefa23277c986a08$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $aefa23277c986a08$var$Ni(f, k, b);
                            $aefa23277c986a08$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $aefa23277c986a08$var$Ri || !$aefa23277c986a08$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $aefa23277c986a08$var$Qi(f, h, b);
                                $aefa23277c986a08$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $aefa23277c986a08$var$Sk(c);
        } catch (na) {
            b = na;
            $aefa23277c986a08$var$Y === c && null !== c && ($aefa23277c986a08$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $aefa23277c986a08$var$Jk() {
    var a = $aefa23277c986a08$var$mk.current;
    $aefa23277c986a08$var$mk.current = $aefa23277c986a08$var$Rh;
    return null === a ? $aefa23277c986a08$var$Rh : a;
}
function $aefa23277c986a08$var$tj() {
    if (0 === $aefa23277c986a08$var$T || 3 === $aefa23277c986a08$var$T || 2 === $aefa23277c986a08$var$T) $aefa23277c986a08$var$T = 4;
    null === $aefa23277c986a08$var$Q || 0 === ($aefa23277c986a08$var$rh & 268435455) && 0 === ($aefa23277c986a08$var$qk & 268435455) || $aefa23277c986a08$var$Ck($aefa23277c986a08$var$Q, $aefa23277c986a08$var$Z);
}
function $aefa23277c986a08$var$Ik(a, b) {
    var c = $aefa23277c986a08$var$K;
    $aefa23277c986a08$var$K |= 2;
    var d = $aefa23277c986a08$var$Jk();
    if ($aefa23277c986a08$var$Q !== a || $aefa23277c986a08$var$Z !== b) $aefa23277c986a08$var$uk = null, $aefa23277c986a08$var$Kk(a, b);
    for(;;)try {
        $aefa23277c986a08$var$Tk();
        break;
    } catch (e) {
        $aefa23277c986a08$var$Mk(a, e);
    }
    $aefa23277c986a08$var$$g();
    $aefa23277c986a08$var$K = c;
    $aefa23277c986a08$var$mk.current = d;
    if (null !== $aefa23277c986a08$var$Y) throw Error($aefa23277c986a08$var$p(261));
    $aefa23277c986a08$var$Q = null;
    $aefa23277c986a08$var$Z = 0;
    return $aefa23277c986a08$var$T;
}
function $aefa23277c986a08$var$Tk() {
    for(; null !== $aefa23277c986a08$var$Y;)$aefa23277c986a08$var$Uk($aefa23277c986a08$var$Y);
}
function $aefa23277c986a08$var$Lk() {
    for(; null !== $aefa23277c986a08$var$Y && !$aefa23277c986a08$var$cc();)$aefa23277c986a08$var$Uk($aefa23277c986a08$var$Y);
}
function $aefa23277c986a08$var$Uk(a) {
    var b = $aefa23277c986a08$var$Vk(a.alternate, a, $aefa23277c986a08$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $aefa23277c986a08$var$Sk(a) : $aefa23277c986a08$var$Y = b;
    $aefa23277c986a08$var$nk.current = null;
}
function $aefa23277c986a08$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $aefa23277c986a08$var$Ej(c, b, $aefa23277c986a08$var$fj), null !== c) {
                $aefa23277c986a08$var$Y = c;
                return;
            }
        } else {
            c = $aefa23277c986a08$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $aefa23277c986a08$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $aefa23277c986a08$var$T = 6;
                $aefa23277c986a08$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $aefa23277c986a08$var$Y = b;
            return;
        }
        $aefa23277c986a08$var$Y = b = a;
    }while (null !== b);
    0 === $aefa23277c986a08$var$T && ($aefa23277c986a08$var$T = 5);
}
function $aefa23277c986a08$var$Pk(a, b, c) {
    var d = $aefa23277c986a08$var$C, e = $aefa23277c986a08$var$ok.transition;
    try {
        $aefa23277c986a08$var$ok.transition = null, $aefa23277c986a08$var$C = 1, $aefa23277c986a08$var$Wk(a, b, c, d);
    } finally{
        $aefa23277c986a08$var$ok.transition = e, $aefa23277c986a08$var$C = d;
    }
    return null;
}
function $aefa23277c986a08$var$Wk(a, b, c, d) {
    do $aefa23277c986a08$var$Hk();
    while (null !== $aefa23277c986a08$var$wk);
    if (0 !== ($aefa23277c986a08$var$K & 6)) throw Error($aefa23277c986a08$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($aefa23277c986a08$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $aefa23277c986a08$var$Bc(a, f);
    a === $aefa23277c986a08$var$Q && ($aefa23277c986a08$var$Y = $aefa23277c986a08$var$Q = null, $aefa23277c986a08$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $aefa23277c986a08$var$vk || ($aefa23277c986a08$var$vk = !0, $aefa23277c986a08$var$Fk($aefa23277c986a08$var$hc, function() {
        $aefa23277c986a08$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $aefa23277c986a08$var$ok.transition;
        $aefa23277c986a08$var$ok.transition = null;
        var g = $aefa23277c986a08$var$C;
        $aefa23277c986a08$var$C = 1;
        var h = $aefa23277c986a08$var$K;
        $aefa23277c986a08$var$K |= 4;
        $aefa23277c986a08$var$nk.current = null;
        $aefa23277c986a08$var$Oj(a, c);
        $aefa23277c986a08$var$dk(c, a);
        $aefa23277c986a08$var$Oe($aefa23277c986a08$var$Df);
        $aefa23277c986a08$var$dd = !!$aefa23277c986a08$var$Cf;
        $aefa23277c986a08$var$Df = $aefa23277c986a08$var$Cf = null;
        a.current = c;
        $aefa23277c986a08$var$hk(c, a, e);
        $aefa23277c986a08$var$dc();
        $aefa23277c986a08$var$K = h;
        $aefa23277c986a08$var$C = g;
        $aefa23277c986a08$var$ok.transition = f;
    } else a.current = c;
    $aefa23277c986a08$var$vk && ($aefa23277c986a08$var$vk = !1, $aefa23277c986a08$var$wk = a, $aefa23277c986a08$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($aefa23277c986a08$var$Ri = null);
    $aefa23277c986a08$var$mc(c.stateNode, d);
    $aefa23277c986a08$var$Dk(a, $aefa23277c986a08$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($aefa23277c986a08$var$Oi) throw $aefa23277c986a08$var$Oi = !1, a = $aefa23277c986a08$var$Pi, $aefa23277c986a08$var$Pi = null, a;
    0 !== ($aefa23277c986a08$var$xk & 1) && 0 !== a.tag && $aefa23277c986a08$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $aefa23277c986a08$var$zk ? $aefa23277c986a08$var$yk++ : ($aefa23277c986a08$var$yk = 0, $aefa23277c986a08$var$zk = a) : $aefa23277c986a08$var$yk = 0;
    $aefa23277c986a08$var$jg();
    return null;
}
function $aefa23277c986a08$var$Hk() {
    if (null !== $aefa23277c986a08$var$wk) {
        var a = $aefa23277c986a08$var$Dc($aefa23277c986a08$var$xk), b = $aefa23277c986a08$var$ok.transition, c = $aefa23277c986a08$var$C;
        try {
            $aefa23277c986a08$var$ok.transition = null;
            $aefa23277c986a08$var$C = 16 > a ? 16 : a;
            if (null === $aefa23277c986a08$var$wk) var d = !1;
            else {
                a = $aefa23277c986a08$var$wk;
                $aefa23277c986a08$var$wk = null;
                $aefa23277c986a08$var$xk = 0;
                if (0 !== ($aefa23277c986a08$var$K & 6)) throw Error($aefa23277c986a08$var$p(331));
                var e = $aefa23277c986a08$var$K;
                $aefa23277c986a08$var$K |= 4;
                for($aefa23277c986a08$var$V = a.current; null !== $aefa23277c986a08$var$V;){
                    var f = $aefa23277c986a08$var$V, g = f.child;
                    if (0 !== ($aefa23277c986a08$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($aefa23277c986a08$var$V = l; null !== $aefa23277c986a08$var$V;){
                                    var m = $aefa23277c986a08$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $aefa23277c986a08$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $aefa23277c986a08$var$V = q;
                                    else for(; null !== $aefa23277c986a08$var$V;){
                                        m = $aefa23277c986a08$var$V;
                                        var r = m.sibling, y = m.return;
                                        $aefa23277c986a08$var$Sj(m);
                                        if (m === l) {
                                            $aefa23277c986a08$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $aefa23277c986a08$var$V = r;
                                            break;
                                        }
                                        $aefa23277c986a08$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $aefa23277c986a08$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $aefa23277c986a08$var$V = g;
                    else b: for(; null !== $aefa23277c986a08$var$V;){
                        f = $aefa23277c986a08$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $aefa23277c986a08$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $aefa23277c986a08$var$V = x;
                            break b;
                        }
                        $aefa23277c986a08$var$V = f.return;
                    }
                }
                var w = a.current;
                for($aefa23277c986a08$var$V = w; null !== $aefa23277c986a08$var$V;){
                    g = $aefa23277c986a08$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $aefa23277c986a08$var$V = u;
                    else b: for(g = w; null !== $aefa23277c986a08$var$V;){
                        h = $aefa23277c986a08$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $aefa23277c986a08$var$Qj(9, h);
                            }
                        } catch (na) {
                            $aefa23277c986a08$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $aefa23277c986a08$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $aefa23277c986a08$var$V = F;
                            break b;
                        }
                        $aefa23277c986a08$var$V = h.return;
                    }
                }
                $aefa23277c986a08$var$K = e;
                $aefa23277c986a08$var$jg();
                if ($aefa23277c986a08$var$lc && "function" === typeof $aefa23277c986a08$var$lc.onPostCommitFiberRoot) try {
                    $aefa23277c986a08$var$lc.onPostCommitFiberRoot($aefa23277c986a08$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $aefa23277c986a08$var$C = c, $aefa23277c986a08$var$ok.transition = b;
        }
    }
    return !1;
}
function $aefa23277c986a08$var$Xk(a, b, c) {
    b = $aefa23277c986a08$var$Ji(c, b);
    b = $aefa23277c986a08$var$Ni(a, b, 1);
    a = $aefa23277c986a08$var$nh(a, b, 1);
    b = $aefa23277c986a08$var$R();
    null !== a && ($aefa23277c986a08$var$Ac(a, 1, b), $aefa23277c986a08$var$Dk(a, b));
}
function $aefa23277c986a08$var$W(a, b, c) {
    if (3 === a.tag) $aefa23277c986a08$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $aefa23277c986a08$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $aefa23277c986a08$var$Ri || !$aefa23277c986a08$var$Ri.has(d))) {
                a = $aefa23277c986a08$var$Ji(c, a);
                a = $aefa23277c986a08$var$Qi(b, a, 1);
                b = $aefa23277c986a08$var$nh(b, a, 1);
                a = $aefa23277c986a08$var$R();
                null !== b && ($aefa23277c986a08$var$Ac(b, 1, a), $aefa23277c986a08$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $aefa23277c986a08$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $aefa23277c986a08$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $aefa23277c986a08$var$Q === a && ($aefa23277c986a08$var$Z & c) === c && (4 === $aefa23277c986a08$var$T || 3 === $aefa23277c986a08$var$T && ($aefa23277c986a08$var$Z & 130023424) === $aefa23277c986a08$var$Z && 500 > $aefa23277c986a08$var$B() - $aefa23277c986a08$var$fk ? $aefa23277c986a08$var$Kk(a, 0) : $aefa23277c986a08$var$rk |= c);
    $aefa23277c986a08$var$Dk(a, b);
}
function $aefa23277c986a08$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $aefa23277c986a08$var$sc, $aefa23277c986a08$var$sc <<= 1, 0 === ($aefa23277c986a08$var$sc & 130023424) && ($aefa23277c986a08$var$sc = 4194304)));
    var c = $aefa23277c986a08$var$R();
    a = $aefa23277c986a08$var$ih(a, b);
    null !== a && ($aefa23277c986a08$var$Ac(a, b, c), $aefa23277c986a08$var$Dk(a, c));
}
function $aefa23277c986a08$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $aefa23277c986a08$var$Yk(a, c);
}
function $aefa23277c986a08$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($aefa23277c986a08$var$p(314));
    }
    null !== d && d.delete(b);
    $aefa23277c986a08$var$Yk(a, c);
}
var $aefa23277c986a08$var$Vk;
$aefa23277c986a08$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $aefa23277c986a08$var$Wf.current) $aefa23277c986a08$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $aefa23277c986a08$var$dh = !1, $aefa23277c986a08$var$yj(a, b, c);
            $aefa23277c986a08$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $aefa23277c986a08$var$dh = !1, $aefa23277c986a08$var$I && 0 !== (b.flags & 1048576) && $aefa23277c986a08$var$ug(b, $aefa23277c986a08$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $aefa23277c986a08$var$ij(a, b);
            a = b.pendingProps;
            var e = $aefa23277c986a08$var$Yf(b, $aefa23277c986a08$var$H.current);
            $aefa23277c986a08$var$ch(b, c);
            e = $aefa23277c986a08$var$Nh(null, b, d, a, e, c);
            var f = $aefa23277c986a08$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $aefa23277c986a08$var$Zf(d) ? (f = !0, $aefa23277c986a08$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $aefa23277c986a08$var$kh(b), e.updater = $aefa23277c986a08$var$Ei, b.stateNode = e, e._reactInternals = b, $aefa23277c986a08$var$Ii(b, d, a, c), b = $aefa23277c986a08$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $aefa23277c986a08$var$I && f && $aefa23277c986a08$var$vg(b), $aefa23277c986a08$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $aefa23277c986a08$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $aefa23277c986a08$var$Zk(d);
                a = $aefa23277c986a08$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $aefa23277c986a08$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $aefa23277c986a08$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $aefa23277c986a08$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $aefa23277c986a08$var$$i(null, b, d, $aefa23277c986a08$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($aefa23277c986a08$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $aefa23277c986a08$var$Ci(d, e), $aefa23277c986a08$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $aefa23277c986a08$var$Ci(d, e), $aefa23277c986a08$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $aefa23277c986a08$var$kj(b);
                if (null === a) throw Error($aefa23277c986a08$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $aefa23277c986a08$var$lh(a, b);
                $aefa23277c986a08$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $aefa23277c986a08$var$Ji(Error($aefa23277c986a08$var$p(423)), b);
                        b = $aefa23277c986a08$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $aefa23277c986a08$var$Ji(Error($aefa23277c986a08$var$p(424)), b);
                        b = $aefa23277c986a08$var$lj(a, b, d, c, e);
                        break a;
                    } else for($aefa23277c986a08$var$yg = $aefa23277c986a08$var$Lf(b.stateNode.containerInfo.firstChild), $aefa23277c986a08$var$xg = b, $aefa23277c986a08$var$I = !0, $aefa23277c986a08$var$zg = null, c = $aefa23277c986a08$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $aefa23277c986a08$var$Ig();
                    if (d === e) {
                        b = $aefa23277c986a08$var$Zi(a, b, c);
                        break a;
                    }
                    $aefa23277c986a08$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $aefa23277c986a08$var$Ah(b), null === a && $aefa23277c986a08$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $aefa23277c986a08$var$Ef(d, e) ? g = null : null !== f && $aefa23277c986a08$var$Ef(d, f) && (b.flags |= 32), $aefa23277c986a08$var$gj(a, b), $aefa23277c986a08$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $aefa23277c986a08$var$Eg(b), null;
        case 13:
            return $aefa23277c986a08$var$oj(a, b, c);
        case 4:
            return $aefa23277c986a08$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $aefa23277c986a08$var$Ug(b, null, d, c) : $aefa23277c986a08$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $aefa23277c986a08$var$Ci(d, e), $aefa23277c986a08$var$Yi(a, b, d, e, c);
        case 7:
            return $aefa23277c986a08$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $aefa23277c986a08$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $aefa23277c986a08$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $aefa23277c986a08$var$G($aefa23277c986a08$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($aefa23277c986a08$var$He(f.value, g)) {
                        if (f.children === e.children && !$aefa23277c986a08$var$Wf.current) {
                            b = $aefa23277c986a08$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $aefa23277c986a08$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $aefa23277c986a08$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($aefa23277c986a08$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $aefa23277c986a08$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $aefa23277c986a08$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $aefa23277c986a08$var$ch(b, c), e = $aefa23277c986a08$var$eh(e), d = d(e), b.flags |= 1, $aefa23277c986a08$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $aefa23277c986a08$var$Ci(d, b.pendingProps), e = $aefa23277c986a08$var$Ci(d.type, e), $aefa23277c986a08$var$$i(a, b, d, e, c);
        case 15:
            return $aefa23277c986a08$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $aefa23277c986a08$var$Ci(d, e), $aefa23277c986a08$var$ij(a, b), b.tag = 1, $aefa23277c986a08$var$Zf(d) ? (a = !0, $aefa23277c986a08$var$cg(b)) : a = !1, $aefa23277c986a08$var$ch(b, c), $aefa23277c986a08$var$Gi(b, d, e), $aefa23277c986a08$var$Ii(b, d, e, c), $aefa23277c986a08$var$jj(null, b, d, !0, a, c);
        case 19:
            return $aefa23277c986a08$var$xj(a, b, c);
        case 22:
            return $aefa23277c986a08$var$dj(a, b, c);
    }
    throw Error($aefa23277c986a08$var$p(156, b.tag));
};
function $aefa23277c986a08$var$Fk(a, b) {
    return $aefa23277c986a08$var$ac(a, b);
}
function $aefa23277c986a08$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $aefa23277c986a08$var$Bg(a, b, c, d) {
    return new $aefa23277c986a08$var$$k(a, b, c, d);
}
function $aefa23277c986a08$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $aefa23277c986a08$var$Zk(a) {
    if ("function" === typeof a) return $aefa23277c986a08$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $aefa23277c986a08$var$Da) return 11;
        if (a === $aefa23277c986a08$var$Ga) return 14;
    }
    return 2;
}
function $aefa23277c986a08$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $aefa23277c986a08$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $aefa23277c986a08$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $aefa23277c986a08$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $aefa23277c986a08$var$ya:
            return $aefa23277c986a08$var$Tg(c.children, e, f, b);
        case $aefa23277c986a08$var$za:
            g = 8;
            e |= 8;
            break;
        case $aefa23277c986a08$var$Aa:
            return a = $aefa23277c986a08$var$Bg(12, c, b, e | 2), a.elementType = $aefa23277c986a08$var$Aa, a.lanes = f, a;
        case $aefa23277c986a08$var$Ea:
            return a = $aefa23277c986a08$var$Bg(13, c, b, e), a.elementType = $aefa23277c986a08$var$Ea, a.lanes = f, a;
        case $aefa23277c986a08$var$Fa:
            return a = $aefa23277c986a08$var$Bg(19, c, b, e), a.elementType = $aefa23277c986a08$var$Fa, a.lanes = f, a;
        case $aefa23277c986a08$var$Ia:
            return $aefa23277c986a08$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $aefa23277c986a08$var$Ba:
                    g = 10;
                    break a;
                case $aefa23277c986a08$var$Ca:
                    g = 9;
                    break a;
                case $aefa23277c986a08$var$Da:
                    g = 11;
                    break a;
                case $aefa23277c986a08$var$Ga:
                    g = 14;
                    break a;
                case $aefa23277c986a08$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($aefa23277c986a08$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $aefa23277c986a08$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $aefa23277c986a08$var$Tg(a, b, c, d) {
    a = $aefa23277c986a08$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $aefa23277c986a08$var$pj(a, b, c, d) {
    a = $aefa23277c986a08$var$Bg(22, a, d, b);
    a.elementType = $aefa23277c986a08$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $aefa23277c986a08$var$Qg(a, b, c) {
    a = $aefa23277c986a08$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $aefa23277c986a08$var$Sg(a, b, c) {
    b = $aefa23277c986a08$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $aefa23277c986a08$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $aefa23277c986a08$var$zc(0);
    this.expirationTimes = $aefa23277c986a08$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $aefa23277c986a08$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $aefa23277c986a08$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $aefa23277c986a08$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $aefa23277c986a08$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $aefa23277c986a08$var$kh(f);
    return a;
}
function $aefa23277c986a08$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $aefa23277c986a08$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $aefa23277c986a08$var$dl(a) {
    if (!a) return $aefa23277c986a08$var$Vf;
    a = a._reactInternals;
    a: {
        if ($aefa23277c986a08$var$Vb(a) !== a || 1 !== a.tag) throw Error($aefa23277c986a08$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($aefa23277c986a08$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($aefa23277c986a08$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($aefa23277c986a08$var$Zf(c)) return $aefa23277c986a08$var$bg(a, c, b);
    }
    return b;
}
function $aefa23277c986a08$var$el(a, b, c, d, e, f, g, h, k) {
    a = $aefa23277c986a08$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $aefa23277c986a08$var$dl(null);
    c = a.current;
    d = $aefa23277c986a08$var$R();
    e = $aefa23277c986a08$var$yi(c);
    f = $aefa23277c986a08$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $aefa23277c986a08$var$nh(c, f, e);
    a.current.lanes = e;
    $aefa23277c986a08$var$Ac(a, e, d);
    $aefa23277c986a08$var$Dk(a, d);
    return a;
}
function $aefa23277c986a08$var$fl(a, b, c, d) {
    var e = b.current, f = $aefa23277c986a08$var$R(), g = $aefa23277c986a08$var$yi(e);
    c = $aefa23277c986a08$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $aefa23277c986a08$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $aefa23277c986a08$var$nh(e, b, g);
    null !== a && ($aefa23277c986a08$var$gi(a, e, g, f), $aefa23277c986a08$var$oh(a, e, g));
    return g;
}
function $aefa23277c986a08$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $aefa23277c986a08$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $aefa23277c986a08$var$il(a, b) {
    $aefa23277c986a08$var$hl(a, b);
    (a = a.alternate) && $aefa23277c986a08$var$hl(a, b);
}
function $aefa23277c986a08$var$jl() {
    return null;
}
var $aefa23277c986a08$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $aefa23277c986a08$var$ll(a) {
    this._internalRoot = a;
}
$aefa23277c986a08$var$ml.prototype.render = $aefa23277c986a08$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($aefa23277c986a08$var$p(409));
    $aefa23277c986a08$var$fl(a, b, null, null);
};
$aefa23277c986a08$var$ml.prototype.unmount = $aefa23277c986a08$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $aefa23277c986a08$var$Rk(function() {
            $aefa23277c986a08$var$fl(null, a, null, null);
        });
        b[$aefa23277c986a08$var$uf] = null;
    }
};
function $aefa23277c986a08$var$ml(a) {
    this._internalRoot = a;
}
$aefa23277c986a08$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $aefa23277c986a08$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $aefa23277c986a08$var$Qc.length && 0 !== b && b < $aefa23277c986a08$var$Qc[c].priority; c++);
        $aefa23277c986a08$var$Qc.splice(c, 0, a);
        0 === c && $aefa23277c986a08$var$Vc(a);
    }
};
function $aefa23277c986a08$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $aefa23277c986a08$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $aefa23277c986a08$var$pl() {}
function $aefa23277c986a08$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $aefa23277c986a08$var$gl(g);
                f.call(a);
            };
        }
        var g = $aefa23277c986a08$var$el(b, d, a, 0, null, !1, !1, "", $aefa23277c986a08$var$pl);
        a._reactRootContainer = g;
        a[$aefa23277c986a08$var$uf] = g.current;
        $aefa23277c986a08$var$sf(8 === a.nodeType ? a.parentNode : a);
        $aefa23277c986a08$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $aefa23277c986a08$var$gl(k);
            h.call(a);
        };
    }
    var k = $aefa23277c986a08$var$bl(a, 0, !1, null, null, !1, !1, "", $aefa23277c986a08$var$pl);
    a._reactRootContainer = k;
    a[$aefa23277c986a08$var$uf] = k.current;
    $aefa23277c986a08$var$sf(8 === a.nodeType ? a.parentNode : a);
    $aefa23277c986a08$var$Rk(function() {
        $aefa23277c986a08$var$fl(b, k, c, d);
    });
    return k;
}
function $aefa23277c986a08$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $aefa23277c986a08$var$gl(g);
                h.call(a);
            };
        }
        $aefa23277c986a08$var$fl(b, g, a, e);
    } else g = $aefa23277c986a08$var$ql(c, b, a, e, d);
    return $aefa23277c986a08$var$gl(g);
}
$aefa23277c986a08$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $aefa23277c986a08$var$tc(b.pendingLanes);
                0 !== c && ($aefa23277c986a08$var$Cc(b, c | 1), $aefa23277c986a08$var$Dk(b, $aefa23277c986a08$var$B()), 0 === ($aefa23277c986a08$var$K & 6) && ($aefa23277c986a08$var$Gj = $aefa23277c986a08$var$B() + 500, $aefa23277c986a08$var$jg()));
            }
            break;
        case 13:
            $aefa23277c986a08$var$Rk(function() {
                var b = $aefa23277c986a08$var$ih(a, 1);
                if (null !== b) {
                    var c = $aefa23277c986a08$var$R();
                    $aefa23277c986a08$var$gi(b, a, 1, c);
                }
            }), $aefa23277c986a08$var$il(a, 1);
    }
};
$aefa23277c986a08$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $aefa23277c986a08$var$ih(a, 134217728);
        if (null !== b) {
            var c = $aefa23277c986a08$var$R();
            $aefa23277c986a08$var$gi(b, a, 134217728, c);
        }
        $aefa23277c986a08$var$il(a, 134217728);
    }
};
$aefa23277c986a08$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $aefa23277c986a08$var$yi(a), c = $aefa23277c986a08$var$ih(a, b);
        if (null !== c) {
            var d = $aefa23277c986a08$var$R();
            $aefa23277c986a08$var$gi(c, a, b, d);
        }
        $aefa23277c986a08$var$il(a, b);
    }
};
$aefa23277c986a08$var$Hc = function() {
    return $aefa23277c986a08$var$C;
};
$aefa23277c986a08$var$Ic = function(a, b) {
    var c = $aefa23277c986a08$var$C;
    try {
        return $aefa23277c986a08$var$C = a, b();
    } finally{
        $aefa23277c986a08$var$C = c;
    }
};
$aefa23277c986a08$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $aefa23277c986a08$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $aefa23277c986a08$var$Db(d);
                        if (!e) throw Error($aefa23277c986a08$var$p(90));
                        $aefa23277c986a08$var$Wa(d);
                        $aefa23277c986a08$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $aefa23277c986a08$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $aefa23277c986a08$var$fb(a, !!c.multiple, b, !1);
    }
};
$aefa23277c986a08$var$Gb = $aefa23277c986a08$var$Qk;
$aefa23277c986a08$var$Hb = $aefa23277c986a08$var$Rk;
var $aefa23277c986a08$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $aefa23277c986a08$var$Cb,
        $aefa23277c986a08$var$ue,
        $aefa23277c986a08$var$Db,
        $aefa23277c986a08$var$Eb,
        $aefa23277c986a08$var$Fb,
        $aefa23277c986a08$var$Qk
    ]
}, $aefa23277c986a08$var$tl = {
    findFiberByHostInstance: $aefa23277c986a08$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $aefa23277c986a08$var$ul = {
    bundleType: $aefa23277c986a08$var$tl.bundleType,
    version: $aefa23277c986a08$var$tl.version,
    rendererPackageName: $aefa23277c986a08$var$tl.rendererPackageName,
    rendererConfig: $aefa23277c986a08$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $aefa23277c986a08$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $aefa23277c986a08$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $aefa23277c986a08$var$tl.findFiberByHostInstance || $aefa23277c986a08$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $aefa23277c986a08$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$aefa23277c986a08$var$vl.isDisabled && $aefa23277c986a08$var$vl.supportsFiber) try {
        $aefa23277c986a08$var$kc = $aefa23277c986a08$var$vl.inject($aefa23277c986a08$var$ul), $aefa23277c986a08$var$lc = $aefa23277c986a08$var$vl;
    } catch (a) {}
}
$aefa23277c986a08$export$ae55be85d98224ed = $aefa23277c986a08$var$sl;
$aefa23277c986a08$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$aefa23277c986a08$var$nl(b)) throw Error($aefa23277c986a08$var$p(200));
    return $aefa23277c986a08$var$cl(a, b, null, c);
};
$aefa23277c986a08$export$882461b6382ed46c = function(a, b) {
    if (!$aefa23277c986a08$var$nl(a)) throw Error($aefa23277c986a08$var$p(299));
    var c = !1, d = "", e = $aefa23277c986a08$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $aefa23277c986a08$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$aefa23277c986a08$var$uf] = b.current;
    $aefa23277c986a08$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $aefa23277c986a08$var$ll(b);
};
$aefa23277c986a08$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($aefa23277c986a08$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($aefa23277c986a08$var$p(268, a));
    }
    a = $aefa23277c986a08$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$aefa23277c986a08$export$cd75ccfd720a3cd4 = function(a) {
    return $aefa23277c986a08$var$Rk(a);
};
$aefa23277c986a08$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$aefa23277c986a08$var$ol(b)) throw Error($aefa23277c986a08$var$p(200));
    return $aefa23277c986a08$var$rl(null, a, b, !0, c);
};
$aefa23277c986a08$export$757ceba2d55c277e = function(a, b, c) {
    if (!$aefa23277c986a08$var$nl(a)) throw Error($aefa23277c986a08$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $aefa23277c986a08$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $aefa23277c986a08$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$aefa23277c986a08$var$uf] = b.current;
    $aefa23277c986a08$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $aefa23277c986a08$var$ml(b);
};
$aefa23277c986a08$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$aefa23277c986a08$var$ol(b)) throw Error($aefa23277c986a08$var$p(200));
    return $aefa23277c986a08$var$rl(null, a, b, !1, c);
};
$aefa23277c986a08$export$502457920280e6be = function(a) {
    if (!$aefa23277c986a08$var$ol(a)) throw Error($aefa23277c986a08$var$p(40));
    return a._reactRootContainer ? ($aefa23277c986a08$var$Rk(function() {
        $aefa23277c986a08$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$aefa23277c986a08$var$uf] = null;
        });
    }), !0) : !1;
};
$aefa23277c986a08$export$c78a37762a8d58e1 = $aefa23277c986a08$var$Qk;
$aefa23277c986a08$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$aefa23277c986a08$var$ol(c)) throw Error($aefa23277c986a08$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($aefa23277c986a08$var$p(38));
    return $aefa23277c986a08$var$rl(a, b, c, !1, d);
};
$aefa23277c986a08$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("8fzia", function(module, exports) {
'use strict';

module.exports = (parcelRequire("i02ua"));

});
parcelRegister("i02ua", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $d1aa27accd54c53b$export$c4744153514ff05d; }, function (v) { return $d1aa27accd54c53b$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $d1aa27accd54c53b$export$3e506c1ccc9cc1a7; }, function (v) { return $d1aa27accd54c53b$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $d1aa27accd54c53b$export$e26fe2ed2fa76875; }, function (v) { return $d1aa27accd54c53b$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $d1aa27accd54c53b$export$502329bbf4b505b1; }, function (v) { return $d1aa27accd54c53b$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $d1aa27accd54c53b$export$6e3807111c4874c4; }, function (v) { return $d1aa27accd54c53b$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $d1aa27accd54c53b$export$c27134553091fb3a; }, function (v) { return $d1aa27accd54c53b$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $d1aa27accd54c53b$export$33ee1acdc04fd2a2; }, function (v) { return $d1aa27accd54c53b$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $d1aa27accd54c53b$export$b00a404bbd5edef2; }, function (v) { return $d1aa27accd54c53b$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $d1aa27accd54c53b$export$8352ce38b91d0c62; }, function (v) { return $d1aa27accd54c53b$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $d1aa27accd54c53b$export$d66a1c1c77bd778b; }, function (v) { return $d1aa27accd54c53b$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $d1aa27accd54c53b$export$d3dfb8e4810cb555; }, function (v) { return $d1aa27accd54c53b$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $d1aa27accd54c53b$export$839f9183b0465a69; }, function (v) { return $d1aa27accd54c53b$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $d1aa27accd54c53b$export$72fdf0e06517287b; }, function (v) { return $d1aa27accd54c53b$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $d1aa27accd54c53b$export$4b844e58a3e414b4; }, function (v) { return $d1aa27accd54c53b$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $d1aa27accd54c53b$export$816d2913ae6b83b1; }, function (v) { return $d1aa27accd54c53b$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $d1aa27accd54c53b$export$61bcfe829111a1d0; }, function (v) { return $d1aa27accd54c53b$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $d1aa27accd54c53b$export$7ee8c9beb337bc3f; }, function (v) { return $d1aa27accd54c53b$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $d1aa27accd54c53b$export$b5836b71941fa3ed; }, function (v) { return $d1aa27accd54c53b$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $d1aa27accd54c53b$export$cf845f2c119da08a; }, function (v) { return $d1aa27accd54c53b$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d1aa27accd54c53b$export$c4744153514ff05d;
var $d1aa27accd54c53b$export$3e506c1ccc9cc1a7;
var $d1aa27accd54c53b$export$e26fe2ed2fa76875;
var $d1aa27accd54c53b$export$502329bbf4b505b1;
var $d1aa27accd54c53b$export$6e3807111c4874c4;
var $d1aa27accd54c53b$export$c27134553091fb3a;
var $d1aa27accd54c53b$export$33ee1acdc04fd2a2;
var $d1aa27accd54c53b$export$b00a404bbd5edef2;
var $d1aa27accd54c53b$export$8352ce38b91d0c62;
var $d1aa27accd54c53b$export$d66a1c1c77bd778b;
var $d1aa27accd54c53b$export$d3dfb8e4810cb555;
var $d1aa27accd54c53b$export$839f9183b0465a69;
var $d1aa27accd54c53b$export$72fdf0e06517287b;
var $d1aa27accd54c53b$export$4b844e58a3e414b4;
var $d1aa27accd54c53b$export$816d2913ae6b83b1;
var $d1aa27accd54c53b$export$61bcfe829111a1d0;
var $d1aa27accd54c53b$export$7ee8c9beb337bc3f;
var $d1aa27accd54c53b$export$b5836b71941fa3ed;
var $d1aa27accd54c53b$export$cf845f2c119da08a;
'use strict';
function $d1aa27accd54c53b$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $d1aa27accd54c53b$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $d1aa27accd54c53b$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $d1aa27accd54c53b$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $d1aa27accd54c53b$var$g(C, c)) n < e && 0 > $d1aa27accd54c53b$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $d1aa27accd54c53b$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $d1aa27accd54c53b$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $d1aa27accd54c53b$var$l = performance;
    $d1aa27accd54c53b$export$c4744153514ff05d = function() {
        return $d1aa27accd54c53b$var$l.now();
    };
} else {
    var $d1aa27accd54c53b$var$p = Date, $d1aa27accd54c53b$var$q = $d1aa27accd54c53b$var$p.now();
    $d1aa27accd54c53b$export$c4744153514ff05d = function() {
        return $d1aa27accd54c53b$var$p.now() - $d1aa27accd54c53b$var$q;
    };
}
var $d1aa27accd54c53b$var$r = [], $d1aa27accd54c53b$var$t = [], $d1aa27accd54c53b$var$u = 1, $d1aa27accd54c53b$var$v = null, $d1aa27accd54c53b$var$y = 3, $d1aa27accd54c53b$var$z = !1, $d1aa27accd54c53b$var$A = !1, $d1aa27accd54c53b$var$B = !1, $d1aa27accd54c53b$var$D = "function" === typeof setTimeout ? setTimeout : null, $d1aa27accd54c53b$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $d1aa27accd54c53b$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $d1aa27accd54c53b$var$G(a) {
    for(var b = $d1aa27accd54c53b$var$h($d1aa27accd54c53b$var$t); null !== b;){
        if (null === b.callback) $d1aa27accd54c53b$var$k($d1aa27accd54c53b$var$t);
        else if (b.startTime <= a) $d1aa27accd54c53b$var$k($d1aa27accd54c53b$var$t), b.sortIndex = b.expirationTime, $d1aa27accd54c53b$var$f($d1aa27accd54c53b$var$r, b);
        else break;
        b = $d1aa27accd54c53b$var$h($d1aa27accd54c53b$var$t);
    }
}
function $d1aa27accd54c53b$var$H(a) {
    $d1aa27accd54c53b$var$B = !1;
    $d1aa27accd54c53b$var$G(a);
    if (!$d1aa27accd54c53b$var$A) {
        if (null !== $d1aa27accd54c53b$var$h($d1aa27accd54c53b$var$r)) $d1aa27accd54c53b$var$A = !0, $d1aa27accd54c53b$var$I($d1aa27accd54c53b$var$J);
        else {
            var b = $d1aa27accd54c53b$var$h($d1aa27accd54c53b$var$t);
            null !== b && $d1aa27accd54c53b$var$K($d1aa27accd54c53b$var$H, b.startTime - a);
        }
    }
}
function $d1aa27accd54c53b$var$J(a, b) {
    $d1aa27accd54c53b$var$A = !1;
    $d1aa27accd54c53b$var$B && ($d1aa27accd54c53b$var$B = !1, $d1aa27accd54c53b$var$E($d1aa27accd54c53b$var$L), $d1aa27accd54c53b$var$L = -1);
    $d1aa27accd54c53b$var$z = !0;
    var c = $d1aa27accd54c53b$var$y;
    try {
        $d1aa27accd54c53b$var$G(b);
        for($d1aa27accd54c53b$var$v = $d1aa27accd54c53b$var$h($d1aa27accd54c53b$var$r); null !== $d1aa27accd54c53b$var$v && (!($d1aa27accd54c53b$var$v.expirationTime > b) || a && !$d1aa27accd54c53b$var$M());){
            var d = $d1aa27accd54c53b$var$v.callback;
            if ("function" === typeof d) {
                $d1aa27accd54c53b$var$v.callback = null;
                $d1aa27accd54c53b$var$y = $d1aa27accd54c53b$var$v.priorityLevel;
                var e = d($d1aa27accd54c53b$var$v.expirationTime <= b);
                b = $d1aa27accd54c53b$export$c4744153514ff05d();
                "function" === typeof e ? $d1aa27accd54c53b$var$v.callback = e : $d1aa27accd54c53b$var$v === $d1aa27accd54c53b$var$h($d1aa27accd54c53b$var$r) && $d1aa27accd54c53b$var$k($d1aa27accd54c53b$var$r);
                $d1aa27accd54c53b$var$G(b);
            } else $d1aa27accd54c53b$var$k($d1aa27accd54c53b$var$r);
            $d1aa27accd54c53b$var$v = $d1aa27accd54c53b$var$h($d1aa27accd54c53b$var$r);
        }
        if (null !== $d1aa27accd54c53b$var$v) var w = !0;
        else {
            var m = $d1aa27accd54c53b$var$h($d1aa27accd54c53b$var$t);
            null !== m && $d1aa27accd54c53b$var$K($d1aa27accd54c53b$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $d1aa27accd54c53b$var$v = null, $d1aa27accd54c53b$var$y = c, $d1aa27accd54c53b$var$z = !1;
    }
}
var $d1aa27accd54c53b$var$N = !1, $d1aa27accd54c53b$var$O = null, $d1aa27accd54c53b$var$L = -1, $d1aa27accd54c53b$var$P = 5, $d1aa27accd54c53b$var$Q = -1;
function $d1aa27accd54c53b$var$M() {
    return $d1aa27accd54c53b$export$c4744153514ff05d() - $d1aa27accd54c53b$var$Q < $d1aa27accd54c53b$var$P ? !1 : !0;
}
function $d1aa27accd54c53b$var$R() {
    if (null !== $d1aa27accd54c53b$var$O) {
        var a = $d1aa27accd54c53b$export$c4744153514ff05d();
        $d1aa27accd54c53b$var$Q = a;
        var b = !0;
        try {
            b = $d1aa27accd54c53b$var$O(!0, a);
        } finally{
            b ? $d1aa27accd54c53b$var$S() : ($d1aa27accd54c53b$var$N = !1, $d1aa27accd54c53b$var$O = null);
        }
    } else $d1aa27accd54c53b$var$N = !1;
}
var $d1aa27accd54c53b$var$S;
if ("function" === typeof $d1aa27accd54c53b$var$F) $d1aa27accd54c53b$var$S = function() {
    $d1aa27accd54c53b$var$F($d1aa27accd54c53b$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $d1aa27accd54c53b$var$T = new MessageChannel, $d1aa27accd54c53b$var$U = $d1aa27accd54c53b$var$T.port2;
    $d1aa27accd54c53b$var$T.port1.onmessage = $d1aa27accd54c53b$var$R;
    $d1aa27accd54c53b$var$S = function() {
        $d1aa27accd54c53b$var$U.postMessage(null);
    };
} else $d1aa27accd54c53b$var$S = function() {
    $d1aa27accd54c53b$var$D($d1aa27accd54c53b$var$R, 0);
};
function $d1aa27accd54c53b$var$I(a) {
    $d1aa27accd54c53b$var$O = a;
    $d1aa27accd54c53b$var$N || ($d1aa27accd54c53b$var$N = !0, $d1aa27accd54c53b$var$S());
}
function $d1aa27accd54c53b$var$K(a, b) {
    $d1aa27accd54c53b$var$L = $d1aa27accd54c53b$var$D(function() {
        a($d1aa27accd54c53b$export$c4744153514ff05d());
    }, b);
}
$d1aa27accd54c53b$export$3e506c1ccc9cc1a7 = 5;
$d1aa27accd54c53b$export$e26fe2ed2fa76875 = 1;
$d1aa27accd54c53b$export$502329bbf4b505b1 = 4;
$d1aa27accd54c53b$export$6e3807111c4874c4 = 3;
$d1aa27accd54c53b$export$c27134553091fb3a = null;
$d1aa27accd54c53b$export$33ee1acdc04fd2a2 = 2;
$d1aa27accd54c53b$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$d1aa27accd54c53b$export$8352ce38b91d0c62 = function() {
    $d1aa27accd54c53b$var$A || $d1aa27accd54c53b$var$z || ($d1aa27accd54c53b$var$A = !0, $d1aa27accd54c53b$var$I($d1aa27accd54c53b$var$J));
};
$d1aa27accd54c53b$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $d1aa27accd54c53b$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$d1aa27accd54c53b$export$d3dfb8e4810cb555 = function() {
    return $d1aa27accd54c53b$var$y;
};
$d1aa27accd54c53b$export$839f9183b0465a69 = function() {
    return $d1aa27accd54c53b$var$h($d1aa27accd54c53b$var$r);
};
$d1aa27accd54c53b$export$72fdf0e06517287b = function(a) {
    switch($d1aa27accd54c53b$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $d1aa27accd54c53b$var$y;
    }
    var c = $d1aa27accd54c53b$var$y;
    $d1aa27accd54c53b$var$y = b;
    try {
        return a();
    } finally{
        $d1aa27accd54c53b$var$y = c;
    }
};
$d1aa27accd54c53b$export$4b844e58a3e414b4 = function() {};
$d1aa27accd54c53b$export$816d2913ae6b83b1 = function() {};
$d1aa27accd54c53b$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $d1aa27accd54c53b$var$y;
    $d1aa27accd54c53b$var$y = a;
    try {
        return b();
    } finally{
        $d1aa27accd54c53b$var$y = c;
    }
};
$d1aa27accd54c53b$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $d1aa27accd54c53b$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $d1aa27accd54c53b$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $d1aa27accd54c53b$var$f($d1aa27accd54c53b$var$t, a), null === $d1aa27accd54c53b$var$h($d1aa27accd54c53b$var$r) && a === $d1aa27accd54c53b$var$h($d1aa27accd54c53b$var$t) && ($d1aa27accd54c53b$var$B ? ($d1aa27accd54c53b$var$E($d1aa27accd54c53b$var$L), $d1aa27accd54c53b$var$L = -1) : $d1aa27accd54c53b$var$B = !0, $d1aa27accd54c53b$var$K($d1aa27accd54c53b$var$H, c - d))) : (a.sortIndex = e, $d1aa27accd54c53b$var$f($d1aa27accd54c53b$var$r, a), $d1aa27accd54c53b$var$A || $d1aa27accd54c53b$var$z || ($d1aa27accd54c53b$var$A = !0, $d1aa27accd54c53b$var$I($d1aa27accd54c53b$var$J)));
    return a;
};
$d1aa27accd54c53b$export$b5836b71941fa3ed = $d1aa27accd54c53b$var$M;
$d1aa27accd54c53b$export$cf845f2c119da08a = function(a) {
    var b = $d1aa27accd54c53b$var$y;
    return function() {
        var c = $d1aa27accd54c53b$var$y;
        $d1aa27accd54c53b$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $d1aa27accd54c53b$var$y = c;
        }
    };
};

});



var $fe3e626085e1e6b8$exports = {};
'use strict';

$fe3e626085e1e6b8$exports = (parcelRequire("1ohhe"));


parcelRequire("aEMJz");
var $8779a10718613263$exports = {};

$parcel$export($8779a10718613263$exports, "createRoot", function () { return $8779a10718613263$export$882461b6382ed46c; }, function (v) { return $8779a10718613263$export$882461b6382ed46c = v; });
$parcel$export($8779a10718613263$exports, "hydrateRoot", function () { return $8779a10718613263$export$757ceba2d55c277e; }, function (v) { return $8779a10718613263$export$757ceba2d55c277e = v; });
var $8779a10718613263$export$882461b6382ed46c;
var $8779a10718613263$export$757ceba2d55c277e;
'use strict';
var $068b8dd51fa92b96$exports = {};
'use strict';
function $068b8dd51fa92b96$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($068b8dd51fa92b96$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$068b8dd51fa92b96$var$checkDCE();

$068b8dd51fa92b96$exports = (parcelRequire("f1oJI"));


var $8779a10718613263$var$i;
$8779a10718613263$export$882461b6382ed46c = $068b8dd51fa92b96$exports.createRoot;
$8779a10718613263$export$757ceba2d55c277e = $068b8dd51fa92b96$exports.hydrateRoot;



function $0aa5c5a93c4e63b8$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $c28f73f96bffd3b9$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $0aa5c5a93c4e63b8$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}




var $aEMJz = parcelRequire("aEMJz");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $10e83365bcd320a7$var$extendStatics = function(d, b) {
    $10e83365bcd320a7$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $10e83365bcd320a7$var$extendStatics(d, b);
};
function $10e83365bcd320a7$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $10e83365bcd320a7$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $10e83365bcd320a7$export$18ce0697a983be9b = function() {
    $10e83365bcd320a7$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $10e83365bcd320a7$export$18ce0697a983be9b.apply(this, arguments);
};
function $10e83365bcd320a7$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $10e83365bcd320a7$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $10e83365bcd320a7$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $10e83365bcd320a7$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $10e83365bcd320a7$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $10e83365bcd320a7$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $10e83365bcd320a7$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $10e83365bcd320a7$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $10e83365bcd320a7$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $10e83365bcd320a7$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $10e83365bcd320a7$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $10e83365bcd320a7$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $10e83365bcd320a7$export$45d3717a4c69092e(o, m, p);
}
function $10e83365bcd320a7$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $10e83365bcd320a7$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $10e83365bcd320a7$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($10e83365bcd320a7$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $10e83365bcd320a7$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $10e83365bcd320a7$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $10e83365bcd320a7$export$10c90e4f7922046c(v) {
    return this instanceof $10e83365bcd320a7$export$10c90e4f7922046c ? (this.v = v, this) : new $10e83365bcd320a7$export$10c90e4f7922046c(v);
}
function $10e83365bcd320a7$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $10e83365bcd320a7$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $10e83365bcd320a7$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $10e83365bcd320a7$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $10e83365bcd320a7$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $10e83365bcd320a7$export$19a8beecd37a4c45 === "function" ? $10e83365bcd320a7$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $10e83365bcd320a7$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $10e83365bcd320a7$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $10e83365bcd320a7$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $10e83365bcd320a7$export$45d3717a4c69092e(result, mod, k);
    }
    $10e83365bcd320a7$var$__setModuleDefault(result, mod);
    return result;
}
function $10e83365bcd320a7$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $10e83365bcd320a7$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $10e83365bcd320a7$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $10e83365bcd320a7$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $10e83365bcd320a7$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $10e83365bcd320a7$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $10e83365bcd320a7$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $10e83365bcd320a7$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $10e83365bcd320a7$export$2e2bcd8739ae039 = {
    __extends: $10e83365bcd320a7$export$a8ba968b8961cb8a,
    __assign: $10e83365bcd320a7$export$18ce0697a983be9b,
    __rest: $10e83365bcd320a7$export$3c9a16f847548506,
    __decorate: $10e83365bcd320a7$export$29e00dfd3077644b,
    __param: $10e83365bcd320a7$export$d5ad3fd78186038f,
    __metadata: $10e83365bcd320a7$export$f1db080c865becb9,
    __awaiter: $10e83365bcd320a7$export$1050f835b63b671e,
    __generator: $10e83365bcd320a7$export$67ebef60e6f28a6,
    __createBinding: $10e83365bcd320a7$export$45d3717a4c69092e,
    __exportStar: $10e83365bcd320a7$export$f33643c0debef087,
    __values: $10e83365bcd320a7$export$19a8beecd37a4c45,
    __read: $10e83365bcd320a7$export$8d051b38c9118094,
    __spread: $10e83365bcd320a7$export$afc72e2116322959,
    __spreadArrays: $10e83365bcd320a7$export$6388937ca91ccae8,
    __spreadArray: $10e83365bcd320a7$export$1216008129fb82ed,
    __await: $10e83365bcd320a7$export$10c90e4f7922046c,
    __asyncGenerator: $10e83365bcd320a7$export$e427f37a30a4de9b,
    __asyncDelegator: $10e83365bcd320a7$export$bbd80228419bb833,
    __asyncValues: $10e83365bcd320a7$export$e3b29a3d6162315f,
    __makeTemplateObject: $10e83365bcd320a7$export$4fb47efe1390b86f,
    __importStar: $10e83365bcd320a7$export$c21735bcef00d192,
    __importDefault: $10e83365bcd320a7$export$da59b14a69baef04,
    __classPrivateFieldGet: $10e83365bcd320a7$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $10e83365bcd320a7$export$d40a35129aaff81f,
    __classPrivateFieldIn: $10e83365bcd320a7$export$81fdc39f203e4e04,
    __addDisposableResource: $10e83365bcd320a7$export$88ac25d8e944e405,
    __disposeResources: $10e83365bcd320a7$export$8f076105dc360e92
};


function $d70e28cd182ca4f6$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $c141231a084a9fb3$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $c141231a084a9fb3$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $d70e28cd182ca4f6$export$2e2bcd8739ae039)(function(prop) {
    return $c141231a084a9fb3$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $aEMJz = parcelRequire("aEMJz");
var $60a79fe7c91658de$exports = {};
//
$60a79fe7c91658de$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


var $1b3c173596e236b2$export$71ad59f2e432cfe8 = "-ms-";
var $1b3c173596e236b2$export$2c0f367103c8d01c = "-moz-";
var $1b3c173596e236b2$export$39dfd62a25e0fe93 = "-webkit-";
var $1b3c173596e236b2$export$a29989082612d0d9 = "comm";
var $1b3c173596e236b2$export$aa3a2e812ca8570d = "rule";
var $1b3c173596e236b2$export$527d108ccf083c2b = "decl";
var $1b3c173596e236b2$export$d3d35020fa5b54f0 = "@page";
var $1b3c173596e236b2$export$500415a86c544f73 = "@media";
var $1b3c173596e236b2$export$a763edbf796b780a = "@import";
var $1b3c173596e236b2$export$2790aeb8b4e5c826 = "@charset";
var $1b3c173596e236b2$export$1cc683e23b84b133 = "@viewport";
var $1b3c173596e236b2$export$9447a5efea57e862 = "@supports";
var $1b3c173596e236b2$export$ef011b4e114b1fba = "@document";
var $1b3c173596e236b2$export$6aad947bda0f3f46 = "@namespace";
var $1b3c173596e236b2$export$b44a8529a35fcb60 = "@keyframes";
var $1b3c173596e236b2$export$2c16de31893252e6 = "@font-face";
var $1b3c173596e236b2$export$3d846dd52e150c6f = "@counter-style";
var $1b3c173596e236b2$export$22314bfbb57653fe = "@font-feature-values";
var $1b3c173596e236b2$export$d773506282b3cfe6 = "@layer";
var $1b3c173596e236b2$export$1c5a554c78c0cd12 = "@scope";
var $1b3c173596e236b2$export$2335f513bbd82c6d = Math.abs;
var $1b3c173596e236b2$export$6788812c4e6611e6 = String.fromCharCode;
var $1b3c173596e236b2$export$e6e34fd1f2686227 = Object.assign;
function $1b3c173596e236b2$export$d6af199866bfb566(e, r) {
    return $1b3c173596e236b2$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $1b3c173596e236b2$export$a9db5e087081082d(e, 0)) << 2 ^ $1b3c173596e236b2$export$a9db5e087081082d(e, 1)) << 2 ^ $1b3c173596e236b2$export$a9db5e087081082d(e, 2)) << 2 ^ $1b3c173596e236b2$export$a9db5e087081082d(e, 3) : 0;
}
function $1b3c173596e236b2$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $1b3c173596e236b2$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $1b3c173596e236b2$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $1b3c173596e236b2$export$f8e21b1e77979a08(e, r, a) {
    return e.indexOf(r, a);
}
function $1b3c173596e236b2$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $1b3c173596e236b2$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $1b3c173596e236b2$export$36776f635604f274(e) {
    return e.length;
}
function $1b3c173596e236b2$export$f9084667e487ed46(e) {
    return e.length;
}
function $1b3c173596e236b2$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $1b3c173596e236b2$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $1b3c173596e236b2$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$1b3c173596e236b2$export$4659b591c19bdf3d(e, r);
    });
}
var $1b3c173596e236b2$export$53f1d5ea8de3d7c = 1;
var $1b3c173596e236b2$export$4e0c71f277ca26b3 = 1;
var $1b3c173596e236b2$export$f24224f1c91d8156 = 0;
var $1b3c173596e236b2$export$5880b8b5730aff45 = 0;
var $1b3c173596e236b2$export$c0306caf338ac095 = 0;
var $1b3c173596e236b2$export$30a86d91af8ff6e6 = "";
function $1b3c173596e236b2$export$35059013cd4a06db(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $1b3c173596e236b2$export$53f1d5ea8de3d7c,
        column: $1b3c173596e236b2$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $1b3c173596e236b2$export$784d13d8ee351f07(e, r) {
    return $1b3c173596e236b2$export$e6e34fd1f2686227($1b3c173596e236b2$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $1b3c173596e236b2$export$590e8b2c435046d9(e) {
    while(e.root)e = $1b3c173596e236b2$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $1b3c173596e236b2$export$10d8903dec122b9d(e, e.siblings);
}
function $1b3c173596e236b2$export$eba6f6f03b0a92e7() {
    return $1b3c173596e236b2$export$c0306caf338ac095;
}
function $1b3c173596e236b2$export$232faf9add678146() {
    $1b3c173596e236b2$export$c0306caf338ac095 = $1b3c173596e236b2$export$5880b8b5730aff45 > 0 ? $1b3c173596e236b2$export$a9db5e087081082d($1b3c173596e236b2$export$30a86d91af8ff6e6, --$1b3c173596e236b2$export$5880b8b5730aff45) : 0;
    if ($1b3c173596e236b2$export$4e0c71f277ca26b3--, $1b3c173596e236b2$export$c0306caf338ac095 === 10) $1b3c173596e236b2$export$4e0c71f277ca26b3 = 1, $1b3c173596e236b2$export$53f1d5ea8de3d7c--;
    return $1b3c173596e236b2$export$c0306caf338ac095;
}
function $1b3c173596e236b2$export$48cfd1e771a65c4f() {
    $1b3c173596e236b2$export$c0306caf338ac095 = $1b3c173596e236b2$export$5880b8b5730aff45 < $1b3c173596e236b2$export$f24224f1c91d8156 ? $1b3c173596e236b2$export$a9db5e087081082d($1b3c173596e236b2$export$30a86d91af8ff6e6, $1b3c173596e236b2$export$5880b8b5730aff45++) : 0;
    if ($1b3c173596e236b2$export$4e0c71f277ca26b3++, $1b3c173596e236b2$export$c0306caf338ac095 === 10) $1b3c173596e236b2$export$4e0c71f277ca26b3 = 1, $1b3c173596e236b2$export$53f1d5ea8de3d7c++;
    return $1b3c173596e236b2$export$c0306caf338ac095;
}
function $1b3c173596e236b2$export$4d3fb11e950abb9e() {
    return $1b3c173596e236b2$export$a9db5e087081082d($1b3c173596e236b2$export$30a86d91af8ff6e6, $1b3c173596e236b2$export$5880b8b5730aff45);
}
function $1b3c173596e236b2$export$e88cb2efb12ae807() {
    return $1b3c173596e236b2$export$5880b8b5730aff45;
}
function $1b3c173596e236b2$export$58adb3bec8346d0f(e, r) {
    return $1b3c173596e236b2$export$2f35ab04d2335697($1b3c173596e236b2$export$30a86d91af8ff6e6, e, r);
}
function $1b3c173596e236b2$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $1b3c173596e236b2$export$2de70f21292aac9e(e) {
    return $1b3c173596e236b2$export$53f1d5ea8de3d7c = $1b3c173596e236b2$export$4e0c71f277ca26b3 = 1, $1b3c173596e236b2$export$f24224f1c91d8156 = $1b3c173596e236b2$export$36776f635604f274($1b3c173596e236b2$export$30a86d91af8ff6e6 = e), $1b3c173596e236b2$export$5880b8b5730aff45 = 0, [];
}
function $1b3c173596e236b2$export$45918ac1574455b1(e) {
    return $1b3c173596e236b2$export$30a86d91af8ff6e6 = "", e;
}
function $1b3c173596e236b2$export$410ac95b9ec204b8(e) {
    return $1b3c173596e236b2$export$87c2784dc9fc4ab($1b3c173596e236b2$export$58adb3bec8346d0f($1b3c173596e236b2$export$5880b8b5730aff45 - 1, $1b3c173596e236b2$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $1b3c173596e236b2$export$660b2ee2d4fb4eff(e) {
    return $1b3c173596e236b2$export$45918ac1574455b1($1b3c173596e236b2$export$5f8c09e3ae6f64e1($1b3c173596e236b2$export$2de70f21292aac9e(e)));
}
function $1b3c173596e236b2$export$7af1228ff777d175(e) {
    while($1b3c173596e236b2$export$c0306caf338ac095 = $1b3c173596e236b2$export$4d3fb11e950abb9e())if ($1b3c173596e236b2$export$c0306caf338ac095 < 33) $1b3c173596e236b2$export$48cfd1e771a65c4f();
    else break;
    return $1b3c173596e236b2$export$9e1725a4cfeada27(e) > 2 || $1b3c173596e236b2$export$9e1725a4cfeada27($1b3c173596e236b2$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $1b3c173596e236b2$export$5f8c09e3ae6f64e1(e) {
    while($1b3c173596e236b2$export$48cfd1e771a65c4f())switch($1b3c173596e236b2$export$9e1725a4cfeada27($1b3c173596e236b2$export$c0306caf338ac095)){
        case 0:
            $1b3c173596e236b2$export$10d8903dec122b9d($1b3c173596e236b2$export$c2ab62c7bf24634($1b3c173596e236b2$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $1b3c173596e236b2$export$10d8903dec122b9d($1b3c173596e236b2$export$410ac95b9ec204b8($1b3c173596e236b2$export$c0306caf338ac095), e);
            break;
        default:
            $1b3c173596e236b2$export$10d8903dec122b9d($1b3c173596e236b2$export$6788812c4e6611e6($1b3c173596e236b2$export$c0306caf338ac095), e);
    }
    return e;
}
function $1b3c173596e236b2$export$955ba06d119e085e(e, r) {
    while(--r && $1b3c173596e236b2$export$48cfd1e771a65c4f())if ($1b3c173596e236b2$export$c0306caf338ac095 < 48 || $1b3c173596e236b2$export$c0306caf338ac095 > 102 || $1b3c173596e236b2$export$c0306caf338ac095 > 57 && $1b3c173596e236b2$export$c0306caf338ac095 < 65 || $1b3c173596e236b2$export$c0306caf338ac095 > 70 && $1b3c173596e236b2$export$c0306caf338ac095 < 97) break;
    return $1b3c173596e236b2$export$58adb3bec8346d0f(e, $1b3c173596e236b2$export$e88cb2efb12ae807() + (r < 6 && $1b3c173596e236b2$export$4d3fb11e950abb9e() == 32 && $1b3c173596e236b2$export$48cfd1e771a65c4f() == 32));
}
function $1b3c173596e236b2$export$c889f2fcc19dbf12(e) {
    while($1b3c173596e236b2$export$48cfd1e771a65c4f())switch($1b3c173596e236b2$export$c0306caf338ac095){
        case e:
            return $1b3c173596e236b2$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $1b3c173596e236b2$export$c889f2fcc19dbf12($1b3c173596e236b2$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $1b3c173596e236b2$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $1b3c173596e236b2$export$48cfd1e771a65c4f();
            break;
    }
    return $1b3c173596e236b2$export$5880b8b5730aff45;
}
function $1b3c173596e236b2$export$4254d4e2b3745c4c(e, r) {
    while($1b3c173596e236b2$export$48cfd1e771a65c4f())if (e + $1b3c173596e236b2$export$c0306caf338ac095 === 57) break;
    else if (e + $1b3c173596e236b2$export$c0306caf338ac095 === 84 && $1b3c173596e236b2$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $1b3c173596e236b2$export$58adb3bec8346d0f(r, $1b3c173596e236b2$export$5880b8b5730aff45 - 1) + "*" + $1b3c173596e236b2$export$6788812c4e6611e6(e === 47 ? e : $1b3c173596e236b2$export$48cfd1e771a65c4f());
}
function $1b3c173596e236b2$export$c2ab62c7bf24634(e) {
    while(!$1b3c173596e236b2$export$9e1725a4cfeada27($1b3c173596e236b2$export$4d3fb11e950abb9e()))$1b3c173596e236b2$export$48cfd1e771a65c4f();
    return $1b3c173596e236b2$export$58adb3bec8346d0f(e, $1b3c173596e236b2$export$5880b8b5730aff45);
}
function $1b3c173596e236b2$export$ef7acd7185315e22(e) {
    return $1b3c173596e236b2$export$45918ac1574455b1($1b3c173596e236b2$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $1b3c173596e236b2$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $1b3c173596e236b2$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var x = c;
    var y = s;
    var j = n;
    var z = k;
    while(w)switch(h = g, g = $1b3c173596e236b2$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $1b3c173596e236b2$export$a9db5e087081082d(z, l - 1) == 58) {
                if ($1b3c173596e236b2$export$f8e21b1e77979a08(z += $1b3c173596e236b2$export$77ad94ebf1c2b9ed($1b3c173596e236b2$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f", $1b3c173596e236b2$export$2335f513bbd82c6d(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            z += $1b3c173596e236b2$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            z += $1b3c173596e236b2$export$7af1228ff777d175(h);
            break;
        case 92:
            z += $1b3c173596e236b2$export$955ba06d119e085e($1b3c173596e236b2$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($1b3c173596e236b2$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $1b3c173596e236b2$export$10d8903dec122b9d($1b3c173596e236b2$export$4a34f930e789283c($1b3c173596e236b2$export$4254d4e2b3745c4c($1b3c173596e236b2$export$48cfd1e771a65c4f(), $1b3c173596e236b2$export$e88cb2efb12ae807()), r, a, i), i);
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * b:
            u[f++] = $1b3c173596e236b2$export$36776f635604f274(z) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = $1b3c173596e236b2$export$77ad94ebf1c2b9ed(z, /\f/g, "");
                    if (p > 0 && $1b3c173596e236b2$export$36776f635604f274(z) - l) $1b3c173596e236b2$export$10d8903dec122b9d(p > 32 ? $1b3c173596e236b2$export$f8483753829ec8f3(z + ";", n, a, l - 1, i) : $1b3c173596e236b2$export$f8483753829ec8f3($1b3c173596e236b2$export$77ad94ebf1c2b9ed(z, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $1b3c173596e236b2$export$10d8903dec122b9d(j = $1b3c173596e236b2$export$3307ffa7023ede1e(z, r, a, f, o, c, u, k, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $1b3c173596e236b2$export$98e6a39c04603d36(z, r, j, j, x, s, l, u, y);
                        else switch(v === 99 && $1b3c173596e236b2$export$a9db5e087081082d(z, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $1b3c173596e236b2$export$98e6a39c04603d36(e, j, j, n && $1b3c173596e236b2$export$10d8903dec122b9d($1b3c173596e236b2$export$3307ffa7023ede1e(e, j, j, 0, 0, c, u, k, c, x = [], l, y), y), c, y, l, u, n ? x : y);
                                break;
                            default:
                                $1b3c173596e236b2$export$98e6a39c04603d36(z, j, j, j, [
                                    ""
                                ], y, 0, u, y);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, k = z = "", l = t;
            break;
        case 58:
            l = 1 + $1b3c173596e236b2$export$36776f635604f274(z), p = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && $1b3c173596e236b2$export$232faf9add678146() == 125) continue;
            }
            switch(z += $1b3c173596e236b2$export$6788812c4e6611e6(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($1b3c173596e236b2$export$36776f635604f274(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($1b3c173596e236b2$export$4d3fb11e950abb9e() === 45) z += $1b3c173596e236b2$export$410ac95b9ec204b8($1b3c173596e236b2$export$48cfd1e771a65c4f());
                    v = $1b3c173596e236b2$export$4d3fb11e950abb9e(), o = l = $1b3c173596e236b2$export$36776f635604f274(k = z += $1b3c173596e236b2$export$c2ab62c7bf24634($1b3c173596e236b2$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (h === 45 && $1b3c173596e236b2$export$36776f635604f274(z) == 2) b = 0;
            }
    }
    return s;
}
function $1b3c173596e236b2$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l, v) {
    var p = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = $1b3c173596e236b2$export$f9084667e487ed46(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var k = 0, m = $1b3c173596e236b2$export$2f35ab04d2335697(e, p + 1, p = $1b3c173596e236b2$export$2335f513bbd82c6d(d = u[w])), x = e; k < b; ++k)if (x = $1b3c173596e236b2$export$87c2784dc9fc4ab(d > 0 ? h[k] + " " + m : $1b3c173596e236b2$export$77ad94ebf1c2b9ed(m, /&\f/g, h[k]))) f[g++] = x;
    return $1b3c173596e236b2$export$35059013cd4a06db(e, r, a, s === 0 ? $1b3c173596e236b2$export$aa3a2e812ca8570d : i, f, o, l, v);
}
function $1b3c173596e236b2$export$4a34f930e789283c(e, r, a, c) {
    return $1b3c173596e236b2$export$35059013cd4a06db(e, r, a, $1b3c173596e236b2$export$a29989082612d0d9, $1b3c173596e236b2$export$6788812c4e6611e6($1b3c173596e236b2$export$eba6f6f03b0a92e7()), $1b3c173596e236b2$export$2f35ab04d2335697(e, 2, -2), 0, c);
}
function $1b3c173596e236b2$export$f8483753829ec8f3(e, r, a, n, c) {
    return $1b3c173596e236b2$export$35059013cd4a06db(e, r, a, $1b3c173596e236b2$export$527d108ccf083c2b, $1b3c173596e236b2$export$2f35ab04d2335697(e, 0, n), $1b3c173596e236b2$export$2f35ab04d2335697(e, n + 1, -1), n, c);
}
function $1b3c173596e236b2$export$82e9f45cca5ba907(n, c, s) {
    switch($1b3c173596e236b2$export$d6af199866bfb566(n, c)){
        case 5103:
            return $1b3c173596e236b2$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $1b3c173596e236b2$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $1b3c173596e236b2$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $1b3c173596e236b2$export$39dfd62a25e0fe93 + n + $1b3c173596e236b2$export$2c0f367103c8d01c + n + $1b3c173596e236b2$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($1b3c173596e236b2$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $1b3c173596e236b2$export$39dfd62a25e0fe93 + n + $1b3c173596e236b2$export$71ad59f2e432cfe8 + $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $1b3c173596e236b2$export$39dfd62a25e0fe93 + n + $1b3c173596e236b2$export$71ad59f2e432cfe8 + $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $1b3c173596e236b2$export$39dfd62a25e0fe93 + n + $1b3c173596e236b2$export$71ad59f2e432cfe8 + $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $1b3c173596e236b2$export$39dfd62a25e0fe93 + n + $1b3c173596e236b2$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $1b3c173596e236b2$export$39dfd62a25e0fe93 + n + $1b3c173596e236b2$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $1b3c173596e236b2$export$39dfd62a25e0fe93 + n + $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $1b3c173596e236b2$export$39dfd62a25e0fe93 + "box-$1$2" + $1b3c173596e236b2$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $1b3c173596e236b2$export$39dfd62a25e0fe93 + n + $1b3c173596e236b2$export$71ad59f2e432cfe8 + "flex-item-" + $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$1b3c173596e236b2$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $1b3c173596e236b2$export$71ad59f2e432cfe8 + "grid-row-" + $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $1b3c173596e236b2$export$39dfd62a25e0fe93 + n + $1b3c173596e236b2$export$71ad59f2e432cfe8 + "flex-line-pack" + $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $1b3c173596e236b2$export$39dfd62a25e0fe93 + n + $1b3c173596e236b2$export$71ad59f2e432cfe8 + $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $1b3c173596e236b2$export$39dfd62a25e0fe93 + n + $1b3c173596e236b2$export$71ad59f2e432cfe8 + $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $1b3c173596e236b2$export$39dfd62a25e0fe93 + "box-" + $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, "-grow", "") + $1b3c173596e236b2$export$39dfd62a25e0fe93 + n + $1b3c173596e236b2$export$71ad59f2e432cfe8 + $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $1b3c173596e236b2$export$39dfd62a25e0fe93 + $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $1b3c173596e236b2$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $1b3c173596e236b2$export$77ad94ebf1c2b9ed($1b3c173596e236b2$export$77ad94ebf1c2b9ed($1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $1b3c173596e236b2$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $1b3c173596e236b2$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $1b3c173596e236b2$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $1b3c173596e236b2$export$77ad94ebf1c2b9ed($1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $1b3c173596e236b2$export$39dfd62a25e0fe93 + "box-pack:$3" + $1b3c173596e236b2$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $1b3c173596e236b2$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$1b3c173596e236b2$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $1b3c173596e236b2$export$71ad59f2e432cfe8 + "grid-column-align" + $1b3c173596e236b2$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $1b3c173596e236b2$export$71ad59f2e432cfe8 + $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $1b3c173596e236b2$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$1b3c173596e236b2$export$f8e21b1e77979a08(n + (s = s[c].value), "span", 0) ? n : $1b3c173596e236b2$export$71ad59f2e432cfe8 + $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $1b3c173596e236b2$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$1b3c173596e236b2$export$f8e21b1e77979a08(s, "span", 0) ? $1b3c173596e236b2$export$4659b591c19bdf3d(s, /\d+/) : +$1b3c173596e236b2$export$4659b591c19bdf3d(s, /\d+/) - +$1b3c173596e236b2$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $1b3c173596e236b2$export$71ad59f2e432cfe8 + $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $1b3c173596e236b2$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $1b3c173596e236b2$export$71ad59f2e432cfe8 + $1b3c173596e236b2$export$77ad94ebf1c2b9ed($1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $1b3c173596e236b2$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($1b3c173596e236b2$export$36776f635604f274(n) - 1 - c > 6) switch($1b3c173596e236b2$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($1b3c173596e236b2$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $1b3c173596e236b2$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $1b3c173596e236b2$export$2c0f367103c8d01c + ($1b3c173596e236b2$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$1b3c173596e236b2$export$f8e21b1e77979a08(n, "stretch", 0) ? $1b3c173596e236b2$export$82e9f45cca5ba907($1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $1b3c173596e236b2$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $1b3c173596e236b2$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($1b3c173596e236b2$export$a9db5e087081082d(n, c + 6) === 121) return $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, ":", ":" + $1b3c173596e236b2$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($1b3c173596e236b2$export$a9db5e087081082d(n, $1b3c173596e236b2$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $1b3c173596e236b2$export$39dfd62a25e0fe93 + ($1b3c173596e236b2$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $1b3c173596e236b2$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $1b3c173596e236b2$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, ":", ":" + $1b3c173596e236b2$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $1b3c173596e236b2$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function $1b3c173596e236b2$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $1b3c173596e236b2$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $1b3c173596e236b2$export$a763edbf796b780a:
        case $1b3c173596e236b2$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $1b3c173596e236b2$export$a29989082612d0d9:
            return "";
        case $1b3c173596e236b2$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $1b3c173596e236b2$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $1b3c173596e236b2$export$aa3a2e812ca8570d:
            if (!$1b3c173596e236b2$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $1b3c173596e236b2$export$36776f635604f274(a = $1b3c173596e236b2$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $1b3c173596e236b2$export$5a7767152ae0305f(e) {
    var r = $1b3c173596e236b2$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $1b3c173596e236b2$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $1b3c173596e236b2$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $1b3c173596e236b2$export$527d108ccf083c2b:
                n.return = $1b3c173596e236b2$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $1b3c173596e236b2$export$b44a8529a35fcb60:
                return $1b3c173596e236b2$export$dfdc1655ccc5b9cb([
                    $1b3c173596e236b2$export$784d13d8ee351f07(n, {
                        value: $1b3c173596e236b2$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $1b3c173596e236b2$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $1b3c173596e236b2$export$aa3a2e812ca8570d:
                if (n.length) return $1b3c173596e236b2$export$1be1fc439b849fdf(u = n.props, function(c) {
                    switch($1b3c173596e236b2$export$4659b591c19bdf3d(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $1b3c173596e236b2$export$590e8b2c435046d9($1b3c173596e236b2$export$784d13d8ee351f07(n, {
                                props: [
                                    $1b3c173596e236b2$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $1b3c173596e236b2$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $1b3c173596e236b2$export$590e8b2c435046d9($1b3c173596e236b2$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $1b3c173596e236b2$export$e6e34fd1f2686227(n, {
                                props: $1b3c173596e236b2$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $1b3c173596e236b2$export$590e8b2c435046d9($1b3c173596e236b2$export$784d13d8ee351f07(n, {
                                props: [
                                    $1b3c173596e236b2$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $1b3c173596e236b2$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $1b3c173596e236b2$export$590e8b2c435046d9($1b3c173596e236b2$export$784d13d8ee351f07(n, {
                                props: [
                                    $1b3c173596e236b2$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $1b3c173596e236b2$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $1b3c173596e236b2$export$590e8b2c435046d9($1b3c173596e236b2$export$784d13d8ee351f07(n, {
                                props: [
                                    $1b3c173596e236b2$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $1b3c173596e236b2$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $1b3c173596e236b2$export$590e8b2c435046d9($1b3c173596e236b2$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $1b3c173596e236b2$export$e6e34fd1f2686227(n, {
                                props: $1b3c173596e236b2$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $1b3c173596e236b2$export$76a88f7de6507443(e) {
    switch(e.type){
        case $1b3c173596e236b2$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $1b3c173596e236b2$export$1be1fc439b849fdf($1b3c173596e236b2$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($1b3c173596e236b2$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $1b3c173596e236b2$export$2f35ab04d2335697(r, 1, $1b3c173596e236b2$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $1b3c173596e236b2$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $1b3c173596e236b2$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $1b3c173596e236b2$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $542fd23dbf943277$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};


var $8368f5385e66edf2$exports = {};
// shim for using process in browser
var $8368f5385e66edf2$var$process = $8368f5385e66edf2$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $8368f5385e66edf2$var$cachedSetTimeout;
var $8368f5385e66edf2$var$cachedClearTimeout;
function $8368f5385e66edf2$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $8368f5385e66edf2$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $8368f5385e66edf2$var$cachedSetTimeout = setTimeout;
        else $8368f5385e66edf2$var$cachedSetTimeout = $8368f5385e66edf2$var$defaultSetTimout;
    } catch (e) {
        $8368f5385e66edf2$var$cachedSetTimeout = $8368f5385e66edf2$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $8368f5385e66edf2$var$cachedClearTimeout = clearTimeout;
        else $8368f5385e66edf2$var$cachedClearTimeout = $8368f5385e66edf2$var$defaultClearTimeout;
    } catch (e) {
        $8368f5385e66edf2$var$cachedClearTimeout = $8368f5385e66edf2$var$defaultClearTimeout;
    }
})();
function $8368f5385e66edf2$var$runTimeout(fun) {
    if ($8368f5385e66edf2$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($8368f5385e66edf2$var$cachedSetTimeout === $8368f5385e66edf2$var$defaultSetTimout || !$8368f5385e66edf2$var$cachedSetTimeout) && setTimeout) {
        $8368f5385e66edf2$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $8368f5385e66edf2$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $8368f5385e66edf2$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $8368f5385e66edf2$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $8368f5385e66edf2$var$runClearTimeout(marker) {
    if ($8368f5385e66edf2$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($8368f5385e66edf2$var$cachedClearTimeout === $8368f5385e66edf2$var$defaultClearTimeout || !$8368f5385e66edf2$var$cachedClearTimeout) && clearTimeout) {
        $8368f5385e66edf2$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $8368f5385e66edf2$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $8368f5385e66edf2$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $8368f5385e66edf2$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $8368f5385e66edf2$var$queue = [];
var $8368f5385e66edf2$var$draining = false;
var $8368f5385e66edf2$var$currentQueue;
var $8368f5385e66edf2$var$queueIndex = -1;
function $8368f5385e66edf2$var$cleanUpNextTick() {
    if (!$8368f5385e66edf2$var$draining || !$8368f5385e66edf2$var$currentQueue) return;
    $8368f5385e66edf2$var$draining = false;
    if ($8368f5385e66edf2$var$currentQueue.length) $8368f5385e66edf2$var$queue = $8368f5385e66edf2$var$currentQueue.concat($8368f5385e66edf2$var$queue);
    else $8368f5385e66edf2$var$queueIndex = -1;
    if ($8368f5385e66edf2$var$queue.length) $8368f5385e66edf2$var$drainQueue();
}
function $8368f5385e66edf2$var$drainQueue() {
    if ($8368f5385e66edf2$var$draining) return;
    var timeout = $8368f5385e66edf2$var$runTimeout($8368f5385e66edf2$var$cleanUpNextTick);
    $8368f5385e66edf2$var$draining = true;
    var len = $8368f5385e66edf2$var$queue.length;
    while(len){
        $8368f5385e66edf2$var$currentQueue = $8368f5385e66edf2$var$queue;
        $8368f5385e66edf2$var$queue = [];
        while(++$8368f5385e66edf2$var$queueIndex < len)if ($8368f5385e66edf2$var$currentQueue) $8368f5385e66edf2$var$currentQueue[$8368f5385e66edf2$var$queueIndex].run();
        $8368f5385e66edf2$var$queueIndex = -1;
        len = $8368f5385e66edf2$var$queue.length;
    }
    $8368f5385e66edf2$var$currentQueue = null;
    $8368f5385e66edf2$var$draining = false;
    $8368f5385e66edf2$var$runClearTimeout(timeout);
}
$8368f5385e66edf2$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $8368f5385e66edf2$var$queue.push(new $8368f5385e66edf2$var$Item(fun, args));
    if ($8368f5385e66edf2$var$queue.length === 1 && !$8368f5385e66edf2$var$draining) $8368f5385e66edf2$var$runTimeout($8368f5385e66edf2$var$drainQueue);
};
// v8 likes predictible objects
function $8368f5385e66edf2$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$8368f5385e66edf2$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$8368f5385e66edf2$var$process.title = 'browser';
$8368f5385e66edf2$var$process.browser = true;
$8368f5385e66edf2$var$process.env = {};
$8368f5385e66edf2$var$process.argv = [];
$8368f5385e66edf2$var$process.version = ''; // empty string to avoid regexp issues
$8368f5385e66edf2$var$process.versions = {};
function $8368f5385e66edf2$var$noop() {}
$8368f5385e66edf2$var$process.on = $8368f5385e66edf2$var$noop;
$8368f5385e66edf2$var$process.addListener = $8368f5385e66edf2$var$noop;
$8368f5385e66edf2$var$process.once = $8368f5385e66edf2$var$noop;
$8368f5385e66edf2$var$process.off = $8368f5385e66edf2$var$noop;
$8368f5385e66edf2$var$process.removeListener = $8368f5385e66edf2$var$noop;
$8368f5385e66edf2$var$process.removeAllListeners = $8368f5385e66edf2$var$noop;
$8368f5385e66edf2$var$process.emit = $8368f5385e66edf2$var$noop;
$8368f5385e66edf2$var$process.prependListener = $8368f5385e66edf2$var$noop;
$8368f5385e66edf2$var$process.prependOnceListener = $8368f5385e66edf2$var$noop;
$8368f5385e66edf2$var$process.listeners = function(name) {
    return [];
};
$8368f5385e66edf2$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$8368f5385e66edf2$var$process.cwd = function() {
    return '/';
};
$8368f5385e66edf2$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$8368f5385e66edf2$var$process.umask = function() {
    return 0;
};


var $4a95c28624d97f2e$var$f = ("undefined" != typeof $8368f5385e66edf2$exports && void 0 !== $8368f5385e66edf2$exports.env && undefined, "data-styled"), $4a95c28624d97f2e$var$m = "active", $4a95c28624d97f2e$var$y = "data-styled-version", $4a95c28624d97f2e$export$83d89fbfd8236492 = "6.1.13", $4a95c28624d97f2e$var$g = "/*!sc*/\n", $4a95c28624d97f2e$var$S = "undefined" != typeof window && "HTMLElement" in window, $4a95c28624d97f2e$var$w = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : ("undefined" != typeof $8368f5385e66edf2$exports && $8368f5385e66edf2$exports.env, "undefined" != typeof $8368f5385e66edf2$exports && $8368f5385e66edf2$exports.env, false)), $4a95c28624d97f2e$var$b = {}, $4a95c28624d97f2e$var$E = /invalid hook call/i, $4a95c28624d97f2e$var$N = new Set, $4a95c28624d97f2e$var$P = function(t, n) {
    var o, s, i, a, e;
}, $4a95c28624d97f2e$var$_ = Object.freeze([]), $4a95c28624d97f2e$var$C = Object.freeze({});
function $4a95c28624d97f2e$var$I(e, t, n) {
    return void 0 === n && (n = $4a95c28624d97f2e$var$C), e.theme !== n.theme && e.theme || t || n.theme;
}
var $4a95c28624d97f2e$var$A = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $4a95c28624d97f2e$var$O = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $4a95c28624d97f2e$var$D = /(^-|-$)/g;
function $4a95c28624d97f2e$var$R(e) {
    return e.replace($4a95c28624d97f2e$var$O, "-").replace($4a95c28624d97f2e$var$D, "");
}
var $4a95c28624d97f2e$var$T = /(a)(d)/gi, $4a95c28624d97f2e$var$k = 52, $4a95c28624d97f2e$var$j = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $4a95c28624d97f2e$var$x(e) {
    var t, n = "";
    for(t = Math.abs(e); t > $4a95c28624d97f2e$var$k; t = t / $4a95c28624d97f2e$var$k | 0)n = $4a95c28624d97f2e$var$j(t % $4a95c28624d97f2e$var$k) + n;
    return ($4a95c28624d97f2e$var$j(t % $4a95c28624d97f2e$var$k) + n).replace($4a95c28624d97f2e$var$T, "$1-$2");
}
var $4a95c28624d97f2e$var$V, $4a95c28624d97f2e$var$F = 5381, $4a95c28624d97f2e$var$M = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $4a95c28624d97f2e$var$z = function(e) {
    return $4a95c28624d97f2e$var$M($4a95c28624d97f2e$var$F, e);
};
function $4a95c28624d97f2e$var$$(e) {
    return $4a95c28624d97f2e$var$x($4a95c28624d97f2e$var$z(e) >>> 0);
}
function $4a95c28624d97f2e$var$B(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $4a95c28624d97f2e$var$L(e) {
    return "string" == typeof e && true;
}
var $4a95c28624d97f2e$var$G = "function" == typeof Symbol && Symbol.for, $4a95c28624d97f2e$var$Y = $4a95c28624d97f2e$var$G ? Symbol.for("react.memo") : 60115, $4a95c28624d97f2e$var$W = $4a95c28624d97f2e$var$G ? Symbol.for("react.forward_ref") : 60112, $4a95c28624d97f2e$var$q = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $4a95c28624d97f2e$var$H = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $4a95c28624d97f2e$var$U = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $4a95c28624d97f2e$var$J = (($4a95c28624d97f2e$var$V = {})[$4a95c28624d97f2e$var$W] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $4a95c28624d97f2e$var$V[$4a95c28624d97f2e$var$Y] = $4a95c28624d97f2e$var$U, $4a95c28624d97f2e$var$V);
function $4a95c28624d97f2e$var$X(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $4a95c28624d97f2e$var$Y ? $4a95c28624d97f2e$var$U : "$$typeof" in e ? $4a95c28624d97f2e$var$J[e.$$typeof] : $4a95c28624d97f2e$var$q;
}
var $4a95c28624d97f2e$var$Z = Object.defineProperty, $4a95c28624d97f2e$var$K = Object.getOwnPropertyNames, $4a95c28624d97f2e$var$Q = Object.getOwnPropertySymbols, $4a95c28624d97f2e$var$ee = Object.getOwnPropertyDescriptor, $4a95c28624d97f2e$var$te = Object.getPrototypeOf, $4a95c28624d97f2e$var$ne = Object.prototype;
function $4a95c28624d97f2e$var$oe(e, t, n) {
    if ("string" != typeof t) {
        if ($4a95c28624d97f2e$var$ne) {
            var o = $4a95c28624d97f2e$var$te(t);
            o && o !== $4a95c28624d97f2e$var$ne && $4a95c28624d97f2e$var$oe(e, o, n);
        }
        var r = $4a95c28624d97f2e$var$K(t);
        $4a95c28624d97f2e$var$Q && (r = r.concat($4a95c28624d97f2e$var$Q(t)));
        for(var s = $4a95c28624d97f2e$var$X(e), i = $4a95c28624d97f2e$var$X(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $4a95c28624d97f2e$var$H || n && n[c] || i && c in i || s && c in s)) {
                var l = $4a95c28624d97f2e$var$ee(t, c);
                try {
                    $4a95c28624d97f2e$var$Z(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $4a95c28624d97f2e$var$re(e) {
    return "function" == typeof e;
}
function $4a95c28624d97f2e$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $4a95c28624d97f2e$var$ie(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $4a95c28624d97f2e$var$ae(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], o = 1; o < e.length; o++)n += t ? t + e[o] : e[o];
    return n;
}
function $4a95c28624d97f2e$var$ce(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $4a95c28624d97f2e$var$le(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$4a95c28624d97f2e$var$ce(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = $4a95c28624d97f2e$var$le(e[o], t[o]);
    else if ($4a95c28624d97f2e$var$ce(t)) for(var o in t)e[o] = $4a95c28624d97f2e$var$le(e[o], t[o]);
    return e;
}
function $4a95c28624d97f2e$var$ue(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $4a95c28624d97f2e$var$pe = {};
function $4a95c28624d97f2e$var$de() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $4a95c28624d97f2e$var$he(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $4a95c28624d97f2e$var$fe = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw $4a95c28624d97f2e$var$he(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat($4a95c28624d97f2e$var$g);
        return t;
    }, e;
}(), $4a95c28624d97f2e$var$me = 1073741824, $4a95c28624d97f2e$var$ye = new Map, $4a95c28624d97f2e$var$ve = new Map, $4a95c28624d97f2e$var$ge = 1, $4a95c28624d97f2e$var$Se = function(e) {
    if ($4a95c28624d97f2e$var$ye.has(e)) return $4a95c28624d97f2e$var$ye.get(e);
    for(; $4a95c28624d97f2e$var$ve.has($4a95c28624d97f2e$var$ge);)$4a95c28624d97f2e$var$ge++;
    var t = $4a95c28624d97f2e$var$ge++;
    return $4a95c28624d97f2e$var$ye.set(e, t), $4a95c28624d97f2e$var$ve.set(t, e), t;
}, $4a95c28624d97f2e$var$we = function(e, t) {
    $4a95c28624d97f2e$var$ge = t + 1, $4a95c28624d97f2e$var$ye.set(e, t), $4a95c28624d97f2e$var$ve.set(t, e);
}, $4a95c28624d97f2e$var$be = "style[".concat($4a95c28624d97f2e$var$f, "][").concat($4a95c28624d97f2e$var$y, '="').concat($4a95c28624d97f2e$export$83d89fbfd8236492, '"]'), $4a95c28624d97f2e$var$Ee = new RegExp("^".concat($4a95c28624d97f2e$var$f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $4a95c28624d97f2e$var$Ne = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, $4a95c28624d97f2e$var$Pe = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($4a95c28624d97f2e$var$g), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match($4a95c28624d97f2e$var$Ee);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($4a95c28624d97f2e$var$we(u, l), $4a95c28624d97f2e$var$Ne(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
}, $4a95c28624d97f2e$var$_e = function(e) {
    for(var t = document.querySelectorAll($4a95c28624d97f2e$var$be), n = 0, o = t.length; n < o; n++){
        var r = t[n];
        r && r.getAttribute($4a95c28624d97f2e$var$f) !== $4a95c28624d97f2e$var$m && ($4a95c28624d97f2e$var$Pe(e, r), r.parentNode && r.parentNode.removeChild(r));
    }
};
function $4a95c28624d97f2e$var$Ce() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $4a95c28624d97f2e$var$Ie = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($4a95c28624d97f2e$var$f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute($4a95c28624d97f2e$var$f, $4a95c28624d97f2e$var$m), o.setAttribute($4a95c28624d97f2e$var$y, $4a95c28624d97f2e$export$83d89fbfd8236492);
    var i = $4a95c28624d97f2e$var$Ce();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, $4a95c28624d97f2e$var$Ae = function() {
    function e(e) {
        this.element = $4a95c28624d97f2e$var$Ie(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, o = t.length; n < o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $4a95c28624d97f2e$var$he(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $4a95c28624d97f2e$var$Oe = function() {
    function e(e) {
        this.element = $4a95c28624d97f2e$var$Ie(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $4a95c28624d97f2e$var$De = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $4a95c28624d97f2e$var$Re = $4a95c28624d97f2e$var$S, $4a95c28624d97f2e$var$Te = {
    isServer: !$4a95c28624d97f2e$var$S,
    useCSSOMInjection: !$4a95c28624d97f2e$var$w
}, $4a95c28624d97f2e$var$ke = function() {
    function e(e, n, o) {
        void 0 === e && (e = $4a95c28624d97f2e$var$C), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $10e83365bcd320a7$export$18ce0697a983be9b)((0, $10e83365bcd320a7$export$18ce0697a983be9b)({}, $4a95c28624d97f2e$var$Te), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $4a95c28624d97f2e$var$S && $4a95c28624d97f2e$var$Re && ($4a95c28624d97f2e$var$Re = !1, $4a95c28624d97f2e$var$_e(this)), $4a95c28624d97f2e$var$ue(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return $4a95c28624d97f2e$var$ve.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = t.getGroup(n);
                    if (void 0 === s || !s.size || 0 === i.length) return "continue";
                    var a = "".concat($4a95c28624d97f2e$var$f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat($4a95c28624d97f2e$var$g);
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $4a95c28624d97f2e$var$Se(e);
    }, e.prototype.rehydrate = function() {
        !this.server && $4a95c28624d97f2e$var$S && $4a95c28624d97f2e$var$_e(this);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, $10e83365bcd320a7$export$18ce0697a983be9b)((0, $10e83365bcd320a7$export$18ce0697a983be9b)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $4a95c28624d97f2e$var$De(n) : t ? new $4a95c28624d97f2e$var$Ae(n) : new $4a95c28624d97f2e$var$Oe(n);
        }(this.options), new $4a95c28624d97f2e$var$fe(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($4a95c28624d97f2e$var$Se(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($4a95c28624d97f2e$var$Se(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($4a95c28624d97f2e$var$Se(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $4a95c28624d97f2e$var$je = /&/g, $4a95c28624d97f2e$var$xe = /^\s*\/\/.*$/gm;
function $4a95c28624d97f2e$var$Ve(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $4a95c28624d97f2e$var$Ve(e.children, t)), e;
    });
}
function $4a95c28624d97f2e$var$Fe(e) {
    var t, n, o, r = void 0 === e ? $4a95c28624d97f2e$var$C : e, s = r.options, i = void 0 === s ? $4a95c28624d97f2e$var$C : s, a = r.plugins, c = void 0 === a ? $4a95c28624d97f2e$var$_ : a, l = function(e, o, r) {
        return r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $1b3c173596e236b2$export$aa3a2e812ca8570d && e.value.includes("&") && (e.props[0] = e.props[0].replace($4a95c28624d97f2e$var$je, n).replace(o, l));
    }), i.prefix && u.push($1b3c173596e236b2$export$e08c7d021b829b7a), u.push($1b3c173596e236b2$export$fac44ee5b035f737);
    var p = function(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($4a95c28624d97f2e$var$xe, ""), l = $1b3c173596e236b2$export$ef7acd7185315e22(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = $4a95c28624d97f2e$var$Ve(l, i.namespace));
        var p = [];
        return $1b3c173596e236b2$export$dfdc1655ccc5b9cb(l, $1b3c173596e236b2$export$5a7767152ae0305f(u.concat($1b3c173596e236b2$export$38bcb760f1d4871c(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $4a95c28624d97f2e$var$he(15), $4a95c28624d97f2e$var$M(e, t.name);
    }, $4a95c28624d97f2e$var$F).toString() : "", p;
}
var $4a95c28624d97f2e$var$Me = new $4a95c28624d97f2e$var$ke, $4a95c28624d97f2e$var$ze = $4a95c28624d97f2e$var$Fe(), $4a95c28624d97f2e$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $4a95c28624d97f2e$var$Me,
    stylis: $4a95c28624d97f2e$var$ze
}), $4a95c28624d97f2e$export$91317688fc694efa = $4a95c28624d97f2e$export$8c190ef828af4c86.Consumer, $4a95c28624d97f2e$var$Le = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).createContext(void 0);
function $4a95c28624d97f2e$var$Ge() {
    return (0, $aEMJz.useContext)($4a95c28624d97f2e$export$8c190ef828af4c86);
}
function $4a95c28624d97f2e$export$a473771da2f0ff7c(e) {
    var t = (0, $aEMJz.useState)(e.stylisPlugins), n = t[0], r = t[1], c = $4a95c28624d97f2e$var$Ge().styleSheet, l = (0, $aEMJz.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, $aEMJz.useMemo)(function() {
        return $4a95c28624d97f2e$var$Fe({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    (0, $aEMJz.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($60a79fe7c91658de$exports)))(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]);
    var d = (0, $aEMJz.useMemo)(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        };
    }, [
        e.shouldForwardProp,
        l,
        u
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).createElement($4a95c28624d97f2e$export$8c190ef828af4c86.Provider, {
        value: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).createElement($4a95c28624d97f2e$var$Le.Provider, {
        value: u
    }, e.children));
}
var $4a95c28624d97f2e$var$We = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $4a95c28624d97f2e$var$ze);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $4a95c28624d97f2e$var$ue(this, function() {
            throw $4a95c28624d97f2e$var$he(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $4a95c28624d97f2e$var$ze), this.name + e.hash;
    }, e;
}(), $4a95c28624d97f2e$var$qe = function(e) {
    return e >= "A" && e <= "Z";
};
function $4a95c28624d97f2e$var$He(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        $4a95c28624d97f2e$var$qe(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $4a95c28624d97f2e$var$Ue = function(e) {
    return null == e || !1 === e || "" === e;
}, $4a95c28624d97f2e$var$Je = function(t) {
    var n, o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$4a95c28624d97f2e$var$Ue(i) && (Array.isArray(i) && i.isCss || $4a95c28624d97f2e$var$re(i) ? r.push("".concat($4a95c28624d97f2e$var$He(s), ":"), i, ";") : $4a95c28624d97f2e$var$ce(i) ? r.push.apply(r, (0, $10e83365bcd320a7$export$1216008129fb82ed)((0, $10e83365bcd320a7$export$1216008129fb82ed)([
            "".concat(s, " {")
        ], $4a95c28624d97f2e$var$Je(i), !1), [
            "}"
        ], !1)) : r.push("".concat($4a95c28624d97f2e$var$He(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in (0, $542fd23dbf943277$export$2e2bcd8739ae039) || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
};
function $4a95c28624d97f2e$var$Xe(e, t, n, o) {
    if ($4a95c28624d97f2e$var$Ue(e)) return [];
    if ($4a95c28624d97f2e$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($4a95c28624d97f2e$var$re(e)) {
        if (!$4a95c28624d97f2e$var$re(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $4a95c28624d97f2e$var$Xe(r, t, n, o);
    }
    var s;
    return e instanceof $4a95c28624d97f2e$var$We ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : $4a95c28624d97f2e$var$ce(e) ? $4a95c28624d97f2e$var$Je(e) : Array.isArray(e) ? Array.prototype.concat.apply($4a95c28624d97f2e$var$_, e.map(function(e) {
        return $4a95c28624d97f2e$var$Xe(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function $4a95c28624d97f2e$var$Ze(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($4a95c28624d97f2e$var$re(n) && !$4a95c28624d97f2e$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $4a95c28624d97f2e$var$Ke = $4a95c28624d97f2e$var$z($4a95c28624d97f2e$export$83d89fbfd8236492), $4a95c28624d97f2e$var$Qe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $4a95c28624d97f2e$var$Ze(e), this.componentId = t, this.baseHash = $4a95c28624d97f2e$var$M($4a95c28624d97f2e$var$Ke, t), this.baseStyle = n, $4a95c28624d97f2e$var$ke.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = $4a95c28624d97f2e$var$ie(o, this.staticRulesId);
            else {
                var r = $4a95c28624d97f2e$var$ae($4a95c28624d97f2e$var$Xe(this.rules, e, t, n)), s = $4a95c28624d97f2e$var$x($4a95c28624d97f2e$var$M(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = $4a95c28624d97f2e$var$ie(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $4a95c28624d97f2e$var$M(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $4a95c28624d97f2e$var$ae($4a95c28624d97f2e$var$Xe(u, e, t, n));
                    a = $4a95c28624d97f2e$var$M(a, p + l), c += p;
                }
            }
            if (c) {
                var d = $4a95c28624d97f2e$var$x(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = $4a95c28624d97f2e$var$ie(o, d);
            }
        }
        return o;
    }, e;
}(), $4a95c28624d97f2e$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).createContext(void 0), $4a95c28624d97f2e$export$b631efc24e9d5e2f = $4a95c28624d97f2e$export$2c657da244d00bd6.Consumer;
function $4a95c28624d97f2e$export$93d4e7f90805808f() {
    var e = (0, $aEMJz.useContext)($4a95c28624d97f2e$export$2c657da244d00bd6);
    if (!e) throw $4a95c28624d97f2e$var$he(18);
    return e;
}
function $4a95c28624d97f2e$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useContext($4a95c28624d97f2e$export$2c657da244d00bd6), r = (0, $aEMJz.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $4a95c28624d97f2e$var$he(14);
            if ($4a95c28624d97f2e$var$re(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $4a95c28624d97f2e$var$he(8);
            return n ? (0, $10e83365bcd320a7$export$18ce0697a983be9b)((0, $10e83365bcd320a7$export$18ce0697a983be9b)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).createElement($4a95c28624d97f2e$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $4a95c28624d97f2e$var$rt = {}, $4a95c28624d97f2e$var$st = new Set;
function $4a95c28624d97f2e$var$it(e, r, s) {
    var i = $4a95c28624d97f2e$export$7ba318d8d2f06c76(e), a = e, c = !$4a95c28624d97f2e$var$L(e), p = r.attrs, d = void 0 === p ? $4a95c28624d97f2e$var$_ : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $4a95c28624d97f2e$var$R(e);
        $4a95c28624d97f2e$var$rt[n] = ($4a95c28624d97f2e$var$rt[n] || 0) + 1;
        var o = "".concat(n, "-").concat($4a95c28624d97f2e$var$$($4a95c28624d97f2e$export$83d89fbfd8236492 + n + $4a95c28624d97f2e$var$rt[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return $4a95c28624d97f2e$var$L(e) ? "styled.".concat(e) : "Styled(".concat($4a95c28624d97f2e$var$B(e), ")");
    }(e) : m, g = r.displayName && r.componentId ? "".concat($4a95c28624d97f2e$var$R(r.displayName), "-").concat(r.componentId) : r.componentId || f, S = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, w = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var b = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var E = r.shouldForwardProp;
            w = function(e, t) {
                return b(e, t) && E(e, t);
            };
        } else w = b;
    }
    var N = new $4a95c28624d97f2e$var$Qe(s, g, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useContext($4a95c28624d97f2e$export$2c657da244d00bd6), m = $4a95c28624d97f2e$var$Ge(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = $4a95c28624d97f2e$var$I(r, f, c) || $4a95c28624d97f2e$var$C, g = function(e, n, o) {
                for(var r, s = (0, $10e83365bcd320a7$export$18ce0697a983be9b)((0, $10e83365bcd320a7$export$18ce0697a983be9b)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $4a95c28624d97f2e$var$re(r = e[i]) ? r(s) : r;
                    for(var c in a)s[c] = "className" === c ? $4a95c28624d97f2e$var$ie(s[c], a[c]) : "style" === c ? (0, $10e83365bcd320a7$export$18ce0697a983be9b)((0, $10e83365bcd320a7$export$18ce0697a983be9b)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = $4a95c28624d97f2e$var$ie(s.className, n.className)), s;
            }(i, r, v), S = g.as || h, w = {};
            for(var b in g)void 0 === g[b] || "$" === b[0] || "as" === b || "theme" === b && g.theme === v || ("forwardedAs" === b ? w.as = g.forwardedAs : y && !y(b, S) || (w[b] = g[b], y));
            var E = function(e, t) {
                var n = $4a95c28624d97f2e$var$Ge(), o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return o;
            }(a, g);
            var N = $4a95c28624d97f2e$var$ie(p, d);
            return E && (N += " " + E), g.className && (N += " " + g.className), w[$4a95c28624d97f2e$var$L(S) && !$4a95c28624d97f2e$var$A.has(S) ? "class" : "className"] = N, w.ref = s, (0, $aEMJz.createElement)(S, w);
        }(D, e, r);
    }
    O.displayName = y;
    var D = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).forwardRef(O);
    return D.attrs = S, D.componentStyle = N, D.displayName = y, D.shouldForwardProp = w, D.foldedComponentIds = i ? $4a95c28624d97f2e$var$ie(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = g, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)$4a95c28624d97f2e$var$le(e, r[o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $4a95c28624d97f2e$var$ue(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && $4a95c28624d97f2e$var$oe(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function $4a95c28624d97f2e$var$at(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var $4a95c28624d97f2e$var$ct = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $4a95c28624d97f2e$export$dbf350e5966cf602(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if ($4a95c28624d97f2e$var$re(t) || $4a95c28624d97f2e$var$ce(t)) return $4a95c28624d97f2e$var$ct($4a95c28624d97f2e$var$Xe($4a95c28624d97f2e$var$at($4a95c28624d97f2e$var$_, (0, $10e83365bcd320a7$export$1216008129fb82ed)([
        t
    ], n, !0))));
    var r = t;
    return 0 === n.length && 1 === r.length && "string" == typeof r[0] ? $4a95c28624d97f2e$var$Xe(r) : $4a95c28624d97f2e$var$ct($4a95c28624d97f2e$var$Xe($4a95c28624d97f2e$var$at(r, n)));
}
function $4a95c28624d97f2e$var$ut(n, o, r) {
    if (void 0 === r && (r = $4a95c28624d97f2e$var$C), !o) throw $4a95c28624d97f2e$var$he(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $4a95c28624d97f2e$export$dbf350e5966cf602.apply(void 0, (0, $10e83365bcd320a7$export$1216008129fb82ed)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $4a95c28624d97f2e$var$ut(n, o, (0, $10e83365bcd320a7$export$18ce0697a983be9b)((0, $10e83365bcd320a7$export$18ce0697a983be9b)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $4a95c28624d97f2e$var$ut(n, o, (0, $10e83365bcd320a7$export$18ce0697a983be9b)((0, $10e83365bcd320a7$export$18ce0697a983be9b)({}, r), e));
    }, s;
}
var $4a95c28624d97f2e$var$pt = function(e) {
    return $4a95c28624d97f2e$var$ut($4a95c28624d97f2e$var$it, e);
}, $4a95c28624d97f2e$export$2e2bcd8739ae039 = $4a95c28624d97f2e$var$pt;
$4a95c28624d97f2e$var$A.forEach(function(e) {
    $4a95c28624d97f2e$export$2e2bcd8739ae039[e] = $4a95c28624d97f2e$var$pt(e);
});
var $4a95c28624d97f2e$var$ht = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $4a95c28624d97f2e$var$Ze(e), $4a95c28624d97f2e$var$ke.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($4a95c28624d97f2e$var$ae($4a95c28624d97f2e$var$Xe(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $4a95c28624d97f2e$var$ke.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function $4a95c28624d97f2e$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $4a95c28624d97f2e$export$dbf350e5966cf602.apply(void 0, (0, $10e83365bcd320a7$export$1216008129fb82ed)([
        n
    ], r, !1)), a = "sc-global-".concat($4a95c28624d97f2e$var$$(JSON.stringify(i))), c = new $4a95c28624d97f2e$var$ht(i, a);
    var l = function(e) {
        var t = $4a95c28624d97f2e$var$Ge(), n = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useContext($4a95c28624d97f2e$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $4a95c28624d97f2e$var$b, o, s);
        else {
            var i = (0, $10e83365bcd320a7$export$18ce0697a983be9b)((0, $10e83365bcd320a7$export$18ce0697a983be9b)({}, n), {
                theme: $4a95c28624d97f2e$var$I(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).memo(l);
}
function $4a95c28624d97f2e$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = $4a95c28624d97f2e$var$ae($4a95c28624d97f2e$export$dbf350e5966cf602.apply(void 0, (0, $10e83365bcd320a7$export$1216008129fb82ed)([
        t
    ], n, !1))), s = $4a95c28624d97f2e$var$$(r);
    return new $4a95c28624d97f2e$var$We(s, r);
}
function $4a95c28624d97f2e$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).forwardRef(function(n, r) {
        var s = $4a95c28624d97f2e$var$I(n, (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useContext($4a95c28624d97f2e$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).createElement(e, (0, $10e83365bcd320a7$export$18ce0697a983be9b)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return n.displayName = "WithTheme(".concat($4a95c28624d97f2e$var$B(e), ")"), $4a95c28624d97f2e$var$oe(n, e);
}
var $4a95c28624d97f2e$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $4a95c28624d97f2e$var$Ce(), o = $4a95c28624d97f2e$var$ae([
                n && 'nonce="'.concat(n, '"'),
                "".concat($4a95c28624d97f2e$var$f, '="true"'),
                "".concat($4a95c28624d97f2e$var$y, '="').concat($4a95c28624d97f2e$export$83d89fbfd8236492, '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $4a95c28624d97f2e$var$he(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw $4a95c28624d97f2e$var$he(2);
            var r = e.instance.toString();
            if (!r) return [];
            var s = ((n = {})[$4a95c28624d97f2e$var$f] = "", n[$4a95c28624d97f2e$var$y] = $4a95c28624d97f2e$export$83d89fbfd8236492, n.dangerouslySetInnerHTML = {
                __html: r
            }, n), i = $4a95c28624d97f2e$var$Ce();
            return i && (s.nonce = i), [
                (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).createElement("style", (0, $10e83365bcd320a7$export$18ce0697a983be9b)({}, s, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $4a95c28624d97f2e$var$ke({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $4a95c28624d97f2e$var$he(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).createElement($4a95c28624d97f2e$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $4a95c28624d97f2e$var$he(3);
    }, e;
}(), $4a95c28624d97f2e$export$5c87cfe6c475f500 = {
    StyleSheet: $4a95c28624d97f2e$var$ke,
    mainSheet: $4a95c28624d97f2e$var$Me
};
var $4a95c28624d97f2e$var$St = "__sc-".concat($4a95c28624d97f2e$var$f, "__");



parcelRequire("aEMJz");

const $576749860f83a2d7$export$9a6bb2acef5e644a = 15;
const $576749860f83a2d7$export$cba6217a006ba569 = 25;
const $576749860f83a2d7$export$83e664a9d119a376 = 600;
const $576749860f83a2d7$export$3d5e80817e1f8611 = `(max-width: ${$576749860f83a2d7$export$83e664a9d119a376}px)`;
const $576749860f83a2d7$export$57b55975112d979e = `(max-width: 400px)`;



parcelRequire("aEMJz");

function $8c0ce35eac81a929$var$WrappedIcon({ style: style, svg: svg }) {
    return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("div", {
        style: style,
        children: svg
    });
}
function $8c0ce35eac81a929$export$9b80ee7d1e129684({ style: style, fill: fill = "none" }) {
    const icon = /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: fill,
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("path", {
            d: "m18 15-6-6-6 6"
        })
    });
    return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($8c0ce35eac81a929$var$WrappedIcon, {
        style: style,
        svg: icon
    });
}
function $8c0ce35eac81a929$export$4e3778eb35f54199({ style: style, fill: fill = "none" }) {
    const icon = /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: fill,
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("path", {
            d: "m6 9 6 6 6-6"
        })
    });
    return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($8c0ce35eac81a929$var$WrappedIcon, {
        style: style,
        svg: icon
    });
}
function $8c0ce35eac81a929$export$ea3b71af1761ff40({ style: style, fill: fill = "none" }) {
    const icon = /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: fill,
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("rect", {
                width: "8",
                height: "4",
                x: "8",
                y: "2",
                rx: "1",
                ry: "1"
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("path", {
                d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("path", {
                d: "M16 4h2a2 2 0 0 1 2 2v4"
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("path", {
                d: "M21 14H11"
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("path", {
                d: "m15 10-4 4 4 4"
            })
        ]
    });
    return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($8c0ce35eac81a929$var$WrappedIcon, {
        style: style,
        svg: icon
    });
}
function $8c0ce35eac81a929$export$1644ba17714857f1({ style: style, fill: fill = "none" }) {
    const icon = /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: fill,
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("path", {
            d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
        })
    });
    return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($8c0ce35eac81a929$var$WrappedIcon, {
        style: style,
        svg: icon
    });
}
function $8c0ce35eac81a929$export$128fdd60f6c96030({ style: style }) {
    const icon = /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("svg", {
        width: "100%",
        height: "100%",
        viewBox: "0 0 600 530",
        fill: "currentColor",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        style: style,
        children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("path", {
            d: "m135.72 44.03c66.496 49.921 138.02 151.14 164.28 205.46 26.262-54.316 97.782-155.54 164.28-205.46 47.98-36.021 125.72-63.892 125.72 24.795 0 17.712-10.155 148.79-16.111 170.07-20.703 73.984-96.144 92.854-163.25 81.433 117.3 19.964 147.14 86.092 82.697 152.22-122.39 125.59-175.91-31.511-189.63-71.766-2.514-7.3797-3.6904-10.832-3.7077-7.8964-0.0174-2.9357-1.1937 0.51669-3.7077 7.8964-13.714 40.255-67.233 197.36-189.63 71.766-64.444-66.128-34.605-132.26 82.697-152.22-67.108 11.421-142.55-7.4491-163.25-81.433-5.9562-21.282-16.111-152.36-16.111-170.07 0-88.687 77.742-60.816 125.72-24.795z"
        })
    });
    return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($8c0ce35eac81a929$var$WrappedIcon, {
        style: style,
        svg: icon
    });
}
const $8c0ce35eac81a929$export$9e389cdad32a5b7a = ({ style: style })=>{
    const icon = /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        viewBox: "0 0 24 23",
        width: "100%",
        height: "100%",
        style: style,
        children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("path", {
            d: "M 24 4.300781 C 23.101563 4.699219 22.199219 5 21.199219 5.101563 C 22.199219 4.5 23 3.5 23.398438 2.398438 C 22.398438 3 21.398438 3.398438 20.300781 3.601563 C 19.300781 2.601563 18 2 16.601563 2 C 13.898438 2 11.699219 4.199219 11.699219 6.898438 C 11.699219 7.300781 11.699219 7.699219 11.800781 8 C 7.699219 7.800781 4.101563 5.898438 1.699219 2.898438 C 1.199219 3.601563 1 4.5 1 5.398438 C 1 7.101563 1.898438 8.601563 3.199219 9.5 C 2.398438 9.398438 1.601563 9.199219 1 8.898438 C 1 8.898438 1 8.898438 1 9 C 1 11.398438 2.699219 13.398438 4.898438 13.800781 C 4.5 13.898438 4.101563 14 3.601563 14 C 3.300781 14 3 14 2.699219 13.898438 C 3.300781 15.898438 5.101563 17.300781 7.300781 17.300781 C 5.601563 18.601563 3.5 19.398438 1.199219 19.398438 C 0.800781 19.398438 0.398438 19.398438 0 19.300781 C 2.199219 20.699219 4.800781 21.5 7.5 21.5 C 16.601563 21.5 21.5 14 21.5 7.5 C 21.5 7.300781 21.5 7.101563 21.5 6.898438 C 22.5 6.199219 23.300781 5.300781 24 4.300781"
        })
    });
    return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($8c0ce35eac81a929$var$WrappedIcon, {
        style: style,
        svg: icon
    });
};
const $8c0ce35eac81a929$export$52f0f02147b12c03 = ({ style: style, fill: fill = "none" })=>{
    const icon = /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "100%",
        width: "100%",
        viewBox: "0 0 24 24",
        fill: fill,
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("polyline", {
                points: "16 18 22 12 16 6"
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("polyline", {
                points: "8 6 2 12 8 18"
            })
        ]
    });
    return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($8c0ce35eac81a929$var$WrappedIcon, {
        style: style,
        svg: icon
    });
};
const $8c0ce35eac81a929$export$1be7516c0280bee8 = ({ style: style, fill: fill = "none" })=>{
    const icon = /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: fill,
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        style: style,
        children: [
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("path", {
                d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("path", {
                d: "M12 17h.01"
            })
        ]
    });
    return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($8c0ce35eac81a929$var$WrappedIcon, {
        style: style,
        svg: icon
    });
};
const $8c0ce35eac81a929$export$78acf4525d8a74c4 = ({ style: style, fill: fill = "none" })=>{
    const icon = /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: fill,
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("path", {
                d: "M18 6 6 18"
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("path", {
                d: "m6 6 12 12"
            })
        ]
    });
    return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($8c0ce35eac81a929$var$WrappedIcon, {
        style: style,
        svg: icon
    });
};
const $8c0ce35eac81a929$export$60f7169f5ee875bc = ({ style: style, fill: fill = "none" })=>{
    const icon = /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("path", {
                d: "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("rect", {
                x: "2",
                y: "9",
                width: "4",
                height: "12"
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)("circle", {
                cx: "4",
                cy: "4",
                r: "2"
            })
        ]
    });
    return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($8c0ce35eac81a929$var$WrappedIcon, {
        style: style,
        svg: icon
    });
};


const $401c39894fc2759b$export$51fe096c4db50bc8 = [
    {
        "type": "OTC",
        "mpid": "AALC",
        "clearingBroker": "0226",
        "brokerName": "THRIVENT INVESTMENT MANAGEMENT, INC.                                  "
    },
    {
        "type": "OTC",
        "mpid": "ABAI",
        "clearingBroker": "0279",
        "brokerName": "ABACUS INVESTMENTS, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "ABBA",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "ABBK",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "ABDA",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "ABDW",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "ABEA",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "ABHE",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "ABIG",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "ABLE",
        "clearingBroker": "0031",
        "brokerName": "NATIXIS SECURITIES AMERICAS LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "ABNA",
        "clearingBroker": "0349",
        "brokerName": "ABN AMRO SECURITIES (USA) LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "ABPR",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "ABRM",
        "clearingBroker": "0534",
        "brokerName": "ABRAHAM & CO., INC.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "ABRP",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "ABST",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "ACAD",
        "clearingBroker": "0443",
        "brokerName": "ACADEMY SECURITIES, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "ACAP",
        "clearingBroker": "0235",
        "brokerName": "ALAMO CAPITAL                                                         "
    },
    {
        "type": "OTC",
        "mpid": "ACCI",
        "clearingBroker": "0226",
        "brokerName": "WORTH FINANCIAL GROUP INC                                             "
    },
    {
        "type": "OTC",
        "mpid": "ACCP",
        "clearingBroker": "0158",
        "brokerName": "AEGIS CAPITAL CORP.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "ACCU",
        "clearingBroker": "0052",
        "brokerName": "ATB CAPITAL MARKETS USA INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "ACII",
        "clearingBroker": "0158",
        "brokerName": "ARCA CAPITAL INVESTMENTS, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "ACLP",
        "clearingBroker": "0235",
        "brokerName": "ALEXANDER CAPITAL, L.P.                                               "
    },
    {
        "type": "OTC",
        "mpid": "ACLV",
        "clearingBroker": "0294",
        "brokerName": "ALEXANDER CAPITAL, L.P.                                               "
    },
    {
        "type": "OTC",
        "mpid": "ACPL",
        "clearingBroker": "0235",
        "brokerName": "AMERICAN CAPITAL PARTNERS                                             "
    },
    {
        "type": "OTC",
        "mpid": "ACPS",
        "clearingBroker": "0534",
        "brokerName": "ACP SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "ACRA",
        "clearingBroker": "0436",
        "brokerName": "ARCHIPELAGO SECURITIES, L.L.C.                                        "
    },
    {
        "type": "OTC",
        "mpid": "ACRN",
        "clearingBroker": "0235",
        "brokerName": "ACORNS SECURITIES, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "ACSS",
        "clearingBroker": "3450",
        "brokerName": "AC SUNSHINE SECURITIES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "ADAM",
        "clearingBroker": "0161",
        "brokerName": "CANACCORD GENUITY INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "ADSB",
        "clearingBroker": "1476",
        "brokerName": "ADELPHI STOCK BROKERS                                                 "
    },
    {
        "type": "OTC",
        "mpid": "ADSO",
        "clearingBroker": "0141",
        "brokerName": "PROSPERA FINANCIAL SERVICES, INC.                                     "
    },
    {
        "type": "OTC",
        "mpid": "AEFA",
        "clearingBroker": "0756",
        "brokerName": "AMERIPRISE FINANCIAL SERVICES, LLC                                    "
    },
    {
        "type": "OTC",
        "mpid": "AETL",
        "clearingBroker": "0158",
        "brokerName": "AET INVESTMENT SERVICES, LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "AEXG",
        "clearingBroker": "0158",
        "brokerName": "ALTERNATIVE EXECUTION GROUP                                           "
    },
    {
        "type": "OTC",
        "mpid": "AFBS",
        "clearingBroker": "0158",
        "brokerName": "APEX FINTECH BROKERAGE SERVICES LLC                                   "
    },
    {
        "type": "OTC",
        "mpid": "AFCO",
        "clearingBroker": "0284",
        "brokerName": "TD PRIME SERVICES LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "AFSS",
        "clearingBroker": "0750",
        "brokerName": "FOUR POINTS CAPITAL PARTNERS LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "AGCO",
        "clearingBroker": "0052",
        "brokerName": "AUERBACH GRAYSON & COMPANY LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "AGCP",
        "clearingBroker": "0052",
        "brokerName": "AEGIS CAPITAL CORP.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "AGES",
        "clearingBroker": "0750",
        "brokerName": "ADVISORY GROUP EQUITY SERVICES LTD.                                   "
    },
    {
        "type": "OTC",
        "mpid": "AGFA",
        "clearingBroker": "0226",
        "brokerName": "VALIC FINANCIAL ADVISORS, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "AGIS",
        "clearingBroker": "0235",
        "brokerName": "AEGIS CAPITAL CORP.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "AGPM",
        "clearingBroker": "1043",
        "brokerName": "A.G.P. / ALLIANCE GLOBAL PARTNERS                                     "
    },
    {
        "type": "OTC",
        "mpid": "AGTS",
        "clearingBroker": "0158",
        "brokerName": "AVANT-GARDE TRADING SECURITIES                                        "
    },
    {
        "type": "OTC",
        "mpid": "AHSI",
        "clearingBroker": "0141",
        "brokerName": "AMERICAN HERITAGE SECURITIES, INC.                                    "
    },
    {
        "type": "OTC",
        "mpid": "AIRS",
        "clearingBroker": "0279",
        "brokerName": "HAND SECURITIES, INC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "AISG",
        "clearingBroker": "0235",
        "brokerName": "AMERICAN INDEPENDENT SECURITIES GROUP, LLC                            "
    },
    {
        "type": "OTC",
        "mpid": "AJCO",
        "clearingBroker": "0443",
        "brokerName": "IDB CAPITAL CORP.                                                     "
    },
    {
        "type": "OTC",
        "mpid": "AKUN",
        "clearingBroker": "0695",
        "brokerName": "AKUNA SECURITIES LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "ALBS",
        "clearingBroker": "0158",
        "brokerName": "ALBERT SECURITIES, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "ALCG",
        "clearingBroker": "0235",
        "brokerName": "ALTITUDE CAPITAL GROUP LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "ALDN",
        "clearingBroker": "0052",
        "brokerName": "J. ALDEN ASSOCIATES, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "ALEG",
        "clearingBroker": "0534",
        "brokerName": "ALLEGRO SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "ALFA",
        "clearingBroker": "0352",
        "brokerName": "ALPHA TRADING L.P.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "ALGP",
        "clearingBroker": "0235",
        "brokerName": "A.G.P. / ALLIANCE GLOBAL PARTNERS                                     "
    },
    {
        "type": "OTC",
        "mpid": "ALGR",
        "clearingBroker": "0158",
        "brokerName": "ALGER (FRED) & CO INC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "ALIS",
        "clearingBroker": "0235",
        "brokerName": "ALEXANDER INVESTMENT SERVICES CO.                                     "
    },
    {
        "type": "OTC",
        "mpid": "ALLC",
        "clearingBroker": "0436",
        "brokerName": "ARCHIPELAGO SECURITIES L.L.C.                                         "
    },
    {
        "type": "OTC",
        "mpid": "ALLN",
        "clearingBroker": "0443",
        "brokerName": "ALLEN & COMPANY LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "ALNC",
        "clearingBroker": "0226",
        "brokerName": "A.G.P./ALLIANCE GLOBAL PARTNERS                                       "
    },
    {
        "type": "OTC",
        "mpid": "ALPS",
        "clearingBroker": "8072",
        "brokerName": "ALPINE SECURITIES CORPORATION                                         "
    },
    {
        "type": "OTC",
        "mpid": "ALPX",
        "clearingBroker": "0067",
        "brokerName": "TSX ALPHA U.S., INC.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "ALTR",
        "clearingBroker": "3164",
        "brokerName": "ALTRUIST FINANCIAL LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "ALTS",
        "clearingBroker": "0052",
        "brokerName": "LODAS SECURITIES LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "AMBB",
        "clearingBroker": "0141",
        "brokerName": "ALLEN, MOONEY & BARNES BROKERAGE SERVICES, LLC                        "
    },
    {
        "type": "OTC",
        "mpid": "AMER",
        "clearingBroker": "0235",
        "brokerName": "AMERICAN TRUST INVESTMENT SERVICES, INC.                              "
    },
    {
        "type": "OTC",
        "mpid": "AMIC",
        "clearingBroker": "0226",
        "brokerName": "AMERICAN INVESTORS COMPANY                                            "
    },
    {
        "type": "OTC",
        "mpid": "AMLU",
        "clearingBroker": "3652",
        "brokerName": "LUCID CAPITAL MARKETS, LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "AMMS",
        "clearingBroker": "0141",
        "brokerName": "AMUNI FINANCIAL, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "AMRI",
        "clearingBroker": "8199",
        "brokerName": "AMERICAS EXECUTIONS, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "ANDG",
        "clearingBroker": "0235",
        "brokerName": "GARRETT (ANDREW), INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "ANOS",
        "clearingBroker": "0235",
        "brokerName": "ABEL NOSER, LLC.                                                      "
    },
    {
        "type": "OTC",
        "mpid": "ANOV",
        "clearingBroker": "0750",
        "brokerName": "ANOVEST FINANCIAL SERVICES, INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "AORP",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "AOSD",
        "clearingBroker": "0158",
        "brokerName": "TRADING BLOCK                                                         "
    },
    {
        "type": "OTC",
        "mpid": "APBD",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "APBO",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "APCA",
        "clearingBroker": "3021",
        "brokerName": "ALPACA SECURITIES LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "APCC",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "APOG",
        "clearingBroker": "8430",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "APRO",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "APRT",
        "clearingBroker": "0226",
        "brokerName": "PARTNERS                                                              "
    },
    {
        "type": "OTC",
        "mpid": "APTO",
        "clearingBroker": "0103",
        "brokerName": "APTO PARTNERS, LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "APXO",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "APXS",
        "clearingBroker": "0052",
        "brokerName": "APEXUS CAPITAL LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "AQUA",
        "clearingBroker": "0197",
        "brokerName": "AQUA SECURITIES L.P.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "AQUB",
        "clearingBroker": "0197",
        "brokerName": "AQUA SECURITIES L.P.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "ARBC",
        "clearingBroker": "0235",
        "brokerName": "ARKADIOS CAPITAL                                                      "
    },
    {
        "type": "OTC",
        "mpid": "ARCA",
        "clearingBroker": "0436",
        "brokerName": "ARCHIPELAGO TRADING SERVICES, INC.                                    "
    },
    {
        "type": "OTC",
        "mpid": "ARCD",
        "clearingBroker": "0443",
        "brokerName": "ARCADIA SECURITIES, LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "ARCT",
        "clearingBroker": "4305",
        "brokerName": "ARCHITECT SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "ARKI",
        "clearingBroker": "0226",
        "brokerName": "ARKADIOS CAPITAL                                                      "
    },
    {
        "type": "OTC",
        "mpid": "ARMS",
        "clearingBroker": "0534",
        "brokerName": "ARMSTRONG SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "ARRB",
        "clearingBroker": "0436",
        "brokerName": "ARCHIPELAGO SECURITIES L.L.C.                                         "
    },
    {
        "type": "OTC",
        "mpid": "ARSC",
        "clearingBroker": "1043",
        "brokerName": "ARCTIC SECURITIES LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "ARVS",
        "clearingBroker": "0443",
        "brokerName": "ARVEST WEALTH MANAGEMENT                                              "
    },
    {
        "type": "OTC",
        "mpid": "ASCM",
        "clearingBroker": "0052",
        "brokerName": "ASCENDIANT CAPITAL MARKETS, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "ASEL",
        "clearingBroker": "0370",
        "brokerName": "TRADITION SECURITIES AND DERIVATIVES LLC                              "
    },
    {
        "type": "OTC",
        "mpid": "ASII",
        "clearingBroker": "0226",
        "brokerName": "AURORA SECURITIES                                                     "
    },
    {
        "type": "OTC",
        "mpid": "ASLB",
        "clearingBroker": "0370",
        "brokerName": "TRADITION SECURITIES AND DERIVATIVES LLC                              "
    },
    {
        "type": "OTC",
        "mpid": "ASLT",
        "clearingBroker": "1043",
        "brokerName": "ASL CAPITAL MARKETS INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "ASOI",
        "clearingBroker": "0226",
        "brokerName": "ASSOCIATED INVESTMENT SERVICES, INC.                                  "
    },
    {
        "type": "OTC",
        "mpid": "ASPI",
        "clearingBroker": "0534",
        "brokerName": "ASIA PACIFIC FINANCIAL MANAGEMENT GROUP, INC.                         "
    },
    {
        "type": "OTC",
        "mpid": "ASSO",
        "clearingBroker": "0075",
        "brokerName": "ASSOCIATED SECURITIES CORP.                                           "
    },
    {
        "type": "OTC",
        "mpid": "ASTW",
        "clearingBroker": "0551",
        "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "ATIS",
        "clearingBroker": "0052",
        "brokerName": "AMERICAN TRUST INVESTMENT SERVICES, INC.                              "
    },
    {
        "type": "OTC",
        "mpid": "ATMC",
        "clearingBroker": "0100",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "ATVT",
        "clearingBroker": "0443",
        "brokerName": "ATOMIC BROKERAGE LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "AUTO",
        "clearingBroker": "0505",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "AVEN",
        "clearingBroker": "0226",
        "brokerName": "AVENTURA SECURITIES, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "AVEW",
        "clearingBroker": "8199",
        "brokerName": "AVENTURA SECURITIES, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "AVIL",
        "clearingBroker": "0158",
        "brokerName": "AVANZA CAPITAL MARKETS INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "AVML",
        "clearingBroker": "0443",
        "brokerName": "AVM, L.P.                                                             "
    },
    {
        "type": "OTC",
        "mpid": "AVNU",
        "clearingBroker": "0158",
        "brokerName": "AVENUE SECURITIES LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "AVSC",
        "clearingBroker": "0294",
        "brokerName": "AVENUE SECURITIES LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "AVSI",
        "clearingBroker": "0443",
        "brokerName": "AMERIVET SECURITIES, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "AVST",
        "clearingBroker": "0235",
        "brokerName": "ATOMIC BROKERAGE LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "AVTR",
        "clearingBroker": "8199",
        "brokerName": "AVATAR SECURITIES, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "AXCL",
        "clearingBroker": "0052",
        "brokerName": "AXOS CLEARING LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "AXCS",
        "clearingBroker": "0443",
        "brokerName": "ACCESS SECURITIES INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "AXGP",
        "clearingBroker": "0443",
        "brokerName": "ACCESS SECURITIES, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "AXIO",
        "clearingBroker": "0279",
        "brokerName": "AXIOM CAPITAL MANAGEMENT, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "AXOS",
        "clearingBroker": "0052",
        "brokerName": "AXOS CLEARING LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "AXXX",
        "clearingBroker": "8601",
        "brokerName": "DTC/NSCC FTS TEST ACCOUNT 1                                           "
    },
    {
        "type": "OTC",
        "mpid": "BALA",
        "clearingBroker": "0005",
        "brokerName": "G1 EXECUTION SERVICES, LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "BALE",
        "clearingBroker": "0443",
        "brokerName": "M&T SECURITIES, INC.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "BALS",
        "clearingBroker": "0750",
        "brokerName": "BRUCE A. LEFAVI SECURITIES, INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "BANK",
        "clearingBroker": "0701",
        "brokerName": "CETERA INVESTMENT SERVICES LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "BARD",
        "clearingBroker": "0547",
        "brokerName": "ROBERT W. BAIRD & CO. INCORPORATED                                    "
    },
    {
        "type": "OTC",
        "mpid": "BARR",
        "clearingBroker": "0226",
        "brokerName": "BARRETT & COMPANY                                                     "
    },
    {
        "type": "OTC",
        "mpid": "BATM",
        "clearingBroker": "0050",
        "brokerName": "BATS TRADING, INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "BATS",
        "clearingBroker": "8199",
        "brokerName": "BATS TRADING, INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "BAYC",
        "clearingBroker": "0161",
        "brokerName": "BAY CREST PARTNERS,  LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "BAYP",
        "clearingBroker": "0161",
        "brokerName": "BAY CREST PARTNERS, LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "BAYT",
        "clearingBroker": "0005",
        "brokerName": "BTIG, LLC                                                             "
    },
    {
        "type": "OTC",
        "mpid": "BBAR",
        "clearingBroker": "0595",
        "brokerName": "BUCKMAN, BUCKMAN & REID, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "BBGC",
        "clearingBroker": "0235",
        "brokerName": "GRAHAM (B.B.) & COMPANY                                               "
    },
    {
        "type": "OTC",
        "mpid": "BBHC",
        "clearingBroker": "0010",
        "brokerName": "BROWN BROTHERS HARRIMAN & CO.                                         "
    },
    {
        "type": "OTC",
        "mpid": "BBOK",
        "clearingBroker": "0229",
        "brokerName": "BARCLAYS CAPITAL INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "BCDX",
        "clearingBroker": "0229",
        "brokerName": "BARCLAYS CAPITAL INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "BCEP",
        "clearingBroker": "0551",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "BCEX",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "BCMX",
        "clearingBroker": "0443",
        "brokerName": "BERENBERG CAPITAL MARKETS LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "BCPI",
        "clearingBroker": "0279",
        "brokerName": "GVC CAPITAL LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "BCPL",
        "clearingBroker": "0750",
        "brokerName": "STOCKKINGS CAPITAL LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "BCRK",
        "clearingBroker": "0279",
        "brokerName": "BEAR CREEK SECURITIES, LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "BCSA",
        "clearingBroker": "0443",
        "brokerName": "BCS AMERICAS, INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "BCSG",
        "clearingBroker": "0294",
        "brokerName": "BCS GLOBAL MARKETS                                                    "
    },
    {
        "type": "OTC",
        "mpid": "BCWM",
        "clearingBroker": "4077",
        "brokerName": "BETA CAPITAL SECURITIES LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "BCZC",
        "clearingBroker": "0443",
        "brokerName": "ZIEGLER (B.C.) & COMPANY                                              "
    },
    {
        "type": "OTC",
        "mpid": "BDCO",
        "clearingBroker": "0534",
        "brokerName": "BARDI CO. LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "BEAF",
        "clearingBroker": "0235",
        "brokerName": "BEACONSFIELD FINANCIAL SERV.                                          "
    },
    {
        "type": "OTC",
        "mpid": "BEAR",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "BELZ",
        "clearingBroker": "0627",
        "brokerName": "DASH FINANCIAL TECHNOLOGIES LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "BERN",
        "clearingBroker": "0013",
        "brokerName": "SANFORD C. BERNSTEIN & CO., LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "BERS",
        "clearingBroker": "0235",
        "brokerName": "BESTEX RESEARCH SECURITIES, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "BEST",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "BESX",
        "clearingBroker": "8199",
        "brokerName": "BESTEX RESEARCH SECURITIES, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "BFAB",
        "clearingBroker": "0695",
        "brokerName": "BLUEFIN CAPITAL MANAGEMENT, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "BFEC",
        "clearingBroker": "0443",
        "brokerName": "BENJAMIN F. EDWARDS & COMPANY                                         "
    },
    {
        "type": "OTC",
        "mpid": "BFFI",
        "clearingBroker": "0226",
        "brokerName": "BERTHEL, FISHER & COMPANY FINANCIAL SERVICES, INC.                    "
    },
    {
        "type": "OTC",
        "mpid": "BFSL",
        "clearingBroker": "0235",
        "brokerName": "BRIGGS-FICKS SECURITIES, LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "BGCE",
        "clearingBroker": "0161",
        "brokerName": "BGC FINANCIAL INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "BGCF",
        "clearingBroker": "0537",
        "brokerName": "BGC FINANCIAL, L.P.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "BGHT",
        "clearingBroker": "0141",
        "brokerName": "BRIGHTON SECURITIES CORP.                                             "
    },
    {
        "type": "OTC",
        "mpid": "BGIS",
        "clearingBroker": "0443",
        "brokerName": "BLACKROCK EXECUTION SERVICES                                          "
    },
    {
        "type": "OTC",
        "mpid": "BGMI",
        "clearingBroker": "0158",
        "brokerName": "BRICKELL GLOBAL MARKETS, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "BGSG",
        "clearingBroker": "0226",
        "brokerName": "CBIZ FINANCIAL SOLUTIONS, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "BHKS",
        "clearingBroker": "0141",
        "brokerName": "BHK SECURITIES, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "BIDS",
        "clearingBroker": "0161",
        "brokerName": "BIDS TRADING L.P.                                                     "
    },
    {
        "type": "OTC",
        "mpid": "BIGG",
        "clearingBroker": "0005",
        "brokerName": "BROWNSTONE INVESTMENT GROUP, LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "BIGP",
        "clearingBroker": "0443",
        "brokerName": "BROWNSTONE INVESTMENT GROUP, LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "BIGZ",
        "clearingBroker": "0443",
        "brokerName": "BROWNSTONE INVESTMENT GROUP, LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "BIMI",
        "clearingBroker": "0136",
        "brokerName": "INTESA SANPAOLO IMI SECURITIES CORP.                                  "
    },
    {
        "type": "OTC",
        "mpid": "BIRM",
        "clearingBroker": "0013",
        "brokerName": "SANFORD C. BERNSTEIN & CO., LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "BISB",
        "clearingBroker": "0286",
        "brokerName": "BERNSTEIN INSTITUTIONAL SERVICES LLC                                  "
    },
    {
        "type": "OTC",
        "mpid": "BISE",
        "clearingBroker": "0286",
        "brokerName": "BERNSTEIN INSTITUTIONAL SERVICES LLC                                  "
    },
    {
        "type": "OTC",
        "mpid": "BISG",
        "clearingBroker": "0286",
        "brokerName": "BERNSTEIN INSTITUTIONAL SERVICES LLC                                  "
    },
    {
        "type": "OTC",
        "mpid": "BISH",
        "clearingBroker": "0286",
        "brokerName": "BERNSTEIN INSTITUTIONAL SERVICES LLC                                  "
    },
    {
        "type": "OTC",
        "mpid": "BISI",
        "clearingBroker": "0443",
        "brokerName": "BANORTE SECURITIES INTERNATIONAL, LTD.                                "
    },
    {
        "type": "OTC",
        "mpid": "BISO",
        "clearingBroker": "0286",
        "brokerName": "BERNSTEIN INSTITUTIONAL SERVICES LLC                                  "
    },
    {
        "type": "OTC",
        "mpid": "BIVO",
        "clearingBroker": "0534",
        "brokerName": "BIVO FINANCIAL LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "BJCM",
        "clearingBroker": "0235",
        "brokerName": "ESSEX SECURITIES LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "BJRC",
        "clearingBroker": "0235",
        "brokerName": "CASCADE INVESTMENT GROUP, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "BKCM",
        "clearingBroker": "0443",
        "brokerName": "BNY CAPITAL MARKETS INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "BKES",
        "clearingBroker": "0443",
        "brokerName": "BNY MELLON CAPITAL MARKETS, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "BKRT",
        "clearingBroker": "0235",
        "brokerName": "BUCKMAN, BUCKMAN & REID, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "BLAV",
        "clearingBroker": "0013",
        "brokerName": "SANFORD C. BERNSTEIN & CO., LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "BLCK",
        "clearingBroker": "0534",
        "brokerName": "JAMES I. BLACK & COMPANY                                              "
    },
    {
        "type": "OTC",
        "mpid": "BLKX",
        "clearingBroker": "0067",
        "brokerName": "INSTINET, LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "BLNI",
        "clearingBroker": "0226",
        "brokerName": "AMERITAS INVESTMENT COMPANY, LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "BLOC",
        "clearingBroker": "0158",
        "brokerName": "TRADING BLOCK                                                         "
    },
    {
        "type": "OTC",
        "mpid": "BLOX",
        "clearingBroker": "0443",
        "brokerName": "JONESTRADING                                                          "
    },
    {
        "type": "OTC",
        "mpid": "BLTK",
        "clearingBroker": "0443",
        "brokerName": "BULLTICK, LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "BLTN",
        "clearingBroker": "0534",
        "brokerName": "BOLTON SECURITIES CORPORATION                                         "
    },
    {
        "type": "OTC",
        "mpid": "BLUE",
        "clearingBroker": "4305",
        "brokerName": "BLUE OCEAN ATS, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "BMOC",
        "clearingBroker": "0045",
        "brokerName": "BMO CAPITAL MARKETS CORP.                                             "
    },
    {
        "type": "OTC",
        "mpid": "BMSI",
        "clearingBroker": "0750",
        "brokerName": "BULL MARKET SECURITIES, INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "BMSX",
        "clearingBroker": "4305",
        "brokerName": "BULL MARKET SECURITIES, INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "BMSY",
        "clearingBroker": "0294",
        "brokerName": "BULL MARKET SECURITIES, INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "BMUR",
        "clearingBroker": "0443",
        "brokerName": "BREAN CAPITAL, LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "BNBB",
        "clearingBroker": "0750",
        "brokerName": "INTERCOASTAL CAPITAL MARKETS, INC.                                    "
    },
    {
        "type": "OTC",
        "mpid": "BNCH",
        "clearingBroker": "0235",
        "brokerName": "THE BENCHMARK COMPANY, LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "BNJM",
        "clearingBroker": "0235",
        "brokerName": "BENJAMIN SECURITIES, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "BNPS",
        "clearingBroker": "2154",
        "brokerName": "BNP PARIBAS SECURITIES CORP.                                          "
    },
    {
        "type": "OTC",
        "mpid": "BNPX",
        "clearingBroker": "2154",
        "brokerName": "BNP PARIBAS SECURITIES CORP.                                          "
    },
    {
        "type": "OTC",
        "mpid": "BNTE",
        "clearingBroker": "0158",
        "brokerName": "BANORTE-IXE SECURITIES INTERNATIONAL, LTD.                            "
    },
    {
        "type": "OTC",
        "mpid": "BNYN",
        "clearingBroker": "0226",
        "brokerName": "BANYAN SECURITIES, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "BOBS",
        "clearingBroker": "0534",
        "brokerName": "BULLISH BOB BAGLEY SECURITIES, INC.                                   "
    },
    {
        "type": "OTC",
        "mpid": "BOKI",
        "clearingBroker": "0443",
        "brokerName": "BOSC, INC.                                                            "
    },
    {
        "type": "OTC",
        "mpid": "BOLL",
        "clearingBroker": "0279",
        "brokerName": "BODELL OVERCASH ANDERSON & CO.                                        "
    },
    {
        "type": "OTC",
        "mpid": "BOSS",
        "clearingBroker": "0158",
        "brokerName": "ALL TIME ATS                                                          "
    },
    {
        "type": "OTC",
        "mpid": "BPWP",
        "clearingBroker": "0226",
        "brokerName": "BUTTONWOOD PARTNERS, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "BRBR",
        "clearingBroker": "0279",
        "brokerName": "BROWN AND BROWN SECURITIES, INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "BRCY",
        "clearingBroker": "0443",
        "brokerName": "BCP SECURITIES, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "BRGE",
        "clearingBroker": "0052",
        "brokerName": "NEWBRIDGE SECURITIES CORPORATION                                      "
    },
    {
        "type": "OTC",
        "mpid": "BRLI",
        "clearingBroker": "0226",
        "brokerName": "BROWN, LISLE/CUMMINGS, INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "BRLY",
        "clearingBroker": "0158",
        "brokerName": "B. RILEY WEALTH MANAGEMENT, INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "BRNK",
        "clearingBroker": "0226",
        "brokerName": "BRINKER CAPITAL SECURITIES, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "BROC",
        "clearingBroker": "0443",
        "brokerName": "PAVILION GLOBAL MARKETS LTD                                           "
    },
    {
        "type": "OTC",
        "mpid": "BRPR",
        "clearingBroker": "0534",
        "brokerName": "BRASIL PLURAL SECURITIES LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "BRRR",
        "clearingBroker": "8199",
        "brokerName": "BARRINGTON RESEARCH ASSOCIATES, INC.                                  "
    },
    {
        "type": "OTC",
        "mpid": "BRSA",
        "clearingBroker": "0103",
        "brokerName": "BOURSA INVESTMENTS                                                    "
    },
    {
        "type": "OTC",
        "mpid": "BRSE",
        "clearingBroker": "0226",
        "brokerName": "BRADESCO SECURITIES, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "BRUT",
        "clearingBroker": "0568",
        "brokerName": "NASDAQ EXECUTION SERVICES, LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "BRVL",
        "clearingBroker": "0443",
        "brokerName": "BLAYLOCK BEAL VAN, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "BRWM",
        "clearingBroker": "0226",
        "brokerName": "B. RILEY WEALTH MANAGEMENT                                            "
    },
    {
        "type": "OTC",
        "mpid": "BSCM",
        "clearingBroker": "0052",
        "brokerName": "BROAD STREET CAPITAL MARKETS, LLC                                     "
    },
    {
        "type": "OTC",
        "mpid": "BSPI",
        "clearingBroker": "0235",
        "brokerName": "BALANCED SECURITY PLANNING, INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "BSSC",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "BSTX",
        "clearingBroker": "4305",
        "brokerName": "BESTEX RESEARCH SECURITIES, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "BTBS",
        "clearingBroker": "0695",
        "brokerName": "BELVEDERE TRADING LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "BTCK",
        "clearingBroker": "0158",
        "brokerName": "BULLTICK, LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "BTDG",
        "clearingBroker": "0161",
        "brokerName": "BIDS TRADING LP                                                       "
    },
    {
        "type": "OTC",
        "mpid": "BTGP",
        "clearingBroker": "2402",
        "brokerName": "BTG PACTUAL US CAPITAL, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "BTIG",
        "clearingBroker": "0005",
        "brokerName": "BTIG, LLC                                                             "
    },
    {
        "type": "OTC",
        "mpid": "BTIM",
        "clearingBroker": "1043",
        "brokerName": "BTIG, LLC                                                             "
    },
    {
        "type": "OTC",
        "mpid": "BTIS",
        "clearingBroker": "0443",
        "brokerName": "BTIG, LLC                                                             "
    },
    {
        "type": "OTC",
        "mpid": "BTSI",
        "clearingBroker": "0158",
        "brokerName": "LIGHT HORSE MARKET SOLUTIONS INC                                      "
    },
    {
        "type": "OTC",
        "mpid": "BTSS",
        "clearingBroker": "0279",
        "brokerName": "HILLTOP SECURITIES INDEPENDENT NETWORK INC.                           "
    },
    {
        "type": "OTC",
        "mpid": "BULL",
        "clearingBroker": "0158",
        "brokerName": "WEBULL FINANCIAL LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "BUMP",
        "clearingBroker": "0158",
        "brokerName": "BUMPED FINANCIAL LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "BUNT",
        "clearingBroker": "5017",
        "brokerName": "UBS SECURITIES CANADA INC./CDS                                        "
    },
    {
        "type": "OTC",
        "mpid": "BWNA",
        "clearingBroker": "0235",
        "brokerName": "BROWN ASSOCIATES INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "BXXX",
        "clearingBroker": "8602",
        "brokerName": "ANONYMOUS BROKER ACCOUNT                                              "
    },
    {
        "type": "OTC",
        "mpid": "BYXM",
        "clearingBroker": "0050",
        "brokerName": "BATS TRADING, INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "BYXX",
        "clearingBroker": "8199",
        "brokerName": "BATS TRADING, INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "BZTN",
        "clearingBroker": "0141",
        "brokerName": "ALLIANT SECURITIES, INC. TURNER, NORD, KIENBAUM                       "
    },
    {
        "type": "OTC",
        "mpid": "BZWV",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "BZYD",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "BZYF",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "BZYJ",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "CAAA",
        "clearingBroker": "0750",
        "brokerName": "AKAR CAPITAL MANAGEMENT, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "CABR",
        "clearingBroker": "0161",
        "brokerName": "CABRERA CAPITAL MARKETS, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "CADG",
        "clearingBroker": "0005",
        "brokerName": "WEEDEN PRIME SERVICES, LLC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "CADZ",
        "clearingBroker": "0279",
        "brokerName": "CADZ SECURITIES INC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "CAES",
        "clearingBroker": "0734",
        "brokerName": "THE NASDAQ STOCK MARKET LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "CAFS",
        "clearingBroker": "0158",
        "brokerName": "COMMUNITYAMERICA FINANCIAL SOLUTIONS, LLC                             "
    },
    {
        "type": "OTC",
        "mpid": "CAGI",
        "clearingBroker": "0279",
        "brokerName": "CRESCENT SECURITIES GROUP, INC.                                       "
    },
    {
        "type": "OTC",
        "mpid": "CAIX",
        "clearingBroker": "0235",
        "brokerName": "CAIS CAPITAL LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "CALD",
        "clearingBroker": "0103",
        "brokerName": "CALDWELL SUTTER CAPITAL, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "CALT",
        "clearingBroker": "0279",
        "brokerName": "CALTON & ASSOCIATES, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "CANA",
        "clearingBroker": "0443",
        "brokerName": "CANACCORD GENUITY INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "CANR",
        "clearingBroker": "0388",
        "brokerName": "CANTONE RESEARCH INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "CANT",
        "clearingBroker": "0696",
        "brokerName": "CANTOR FITZGERALD & CO.                                               "
    },
    {
        "type": "OTC",
        "mpid": "CAPC",
        "clearingBroker": "0235",
        "brokerName": "CAPITAL CITY SECURITIES, LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "CAPE",
        "clearingBroker": "0279",
        "brokerName": "CAPE SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "CARY",
        "clearingBroker": "0141",
        "brokerName": "CARY STREET PARTNERS                                                  "
    },
    {
        "type": "OTC",
        "mpid": "CASH",
        "clearingBroker": "0158",
        "brokerName": "PLANNER SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "CATE",
        "clearingBroker": "0235",
        "brokerName": "CARTER, TERRY & COMPANY, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "CATH",
        "clearingBroker": "0534",
        "brokerName": "CATHAY SECURITIES, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "CATS",
        "clearingBroker": "8430",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "CBLC",
        "clearingBroker": "0505",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "CBOL",
        "clearingBroker": "0226",
        "brokerName": "MUTUAL SECURITIES, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "CBRA",
        "clearingBroker": "0103",
        "brokerName": "COBRA TRADING, INC.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "CBRC",
        "clearingBroker": "3450",
        "brokerName": "COBRA TRADING, INC.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "CBRV",
        "clearingBroker": "8199",
        "brokerName": "COBRA TRADING, INC.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "CBTD",
        "clearingBroker": "0226",
        "brokerName": "SYNOVOUS SECURITIES INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "CBUZ",
        "clearingBroker": "0695",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "CCAI",
        "clearingBroker": "5046",
        "brokerName": "CANACCORD CAPITAL CORPORATION/CDS                                     "
    },
    {
        "type": "OTC",
        "mpid": "CCAT",
        "clearingBroker": "0505",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "CCCO",
        "clearingBroker": "0226",
        "brokerName": "CARNES CAPITAL CORPORATION                                            "
    },
    {
        "type": "OTC",
        "mpid": "CCIG",
        "clearingBroker": "0235",
        "brokerName": "CINCAP INVESTMENT GROUP, INC                                          "
    },
    {
        "type": "OTC",
        "mpid": "CCMB",
        "clearingBroker": "0443",
        "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "CCMI",
        "clearingBroker": "0443",
        "brokerName": "JMP SECURITIES LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "CCMM",
        "clearingBroker": "0235",
        "brokerName": "CRAFT CAPITAL MANAGEMENT LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "CCMX",
        "clearingBroker": "8430",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "CCPM",
        "clearingBroker": "0595",
        "brokerName": "CAMBRIA CAPITAL, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "CDEA",
        "clearingBroker": "0438",
        "brokerName": "CIBC WORLD MARKETS CORP.                                              "
    },
    {
        "type": "OTC",
        "mpid": "CDED",
        "clearingBroker": "8430",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "CDEL",
        "clearingBroker": "0161",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "CDFS",
        "clearingBroker": "0052",
        "brokerName": "NAVIAN CAPITAL SECURITIES, LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "CDGO",
        "clearingBroker": "0551",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "CDLC",
        "clearingBroker": "0395",
        "brokerName": "CITADEL CLEARING LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "CDMA",
        "clearingBroker": "0505",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "CDMI",
        "clearingBroker": "0005",
        "brokerName": "CITIGROUP DERIVATIVES MARKETS INC.                                    "
    },
    {
        "type": "OTC",
        "mpid": "CDON",
        "clearingBroker": "0534",
        "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "CDRG",
        "clearingBroker": "8430",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "CDSO",
        "clearingBroker": "4305",
        "brokerName": "CDS1 SECURITIES LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "CECL",
        "clearingBroker": "0158",
        "brokerName": "CARVER EDISON CAPITAL, LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "CEDL",
        "clearingBroker": "8430",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "CEMM",
        "clearingBroker": "8430",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "CERS",
        "clearingBroker": "0226",
        "brokerName": "CEROS FINANCIAL SERVICES, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "CFCD",
        "clearingBroker": "0005",
        "brokerName": "CANTOR FITZGERALD & CO.                                               "
    },
    {
        "type": "OTC",
        "mpid": "CFCO",
        "clearingBroker": "7311",
        "brokerName": "CANTOR FITZGERALD & CO.                                               "
    },
    {
        "type": "OTC",
        "mpid": "CFCS",
        "clearingBroker": "0005",
        "brokerName": "CANTOR FITZGERALD & CO.                                               "
    },
    {
        "type": "OTC",
        "mpid": "CFDI",
        "clearingBroker": "0226",
        "brokerName": "CFD INVESTMENTS, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "CFGM",
        "clearingBroker": "0235",
        "brokerName": "TRUSTMONT FINANCIAL GROUP, INC.                                       "
    },
    {
        "type": "OTC",
        "mpid": "CFGT",
        "clearingBroker": "0235",
        "brokerName": "CF GLOBAL TRADING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "CFII",
        "clearingBroker": "0235",
        "brokerName": "CONSOLIDATED FINANCIAL INVESTMENTS, INC.                              "
    },
    {
        "type": "OTC",
        "mpid": "CFIN",
        "clearingBroker": "0279",
        "brokerName": "CHELSEA FINANCIAL SERVICES                                            "
    },
    {
        "type": "OTC",
        "mpid": "CFPT",
        "clearingBroker": "0197",
        "brokerName": "CANTOR FITZGERALD & CO.                                               "
    },
    {
        "type": "OTC",
        "mpid": "CFRC",
        "clearingBroker": "3259",
        "brokerName": "CANTOR FITZGERALD & CO.                                               "
    },
    {
        "type": "OTC",
        "mpid": "CFSI",
        "clearingBroker": "0052",
        "brokerName": "CEROS FINANCIAL SERVICES, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "CFSX",
        "clearingBroker": "0794",
        "brokerName": "CF SECURED, LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "CGQT",
        "clearingBroker": "0505",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "CGWM",
        "clearingBroker": "0443",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "CGXS",
        "clearingBroker": "0067",
        "brokerName": "ONECHRONOS                                                            "
    },
    {
        "type": "OTC",
        "mpid": "CHAS",
        "clearingBroker": "0164",
        "brokerName": "CHARLES SCHWAB & CO., INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "CHBC",
        "clearingBroker": "0235",
        "brokerName": "PENSERRA SECURITIES, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CHCH",
        "clearingBroker": "0226",
        "brokerName": "CHURCHILL FINANCIAL, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CHCK",
        "clearingBroker": "0226",
        "brokerName": "CHICKASAW SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "CHDA",
        "clearingBroker": "0141",
        "brokerName": "CHAPIN, DAVIS                                                         "
    },
    {
        "type": "OTC",
        "mpid": "CHDN",
        "clearingBroker": "8199",
        "brokerName": "CHARDAN CAPITAL MARKETS LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "CHLC",
        "clearingBroker": "0443",
        "brokerName": "CHURCHILL CAPITAL USA, INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "CHLM",
        "clearingBroker": "0226",
        "brokerName": "CRAIG-HALLUM CAPITAL GROUP LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "CHMR",
        "clearingBroker": "0294",
        "brokerName": "CHIMERA SECURITIES, LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "CHPP",
        "clearingBroker": "0624",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "OTC",
        "mpid": "CHRD",
        "clearingBroker": "0158",
        "brokerName": "CHERRY TRADING                                                        "
    },
    {
        "type": "OTC",
        "mpid": "CHRS",
        "clearingBroker": "0750",
        "brokerName": "ROYAL TREASURE SECURITIES LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "CHUB",
        "clearingBroker": "0226",
        "brokerName": "OSAIC FS, INC.                                                        "
    },
    {
        "type": "OTC",
        "mpid": "CIBP",
        "clearingBroker": "0438",
        "brokerName": "CIBC WORLD MARKETS CORP.                                              "
    },
    {
        "type": "OTC",
        "mpid": "CICC",
        "clearingBroker": "0443",
        "brokerName": "CICC US SECURITIES, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "CICF",
        "clearingBroker": "5046",
        "brokerName": "CANACCORD GENUITY CORP./CDS                                           "
    },
    {
        "type": "OTC",
        "mpid": "CIIV",
        "clearingBroker": "0052",
        "brokerName": "CORPORATE INVESTMENTS GROUP, INC.                                     "
    },
    {
        "type": "OTC",
        "mpid": "CIMB",
        "clearingBroker": "0005",
        "brokerName": "CIMB SECURITIES (USA), INC                                            "
    },
    {
        "type": "OTC",
        "mpid": "CIOI",
        "clearingBroker": "0505",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "CIRI",
        "clearingBroker": "0443",
        "brokerName": "CAMBRIDGE INVESTMENT RESEARCH, INC.                                   "
    },
    {
        "type": "OTC",
        "mpid": "CISI",
        "clearingBroker": "0352",
        "brokerName": "CHASE INVESTMENT SERVICES CORP.                                       "
    },
    {
        "type": "OTC",
        "mpid": "CIST",
        "clearingBroker": "0161",
        "brokerName": "CAPITAL INSTITUTIONAL SERVICES, INC.                                  "
    },
    {
        "type": "OTC",
        "mpid": "CISV",
        "clearingBroker": "0226",
        "brokerName": "CITIZENS SECURITIES, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "CITO",
        "clearingBroker": "8430",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "CJSC",
        "clearingBroker": "0443",
        "brokerName": "CJS SECURITIES, INC.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "CLCU",
        "clearingBroker": "9132",
        "brokerName": "CLSA AMERICAS, LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "CLDN",
        "clearingBroker": "0235",
        "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "CLHT",
        "clearingBroker": "9132",
        "brokerName": "CLEAR STREET LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "CLIC",
        "clearingBroker": "0158",
        "brokerName": "CLICK IPO SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "CLRK",
        "clearingBroker": "0235",
        "brokerName": "CLARK DODGE & CO, INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "CLSA",
        "clearingBroker": "0161",
        "brokerName": "CLSA AMERICAS, LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "CLSC",
        "clearingBroker": "0235",
        "brokerName": "CABOT LODGE SECURITIES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "CLST",
        "clearingBroker": "9132",
        "brokerName": "CLEAR STREET, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "CLTN",
        "clearingBroker": "0226",
        "brokerName": "CALTON & ASSOCIATES, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "CMBA",
        "clearingBroker": "0551",
        "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "CMBB",
        "clearingBroker": "0551",
        "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "CMBC",
        "clearingBroker": "0551",
        "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "CMBD",
        "clearingBroker": "0551",
        "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "CMCE",
        "clearingBroker": "0226",
        "brokerName": "COMMERCE BROKERAGE SERVICES                                           "
    },
    {
        "type": "OTC",
        "mpid": "CMMW",
        "clearingBroker": "0226",
        "brokerName": "COMMONWEALTH FINANCIAL NETWORK                                        "
    },
    {
        "type": "OTC",
        "mpid": "CMPR",
        "clearingBroker": "0158",
        "brokerName": "COMPOSER SECURITIES LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "CMPT",
        "clearingBroker": "0750",
        "brokerName": "COMPASS POINT RESEARCH & TRADING, LLC                                 "
    },
    {
        "type": "OTC",
        "mpid": "CMRA",
        "clearingBroker": "9132",
        "brokerName": "CHIMERA SECURITIES, LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "CMSI",
        "clearingBroker": "0279",
        "brokerName": "CAPITAL MANAGEMENT SECURITIES, INC.                                   "
    },
    {
        "type": "OTC",
        "mpid": "CNAB",
        "clearingBroker": "1186",
        "brokerName": "COR CLEARING LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "CNCD",
        "clearingBroker": "0235",
        "brokerName": "CONCORDE INVESTMENT SERVICES, LLC                                     "
    },
    {
        "type": "OTC",
        "mpid": "CNFR",
        "clearingBroker": "0443",
        "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "CNSI",
        "clearingBroker": "0226",
        "brokerName": "CITY NATIONAL SECURITIES, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "CNTR",
        "clearingBroker": "0103",
        "brokerName": "PRECISION SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "COAK",
        "clearingBroker": "0443",
        "brokerName": "CASTLE OAK SECURITIES, L.P.                                           "
    },
    {
        "type": "OTC",
        "mpid": "CODA",
        "clearingBroker": "0161",
        "brokerName": "CODA MARKETS, INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "COEI",
        "clearingBroker": "0052",
        "brokerName": "COASTAL EQUITIES, INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "COEX",
        "clearingBroker": "0161",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "OTC",
        "mpid": "COFS",
        "clearingBroker": "0279",
        "brokerName": "COLORADO FINANCIAL SERVICE CORPORATION                                "
    },
    {
        "type": "OTC",
        "mpid": "COHN",
        "clearingBroker": "0235",
        "brokerName": "COHEN BROS. & COMPANY                                                 "
    },
    {
        "type": "OTC",
        "mpid": "COHR",
        "clearingBroker": "9132",
        "brokerName": "COMHAR CAPITAL MARKETS, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "COKE",
        "clearingBroker": "0235",
        "brokerName": "COKER & PALMER, INC.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "COMP",
        "clearingBroker": "0595",
        "brokerName": "COMPASS POINT RESEARCH & TRADING, LLC                                 "
    },
    {
        "type": "OTC",
        "mpid": "CONI",
        "clearingBroker": "0235",
        "brokerName": "CONTINENTAL INVESTORS SERVICES, INC.                                  "
    },
    {
        "type": "OTC",
        "mpid": "CONR",
        "clearingBroker": "0235",
        "brokerName": "CONNERS & CO., INC.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "COOR",
        "clearingBroker": "0141",
        "brokerName": "COORDINATED CAPITAL SECURITIES, INC.                                  "
    },
    {
        "type": "OTC",
        "mpid": "COWN",
        "clearingBroker": "0100",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "COWP",
        "clearingBroker": "0226",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "COWR",
        "clearingBroker": "0443",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "COWX",
        "clearingBroker": "0161",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "COWZ",
        "clearingBroker": "0100",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "COYL",
        "clearingBroker": "0235",
        "brokerName": "COYLE SECURITIES LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "CPEM",
        "clearingBroker": "0161",
        "brokerName": "CLEARPOOL EXECUTION SERVICES, LLC                                     "
    },
    {
        "type": "OTC",
        "mpid": "CPLC",
        "clearingBroker": "0595",
        "brokerName": "COVA CAPITAL PARTNERS LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "CPNT",
        "clearingBroker": "8199",
        "brokerName": "PRECISION SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "CPRC",
        "clearingBroker": "0235",
        "brokerName": "CORINTHIAN PARTNERS, L.L.C.                                           "
    },
    {
        "type": "OTC",
        "mpid": "CPRM",
        "clearingBroker": "8199",
        "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "CPST",
        "clearingBroker": "9132",
        "brokerName": "CLEAR STREET LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "CRAG",
        "clearingBroker": "0443",
        "brokerName": "KEPLER CAPITAL MARKETS, INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "CRCM",
        "clearingBroker": "0235",
        "brokerName": "COHNREZNICK CAPITAL                                                   "
    },
    {
        "type": "OTC",
        "mpid": "CRDL",
        "clearingBroker": "0235",
        "brokerName": "CARDINAL INVESTMENTS, INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "CRED",
        "clearingBroker": "0443",
        "brokerName": "CREDICORP CAPITAL LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "CRFN",
        "clearingBroker": "6769",
        "brokerName": "ROBINHOOD FINANCIAL, LLC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "CRIT",
        "clearingBroker": "0294",
        "brokerName": "CRITO CAPITAL LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "CRNJ",
        "clearingBroker": "0103",
        "brokerName": "CANTONE RESEARCH INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "CRPT",
        "clearingBroker": "0235",
        "brokerName": "CROSS POINT CAPITAL LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "CRUS",
        "clearingBroker": "0005",
        "brokerName": "CHINA RENAISSANCE SECURITIES (US) INC.                                "
    },
    {
        "type": "OTC",
        "mpid": "CRWE",
        "clearingBroker": "0534",
        "brokerName": "CREWE CAPITAL                                                         "
    },
    {
        "type": "OTC",
        "mpid": "CRYN",
        "clearingBroker": "0235",
        "brokerName": "BRENDAN E. CRYAN AND COMPANY, L.L.C.                                  "
    },
    {
        "type": "OTC",
        "mpid": "CSAI",
        "clearingBroker": "0793",
        "brokerName": "STIFEL INDEPENDENT ADVISORS, LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "CSAP",
        "clearingBroker": "0141",
        "brokerName": "CRESAP, INC.                                                          "
    },
    {
        "type": "OTC",
        "mpid": "CSCM",
        "clearingBroker": "0279",
        "brokerName": "CENTRAL STATES CAPITAL MARKETS, LLC                                   "
    },
    {
        "type": "OTC",
        "mpid": "CSEC",
        "clearingBroker": "8430",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "CSGI",
        "clearingBroker": "7587",
        "brokerName": "CHARLES SCHWAB & CO., INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "CSIN",
        "clearingBroker": "0161",
        "brokerName": "CITADEL SECURITIES INSTITUTIONAL LLC                                  "
    },
    {
        "type": "OTC",
        "mpid": "CSMI",
        "clearingBroker": "0534",
        "brokerName": "CAPITOL SECURITIES MANAGEMENT, INC.                                   "
    },
    {
        "type": "OTC",
        "mpid": "CSMM",
        "clearingBroker": "9132",
        "brokerName": "SUMMIT SECURITIES GROUP, LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "CSOT",
        "clearingBroker": "9132",
        "brokerName": "CLEAR STREET, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "CSPD",
        "clearingBroker": "0197",
        "brokerName": "CANTOR FITZGERALD & CO.                                               "
    },
    {
        "type": "OTC",
        "mpid": "CSPI",
        "clearingBroker": "0235",
        "brokerName": "CAPITAL SYNERGY PARTNERS                                              "
    },
    {
        "type": "OTC",
        "mpid": "CSSA",
        "clearingBroker": "0695",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "CSSB",
        "clearingBroker": "0551",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "CSTI",
        "clearingBroker": "0161",
        "brokerName": "CANACCORD GENUITY INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "CTAS",
        "clearingBroker": "0443",
        "brokerName": "OSAIC INSTITUTIONS, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "CTCA",
        "clearingBroker": "0551",
        "brokerName": "CTC, LLC                                                              "
    },
    {
        "type": "OTC",
        "mpid": "CTCB",
        "clearingBroker": "0005",
        "brokerName": "CTC, LLC                                                              "
    },
    {
        "type": "OTC",
        "mpid": "CTCO",
        "clearingBroker": "0534",
        "brokerName": "CITCO SECURITIES, INC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "CTDL",
        "clearingBroker": "0551",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "CTDN",
        "clearingBroker": "0352",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "CTLA",
        "clearingBroker": "0443",
        "brokerName": "CANTELLA & CO, INC.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "CTNL",
        "clearingBroker": "0235",
        "brokerName": "CENTENNIAL SECURITIES COMPANY LLC                                     "
    },
    {
        "type": "OTC",
        "mpid": "CTRD",
        "clearingBroker": "3856",
        "brokerName": "CHOICETRADE                                                           "
    },
    {
        "type": "OTC",
        "mpid": "CUAL",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CUAN",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CUAX",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CUFT",
        "clearingBroker": "0226",
        "brokerName": "FROST BROKERAGE SERVICES, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "CUGS",
        "clearingBroker": "8199",
        "brokerName": "DRIVEWEALTH INSTITUTIONAL, LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "CURG",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CURI",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "CURM",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "CURO",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CURT",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CURV",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "CUTW",
        "clearingBroker": "0235",
        "brokerName": "PROSPERA FINANCIAL SERVICES, INC.                                     "
    },
    {
        "type": "OTC",
        "mpid": "CUWB",
        "clearingBroker": "0103",
        "brokerName": "DRIVEWEALTH INSTITUTIONAL, LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "CVCG",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CVCN",
        "clearingBroker": "0158",
        "brokerName": "CV BROKERAGE, INC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "CVDC",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "CVFM",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CVHE",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "CVKD",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CVKX",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CVMS",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CVRB",
        "clearingBroker": "0005",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "CVRJ",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CVSB",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CVSH",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CVSX",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CVVG",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CVWS",
        "clearingBroker": "3450",
        "brokerName": "CURVATURE SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "CWMC",
        "clearingBroker": "0438",
        "brokerName": "CIBC WORLD MARKETS CORP.                                              "
    },
    {
        "type": "OTC",
        "mpid": "CWMK",
        "clearingBroker": "0438",
        "brokerName": "CIBC WORLD MARKETS CORP.                                              "
    },
    {
        "type": "OTC",
        "mpid": "CXCX",
        "clearingBroker": "0505",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "CXPS",
        "clearingBroker": "0534",
        "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "CXXX",
        "clearingBroker": "8603",
        "brokerName": "DTC/NSCC FTS TEST ACCOUNT #3                                          "
    },
    {
        "type": "OTC",
        "mpid": "CYND",
        "clearingBroker": "0443",
        "brokerName": "TIGRESS FINANCIAL PARTNERS LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "DABS",
        "clearingBroker": "0534",
        "brokerName": "DABBAH SECURITIES CORP.                                               "
    },
    {
        "type": "OTC",
        "mpid": "DADA",
        "clearingBroker": "0361",
        "brokerName": "D. A. DAVIDSON & CO.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "DAIN",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "DAIS",
        "clearingBroker": "0052",
        "brokerName": "DAI SECURITIES, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "DARA",
        "clearingBroker": "0235",
        "brokerName": "DARWOOD ASSOCIATES, INC                                               "
    },
    {
        "type": "OTC",
        "mpid": "DARQ",
        "clearingBroker": "0568",
        "brokerName": "NASDAQ EXECUTION SERVICES, LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "DART",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "DASH",
        "clearingBroker": "0161",
        "brokerName": "DASH FINANCIAL TECHNOLOGIES LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "DAVA",
        "clearingBroker": "0443",
        "brokerName": "DAVENPORT & COMPANY LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "DAVS",
        "clearingBroker": "0534",
        "brokerName": "DAVIS SECURITIES LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "DAWA",
        "clearingBroker": "0647",
        "brokerName": "DAIWA CAPITAL MARKETS AMERICA INC.                                    "
    },
    {
        "type": "OTC",
        "mpid": "DBAB",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "DBAE",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "DBAT",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "DBAX",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "DBCC",
        "clearingBroker": "0235",
        "brokerName": "D. BORAL CAPITAL                                                      "
    },
    {
        "type": "OTC",
        "mpid": "DBCH",
        "clearingBroker": "0052",
        "brokerName": "D. BORAL CAPITAL                                                      "
    },
    {
        "type": "OTC",
        "mpid": "DBIB",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "DBLV",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "DBMS",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "DBPC",
        "clearingBroker": "0443",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "DBPR",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "DBPT",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "DBQT",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "DBRC",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "DBRT",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "DBST",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "DBUL",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "DCMI",
        "clearingBroker": "0226",
        "brokerName": "DAVINCI CAPITAL MANAGEMENT, INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "DCSD",
        "clearingBroker": "0235",
        "brokerName": "DAIN CORRESPONDENT SERVICES                                           "
    },
    {
        "type": "OTC",
        "mpid": "DCVL",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "DEAN",
        "clearingBroker": "0015",
        "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "DEDT",
        "clearingBroker": "0695",
        "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "DEFA",
        "clearingBroker": "0443",
        "brokerName": "JEFFERIES LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "DEGS",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "DEIF",
        "clearingBroker": "0551",
        "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "DEMA",
        "clearingBroker": "0534",
        "brokerName": "DEMATTEO MONNESS LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "DENI",
        "clearingBroker": "0279",
        "brokerName": "H.C. DENISON CO.                                                      "
    },
    {
        "type": "OTC",
        "mpid": "DESJ",
        "clearingBroker": "5028",
        "brokerName": "DESJARDINS SECURITIES INC./CDS                                        "
    },
    {
        "type": "OTC",
        "mpid": "DETF",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "DEXP",
        "clearingBroker": "0551",
        "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "DFIN",
        "clearingBroker": "0161",
        "brokerName": "DASH FINANCIAL LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "DFPG",
        "clearingBroker": "0235",
        "brokerName": "DFPG INVESTMENTS, INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "DFTA",
        "clearingBroker": "0695",
        "brokerName": "DASH FINANCIAL TECHNOLOGIES LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "DFTR",
        "clearingBroker": "9132",
        "brokerName": "DASH FINANCIAL TECHNOLOGIES LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "DGLE",
        "clearingBroker": "0695",
        "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "DIBS",
        "clearingBroker": "0226",
        "brokerName": "DIGITAL BROKERAGE SERVICES LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "DIGG",
        "clearingBroker": "0595",
        "brokerName": "BOUSTEAD SECURITIES, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "DINO",
        "clearingBroker": "8199",
        "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
    },
    {
        "type": "OTC",
        "mpid": "DJMA",
        "clearingBroker": "0158",
        "brokerName": "DOJIMA SERVICES LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "DJSA",
        "clearingBroker": "0750",
        "brokerName": "DAWSON JAMES SECURITIES, INC                                          "
    },
    {
        "type": "OTC",
        "mpid": "DLAI",
        "clearingBroker": "0235",
        "brokerName": "DAVID LERNER ASSOCIATES, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "DLPS",
        "clearingBroker": "0595",
        "brokerName": "DLP SECURITIES,.LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "DLSI",
        "clearingBroker": "0226",
        "brokerName": "DEMPSEY LORD SMITH, LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "DLTA",
        "clearingBroker": "8445",
        "brokerName": "DEALERWEB INC.                                                        "
    },
    {
        "type": "OTC",
        "mpid": "DMCD",
        "clearingBroker": "0279",
        "brokerName": "MCDERMOTT INVESTMENT SERVICES, LLC                                    "
    },
    {
        "type": "OTC",
        "mpid": "DMER",
        "clearingBroker": "0551",
        "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "DMFE",
        "clearingBroker": "0551",
        "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "DMKC",
        "clearingBroker": "0141",
        "brokerName": "D.M. KELLY & COMPANY                                                  "
    },
    {
        "type": "OTC",
        "mpid": "DNOR",
        "clearingBroker": "0005",
        "brokerName": "DNB MARKETS, INC.                                                     "
    },
    {
        "type": "OTC",
        "mpid": "DNSR",
        "clearingBroker": "0158",
        "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
    },
    {
        "type": "OTC",
        "mpid": "DNWL",
        "clearingBroker": "0443",
        "brokerName": "DUNCAN & WILLIAMS, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "DOFI",
        "clearingBroker": "4305",
        "brokerName": "DOO FINANCIAL US, INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "DOFT",
        "clearingBroker": "0443",
        "brokerName": "DOFT & CO., INC.                                                      "
    },
    {
        "type": "OTC",
        "mpid": "DOMI",
        "clearingBroker": "0279",
        "brokerName": "DOMINION INVESTOR SERVICES, INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "DOMS",
        "clearingBroker": "0235",
        "brokerName": "DOMINARI SECURITIES LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "DOPE",
        "clearingBroker": "0158",
        "brokerName": "DOUGH LLC                                                             "
    },
    {
        "type": "OTC",
        "mpid": "DORN",
        "clearingBroker": "0235",
        "brokerName": "DORN & CO., INC.                                                      "
    },
    {
        "type": "OTC",
        "mpid": "DOTC",
        "clearingBroker": "0226",
        "brokerName": "COLLIERS SECURITIES LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "DOVE",
        "clearingBroker": "0226",
        "brokerName": "SECURITIES EQUITY GROUP                                               "
    },
    {
        "type": "OTC",
        "mpid": "DOWL",
        "clearingBroker": "0443",
        "brokerName": "DOWLING & PARTNERS SECURITIES LLC                                     "
    },
    {
        "type": "OTC",
        "mpid": "DQNY",
        "clearingBroker": "0551",
        "brokerName": "DRW SECURITIES, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "DRAT",
        "clearingBroker": "0571",
        "brokerName": "DRATEL GROUP (THE)                                                    "
    },
    {
        "type": "OTC",
        "mpid": "DREX",
        "clearingBroker": "0443",
        "brokerName": "DREXEL HAMILTON, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "DRIV",
        "clearingBroker": "2402",
        "brokerName": "DRIVEWEALTH, LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "DRSC",
        "clearingBroker": "0443",
        "brokerName": "BNY MELLON SECURITIES CORPORATION                                     "
    },
    {
        "type": "OTC",
        "mpid": "DRTG",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "DRTR",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "DRVW",
        "clearingBroker": "0235",
        "brokerName": "DRIVEWEALTH, LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "DRWC",
        "clearingBroker": "0005",
        "brokerName": "DRW SECURITIES, L.L.C.                                                "
    },
    {
        "type": "OTC",
        "mpid": "DRWJ",
        "clearingBroker": "0551",
        "brokerName": "DRW SECURITIES, L.L.C.                                                "
    },
    {
        "type": "OTC",
        "mpid": "DRWK",
        "clearingBroker": "0695",
        "brokerName": "DRW SECURITIES, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "DRWM",
        "clearingBroker": "0005",
        "brokerName": "DRW SECURITIES, L.L.C.                                                "
    },
    {
        "type": "OTC",
        "mpid": "DRWP",
        "clearingBroker": "0695",
        "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "DRWS",
        "clearingBroker": "0005",
        "brokerName": "DRW SECURITIES, L.L.C.                                                "
    },
    {
        "type": "OTC",
        "mpid": "DRWW",
        "clearingBroker": "8199",
        "brokerName": "DRIVEWEALTH, LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "DRXL",
        "clearingBroker": "0443",
        "brokerName": "DREXEL HAMILTON, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "DSEC",
        "clearingBroker": "8199",
        "brokerName": "DOMINARI SECURITIES LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "DSGG",
        "clearingBroker": "0226",
        "brokerName": "DMG SECURITIES, INC.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "DSIO",
        "clearingBroker": "0551",
        "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "DSNG",
        "clearingBroker": "0695",
        "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "DTEX",
        "clearingBroker": "0235",
        "brokerName": "INSTITUTIONAL SECURITIES CORPORATION                                  "
    },
    {
        "type": "OTC",
        "mpid": "DTTX",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "DUST",
        "clearingBroker": "0161",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "DVEQ",
        "clearingBroker": "0695",
        "brokerName": "DV EQUITIES                                                           "
    },
    {
        "type": "OTC",
        "mpid": "DVES",
        "clearingBroker": "0005",
        "brokerName": "DV EQUITIES                                                           "
    },
    {
        "type": "OTC",
        "mpid": "DWEL",
        "clearingBroker": "3856",
        "brokerName": "DRIVEWEALTH, LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "DWEQ",
        "clearingBroker": "0695",
        "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "DWIZ",
        "clearingBroker": "0235",
        "brokerName": "DRIVEWEALTH INSTITUTIONAL LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "DWLY",
        "clearingBroker": "2402",
        "brokerName": "DRIVELOYALTY                                                          "
    },
    {
        "type": "OTC",
        "mpid": "DXXX",
        "clearingBroker": "8604",
        "brokerName": "DTC/NSCC FTS TEST ACCOUNT #4                                          "
    },
    {
        "type": "OTC",
        "mpid": "EAMC",
        "clearingBroker": "0235",
        "brokerName": "EMPIRE ASSET MANAGEMENT COMPANY                                       "
    },
    {
        "type": "OTC",
        "mpid": "EAMG",
        "clearingBroker": "0235",
        "brokerName": "EMPIRE ASSET MANAGEMENT COMPANY                                       "
    },
    {
        "type": "OTC",
        "mpid": "EBKR",
        "clearingBroker": "0537",
        "brokerName": "BGC FINANCIAL INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "EBRD",
        "clearingBroker": "0103",
        "brokerName": "EARLYBIRD CAPITAL, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "EBXL",
        "clearingBroker": "0067",
        "brokerName": "KEZAR TRADING, LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "ECFI",
        "clearingBroker": "0158",
        "brokerName": "DASTA FINANCIAL, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "ECUT",
        "clearingBroker": "0100",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "EDDI",
        "clearingBroker": "0294",
        "brokerName": "EDDID SECURITIES USA INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "EDDY",
        "clearingBroker": "0294",
        "brokerName": "BOUSTEAD SECURITIES, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "EDFC",
        "clearingBroker": "0443",
        "brokerName": "E D & F MAN CAPITAL MARKETS INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "EDFI",
        "clearingBroker": "8873",
        "brokerName": "E D & F MAN CAPITAL MARKETS INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "EDFO",
        "clearingBroker": "0158",
        "brokerName": "E D & F MAN CAPITAL MARKETS INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "EDFP",
        "clearingBroker": "8873",
        "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "EDJC",
        "clearingBroker": "5012",
        "brokerName": "EDWARD JONES/CDS                                                      "
    },
    {
        "type": "OTC",
        "mpid": "EDJO",
        "clearingBroker": "0057",
        "brokerName": "EDWARD D. JONES & CO.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "EGAM",
        "clearingBroker": "0050",
        "brokerName": "BATS TRADING, INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "EGAW",
        "clearingBroker": "8199",
        "brokerName": "BATS TRADING, INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "EGLE",
        "clearingBroker": "1043",
        "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
    },
    {
        "type": "OTC",
        "mpid": "EGXM",
        "clearingBroker": "0050",
        "brokerName": "BATS TRADING, INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "EGXW",
        "clearingBroker": "8199",
        "brokerName": "BATS TRADING, INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "ELEQ",
        "clearingBroker": "0551",
        "brokerName": "ELEQUIN SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "ELET",
        "clearingBroker": "0388",
        "brokerName": "ELECTRONIFIE SECURITIES LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "ELEV",
        "clearingBroker": "0235",
        "brokerName": "ELEVATION, LLC                                                        "
    },
    {
        "type": "OTC",
        "mpid": "EMOC",
        "clearingBroker": "0750",
        "brokerName": "E. MAGNUS OPPENHIEM & CO. INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "ENTR",
        "clearingBroker": "0235",
        "brokerName": "ENTRUSTODY FINANCIAL, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "EQHA",
        "clearingBroker": "0075",
        "brokerName": "EQUITABLE ADVISORS, LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "EQSV",
        "clearingBroker": "0226",
        "brokerName": "EQUITY SERVICES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "EROP",
        "clearingBroker": "0158",
        "brokerName": "EROOM SECURITIES L.L.C.                                               "
    },
    {
        "type": "OTC",
        "mpid": "ESBD",
        "clearingBroker": "0235",
        "brokerName": "EASTDIL SECURED ADVISORS LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "ESGT",
        "clearingBroker": "0294",
        "brokerName": "EASTGATE SECURITIES, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "ESPD",
        "clearingBroker": "0696",
        "brokerName": "CANTOR FITZGERALD & CO.                                               "
    },
    {
        "type": "OTC",
        "mpid": "ETBE",
        "clearingBroker": "9132",
        "brokerName": "CLEAR STREET LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "ETCB",
        "clearingBroker": "3505",
        "brokerName": "ETC BROKERAGE SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "ETCL",
        "clearingBroker": "0015",
        "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "ETDX",
        "clearingBroker": "9132",
        "brokerName": "CLEAR STREET LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "ETEJ",
        "clearingBroker": "9132",
        "brokerName": "CLEAR STREET LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "ETFU",
        "clearingBroker": "9132",
        "brokerName": "CLEAR STREET LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "ETMM",
        "clearingBroker": "0005",
        "brokerName": "G1 EXECUTION SERVICES, LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "ETOR",
        "clearingBroker": "0158",
        "brokerName": "ETORO USA SECURITIES INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "ETRF",
        "clearingBroker": "0161",
        "brokerName": "G1 EXECUTION SERVICES, LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "ETRS",
        "clearingBroker": "0015",
        "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "EWMX",
        "clearingBroker": "0279",
        "brokerName": "EAST WEST MARKETS, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "EXTF",
        "clearingBroker": "0534",
        "brokerName": "WYNSTON HILL CAPITAL, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "EZOP",
        "clearingBroker": "0158",
        "brokerName": "OPTIONSHOUSE, INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "FALC",
        "clearingBroker": "0103",
        "brokerName": "FALCON SQUARE CAPITAL, LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "FARA",
        "clearingBroker": "8199",
        "brokerName": "FARINA & ASSOCIATES, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "FATS",
        "clearingBroker": "0443",
        "brokerName": "FIRST BROKERS SECURITIES LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "FBLM",
        "clearingBroker": "0235",
        "brokerName": "FBL MARKETING SERVICES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "FBLT",
        "clearingBroker": "8199",
        "brokerName": "FIRST BALLANTYNE, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "FBNS",
        "clearingBroker": "0235",
        "brokerName": "FBN SECURITIES, INC.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "FBPC",
        "clearingBroker": "0443",
        "brokerName": "CREDIT SUISSE SECURITIES (USA) LLC                                    "
    },
    {
        "type": "OTC",
        "mpid": "FBSB",
        "clearingBroker": "0280",
        "brokerName": "U.S. BANCORP INVESTMENTS, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "FCCP",
        "clearingBroker": "0141",
        "brokerName": "WELLS FARGO CLEARING SERVICES, LLC                                    "
    },
    {
        "type": "OTC",
        "mpid": "FCML",
        "clearingBroker": "0279",
        "brokerName": "FNBB CAPITAL MARKETS, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "FCMP",
        "clearingBroker": "0595",
        "brokerName": "PRIME EXECUTIONS, INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "FCST",
        "clearingBroker": "0443",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "FDMI",
        "clearingBroker": "0571",
        "brokerName": "FREEDOM INVESTMENTS, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "FDSC",
        "clearingBroker": "0158",
        "brokerName": "1ST DISCOUNT BROKERAGE INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "FDSI",
        "clearingBroker": "0141",
        "brokerName": "FIRST DALLAS SECURITIES, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "FEDR",
        "clearingBroker": "0235",
        "brokerName": "FEDERATED SECURITIES INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "FENV",
        "clearingBroker": "0294",
        "brokerName": "FENIX SECURITIES, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "FENX",
        "clearingBroker": "0595",
        "brokerName": "FENIX SECURITIES, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "FFCM",
        "clearingBroker": "0235",
        "brokerName": "FOREFRONT CAPITAL MARKETS LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "FFGI",
        "clearingBroker": "0235",
        "brokerName": "FELDSTEIN FINANCIAL GROUP, LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "FFSI",
        "clearingBroker": "0158",
        "brokerName": "FIRSTRADE SECURITIES INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "FGIC",
        "clearingBroker": "0534",
        "brokerName": "FINANCORP GROUP INTERNATIONAL CORPORATION                             "
    },
    {
        "type": "OTC",
        "mpid": "FGOE",
        "clearingBroker": "0226",
        "brokerName": "FIRST GEORGETOWN SECURITIES, INC.                                     "
    },
    {
        "type": "OTC",
        "mpid": "FHON",
        "clearingBroker": "0235",
        "brokerName": "FIRST HONOLULU SECURITIES INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "FIBS",
        "clearingBroker": "0226",
        "brokerName": "FIDELITY BROKERAGE SERVICES LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "FIDT",
        "clearingBroker": "5040",
        "brokerName": "FIDELITY CLEARING CANADA ULC/CDS                                      "
    },
    {
        "type": "OTC",
        "mpid": "FISA",
        "clearingBroker": "0443",
        "brokerName": "ADVISORS ASSET MANAGEMENT, INC.                                       "
    },
    {
        "type": "OTC",
        "mpid": "FISH",
        "clearingBroker": "0235",
        "brokerName": "L.B. FISHER & COMPANY                                                 "
    },
    {
        "type": "OTC",
        "mpid": "FJRF",
        "clearingBroker": "0052",
        "brokerName": "PARITER SECURITIES, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "FKSC",
        "clearingBroker": "0235",
        "brokerName": "FIRST KENTUCKY SECURITIES CORP.                                       "
    },
    {
        "type": "OTC",
        "mpid": "FLAT",
        "clearingBroker": "0226",
        "brokerName": "FLORIDA ATLANTIC SECURITIES CORP.                                     "
    },
    {
        "type": "OTC",
        "mpid": "FLEX",
        "clearingBroker": "0158",
        "brokerName": "GWM GROUP, INC.                                                       "
    },
    {
        "type": "OTC",
        "mpid": "FLIB",
        "clearingBroker": "0235",
        "brokerName": "FIRST LIBERTIES FINANCIAL                                             "
    },
    {
        "type": "OTC",
        "mpid": "FLIO",
        "clearingBroker": "0158",
        "brokerName": "SANTOS CAPITAL GROUP, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "FLTG",
        "clearingBroker": "0005",
        "brokerName": "FLOW TRADERS U.S. LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "FLTL",
        "clearingBroker": "0235",
        "brokerName": "FELTL & COMPANY                                                       "
    },
    {
        "type": "OTC",
        "mpid": "FLTU",
        "clearingBroker": "0551",
        "brokerName": "FLOW TRADERS U.S. LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "FLWT",
        "clearingBroker": "0161",
        "brokerName": "FLOW TRADERS U.S. INSTITUTIONAL TRADING LLC                           "
    },
    {
        "type": "OTC",
        "mpid": "FMAF",
        "clearingBroker": "5008",
        "brokerName": "NBCN INC./CDS                                                         "
    },
    {
        "type": "OTC",
        "mpid": "FMAT",
        "clearingBroker": "0608",
        "brokerName": "SG AMERICAS SECURITIES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "FMCO",
        "clearingBroker": "0443",
        "brokerName": "FIRST MANHATTAN CO.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "FMEX",
        "clearingBroker": "0750",
        "brokerName": "FINAMEX INTERNATIONAL, LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "FMGF",
        "clearingBroker": "0695",
        "brokerName": "ABN AMRO CLEARING CHICAGO LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "FMNC",
        "clearingBroker": "0226",
        "brokerName": "FMN CAPITAL CORPORATION                                               "
    },
    {
        "type": "OTC",
        "mpid": "FNBR",
        "clearingBroker": "0728",
        "brokerName": "FOLIOFN INVESTMENTS, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "FNET",
        "clearingBroker": "0141",
        "brokerName": "WACHOVIA SECURITIES FINANCIAL NETWORK, LLC                            "
    },
    {
        "type": "OTC",
        "mpid": "FNFD",
        "clearingBroker": "0443",
        "brokerName": "FOLGER NOLAN FLEMING DOUGLAS INCORPORATED                             "
    },
    {
        "type": "OTC",
        "mpid": "FNIC",
        "clearingBroker": "0443",
        "brokerName": "FINANCIAL NETWORK INVESTMENT CORP.                                    "
    },
    {
        "type": "OTC",
        "mpid": "FNNL",
        "clearingBroker": "0158",
        "brokerName": "FENNEL                                                                "
    },
    {
        "type": "OTC",
        "mpid": "FNSJ",
        "clearingBroker": "0443",
        "brokerName": "FINANCIAL NORTHEASTERN SECURITIES, INC.                               "
    },
    {
        "type": "OTC",
        "mpid": "FNTN",
        "clearingBroker": "0158",
        "brokerName": "FINTRON INVEST                                                        "
    },
    {
        "type": "OTC",
        "mpid": "FNXE",
        "clearingBroker": "0158",
        "brokerName": "FENIX SECURITIES, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "FNXS",
        "clearingBroker": "0750",
        "brokerName": "FENIX SECURITIES, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "FOGS",
        "clearingBroker": "0235",
        "brokerName": "FOG EQUITIES LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "FORI",
        "clearingBroker": "0750",
        "brokerName": "FORTREND SECURITIES, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "FORS",
        "clearingBroker": "0158",
        "brokerName": "FORIS CAPITAL US LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "FRAC",
        "clearingBroker": "4305",
        "brokerName": "ATOMIC VAULTS SECURITIES, LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "FRCE",
        "clearingBroker": "2402",
        "brokerName": "FIN2                                                                  "
    },
    {
        "type": "OTC",
        "mpid": "FREC",
        "clearingBroker": "0158",
        "brokerName": "FREC SECURITIES LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "FRKS",
        "clearingBroker": "0294",
        "brokerName": "FARKAS CAPITAL                                                        "
    },
    {
        "type": "OTC",
        "mpid": "FRSO",
        "clearingBroker": "0534",
        "brokerName": "FIRST OMEGA, LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "FRTN",
        "clearingBroker": "0103",
        "brokerName": "FORTUNE SECURITIES, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "FRTS",
        "clearingBroker": "0534",
        "brokerName": "FORTRESS PRIVATE LEDGER, LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "FSRP",
        "clearingBroker": "0443",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "FTBR",
        "clearingBroker": "0728",
        "brokerName": "FOLIO INVESTMENTS, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "FTEN",
        "clearingBroker": "0226",
        "brokerName": "FTB ADVISORS, INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "FTIT",
        "clearingBroker": "0005",
        "brokerName": "FLOW TRADERS U.S. INSTITUTIONAL TRADING LLC                           "
    },
    {
        "type": "OTC",
        "mpid": "FTLP",
        "clearingBroker": "8244",
        "brokerName": "FIRST TRUST PORTFOLIOS, L.P.                                          "
    },
    {
        "type": "OTC",
        "mpid": "FTRD",
        "clearingBroker": "0161",
        "brokerName": "FLOW TRADERS U.S. LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "FTSC",
        "clearingBroker": "0202",
        "brokerName": "FHN FINANCIAL SECURITIES CORP.                                        "
    },
    {
        "type": "OTC",
        "mpid": "FTSR",
        "clearingBroker": "0226",
        "brokerName": "FIFTH THIRD SECURITIES, INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "FUTA",
        "clearingBroker": "4272",
        "brokerName": "FUTU CLEARING INC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "FUTC",
        "clearingBroker": "4272",
        "brokerName": "FUTU CLEARING INC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "FUTG",
        "clearingBroker": "4272",
        "brokerName": "FUTU CLEARING INC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "FUTI",
        "clearingBroker": "4272",
        "brokerName": "FUTU INC                                                              "
    },
    {
        "type": "OTC",
        "mpid": "FUTJ",
        "clearingBroker": "4272",
        "brokerName": "FUTU CLEARING INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "FUTM",
        "clearingBroker": "4272",
        "brokerName": "FUTU CLEARING INC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "FUTU",
        "clearingBroker": "0534",
        "brokerName": "FUTU INC                                                              "
    },
    {
        "type": "OTC",
        "mpid": "FWSI",
        "clearingBroker": "0141",
        "brokerName": "FIRST WESTERN SECURITIES, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "GABE",
        "clearingBroker": "0534",
        "brokerName": "G. RESEARCH, INC.                                                     "
    },
    {
        "type": "OTC",
        "mpid": "GAFI",
        "clearingBroker": "0235",
        "brokerName": "GARDNER FINANCIAL SERVICES INC.                                       "
    },
    {
        "type": "OTC",
        "mpid": "GAGN",
        "clearingBroker": "0226",
        "brokerName": "GAGNON SECURITIES, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "GALX",
        "clearingBroker": "0534",
        "brokerName": "GALAXY SECURITIES, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "GARB",
        "clearingBroker": "0148",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC                                   "
    },
    {
        "type": "OTC",
        "mpid": "GARC",
        "clearingBroker": "0161",
        "brokerName": "ICAP CORPORATES LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "GARR",
        "clearingBroker": "0226",
        "brokerName": "GARRETT NAGLE & CO., INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "GARW",
        "clearingBroker": "0595",
        "brokerName": "GAR WOOD SECURITIES, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "GATE",
        "clearingBroker": "0505",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "GBMT",
        "clearingBroker": "0443",
        "brokerName": "GBM INTERNATIONAL, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "GBTS",
        "clearingBroker": "0005",
        "brokerName": "GTS SECURITIES, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "GDOC",
        "clearingBroker": "0551",
        "brokerName": "DRW EXECUTION SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "GEBB",
        "clearingBroker": "0551",
        "brokerName": "GLOBAL EXECUTION BROKERS, LP                                          "
    },
    {
        "type": "OTC",
        "mpid": "GELB",
        "clearingBroker": "0005",
        "brokerName": "GELBER SECURITIES, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "GELP",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "GENS",
        "clearingBroker": "0279",
        "brokerName": "GENERAL SECURITIES CORP                                               "
    },
    {
        "type": "OTC",
        "mpid": "GENW",
        "clearingBroker": "0226",
        "brokerName": "GENEOS WEALTH MANAGEMENT, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "GETS",
        "clearingBroker": "0295",
        "brokerName": "GETCO SECURITIES, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "GFIG",
        "clearingBroker": "0537",
        "brokerName": "GFI SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "GFIS",
        "clearingBroker": "0005",
        "brokerName": "GFI SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "GFLO",
        "clearingBroker": "0443",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "GFRY",
        "clearingBroker": "0695",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "GFYC",
        "clearingBroker": "0438",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "GHCC",
        "clearingBroker": "0226",
        "brokerName": "GORDON, HASKETT CAPITAL CORPORATION                                   "
    },
    {
        "type": "OTC",
        "mpid": "GILG",
        "clearingBroker": "0226",
        "brokerName": "GILDER GAGNON HOWE & CO. LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "GJSS",
        "clearingBroker": "0235",
        "brokerName": "SCHWARTZ, GREGORY J & CO. INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "GLED",
        "clearingBroker": "0283",
        "brokerName": "GLENDALE SECURITIES, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "GLII",
        "clearingBroker": "5005",
        "brokerName": "TD SECURITIES INC./CDS                                                "
    },
    {
        "type": "OTC",
        "mpid": "GLIP",
        "clearingBroker": "5062",
        "brokerName": "TD SECURITIES INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "GLIR",
        "clearingBroker": "5021",
        "brokerName": "TD WATERHOUSE CANADA INC. #5/CDS                                      "
    },
    {
        "type": "OTC",
        "mpid": "GLIS",
        "clearingBroker": "5036",
        "brokerName": "TD WATERHOUSE CANADA INC./CDS                                         "
    },
    {
        "type": "OTC",
        "mpid": "GLLL",
        "clearingBroker": "0279",
        "brokerName": "GILL CAPITAL PARTNERS                                                 "
    },
    {
        "type": "OTC",
        "mpid": "GLPX",
        "clearingBroker": "9132",
        "brokerName": "ACS EXECUTION SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "GLTV",
        "clearingBroker": "0294",
        "brokerName": "GTS SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "GMSE",
        "clearingBroker": "0750",
        "brokerName": "GAMMA SECURITIES, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "GMSG",
        "clearingBroker": "0443",
        "brokerName": "GMS GROUP (THE), L.L.C.                                               "
    },
    {
        "type": "OTC",
        "mpid": "GONE",
        "clearingBroker": "0551",
        "brokerName": "GROUP ONE TRADING, L.P.                                               "
    },
    {
        "type": "OTC",
        "mpid": "GPCA",
        "clearingBroker": "0235",
        "brokerName": "GREAT POINT CAPITAL LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "GPCE",
        "clearingBroker": "9132",
        "brokerName": "CLEAR STREET LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "GPCW",
        "clearingBroker": "8199",
        "brokerName": "GREAT POINT CAPITAL LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "GPSA",
        "clearingBroker": "0294",
        "brokerName": "GLOBAL PACIFIC SECURITIES US, INC.                                    "
    },
    {
        "type": "OTC",
        "mpid": "GPSS",
        "clearingBroker": "0443",
        "brokerName": "GREAT PACIFIC SECURITIES                                              "
    },
    {
        "type": "OTC",
        "mpid": "GPTG",
        "clearingBroker": "0534",
        "brokerName": "SMITH CAPITAL MARKETS, LLC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "GRAD",
        "clearingBroker": "0235",
        "brokerName": "GRADIENT SECURITIES, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "GRBD",
        "clearingBroker": "0052",
        "brokerName": "GREENBIRD CAPITAL LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "GRFN",
        "clearingBroker": "0103",
        "brokerName": "GRIFFIN FINANCIAL GROUP, LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "GRIL",
        "clearingBroker": "0235",
        "brokerName": "GLOBAL RESOURCE INVESTMENTS, LTD.                                     "
    },
    {
        "type": "OTC",
        "mpid": "GROD",
        "clearingBroker": "0226",
        "brokerName": "GRODSKY ASSOCIATES, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "GRPS",
        "clearingBroker": "0226",
        "brokerName": "MML INVESTORS SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "GRWD",
        "clearingBroker": "0052",
        "brokerName": "GAR WOOD SECURITIES, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "GSBI",
        "clearingBroker": "0279",
        "brokerName": "GLOBAL BROKERAGE SERVICES, INC.                                       "
    },
    {
        "type": "OTC",
        "mpid": "GSCO",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "GSCS",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "GSFS",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "GSIB",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "GSLM",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "GSLT",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "GSLZ",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "GSMM",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "GSQQ",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "GSSC",
        "clearingBroker": "0161",
        "brokerName": "GEORGESON SHAREHOLDER SECURITIES CORP.                                "
    },
    {
        "type": "OTC",
        "mpid": "GSSI",
        "clearingBroker": "0052",
        "brokerName": "GARDEN STATE SECURITIES, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "GSUU",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "GSVV",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "GSWW",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "GSXX",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "GSYY",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "GSZZ",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "GTBY",
        "clearingBroker": "0158",
        "brokerName": "GATSBY SECURITIES, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "GTEX",
        "clearingBroker": "0005",
        "brokerName": "GTS EXECUTION SERVICES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "GTNA",
        "clearingBroker": "0294",
        "brokerName": "GTN AMERICAS FINANCIAL SERVICES INC                                   "
    },
    {
        "type": "OTC",
        "mpid": "GTNB",
        "clearingBroker": "0595",
        "brokerName": "GTN AMERICAS FINANCIAL SERVICES, INC.                                 "
    },
    {
        "type": "OTC",
        "mpid": "GTNC",
        "clearingBroker": "9132",
        "brokerName": "GTN AMERICAS FINANCIAL SERVICES INC.                                  "
    },
    {
        "type": "OTC",
        "mpid": "GTSB",
        "clearingBroker": "0005",
        "brokerName": "GTS SECURITIES, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "GTSM",
        "clearingBroker": "0005",
        "brokerName": "GTS SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "GTSW",
        "clearingBroker": "0005",
        "brokerName": "GTS SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "GTSY",
        "clearingBroker": "0005",
        "brokerName": "GTS SECURITIES, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "GTSZ",
        "clearingBroker": "0005",
        "brokerName": "GTS SECURITIES, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "GTTX",
        "clearingBroker": "0695",
        "brokerName": "ABN AMRO CLEARING CHICAGO LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "GUGI",
        "clearingBroker": "0526",
        "brokerName": "GUGGENHEIM FUNDS DISTRIBUTORS, LLC                                    "
    },
    {
        "type": "OTC",
        "mpid": "GUGS",
        "clearingBroker": "0443",
        "brokerName": "GUGGENHEIM SECURITIES, LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "GWDS",
        "clearingBroker": "0534",
        "brokerName": "GAR WOOD SECURITIES, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "GWNS",
        "clearingBroker": "0226",
        "brokerName": "GWN SECURITIES INC.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "GZML",
        "clearingBroker": "0161",
        "brokerName": "GUZMAN & COMPANY                                                      "
    },
    {
        "type": "OTC",
        "mpid": "HACA",
        "clearingBroker": "0701",
        "brokerName": "HARVEST CAPITAL LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "HAFS",
        "clearingBroker": "0279",
        "brokerName": "HANTZ FINANCIAL SERVICES, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "HALA",
        "clearingBroker": "0534",
        "brokerName": "HALIFAX AMERICA LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "HALO",
        "clearingBroker": "0235",
        "brokerName": "HALO SECURITIES, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "HAPI",
        "clearingBroker": "0158",
        "brokerName": "HAPI                                                                  "
    },
    {
        "type": "OTC",
        "mpid": "HAPX",
        "clearingBroker": "0551",
        "brokerName": "HAP TRADING, LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "HARC",
        "clearingBroker": "0235",
        "brokerName": "HARLEY CAPITAL LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "HARS",
        "clearingBroker": "8199",
        "brokerName": "HARVESTONS SECURITIES, INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "HASF",
        "clearingBroker": "5058",
        "brokerName": "HAYWOOD SECURITIES INC./ CDS                                          "
    },
    {
        "type": "OTC",
        "mpid": "HAVK",
        "clearingBroker": "0235",
        "brokerName": "EMPIRE STATE FINANCIAL, INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "HAZL",
        "clearingBroker": "0226",
        "brokerName": "HAZLETT, BURT AND WATSON, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "HBCA",
        "clearingBroker": "0430",
        "brokerName": "HOLD BROTHERS CAPITAL LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "HBCL",
        "clearingBroker": "0430",
        "brokerName": "HOLD BROTHERS CAPITAL LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "HBIF",
        "clearingBroker": "0695",
        "brokerName": "DRW SECURITIES, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "HBIW",
        "clearingBroker": "0695",
        "brokerName": "DRW SECURITIES, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "HCGC",
        "clearingBroker": "0103",
        "brokerName": "FALCON SQUARE CAPITAL, LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "HCMX",
        "clearingBroker": "0235",
        "brokerName": "HOOPOE CAPITAL MARKETS, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "HCTA",
        "clearingBroker": "0005",
        "brokerName": "PEAK6 CAPITAL MANAGEMENT LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "HCWW",
        "clearingBroker": "0235",
        "brokerName": "H.C.WAINWRIGHT & CO., LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "HDVS",
        "clearingBroker": "0226",
        "brokerName": "AVANTAX INVESTMENT SERVICES, INC.                                     "
    },
    {
        "type": "OTC",
        "mpid": "HEAD",
        "clearingBroker": "0443",
        "brokerName": "TD SECURITIES AUTOMATED TRADING LLC                                   "
    },
    {
        "type": "OTC",
        "mpid": "HEDG",
        "clearingBroker": "0158",
        "brokerName": "HEDGE PRO LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "HENN",
        "clearingBroker": "0235",
        "brokerName": "CARL M. HENNIG, INC.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "HENY",
        "clearingBroker": "0443",
        "brokerName": "HENLEY & COMPANY LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "HFLD",
        "clearingBroker": "0279",
        "brokerName": "HARTFIELD, TITUS & DONNELLY, LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "HIGG",
        "clearingBroker": "0235",
        "brokerName": "HIGGINS CAPITAL MANAGEMENT, INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "HNTR",
        "clearingBroker": "0443",
        "brokerName": "HUNTER ASSOCIATES, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "HOLD",
        "clearingBroker": "0430",
        "brokerName": "HOLD BROTHERS CAPITAL LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "HONR",
        "clearingBroker": "0235",
        "brokerName": "ROBERTS & RYAN INVESTMENTS INC.                                       "
    },
    {
        "type": "OTC",
        "mpid": "HOOD",
        "clearingBroker": "6769",
        "brokerName": "ROBINHOOD SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "HOPK",
        "clearingBroker": "0750",
        "brokerName": "SILVER OAK SECURITIES, INCORPORATED                                   "
    },
    {
        "type": "OTC",
        "mpid": "HORW",
        "clearingBroker": "0534",
        "brokerName": "INSIGHT SECURITIES, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "HOVD",
        "clearingBroker": "0103",
        "brokerName": "HOVDE GROUP, LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "HPOM",
        "clearingBroker": "0235",
        "brokerName": "HERNDON PLANT OAKLEY, LTD.                                            "
    },
    {
        "type": "OTC",
        "mpid": "HPSR",
        "clearingBroker": "0534",
        "brokerName": "HEWLETT POINT SECURITIES, LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "HRBF",
        "clearingBroker": "0756",
        "brokerName": "AMERICAN ENTERPRISE INVESTMENT SERVICES INC.                          "
    },
    {
        "type": "OTC",
        "mpid": "HRGR",
        "clearingBroker": "0235",
        "brokerName": "HARGER AND COMPANY, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "HRTB",
        "clearingBroker": "0551",
        "brokerName": "HRT FINANCIAL LP                                                      "
    },
    {
        "type": "OTC",
        "mpid": "HRTF",
        "clearingBroker": "0369",
        "brokerName": "HRT FINANCIAL LP                                                      "
    },
    {
        "type": "OTC",
        "mpid": "HRTW",
        "clearingBroker": "0369",
        "brokerName": "HRT FINANCIAL LP                                                      "
    },
    {
        "type": "OTC",
        "mpid": "HRTX",
        "clearingBroker": "0369",
        "brokerName": "HRT EXECUTION SERVICES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "HSAC",
        "clearingBroker": "0158",
        "brokerName": "KBFG SECURITIES AMERICA INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "HSAI",
        "clearingBroker": "0443",
        "brokerName": "INDEPENDENT FINANCIAL GROUP, LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "HSBC",
        "clearingBroker": "0816",
        "brokerName": "HSBC SECURITIES (USA), INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "HSBK",
        "clearingBroker": "0816",
        "brokerName": "HSBC SECURITIES (USA) INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "HTCM",
        "clearingBroker": "0235",
        "brokerName": "HOWDEN TIGER CAPITAL MARKETS & ADVISOF LLC                            "
    },
    {
        "type": "OTC",
        "mpid": "HTIS",
        "clearingBroker": "0443",
        "brokerName": "HAITONG INTERNATIONAL SECURITIES (USA) INC.                           "
    },
    {
        "type": "OTC",
        "mpid": "HTSC",
        "clearingBroker": "0750",
        "brokerName": "HUATAI SECURITIES (USA), INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "HTWR",
        "clearingBroker": "0226",
        "brokerName": "HIGHTOWER SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "HUCO",
        "clearingBroker": "0226",
        "brokerName": "HUNTINGTON INVESTMENT COMPANY                                         "
    },
    {
        "type": "OTC",
        "mpid": "HUNT",
        "clearingBroker": "0141",
        "brokerName": "HUNTLEIGH SECURITIES CORPORATION                                      "
    },
    {
        "type": "OTC",
        "mpid": "HWJC",
        "clearingBroker": "0052",
        "brokerName": "HWJ CAPITAL PARTNERS II, LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "HWLS",
        "clearingBroker": "0443",
        "brokerName": "M.S. HOWELLS & CO.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "HYSI",
        "clearingBroker": "0226",
        "brokerName": "HEIM, YOUNG & ASSOCIATES, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "IAAK",
        "clearingBroker": "0279",
        "brokerName": "ISAAK BOND INVESTMENT, INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "IAEA",
        "clearingBroker": "0294",
        "brokerName": "SRT SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "IAEW",
        "clearingBroker": "0595",
        "brokerName": "SRT SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "IAEX",
        "clearingBroker": "0235",
        "brokerName": "SRT SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "IATS",
        "clearingBroker": "0017",
        "brokerName": "INTERACTIVE BROKERS LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "IBCO",
        "clearingBroker": "0534",
        "brokerName": "INTERACTIVE BROKERS CORP.                                             "
    },
    {
        "type": "OTC",
        "mpid": "IBFS",
        "clearingBroker": "0824",
        "brokerName": "INDUSTRIAL AND COMMERCIAL BANK OF CHINA FINANCIAL SERVICES LLC        "
    },
    {
        "type": "OTC",
        "mpid": "IBKR",
        "clearingBroker": "0534",
        "brokerName": "INTERACTIVE BROKERS LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "IBND",
        "clearingBroker": "0103",
        "brokerName": "INSTITUTIONAL BOND NETWORK, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "IBPR",
        "clearingBroker": "0052",
        "brokerName": "IB CAPITAL LLC                                                        "
    },
    {
        "type": "OTC",
        "mpid": "IBSH",
        "clearingBroker": "0595",
        "brokerName": "INTEGRITY BROKERAGE SERVICES, INC.                                    "
    },
    {
        "type": "OTC",
        "mpid": "IBSJ",
        "clearingBroker": "0052",
        "brokerName": "INTEGRITY BROKERAGE SERVICES, INC.                                    "
    },
    {
        "type": "OTC",
        "mpid": "ICAN",
        "clearingBroker": "0226",
        "brokerName": "CETERA ADVISOR NETWORKS LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "ICBC",
        "clearingBroker": "0824",
        "brokerName": "INDUSTRIAL AND COMMERCIAL BANK OF CHINA FINANCIAL                     "
    },
    {
        "type": "OTC",
        "mpid": "ICBK",
        "clearingBroker": "0388",
        "brokerName": "INDUSTRIAL AND COMMERCIAL BANK OF CHINA FINANCIAL SERVICES LLC        "
    },
    {
        "type": "OTC",
        "mpid": "ICBX",
        "clearingBroker": "0067",
        "brokerName": "INSTINET, LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "ICCP",
        "clearingBroker": "0443",
        "brokerName": "INVESTORS CAPITAL CORPORATION                                         "
    },
    {
        "type": "OTC",
        "mpid": "ICDS",
        "clearingBroker": "0750",
        "brokerName": "ICD SECURITIES                                                        "
    },
    {
        "type": "OTC",
        "mpid": "ICFS",
        "clearingBroker": "0534",
        "brokerName": "INTERCAROLINA FINANCIAL SERVICES, INC.                                "
    },
    {
        "type": "OTC",
        "mpid": "ICMH",
        "clearingBroker": "0235",
        "brokerName": "INSTITUTIONAL CAPITAL MANAGEMENT, INC.                                "
    },
    {
        "type": "OTC",
        "mpid": "ICON",
        "clearingBroker": "0595",
        "brokerName": "ICON CAPITAL GROUP, LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "ICRD",
        "clearingBroker": "0551",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "ICVT",
        "clearingBroker": "8430",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "IDAY",
        "clearingBroker": "0103",
        "brokerName": "BROKERAGESELECT                                                       "
    },
    {
        "type": "OTC",
        "mpid": "IELP",
        "clearingBroker": "8430",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "IEOS",
        "clearingBroker": "0534",
        "brokerName": "INTERACTIVE BROKERS LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "IEQY",
        "clearingBroker": "0551",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "IESI",
        "clearingBroker": "0443",
        "brokerName": "ITAU EUROPA SECURITIES INC                                            "
    },
    {
        "type": "OTC",
        "mpid": "IEXG",
        "clearingBroker": "0161",
        "brokerName": "IEX SERVICES, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "IFCS",
        "clearingBroker": "0161",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "ILND",
        "clearingBroker": "0520",
        "brokerName": "NASDAQ EXECUTION SERVICES, LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "ILNK",
        "clearingBroker": "0750",
        "brokerName": "INVESTORLINK CAPITAL MARKETS, LLC                                     "
    },
    {
        "type": "OTC",
        "mpid": "IMAB",
        "clearingBroker": "0695",
        "brokerName": "IMC-CHICAGO, LLC, IMC FINANCIAL MARKETS                               "
    },
    {
        "type": "OTC",
        "mpid": "IMCC",
        "clearingBroker": "0005",
        "brokerName": "IMC FINANCIAL MARKETS                                                 "
    },
    {
        "type": "OTC",
        "mpid": "IMCS",
        "clearingBroker": "0005",
        "brokerName": "IMC FINANCIAL MARKETS                                                 "
    },
    {
        "type": "OTC",
        "mpid": "IMCX",
        "clearingBroker": "0005",
        "brokerName": "IMC EXECUTION SERVICES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "IMMG",
        "clearingBroker": "0226",
        "brokerName": "INTERNATIONAL MONEY MANAGEMENT GROUP, INC.                            "
    },
    {
        "type": "OTC",
        "mpid": "IMPC",
        "clearingBroker": "0443",
        "brokerName": "IMPERIAL CAPITAL, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "IMSE",
        "clearingBroker": "0695",
        "brokerName": "IMC SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "INAB",
        "clearingBroker": "0695",
        "brokerName": "INSTINET, LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "INAM",
        "clearingBroker": "0695",
        "brokerName": "INSTINET, LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "INCA",
        "clearingBroker": "0067",
        "brokerName": "INSTINET, LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "INCE",
        "clearingBroker": "0067",
        "brokerName": "INSTINET, LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "INCR",
        "clearingBroker": "0067",
        "brokerName": "INTELLIGENT CROSS LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "INCV",
        "clearingBroker": "0294",
        "brokerName": "INSTINET, LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "INCW",
        "clearingBroker": "0294",
        "brokerName": "INSTINET, LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "INCX",
        "clearingBroker": "9132",
        "brokerName": "INSTINET, LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "INCY",
        "clearingBroker": "9132",
        "brokerName": "INSTINET, LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "INDB",
        "clearingBroker": "0067",
        "brokerName": "INSTINET, LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "INDX",
        "clearingBroker": "0158",
        "brokerName": "LINDEN THOMAS AND COMPANY SECURITIES, LLC                             "
    },
    {
        "type": "OTC",
        "mpid": "INDY",
        "clearingBroker": "0695",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "INET",
        "clearingBroker": "0568",
        "brokerName": "NADAQ EXECUTION SERVICES, LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "INFI",
        "clearingBroker": "0279",
        "brokerName": "INTEGRAL FINANCIAL, LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "INFX",
        "clearingBroker": "9132",
        "brokerName": "CLEAR STREET LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "INGF",
        "clearingBroker": "0270",
        "brokerName": "ING FINANCIAL MARKETS LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "INGS",
        "clearingBroker": "0124",
        "brokerName": "INGALLS & SNYDER, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "INJX",
        "clearingBroker": "0536",
        "brokerName": "INSTINET, LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "INNO",
        "clearingBroker": "0052",
        "brokerName": "ETC BROKERAGE SERVICES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "INPI",
        "clearingBroker": "0235",
        "brokerName": "INVESTMENT PLANNERS INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "INPS",
        "clearingBroker": "0235",
        "brokerName": "INDEPENDENCE POINT SECURITIES LLC                                     "
    },
    {
        "type": "OTC",
        "mpid": "INSR",
        "clearingBroker": "0067",
        "brokerName": "INTELLIGENT CROSS LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "INTB",
        "clearingBroker": "0158",
        "brokerName": "INTER&CO SECURITIES LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "INTL",
        "clearingBroker": "0161",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "INTW",
        "clearingBroker": "0067",
        "brokerName": "INSTINET, LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "INTX",
        "clearingBroker": "0235",
        "brokerName": "INTERNATIONAL ASSETS ADVISORY, LLC                                    "
    },
    {
        "type": "OTC",
        "mpid": "ISCN",
        "clearingBroker": "0235",
        "brokerName": "INSTITUTIONAL SECURITIES CORPORATION                                  "
    },
    {
        "type": "OTC",
        "mpid": "ISEY",
        "clearingBroker": "0520",
        "brokerName": "NASDAQ EXECUTION SERVICES, LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "ISIG",
        "clearingBroker": "0226",
        "brokerName": "EVERCORE GROUP L.L.C.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "ISLL",
        "clearingBroker": "0052",
        "brokerName": "INLET SECURITIES LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "ISSI",
        "clearingBroker": "0052",
        "brokerName": "INSIGHT SECURITIES, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "ITAU",
        "clearingBroker": "0443",
        "brokerName": "ITAU BBA USA SECURITIES INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "ITCC",
        "clearingBroker": "0750",
        "brokerName": "STERNE AGEE FINANCIAL SERVICES, INC.                                  "
    },
    {
        "type": "OTC",
        "mpid": "ITGI",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "ITGP",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "IURS",
        "clearingBroker": "0534",
        "brokerName": "IUR SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "IVNT",
        "clearingBroker": "0235",
        "brokerName": "INVESTMENT NETWORK, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "IVOL",
        "clearingBroker": "0235",
        "brokerName": "UNION CAPITAL COMPANY                                                 "
    },
    {
        "type": "OTC",
        "mpid": "JANE",
        "clearingBroker": "0352",
        "brokerName": "JANE STREET MARKETS, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "JANS",
        "clearingBroker": "0352",
        "brokerName": "JANE STREET MARKETS, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "JANY",
        "clearingBroker": "0374",
        "brokerName": "JANNEY MONTGOMERY SCOTT LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "JBDX",
        "clearingBroker": "0294",
        "brokerName": "JB DRAX HONORE INC.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "JBLK",
        "clearingBroker": "0019",
        "brokerName": "JEFFERIES LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "JDRB",
        "clearingBroker": "0595",
        "brokerName": "J.H. DARBIE & CO., INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "JEFF",
        "clearingBroker": "0019",
        "brokerName": "JEFFERIES LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "JEFM",
        "clearingBroker": "0235",
        "brokerName": "JEFFREY MATTHEWS FINANCIAL GROUP, L.L.C.                              "
    },
    {
        "type": "OTC",
        "mpid": "JEFX",
        "clearingBroker": "0536",
        "brokerName": "JEFFERIES EXECUTION SERVICES, INC.                                    "
    },
    {
        "type": "OTC",
        "mpid": "JEVO",
        "clearingBroker": "0235",
        "brokerName": "ATIS, INC                                                             "
    },
    {
        "type": "OTC",
        "mpid": "JEXF",
        "clearingBroker": "0536",
        "brokerName": "ABN AMRO CLEARING CHICAGO LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "JGRC",
        "clearingBroker": "0103",
        "brokerName": "JOSEPH GRACE                                                          "
    },
    {
        "type": "OTC",
        "mpid": "JGUN",
        "clearingBroker": "0235",
        "brokerName": "JOSEPH GUNNAR & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "JHDR",
        "clearingBroker": "0052",
        "brokerName": "JH DARBIE & CO. INC.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "JHYT",
        "clearingBroker": "0019",
        "brokerName": "JEFFERIES PARTNER OPPORTUNITY FUND II, LLC                            "
    },
    {
        "type": "OTC",
        "mpid": "JKFS",
        "clearingBroker": "0279",
        "brokerName": "J.K. FINANCIAL SERVICES INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "JLEQ",
        "clearingBroker": "0161",
        "brokerName": "JUMP EXECUTION, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "JMLS",
        "clearingBroker": "0235",
        "brokerName": "J.M LUMMIS SECURITIES, INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "JMPT",
        "clearingBroker": "0551",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "JMSI",
        "clearingBroker": "0374",
        "brokerName": "JANNEY MONTGOMERY SCOTT LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "JNST",
        "clearingBroker": "0352",
        "brokerName": "JANE STREET CAPITAL LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "JOHN",
        "clearingBroker": "8072",
        "brokerName": "SCOTTSDALE CAPITAL ADVISORS                                           "
    },
    {
        "type": "OTC",
        "mpid": "JONE",
        "clearingBroker": "0161",
        "brokerName": "JONESTRADING                                                          "
    },
    {
        "type": "OTC",
        "mpid": "JPBX",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "JPII",
        "clearingBroker": "0534",
        "brokerName": "JAYPEE INTERNATIONAL, INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "JPME",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "JPMG",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "JPMP",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "JPMS",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "JPMT",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "JPMX",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "JPPB",
        "clearingBroker": "0443",
        "brokerName": "JEFFERIES LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "JRCO",
        "clearingBroker": "0226",
        "brokerName": "JOHNSON RICE & COMPANY L.L.C.                                         "
    },
    {
        "type": "OTC",
        "mpid": "JSAP",
        "clearingBroker": "8497",
        "brokerName": "JANE STREET CAPITAL, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "JSBA",
        "clearingBroker": "0161",
        "brokerName": "JANE STREET CAPITAL, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "JSCA",
        "clearingBroker": "0352",
        "brokerName": "JANE STREET CAPITAL LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "JSCL",
        "clearingBroker": "0052",
        "brokerName": "JOSEPH STONE CAPITAL L.L.C.                                           "
    },
    {
        "type": "OTC",
        "mpid": "JSCO",
        "clearingBroker": "3856",
        "brokerName": "J. STREICHER & CO. L.L.C.                                             "
    },
    {
        "type": "OTC",
        "mpid": "JSCT",
        "clearingBroker": "0005",
        "brokerName": "JANE STREET CAPITAL LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "JSEB",
        "clearingBroker": "0161",
        "brokerName": "JANE STREET EXECUTION SERVICES, LLC                                   "
    },
    {
        "type": "OTC",
        "mpid": "JSEG",
        "clearingBroker": "0161",
        "brokerName": "JANE STREET EXECUTION SERVICES, LLC                                   "
    },
    {
        "type": "OTC",
        "mpid": "JSJX",
        "clearingBroker": "0352",
        "brokerName": "JANE STREET CAPITAL LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "JSML",
        "clearingBroker": "0551",
        "brokerName": "JANE STREET CAPITAL, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "JSOL",
        "clearingBroker": "0551",
        "brokerName": "JANE STREET OPTIONS, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "JSPT",
        "clearingBroker": "0352",
        "brokerName": "JANE STREET MARKETS, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "JSSC",
        "clearingBroker": "3492",
        "brokerName": "JANE STREET EXECUTION SERVICES, LLC                                   "
    },
    {
        "type": "OTC",
        "mpid": "JSSF",
        "clearingBroker": "0226",
        "brokerName": "JMP SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "JTOT",
        "clearingBroker": "0005",
        "brokerName": "JONES TRADING                                                         "
    },
    {
        "type": "OTC",
        "mpid": "JUSX",
        "clearingBroker": "3856",
        "brokerName": "JUST2TRADE, INC.                                                      "
    },
    {
        "type": "OTC",
        "mpid": "JVBF",
        "clearingBroker": "0235",
        "brokerName": "JACK V. BUTTERFIELD INVESTMENT COMPANY                                "
    },
    {
        "type": "OTC",
        "mpid": "JVBG",
        "clearingBroker": "0443",
        "brokerName": "J.V.B. FINANCIAL GROUP LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "JVDA",
        "clearingBroker": "0294",
        "brokerName": "CHAINCE SECURITIES, LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "JWCF",
        "clearingBroker": "0226",
        "brokerName": "J. W. COLE FINANCIAL, INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "JWTT",
        "clearingBroker": "0158",
        "brokerName": "JWTT INC.                                                             "
    },
    {
        "type": "OTC",
        "mpid": "JXLI",
        "clearingBroker": "0536",
        "brokerName": "LIME BROKERAGE LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "KALA",
        "clearingBroker": "0226",
        "brokerName": "KA ASSOCIATES, INC.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "KALS",
        "clearingBroker": "0235",
        "brokerName": "KALOS CAPITAL, INC.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "KAPG",
        "clearingBroker": "0158",
        "brokerName": "KAPITALL GENERATION, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "KART",
        "clearingBroker": "0750",
        "brokerName": "REVERE SECURITIES CORP.                                               "
    },
    {
        "type": "OTC",
        "mpid": "KBWI",
        "clearingBroker": "0793",
        "brokerName": "KEEFE, BRUYETTE & WOODS, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "KCAM",
        "clearingBroker": "0052",
        "brokerName": "K2 CAPITAL ASSET MANAGEMENT, LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "KCGM",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "KCIM",
        "clearingBroker": "0235",
        "brokerName": "INVESTMENT MANAGEMENT CORPORATION                                     "
    },
    {
        "type": "OTC",
        "mpid": "KCIX",
        "clearingBroker": "0279",
        "brokerName": "KILEY PARTNERS, INC.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "KCMP",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "KCRD",
        "clearingBroker": "0052",
        "brokerName": "PHX FINANCIAL, INC.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "KEEN",
        "clearingBroker": "0279",
        "brokerName": "ST. BERNARD FINANCIAL SERVICES, INC.                                  "
    },
    {
        "type": "OTC",
        "mpid": "KELG",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "KELL",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "KENS",
        "clearingBroker": "0279",
        "brokerName": "KENSINGTON CAPITAL CORP.                                              "
    },
    {
        "type": "OTC",
        "mpid": "KEYB",
        "clearingBroker": "0443",
        "brokerName": "KEYBANC CAPITAL MARKETS INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "KEYS",
        "clearingBroker": "2402",
        "brokerName": "ARETE WEALTH MANAGEMENT, LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "KIML",
        "clearingBroker": "0226",
        "brokerName": "KIMELMAN & BAIRD, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "KING",
        "clearingBroker": "0235",
        "brokerName": "C. L. KING & ASSOCIATES, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "KISA",
        "clearingBroker": "0294",
        "brokerName": "KOREA INVESTMENT & SECURITIES AMERICA, INC.                           "
    },
    {
        "type": "OTC",
        "mpid": "KLFX",
        "clearingBroker": "9132",
        "brokerName": "KLEON FINANCIAL, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "KNGS",
        "clearingBroker": "0235",
        "brokerName": "KINGSWOOD CAPITAL PARTNERS, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "KNGW",
        "clearingBroker": "0158",
        "brokerName": "KINGSWOOD CAPITAL PARTNERS, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "KOVS",
        "clearingBroker": "0226",
        "brokerName": "KOVACK SECURITIES INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "KRCO",
        "clearingBroker": "0235",
        "brokerName": "KR SECURITIES, LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "KRMQ",
        "clearingBroker": "0158",
        "brokerName": "KARMEQ, LLC                                                           "
    },
    {
        "type": "OTC",
        "mpid": "KRSH",
        "clearingBroker": "0005",
        "brokerName": "KERSHNER SECURITIES, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "KRTH",
        "clearingBroker": "0235",
        "brokerName": "J.W. KORTH & COMPANY                                                  "
    },
    {
        "type": "OTC",
        "mpid": "KUYK",
        "clearingBroker": "0279",
        "brokerName": "KUYKENDALL & SCHNEIDER, INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "KWSC",
        "clearingBroker": "0294",
        "brokerName": "KW SECURITIES CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "KYAN",
        "clearingBroker": "0103",
        "brokerName": "KAYAN SECURITIES, INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "KYCS",
        "clearingBroker": "9132",
        "brokerName": "CLEAR STREET LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "LAFB",
        "clearingBroker": "0235",
        "brokerName": "R.F. LAFFERTY & CO., INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "LAFC",
        "clearingBroker": "0443",
        "brokerName": "R.F. LAFFERTY & CO., INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "LAFF",
        "clearingBroker": "0443",
        "brokerName": "R.F. LAFFERTY & CO., INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "LAFI",
        "clearingBroker": "0750",
        "brokerName": "LAFISE SECURITIES CORPORATION                                         "
    },
    {
        "type": "OTC",
        "mpid": "LAGI",
        "clearingBroker": "0226",
        "brokerName": "ALLSTATE FINANCIAL SERVICES, LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "LAMA",
        "clearingBroker": "0141",
        "brokerName": "XML SECURITIES                                                        "
    },
    {
        "type": "OTC",
        "mpid": "LAMP",
        "clearingBroker": "4305",
        "brokerName": "LAMPOST CAPITAL, L.C.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "LANE",
        "clearingBroker": "0235",
        "brokerName": "MARC J. LANE & COMPANY                                                "
    },
    {
        "type": "OTC",
        "mpid": "LASI",
        "clearingBroker": "0141",
        "brokerName": "LIEBLONG & ASSOCIATES, INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "LASS",
        "clearingBroker": "0226",
        "brokerName": "LASALLE ST. SECURITIES, INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "LATG",
        "clearingBroker": "0537",
        "brokerName": "GFI SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "LATM",
        "clearingBroker": "0537",
        "brokerName": "GFI SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "LATN",
        "clearingBroker": "0443",
        "brokerName": "HEROLD & LANTERN INVESTMENTS, INC.                                    "
    },
    {
        "type": "OTC",
        "mpid": "LATS",
        "clearingBroker": "0229",
        "brokerName": "BARCLAYS CAPITAL INC./BARCLAYS CAPITAL INC.                           "
    },
    {
        "type": "OTC",
        "mpid": "LBKI",
        "clearingBroker": "0235",
        "brokerName": "LIBUCKI & CO., LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "LDGA",
        "clearingBroker": "0052",
        "brokerName": "DOUGALL & ASSOCIATES                                                  "
    },
    {
        "type": "OTC",
        "mpid": "LDIL",
        "clearingBroker": "0226",
        "brokerName": "LINCOLN DOUGLAS INVESTMENTS, LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "LDLW",
        "clearingBroker": "0750",
        "brokerName": "LAIDLAW & COMPANY (UK) LTD.                                           "
    },
    {
        "type": "OTC",
        "mpid": "LDOT",
        "clearingBroker": "0235",
        "brokerName": "LANDOLT SECURITIES, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "LEAD",
        "clearingBroker": "0226",
        "brokerName": "THE LEADERS GROUP, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "LEBO",
        "clearingBroker": "0226",
        "brokerName": "LEIGH BALDWIN & CO., LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "LEDE",
        "clearingBroker": "5071",
        "brokerName": "LEEDE JONES GABLE INC./CDS                                            "
    },
    {
        "type": "OTC",
        "mpid": "LEER",
        "clearingBroker": "0443",
        "brokerName": "LEERINK SWANN & COMPANY                                               "
    },
    {
        "type": "OTC",
        "mpid": "LEHB",
        "clearingBroker": "0229",
        "brokerName": "BARCLAYS CAPITAL INC./BARCLAYS CAPITAL INC.                           "
    },
    {
        "type": "OTC",
        "mpid": "LEHM",
        "clearingBroker": "0229",
        "brokerName": "BARCLAYS CAPITAL INC./BARCLAYS CAPITAL INC.                           "
    },
    {
        "type": "OTC",
        "mpid": "LEHP",
        "clearingBroker": "0229",
        "brokerName": "BARCLAYS CAPITAL INC./BARCLAYS CAPITAL INC.                           "
    },
    {
        "type": "OTC",
        "mpid": "LEIM",
        "clearingBroker": "0229",
        "brokerName": "BARCLAYS CAPITAL INC./BARCLAYS CAPITAL INC.                           "
    },
    {
        "type": "OTC",
        "mpid": "LESW",
        "clearingBroker": "0443",
        "brokerName": "LEERINK SWANN & COMPANY                                               "
    },
    {
        "type": "OTC",
        "mpid": "LETS",
        "clearingBroker": "3450",
        "brokerName": "CHOICETRADE                                                           "
    },
    {
        "type": "OTC",
        "mpid": "LEXM",
        "clearingBroker": "0158",
        "brokerName": "LEX MARKETS LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "LEYA",
        "clearingBroker": "0235",
        "brokerName": "LEMLEY, YARLING & CO.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "LFAC",
        "clearingBroker": "0226",
        "brokerName": "OSAIC FA, INC.                                                        "
    },
    {
        "type": "OTC",
        "mpid": "LFRO",
        "clearingBroker": "0235",
        "brokerName": "LF ROTHSCHILD, LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "LGLL",
        "clearingBroker": "0534",
        "brokerName": "MM GLOBAL SECURITIES, INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "LGNT",
        "clearingBroker": "0052",
        "brokerName": "AXOS CLEARING LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "LGSA",
        "clearingBroker": "0158",
        "brokerName": "WOORI INVESTMENT AND SECURITIES AMERICA, INC.                         "
    },
    {
        "type": "OTC",
        "mpid": "LHMA",
        "clearingBroker": "0229",
        "brokerName": "BARCLAYS CAPITAL INC./BARCLAYS CAPITAL INC.                           "
    },
    {
        "type": "OTC",
        "mpid": "LHMB",
        "clearingBroker": "0229",
        "brokerName": "BARCLAYS CAPITAL INC./BARCLAYS CAPITAL INC.                           "
    },
    {
        "type": "OTC",
        "mpid": "LHSB",
        "clearingBroker": "0229",
        "brokerName": "BARCLAYS CAPITAL INC./BARCLAYS CAPITAL INC.                           "
    },
    {
        "type": "OTC",
        "mpid": "LIFG",
        "clearingBroker": "0279",
        "brokerName": "LONG ISLAND FINANCIAL GROUP, INC.                                     "
    },
    {
        "type": "OTC",
        "mpid": "LIME",
        "clearingBroker": "8199",
        "brokerName": "SCORE PRIORITY CORP.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "LINC",
        "clearingBroker": "0158",
        "brokerName": "LIBERUM                                                               "
    },
    {
        "type": "OTC",
        "mpid": "LIVC",
        "clearingBroker": "0294",
        "brokerName": "LIME TRADING CORP                                                     "
    },
    {
        "type": "OTC",
        "mpid": "LIWM",
        "clearingBroker": "0695",
        "brokerName": "SCORE PRIORITY CORP.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "LIWO",
        "clearingBroker": "0695",
        "brokerName": "SCORE PRIORITY CORP.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "LMAR",
        "clearingBroker": "0226",
        "brokerName": "LIFEMARK SECURITIES CORP.                                             "
    },
    {
        "type": "OTC",
        "mpid": "LMGP",
        "clearingBroker": "8199",
        "brokerName": "SCORE PRIORITY CORP.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "LMKO",
        "clearingBroker": "0235",
        "brokerName": "KOHN (L.M.) & COMPANY                                                 "
    },
    {
        "type": "OTC",
        "mpid": "LMNX",
        "clearingBroker": "0226",
        "brokerName": "LUMINEX TRADING & ANALYTICS LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "LMPC",
        "clearingBroker": "0695",
        "brokerName": "SCORE PRIORITY CORP.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "LMPT",
        "clearingBroker": "0695",
        "brokerName": "SCORE PRIORITY CORP.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "LNCL",
        "clearingBroker": "0443",
        "brokerName": "LINCOLN INVESTMENT                                                    "
    },
    {
        "type": "OTC",
        "mpid": "LOMB",
        "clearingBroker": "0141",
        "brokerName": "LOMBARD SECURITIES INCORPORATED                                       "
    },
    {
        "type": "OTC",
        "mpid": "LOOP",
        "clearingBroker": "0443",
        "brokerName": "LOOP CAPITAL MARKETS LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "LOTC",
        "clearingBroker": "0226",
        "brokerName": "L.O. THOMAS & CO. INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "LOUE",
        "clearingBroker": "0161",
        "brokerName": "ICAP CORPORATES LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "LOUI",
        "clearingBroker": "0005",
        "brokerName": "LOUIS CAPITAL MARKETS, LP                                             "
    },
    {
        "type": "OTC",
        "mpid": "LPCA",
        "clearingBroker": "3856",
        "brokerName": "ALPACA SECURITIES LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "LPCM",
        "clearingBroker": "0103",
        "brokerName": "LAMPERT CAPITAL MARKETS INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "LPFS",
        "clearingBroker": "0235",
        "brokerName": "LIBERTY PARTNERS FINANCIAL SERVICES, INC.                             "
    },
    {
        "type": "OTC",
        "mpid": "LPLE",
        "clearingBroker": "0075",
        "brokerName": "LPL ENTERPRISE, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "LPSP",
        "clearingBroker": "1043",
        "brokerName": "LPS CAPITAL LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "LQFI",
        "clearingBroker": "0505",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "LQNA",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "OTC",
        "mpid": "LQNB",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "OTC",
        "mpid": "LQNF",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "OTC",
        "mpid": "LQNT",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "OTC",
        "mpid": "LQPT",
        "clearingBroker": "0161",
        "brokerName": "DASH FINANCIAL TECHNOLOGIES LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "LRBC",
        "clearingBroker": "0235",
        "brokerName": "LIBERTY ASSOCIATES, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "LRCM",
        "clearingBroker": "0279",
        "brokerName": "LOCKTON RE CAPITAL MARKETS, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "LSAH",
        "clearingBroker": "0229",
        "brokerName": "BARCLAYS CAPITAL INC./BARCLAYS CAPITAL INC.                           "
    },
    {
        "type": "OTC",
        "mpid": "LSCM",
        "clearingBroker": "0235",
        "brokerName": "LAKE STREET CAPITAL MARKETS, LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "LSCP",
        "clearingBroker": "8199",
        "brokerName": "LIFESCI CAPITAL, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "LSKO",
        "clearingBroker": "0226",
        "brokerName": "LESKO SECURITIES INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "LSPS",
        "clearingBroker": "8199",
        "brokerName": "LIGHTSPEED FINANCIAL SERVICES GROUP LLC                               "
    },
    {
        "type": "OTC",
        "mpid": "LSSI",
        "clearingBroker": "0750",
        "brokerName": "EJ STERLING INC.                                                      "
    },
    {
        "type": "OTC",
        "mpid": "LSUS",
        "clearingBroker": "0443",
        "brokerName": "LATIN SECURITIES INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "LTAA",
        "clearingBroker": "0226",
        "brokerName": "LUMINEX TRADING & ANALYTICS LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "LTCO",
        "clearingBroker": "0226",
        "brokerName": "LADENBURG, THALMANN & CO., INC.                                       "
    },
    {
        "type": "OTC",
        "mpid": "LTCS",
        "clearingBroker": "0141",
        "brokerName": "LINDEN THOMAS AND COMPANY SECURITIES, LLC                             "
    },
    {
        "type": "OTC",
        "mpid": "LVAR",
        "clearingBroker": "0443",
        "brokerName": "LARRAINVIAL SECURITIES US LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "LVMR",
        "clearingBroker": "0235",
        "brokerName": "LIVERMORE TRADING GROUP, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "MACC",
        "clearingBroker": "0226",
        "brokerName": "NEWEDGE SECURITIES, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "MACQ",
        "clearingBroker": "0114",
        "brokerName": "MACQUARIE CAPITAL (USA) INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "MADV",
        "clearingBroker": "0443",
        "brokerName": "MILLENNIUM ADVISORS, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "MATD",
        "clearingBroker": "3856",
        "brokerName": "MM GLOBAL SECURITIES, INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "MATI",
        "clearingBroker": "9132",
        "brokerName": "MATRIX EXECUTIONS, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "MAVB",
        "clearingBroker": "0103",
        "brokerName": "GREAT POINT CAPITAL LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "MAXC",
        "clearingBroker": "0537",
        "brokerName": "BGC FINANCIAL INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "MAXM",
        "clearingBroker": "0443",
        "brokerName": "MAXIM GROUP LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "MAXN",
        "clearingBroker": "0537",
        "brokerName": "BGC FINANCIAL INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "MBSE",
        "clearingBroker": "0052",
        "brokerName": "MBS SOURCE ETRADING, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "MBTS",
        "clearingBroker": "0158",
        "brokerName": "MB TRADING                                                            "
    },
    {
        "type": "OTC",
        "mpid": "MBUS",
        "clearingBroker": "0052",
        "brokerName": "MEDIOBANCA SECURITIES USA LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "MCAP",
        "clearingBroker": "0161",
        "brokerName": "MCAP LLC                                                              "
    },
    {
        "type": "OTC",
        "mpid": "MCBT",
        "clearingBroker": "0235",
        "brokerName": "MOORS & CABOT, INC.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "MCMF",
        "clearingBroker": "5076",
        "brokerName": "RAYMOND JAMES LTD./CDS                                                "
    },
    {
        "type": "OTC",
        "mpid": "MCMG",
        "clearingBroker": "0279",
        "brokerName": "MUNICIPAL CAPITAL MARKETS GROUP, INC.                                 "
    },
    {
        "type": "OTC",
        "mpid": "MDBC",
        "clearingBroker": "0534",
        "brokerName": "MDB CAPITAL GROUP LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MDGP",
        "clearingBroker": "0235",
        "brokerName": "MD GLOBAL PARTNERS, LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "MEAL",
        "clearingBroker": "0226",
        "brokerName": "M. E. ALLISON & CO., INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "MEMX",
        "clearingBroker": "0161",
        "brokerName": "MEMX EXECUTION SERVICES LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "MERP",
        "clearingBroker": "0235",
        "brokerName": "MERIDIAN EQUITY PARTNERS, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "MESF",
        "clearingBroker": "0443",
        "brokerName": "MESIROW FINANCIAL, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "MEXD",
        "clearingBroker": "0551",
        "brokerName": "DYNAMEX TRADING, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "MFGX",
        "clearingBroker": "0443",
        "brokerName": "MISCHLER FINANCIAL GROUP, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "MGIS",
        "clearingBroker": "5008",
        "brokerName": "INDUSTRIAL ALLIANCE SECURITIES INC.                                   "
    },
    {
        "type": "OTC",
        "mpid": "MGPC",
        "clearingBroker": "0534",
        "brokerName": "MADISON GLOBAL PARTNERS LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "MGTX",
        "clearingBroker": "0695",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "MHFI",
        "clearingBroker": "0226",
        "brokerName": "M HOLDINGS SECURITIES, INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "MIAM",
        "clearingBroker": "0141",
        "brokerName": "FMSBONDS, INC.                                                        "
    },
    {
        "type": "OTC",
        "mpid": "MIDL",
        "clearingBroker": "0226",
        "brokerName": "MIDDLEGATE SECURITIES LTD.                                            "
    },
    {
        "type": "OTC",
        "mpid": "MILE",
        "clearingBroker": "0052",
        "brokerName": "I-BANKERS SECURITIES INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "MINP",
        "clearingBroker": "0235",
        "brokerName": "MINISTRY PARTNERS SECURITIES, LLC                                     "
    },
    {
        "type": "OTC",
        "mpid": "MINT",
        "clearingBroker": "0537",
        "brokerName": "BGC FINANCIAL INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "MINV",
        "clearingBroker": "0235",
        "brokerName": "MACK INVESTMENTS SECURITIES, INC.                                     "
    },
    {
        "type": "OTC",
        "mpid": "MIRA",
        "clearingBroker": "1043",
        "brokerName": "MIRAE ASSET SECURITIES (USA) INC.                                     "
    },
    {
        "type": "OTC",
        "mpid": "MISL",
        "clearingBroker": "0161",
        "brokerName": "MISCHLER FINANCIAL GROUP, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "MITR",
        "clearingBroker": "0443",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MJWH",
        "clearingBroker": "0235",
        "brokerName": "ETICO PARTNERS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "MKRT",
        "clearingBroker": "0235",
        "brokerName": "MARKET SECURITIES, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "MKTI",
        "clearingBroker": "0226",
        "brokerName": "U.S. BANCORP ADVISORS, LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "MKTX",
        "clearingBroker": "4265",
        "brokerName": "MARKETAXESS CORPORATION                                               "
    },
    {
        "type": "OTC",
        "mpid": "MKTY",
        "clearingBroker": "4265",
        "brokerName": "MARKETAXESS CORPORATION                                               "
    },
    {
        "type": "OTC",
        "mpid": "MLBC",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLCA",
        "clearingBroker": "0161",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "OTC",
        "mpid": "MLCB",
        "clearingBroker": "0161",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "OTC",
        "mpid": "MLCC",
        "clearingBroker": "0161",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "OTC",
        "mpid": "MLCD",
        "clearingBroker": "0161",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "OTC",
        "mpid": "MLCG",
        "clearingBroker": "0161",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "OTC",
        "mpid": "MLCO",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLCP",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLCQ",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLCS",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLCX",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLEL",
        "clearingBroker": "0161",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "OTC",
        "mpid": "MLEX",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLIX",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLMA",
        "clearingBroker": "0671",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "OTC",
        "mpid": "MLPK",
        "clearingBroker": "0161",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "OTC",
        "mpid": "MLPL",
        "clearingBroker": "0075",
        "brokerName": "MUTUAL SERVICE CORPORATION                                            "
    },
    {
        "type": "OTC",
        "mpid": "MLRM",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLRO",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLSE",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLSK",
        "clearingBroker": "0161",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "OTC",
        "mpid": "MLSL",
        "clearingBroker": "0161",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "OTC",
        "mpid": "MLTA",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLTB",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLTC",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLTE",
        "clearingBroker": "0161",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "OTC",
        "mpid": "MLTF",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLTG",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLTH",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLTI",
        "clearingBroker": "0161",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "OTC",
        "mpid": "MLTJ",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLTK",
        "clearingBroker": "0161",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "OTC",
        "mpid": "MLTL",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLTO",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLTP",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLTQ",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLTR",
        "clearingBroker": "0158",
        "brokerName": "MONEYLION SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "MLTT",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLTU",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLTW",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLTX",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLTY",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLUA",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLUB",
        "clearingBroker": "0161",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "OTC",
        "mpid": "MLUC",
        "clearingBroker": "0161",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "OTC",
        "mpid": "MLUD",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLVX",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLWM",
        "clearingBroker": "0671",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "OTC",
        "mpid": "MLZB",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLZC",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLZD",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLZE",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLZF",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLZI",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLZJ",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLZL",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLZM",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLZN",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLZO",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLZP",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLZQ",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLZR",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLZS",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLZT",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLZU",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLZV",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MLZW",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MMNT",
        "clearingBroker": "0158",
        "brokerName": "MOMENT MARKETS, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "MNCO",
        "clearingBroker": "0279",
        "brokerName": "NELSON (MARTIN) & CO., INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "MNDC",
        "clearingBroker": "4305",
        "brokerName": "MONDEUM CAPITAL, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "MNDX",
        "clearingBroker": "9132",
        "brokerName": "TJM INVESTMENTS, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "MOCM",
        "clearingBroker": "0235",
        "brokerName": "MORETON CAPITAL MARKETS, LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "MOFI",
        "clearingBroker": "0158",
        "brokerName": "M1 FINANCE LLC                                                        "
    },
    {
        "type": "OTC",
        "mpid": "MOFO",
        "clearingBroker": "1497",
        "brokerName": "M1 FINANCE LLC                                                        "
    },
    {
        "type": "OTC",
        "mpid": "MOLO",
        "clearingBroker": "0235",
        "brokerName": "MOLONEY SECURITIES                                                    "
    },
    {
        "type": "OTC",
        "mpid": "MONR",
        "clearingBroker": "0226",
        "brokerName": "MONROE FINANCIAL PARTNERS, INC.                                       "
    },
    {
        "type": "OTC",
        "mpid": "MOON",
        "clearingBroker": "0158",
        "brokerName": "OTC LINK LLC                                                          "
    },
    {
        "type": "OTC",
        "mpid": "MORE",
        "clearingBroker": "0361",
        "brokerName": "MITCHELL SECURITIES CORPORATION OF OREGON                             "
    },
    {
        "type": "OTC",
        "mpid": "MPLA",
        "clearingBroker": "0158",
        "brokerName": "EMPALA SECURITIES, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "MPLW",
        "clearingBroker": "0226",
        "brokerName": "MAPLEWOOD INVESTMENT ADVISORS, INC.                                   "
    },
    {
        "type": "OTC",
        "mpid": "MPSG",
        "clearingBroker": "0161",
        "brokerName": "E D & F MAN CAPITAL MARKETS INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "MRAD",
        "clearingBroker": "0052",
        "brokerName": "MACRO RISK ADVISORS LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "MRBA",
        "clearingBroker": "0052",
        "brokerName": "IBN FINANCIAL SERVICES, INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "MRCY",
        "clearingBroker": "0520",
        "brokerName": "NASDAQ EXECUTION SERVICES, LLC/OPTIONS                                "
    },
    {
        "type": "OTC",
        "mpid": "MREC",
        "clearingBroker": "5029",
        "brokerName": "MACKIE RESERCH CAPITAL CORPORATION/CDS                                "
    },
    {
        "type": "OTC",
        "mpid": "MRNA",
        "clearingBroker": "0161",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "MRSC",
        "clearingBroker": "0287",
        "brokerName": "TRADEUP SECURITIES, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "MSBT",
        "clearingBroker": "0445",
        "brokerName": "MURIEL SIEBERT & CO., INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "MSCB",
        "clearingBroker": "0279",
        "brokerName": "MAINE SECURITIES CORPORATION                                          "
    },
    {
        "type": "OTC",
        "mpid": "MSCO",
        "clearingBroker": "0050",
        "brokerName": "MORGAN STANLEY & CO. LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "MSEC",
        "clearingBroker": "0235",
        "brokerName": "MSEC, LLC                                                             "
    },
    {
        "type": "OTC",
        "mpid": "MSED",
        "clearingBroker": "0050",
        "brokerName": "MORGAN STANLEY & CO. LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "MSEM",
        "clearingBroker": "0050",
        "brokerName": "MORGAN STANLEY & CO. LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "MSET",
        "clearingBroker": "0050",
        "brokerName": "MORGAN STANLEY & CO. LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "MSFP",
        "clearingBroker": "0050",
        "brokerName": "MORGAN STANLEY & CO. LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "MSLC",
        "clearingBroker": "0534",
        "brokerName": "MCDONNAUGH SECURITIES LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "MSML",
        "clearingBroker": "0050",
        "brokerName": "MORGAN STANLEY & CO. LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "MSMP",
        "clearingBroker": "0050",
        "brokerName": "MORGAN STANLEY & CO. LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "MSNY",
        "clearingBroker": "0015",
        "brokerName": "MORGAN STANLEY & CO. LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "MSPL",
        "clearingBroker": "0050",
        "brokerName": "MORGAN STANLEY & CO. LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "MSPW",
        "clearingBroker": "0050",
        "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "MSRO",
        "clearingBroker": "0226",
        "brokerName": "MESIROW FINANCIAL, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "MSRP",
        "clearingBroker": "0050",
        "brokerName": "MORGAN STANLEY & CO. LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "MSTC",
        "clearingBroker": "0226",
        "brokerName": "MIDWESTERN SECURITIES TRADING COMPANY, LLC                            "
    },
    {
        "type": "OTC",
        "mpid": "MSTI",
        "clearingBroker": "0050",
        "brokerName": "MORGAN STANLEY & CO. LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "MSTW",
        "clearingBroker": "0050",
        "brokerName": "MORGAN STANLEY & CO. LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "MSTX",
        "clearingBroker": "0050",
        "brokerName": "MORGAN STANLEY & CO. LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "MTDB",
        "clearingBroker": "0443",
        "brokerName": "M&T SECURITIES, INC.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "MTGO",
        "clearingBroker": "0158",
        "brokerName": "MTG, LLC                                                              "
    },
    {
        "type": "OTC",
        "mpid": "MTHN",
        "clearingBroker": "0005",
        "brokerName": "MARATHON TRADING GROUP LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "MTLE",
        "clearingBroker": "0235",
        "brokerName": "MTL EQUITY PRODUCTS, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "MTSL",
        "clearingBroker": "0226",
        "brokerName": "MSEC, LLC                                                             "
    },
    {
        "type": "OTC",
        "mpid": "MUFG",
        "clearingBroker": "0076",
        "brokerName": "MUFG SECURITIES AMERICAS INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "MULA",
        "clearingBroker": "0534",
        "brokerName": "MUNDIAL FINANCIAL GROUP, LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "MULL",
        "clearingBroker": "8199",
        "brokerName": "MARK J. MULLER EQUITIES, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "MURJ",
        "clearingBroker": "0750",
        "brokerName": "COMMERCE ONE FINANCIAL INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "MVMP",
        "clearingBroker": "0534",
        "brokerName": "MICROVENTURE MARKETPLACE INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "MWCC",
        "clearingBroker": "0235",
        "brokerName": "MONNESS CRESPI HARDT & CO., INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "MWIL",
        "clearingBroker": "0235",
        "brokerName": "MORGAN WILSHIRE SECURITIES, INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "MYSS",
        "clearingBroker": "0158",
        "brokerName": "M.Y. SAFRA SECURITIES, INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "MZHO",
        "clearingBroker": "0892",
        "brokerName": "MIZUHO SECURITIES USA LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "NACM",
        "clearingBroker": "0161",
        "brokerName": "NABSECURITIES, LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "NADL",
        "clearingBroker": "0235",
        "brokerName": "WARREN D. NADEL & COMPANY                                             "
    },
    {
        "type": "OTC",
        "mpid": "NAPK",
        "clearingBroker": "0052",
        "brokerName": "B. RILEY WEALTH MANAGEMENT                                            "
    },
    {
        "type": "OTC",
        "mpid": "NASC",
        "clearingBroker": "0235",
        "brokerName": "NATALLIANCE SECURITIES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "NASJ",
        "clearingBroker": "0352",
        "brokerName": "JANE STREET MARKETS, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "NATI",
        "clearingBroker": "4305",
        "brokerName": "NATISA SECURITIES LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "NAVC",
        "clearingBroker": "0235",
        "brokerName": "NAVIAN CAPITAL SECURITIES LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "NBAR",
        "clearingBroker": "0226",
        "brokerName": "NANCY BARRON & ASSOCIATES, INC.                                       "
    },
    {
        "type": "OTC",
        "mpid": "NBCS",
        "clearingBroker": "0235",
        "brokerName": "NBC SECURITIES, INC.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "NBFI",
        "clearingBroker": "5008",
        "brokerName": "NBF SECURITIES (USA) CORP.                                            "
    },
    {
        "type": "OTC",
        "mpid": "NBKT",
        "clearingBroker": "8353",
        "brokerName": "NATIONAL BANK OF CANADA FINANCIAL INC.                                "
    },
    {
        "type": "OTC",
        "mpid": "NBLB",
        "clearingBroker": "0226",
        "brokerName": "NEUBERGER BERMAN BD LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "NBSL",
        "clearingBroker": "0226",
        "brokerName": "BMO NESBITT BURNS SECURITIES LTD.                                     "
    },
    {
        "type": "OTC",
        "mpid": "NEED",
        "clearingBroker": "0443",
        "brokerName": "NEEDHAM & COMPANY, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "NEFO",
        "clearingBroker": "0608",
        "brokerName": "SG AMERICAS SECURITIES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "NENB",
        "clearingBroker": "0608",
        "brokerName": "SG AMERICAS SECURITIES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "NEST",
        "clearingBroker": "0235",
        "brokerName": "NEST INVESTMENTS BD LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "NEUS",
        "clearingBroker": "0750",
        "brokerName": "NINTH ETERNITY SECURITIES LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "NFBS",
        "clearingBroker": "2402",
        "brokerName": "NAVY FEDERAL INVESTMENT SERVICES, LLC                                 "
    },
    {
        "type": "OTC",
        "mpid": "NFGR",
        "clearingBroker": "0141",
        "brokerName": "NATIONS FINANCIAL GROUP, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "NFSC",
        "clearingBroker": "0226",
        "brokerName": "NATIONAL FINANCIAL SERVICES LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "NFTY",
        "clearingBroker": "0235",
        "brokerName": "INFINITY FINANCIAL SERVICES                                           "
    },
    {
        "type": "OTC",
        "mpid": "NHFS",
        "clearingBroker": "0158",
        "brokerName": "ALIGHT FINANCIAL SOLUTIONS, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "NHWI",
        "clearingBroker": "0141",
        "brokerName": "HENNION & WALSH, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "NIAD",
        "clearingBroker": "0052",
        "brokerName": "NI ADVISORS                                                           "
    },
    {
        "type": "OTC",
        "mpid": "NICK",
        "clearingBroker": "0161",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "NITC",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "NITD",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "NITE",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "NITP",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "NITX",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "NLOV",
        "clearingBroker": "0534",
        "brokerName": "NORTLOV SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "NMRA",
        "clearingBroker": "0180",
        "brokerName": "NOMURA SECURITIES INTERNATIONAL, INC./FIXED INCOME                    "
    },
    {
        "type": "OTC",
        "mpid": "NMRB",
        "clearingBroker": "0180",
        "brokerName": "NOMURA SECURITIES INTERNATIONAL, INC                                  "
    },
    {
        "type": "OTC",
        "mpid": "NOBL",
        "clearingBroker": "0750",
        "brokerName": "NOBLE FINANCIAL CAPITAL MARKETS                                       "
    },
    {
        "type": "OTC",
        "mpid": "NORC",
        "clearingBroker": "0235",
        "brokerName": "NORTHERN CAPITAL SEC. CORP.                                           "
    },
    {
        "type": "OTC",
        "mpid": "NORT",
        "clearingBroker": "0443",
        "brokerName": "NORTHLAND SECURITIES, INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "NORW",
        "clearingBroker": "0250",
        "brokerName": "WELLS FARGO BROKERAGE SERVICES, LLC                                   "
    },
    {
        "type": "OTC",
        "mpid": "NOSO",
        "clearingBroker": "0443",
        "brokerName": "NORTH SOUTH CAPITAL LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "NPNT",
        "clearingBroker": "0005",
        "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "NPTP",
        "clearingBroker": "0443",
        "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "NQBX",
        "clearingBroker": "0163",
        "brokerName": "NASDAQ BX, INC.                                                       "
    },
    {
        "type": "OTC",
        "mpid": "NQOP",
        "clearingBroker": "0520",
        "brokerName": "NASDAQ EXECUTION SERVICES, LLC/OPTIONS                                "
    },
    {
        "type": "OTC",
        "mpid": "NQPX",
        "clearingBroker": "0237",
        "brokerName": "NASDAQ PHLX LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "NQRB",
        "clearingBroker": "0568",
        "brokerName": "NASDAQ EXECUTION SERVICES, LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "NSDQ",
        "clearingBroker": "0759",
        "brokerName": "NASDAQ STOCK MARKET LLC/OMNIBUS ACCOUNT                               "
    },
    {
        "type": "OTC",
        "mpid": "NSFP",
        "clearingBroker": "0235",
        "brokerName": "NORTHSTAR FINANCIAL PARTNERS, INC.                                    "
    },
    {
        "type": "OTC",
        "mpid": "NSIF",
        "clearingBroker": "5061",
        "brokerName": "TD WATERHOUSE - NORSTAR SECURITIES/CDS                                "
    },
    {
        "type": "OTC",
        "mpid": "NSRD",
        "clearingBroker": "0235",
        "brokerName": "NESTLERODE & CO., INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "NTBF",
        "clearingBroker": "5043",
        "brokerName": "BMO NESBITT BURNS INC./CDS                                            "
    },
    {
        "type": "OTC",
        "mpid": "NTFN",
        "clearingBroker": "0052",
        "brokerName": "NETWORK 1 FINANCIAL SECURITIES INC.                                   "
    },
    {
        "type": "OTC",
        "mpid": "NTRC",
        "clearingBroker": "0226",
        "brokerName": "NORTHERN TRUST SECURITIES, INC.                                       "
    },
    {
        "type": "OTC",
        "mpid": "NVEN",
        "clearingBroker": "0448",
        "brokerName": "NUVEEN SECURITIES, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "NVGT",
        "clearingBroker": "0388",
        "brokerName": "NAVIGATE ADVISORS LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "NVSR",
        "clearingBroker": "0158",
        "brokerName": "NVSTR FINANCIAL LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "NWCM",
        "clearingBroker": "0235",
        "brokerName": "NW CAPITAL MARKETS INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "NWIA",
        "clearingBroker": "0750",
        "brokerName": "NORTHWEST INVESTMENT ADVISORS, INC.                                   "
    },
    {
        "type": "OTC",
        "mpid": "NYFX",
        "clearingBroker": "0100",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "NYLS",
        "clearingBroker": "0226",
        "brokerName": "NYLIFE SECURITIES INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "OAIF",
        "clearingBroker": "0158",
        "brokerName": "OPTIONS AI FINANCIAL, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "OAKR",
        "clearingBroker": "0235",
        "brokerName": "THE OAK RIDGE FINANCIAL SERVICES GROUP, INC.                          "
    },
    {
        "type": "OTC",
        "mpid": "OBEX",
        "clearingBroker": "0534",
        "brokerName": "OBEX SECURITIES LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "OBWS",
        "clearingBroker": "0226",
        "brokerName": "OBERWEIS SECURITIES, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "OCAC",
        "clearingBroker": "0235",
        "brokerName": "OLSON, CROSS & ALAMO LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "OCEA",
        "clearingBroker": "0052",
        "brokerName": "OCEAN FINANCIAL SERVICES, LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "OCEE",
        "clearingBroker": "4305",
        "brokerName": "OCEANUS SECURITIES, LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "OCEN",
        "clearingBroker": "0568",
        "brokerName": "NASDAQ EXECUTION SERVICES, LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "OCTG",
        "clearingBroker": "0295",
        "brokerName": "OCTEG, LLC                                                            "
    },
    {
        "type": "OTC",
        "mpid": "ODNC",
        "clearingBroker": "0235",
        "brokerName": "ODEON CAPITAL GROUP LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "OFGF",
        "clearingBroker": "0235",
        "brokerName": "OFG FINANCIAL SERVICES INC                                            "
    },
    {
        "type": "OTC",
        "mpid": "OFMC",
        "clearingBroker": "9132",
        "brokerName": "CLEAR STREET, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "OGRU",
        "clearingBroker": "0161",
        "brokerName": "OSCAR GRUSS & SON, INCORPORATED                                       "
    },
    {
        "type": "OTC",
        "mpid": "OGTL",
        "clearingBroker": "0005",
        "brokerName": "OUTSET GLOBAL TRADING LIMITED                                         "
    },
    {
        "type": "OTC",
        "mpid": "OHIO",
        "clearingBroker": "0443",
        "brokerName": "FIFTH THIRD SECURITIES, INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "OHOS",
        "clearingBroker": "0551",
        "brokerName": "TWO SIGMA SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "OLDM",
        "clearingBroker": "0005",
        "brokerName": "OLD MISSION CAPITAL, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "OLMN",
        "clearingBroker": "0005",
        "brokerName": "OLD MISSION MARKETS LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "OLNE",
        "clearingBroker": "0279",
        "brokerName": "OLDEN LANE SECURITIES, LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "OMMA",
        "clearingBroker": "0005",
        "brokerName": "OLD MISSION MARKETS LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "ONEC",
        "clearingBroker": "0505",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "ONEL",
        "clearingBroker": "0161",
        "brokerName": "O'NEIL (WILLIAM) & CO                                                 "
    },
    {
        "type": "OTC",
        "mpid": "OPAL",
        "clearingBroker": "8199",
        "brokerName": "OPAL SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "OPCO",
        "clearingBroker": "0571",
        "brokerName": "OPPENHEIMER & CO. INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "OPDL",
        "clearingBroker": "0158",
        "brokerName": "OPENDEAL BROKER LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "OPTE",
        "clearingBroker": "0695",
        "brokerName": "OPTIVER US LLC                                                        "
    },
    {
        "type": "OTC",
        "mpid": "OPTF",
        "clearingBroker": "0005",
        "brokerName": "OPTIVER US LLC                                                        "
    },
    {
        "type": "OTC",
        "mpid": "OPTG",
        "clearingBroker": "0005",
        "brokerName": "OPTIVER US, LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "OPTU",
        "clearingBroker": "0695",
        "brokerName": "OPTIVER US, LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "OPTY",
        "clearingBroker": "0158",
        "brokerName": "OPTIONALITY SECURITIES                                                "
    },
    {
        "type": "OTC",
        "mpid": "OSFI",
        "clearingBroker": "0534",
        "brokerName": "ONESOURCE FI LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "OSIC",
        "clearingBroker": "0226",
        "brokerName": "OSAIC INSTITUTIONS, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "OTAA",
        "clearingBroker": "0551",
        "brokerName": "OTA LIMITED PARTNERSHIP                                               "
    },
    {
        "type": "OTC",
        "mpid": "OTCN",
        "clearingBroker": "0158",
        "brokerName": "OTC LINK LLC                                                          "
    },
    {
        "type": "OTC",
        "mpid": "OTCO",
        "clearingBroker": "0158",
        "brokerName": "OTC LINK LLC                                                          "
    },
    {
        "type": "OTC",
        "mpid": "OTCX",
        "clearingBroker": "0158",
        "brokerName": "OTC LINK LLC                                                          "
    },
    {
        "type": "OTC",
        "mpid": "OTSB",
        "clearingBroker": "0103",
        "brokerName": "OAK TREE SECURITIES, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "OYLD",
        "clearingBroker": "0235",
        "brokerName": "OPENYIELD TRADING LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "PACT",
        "clearingBroker": "0443",
        "brokerName": "BTG PACTUAL US CAPITAL LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "PAPP",
        "clearingBroker": "0534",
        "brokerName": "EUROPEAN FAMILY OFFICE INSTITUTE LLC.                                 "
    },
    {
        "type": "OTC",
        "mpid": "PARK",
        "clearingBroker": "0750",
        "brokerName": "PARK WALK CAPITAL MARKETS, LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "PARX",
        "clearingBroker": "0695",
        "brokerName": "PARX TRADING, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "PASF",
        "clearingBroker": "2402",
        "brokerName": "PASSFOLIO SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "PASL",
        "clearingBroker": "0443",
        "brokerName": "PERSHING ADVISOR SOLUTIONS, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "PATR",
        "clearingBroker": "0624",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "OTC",
        "mpid": "PAUL",
        "clearingBroker": "0595",
        "brokerName": "PAULSON INVESTMENT COMPANY, INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "PAVE",
        "clearingBroker": "0534",
        "brokerName": "PAVE SECURITIES, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "PBON",
        "clearingBroker": "0161",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "OTC",
        "mpid": "PCAP",
        "clearingBroker": "0608",
        "brokerName": "SG AMERICAS SECURITIES, LLC/SUB 608                                   "
    },
    {
        "type": "OTC",
        "mpid": "PCCA",
        "clearingBroker": "0279",
        "brokerName": "PEACHCAP SECURITIES, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "PCFF",
        "clearingBroker": "5075",
        "brokerName": "PI FINANCIAL CORP./CDS                                                "
    },
    {
        "type": "OTC",
        "mpid": "PCIS",
        "clearingBroker": "0226",
        "brokerName": "BANKOH INVESTMENT SERVICES, INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "PCPT",
        "clearingBroker": "8460",
        "brokerName": "PHILLIP CAPITAL INC.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "PCSG",
        "clearingBroker": "0158",
        "brokerName": "PACIFIC CENTURY SECURITIES, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "PCSS",
        "clearingBroker": "0294",
        "brokerName": "PACIFIC CENTURY SECURITIES, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "PECA",
        "clearingBroker": "0388",
        "brokerName": "PERAZA CAPITAL AND INVESTMENT, LLC                                    "
    },
    {
        "type": "OTC",
        "mpid": "PERC",
        "clearingBroker": "0279",
        "brokerName": "PERCIVAL FINANCIAL PARTNERS, LTD.                                     "
    },
    {
        "type": "OTC",
        "mpid": "PERO",
        "clearingBroker": "9132",
        "brokerName": "CLEAR STREET LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "PERS",
        "clearingBroker": "0443",
        "brokerName": "PERSHING LLC                                                          "
    },
    {
        "type": "OTC",
        "mpid": "PERX",
        "clearingBroker": "0443",
        "brokerName": "PERSHING LLC                                                          "
    },
    {
        "type": "OTC",
        "mpid": "PFCG",
        "clearingBroker": "0279",
        "brokerName": "PREFERRED CLIENT GROUP, INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "PFCL",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "PFCM",
        "clearingBroker": "0158",
        "brokerName": "PENSON FINANCIAL SERVICES, INC.                                       "
    },
    {
        "type": "OTC",
        "mpid": "PFDC",
        "clearingBroker": "0235",
        "brokerName": "PREFERRED CAPITAL SECURITIES, LLC                                     "
    },
    {
        "type": "OTC",
        "mpid": "PFPI",
        "clearingBroker": "0161",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "OTC",
        "mpid": "PFRA",
        "clearingBroker": "0443",
        "brokerName": "PERSHING LLC                                                          "
    },
    {
        "type": "OTC",
        "mpid": "PHBP",
        "clearingBroker": "0052",
        "brokerName": "PENNHAVEN BROKERAGE PARTNERS, LLC                                     "
    },
    {
        "type": "OTC",
        "mpid": "PHLY",
        "clearingBroker": "0520",
        "brokerName": "NASDAQ EXECUTION SERVICES, LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "PHRS",
        "clearingBroker": "0279",
        "brokerName": "NAVAID FINANCIAL SERVICES, INC.                                       "
    },
    {
        "type": "OTC",
        "mpid": "PICF",
        "clearingBroker": "5027",
        "brokerName": "PICTET CANADA L.P./CDS                                                "
    },
    {
        "type": "OTC",
        "mpid": "PICI",
        "clearingBroker": "0279",
        "brokerName": "POLAR INVESTMENT COUNSEL, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "PICL",
        "clearingBroker": "0052",
        "brokerName": "PAULSON INVESTMENT COMPANY LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "PICT",
        "clearingBroker": "5027",
        "brokerName": "PICTET OVERSEAS, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "PIER",
        "clearingBroker": "3018",
        "brokerName": "GREEN PIER FINTECH LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "PINA",
        "clearingBroker": "0141",
        "brokerName": "PINNACLE INVESTMENTS, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "PIPR",
        "clearingBroker": "0443",
        "brokerName": "PIPER SANDLER & CO.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "PISC",
        "clearingBroker": "0750",
        "brokerName": "PACIFIC INVESTMENT SECURITIES CORP.                                   "
    },
    {
        "type": "OTC",
        "mpid": "PIUS",
        "clearingBroker": "5075",
        "brokerName": "PI FINANCIAL (US) CORP.                                               "
    },
    {
        "type": "OTC",
        "mpid": "PJCX",
        "clearingBroker": "0443",
        "brokerName": "PIPER SANDLER & CO.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "PJEF",
        "clearingBroker": "0443",
        "brokerName": "JEFFERIES LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "PKAX",
        "clearingBroker": "0158",
        "brokerName": "PEAK6 CAPITAL MANAGEMENT LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "PKCM",
        "clearingBroker": "0005",
        "brokerName": "PEAK6 CAPITAL MANAGEMENT LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "PKSD",
        "clearingBroker": "8460",
        "brokerName": "PARKSIDE SECURITIES, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "PLAT",
        "clearingBroker": "0443",
        "brokerName": "CLARKSONS PLATOU SECURITIES, INC.                                     "
    },
    {
        "type": "OTC",
        "mpid": "PLHT",
        "clearingBroker": "0750",
        "brokerName": "PEEL HUNT INC.                                                        "
    },
    {
        "type": "OTC",
        "mpid": "PLTF",
        "clearingBroker": "0534",
        "brokerName": "PLACE TRADE FINANCIAL, INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "PNCC",
        "clearingBroker": "0226",
        "brokerName": "PNC INVESTMENTS                                                       "
    },
    {
        "type": "OTC",
        "mpid": "PNCS",
        "clearingBroker": "3856",
        "brokerName": "PRIME NUMBER CAPITAL, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "PNFP",
        "clearingBroker": "0279",
        "brokerName": "PNFP CAPITAL MARKETS, INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "PNSA",
        "clearingBroker": "0235",
        "brokerName": "PENSERRA SECURITIES, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "PNSR",
        "clearingBroker": "0161",
        "brokerName": "PENSERRA SECURITIES, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "PODE",
        "clearingBroker": "0235",
        "brokerName": "PODESTA & CO.                                                         "
    },
    {
        "type": "OTC",
        "mpid": "POPS",
        "clearingBroker": "0226",
        "brokerName": "POPULAR SECURITIES, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "PPNY",
        "clearingBroker": "3450",
        "brokerName": "PRIME NUMBER CAPITAL LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "PPPP",
        "clearingBroker": "0122",
        "brokerName": "PPPP CLEARING 0122 TEST                                               "
    },
    {
        "type": "OTC",
        "mpid": "PPSI",
        "clearingBroker": "0235",
        "brokerName": "PENSION PLANNERS SECURITIES, INC.                                     "
    },
    {
        "type": "OTC",
        "mpid": "PPSL",
        "clearingBroker": "0443",
        "brokerName": "SANTANDER US CAPITAL MARKETS LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "PRAG",
        "clearingBroker": "0067",
        "brokerName": "PRAGMA LLC                                                            "
    },
    {
        "type": "OTC",
        "mpid": "PRDG",
        "clearingBroker": "0551",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "PREB",
        "clearingBroker": "0005",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "OTC",
        "mpid": "PRFA",
        "clearingBroker": "0235",
        "brokerName": "PROOF SERVICES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "PRFT",
        "clearingBroker": "0158",
        "brokerName": "PROOF SERVICES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "PRJX",
        "clearingBroker": "0695",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "PRST",
        "clearingBroker": "0551",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "PRXX",
        "clearingBroker": "2793",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "PSFL",
        "clearingBroker": "0534",
        "brokerName": "PUENTE SERVICIOS FINANCIEROS LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "PSII",
        "clearingBroker": "0226",
        "brokerName": "KESTRA INVESTMENT SERVICES, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "PSIM",
        "clearingBroker": "0226",
        "brokerName": "PRINCIPAL SECURITIES, INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "PSRI",
        "clearingBroker": "0103",
        "brokerName": "GLOBALINK SECURITIES, INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "PSUT",
        "clearingBroker": "0235",
        "brokerName": "INNOVATION PARTNERS LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "PTFI",
        "clearingBroker": "0221",
        "brokerName": "UBS FINANCIAL SERVICES INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "PTIS",
        "clearingBroker": "0235",
        "brokerName": "PTI SECURITIES & FUTURES L.P.                                         "
    },
    {
        "type": "OTC",
        "mpid": "PTIX",
        "clearingBroker": "0534",
        "brokerName": "PTI SECURITIES & FUTURES L.P.                                         "
    },
    {
        "type": "OTC",
        "mpid": "PTLV",
        "clearingBroker": "8353",
        "brokerName": "NATIONAL BANK OF CANADA FINANCIAL INC.                                "
    },
    {
        "type": "OTC",
        "mpid": "PTSB",
        "clearingBroker": "0534",
        "brokerName": "PTS BROKERAGE, LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "PUBV",
        "clearingBroker": "3341",
        "brokerName": "MDB CAPITAL                                                           "
    },
    {
        "type": "OTC",
        "mpid": "PULX",
        "clearingBroker": "0067",
        "brokerName": "INSTINET, LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "PUMA",
        "clearingBroker": "8199",
        "brokerName": "PUMA CAPITAL, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "PUMX",
        "clearingBroker": "8199",
        "brokerName": "PUMA CAPITAL, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "PUND",
        "clearingBroker": "0551",
        "brokerName": "PUNDION LLC                                                           "
    },
    {
        "type": "OTC",
        "mpid": "PUPL",
        "clearingBroker": "0226",
        "brokerName": "PUPLAVA SECURITIES, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "PURE",
        "clearingBroker": "0067",
        "brokerName": "PURESTREAM, LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "PURP",
        "clearingBroker": "0279",
        "brokerName": "LIBERTY CAPITAL INVESTMENT CORPORATION                                "
    },
    {
        "type": "OTC",
        "mpid": "PWCP",
        "clearingBroker": "0534",
        "brokerName": "PICKWICK CAPITAL PARTNERS, LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "PWJC",
        "clearingBroker": "0221",
        "brokerName": "UBS FINANCIAL SERVICES INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "PWJX",
        "clearingBroker": "0221",
        "brokerName": "UBS FINANCIAL SERVICES INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "PXCJ",
        "clearingBroker": "0161",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "OTC",
        "mpid": "PXGA",
        "clearingBroker": "0551",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "PXGG",
        "clearingBroker": "0695",
        "brokerName": "JUMP TRADING                                                          "
    },
    {
        "type": "OTC",
        "mpid": "PXGJ",
        "clearingBroker": "0352",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "QAMM",
        "clearingBroker": "0294",
        "brokerName": "QUANTEX CLEARING, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "QBND",
        "clearingBroker": "0161",
        "brokerName": "MCAP LLC                                                              "
    },
    {
        "type": "OTC",
        "mpid": "QBSI",
        "clearingBroker": "0226",
        "brokerName": "GLEN EAGLE WEALTH, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "QCAP",
        "clearingBroker": "0235",
        "brokerName": "QUINT CAPITAL CORPORATION                                             "
    },
    {
        "type": "OTC",
        "mpid": "QCAS",
        "clearingBroker": "0226",
        "brokerName": "QUINCY CASS ASSOCIATES, INCORPORATED                                  "
    },
    {
        "type": "OTC",
        "mpid": "QGSB",
        "clearingBroker": "0158",
        "brokerName": "QUAESTOR GLOBAL SECURITIES, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "QLBR",
        "clearingBroker": "0695",
        "brokerName": "QUANTLAB BROKERAGE, LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "QMSR",
        "clearingBroker": "0235",
        "brokerName": "QUATTRO M SECURITIES INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "QMSX",
        "clearingBroker": "0294",
        "brokerName": "QUATTRO M SECURITIES INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "QNTX",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "QRQR",
        "clearingBroker": "0534",
        "brokerName": "QUANTRIVER FINANCIAL, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "QUES",
        "clearingBroker": "5084",
        "brokerName": "QUESTRADE INC./CDS                                                    "
    },
    {
        "type": "OTC",
        "mpid": "QUOI",
        "clearingBroker": "0279",
        "brokerName": "QUOIN CAPITAL LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "QWIK",
        "clearingBroker": "0161",
        "brokerName": "MCAP LLC                                                              "
    },
    {
        "type": "OTC",
        "mpid": "RAAA",
        "clearingBroker": "0052",
        "brokerName": "RICHARD JAMES & ASSOCIATES, INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "RAAI",
        "clearingBroker": "0226",
        "brokerName": "OSAIC WEALTH, INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "RABO",
        "clearingBroker": "0443",
        "brokerName": "RABO SECURITIES USA, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "RACO",
        "clearingBroker": "0158",
        "brokerName": "SHEARMAN, RALSTON, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "RAJA",
        "clearingBroker": "0725",
        "brokerName": "RAYMOND JAMES & ASSOCIATES, INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "RAYG",
        "clearingBroker": "0443",
        "brokerName": "BOLTON GLOBAL CAPITAL                                                 "
    },
    {
        "type": "OTC",
        "mpid": "RBAC",
        "clearingBroker": "0235",
        "brokerName": "ROBERT B. AUSDAL & CO. INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "RBCD",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS CORPORATION                                       "
    },
    {
        "type": "OTC",
        "mpid": "RBCF",
        "clearingBroker": "5002",
        "brokerName": "RBC DOMINION SECURITIES INC./CDS                                      "
    },
    {
        "type": "OTC",
        "mpid": "RBCM",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS CORPORATION                                       "
    },
    {
        "type": "OTC",
        "mpid": "RBCX",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS CORPORATION                                       "
    },
    {
        "type": "OTC",
        "mpid": "RBDG",
        "clearingBroker": "0158",
        "brokerName": "REDBRIDGE SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "RCKF",
        "clearingBroker": "0534",
        "brokerName": "ROCKFLEET FINANCIAL SERVICES, INC.                                    "
    },
    {
        "type": "OTC",
        "mpid": "RCMA",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS ARBITRAGE, S.A.                                   "
    },
    {
        "type": "OTC",
        "mpid": "RCMI",
        "clearingBroker": "0608",
        "brokerName": "DEALERWEB INC.                                                        "
    },
    {
        "type": "OTC",
        "mpid": "RDBN",
        "clearingBroker": "0443",
        "brokerName": "REDBURN PARTNERS (USA) LP                                             "
    },
    {
        "type": "OTC",
        "mpid": "RECA",
        "clearingBroker": "5029",
        "brokerName": "RESEARCH CAPITAL USA INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "REGN",
        "clearingBroker": "0443",
        "brokerName": "REGIONS SECURITIES LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "REGR",
        "clearingBroker": "0141",
        "brokerName": "REGISTER & AKERS INVESTMENTS, INC.                                    "
    },
    {
        "type": "OTC",
        "mpid": "REPP",
        "clearingBroker": "0226",
        "brokerName": "G. A. REPPLE & COMPANY                                                "
    },
    {
        "type": "OTC",
        "mpid": "REVE",
        "clearingBroker": "3450",
        "brokerName": "REVERE SECURITIES CORP.                                               "
    },
    {
        "type": "OTC",
        "mpid": "REVO",
        "clearingBroker": "2402",
        "brokerName": "REVOLUT SECURITIES INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "RFRC",
        "clearingBroker": "0279",
        "brokerName": "THE ROCKWELL FINANCIAL GROUP, INC.                                    "
    },
    {
        "type": "OTC",
        "mpid": "RGLD",
        "clearingBroker": "0279",
        "brokerName": "REGAL SECURITIES, INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "RGLS",
        "clearingBroker": "0235",
        "brokerName": "REGAL SECURITIES, INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "RHCO",
        "clearingBroker": "0226",
        "brokerName": "TRUIST SECURITIES, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "RHDS",
        "clearingBroker": "0141",
        "brokerName": "RHODES SECURITIES, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "RHOX",
        "clearingBroker": "0005",
        "brokerName": "XR SECURITIES LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "RIAN",
        "clearingBroker": "0226",
        "brokerName": "OSAIC SERVICES, INC.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "RICD",
        "clearingBroker": "4305",
        "brokerName": "RICE FINANCIAL PRODUCTS COMPANY                                       "
    },
    {
        "type": "OTC",
        "mpid": "RICJ",
        "clearingBroker": "0235",
        "brokerName": "RICE SECURITIES, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "RICM",
        "clearingBroker": "0595",
        "brokerName": "RICE FINANCIAL PRODUCTS COMPANY                                       "
    },
    {
        "type": "OTC",
        "mpid": "RIED",
        "clearingBroker": "0235",
        "brokerName": "RIEDL, FIRST SECURITIES COMPANY OF KANSAS                             "
    },
    {
        "type": "OTC",
        "mpid": "RILY",
        "clearingBroker": "0226",
        "brokerName": "B. RILEY FBR, INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "RJFI",
        "clearingBroker": "0390",
        "brokerName": "RAYMOND JAMES & ASSOCIATES, INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "RKWS",
        "clearingBroker": "0235",
        "brokerName": "ROCKWELL SECURITIES LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "RLIN",
        "clearingBroker": "0005",
        "brokerName": "WELLS FARGO SECURITIES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "RMAC",
        "clearingBroker": "0235",
        "brokerName": "RENAISSANCE MACRO SECURITIES, LLC                                     "
    },
    {
        "type": "OTC",
        "mpid": "RMPI",
        "clearingBroker": "0141",
        "brokerName": "RICHARDS, MERRILL & PETERSON, INC.                                    "
    },
    {
        "type": "OTC",
        "mpid": "RNYB",
        "clearingBroker": "3350",
        "brokerName": "ROYAL BANK OF CANADA, WFC BRANCH                                      "
    },
    {
        "type": "OTC",
        "mpid": "ROBT",
        "clearingBroker": "0443",
        "brokerName": "ROBOTTI & COMPANY, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "ROCK",
        "clearingBroker": "0226",
        "brokerName": "ROCKEFELLER FINANCIAL LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "ROCM",
        "clearingBroker": "0443",
        "brokerName": "RIM SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "RODM",
        "clearingBroker": "1043",
        "brokerName": "RODMAN & RENSHAW, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "ROMO",
        "clearingBroker": "0141",
        "brokerName": "ROMANO BROTHERS AND COMPANY                                           "
    },
    {
        "type": "OTC",
        "mpid": "RONI",
        "clearingBroker": "0005",
        "brokerName": "RONIN CAPITAL, LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "ROSN",
        "clearingBroker": "0443",
        "brokerName": "ROSENBLATT SECURITIES INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "ROTB",
        "clearingBroker": "0235",
        "brokerName": "ROTH CAPITAL PARTNERS, LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "ROTH",
        "clearingBroker": "0161",
        "brokerName": "ROTH CAPITAL PARTNERS, LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "RPTR",
        "clearingBroker": "0235",
        "brokerName": "DINOSAUR SECURITIES, L.L.C.                                           "
    },
    {
        "type": "OTC",
        "mpid": "RQDR",
        "clearingBroker": "0235",
        "brokerName": "RQD* CLEARING LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "RREZ",
        "clearingBroker": "0443",
        "brokerName": "SAMUEL A RAMIREZ & CO., INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "RRUD",
        "clearingBroker": "0235",
        "brokerName": "REID & RUDIGER, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "RSCM",
        "clearingBroker": "0235",
        "brokerName": "ROBERTSON STEPHENS CAPITAL MARKETS, LLC                               "
    },
    {
        "type": "OTC",
        "mpid": "RSKY",
        "clearingBroker": "0695",
        "brokerName": "ITG DERIVATIVES, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "RSSE",
        "clearingBroker": "0443",
        "brokerName": "RUSSELL IMPLEMENTATION SERVICES INC. PART OF RUSSE                    "
    },
    {
        "type": "OTC",
        "mpid": "RTHS",
        "clearingBroker": "0443",
        "brokerName": "ROTHSCHILD INVESTMENT CORPORATION                                     "
    },
    {
        "type": "OTC",
        "mpid": "RWPS",
        "clearingBroker": "0443",
        "brokerName": "R.W. PRESSPRICH & CO.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "RWSM",
        "clearingBroker": "0279",
        "brokerName": "R.W. SMITH & ASSOCIATES, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "RYDS",
        "clearingBroker": "0235",
        "brokerName": "RBC DOMINION SECURITIES CORPORATION                                   "
    },
    {
        "type": "OTC",
        "mpid": "SAFS",
        "clearingBroker": "0750",
        "brokerName": "STERNE AGEE FINANCIAL SERVICES, INC.                                  "
    },
    {
        "type": "OTC",
        "mpid": "SAFX",
        "clearingBroker": "0235",
        "brokerName": "SAF FINANCIAL SECURITIES LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "SAGE",
        "clearingBroker": "0141",
        "brokerName": "SAGE, RUTTY & CO., INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "SAGL",
        "clearingBroker": "9132",
        "brokerName": "SAGETRADER LLC                                                        "
    },
    {
        "type": "OTC",
        "mpid": "SAGP",
        "clearingBroker": "8199",
        "brokerName": "SAGETRADER, LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "SAGR",
        "clearingBroker": "4305",
        "brokerName": "SAGETRADER, LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "SAGT",
        "clearingBroker": "3856",
        "brokerName": "SAGETRADER, LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "SAKL",
        "clearingBroker": "0279",
        "brokerName": "DMK ADVISORS GROUP, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "SALI",
        "clearingBroker": "0750",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "SALL",
        "clearingBroker": "0534",
        "brokerName": "SUPREME ALLIANCE LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "SAMI",
        "clearingBroker": "0226",
        "brokerName": "SAMI BROKERAGE LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "SANC",
        "clearingBroker": "3499",
        "brokerName": "SANTANDER US CAPITAL MARKETS LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "SANT",
        "clearingBroker": "0443",
        "brokerName": "SANTANDER US CAPITAL MARKETS LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "SARG",
        "clearingBroker": "0226",
        "brokerName": "PURSHE KAPLAN STERLING INVESTMENTS, INC.                              "
    },
    {
        "type": "OTC",
        "mpid": "SBER",
        "clearingBroker": "0013",
        "brokerName": "SANFORD C. BERNSTEIN & CO., LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "SBLS",
        "clearingBroker": "0235",
        "brokerName": "SAN BLAS SECURITIES LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "SBLT",
        "clearingBroker": "0226",
        "brokerName": "SUNBELT SECURITIES, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "SBRO",
        "clearingBroker": "0443",
        "brokerName": "STERN BROTHERS & CO.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "SBRT",
        "clearingBroker": "0226",
        "brokerName": "SIEBERT(MURIEL) & CO.,INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "SBRX",
        "clearingBroker": "0445",
        "brokerName": "MURIEL SIEBERT & CO., INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "SBSC",
        "clearingBroker": "0226",
        "brokerName": "SIEBERT CISNEROS SHANK & CO., L.L.C.                                  "
    },
    {
        "type": "OTC",
        "mpid": "SBSH",
        "clearingBroker": "0505",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "SBSI",
        "clearingBroker": "0103",
        "brokerName": "SUN'S BROTHERS SECURITIES INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "SBSL",
        "clearingBroker": "1043",
        "brokerName": "STOCKBLOCK SECURITIES LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "SCAP",
        "clearingBroker": "0595",
        "brokerName": "STRONG CAPITAL MARKETS, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "SCBO",
        "clearingBroker": "0013",
        "brokerName": "SANFORD C. BERNSTEIN & CO., LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "SCBT",
        "clearingBroker": "0013",
        "brokerName": "SANFORD C. BERNSTEIN & CO., LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "SCIL",
        "clearingBroker": "0052",
        "brokerName": "STRATEGIC CAPITAL INVESTMENTS, LLC                                    "
    },
    {
        "type": "OTC",
        "mpid": "SCMC",
        "clearingBroker": "0096",
        "brokerName": "SCOTIA CAPITAL MARKETS (USA) INC.                                     "
    },
    {
        "type": "OTC",
        "mpid": "SCMF",
        "clearingBroker": "5011",
        "brokerName": "SCOTIA CAPITAL INC./CDS                                               "
    },
    {
        "type": "OTC",
        "mpid": "SCSI",
        "clearingBroker": "0370",
        "brokerName": "STANDARD CREDIT SECURITIES INC.                                       "
    },
    {
        "type": "OTC",
        "mpid": "SCSS",
        "clearingBroker": "0750",
        "brokerName": "STONECASTLE SECURITIES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "SDIC",
        "clearingBroker": "0235",
        "brokerName": "SAUER DAZEY INVESTMENT CO.                                            "
    },
    {
        "type": "OTC",
        "mpid": "SEAP",
        "clearingBroker": "0226",
        "brokerName": "SEAPORT SECURITIES CORP.                                              "
    },
    {
        "type": "OTC",
        "mpid": "SEBR",
        "clearingBroker": "0158",
        "brokerName": "SENTINEL BROKERS COMPANY, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "SEEL",
        "clearingBroker": "0443",
        "brokerName": "R. SEELAUS & CO., INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "SEFB",
        "clearingBroker": "0052",
        "brokerName": "SOUTHEAST INVESTMENTS, N.C., INC.                                     "
    },
    {
        "type": "OTC",
        "mpid": "SEIB",
        "clearingBroker": "0158",
        "brokerName": "SEIBERT (J.D.) & COMPANY INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "SEIC",
        "clearingBroker": "0295",
        "brokerName": "SEI INVESTMENTS DISTRIBUTION CO.                                      "
    },
    {
        "type": "OTC",
        "mpid": "SEID",
        "clearingBroker": "0388",
        "brokerName": "SEIDEL & SHAW LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "SEIF",
        "clearingBroker": "0696",
        "brokerName": "SEI INVESTMENTS DISTRIBUTION CO.                                      "
    },
    {
        "type": "OTC",
        "mpid": "SEMT",
        "clearingBroker": "7311",
        "brokerName": "MINT BROKERS                                                          "
    },
    {
        "type": "OTC",
        "mpid": "SERL",
        "clearingBroker": "0443",
        "brokerName": "SEARLE & CO.                                                          "
    },
    {
        "type": "OTC",
        "mpid": "SETX",
        "clearingBroker": "0695",
        "brokerName": "ABN AMRO CLEARING USA LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "SFGB",
        "clearingBroker": "0161",
        "brokerName": "SUSQUEHANNA FINANCIAL GROUP, LLP                                      "
    },
    {
        "type": "OTC",
        "mpid": "SFSI",
        "clearingBroker": "0235",
        "brokerName": "SUPERIOR FINANCIAL SERVICES, INC.                                     "
    },
    {
        "type": "OTC",
        "mpid": "SGAL",
        "clearingBroker": "0534",
        "brokerName": "S. GOLDMAN ADVISORS, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "SGAS",
        "clearingBroker": "0286",
        "brokerName": "SG AMERICAS SECURITIES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "SGBI",
        "clearingBroker": "0226",
        "brokerName": "SMITH, BROWN & GROOVER, INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "SGFC",
        "clearingBroker": "0226",
        "brokerName": "SIGMA FINANCIAL CORPORATION                                           "
    },
    {
        "type": "OTC",
        "mpid": "SGLC",
        "clearingBroker": "0235",
        "brokerName": "S.G. LONG & COMPANY                                                   "
    },
    {
        "type": "OTC",
        "mpid": "SGMA",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS EXECUTION & CLEARING, L.P.                              "
    },
    {
        "type": "OTC",
        "mpid": "SGMT",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "SGNL",
        "clearingBroker": "0279",
        "brokerName": "SIGNAL SECURITIES, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "SGOV",
        "clearingBroker": "0286",
        "brokerName": "SG AMERICAS SECURITIES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "SGSM",
        "clearingBroker": "1043",
        "brokerName": "SEAPORT GLOBAL SECURITIES LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "SHMR",
        "clearingBroker": "0695",
        "brokerName": "ABN AMRO CLEARING USA LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "SHOT",
        "clearingBroker": "0005",
        "brokerName": "SCHOTTENFELD GROUP LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "SHYR",
        "clearingBroker": "0158",
        "brokerName": "STERLINGSHIRE INVESTMENTS                                             "
    },
    {
        "type": "OTC",
        "mpid": "SIBO",
        "clearingBroker": "8199",
        "brokerName": "PRIME EXECUTIONS, INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "SILC",
        "clearingBroker": "0158",
        "brokerName": "SOCIAL INVSTR                                                         "
    },
    {
        "type": "OTC",
        "mpid": "SILK",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS EXECUTION & CLEARING, L.P.                              "
    },
    {
        "type": "OTC",
        "mpid": "SIMP",
        "clearingBroker": "0551",
        "brokerName": "SIMPLEX TRADING, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "SKTR",
        "clearingBroker": "0279",
        "brokerName": "STOCK TRADERS                                                         "
    },
    {
        "type": "OTC",
        "mpid": "SLRD",
        "clearingBroker": "0226",
        "brokerName": "S.L. REED & COMPANY                                                   "
    },
    {
        "type": "OTC",
        "mpid": "SMCO",
        "clearingBroker": "0235",
        "brokerName": "SMITH, MOORE & CO.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "SMHI",
        "clearingBroker": "0443",
        "brokerName": "SANDERS MORRIS HARRIS INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "SMNS",
        "clearingBroker": "0226",
        "brokerName": "PARKLAND SECURITIES, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "SMPX",
        "clearingBroker": "0695",
        "brokerName": "SIMPLEX TRADING, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "SMRD",
        "clearingBroker": "0443",
        "brokerName": "SUMRIDGE PARTNERS, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "SMRI",
        "clearingBroker": "0226",
        "brokerName": "SECURITIES MANAGEMENT & RESEARCH, INC.                                "
    },
    {
        "type": "OTC",
        "mpid": "SNCC",
        "clearingBroker": "0534",
        "brokerName": "SNC CAPITAL MANAGEMENT CORP.                                          "
    },
    {
        "type": "OTC",
        "mpid": "SNEX",
        "clearingBroker": "0750",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "SOCO",
        "clearingBroker": "0443",
        "brokerName": "CAPITAL ONE SECURITIES, INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "SOFI",
        "clearingBroker": "0158",
        "brokerName": "SOFI SECURITIES LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "SOGO",
        "clearingBroker": "0158",
        "brokerName": "WANG INVESTMENT ASSOCIATES, INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "SOHO",
        "clearingBroker": "0161",
        "brokerName": "TWO SIGMA SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "SORS",
        "clearingBroker": "0235",
        "brokerName": "SORSBY FINANCIAL CORP.                                                "
    },
    {
        "type": "OTC",
        "mpid": "SOVG",
        "clearingBroker": "8199",
        "brokerName": "SOVEREIGN GLOBAL ADVISORS, LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "SPAC",
        "clearingBroker": "0793",
        "brokerName": "SIERRA PACIFIC SECURITIES, LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "SPBR",
        "clearingBroker": "3856",
        "brokerName": "SPRINKLEBROKERAGE, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "SPCS",
        "clearingBroker": "0052",
        "brokerName": "SPARTAN CAPITAL SECURITIES, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "SPCX",
        "clearingBroker": "8199",
        "brokerName": "SCORE PRIORITY CORP.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "SPEX",
        "clearingBroker": "0235",
        "brokerName": "INSPEREX LLC                                                          "
    },
    {
        "type": "OTC",
        "mpid": "SPFI",
        "clearingBroker": "2402",
        "brokerName": "NORTHBOUND SECURITIES LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "SPGS",
        "clearingBroker": "0443",
        "brokerName": "SEAPORT GLOBAL SECURITIES LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "SPHN",
        "clearingBroker": "0443",
        "brokerName": "STEPHENS INC.                                                         "
    },
    {
        "type": "OTC",
        "mpid": "SPLC",
        "clearingBroker": "0226",
        "brokerName": "SPIRE SECURITIES, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "SPLN",
        "clearingBroker": "8199",
        "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "SPLX",
        "clearingBroker": "0695",
        "brokerName": "SIMPLEX TRADING, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "SPNN",
        "clearingBroker": "0052",
        "brokerName": "SPARTAN CAPITAL SECURITIES, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "SPOT",
        "clearingBroker": "0005",
        "brokerName": "SPOT TRADING                                                          "
    },
    {
        "type": "OTC",
        "mpid": "SPTD",
        "clearingBroker": "0052",
        "brokerName": "MINT GLOBAL MARKETS, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "SPTS",
        "clearingBroker": "0158",
        "brokerName": "SEVEN POINTS CAPITAL, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "SRBC",
        "clearingBroker": "0235",
        "brokerName": "SPIDERROCK EXS, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "SRPT",
        "clearingBroker": "9132",
        "brokerName": "SPEEDROUTE LLC                                                        "
    },
    {
        "type": "OTC",
        "mpid": "SSBS",
        "clearingBroker": "0189",
        "brokerName": "STATE STREET GLOBAL MARKETS, LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "SSCO",
        "clearingBroker": "8457",
        "brokerName": "SAFRA SECURITIES LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "SSEI",
        "clearingBroker": "0824",
        "brokerName": "SEI INVESTMENTS DISTRIBUTION CO.                                      "
    },
    {
        "type": "OTC",
        "mpid": "SSGC",
        "clearingBroker": "0226",
        "brokerName": "SIGNATURE SECURITIES                                                  "
    },
    {
        "type": "OTC",
        "mpid": "SSGM",
        "clearingBroker": "0226",
        "brokerName": "STATE STREET GLOBAL MARKETS, LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "SSGR",
        "clearingBroker": "0443",
        "brokerName": "SHAREHOLDERS SERVICES GROUP INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "SSIN",
        "clearingBroker": "0226",
        "brokerName": "TRUIST INVESTMENT SERVICES, INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "SSLC",
        "clearingBroker": "0279",
        "brokerName": "SANDERLIN SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "SSLL",
        "clearingBroker": "0189",
        "brokerName": "STATE STREET GLOBAL MARKETS, LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "SSNE",
        "clearingBroker": "0226",
        "brokerName": "SANTANDER SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "SSUS",
        "clearingBroker": "0551",
        "brokerName": "SUSQUEHANNA SECURITIES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "STEP",
        "clearingBroker": "0235",
        "brokerName": "FERRETTI GROUP, INC.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "STFC",
        "clearingBroker": "0443",
        "brokerName": "STUART FRANKEL & CO., INCORPORATED                                    "
    },
    {
        "type": "OTC",
        "mpid": "STFL",
        "clearingBroker": "0793",
        "brokerName": "STIFEL, NICOLAUS & COMPANY, INCORPORATED                              "
    },
    {
        "type": "OTC",
        "mpid": "STFX",
        "clearingBroker": "0793",
        "brokerName": "STIFEL, NICOLAUS & COMPANY, INCORPORATED                              "
    },
    {
        "type": "OTC",
        "mpid": "STGC",
        "clearingBroker": "0279",
        "brokerName": "STERLING GRACE MUNICIPAL SECURITIES CO                                "
    },
    {
        "type": "OTC",
        "mpid": "STHR",
        "clearingBroker": "0388",
        "brokerName": "STORMHARBOUR SECURITIES LP                                            "
    },
    {
        "type": "OTC",
        "mpid": "STKP",
        "clearingBroker": "0158",
        "brokerName": "STOCKPILE INVESTMENTS, INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "STNH",
        "clearingBroker": "0534",
        "brokerName": "STONEHAVEN, LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "STOX",
        "clearingBroker": "0445",
        "brokerName": "MURIEL SIEBERT & CO., LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "STRM",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "OTC",
        "mpid": "STRS",
        "clearingBroker": "0161",
        "brokerName": "STRATEGAS RESEARCH PARTNERS, LLC                                      "
    },
    {
        "type": "OTC",
        "mpid": "STSB",
        "clearingBroker": "3856",
        "brokerName": "SOUTHERN TRUST SECURITIES, INC.                                       "
    },
    {
        "type": "OTC",
        "mpid": "STSH",
        "clearingBroker": "0158",
        "brokerName": "STASH CAPITAL LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "STSV",
        "clearingBroker": "3856",
        "brokerName": "SOUTHERN TRUST SECURITIES, INC.                                       "
    },
    {
        "type": "OTC",
        "mpid": "STTT",
        "clearingBroker": "0052",
        "brokerName": "STATETRUST INVESTMENTS INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "STUR",
        "clearingBroker": "0158",
        "brokerName": "STURDIVANT & CO., INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "STXG",
        "clearingBroker": "0445",
        "brokerName": "MURIEL SIEBERT & CO., INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "SUFI",
        "clearingBroker": "0551",
        "brokerName": "SUSQUEHANNA FINANCIAL GROUP, LLP                                      "
    },
    {
        "type": "OTC",
        "mpid": "SUMI",
        "clearingBroker": "0443",
        "brokerName": "SMBC NIKKO SECURITIES AMERICA, INC.                                   "
    },
    {
        "type": "OTC",
        "mpid": "SUNX",
        "clearingBroker": "0695",
        "brokerName": "ABN AMRO CLEARING CHICAGO LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "SUSQ",
        "clearingBroker": "0551",
        "brokerName": "SUSQUEHANNA FINANCIAL GROUP, LLP                                      "
    },
    {
        "type": "OTC",
        "mpid": "SUST",
        "clearingBroker": "0235",
        "brokerName": "SUNSTREET SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "SVBS",
        "clearingBroker": "0443",
        "brokerName": "SVB SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "SWSS",
        "clearingBroker": "0443",
        "brokerName": "SANCTUARY SECURITIES, INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "SWST",
        "clearingBroker": "0279",
        "brokerName": "HILLTOP SECURITIES INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "TAGB",
        "clearingBroker": "0052",
        "brokerName": "TAGLICH BROTHERS, INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "TAGC",
        "clearingBroker": "1043",
        "brokerName": "TELSEY ADVISORY GROUP LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "TAGD",
        "clearingBroker": "1043",
        "brokerName": "TELSEY ADVISORY GROUP LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "TAIQ",
        "clearingBroker": "8199",
        "brokerName": "THINK ALPHA SECURITIES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "TAPP",
        "clearingBroker": "0294",
        "brokerName": "TAPP ENGINE SECURITIES                                                "
    },
    {
        "type": "OTC",
        "mpid": "TAPR",
        "clearingBroker": "4305",
        "brokerName": "TAPP ENGINE SECURITIES                                                "
    },
    {
        "type": "OTC",
        "mpid": "TBCL",
        "clearingBroker": "0750",
        "brokerName": "TRADE BRIDGE CAPITAL LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "TBCR",
        "clearingBroker": "0235",
        "brokerName": "TRADE BRIDGE CAPITAL LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "TBGO",
        "clearingBroker": "4305",
        "brokerName": "TRADINGBLOCK                                                          "
    },
    {
        "type": "OTC",
        "mpid": "TBIA",
        "clearingBroker": "0158",
        "brokerName": "TRADIER BROKERAGE, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "TBIS",
        "clearingBroker": "0158",
        "brokerName": "TRADIER BROKERAGE, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "TBLK",
        "clearingBroker": "4305",
        "brokerName": "TRADINGBLOCK                                                          "
    },
    {
        "type": "OTC",
        "mpid": "TBRD",
        "clearingBroker": "0226",
        "brokerName": "THOROUGHBRED FINANCIAL SERVICES, LLC                                  "
    },
    {
        "type": "OTC",
        "mpid": "TBRO",
        "clearingBroker": "8199",
        "brokerName": "TUOHY BROTHERS INVESTMENT RESEARCH, INC.                              "
    },
    {
        "type": "OTC",
        "mpid": "TCBI",
        "clearingBroker": "0443",
        "brokerName": "TCBI SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "TDCO",
        "clearingBroker": "0235",
        "brokerName": "THOMPSON DAVIS & CO., INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "TDED",
        "clearingBroker": "0284",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "TDFS",
        "clearingBroker": "0052",
        "brokerName": "TRADERFIELD SECURITIES INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "TDFV",
        "clearingBroker": "0294",
        "brokerName": "TRADERFIELD SECURITIES INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "TDNF",
        "clearingBroker": "2568",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "TDSI",
        "clearingBroker": "0226",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "TFAI",
        "clearingBroker": "0226",
        "brokerName": "TRANSAMERICA FINANCIAL ADVISORS, INC.                                 "
    },
    {
        "type": "OTC",
        "mpid": "TFAS",
        "clearingBroker": "0443",
        "brokerName": "TRADITION SECURITIES AND DERIVATIVES LLC                              "
    },
    {
        "type": "OTC",
        "mpid": "TFSL",
        "clearingBroker": "0235",
        "brokerName": "TECKMEYER FINANCIAL SERVICES                                          "
    },
    {
        "type": "OTC",
        "mpid": "THEM",
        "clearingBroker": "0235",
        "brokerName": "THEMIS TRADING LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "THNK",
        "clearingBroker": "0052",
        "brokerName": "THINKEQUITY, LLC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "TIAD",
        "clearingBroker": "8199",
        "brokerName": "TRIAD SECURITIES CORP                                                 "
    },
    {
        "type": "OTC",
        "mpid": "TIAN",
        "clearingBroker": "0226",
        "brokerName": "TRIAD SECURITIES CORP                                                 "
    },
    {
        "type": "OTC",
        "mpid": "TIGC",
        "clearingBroker": "0235",
        "brokerName": "NELSONREID, INC.                                                      "
    },
    {
        "type": "OTC",
        "mpid": "TIGE",
        "clearingBroker": "1043",
        "brokerName": "US TIGER SECURITIES, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "TIRE",
        "clearingBroker": "0695",
        "brokerName": "JUMP TRADING                                                          "
    },
    {
        "type": "OTC",
        "mpid": "TJMI",
        "clearingBroker": "9132",
        "brokerName": "TJM INVESTMENTS, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "TKEQ",
        "clearingBroker": "1186",
        "brokerName": "FORDHAM FINANCIAL MANAGEMENT, INC.                                    "
    },
    {
        "type": "OTC",
        "mpid": "TKNG",
        "clearingBroker": "0158",
        "brokerName": "TRADEKING LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "TLSA",
        "clearingBroker": "4230",
        "brokerName": "TRADELINK SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "TMAS",
        "clearingBroker": "0235",
        "brokerName": "TRADEMAS INC.                                                         "
    },
    {
        "type": "OTC",
        "mpid": "TMBI",
        "clearingBroker": "0141",
        "brokerName": "THURSTON SPRINGER FINANCIAL                                           "
    },
    {
        "type": "OTC",
        "mpid": "TMBR",
        "clearingBroker": "0534",
        "brokerName": "IBKR SECURITIES SERVICES LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "TMCD",
        "clearingBroker": "0235",
        "brokerName": "MCDONALD PARTNERS LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "TMIN",
        "clearingBroker": "0443",
        "brokerName": "TRADITION SECURITIES AND DERIVATIVES LLC                              "
    },
    {
        "type": "OTC",
        "mpid": "TOCQ",
        "clearingBroker": "0443",
        "brokerName": "TOCQUEVILLE SECURITIES L.P.                                           "
    },
    {
        "type": "OTC",
        "mpid": "TONE",
        "clearingBroker": "8199",
        "brokerName": "2021 CAPITAL                                                          "
    },
    {
        "type": "OTC",
        "mpid": "TORB",
        "clearingBroker": "0294",
        "brokerName": "TOR BROKERAGE LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "TORM",
        "clearingBroker": "0294",
        "brokerName": "TOR BROKERAGE LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "TOUR",
        "clearingBroker": "0005",
        "brokerName": "TOURMALINE PARTNERS, LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "TPIS",
        "clearingBroker": "0161",
        "brokerName": "TULLETT PREBON FINANCIAL SERVICES, LLC                                "
    },
    {
        "type": "OTC",
        "mpid": "TPMG",
        "clearingBroker": "0005",
        "brokerName": "TOWER PRINCIPAL MARKETS LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "TPMR",
        "clearingBroker": "0141",
        "brokerName": "TRADE-PMR INC.                                                        "
    },
    {
        "type": "OTC",
        "mpid": "TPMX",
        "clearingBroker": "0695",
        "brokerName": "TOWER PRINCIPAL MARKETS LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "TPRO",
        "clearingBroker": "4305",
        "brokerName": "TRADEPRO SECURITIES, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "TPTG",
        "clearingBroker": "2402",
        "brokerName": "CASH APP INVESTING LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "TPVC",
        "clearingBroker": "0294",
        "brokerName": "TRADEPRO SECURITIES,INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "TRAD",
        "clearingBroker": "0271",
        "brokerName": "TRADESTATION SECURITIES, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "TRBT",
        "clearingBroker": "0083",
        "brokerName": "TRADEBOT SYSTEMS, INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "TRCG",
        "clearingBroker": "0005",
        "brokerName": "TRC MARKETS LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "TRCJ",
        "clearingBroker": "0352",
        "brokerName": "TRC MARKETS LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "TRCM",
        "clearingBroker": "0695",
        "brokerName": "TRC MARKETS LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "TRCS",
        "clearingBroker": "0388",
        "brokerName": "TIGERRISK CAPITAL MARKETS & ADVISORY                                  "
    },
    {
        "type": "OTC",
        "mpid": "TRCX",
        "clearingBroker": "0695",
        "brokerName": "TRC MARKETS LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "TREX",
        "clearingBroker": "1043",
        "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
    },
    {
        "type": "OTC",
        "mpid": "TRIB",
        "clearingBroker": "0235",
        "brokerName": "TRIBAL CAPITAL MARKETS, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "TRIM",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "TRIP",
        "clearingBroker": "0235",
        "brokerName": "TRIDENT PARTNERS LTD                                                  "
    },
    {
        "type": "OTC",
        "mpid": "TRLN",
        "clearingBroker": "4230",
        "brokerName": "TRADELINK SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "TRMZ",
        "clearingBroker": "0161",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "TRSH",
        "clearingBroker": "0279",
        "brokerName": "THRASHER & CHAMBERS, INC.                                             "
    },
    {
        "type": "OTC",
        "mpid": "TRSQ",
        "clearingBroker": "0443",
        "brokerName": "TOWER SQUARE SECURITIES, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "TRUB",
        "clearingBroker": "0141",
        "brokerName": "TRUBEE, COLLINS & CO., INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "TRWN",
        "clearingBroker": "0443",
        "brokerName": "T.R. WINSTON & COMPANY, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "TRYC",
        "clearingBroker": "0158",
        "brokerName": "SIXTEEN SECURITIES, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "TRYN",
        "clearingBroker": "0279",
        "brokerName": "FIRST TRYON SECURITIES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "TSCD",
        "clearingBroker": "0235",
        "brokerName": "STURGES COMPANY (THE)                                                 "
    },
    {
        "type": "OTC",
        "mpid": "TSER",
        "clearingBroker": "0161",
        "brokerName": "TWO SIGMA EXECUTION SERVICES, LLC                                     "
    },
    {
        "type": "OTC",
        "mpid": "TSSM",
        "clearingBroker": "0161",
        "brokerName": "TWO SIGMA SECURITIES, LLC                                             "
    },
    {
        "type": "OTC",
        "mpid": "TTCS",
        "clearingBroker": "9132",
        "brokerName": "T3 TRADING GROUP, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "TTSC",
        "clearingBroker": "0052",
        "brokerName": "TREND TRADE SECURITIES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "TTSI",
        "clearingBroker": "0158",
        "brokerName": "T3 SECURITIES, INC.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "TTTG",
        "clearingBroker": "0294",
        "brokerName": "T3 TRADING GROUP, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "TTTS",
        "clearingBroker": "0158",
        "brokerName": "T3 SECURITIES, INC.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "TWDP",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "TWTT",
        "clearingBroker": "0158",
        "brokerName": "TASTYWORKS, INC.                                                      "
    },
    {
        "type": "OTC",
        "mpid": "TWXS",
        "clearingBroker": "0161",
        "brokerName": "TRADEWORX SECURITIES LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "TYLO",
        "clearingBroker": "1186",
        "brokerName": "DOUGALL & ASSOCIATES                                                  "
    },
    {
        "type": "OTC",
        "mpid": "TZCL",
        "clearingBroker": "0712",
        "brokerName": "TZ CLEAR LLC                                                          "
    },
    {
        "type": "OTC",
        "mpid": "UBII",
        "clearingBroker": "0221",
        "brokerName": "UBS INTERNATIONAL, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "UBSA",
        "clearingBroker": "0642",
        "brokerName": "UBS SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "UBSB",
        "clearingBroker": "0642",
        "brokerName": "UBS SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "UBSI",
        "clearingBroker": "0141",
        "brokerName": "UNITED BROKERAGE SERVICES, INC                                        "
    },
    {
        "type": "OTC",
        "mpid": "UBSS",
        "clearingBroker": "0642",
        "brokerName": "UBS SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "UBSW",
        "clearingBroker": "0642",
        "brokerName": "UBS SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "UBSX",
        "clearingBroker": "0642",
        "brokerName": "UBS SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "UCAP",
        "clearingBroker": "0750",
        "brokerName": "UCAP SECURITIES LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "UCCM",
        "clearingBroker": "0279",
        "brokerName": "CU INVESTMENT SOLUTIONS, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "UCML",
        "clearingBroker": "0052",
        "brokerName": "UNITED CAPITAL MARKETS, INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "UFPF",
        "clearingBroker": "0226",
        "brokerName": "UNITED FIRST PARTNERS, LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "UHLM",
        "clearingBroker": "0235",
        "brokerName": "UHLMANN PRICE SECURITIES, LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "UMBF",
        "clearingBroker": "0226",
        "brokerName": "UMB FINANCIAL SERVICES, INC.                                          "
    },
    {
        "type": "OTC",
        "mpid": "UNIS",
        "clearingBroker": "3450",
        "brokerName": "UNIVEST SECURITIES, LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "UNIV",
        "clearingBroker": "3856",
        "brokerName": "UNIVEST SECURITIES, LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "UPLN",
        "clearingBroker": "0443",
        "brokerName": "UNITED PLANNERS FINANCIAL SERVICES OF AMERICA                         "
    },
    {
        "type": "OTC",
        "mpid": "USCA",
        "clearingBroker": "0226",
        "brokerName": "USCA SECURITIES LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "USDB",
        "clearingBroker": "0279",
        "brokerName": "U.S. BROKERAGE, INC.                                                  "
    },
    {
        "type": "OTC",
        "mpid": "USEC",
        "clearingBroker": "3450",
        "brokerName": "UNIVEST SECURITIES, LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "USFB",
        "clearingBroker": "0595",
        "brokerName": "U.S. FINANCIAL INVESTMENTS, INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "USIC",
        "clearingBroker": "0226",
        "brokerName": "U.S. SECURITIES, INTL. CORP.                                          "
    },
    {
        "type": "OTC",
        "mpid": "USLF",
        "clearingBroker": "5075",
        "brokerName": "PI FINANCIAL CORP.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "USSI",
        "clearingBroker": "0279",
        "brokerName": "U.S. STERLING SECURITIES, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "USTZ",
        "clearingBroker": "0595",
        "brokerName": "TRADEZERO AMERINCA, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "UVUV",
        "clearingBroker": "0161",
        "brokerName": "ULTRAVIOLET SECURITIES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "VALA",
        "clearingBroker": "0294",
        "brokerName": "VALUABLE CAPITAL SECURITIES                                           "
    },
    {
        "type": "OTC",
        "mpid": "VALD",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "VALI",
        "clearingBroker": "0226",
        "brokerName": "VALLEY NATIONAL INVESTMENTS, INC.                                     "
    },
    {
        "type": "OTC",
        "mpid": "VALR",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "VALU",
        "clearingBroker": "0294",
        "brokerName": "VALUABLE CAPITAL SECURITIES                                           "
    },
    {
        "type": "OTC",
        "mpid": "VALX",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "VBLT",
        "clearingBroker": "0226",
        "brokerName": "VANDERBILT SECURITIES, LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "VBSL",
        "clearingBroker": "0595",
        "brokerName": "VISION BROKERAGE SERVICES, LLC                                        "
    },
    {
        "type": "OTC",
        "mpid": "VCAB",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCAX",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCBB",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCBR",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CAPITAL, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "VCBY",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCCA",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCEC",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCEL",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCEX",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCFL",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCFN",
        "clearingBroker": "0235",
        "brokerName": "VAN CLEMENS & CO. INCORPORATED                                        "
    },
    {
        "type": "OTC",
        "mpid": "VCFS",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCGD",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCGL",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCGO",
        "clearingBroker": "0005",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCGP",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCGS",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCGT",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCIM",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCIN",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCIT",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCKW",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCLT",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCMA",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCPR",
        "clearingBroker": "4424",
        "brokerName": "VELOCITY CAPITAL, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "VCPS",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCRB",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCSG",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCSH",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCSK",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCSM",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCSO",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCSS",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCST",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCSV",
        "clearingBroker": "0052",
        "brokerName": "PRIMARY CAPITAL, LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "VCTC",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCTH",
        "clearingBroker": "6019",
        "brokerName": "VELOCITY CAPITAL LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "VCTP",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCTS",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCTY",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCUG",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCUH",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCUS",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCVL",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCVS",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCVT",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCVU",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCVV",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCVW",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCWC",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCWP",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VCWS",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VEAA",
        "clearingBroker": "3856",
        "brokerName": "VELOX CLEARING LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "VEAB",
        "clearingBroker": "3856",
        "brokerName": "VELOX CLEARING LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "VEAD",
        "clearingBroker": "3856",
        "brokerName": "VELOX CLEARING LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "VEAE",
        "clearingBroker": "3856",
        "brokerName": "VELOX CLEARING LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "VEAF",
        "clearingBroker": "3856",
        "brokerName": "VELOX CLEARING LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "VELC",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CAPITAL, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "VERF",
        "clearingBroker": "0235",
        "brokerName": "THE VERTICAL TRADING GROUP, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "VERT",
        "clearingBroker": "8199",
        "brokerName": "THE VERTICAL TRADING GROUP, LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "VESB",
        "clearingBroker": "0158",
        "brokerName": "VESTFI INC.                                                           "
    },
    {
        "type": "OTC",
        "mpid": "VEST",
        "clearingBroker": "0750",
        "brokerName": "VESTECH SECURITIES, INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "VETS",
        "clearingBroker": "0235",
        "brokerName": "AMERICAN VETERANS GROUP, PBC                                          "
    },
    {
        "type": "OTC",
        "mpid": "VFSI",
        "clearingBroker": "2402",
        "brokerName": "VF SECURITIES                                                         "
    },
    {
        "type": "OTC",
        "mpid": "VGRD",
        "clearingBroker": "0062",
        "brokerName": "VANGUARD MARKETING CORPORATION                                        "
    },
    {
        "type": "OTC",
        "mpid": "VHTO",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VIEW",
        "clearingBroker": "9132",
        "brokerName": "VIEWTRADE SECURITIES, INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "VIRT",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "VKMI",
        "clearingBroker": "0692",
        "brokerName": "INVESCO CAPITAL MARKETS, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "VLCT",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VLEO",
        "clearingBroker": "0158",
        "brokerName": "VOLEO USA, INC                                                        "
    },
    {
        "type": "OTC",
        "mpid": "VLET",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VLFX",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VLMM",
        "clearingBroker": "0294",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VLNT",
        "clearingBroker": "4305",
        "brokerName": "VOLANT SECURITIES, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "VLOX",
        "clearingBroker": "3856",
        "brokerName": "VELOX CLEARING LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "VMDI",
        "clearingBroker": "0443",
        "brokerName": "DESJARDINS SECURITIES INTERNATIONAL INC.                              "
    },
    {
        "type": "OTC",
        "mpid": "VNDM",
        "clearingBroker": "0443",
        "brokerName": "VANDHAM SECURITIES CORP.                                              "
    },
    {
        "type": "OTC",
        "mpid": "VNMS",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "VPEW",
        "clearingBroker": "0158",
        "brokerName": "VPE WERTPAPIERHANDELSBANK AG                                          "
    },
    {
        "type": "OTC",
        "mpid": "VRTG",
        "clearingBroker": "0695",
        "brokerName": "ABN AMRO CLEARING CHICAGO LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "VSIN",
        "clearingBroker": "0595",
        "brokerName": "VISION FINANCIAL MARKETS LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "VTDT",
        "clearingBroker": "0158",
        "brokerName": "VIEWTRADE SECURITIES, INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "VTRN",
        "clearingBroker": "0443",
        "brokerName": "BANCROFT CAPITAL, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "WABR",
        "clearingBroker": "0443",
        "brokerName": "WALL STREET ACCESS                                                    "
    },
    {
        "type": "OTC",
        "mpid": "WACC",
        "clearingBroker": "0279",
        "brokerName": "MIDLAND SECURITIES, LTD                                               "
    },
    {
        "type": "OTC",
        "mpid": "WACL",
        "clearingBroker": "0709",
        "brokerName": "WACHTEL & CO., INC.                                                   "
    },
    {
        "type": "OTC",
        "mpid": "WAIN",
        "clearingBroker": "1043",
        "brokerName": "H.C. WAINWRIGHT & CO., INC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "WBAX",
        "clearingBroker": "0052",
        "brokerName": "WALLACHBETH CAPITAL LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "WBBC",
        "clearingBroker": "0226",
        "brokerName": "WBB SECURITIES, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "WBET",
        "clearingBroker": "0161",
        "brokerName": "WALLACHBETH CAPITAL LLC                                               "
    },
    {
        "type": "OTC",
        "mpid": "WBLR",
        "clearingBroker": "0771",
        "brokerName": "WILLIAM BLAIR & COMPANY, L.L.C.                                       "
    },
    {
        "type": "OTC",
        "mpid": "WBNF",
        "clearingBroker": "0226",
        "brokerName": "WILLIAM BLAIR & COMPANY L.L.C.                                        "
    },
    {
        "type": "OTC",
        "mpid": "WBPA",
        "clearingBroker": "0161",
        "brokerName": "CLEAR STREET MARKETS LLC                                              "
    },
    {
        "type": "OTC",
        "mpid": "WBPX",
        "clearingBroker": "0551",
        "brokerName": "SUMMIT SECURITIES GROUP, LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "WBSI",
        "clearingBroker": "8199",
        "brokerName": "WEDBUSH SECURITIES INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "WBUL",
        "clearingBroker": "0158",
        "brokerName": "WEBULL FINANCIAL LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "WCHV",
        "clearingBroker": "0250",
        "brokerName": "WELLS FARGO SECURITIES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "WCIG",
        "clearingBroker": "0750",
        "brokerName": "WILLOW COVE INVESTMENT GROUP, INC.                                    "
    },
    {
        "type": "OTC",
        "mpid": "WCSC",
        "clearingBroker": "0235",
        "brokerName": "WILMINGTON CAPITAL SECURITIES, LLC                                    "
    },
    {
        "type": "OTC",
        "mpid": "WCSF",
        "clearingBroker": "0235",
        "brokerName": "WORLD CHOICE SECURITIES, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "WDCO",
        "clearingBroker": "0283",
        "brokerName": "WILSON-DAVIS & CO., INC.                                              "
    },
    {
        "type": "OTC",
        "mpid": "WDLF",
        "clearingBroker": "5078",
        "brokerName": "W.D. LATIMER CO LTD./CDS                                              "
    },
    {
        "type": "OTC",
        "mpid": "WDLP",
        "clearingBroker": "0005",
        "brokerName": "WOLVERINE TRADING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "WDOG",
        "clearingBroker": "0158",
        "brokerName": "WATCHDOG CAPITAL, LLC                                                 "
    },
    {
        "type": "OTC",
        "mpid": "WDSB",
        "clearingBroker": "0536",
        "brokerName": "JEFFERIES LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "WEBL",
        "clearingBroker": "0158",
        "brokerName": "WEBULL FINANCIAL LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "WEBS",
        "clearingBroker": "0226",
        "brokerName": "WEALTH ENHANCEMENT BROKERAGE SERVICES, LLC                            "
    },
    {
        "type": "OTC",
        "mpid": "WEDB",
        "clearingBroker": "0103",
        "brokerName": "WEDBUSH SECURITIES INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "WEDP",
        "clearingBroker": "0103",
        "brokerName": "WEDBUSH MORGAN SECURITIES INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "WEGI",
        "clearingBroker": "0235",
        "brokerName": "WORLD EQUITY GROUP INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "WEGP",
        "clearingBroker": "0235",
        "brokerName": "WESTERN EQUITY GROUP, INC.                                            "
    },
    {
        "type": "OTC",
        "mpid": "WELX",
        "clearingBroker": "0250",
        "brokerName": "WELLS FARGO SECURITIES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "WEMM",
        "clearingBroker": "0250",
        "brokerName": "WELLS FARGO SECURITIES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "WESC",
        "clearingBroker": "0443",
        "brokerName": "WELLINGTON SHIELDS & CO., LLC                                         "
    },
    {
        "type": "OTC",
        "mpid": "WEXC",
        "clearingBroker": "7350",
        "brokerName": "WOLVERINE EXECUTION SERVICES, LLC                                     "
    },
    {
        "type": "OTC",
        "mpid": "WEXM",
        "clearingBroker": "0161",
        "brokerName": "WOLVERINE EXECUTION SERVICES, LLC                                     "
    },
    {
        "type": "OTC",
        "mpid": "WEXR",
        "clearingBroker": "0235",
        "brokerName": "WOLVERINE EXECUTION SERVICES, LLC                                     "
    },
    {
        "type": "OTC",
        "mpid": "WEXS",
        "clearingBroker": "9132",
        "brokerName": "WOLVERINE EXECUTION SERVICES, LLC                                     "
    },
    {
        "type": "OTC",
        "mpid": "WEXX",
        "clearingBroker": "0005",
        "brokerName": "WOLVERINE EXECUTION SERVICES, LLC                                     "
    },
    {
        "type": "OTC",
        "mpid": "WEYE",
        "clearingBroker": "0005",
        "brokerName": "WALLEYE TRADING LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "WFES",
        "clearingBroker": "0250",
        "brokerName": "WELLS FARGO SECURITIES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "WFGP",
        "clearingBroker": "0075",
        "brokerName": "WATERSTONE FINANCIAL GROUP, INC.                                      "
    },
    {
        "type": "OTC",
        "mpid": "WFPB",
        "clearingBroker": "0250",
        "brokerName": "WELLS FARGO SECURITIES, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "WGIF",
        "clearingBroker": "5030",
        "brokerName": "CIBC WORLD MARKETS INC./CDS                                           "
    },
    {
        "type": "OTC",
        "mpid": "WHBB",
        "clearingBroker": "0537",
        "brokerName": "BGC FINANCIAL INC.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "WHOT",
        "clearingBroker": "0595",
        "brokerName": "JUST2TRADE, INC.                                                      "
    },
    {
        "type": "OTC",
        "mpid": "WIDS",
        "clearingBroker": "0279",
        "brokerName": "WISCONSIN DISCOUNT SECURITIES CORP.                                   "
    },
    {
        "type": "OTC",
        "mpid": "WINO",
        "clearingBroker": "0695",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "WINR",
        "clearingBroker": "0695",
        "brokerName": "JUMP TRADING                                                          "
    },
    {
        "type": "OTC",
        "mpid": "WINZ",
        "clearingBroker": "0695",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "WISC",
        "clearingBroker": "0235",
        "brokerName": "WINDSOR, SHEFFIELD & CO., INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "WISE",
        "clearingBroker": "0052",
        "brokerName": "AXOS INVEST LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "WISP",
        "clearingBroker": "0443",
        "brokerName": "WESTERN INTERNATIONAL SECURITIES, INC.                                "
    },
    {
        "type": "OTC",
        "mpid": "WLMS",
        "clearingBroker": "0443",
        "brokerName": "SIEBERT CISNEROS SHANK & CO., L.L.C.                                  "
    },
    {
        "type": "OTC",
        "mpid": "WLTH",
        "clearingBroker": "0235",
        "brokerName": "WEALTHFRONT BROKERAGE CORPORATION                                     "
    },
    {
        "type": "OTC",
        "mpid": "WMCL",
        "clearingBroker": "0279",
        "brokerName": "WHITE MOUNTAIN CAPITAL, LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "WMFS",
        "clearingBroker": "0226",
        "brokerName": "WESTMINSTER FINANCIAL SECURITIES, INC.                                "
    },
    {
        "type": "OTC",
        "mpid": "WMLL",
        "clearingBroker": "0235",
        "brokerName": "WATERMILL INSTITUTIONAL TRADING LLC                                   "
    },
    {
        "type": "OTC",
        "mpid": "WNUT",
        "clearingBroker": "0443",
        "brokerName": "WALNUT STREET SECURITIES, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "WPCC",
        "clearingBroker": "0052",
        "brokerName": "WESTPARK CAPITAL, INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "WPCI",
        "clearingBroker": "0595",
        "brokerName": "WESTPARK CAPITAL, INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "WPRM",
        "clearingBroker": "8199",
        "brokerName": "WEDBUSH SECURITIES INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "WPSG",
        "clearingBroker": "0005",
        "brokerName": "WEEDEN PRIME SERVICES, LLC.                                           "
    },
    {
        "type": "OTC",
        "mpid": "WPSX",
        "clearingBroker": "0445",
        "brokerName": "RISE FINANCIAL SERVICES, LLC                                          "
    },
    {
        "type": "OTC",
        "mpid": "WRDN",
        "clearingBroker": "0534",
        "brokerName": "WORDENTRADE, INC.                                                     "
    },
    {
        "type": "OTC",
        "mpid": "WRET",
        "clearingBroker": "0141",
        "brokerName": "WELLS FARGO CLEARING SERVICES, LLC                                    "
    },
    {
        "type": "OTC",
        "mpid": "WRIS",
        "clearingBroker": "0141",
        "brokerName": "SMH CAPITAL INVESTMENTS LLC                                           "
    },
    {
        "type": "OTC",
        "mpid": "WSAG",
        "clearingBroker": "0443",
        "brokerName": "WALL STREET ACCESS                                                    "
    },
    {
        "type": "OTC",
        "mpid": "WSAT",
        "clearingBroker": "0443",
        "brokerName": "WALL STREET ACCESS                                                    "
    },
    {
        "type": "OTC",
        "mpid": "WSCC",
        "clearingBroker": "0235",
        "brokerName": "WASHINGTON SECURITIES CORPORATION                                     "
    },
    {
        "type": "OTC",
        "mpid": "WSCX",
        "clearingBroker": "0235",
        "brokerName": "WORKMAN SECURITIES CORP                                               "
    },
    {
        "type": "OTC",
        "mpid": "WSGD",
        "clearingBroker": "8199",
        "brokerName": "WEDBUSH SECURITIES INC./P3                                            "
    },
    {
        "type": "OTC",
        "mpid": "WSIW",
        "clearingBroker": "8199",
        "brokerName": "WEDBUSH SECURITIES INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "WSRP",
        "clearingBroker": "0052",
        "brokerName": "WESTROCK CAPITAL MANAGEMENT, INC.                                     "
    },
    {
        "type": "OTC",
        "mpid": "WSTI",
        "clearingBroker": "0226",
        "brokerName": "WESTERN INTERNATIONAL SECURITIES, INC.                                "
    },
    {
        "type": "OTC",
        "mpid": "WTCO",
        "clearingBroker": "0005",
        "brokerName": "WILLIAMS TRADING LLC                                                  "
    },
    {
        "type": "OTC",
        "mpid": "WTFS",
        "clearingBroker": "0052",
        "brokerName": "LIME TRADING CORP                                                     "
    },
    {
        "type": "OTC",
        "mpid": "WTLP",
        "clearingBroker": "0005",
        "brokerName": "WOLVERINE TRADING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "WTRI",
        "clearingBroker": "0235",
        "brokerName": "WATERFORD INVESTORS SERVICES, INC.                                    "
    },
    {
        "type": "OTC",
        "mpid": "WUND",
        "clearingBroker": "0141",
        "brokerName": "B. RILEY WEALTH MANAGEMENT                                            "
    },
    {
        "type": "OTC",
        "mpid": "WVBD",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "WWLD",
        "clearingBroker": "0647",
        "brokerName": "WHITEWELD TRADING, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "XCNC",
        "clearingBroker": "0005",
        "brokerName": "C&C TRADING L.L.C.                                                    "
    },
    {
        "type": "OTC",
        "mpid": "XDOZ",
        "clearingBroker": "0438",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "XGWD",
        "clearingBroker": "0695",
        "brokerName": "LATOUR TRADING LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "XIST",
        "clearingBroker": "0067",
        "brokerName": "INSTINET, LLC                                                         "
    },
    {
        "type": "OTC",
        "mpid": "XPQR",
        "clearingBroker": "0695",
        "brokerName": "JUMP TRADING                                                          "
    },
    {
        "type": "OTC",
        "mpid": "XPSE",
        "clearingBroker": "0158",
        "brokerName": "XP INVESTMENTS US, LLC                                                "
    },
    {
        "type": "OTC",
        "mpid": "XPUS",
        "clearingBroker": "0443",
        "brokerName": "XP SECURITIES, LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "XRVR",
        "clearingBroker": "0279",
        "brokerName": "CRB SECURITIES, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "XSTM",
        "clearingBroker": "0226",
        "brokerName": "NATIONAL FINANCIAL SERVICES LLC                                       "
    },
    {
        "type": "OTC",
        "mpid": "XTLS",
        "clearingBroker": "0052",
        "brokerName": "XTELLUS CAPITAL PARTNERS, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "XTLW",
        "clearingBroker": "0052",
        "brokerName": "XTELLUS CAPITAL PARTNERS, INC.                                        "
    },
    {
        "type": "OTC",
        "mpid": "XTXE",
        "clearingBroker": "0161",
        "brokerName": "XTX EXECUTION SERVICES LLC                                            "
    },
    {
        "type": "OTC",
        "mpid": "XTXM",
        "clearingBroker": "0551",
        "brokerName": "XTX MARKETS LLC                                                       "
    },
    {
        "type": "OTC",
        "mpid": "XXXX",
        "clearingBroker": "0123",
        "brokerName": "XXXX CLEARING 0123 TEST                                               "
    },
    {
        "type": "OTC",
        "mpid": "YLPL",
        "clearingBroker": "0075",
        "brokerName": "LPL FINANCIAL LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "YOSE",
        "clearingBroker": "0052",
        "brokerName": "YORK SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "YSBI",
        "clearingBroker": "0534",
        "brokerName": "YORK STOCKBROKERS, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "YYYY",
        "clearingBroker": "0122",
        "brokerName": "TEST ACCOUNT FORWARD TO P & S DEPT                                    "
    },
    {
        "type": "OTC",
        "mpid": "ZACK",
        "clearingBroker": "0534",
        "brokerName": "LBMZ SECURITIES, INC.                                                 "
    },
    {
        "type": "OTC",
        "mpid": "ZBAH",
        "clearingBroker": "0712",
        "brokerName": "TZ CLEAR LLC                                                          "
    },
    {
        "type": "OTC",
        "mpid": "ZCAN",
        "clearingBroker": "0712",
        "brokerName": "TZ CLEAR LLC                                                          "
    },
    {
        "type": "OTC",
        "mpid": "ZEDB",
        "clearingBroker": "0161",
        "brokerName": "INVESCO CAPITAL MARKETS, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "ZEDD",
        "clearingBroker": "0295",
        "brokerName": "VAN KAMPEN FUNDS, INC.                                                "
    },
    {
        "type": "OTC",
        "mpid": "ZERO",
        "clearingBroker": "0158",
        "brokerName": "TRADEZERO AMERICA, INC.                                               "
    },
    {
        "type": "OTC",
        "mpid": "ZEUS",
        "clearingBroker": "0443",
        "brokerName": "ZEUS FINANCIAL, LLC                                                   "
    },
    {
        "type": "OTC",
        "mpid": "ZIPD",
        "clearingBroker": "3450",
        "brokerName": "SPEEDTRADER, INC                                                      "
    },
    {
        "type": "OTC",
        "mpid": "ZIVI",
        "clearingBroker": "8082",
        "brokerName": "ZIV INVESTMENT COMPANY                                                "
    },
    {
        "type": "OTC",
        "mpid": "ZNTH",
        "clearingBroker": "0695",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "OTC",
        "mpid": "ZOES",
        "clearingBroker": "0158",
        "brokerName": "ZOE SECURITIES LLC                                                    "
    },
    {
        "type": "OTC",
        "mpid": "ZOUL",
        "clearingBroker": "0235",
        "brokerName": "N.B. ZOULLAS SECURITIES, INC.                                         "
    },
    {
        "type": "OTC",
        "mpid": "ZPFD",
        "clearingBroker": "0443",
        "brokerName": "B. C. ZIEGLER AND COMPANY                                             "
    },
    {
        "type": "OTC",
        "mpid": "ZZZZ",
        "clearingBroker": "0123",
        "brokerName": "TEST ACCOUNT - FORWARD TO P&S DEPARTMENT                              "
    },
    {
        "type": "CORP",
        "mpid": "AALC",
        "clearingBroker": "0226",
        "brokerName": "THRIVENT INVESTMENT MANAGEMENT, INC.                                  "
    },
    {
        "type": "CORP",
        "mpid": "ABAI",
        "clearingBroker": "0279",
        "brokerName": "ABACUS INVESTMENTS, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "ABBA",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "CORP",
        "mpid": "ABBK",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "CORP",
        "mpid": "ABDA",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "CORP",
        "mpid": "ABDW",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "CORP",
        "mpid": "ABEA",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "CORP",
        "mpid": "ABEN",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "CORP",
        "mpid": "ABHE",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "CORP",
        "mpid": "ABIG",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "CORP",
        "mpid": "ABPR",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "CORP",
        "mpid": "ABRP",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "CORP",
        "mpid": "ABST",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "CORP",
        "mpid": "ACAD",
        "clearingBroker": "0443",
        "brokerName": "ACADEMY SECURITIES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "ACAM",
        "clearingBroker": "0388",
        "brokerName": "ACADEMY SECURITIES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "ACAP",
        "clearingBroker": "0235",
        "brokerName": "ALAMO CAPITAL                                                         "
    },
    {
        "type": "CORP",
        "mpid": "ACCP",
        "clearingBroker": "0158",
        "brokerName": "AEGIS CAPITAL CORP.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "ACCU",
        "clearingBroker": "0052",
        "brokerName": "ATB CAPITAL MARKETS USA INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "ACII",
        "clearingBroker": "0158",
        "brokerName": "ARCA CAPITAL INVESTMENTS, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "ACLP",
        "clearingBroker": "0235",
        "brokerName": "ALEXANDER CAPITAL, L.P.                                               "
    },
    {
        "type": "CORP",
        "mpid": "ACPL",
        "clearingBroker": "0235",
        "brokerName": "AMERICAN CAPITAL PARTNERS                                             "
    },
    {
        "type": "CORP",
        "mpid": "ACPS",
        "clearingBroker": "0443",
        "brokerName": "ACP SECURITIES LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "ACRN",
        "clearingBroker": "0235",
        "brokerName": "ACORNS SECURITIES, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "ACTI",
        "clearingBroker": "0443",
        "brokerName": "ACTIVNER SECURITIES, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "ADAM",
        "clearingBroker": "0161",
        "brokerName": "CANACCORD GENUITY INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "ADSD",
        "clearingBroker": "0725",
        "brokerName": "ROGAN & ASSOCIATES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "ADSO",
        "clearingBroker": "0141",
        "brokerName": "PROSPERA FINANCIAL SERVICES, INC.                                     "
    },
    {
        "type": "CORP",
        "mpid": "AEFS",
        "clearingBroker": "0226",
        "brokerName": "AE FINANCIAL SERVICES, LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "AETL",
        "clearingBroker": "0158",
        "brokerName": "AET INVESTMENT SERVICES, LLC                                          "
    },
    {
        "type": "CORP",
        "mpid": "AEXG",
        "clearingBroker": "0158",
        "brokerName": "ALTERNATIVE EXECUTION GROUP                                           "
    },
    {
        "type": "CORP",
        "mpid": "AFBS",
        "clearingBroker": "0158",
        "brokerName": "APEX FINTECH BROKERAGE SERVICES LLC                                   "
    },
    {
        "type": "CORP",
        "mpid": "AFGI",
        "clearingBroker": "0725",
        "brokerName": "ACCESS FINANCIAL GROUP, INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "AFGT",
        "clearingBroker": "0052",
        "brokerName": "J. ALDEN ASSOCIATES, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "AFSL",
        "clearingBroker": "0443",
        "brokerName": "SORRENTO PACIFIC FINANCIAL                                            "
    },
    {
        "type": "CORP",
        "mpid": "AFSS",
        "clearingBroker": "0750",
        "brokerName": "FOUR POINTS CAPITAL PARTNERS LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "AGCO",
        "clearingBroker": "0052",
        "brokerName": "AUERBACH GRAYSON & COMPANY LLC                                        "
    },
    {
        "type": "CORP",
        "mpid": "AGCP",
        "clearingBroker": "0052",
        "brokerName": "AEGIS CAPITAL CORP.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "AGES",
        "clearingBroker": "0750",
        "brokerName": "ADVISORY GROUP EQUITY SERVICES LTD.                                   "
    },
    {
        "type": "CORP",
        "mpid": "AGFA",
        "clearingBroker": "0226",
        "brokerName": "VALIC FINANCIAL ADVISORS, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "AGIS",
        "clearingBroker": "0235",
        "brokerName": "AEGIS CAPITAL CORP.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "AGPM",
        "clearingBroker": "1043",
        "brokerName": "A.G.P. / ALLIANCE GLOBAL PARTNERS                                     "
    },
    {
        "type": "CORP",
        "mpid": "AGSS",
        "clearingBroker": "0443",
        "brokerName": "GREAT AMERICAN ADVISORS, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "AHSI",
        "clearingBroker": "0141",
        "brokerName": "AMERICAN HERITAGE SECURITIES, INC.                                    "
    },
    {
        "type": "CORP",
        "mpid": "AIGF",
        "clearingBroker": "0443",
        "brokerName": "OSAIC WEALTH, INC.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "AIGN",
        "clearingBroker": "0226",
        "brokerName": "OSAIC WEALTH, INC.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "AIRS",
        "clearingBroker": "0279",
        "brokerName": "HAND SECURITIES, INC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "AISG",
        "clearingBroker": "0235",
        "brokerName": "AMERICAN INDEPENDENT SECURITIES GROUP, LLC                            "
    },
    {
        "type": "CORP",
        "mpid": "AJCO",
        "clearingBroker": "0443",
        "brokerName": "IDB CAPITAL CORP.                                                     "
    },
    {
        "type": "CORP",
        "mpid": "ALCG",
        "clearingBroker": "0235",
        "brokerName": "ALTITUDE CAPITAL GROUP LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "ALCM",
        "clearingBroker": "0279",
        "brokerName": "ALPHALEDGER MARKETS, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "ALDN",
        "clearingBroker": "0052",
        "brokerName": "J. ALDEN ASSOCIATES, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "ALGP",
        "clearingBroker": "0235",
        "brokerName": "A.G.P. / ALLIANCE GLOBAL PARTNERS                                     "
    },
    {
        "type": "CORP",
        "mpid": "ALGR",
        "clearingBroker": "0158",
        "brokerName": "ALGER (FRED) & CO INC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "ALIS",
        "clearingBroker": "0235",
        "brokerName": "ALEXANDER INVESTMENT SERVICES CO.                                     "
    },
    {
        "type": "CORP",
        "mpid": "ALLN",
        "clearingBroker": "0443",
        "brokerName": "ALLEN & COMPANY LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "ALNC",
        "clearingBroker": "0226",
        "brokerName": "A.G.P./ALLIANCE GLOBAL PARTNERS                                       "
    },
    {
        "type": "CORP",
        "mpid": "ALTR",
        "clearingBroker": "3164",
        "brokerName": "ALTRUIST FINANCIAL LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "AMBB",
        "clearingBroker": "0141",
        "brokerName": "ALLEN, MOONEY & BARNES BROKERAGE SERVICES, LLC                        "
    },
    {
        "type": "CORP",
        "mpid": "AMER",
        "clearingBroker": "0235",
        "brokerName": "AMERICAN TRUST INVESTMENT SERVICES, INC.                              "
    },
    {
        "type": "CORP",
        "mpid": "AMIC",
        "clearingBroker": "0226",
        "brokerName": "AMERICAN INVESTORS COMPANY                                            "
    },
    {
        "type": "CORP",
        "mpid": "AMLU",
        "clearingBroker": "3652",
        "brokerName": "LUCID CAPITAL MARKETS, LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "AMMS",
        "clearingBroker": "0141",
        "brokerName": "AMUNI FINANCIAL, INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "AMRG",
        "clearingBroker": "0443",
        "brokerName": "WORLD CAPITAL BROKERAGE, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "ANDB",
        "clearingBroker": "0443",
        "brokerName": "ANDBANC BROKERAGE, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "ANDG",
        "clearingBroker": "0235",
        "brokerName": "GARRETT (ANDREW), INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "ANOS",
        "clearingBroker": "0235",
        "brokerName": "ABEL NOSER, LLC.                                                      "
    },
    {
        "type": "CORP",
        "mpid": "ANOV",
        "clearingBroker": "0750",
        "brokerName": "ANOVEST FINANCIAL SERVICES, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "AOCS",
        "clearingBroker": "0388",
        "brokerName": "AOC SECURITIES                                                        "
    },
    {
        "type": "CORP",
        "mpid": "AONC",
        "clearingBroker": "0443",
        "brokerName": "AON BENFIELD SECURITIES                                               "
    },
    {
        "type": "CORP",
        "mpid": "AORP",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "CORP",
        "mpid": "AOSD",
        "clearingBroker": "0158",
        "brokerName": "TRADING BLOCK                                                         "
    },
    {
        "type": "CORP",
        "mpid": "APBD",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "CORP",
        "mpid": "APBO",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "CORP",
        "mpid": "APFS",
        "clearingBroker": "0443",
        "brokerName": "AMERICA'S PORTFOLIO'S                                                 "
    },
    {
        "type": "CORP",
        "mpid": "APRT",
        "clearingBroker": "0226",
        "brokerName": "PARTNERS                                                              "
    },
    {
        "type": "CORP",
        "mpid": "APXO",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "CORP",
        "mpid": "APXS",
        "clearingBroker": "0052",
        "brokerName": "APEXUS CAPITAL LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "ARBC",
        "clearingBroker": "0235",
        "brokerName": "ARKADIOS CAPITAL                                                      "
    },
    {
        "type": "CORP",
        "mpid": "ARCD",
        "clearingBroker": "0443",
        "brokerName": "ARCADIA SECURITIES, LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "ARKA",
        "clearingBroker": "0443",
        "brokerName": "ARKA SECURITIES, INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "ARKI",
        "clearingBroker": "0226",
        "brokerName": "ARKADIOS CAPITAL                                                      "
    },
    {
        "type": "CORP",
        "mpid": "ARSC",
        "clearingBroker": "1043",
        "brokerName": "ARCTIC SECURITIES LLC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "ARTI",
        "clearingBroker": "1043",
        "brokerName": "ARBOR RESEARCH & TRADING, LLC                                         "
    },
    {
        "type": "CORP",
        "mpid": "ARVS",
        "clearingBroker": "0443",
        "brokerName": "ARVEST WEALTH MANAGEMENT                                              "
    },
    {
        "type": "CORP",
        "mpid": "ASCM",
        "clearingBroker": "0052",
        "brokerName": "ASCENDIANT CAPITAL MARKETS, LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "ASCP",
        "clearingBroker": "0443",
        "brokerName": "BOK FINANCIAL SECURITIES                                              "
    },
    {
        "type": "CORP",
        "mpid": "ASII",
        "clearingBroker": "0226",
        "brokerName": "AURORA SECURITIES                                                     "
    },
    {
        "type": "CORP",
        "mpid": "ASLB",
        "clearingBroker": "0370",
        "brokerName": "TRADITION SECURITIES AND DERIVATIVES LLC                              "
    },
    {
        "type": "CORP",
        "mpid": "ASOI",
        "clearingBroker": "0226",
        "brokerName": "ASSOCIATED INVESTMENT SERVICES, INC.                                  "
    },
    {
        "type": "CORP",
        "mpid": "ASPI",
        "clearingBroker": "0725",
        "brokerName": "ASIA PACIFIC FINANCIAL MANAGEMENT GROUP, INC.                         "
    },
    {
        "type": "CORP",
        "mpid": "ATIS",
        "clearingBroker": "0052",
        "brokerName": "AMERICAN TRUST INVESTMENT SERVICES, INC.                              "
    },
    {
        "type": "CORP",
        "mpid": "ATLS",
        "clearingBroker": "0443",
        "brokerName": "APOLLO GLOBAL SECURITIES, LLC                                         "
    },
    {
        "type": "CORP",
        "mpid": "ATMC",
        "clearingBroker": "0100",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "ATVT",
        "clearingBroker": "0443",
        "brokerName": "ATOMIC BROKERAGE LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "AULC",
        "clearingBroker": "0443",
        "brokerName": "ONEAMERICA SECURITIES, INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "AVEN",
        "clearingBroker": "0226",
        "brokerName": "AVENTURA SECURITIES, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "AVEW",
        "clearingBroker": "8199",
        "brokerName": "AVENTURA SECURITIES, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "AVIL",
        "clearingBroker": "0158",
        "brokerName": "AVANZA CAPITAL MARKETS INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "AVML",
        "clearingBroker": "0443",
        "brokerName": "AVM, L.P.                                                             "
    },
    {
        "type": "CORP",
        "mpid": "AVON",
        "clearingBroker": "0226",
        "brokerName": "AVONDALE PARTNERS, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "AVSI",
        "clearingBroker": "0443",
        "brokerName": "AMERIVET SECURITIES, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "AVST",
        "clearingBroker": "0235",
        "brokerName": "ATOMIC BROKERAGE LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "AWMI",
        "clearingBroker": "0725",
        "brokerName": "AMERICAN WEALTH MANAGEMENT INC                                        "
    },
    {
        "type": "CORP",
        "mpid": "AXAA",
        "clearingBroker": "0075",
        "brokerName": "AXA ADVISORS LLC                                                      "
    },
    {
        "type": "CORP",
        "mpid": "AXCB",
        "clearingBroker": "0443",
        "brokerName": "ACCESS SECURITIES                                                     "
    },
    {
        "type": "CORP",
        "mpid": "AXCL",
        "clearingBroker": "0052",
        "brokerName": "AXOS CLEARING LLC                                                     "
    },
    {
        "type": "CORP",
        "mpid": "AXCS",
        "clearingBroker": "0443",
        "brokerName": "ACCESS SECURITIES INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "AXGP",
        "clearingBroker": "0443",
        "brokerName": "ACCESS SECURITIES, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "AXIO",
        "clearingBroker": "0279",
        "brokerName": "AXIOM CAPITAL MANAGEMENT, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "AXOS",
        "clearingBroker": "0052",
        "brokerName": "AXOS CLEARING LLC                                                     "
    },
    {
        "type": "CORP",
        "mpid": "AXTN",
        "clearingBroker": "0052",
        "brokerName": "AX TRADING, LLC                                                       "
    },
    {
        "type": "CORP",
        "mpid": "BAKR",
        "clearingBroker": "0443",
        "brokerName": "JAMES BAKER & ASSOCIATES, L.P.                                        "
    },
    {
        "type": "CORP",
        "mpid": "BALE",
        "clearingBroker": "0443",
        "brokerName": "M&T SECURITIES, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "BALS",
        "clearingBroker": "0750",
        "brokerName": "BRUCE A. LEFAVI SECURITIES, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "BANK",
        "clearingBroker": "0701",
        "brokerName": "CETERA INVESTMENT SERVICES LLC                                        "
    },
    {
        "type": "CORP",
        "mpid": "BARC",
        "clearingBroker": "0388",
        "brokerName": "BARCLAY                                                               "
    },
    {
        "type": "CORP",
        "mpid": "BARD",
        "clearingBroker": "0547",
        "brokerName": "ROBERT W. BAIRD & CO. INCORPORATED                                    "
    },
    {
        "type": "CORP",
        "mpid": "BARR",
        "clearingBroker": "0226",
        "brokerName": "BARRETT & COMPANY                                                     "
    },
    {
        "type": "CORP",
        "mpid": "BAYC",
        "clearingBroker": "0161",
        "brokerName": "BAY CREST PARTNERS,  LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "BAYP",
        "clearingBroker": "0161",
        "brokerName": "BAY CREST PARTNERS, LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "BBAR",
        "clearingBroker": "0595",
        "brokerName": "BUCKMAN, BUCKMAN & REID, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "BBGC",
        "clearingBroker": "0235",
        "brokerName": "GRAHAM (B.B.) & COMPANY                                               "
    },
    {
        "type": "CORP",
        "mpid": "BBNI",
        "clearingBroker": "0443",
        "brokerName": "PERFORMANCE TRUST CAPITAL PARTNERS, INC.                              "
    },
    {
        "type": "CORP",
        "mpid": "BCAP",
        "clearingBroker": "7256",
        "brokerName": "BARCLAYS CAPITAL, INC./FIXED INCOME                                   "
    },
    {
        "type": "CORP",
        "mpid": "BCCS",
        "clearingBroker": "0443",
        "brokerName": "BAC FLORIDA INVESTMENTS CORP.                                         "
    },
    {
        "type": "CORP",
        "mpid": "BCEX",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "BCGS",
        "clearingBroker": "0443",
        "brokerName": "BCG SECURITIES, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "BCIB",
        "clearingBroker": "0443",
        "brokerName": "BCI SECURITIES, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "BCKL",
        "clearingBroker": "0443",
        "brokerName": "BANCOLOMBIA CAPITAL LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "BCLE",
        "clearingBroker": "0229",
        "brokerName": "BARCLAYS CAPITAL INC./BARCLAYS CAPITAL INC.                           "
    },
    {
        "type": "CORP",
        "mpid": "BCPI",
        "clearingBroker": "0279",
        "brokerName": "GVC CAPITAL LLC                                                       "
    },
    {
        "type": "CORP",
        "mpid": "BCRK",
        "clearingBroker": "0279",
        "brokerName": "BEAR CREEK SECURITIES, LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "BCSA",
        "clearingBroker": "0443",
        "brokerName": "BCS AMERICAS, INC.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "BCWM",
        "clearingBroker": "4077",
        "brokerName": "BETA CAPITAL SECURITIES LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "BCZC",
        "clearingBroker": "0443",
        "brokerName": "ZIEGLER (B.C.) & COMPANY                                              "
    },
    {
        "type": "CORP",
        "mpid": "BDBS",
        "clearingBroker": "0443",
        "brokerName": "BANCO DO BRASIL SECURITIES                                            "
    },
    {
        "type": "CORP",
        "mpid": "BDDK",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "BDIR",
        "clearingBroker": "0443",
        "brokerName": "JEFFERIES LLC                                                         "
    },
    {
        "type": "CORP",
        "mpid": "BDTR",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "BEAF",
        "clearingBroker": "0235",
        "brokerName": "BEACONSFIELD FINANCIAL SERV.                                          "
    },
    {
        "type": "CORP",
        "mpid": "BECM",
        "clearingBroker": "0725",
        "brokerName": "BETA CAPITAL SECURITIES LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "BELS",
        "clearingBroker": "0443",
        "brokerName": "BEL AIR SECURITIES LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "BERN",
        "clearingBroker": "0013",
        "brokerName": "SANFORD C. BERNSTEIN & CO., LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "BERS",
        "clearingBroker": "0235",
        "brokerName": "BESTEX RESEARCH SECURITIES, LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "BEST",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "BFEC",
        "clearingBroker": "0443",
        "brokerName": "BENJAMIN F. EDWARDS & COMPANY                                         "
    },
    {
        "type": "CORP",
        "mpid": "BFEW",
        "clearingBroker": "0443",
        "brokerName": "BILL FEW ASSOCIATES, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "BFFI",
        "clearingBroker": "0226",
        "brokerName": "BERTHEL, FISHER & COMPANY FINANCIAL SERVICES, INC.                    "
    },
    {
        "type": "CORP",
        "mpid": "BFSL",
        "clearingBroker": "0235",
        "brokerName": "BRIGGS-FICKS SECURITIES, LLC                                          "
    },
    {
        "type": "CORP",
        "mpid": "BGCE",
        "clearingBroker": "0161",
        "brokerName": "BGC FINANCIAL INC.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "BGCF",
        "clearingBroker": "0537",
        "brokerName": "BGC FINANCIAL, L.P.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "BGCX",
        "clearingBroker": "0537",
        "brokerName": "BGC FINANCIAL INC.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "BGHT",
        "clearingBroker": "0141",
        "brokerName": "BRIGHTON SECURITIES CORP.                                             "
    },
    {
        "type": "CORP",
        "mpid": "BGIS",
        "clearingBroker": "0443",
        "brokerName": "BLACKROCK EXECUTION SERVICES                                          "
    },
    {
        "type": "CORP",
        "mpid": "BGMI",
        "clearingBroker": "0158",
        "brokerName": "BRICKELL GLOBAL MARKETS, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "BGSG",
        "clearingBroker": "0226",
        "brokerName": "CBIZ FINANCIAL SOLUTIONS, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "BGVS",
        "clearingBroker": "0443",
        "brokerName": "BGV SECURITIES                                                        "
    },
    {
        "type": "CORP",
        "mpid": "BHII",
        "clearingBroker": "0443",
        "brokerName": "BELLE HAVEN INVESTMENTS, LP                                           "
    },
    {
        "type": "CORP",
        "mpid": "BHKS",
        "clearingBroker": "0141",
        "brokerName": "BHK SECURITIES, LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "BIFS",
        "clearingBroker": "0443",
        "brokerName": "BROKERS INTERNATIONAL FINANCIAL SERVICES, LLC                         "
    },
    {
        "type": "CORP",
        "mpid": "BIGG",
        "clearingBroker": "0005",
        "brokerName": "BROWNSTONE INVESTMENT GROUP                                           "
    },
    {
        "type": "CORP",
        "mpid": "BIGP",
        "clearingBroker": "0443",
        "brokerName": "BROWNSTONE INVESTMENT GROUP, LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "BIMI",
        "clearingBroker": "0136",
        "brokerName": "INTESA SANPAOLO IMI SECURITIES CORP.                                  "
    },
    {
        "type": "CORP",
        "mpid": "BISI",
        "clearingBroker": "0443",
        "brokerName": "BANORTE SECURITIES INTERNATIONAL, LTD.                                "
    },
    {
        "type": "CORP",
        "mpid": "BJCM",
        "clearingBroker": "0235",
        "brokerName": "ESSEX SECURITIES LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "BJRC",
        "clearingBroker": "0235",
        "brokerName": "CASCADE INVESTMENT GROUP, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "BKCM",
        "clearingBroker": "0443",
        "brokerName": "BNY CAPITAL MARKETS INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "BKES",
        "clearingBroker": "0443",
        "brokerName": "BNY MELLON CAPITAL MARKETS, LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "BKRT",
        "clearingBroker": "0235",
        "brokerName": "BUCKMAN, BUCKMAN & REID, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "BLEY",
        "clearingBroker": "0443",
        "brokerName": "BLEY INVESTMENT GROUP, INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "BLNI",
        "clearingBroker": "0226",
        "brokerName": "AMERITAS INVESTMENT COMPANY, LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "BLOC",
        "clearingBroker": "0158",
        "brokerName": "TRADING BLOCK                                                         "
    },
    {
        "type": "CORP",
        "mpid": "BLTK",
        "clearingBroker": "0443",
        "brokerName": "BULLTICK, LLC                                                         "
    },
    {
        "type": "CORP",
        "mpid": "BMKS",
        "clearingBroker": "0443",
        "brokerName": "BENCHMARK SECURITIES, LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "BMSA",
        "clearingBroker": "0443",
        "brokerName": "MARIVA CAPITAL MARKETS, LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "BMSI",
        "clearingBroker": "0750",
        "brokerName": "BULL MARKET SECURITIES, INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "BMUR",
        "clearingBroker": "0443",
        "brokerName": "BREAN CAPITAL, LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "BNBB",
        "clearingBroker": "0750",
        "brokerName": "INTERCOASTAL CAPITAL MARKETS, INC.                                    "
    },
    {
        "type": "CORP",
        "mpid": "BNCH",
        "clearingBroker": "0235",
        "brokerName": "THE BENCHMARK COMPANY, LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "BNDI",
        "clearingBroker": "0443",
        "brokerName": "BERNARDI SECURITIES, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "BNDS",
        "clearingBroker": "0226",
        "brokerName": "MTS MARKETS INTERNATIONAL, INC                                        "
    },
    {
        "type": "CORP",
        "mpid": "BNJM",
        "clearingBroker": "0235",
        "brokerName": "BENJAMIN SECURITIES, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "BNPS",
        "clearingBroker": "2154",
        "brokerName": "BNP PARIBAS SECURITIES CORP.                                          "
    },
    {
        "type": "CORP",
        "mpid": "BNPX",
        "clearingBroker": "2154",
        "brokerName": "BNP PARIBAS SECURITIES CORP.                                          "
    },
    {
        "type": "CORP",
        "mpid": "BNTE",
        "clearingBroker": "0158",
        "brokerName": "BANORTE-IXE SECURITIES INTERNATIONAL, LTD.                            "
    },
    {
        "type": "CORP",
        "mpid": "BNYM",
        "clearingBroker": "8355",
        "brokerName": "BNYM/UIT NSCC CNS CLEARANCE                                           "
    },
    {
        "type": "CORP",
        "mpid": "BNYN",
        "clearingBroker": "0226",
        "brokerName": "BANYAN SECURITIES, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "BOFA",
        "clearingBroker": "0773",
        "brokerName": "BOFA SECURITIES, INC./FIXED INCOME                                    "
    },
    {
        "type": "CORP",
        "mpid": "BOKI",
        "clearingBroker": "0443",
        "brokerName": "BOSC, INC.                                                            "
    },
    {
        "type": "CORP",
        "mpid": "BOLL",
        "clearingBroker": "0279",
        "brokerName": "BODELL OVERCASH ANDERSON & CO.                                        "
    },
    {
        "type": "CORP",
        "mpid": "BOSE",
        "clearingBroker": "0443",
        "brokerName": "BOE SECURITIES INC.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "BOSS",
        "clearingBroker": "0158",
        "brokerName": "ALL TIME ATS                                                          "
    },
    {
        "type": "CORP",
        "mpid": "BOTS",
        "clearingBroker": "0052",
        "brokerName": "C A BOTZUM & CO                                                       "
    },
    {
        "type": "CORP",
        "mpid": "BPWP",
        "clearingBroker": "0226",
        "brokerName": "BUTTONWOOD PARTNERS, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "BRAD",
        "clearingBroker": "0443",
        "brokerName": "BERNARD HEROLD & CO                                                   "
    },
    {
        "type": "CORP",
        "mpid": "BRAZ",
        "clearingBroker": "0279",
        "brokerName": "BRAZOS SECURITIES INC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "BRBR",
        "clearingBroker": "0279",
        "brokerName": "BROWN AND BROWN SECURITIES, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "BRCY",
        "clearingBroker": "0443",
        "brokerName": "BCP SECURITIES, LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "BRGE",
        "clearingBroker": "0052",
        "brokerName": "NEWBRIDGE SECURITIES CORPORATION                                      "
    },
    {
        "type": "CORP",
        "mpid": "BRLI",
        "clearingBroker": "0226",
        "brokerName": "BROWN, LISLE/CUMMINGS, INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "BRNK",
        "clearingBroker": "0226",
        "brokerName": "BRINKER CAPITAL SECURITIES, LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "BROC",
        "clearingBroker": "0443",
        "brokerName": "PAVILION GLOBAL MARKETS LTD                                           "
    },
    {
        "type": "CORP",
        "mpid": "BRRR",
        "clearingBroker": "8199",
        "brokerName": "BARRINGTON RESEARCH ASSOCIATES, INC.                                  "
    },
    {
        "type": "CORP",
        "mpid": "BRSA",
        "clearingBroker": "0103",
        "brokerName": "BOURSA INVESTMENT                                                     "
    },
    {
        "type": "CORP",
        "mpid": "BRSE",
        "clearingBroker": "0226",
        "brokerName": "BRADESCO SECURITIES, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "BRVL",
        "clearingBroker": "0443",
        "brokerName": "BLAYLOCK BEAL VAN, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "BRWM",
        "clearingBroker": "0226",
        "brokerName": "B. RILEY WEALTH MANAGEMENT                                            "
    },
    {
        "type": "CORP",
        "mpid": "BSCM",
        "clearingBroker": "0052",
        "brokerName": "BROAD STREET CAPITAL MARKETS, LLC                                     "
    },
    {
        "type": "CORP",
        "mpid": "BSPI",
        "clearingBroker": "0235",
        "brokerName": "BALANCED SECURITY PLANNING, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "BTCK",
        "clearingBroker": "0158",
        "brokerName": "BULLTICK, LLC                                                         "
    },
    {
        "type": "CORP",
        "mpid": "BTDG",
        "clearingBroker": "0161",
        "brokerName": "BIDS TRADING LP                                                       "
    },
    {
        "type": "CORP",
        "mpid": "BTIM",
        "clearingBroker": "1043",
        "brokerName": "BTIG, LLC                                                             "
    },
    {
        "type": "CORP",
        "mpid": "BTIS",
        "clearingBroker": "0443",
        "brokerName": "BTIG, LLC                                                             "
    },
    {
        "type": "CORP",
        "mpid": "BTSS",
        "clearingBroker": "0279",
        "brokerName": "HILLTOP SECURITIES INDEPENDENT NETWORK INC.                           "
    },
    {
        "type": "CORP",
        "mpid": "BURK",
        "clearingBroker": "0141",
        "brokerName": "BURKE, LAWTON, BREWER & BURKE                                         "
    },
    {
        "type": "CORP",
        "mpid": "BURT",
        "clearingBroker": "0725",
        "brokerName": "HARBOR FINANCIAL SERVICES, L.L.C.                                     "
    },
    {
        "type": "CORP",
        "mpid": "BWNA",
        "clearingBroker": "0235",
        "brokerName": "BROWN ASSOCIATES INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "BYAI",
        "clearingBroker": "0226",
        "brokerName": "BRECEK & YOUNG                                                        "
    },
    {
        "type": "CORP",
        "mpid": "BZCP",
        "clearingBroker": "0443",
        "brokerName": "BALANZ CAPITAL USA LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "BZTN",
        "clearingBroker": "0141",
        "brokerName": "ALLIANT SECURITIES, INC. TURNER, NORD, KIENBAUM                       "
    },
    {
        "type": "CORP",
        "mpid": "BZWV",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "BZYD",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "BZYF",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "CABA",
        "clearingBroker": "0443",
        "brokerName": "CABRERA CAPITAL MARKETS, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "CABR",
        "clearingBroker": "0161",
        "brokerName": "CABRERA CAPITAL MARKETS, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "CADG",
        "clearingBroker": "0005",
        "brokerName": "WEEDEN PRIME SERVICES, LLC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "CADZ",
        "clearingBroker": "0279",
        "brokerName": "CADZ SECURITIES INC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "CAFS",
        "clearingBroker": "0158",
        "brokerName": "COMMUNITYAMERICA FINANCIAL SOLUTIONS, LLC                             "
    },
    {
        "type": "CORP",
        "mpid": "CAGI",
        "clearingBroker": "0279",
        "brokerName": "CRESCENT SECURITIES GROUP, INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "CAIX",
        "clearingBroker": "0235",
        "brokerName": "CAIS CAPITAL LLC                                                      "
    },
    {
        "type": "CORP",
        "mpid": "CALD",
        "clearingBroker": "0103",
        "brokerName": "CALDWELL SUTTER CAPITAL, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "CALT",
        "clearingBroker": "0279",
        "brokerName": "CALTON & ASSOCIATES                                                   "
    },
    {
        "type": "CORP",
        "mpid": "CAMS",
        "clearingBroker": "0443",
        "brokerName": "COMPREHENSIVE ASSET MANAGEMENT AND SERVICING, INC.                    "
    },
    {
        "type": "CORP",
        "mpid": "CANA",
        "clearingBroker": "0443",
        "brokerName": "CANACCORD GENUITY INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "CANT",
        "clearingBroker": "0696",
        "brokerName": "CANTOR FITZGERALD & CO.                                               "
    },
    {
        "type": "CORP",
        "mpid": "CAPC",
        "clearingBroker": "0235",
        "brokerName": "CAPITAL CITY SECURITIES, LLC                                          "
    },
    {
        "type": "CORP",
        "mpid": "CAPE",
        "clearingBroker": "0279",
        "brokerName": "CAPE SECURITIES, INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "CAPF",
        "clearingBroker": "0443",
        "brokerName": "CAPITAL FINANCIAL SERVICES, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "CAPP",
        "clearingBroker": "0443",
        "brokerName": "CAPTRUST FINANCIAL ADVISORS                                           "
    },
    {
        "type": "CORP",
        "mpid": "CARG",
        "clearingBroker": "0141",
        "brokerName": "CARTHAGE GROUP INC.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "CART",
        "clearingBroker": "0443",
        "brokerName": "CARTY & COMPANY, INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "CARY",
        "clearingBroker": "0141",
        "brokerName": "CARY STREET PARTNERS                                                  "
    },
    {
        "type": "CORP",
        "mpid": "CASH",
        "clearingBroker": "0158",
        "brokerName": "PLANNER SECURITIES LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "CATE",
        "clearingBroker": "0235",
        "brokerName": "CARTER, TERRY & COMPANY, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "CAVU",
        "clearingBroker": "0443",
        "brokerName": "CAVU SECURITIES LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "CBEV",
        "clearingBroker": "0226",
        "brokerName": "CITY NATIONAL BANK, BEVERLY HILLS, CALIFORNIA                         "
    },
    {
        "type": "CORP",
        "mpid": "CBII",
        "clearingBroker": "0443",
        "brokerName": "WESBANCO SECURITIES, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "CBIN",
        "clearingBroker": "0443",
        "brokerName": "COMPASS BROKERAGE, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "CBOL",
        "clearingBroker": "0226",
        "brokerName": "MUTUAL SECURITIES, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "CBSE",
        "clearingBroker": "1043",
        "brokerName": "CAMBRIDGE INTERNATIONAL SECURITIES, LLC                               "
    },
    {
        "type": "CORP",
        "mpid": "CBTD",
        "clearingBroker": "0226",
        "brokerName": "SYNOVOUS SECURITIES INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "CCCO",
        "clearingBroker": "0226",
        "brokerName": "CARNES CAPITAL CORPORATION                                            "
    },
    {
        "type": "CORP",
        "mpid": "CCIG",
        "clearingBroker": "0235",
        "brokerName": "CINCAP INVESTMENT GROUP, INC                                          "
    },
    {
        "type": "CORP",
        "mpid": "CCMB",
        "clearingBroker": "0443",
        "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "CCMC",
        "clearingBroker": "0443",
        "brokerName": "COMMERZEBANK CAPITAL CORP.                                            "
    },
    {
        "type": "CORP",
        "mpid": "CCMI",
        "clearingBroker": "0443",
        "brokerName": "JMP SECURITIES LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "CCMM",
        "clearingBroker": "0235",
        "brokerName": "CRAFT CAPITAL MANAGEMENT LLC                                          "
    },
    {
        "type": "CORP",
        "mpid": "CCPM",
        "clearingBroker": "0595",
        "brokerName": "CAMBRIA CAPITAL, LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "CCRD",
        "clearingBroker": "0443",
        "brokerName": "CONCORDE INVESTMENT SERVICES, LLC                                     "
    },
    {
        "type": "CORP",
        "mpid": "CCSS",
        "clearingBroker": "0443",
        "brokerName": "CROWN CAPITAL SECURITIES, L.P.                                        "
    },
    {
        "type": "CORP",
        "mpid": "CDFS",
        "clearingBroker": "0052",
        "brokerName": "NAVIAN CAPITAL SECURITIES, LLC                                        "
    },
    {
        "type": "CORP",
        "mpid": "CDGO",
        "clearingBroker": "0551",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "CERS",
        "clearingBroker": "0226",
        "brokerName": "CEROS FINANCIAL SERVICES, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "CFCO",
        "clearingBroker": "7311",
        "brokerName": "CANTOR FITZGERALD & CO.                                               "
    },
    {
        "type": "CORP",
        "mpid": "CFCS",
        "clearingBroker": "0005",
        "brokerName": "CANTOR FITZGERALD & CO                                                "
    },
    {
        "type": "CORP",
        "mpid": "CFGM",
        "clearingBroker": "0235",
        "brokerName": "TRUSTMONT FINANCIAL GROUP, INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "CFGT",
        "clearingBroker": "0235",
        "brokerName": "CF GLOBAL TRADING, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "CFII",
        "clearingBroker": "0235",
        "brokerName": "CONSOLIDATED FINANCIAL INVESTMENTS, INC.                              "
    },
    {
        "type": "CORP",
        "mpid": "CFIN",
        "clearingBroker": "0279",
        "brokerName": "CHELSEA FINANCIAL SERVICES                                            "
    },
    {
        "type": "CORP",
        "mpid": "CFSC",
        "clearingBroker": "0443",
        "brokerName": "INSIGNEO SECURITIES LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "CFSI",
        "clearingBroker": "0052",
        "brokerName": "CEROS FINANCIAL SERVICES, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "CFSX",
        "clearingBroker": "0794",
        "brokerName": "CF SECURED, LLC                                                       "
    },
    {
        "type": "CORP",
        "mpid": "CGAM",
        "clearingBroker": "0443",
        "brokerName": "CGIS SECURITIES LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "CGAT",
        "clearingBroker": "0443",
        "brokerName": "CADARET, GRANT & CO., INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "CGCO",
        "clearingBroker": "0443",
        "brokerName": "CG COMPASS (USA) LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "CGLN",
        "clearingBroker": "0103",
        "brokerName": "COUGHLIN & CO                                                         "
    },
    {
        "type": "CORP",
        "mpid": "CGMI",
        "clearingBroker": "0505",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "CGWM",
        "clearingBroker": "0443",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "CHAS",
        "clearingBroker": "0164",
        "brokerName": "CHARLES SCHWAB & CO., INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "CHBC",
        "clearingBroker": "0235",
        "brokerName": "PENSERRA SECURITIES, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "CHCH",
        "clearingBroker": "0226",
        "brokerName": "CHURCHILL FINANCIAL, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "CHCK",
        "clearingBroker": "0226",
        "brokerName": "CHICKASAW SECURITIES, LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "CHDA",
        "clearingBroker": "0141",
        "brokerName": "CHAPIN, DAVIS                                                         "
    },
    {
        "type": "CORP",
        "mpid": "CHHS",
        "clearingBroker": "0141",
        "brokerName": "CHESTER HARRIS & CO., INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "CHLC",
        "clearingBroker": "0443",
        "brokerName": "CHURCHILL CAPITAL USA, INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "CHPP",
        "clearingBroker": "0624",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "CORP",
        "mpid": "CHRS",
        "clearingBroker": "0750",
        "brokerName": "ROYAL TREASURE SECURITIES LLC                                         "
    },
    {
        "type": "CORP",
        "mpid": "CHSI",
        "clearingBroker": "0187",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "CHUB",
        "clearingBroker": "0226",
        "brokerName": "OSAIC FS, INC.                                                        "
    },
    {
        "type": "CORP",
        "mpid": "CICC",
        "clearingBroker": "0443",
        "brokerName": "CICC US SECURITIES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "CICI",
        "clearingBroker": "0443",
        "brokerName": "COMMERCE BANK INVESTMENT SERVICES, INC.                               "
    },
    {
        "type": "CORP",
        "mpid": "CICL",
        "clearingBroker": "0141",
        "brokerName": "CAROLINAS INVESTMENT CONSULTING                                       "
    },
    {
        "type": "CORP",
        "mpid": "CIIV",
        "clearingBroker": "0052",
        "brokerName": "CORPORATE INVESTMENTS GROUP, INC.                                     "
    },
    {
        "type": "CORP",
        "mpid": "CIMB",
        "clearingBroker": "0005",
        "brokerName": "CIMB SECURITIES (USA), INC                                            "
    },
    {
        "type": "CORP",
        "mpid": "CIRI",
        "clearingBroker": "0443",
        "brokerName": "CAMBRIDGE INVESTMENT RESEARCH, INC.                                   "
    },
    {
        "type": "CORP",
        "mpid": "CIST",
        "clearingBroker": "0161",
        "brokerName": "CAPITAL INSTITUTIONAL SERVICES, INC.                                  "
    },
    {
        "type": "CORP",
        "mpid": "CISV",
        "clearingBroker": "0226",
        "brokerName": "CITIZENS SECURITIES, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "CJSC",
        "clearingBroker": "0443",
        "brokerName": "CJS SECURITIES, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "CLDN",
        "clearingBroker": "0235",
        "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "CLRK",
        "clearingBroker": "0235",
        "brokerName": "CLARK DODGE & CO, INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "CLRT",
        "clearingBroker": "1043",
        "brokerName": "ARBOR RESEARCH & TRADING, LLC                                         "
    },
    {
        "type": "CORP",
        "mpid": "CLSA",
        "clearingBroker": "0161",
        "brokerName": "CLSA AMERICAS, LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "CLSC",
        "clearingBroker": "0235",
        "brokerName": "CABOT LODGE SECURITIES LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "CLSS",
        "clearingBroker": "0235",
        "brokerName": "CABOT LODGE SECURITIES LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "CLTN",
        "clearingBroker": "0226",
        "brokerName": "CALTON & ASSOCIATES, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "CMCE",
        "clearingBroker": "0226",
        "brokerName": "COMMERCE BROKERAGE SERVICES                                           "
    },
    {
        "type": "CORP",
        "mpid": "CMCX",
        "clearingBroker": "0624",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC                                   "
    },
    {
        "type": "CORP",
        "mpid": "CMFS",
        "clearingBroker": "0443",
        "brokerName": "BNY MELLON CAP MKTS                                                   "
    },
    {
        "type": "CORP",
        "mpid": "CMGF",
        "clearingBroker": "0443",
        "brokerName": "CMG SECURITIES LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "CMMW",
        "clearingBroker": "0226",
        "brokerName": "COMMONWEALTH FINANCIAL NETWORK                                        "
    },
    {
        "type": "CORP",
        "mpid": "CMPT",
        "clearingBroker": "0750",
        "brokerName": "COMPASS POINT RESEARCH & TRADING, LLC                                 "
    },
    {
        "type": "CORP",
        "mpid": "CMSI",
        "clearingBroker": "0279",
        "brokerName": "CAPITAL MANAGEMENT SECURITIES, INC.                                   "
    },
    {
        "type": "CORP",
        "mpid": "CNCD",
        "clearingBroker": "0235",
        "brokerName": "CONCORDE INVESTMENT SERVICES, LLC                                     "
    },
    {
        "type": "CORP",
        "mpid": "CNFI",
        "clearingBroker": "0443",
        "brokerName": "CENTAURUS FINANCIAL INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "CNFR",
        "clearingBroker": "0443",
        "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "CNSI",
        "clearingBroker": "0226",
        "brokerName": "CITY NATIONAL SECURITIES, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "CNTR",
        "clearingBroker": "0103",
        "brokerName": "PRECISION SECURITIES                                                  "
    },
    {
        "type": "CORP",
        "mpid": "COAK",
        "clearingBroker": "0443",
        "brokerName": "CASTLE OAK SECURITIES, L.P.                                           "
    },
    {
        "type": "CORP",
        "mpid": "COAS",
        "clearingBroker": "0443",
        "brokerName": "REALTA EQUITIES, INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "CODA",
        "clearingBroker": "0161",
        "brokerName": "CODA MARKETS, INC.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "COEI",
        "clearingBroker": "0052",
        "brokerName": "COASTAL EQUITIES, INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "COEX",
        "clearingBroker": "0161",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "CORP",
        "mpid": "COFS",
        "clearingBroker": "0279",
        "brokerName": "COLORADO FINANCIAL SERVICE CORPORATION                                "
    },
    {
        "type": "CORP",
        "mpid": "COHN",
        "clearingBroker": "0235",
        "brokerName": "COHEN BROS. & COMPANY                                                 "
    },
    {
        "type": "CORP",
        "mpid": "COKE",
        "clearingBroker": "0235",
        "brokerName": "COKER & PALMER, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "COLS",
        "clearingBroker": "0279",
        "brokerName": "COLONIAL SECURITIES INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "COMP",
        "clearingBroker": "0595",
        "brokerName": "COMPASS POINT RESEARCH & TRADING, LLC                                 "
    },
    {
        "type": "CORP",
        "mpid": "CONI",
        "clearingBroker": "0235",
        "brokerName": "CONTINENTAL INVESTORS SERVICES, INC.                                  "
    },
    {
        "type": "CORP",
        "mpid": "CONR",
        "clearingBroker": "0235",
        "brokerName": "CONNERS & CO., INC.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "CONS",
        "clearingBroker": "0141",
        "brokerName": "CONSULTIVA SECURITIES, INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "COOR",
        "clearingBroker": "0141",
        "brokerName": "COORDINATED CAPITAL SECURITIES, INC.                                  "
    },
    {
        "type": "CORP",
        "mpid": "COSL",
        "clearingBroker": "0443",
        "brokerName": "CLIENT ONE SECURITIES, LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "COWN",
        "clearingBroker": "0100",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "COWP",
        "clearingBroker": "0226",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "COWR",
        "clearingBroker": "0443",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "COWX",
        "clearingBroker": "0161",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "COYL",
        "clearingBroker": "0235",
        "brokerName": "COYLE SECURITIES LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "CPGL",
        "clearingBroker": "0226",
        "brokerName": "CONTINUITY PARTNERS GROUP, LLC                                        "
    },
    {
        "type": "CORP",
        "mpid": "CPLC",
        "clearingBroker": "0595",
        "brokerName": "COVA CAPITAL PARTNERS LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "CPRC",
        "clearingBroker": "0235",
        "brokerName": "CORINTHIAN PARTNERS, L.L.C.                                           "
    },
    {
        "type": "CORP",
        "mpid": "CPRM",
        "clearingBroker": "8199",
        "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "CRCM",
        "clearingBroker": "0235",
        "brokerName": "COHNREZNICK CAPITAL                                                   "
    },
    {
        "type": "CORP",
        "mpid": "CRDL",
        "clearingBroker": "0235",
        "brokerName": "CARDINAL INVESTMENTS, INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "CRED",
        "clearingBroker": "0443",
        "brokerName": "CREDICORP CAPITAL LLC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "CREF",
        "clearingBroker": "0443",
        "brokerName": "TIAA-CREF INDIVIDUAL AND INSTITUTIONAL SERVICES, LLC                  "
    },
    {
        "type": "CORP",
        "mpid": "CREW",
        "clearingBroker": "0443",
        "brokerName": "CREWS & ASSOCIATES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "CRFN",
        "clearingBroker": "6769",
        "brokerName": "ROBINHOOD FINANCIAL, LLC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "CRII",
        "clearingBroker": "0443",
        "brokerName": "CRI SECURITIES INC.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "CRNJ",
        "clearingBroker": "0103",
        "brokerName": "CANTONE RESEARCH                                                      "
    },
    {
        "type": "CORP",
        "mpid": "CRON",
        "clearingBroker": "0443",
        "brokerName": "CRONIN & CO., INC.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "CRPT",
        "clearingBroker": "0235",
        "brokerName": "CROSS POINT CAPITAL LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "CRTH",
        "clearingBroker": "0443",
        "brokerName": "CORINTHIAN PARTNERS, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "CRYN",
        "clearingBroker": "0235",
        "brokerName": "BRENDAN E. CRYAN AND COMPANY, L.L.C.                                  "
    },
    {
        "type": "CORP",
        "mpid": "CSAI",
        "clearingBroker": "0793",
        "brokerName": "STIFEL INDEPENDENT ADVISORS, LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "CSAP",
        "clearingBroker": "0141",
        "brokerName": "CRESAP, INC.                                                          "
    },
    {
        "type": "CORP",
        "mpid": "CSCA",
        "clearingBroker": "4264",
        "brokerName": "ICE BONDS SECURITIES CORPORATION                                      "
    },
    {
        "type": "CORP",
        "mpid": "CSCM",
        "clearingBroker": "0279",
        "brokerName": "CENTRAL STATES CAPITAL MARKETS, LLC                                   "
    },
    {
        "type": "CORP",
        "mpid": "CSPA",
        "clearingBroker": "0226",
        "brokerName": "CREDIT SUISSE PRIVATE ADVISORS                                        "
    },
    {
        "type": "CORP",
        "mpid": "CSPD",
        "clearingBroker": "0197",
        "brokerName": "CANTOR FITZGERALD & CO.                                               "
    },
    {
        "type": "CORP",
        "mpid": "CSPI",
        "clearingBroker": "0235",
        "brokerName": "CAPITAL SYNERGY PARTNERS                                              "
    },
    {
        "type": "CORP",
        "mpid": "CSTI",
        "clearingBroker": "0161",
        "brokerName": "CANACCORD GENUITY INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "CTAS",
        "clearingBroker": "0443",
        "brokerName": "OSAIC INSTITUTIONS, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "CTBK",
        "clearingBroker": "4270",
        "brokerName": "CENTRAL TRUST BANK                                                    "
    },
    {
        "type": "CORP",
        "mpid": "CTDL",
        "clearingBroker": "0551",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "CTDN",
        "clearingBroker": "0352",
        "brokerName": "CITADEL SECURITIES LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "CTNL",
        "clearingBroker": "0235",
        "brokerName": "CENTENNIAL SECURITIES COMPANY LLC                                     "
    },
    {
        "type": "CORP",
        "mpid": "CTSC",
        "clearingBroker": "4264",
        "brokerName": "ICE BONDS SECURITIES CORPORATION                                      "
    },
    {
        "type": "CORP",
        "mpid": "CUFT",
        "clearingBroker": "0226",
        "brokerName": "FROST BROKERAGE SERVICES, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "CUGS",
        "clearingBroker": "8199",
        "brokerName": "DRIVEWEALTH INSTITUTIONAL, LLC                                        "
    },
    {
        "type": "CORP",
        "mpid": "CULL",
        "clearingBroker": "0725",
        "brokerName": "CULLEN INVESTMENT GROUP, LTD.                                         "
    },
    {
        "type": "CORP",
        "mpid": "CUSO",
        "clearingBroker": "0443",
        "brokerName": "CUSO FINANCIAL SERVICES, L.P.                                         "
    },
    {
        "type": "CORP",
        "mpid": "CUTW",
        "clearingBroker": "0235",
        "brokerName": "PROSPERA FINANCIAL SERVICES, INC.                                     "
    },
    {
        "type": "CORP",
        "mpid": "CUWB",
        "clearingBroker": "0103",
        "brokerName": "DRIVEWEALTH INSTITUTIONAL, LLC                                        "
    },
    {
        "type": "CORP",
        "mpid": "CVGP",
        "clearingBroker": "0443",
        "brokerName": "COWEN AND COMPANY LLC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "CWEI",
        "clearingBroker": "0443",
        "brokerName": "BEECH HILL SECURITIES, INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "CWMK",
        "clearingBroker": "0438",
        "brokerName": "CIBC WORLD MARKETS CORP.                                              "
    },
    {
        "type": "CORP",
        "mpid": "CYND",
        "clearingBroker": "0443",
        "brokerName": "TIGRESS FINANCIAL PARTNERS LLC                                        "
    },
    {
        "type": "CORP",
        "mpid": "DADA",
        "clearingBroker": "0361",
        "brokerName": "D. A. DAVIDSON & CO.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "DAII",
        "clearingBroker": "0235",
        "brokerName": "ALEXANDER (DON) INVESTMENTS, INC.                                     "
    },
    {
        "type": "CORP",
        "mpid": "DAIN",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "DAIS",
        "clearingBroker": "0052",
        "brokerName": "DAI SECURITIES, LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "DARA",
        "clearingBroker": "0235",
        "brokerName": "DARWOOD ASSOCIATES, INC                                               "
    },
    {
        "type": "CORP",
        "mpid": "DART",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "DASH",
        "clearingBroker": "0161",
        "brokerName": "DASH FINANCIAL TECHNOLOGIES LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "DAVA",
        "clearingBroker": "0443",
        "brokerName": "DAVENPORT & COMPANY LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "DAWA",
        "clearingBroker": "0647",
        "brokerName": "DAIWA CAPITAL MARKETS AMERICA INC.                                    "
    },
    {
        "type": "CORP",
        "mpid": "DBCC",
        "clearingBroker": "0235",
        "brokerName": "D. BORAL CAPITAL                                                      "
    },
    {
        "type": "CORP",
        "mpid": "DBCH",
        "clearingBroker": "0052",
        "brokerName": "D. BORAL CAPITAL                                                      "
    },
    {
        "type": "CORP",
        "mpid": "DBKS",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "DBPC",
        "clearingBroker": "0443",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "DCAN",
        "clearingBroker": "0279",
        "brokerName": "R. M. DUNCAN SECURITIES, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "DCSD",
        "clearingBroker": "0235",
        "brokerName": "DAIN CORRESPONDENT SERVICES                                           "
    },
    {
        "type": "CORP",
        "mpid": "DCVL",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "DEAN",
        "clearingBroker": "0015",
        "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "DEGS",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "DENI",
        "clearingBroker": "0279",
        "brokerName": "H.C. DENISON CO.                                                      "
    },
    {
        "type": "CORP",
        "mpid": "DETF",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "DFIN",
        "clearingBroker": "0161",
        "brokerName": "DASH FINANCIAL LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "DFPG",
        "clearingBroker": "0235",
        "brokerName": "DFPG INVESTMENTS, INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "DIGG",
        "clearingBroker": "0595",
        "brokerName": "BOUSTEAD SECURITIES, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "DINO",
        "clearingBroker": "0103",
        "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
    },
    {
        "type": "CORP",
        "mpid": "DJSA",
        "clearingBroker": "0750",
        "brokerName": "DAWSON JAMES SECURITIES, INC                                          "
    },
    {
        "type": "CORP",
        "mpid": "DLAI",
        "clearingBroker": "0235",
        "brokerName": "DAVID LERNER ASSOCIATES, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "DLPS",
        "clearingBroker": "0595",
        "brokerName": "DLP SECURITIES,.LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "DLSI",
        "clearingBroker": "0226",
        "brokerName": "DEMPSEY LORD SMITH, LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "DMCD",
        "clearingBroker": "0279",
        "brokerName": "MCDERMOTT INVESTMENT SERVICES, LLC                                    "
    },
    {
        "type": "CORP",
        "mpid": "DMKC",
        "clearingBroker": "0141",
        "brokerName": "D.M. KELLY & COMPANY                                                  "
    },
    {
        "type": "CORP",
        "mpid": "DNOR",
        "clearingBroker": "0005",
        "brokerName": "DNB MARKETS, INC.                                                     "
    },
    {
        "type": "CORP",
        "mpid": "DNSR",
        "clearingBroker": "0158",
        "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
    },
    {
        "type": "CORP",
        "mpid": "DNWL",
        "clearingBroker": "0443",
        "brokerName": "DUNCAN & WILLIAMS, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "DOFT",
        "clearingBroker": "0443",
        "brokerName": "DOFT & CO., INC.                                                      "
    },
    {
        "type": "CORP",
        "mpid": "DOMI",
        "clearingBroker": "0279",
        "brokerName": "DOMINION INVESTOR SERVICES, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "DOMS",
        "clearingBroker": "0235",
        "brokerName": "DOMINARI SECURITIES LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "DORN",
        "clearingBroker": "0235",
        "brokerName": "DORN & CO., INC.                                                      "
    },
    {
        "type": "CORP",
        "mpid": "DOTC",
        "clearingBroker": "0226",
        "brokerName": "COLLIERS SECURITIES LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "DOVE",
        "clearingBroker": "0226",
        "brokerName": "SECURITIES EQUITY GROUP                                               "
    },
    {
        "type": "CORP",
        "mpid": "DOWL",
        "clearingBroker": "0443",
        "brokerName": "DOWLING & PARTNERS SECURITIES LLC                                     "
    },
    {
        "type": "CORP",
        "mpid": "DREX",
        "clearingBroker": "0443",
        "brokerName": "DREXEL HAMILTON, LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "DRSC",
        "clearingBroker": "0443",
        "brokerName": "BNY MELLON SECURITIES CORPORATION                                     "
    },
    {
        "type": "CORP",
        "mpid": "DRTG",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "DRTR",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "DRVW",
        "clearingBroker": "0235",
        "brokerName": "DRIVEWEALTH, LLC                                                      "
    },
    {
        "type": "CORP",
        "mpid": "DRWM",
        "clearingBroker": "0005",
        "brokerName": "DRW SECURITIES, L.L.C.                                                "
    },
    {
        "type": "CORP",
        "mpid": "DSAI",
        "clearingBroker": "0443",
        "brokerName": "DAEWOO SECURITIES (AMERICA) INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "DSGG",
        "clearingBroker": "0226",
        "brokerName": "DMG SECURITIES, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "DTEX",
        "clearingBroker": "0235",
        "brokerName": "INSTITUTIONAL SECURITIES CORPORATION                                  "
    },
    {
        "type": "CORP",
        "mpid": "DUST",
        "clearingBroker": "0161",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "CORP",
        "mpid": "DVES",
        "clearingBroker": "0005",
        "brokerName": "DV EQUITIES                                                           "
    },
    {
        "type": "CORP",
        "mpid": "DWIZ",
        "clearingBroker": "0235",
        "brokerName": "DRIVEWEALTH INSTITUTIONAL LLC                                         "
    },
    {
        "type": "CORP",
        "mpid": "EAMC",
        "clearingBroker": "0235",
        "brokerName": "EMPIRE ASSET MANAGEMENT COMPANY                                       "
    },
    {
        "type": "CORP",
        "mpid": "EAMG",
        "clearingBroker": "0235",
        "brokerName": "EMPIRE ASSET MANAGEMENT COMPANY                                       "
    },
    {
        "type": "CORP",
        "mpid": "EBKD",
        "clearingBroker": "0537",
        "brokerName": "BGC FINANCIAL, L.P.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "EBKR",
        "clearingBroker": "0537",
        "brokerName": "BGC FINANCIAL INC.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "EBRD",
        "clearingBroker": "0103",
        "brokerName": "EARLYBIRD CAPITAL, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "ECCC",
        "clearingBroker": "0226",
        "brokerName": "EAGLES COAST CAPITAL, LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "EDFC",
        "clearingBroker": "0443",
        "brokerName": "E D & F MAN CAPITAL MARKETS INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "EDFO",
        "clearingBroker": "0158",
        "brokerName": "E D & F MAN CAPITAL MARKETS INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "EDIR",
        "clearingBroker": "0235",
        "brokerName": "EDI FINANCIAL, INC.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "EDJO",
        "clearingBroker": "0057",
        "brokerName": "EDWARD D. JONES & CO.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "EFGC",
        "clearingBroker": "0443",
        "brokerName": "EFG CAPITAL INTERNATIONAL                                             "
    },
    {
        "type": "CORP",
        "mpid": "EFSP",
        "clearingBroker": "0443",
        "brokerName": "ESSEX FINANCIAL SERVICES, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "EGLE",
        "clearingBroker": "1043",
        "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
    },
    {
        "type": "CORP",
        "mpid": "EGMT",
        "clearingBroker": "0005",
        "brokerName": "EG MARKET TECHNOLOGIES LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "ELEQ",
        "clearingBroker": "0551",
        "brokerName": "ELEQUIN SECURITIES LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "ELET",
        "clearingBroker": "0388",
        "brokerName": "ELECTRONIFIE SECURITIES LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "ELEV",
        "clearingBroker": "0235",
        "brokerName": "ELEVATION, LLC                                                        "
    },
    {
        "type": "CORP",
        "mpid": "ELQN",
        "clearingBroker": "0443",
        "brokerName": "ELEQUIN SECURITIES LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "EMER",
        "clearingBroker": "0443",
        "brokerName": "EMERSON EQUITY LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "EMOC",
        "clearingBroker": "0750",
        "brokerName": "E. MAGNUS OPPENHIEM & CO. INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "EMPR",
        "clearingBroker": "0279",
        "brokerName": "SELKIRK INVESTMENTS, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "EMRP",
        "clearingBroker": "0161",
        "brokerName": "EMPIRICAL RESEARCH PARTNERS LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "ENTR",
        "clearingBroker": "0235",
        "brokerName": "ENTRUSTODY FINANCIAL, LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "EPIC",
        "clearingBroker": "0443",
        "brokerName": "EPIC CAPITAL SECURITIES                                               "
    },
    {
        "type": "CORP",
        "mpid": "EQHA",
        "clearingBroker": "0075",
        "brokerName": "EQUITABLE ADVISORS, LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "EQSV",
        "clearingBroker": "0226",
        "brokerName": "EQUITY SERVICES, INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "EROP",
        "clearingBroker": "0158",
        "brokerName": "EROOM SECURITIES LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "ESBD",
        "clearingBroker": "0235",
        "brokerName": "EASTDIL SECURED ADVISORS LLC                                          "
    },
    {
        "type": "CORP",
        "mpid": "ESHC",
        "clearingBroker": "0443",
        "brokerName": "FIRST SOUTHERN, LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "ETCB",
        "clearingBroker": "3505",
        "brokerName": "ETC BROKERAGE SERVICES, LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "ETCL",
        "clearingBroker": "0015",
        "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "ETRF",
        "clearingBroker": "0161",
        "brokerName": "G1 EXECUTION SERVICES, LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "ETRS",
        "clearingBroker": "0015",
        "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "EUBR",
        "clearingBroker": "0537",
        "brokerName": "BGC FINANCIAL INC.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "EVOL",
        "clearingBroker": "0226",
        "brokerName": "EVOLVE SECURITIES, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "EWMX",
        "clearingBroker": "0279",
        "brokerName": "EAST WEST MARKETS, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "EXCS",
        "clearingBroker": "0443",
        "brokerName": "EXCEL SECURITIES AND ASSOCIATES, INC.                                 "
    },
    {
        "type": "CORP",
        "mpid": "FAFI",
        "clearingBroker": "0279",
        "brokerName": "FIRST ASSET FINANCIAL                                                 "
    },
    {
        "type": "CORP",
        "mpid": "FALC",
        "clearingBroker": "0103",
        "brokerName": "FALCON SQUARE CAPITAL, LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "FALL",
        "clearingBroker": "0725",
        "brokerName": "FALLLINE SECURITIES LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "FANC",
        "clearingBroker": "0235",
        "brokerName": "FINANCE 500, INC.                                                     "
    },
    {
        "type": "CORP",
        "mpid": "FARA",
        "clearingBroker": "8199",
        "brokerName": "FARINA & ASSOCIATES, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "FATS",
        "clearingBroker": "0443",
        "brokerName": "FIRST BROKERS SECURITIES LLC                                          "
    },
    {
        "type": "CORP",
        "mpid": "FBLM",
        "clearingBroker": "0235",
        "brokerName": "FBL MARKETING SERVICES LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "FBLT",
        "clearingBroker": "8199",
        "brokerName": "FIRST BALLANTYNE, LLC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "FBNS",
        "clearingBroker": "0235",
        "brokerName": "FBN SECURITIES, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "FBPC",
        "clearingBroker": "0443",
        "brokerName": "CREDIT SUISSE SECURITIES (USA) LLC                                    "
    },
    {
        "type": "CORP",
        "mpid": "FBSB",
        "clearingBroker": "0280",
        "brokerName": "U.S. BANCORP INVESTMENTS, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "FCFP",
        "clearingBroker": "0141",
        "brokerName": "FIRST CITIZENS FINANCIAL PLUS, INC.                                   "
    },
    {
        "type": "CORP",
        "mpid": "FCFS",
        "clearingBroker": "0443",
        "brokerName": "FIRST COMMAND FINANCIAL PLANNING, INC.                                "
    },
    {
        "type": "CORP",
        "mpid": "FCGB",
        "clearingBroker": "0537",
        "brokerName": "BGC FINANCIAL, L.P.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "FCIT",
        "clearingBroker": "0443",
        "brokerName": "FIRST CITIZENS INVESTOR SERVICES, INC.                                "
    },
    {
        "type": "CORP",
        "mpid": "FCML",
        "clearingBroker": "0279",
        "brokerName": "FNBB CAPITAL MARKETS, LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "FCMP",
        "clearingBroker": "0595",
        "brokerName": "PRIME EXECUTIONS, INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "FCST",
        "clearingBroker": "0443",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "FDSC",
        "clearingBroker": "0158",
        "brokerName": "1ST DISCOUNT BROKERAGE INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "FDSI",
        "clearingBroker": "0141",
        "brokerName": "FIRST DALLAS SECURITIES, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "FEDR",
        "clearingBroker": "0235",
        "brokerName": "FEDERATED SECURITIES INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "FENX",
        "clearingBroker": "0595",
        "brokerName": "FENIX SECURITIES, LLC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "FERN",
        "clearingBroker": "0443",
        "brokerName": "FEARNLEY SECURITIES                                                   "
    },
    {
        "type": "CORP",
        "mpid": "FFCM",
        "clearingBroker": "0235",
        "brokerName": "FOREFRONT CAPITAL MARKETS LLC                                         "
    },
    {
        "type": "CORP",
        "mpid": "FFGI",
        "clearingBroker": "0235",
        "brokerName": "FELDSTEIN FINANCIAL GROUP, LLC                                        "
    },
    {
        "type": "CORP",
        "mpid": "FFSI",
        "clearingBroker": "0158",
        "brokerName": "FIRSTRADE SECURITIES INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "FHCI",
        "clearingBroker": "0443",
        "brokerName": "FIRST HEARTLAND CAPITAL, INC                                          "
    },
    {
        "type": "CORP",
        "mpid": "FHON",
        "clearingBroker": "0235",
        "brokerName": "FIRST HONOLULU SECURITIES INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "FIBS",
        "clearingBroker": "0226",
        "brokerName": "FIDELITY BROKERAGE SERVICES LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "FISA",
        "clearingBroker": "0443",
        "brokerName": "ADVISORS ASSET MANAGEMENT, INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "FISB",
        "clearingBroker": "0226",
        "brokerName": "ADVISORS ASSET MANAGEMENT, INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "FISH",
        "clearingBroker": "0235",
        "brokerName": "L.B. FISHER & COMPANY                                                 "
    },
    {
        "type": "CORP",
        "mpid": "FJRF",
        "clearingBroker": "0052",
        "brokerName": "PARITER SECURITIES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "FKSC",
        "clearingBroker": "0235",
        "brokerName": "FIRST KENTUCKY SECURITIES CORP.                                       "
    },
    {
        "type": "CORP",
        "mpid": "FLAT",
        "clearingBroker": "0226",
        "brokerName": "FLORIDA ATLANTIC SECURITIES CORP.                                     "
    },
    {
        "type": "CORP",
        "mpid": "FLCO",
        "clearingBroker": "0750",
        "brokerName": "THE FRAZER LANIER COMPANY, INCORPORATED                               "
    },
    {
        "type": "CORP",
        "mpid": "FLEX",
        "clearingBroker": "0158",
        "brokerName": "GWM GROUP, INC.                                                       "
    },
    {
        "type": "CORP",
        "mpid": "FLIB",
        "clearingBroker": "0235",
        "brokerName": "FIRST LIBERTIES FINANCIAL                                             "
    },
    {
        "type": "CORP",
        "mpid": "FLIO",
        "clearingBroker": "0750",
        "brokerName": "SANTOS CAPITAL GROUP, LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "FLOU",
        "clearingBroker": "0443",
        "brokerName": "FIRST ST. LOUIS SECURITIES, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "FLTG",
        "clearingBroker": "0005",
        "brokerName": "FLOW TRADERS U.S. LLC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "FLTL",
        "clearingBroker": "0235",
        "brokerName": "FELTL & COMPANY                                                       "
    },
    {
        "type": "CORP",
        "mpid": "FLTU",
        "clearingBroker": "0551",
        "brokerName": "FLOW TRADERS US LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "FLWT",
        "clearingBroker": "0161",
        "brokerName": "FLOW TRADERS U.S. INSTITUTIONAL TRADING LLC                           "
    },
    {
        "type": "CORP",
        "mpid": "FMAT",
        "clearingBroker": "0608",
        "brokerName": "SG AMERICAS SECURITIES, LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "FMCO",
        "clearingBroker": "0443",
        "brokerName": "FIRST MANHATTAN CO.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "FMEX",
        "clearingBroker": "0750",
        "brokerName": "FINAMEX INTERNATIONAL, LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "FMFS",
        "clearingBroker": "0226",
        "brokerName": "FISRT MERIT FINANCIAL SERVICES, INC                                   "
    },
    {
        "type": "CORP",
        "mpid": "FMGT",
        "clearingBroker": "0443",
        "brokerName": "FAMILY MANAGEMENT SECURITIES, LLC                                     "
    },
    {
        "type": "CORP",
        "mpid": "FNFD",
        "clearingBroker": "0443",
        "brokerName": "FOLGER NOLAN FLEMING DOUGLAS INCORPORATED                             "
    },
    {
        "type": "CORP",
        "mpid": "FNIC",
        "clearingBroker": "0443",
        "brokerName": "FINANCIAL NETWORK INVESTMENT CORP.                                    "
    },
    {
        "type": "CORP",
        "mpid": "FNPN",
        "clearingBroker": "0443",
        "brokerName": "UNIVEST INVESTMENTS                                                   "
    },
    {
        "type": "CORP",
        "mpid": "FNSJ",
        "clearingBroker": "0443",
        "brokerName": "FINANCIAL NORTHEASTERN SECURITIES, INC.                               "
    },
    {
        "type": "CORP",
        "mpid": "FNXB",
        "clearingBroker": "0537",
        "brokerName": "BGC FINANCIAL, L.P.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "FNXS",
        "clearingBroker": "0750",
        "brokerName": "FENIX SECURITIES, LLC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "FOGS",
        "clearingBroker": "0235",
        "brokerName": "FOG EQUITIES LLC                                                      "
    },
    {
        "type": "CORP",
        "mpid": "FORI",
        "clearingBroker": "0750",
        "brokerName": "FORTREND SECURITIES, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "FOXC",
        "clearingBroker": "0443",
        "brokerName": "FOX CHASE CAPITAL PARTNERS, LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "FRLZ",
        "clearingBroker": "0103",
        "brokerName": "FRIEDMAN LUZZATTO & CO                                                "
    },
    {
        "type": "CORP",
        "mpid": "FRTN",
        "clearingBroker": "0103",
        "brokerName": "FORTUNE SECURITIES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "FSCS",
        "clearingBroker": "0443",
        "brokerName": "OSAIC WEALTH, INC.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "FSIX",
        "clearingBroker": "0725",
        "brokerName": "FSIC                                                                  "
    },
    {
        "type": "CORP",
        "mpid": "FSRP",
        "clearingBroker": "0443",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "FTEN",
        "clearingBroker": "0226",
        "brokerName": "FTB ADVISORS, INC.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "FTLP",
        "clearingBroker": "8244",
        "brokerName": "FIRST TRUST PORTFOLIOS, L.P.                                          "
    },
    {
        "type": "CORP",
        "mpid": "FTSC",
        "clearingBroker": "0202",
        "brokerName": "FHN FINANCIAL SECURITIES CORP.                                        "
    },
    {
        "type": "CORP",
        "mpid": "FTSR",
        "clearingBroker": "0226",
        "brokerName": "FIFTH THIRD SECURITIES, INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "FUBO",
        "clearingBroker": "0443",
        "brokerName": "GRIFFINEST ASIA SECURITIES, LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "FWSI",
        "clearingBroker": "0141",
        "brokerName": "FIRST WESTERN SECURITIES, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "GABE",
        "clearingBroker": "0141",
        "brokerName": "G. RESEARCH, INC.                                                     "
    },
    {
        "type": "CORP",
        "mpid": "GAFI",
        "clearingBroker": "0235",
        "brokerName": "GARDNER FINANCIAL SERVICES INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "GAGN",
        "clearingBroker": "0226",
        "brokerName": "GAGNON SECURITIES, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "GAII",
        "clearingBroker": "0279",
        "brokerName": "GREAT AMERICAN INVESTORS, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "GARB",
        "clearingBroker": "0148",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC                                   "
    },
    {
        "type": "CORP",
        "mpid": "GARC",
        "clearingBroker": "0161",
        "brokerName": "ICAP CORPORATES LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "GARE",
        "clearingBroker": "0148",
        "brokerName": "GARE                                                                  "
    },
    {
        "type": "CORP",
        "mpid": "GARR",
        "clearingBroker": "0226",
        "brokerName": "GARRETT NAGLE & CO., INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "GARW",
        "clearingBroker": "0595",
        "brokerName": "GAR WOOD SECURITIES, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "GBMS",
        "clearingBroker": "0158",
        "brokerName": "GBM INTERNATIONAL, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "GBMT",
        "clearingBroker": "0443",
        "brokerName": "GBM INTERNATIONAL, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "GBTS",
        "clearingBroker": "0005",
        "brokerName": "GTS SECURITIES, LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "GCMC",
        "clearingBroker": "0443",
        "brokerName": "GLADOWSKY CAPITAL MANAGEMENT CORP.                                    "
    },
    {
        "type": "CORP",
        "mpid": "GDCO",
        "clearingBroker": "0443",
        "brokerName": "GILBERT, DONIGER CO., INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "GELP",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "GENS",
        "clearingBroker": "0279",
        "brokerName": "GENERAL SECURITIES CORP                                               "
    },
    {
        "type": "CORP",
        "mpid": "GENW",
        "clearingBroker": "0443",
        "brokerName": "GENEOS WEALTH MANAGEMENT, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "GFIG",
        "clearingBroker": "0537",
        "brokerName": "GFI SECURITIES LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "GFSI",
        "clearingBroker": "0725",
        "brokerName": "GLOBAL FINANCIAL SERVICES, L.L.C.                                     "
    },
    {
        "type": "CORP",
        "mpid": "GGWI",
        "clearingBroker": "0141",
        "brokerName": "GAGE-WILEY & COMPANY INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "GHCC",
        "clearingBroker": "0226",
        "brokerName": "GORDON, HASKETT CAPITAL CORPORATION                                   "
    },
    {
        "type": "CORP",
        "mpid": "GILG",
        "clearingBroker": "0226",
        "brokerName": "GILDER GAGNON HOWE & CO. LLC                                          "
    },
    {
        "type": "CORP",
        "mpid": "GJSS",
        "clearingBroker": "0235",
        "brokerName": "SCHWARTZ, GREGORY J & CO. INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "GLCM",
        "clearingBroker": "0443",
        "brokerName": "GREENSLEDGE CAPITAL MARKETS                                           "
    },
    {
        "type": "CORP",
        "mpid": "GLLL",
        "clearingBroker": "0279",
        "brokerName": "GILL CAPITAL PARTNERS                                                 "
    },
    {
        "type": "CORP",
        "mpid": "GLYN",
        "clearingBroker": "0443",
        "brokerName": "GLYNN (J.A.) & CO.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "GMSE",
        "clearingBroker": "0750",
        "brokerName": "GAMMA SECURITIES, LLC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "GMSG",
        "clearingBroker": "0443",
        "brokerName": "GMS GROUP (THE), L.L.C.                                               "
    },
    {
        "type": "CORP",
        "mpid": "GPCA",
        "clearingBroker": "0158",
        "brokerName": "GREAT POINT CAPITAL LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "GPCG",
        "clearingBroker": "0443",
        "brokerName": "GREENMAN, PARKER, CONNALLY, GREENMAN, INC.                            "
    },
    {
        "type": "CORP",
        "mpid": "GPSS",
        "clearingBroker": "0443",
        "brokerName": "GREAT PACIFIC SECURITIES                                              "
    },
    {
        "type": "CORP",
        "mpid": "GRAD",
        "clearingBroker": "0235",
        "brokerName": "GRADIENT SECURITIES, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "GRBD",
        "clearingBroker": "0052",
        "brokerName": "GREENBIRD CAPITAL LLC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "GRIL",
        "clearingBroker": "0235",
        "brokerName": "GLOBAL RESOURCE INVESTMENTS, LTD.                                     "
    },
    {
        "type": "CORP",
        "mpid": "GROD",
        "clearingBroker": "0226",
        "brokerName": "GRODSKY ASSOCIATES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "GRPS",
        "clearingBroker": "0226",
        "brokerName": "MML INVESTORS SERVICES, LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "GRWD",
        "clearingBroker": "0052",
        "brokerName": "GAR WOOD SECURITIES, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "GRYG",
        "clearingBroker": "0226",
        "brokerName": "GOLDBERG (GARY) & CO., INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "GSBI",
        "clearingBroker": "0279",
        "brokerName": "GLOBAL BROKERAGE SERVICES, INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "GSCO",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "GSIL",
        "clearingBroker": "0158",
        "brokerName": "GLOBAL STRATEGIC INVESTMENTS, LLC                                     "
    },
    {
        "type": "CORP",
        "mpid": "GSMM",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "GSQQ",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "GSSC",
        "clearingBroker": "0161",
        "brokerName": "GEORGESON SHAREHOLDER SECURITIES CORP.                                "
    },
    {
        "type": "CORP",
        "mpid": "GSSI",
        "clearingBroker": "0052",
        "brokerName": "GARDEN STATE SECURITIES, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "GSUU",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "GSVV",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "GTNB",
        "clearingBroker": "0595",
        "brokerName": "GTN AMERICAS FINANCIAL SERVICES, INC.                                 "
    },
    {
        "type": "CORP",
        "mpid": "GTSM",
        "clearingBroker": "0005",
        "brokerName": "GTS SECURITIES LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "GWFS",
        "clearingBroker": "0443",
        "brokerName": "GWFS EQUITIES, INC.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "GWNS",
        "clearingBroker": "0443",
        "brokerName": "GWN SECURITIES INC.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "GZML",
        "clearingBroker": "0161",
        "brokerName": "GUZMAN & COMPANY                                                      "
    },
    {
        "type": "CORP",
        "mpid": "HAFS",
        "clearingBroker": "0279",
        "brokerName": "HANTZ FINANCIAL SERVICES, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "HALO",
        "clearingBroker": "0235",
        "brokerName": "HALO SECURITIES, LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "HARB",
        "clearingBroker": "0443",
        "brokerName": "HARBOUR INVESTMENTS INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "HARC",
        "clearingBroker": "0235",
        "brokerName": "HARLEY CAPITAL LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "HARS",
        "clearingBroker": "8199",
        "brokerName": "HARVESTONS SECURITIES, INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "HAVK",
        "clearingBroker": "0235",
        "brokerName": "EMPIRE STATE FINANCIAL, INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "HAZL",
        "clearingBroker": "0226",
        "brokerName": "HAZLETT, BURT AND WATSON, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "HBCO",
        "clearingBroker": "0443",
        "brokerName": "GLOBAL INVESTOR SERVICES, L.C.                                        "
    },
    {
        "type": "CORP",
        "mpid": "HBUS",
        "clearingBroker": "0443",
        "brokerName": "HOLISTIC BROKERAGE, LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "HCGC",
        "clearingBroker": "0103",
        "brokerName": "FALCON SQUARE CAPITAL, LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "HCMX",
        "clearingBroker": "0235",
        "brokerName": "HOOPOE CAPITAL MARKETS, LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "HCTA",
        "clearingBroker": "0005",
        "brokerName": "PEAK6 CAPITAL MANAGEMENT LLC                                          "
    },
    {
        "type": "CORP",
        "mpid": "HCWW",
        "clearingBroker": "0235",
        "brokerName": "H.C.WAINWRIGHT & CO., LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "HDVS",
        "clearingBroker": "0226",
        "brokerName": "AVANTAX INVESTMENT SERVICES, INC.                                     "
    },
    {
        "type": "CORP",
        "mpid": "HEAD",
        "clearingBroker": "0443",
        "brokerName": "TD SECURITIES AUTOMATED TRADING LLC                                   "
    },
    {
        "type": "CORP",
        "mpid": "HEGS",
        "clearingBroker": "1043",
        "brokerName": "HEG SECURITIES, LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "HENN",
        "clearingBroker": "0235",
        "brokerName": "CARL M. HENNIG, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "HENY",
        "clearingBroker": "0443",
        "brokerName": "HENLEY & COMPANY LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "HFLD",
        "clearingBroker": "0279",
        "brokerName": "HARTFIELD, TITUS & DONNELLY, LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "HIAL",
        "clearingBroker": "0443",
        "brokerName": "HARBOR INVESTMENT ADVISORY, LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "HIGG",
        "clearingBroker": "0235",
        "brokerName": "HIGGINS CAPITAL MANAGEMENT, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "HINO",
        "clearingBroker": "0235",
        "brokerName": "TRB CAPITAL MARKETS,LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "HITS",
        "clearingBroker": "0443",
        "brokerName": "HEIGHT SECURITIES, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "HJSC",
        "clearingBroker": "0443",
        "brokerName": "SIMS (HERBERT J.) & CO., INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "HNTR",
        "clearingBroker": "0443",
        "brokerName": "HUNTER ASSOCIATES, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "HONR",
        "clearingBroker": "0235",
        "brokerName": "ROBERTS & RYAN INVESTMENTS INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "HOOD",
        "clearingBroker": "6769",
        "brokerName": "ROBINHOOD SECURITIES, LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "HOPK",
        "clearingBroker": "0750",
        "brokerName": "SILVER OAK SECURITIES, INCORPORATED                                   "
    },
    {
        "type": "CORP",
        "mpid": "HOTO",
        "clearingBroker": "0443",
        "brokerName": "HORNOR, TOWNSEND & KENT, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "HPOM",
        "clearingBroker": "0235",
        "brokerName": "HERNDON PLANT OAKLEY, LTD.                                            "
    },
    {
        "type": "CORP",
        "mpid": "HPWD",
        "clearingBroker": "0443",
        "brokerName": "PIPER SANDLER & CO.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "HRBF",
        "clearingBroker": "0756",
        "brokerName": "AMERICAN ENTERPRISE INVESTMENT SERVICES INC.                          "
    },
    {
        "type": "CORP",
        "mpid": "HRCO",
        "clearingBroker": "0103",
        "brokerName": "H RIVKIN & COMPANY                                                    "
    },
    {
        "type": "CORP",
        "mpid": "HRCS",
        "clearingBroker": "0443",
        "brokerName": "HRC INVESTMENT SERVICES, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "HRGR",
        "clearingBroker": "0235",
        "brokerName": "HARGER AND COMPANY, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "HRRS",
        "clearingBroker": "0443",
        "brokerName": "HARRIS INVESTORS SERVICES, INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "HSAI",
        "clearingBroker": "0443",
        "brokerName": "INDEPENDENT FINANCIAL GROUP, LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "HSBK",
        "clearingBroker": "0443",
        "brokerName": "HSBC SECURITIES (USA) INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "HSBM",
        "clearingBroker": "0486",
        "brokerName": "HSBC SECURITIES (USA), INC/ FIXED INCOME SECS                         "
    },
    {
        "type": "CORP",
        "mpid": "HTCM",
        "clearingBroker": "0235",
        "brokerName": "HOWDEN TIGER CAPITAL MARKETS & ADVISOF LLC                            "
    },
    {
        "type": "CORP",
        "mpid": "HTDX",
        "clearingBroker": "0279",
        "brokerName": "HARTFIELD, TITUS & DONNELLY, LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "HTIS",
        "clearingBroker": "0443",
        "brokerName": "HAITONG INTERNATIONAL SECURITIES (USA) INC.                           "
    },
    {
        "type": "CORP",
        "mpid": "HTPS",
        "clearingBroker": "0443",
        "brokerName": "HIGHTOWER SECURITIES, LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "HTWR",
        "clearingBroker": "0226",
        "brokerName": "HIGHTOWER SECURITIES, LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "HUCO",
        "clearingBroker": "0226",
        "brokerName": "HUNTINGTON INVESTMENT COMPANY                                         "
    },
    {
        "type": "CORP",
        "mpid": "HUFS",
        "clearingBroker": "0443",
        "brokerName": "HUNT FINANCIAL SECURITIES, LLC                                        "
    },
    {
        "type": "CORP",
        "mpid": "HUNT",
        "clearingBroker": "0141",
        "brokerName": "HUNTLEIGH SECURITIES CORPORATION                                      "
    },
    {
        "type": "CORP",
        "mpid": "HUTC",
        "clearingBroker": "0443",
        "brokerName": "HUNTINGTON SECURITIES, INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "HWJC",
        "clearingBroker": "0052",
        "brokerName": "HWJ CAPITAL PARTNERS II, LLC                                          "
    },
    {
        "type": "CORP",
        "mpid": "HWLS",
        "clearingBroker": "0443",
        "brokerName": "M.S. HOWELLS & CO.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "IAAK",
        "clearingBroker": "0279",
        "brokerName": "ISAAK BOND INVESTMENT, INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "IAEW",
        "clearingBroker": "0595",
        "brokerName": "SRT SECURITIES LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "IAEX",
        "clearingBroker": "0235",
        "brokerName": "SRT SECURITIES LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "IBKR",
        "clearingBroker": "0017",
        "brokerName": "INTERACTIVE BROKERS LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "IBND",
        "clearingBroker": "0103",
        "brokerName": "INSTITUTIONAL BOND NETWORK, LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "IBOT",
        "clearingBroker": "0279",
        "brokerName": "INVESTORS BROKERAGE OF TEXAS, INC                                     "
    },
    {
        "type": "CORP",
        "mpid": "IBPR",
        "clearingBroker": "0052",
        "brokerName": "IB CAPITAL LLC                                                        "
    },
    {
        "type": "CORP",
        "mpid": "IBSJ",
        "clearingBroker": "0052",
        "brokerName": "INTEGRITY BROKERAGE                                                   "
    },
    {
        "type": "CORP",
        "mpid": "ICAN",
        "clearingBroker": "0226",
        "brokerName": "CETERA ADVISOR NETWORKS LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "ICBK",
        "clearingBroker": "0388",
        "brokerName": "INDUSTRIAL AND COMMERCIAL BANK OF CHINA FINANCIAL SERVICES LLC        "
    },
    {
        "type": "CORP",
        "mpid": "ICCI",
        "clearingBroker": "0279",
        "brokerName": "INDEPENDENCE CAPITAL CO.                                              "
    },
    {
        "type": "CORP",
        "mpid": "ICDS",
        "clearingBroker": "0750",
        "brokerName": "ICD SECURITIES                                                        "
    },
    {
        "type": "CORP",
        "mpid": "ICEX",
        "clearingBroker": "4264",
        "brokerName": "ICE SECURITIES EXECUTION & CLEARING, LLC                              "
    },
    {
        "type": "CORP",
        "mpid": "ICMB",
        "clearingBroker": "1043",
        "brokerName": "INTERCOASTAL CAPITAL MARKETS, INC.                                    "
    },
    {
        "type": "CORP",
        "mpid": "ICMH",
        "clearingBroker": "0235",
        "brokerName": "INSTITUTIONAL CAPITAL MANAGEMENT, INC.                                "
    },
    {
        "type": "CORP",
        "mpid": "ICMI",
        "clearingBroker": "0279",
        "brokerName": "INTERCOASTAL CAPITAL MARKETS, INC.                                    "
    },
    {
        "type": "CORP",
        "mpid": "ICON",
        "clearingBroker": "0595",
        "brokerName": "ICON CAPITAL GROUP, LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "ICRL",
        "clearingBroker": "0443",
        "brokerName": "RIDEAU (I.C.) LYONS AND CO.                                           "
    },
    {
        "type": "CORP",
        "mpid": "ICTI",
        "clearingBroker": "0158",
        "brokerName": "INTERNATIONAL CORRESPONDENT TRADING, INC.                             "
    },
    {
        "type": "CORP",
        "mpid": "IDAY",
        "clearingBroker": "0103",
        "brokerName": "BROKERAGESELECT                                                       "
    },
    {
        "type": "CORP",
        "mpid": "IESI",
        "clearingBroker": "0443",
        "brokerName": "ITAU EUROPA SECURITIES INC                                            "
    },
    {
        "type": "CORP",
        "mpid": "IFCS",
        "clearingBroker": "0161",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "IMCC",
        "clearingBroker": "0005",
        "brokerName": "IMC FINANCIAL MARKETS                                                 "
    },
    {
        "type": "CORP",
        "mpid": "IMPC",
        "clearingBroker": "0443",
        "brokerName": "IMPERIAL CAPITAL, LLC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "INCC",
        "clearingBroker": "0443",
        "brokerName": "SATURNA BROKERAGE SERVICES, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "INFI",
        "clearingBroker": "0279",
        "brokerName": "INTEGRAL FINANCIAL, LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "INGF",
        "clearingBroker": "0270",
        "brokerName": "ING FINANCIAL MARKETS LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "INGS",
        "clearingBroker": "0124",
        "brokerName": "INGALLS & SNYDER, LLC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "INNO",
        "clearingBroker": "0052",
        "brokerName": "ETC BROKERAGE SERVICES, LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "INPI",
        "clearingBroker": "0235",
        "brokerName": "INVESTMENT PLANNERS INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "INPS",
        "clearingBroker": "0235",
        "brokerName": "INDEPENDENCE POINT SECURITIES LLC                                     "
    },
    {
        "type": "CORP",
        "mpid": "INTL",
        "clearingBroker": "0750",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "INTX",
        "clearingBroker": "0235",
        "brokerName": "INTERNATIONAL ASSETS ADVISORY, LLC                                    "
    },
    {
        "type": "CORP",
        "mpid": "IPGR",
        "clearingBroker": "0443",
        "brokerName": "INVESTMENT PLACEMENT GROUP                                            "
    },
    {
        "type": "CORP",
        "mpid": "IRMD",
        "clearingBroker": "0443",
        "brokerName": "PLANMEMBER SECURITIES CORP                                            "
    },
    {
        "type": "CORP",
        "mpid": "ISCN",
        "clearingBroker": "0235",
        "brokerName": "INSTITUTIONAL SECURITIES CORPORATION                                  "
    },
    {
        "type": "CORP",
        "mpid": "ISIG",
        "clearingBroker": "0226",
        "brokerName": "EVERCORE GROUP L.L.C.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "ISLL",
        "clearingBroker": "0052",
        "brokerName": "INLET SECURITIES LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "ISSI",
        "clearingBroker": "0052",
        "brokerName": "INSIGHT SECURITIES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "ITAU",
        "clearingBroker": "0443",
        "brokerName": "ITAU BBA USA SECURITIES INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "ITCC",
        "clearingBroker": "0750",
        "brokerName": "STERNE AGEE FINANCIAL SERVICES, INC.                                  "
    },
    {
        "type": "CORP",
        "mpid": "ITCM",
        "clearingBroker": "0443",
        "brokerName": "INTERCAM SECURITIES, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "ITFS",
        "clearingBroker": "0226",
        "brokerName": "KEEL POINT CAPITAL, LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "IVEX",
        "clearingBroker": "0443",
        "brokerName": "INVEX, INC.                                                           "
    },
    {
        "type": "CORP",
        "mpid": "IVNT",
        "clearingBroker": "0235",
        "brokerName": "INVESTMENT NETWORK, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "IVOL",
        "clearingBroker": "0235",
        "brokerName": "UNION CAPITAL COMPANY                                                 "
    },
    {
        "type": "CORP",
        "mpid": "IVST",
        "clearingBroker": "0443",
        "brokerName": "INTERVEST INTERNATIONAL EQUITIES CORPORATION                          "
    },
    {
        "type": "CORP",
        "mpid": "JADN",
        "clearingBroker": "0725",
        "brokerName": "J ALDEN ASSOCIATES                                                    "
    },
    {
        "type": "CORP",
        "mpid": "JANY",
        "clearingBroker": "0374",
        "brokerName": "JANNEY MONTGOMERY SCOTT LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "JBLW",
        "clearingBroker": "0443",
        "brokerName": "OHANESIAN / LECOURS, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "JDLS",
        "clearingBroker": "0103",
        "brokerName": "JDL SECURITIES                                                        "
    },
    {
        "type": "CORP",
        "mpid": "JDRB",
        "clearingBroker": "0595",
        "brokerName": "J.H. DARBIE & CO., INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "JEFF",
        "clearingBroker": "0019",
        "brokerName": "JEFFERIES LLC                                                         "
    },
    {
        "type": "CORP",
        "mpid": "JEFM",
        "clearingBroker": "0235",
        "brokerName": "JEFFREY MATTHEWS FINANCIAL GROUP, L.L.C.                              "
    },
    {
        "type": "CORP",
        "mpid": "JEVO",
        "clearingBroker": "0235",
        "brokerName": "ATIS, INC                                                             "
    },
    {
        "type": "CORP",
        "mpid": "JGUN",
        "clearingBroker": "0235",
        "brokerName": "JOSEPH GUNNAR & CO. LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "JHDR",
        "clearingBroker": "0052",
        "brokerName": "JH DARBIE & CO. INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "JJKE",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "JKFS",
        "clearingBroker": "0279",
        "brokerName": "J.K. FINANCIAL SERVICES INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "JKRC",
        "clearingBroker": "0443",
        "brokerName": "J.K.R. & CO., INC.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "JLEQ",
        "clearingBroker": "0161",
        "brokerName": "JUMP EXECUTION, LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "JMLS",
        "clearingBroker": "0235",
        "brokerName": "J.M LUMMIS SECURITIES, INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "JNSN",
        "clearingBroker": "0443",
        "brokerName": "D A DAVIDSON                                                          "
    },
    {
        "type": "CORP",
        "mpid": "JNST",
        "clearingBroker": "0352",
        "brokerName": "JANE STREET CAPITAL LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "JONE",
        "clearingBroker": "0161",
        "brokerName": "JONESTRADING                                                          "
    },
    {
        "type": "CORP",
        "mpid": "JPMS",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "JPPB",
        "clearingBroker": "0443",
        "brokerName": "JEFFERIES LLC                                                         "
    },
    {
        "type": "CORP",
        "mpid": "JQII",
        "clearingBroker": "0443",
        "brokerName": "THE GARBACZ GROUP                                                     "
    },
    {
        "type": "CORP",
        "mpid": "JRCO",
        "clearingBroker": "0226",
        "brokerName": "JOHNSON RICE & COMPANY L.L.C.                                         "
    },
    {
        "type": "CORP",
        "mpid": "JSAP",
        "clearingBroker": "8497",
        "brokerName": "JANE STREET CAPITAL, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "JSBA",
        "clearingBroker": "0161",
        "brokerName": "JANE STREET CAPITAL, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "JSCL",
        "clearingBroker": "0052",
        "brokerName": "JOSEPH STONE CAPITAL L.L.C.                                           "
    },
    {
        "type": "CORP",
        "mpid": "JSCT",
        "clearingBroker": "0005",
        "brokerName": "JANE STREET CAPITAL LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "JSEB",
        "clearingBroker": "0161",
        "brokerName": "JANE STREET EXECUTION SERVICES, LLC                                   "
    },
    {
        "type": "CORP",
        "mpid": "JSEG",
        "clearingBroker": "0161",
        "brokerName": "JANE STREET EXECUTION SERVICES, LLC                                   "
    },
    {
        "type": "CORP",
        "mpid": "JSSF",
        "clearingBroker": "0226",
        "brokerName": "JMP SECURITIES LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "JVBF",
        "clearingBroker": "0235",
        "brokerName": "JACK V. BUTTERFIELD INVESTMENT COMPANY                                "
    },
    {
        "type": "CORP",
        "mpid": "JVBG",
        "clearingBroker": "0443",
        "brokerName": "J.V.B. FINANCIAL GROUP LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "JWCF",
        "clearingBroker": "0226",
        "brokerName": "J. W. COLE FINANCIAL, INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "JWML",
        "clearingBroker": "0235",
        "brokerName": "MILLEGAN (J.W.), INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "KALS",
        "clearingBroker": "0235",
        "brokerName": "KALOS CAPITAL, INC.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "KAPG",
        "clearingBroker": "0158",
        "brokerName": "KAPITALL GENERATION, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "KART",
        "clearingBroker": "0750",
        "brokerName": "REVERE SECURITIES CORP.                                               "
    },
    {
        "type": "CORP",
        "mpid": "KAWM",
        "clearingBroker": "0443",
        "brokerName": "ARETE WEALTH MANAGEMENT, LLC                                          "
    },
    {
        "type": "CORP",
        "mpid": "KBCO",
        "clearingBroker": "0443",
        "brokerName": "KAHN BROTHERS LLC                                                     "
    },
    {
        "type": "CORP",
        "mpid": "KCAM",
        "clearingBroker": "0052",
        "brokerName": "K2 CAPITAL ASSET MANAGEMENT, LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "KCIM",
        "clearingBroker": "0235",
        "brokerName": "INVESTMENT MANAGEMENT CORPORATION                                     "
    },
    {
        "type": "CORP",
        "mpid": "KCIX",
        "clearingBroker": "0279",
        "brokerName": "KILEY PARTNERS, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "KCRD",
        "clearingBroker": "0052",
        "brokerName": "PHX FINANCIAL, INC.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "KEEN",
        "clearingBroker": "0279",
        "brokerName": "ST. BERNARD FINANCIAL SERVICES, INC.                                  "
    },
    {
        "type": "CORP",
        "mpid": "KENS",
        "clearingBroker": "0279",
        "brokerName": "KENSINGTON CAPITAL CORP.                                              "
    },
    {
        "type": "CORP",
        "mpid": "KERC",
        "clearingBroker": "0443",
        "brokerName": "KERCHEVILLE & COMPANY                                                 "
    },
    {
        "type": "CORP",
        "mpid": "KEYB",
        "clearingBroker": "0443",
        "brokerName": "KEYBANC CAPITAL MARKETS INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "KIML",
        "clearingBroker": "0226",
        "brokerName": "KIMELMAN & BAIRD, LLC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "KING",
        "clearingBroker": "0235",
        "brokerName": "C. L. KING & ASSOCIATES, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "KISL",
        "clearingBroker": "0443",
        "brokerName": "KEY INVESTMENT SERVICES LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "KJCO",
        "clearingBroker": "0725",
        "brokerName": "KIPLING JONES & CO., LTD.                                             "
    },
    {
        "type": "CORP",
        "mpid": "KMSF",
        "clearingBroker": "0443",
        "brokerName": "KMS FINANCIAL SERVICES                                                "
    },
    {
        "type": "CORP",
        "mpid": "KNGS",
        "clearingBroker": "0235",
        "brokerName": "KINGSWOOD CAPITAL PARTNERS, LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "KOTK",
        "clearingBroker": "1043",
        "brokerName": "KOTAK MAHINDRA, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "KOVP",
        "clearingBroker": "0443",
        "brokerName": "KOVACK SECURITIES INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "KOVS",
        "clearingBroker": "0226",
        "brokerName": "KOVACK SECURITIES, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "KRCO",
        "clearingBroker": "0235",
        "brokerName": "KR SECURITIES, LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "KRSH",
        "clearingBroker": "0005",
        "brokerName": "KERSHNER SECURITIES, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "KRTH",
        "clearingBroker": "0235",
        "brokerName": "J.W. KORTH & COMPANY                                                  "
    },
    {
        "type": "CORP",
        "mpid": "KUYK",
        "clearingBroker": "0279",
        "brokerName": "KUYKENDALL & SCHNEIDER, INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "LADY",
        "clearingBroker": "0443",
        "brokerName": "TRUSTFIRST, INC.                                                      "
    },
    {
        "type": "CORP",
        "mpid": "LAFB",
        "clearingBroker": "0235",
        "brokerName": "LAFFERTY (R.F.) & CO., INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "LAFC",
        "clearingBroker": "0443",
        "brokerName": "R.F. LAFFERTY & CO., INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "LAFF",
        "clearingBroker": "0443",
        "brokerName": "R.F. LAFFERTY & CO., INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "LAFI",
        "clearingBroker": "0750",
        "brokerName": "LAFISE SECURITIES CORPORATION                                         "
    },
    {
        "type": "CORP",
        "mpid": "LAGI",
        "clearingBroker": "0226",
        "brokerName": "ALLSTATE FINANCIAL SERVICES, LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "LANE",
        "clearingBroker": "0235",
        "brokerName": "MARC J. LANE & COMPANY                                                "
    },
    {
        "type": "CORP",
        "mpid": "LARC",
        "clearingBroker": "0235",
        "brokerName": "LARIMER CAPITAL CORPORATION                                           "
    },
    {
        "type": "CORP",
        "mpid": "LASI",
        "clearingBroker": "0141",
        "brokerName": "LIEBLONG & ASSOCIATES, INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "LASS",
        "clearingBroker": "0226",
        "brokerName": "LASALLE ST. SECURITIES, INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "LATG",
        "clearingBroker": "0537",
        "brokerName": "GFI SECURITIES LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "LATM",
        "clearingBroker": "0537",
        "brokerName": "GFI SECURITIES LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "LATN",
        "clearingBroker": "0443",
        "brokerName": "HEROLD & LANTERN INVESTMENTS, INC.                                    "
    },
    {
        "type": "CORP",
        "mpid": "LBKI",
        "clearingBroker": "0235",
        "brokerName": "LIBUCKI & CO., LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "LDAS",
        "clearingBroker": "0443",
        "brokerName": "LANDAAS & CO.                                                         "
    },
    {
        "type": "CORP",
        "mpid": "LDIL",
        "clearingBroker": "0226",
        "brokerName": "LINCOLN DOUGLAS INVESTMENTS, LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "LDLW",
        "clearingBroker": "0750",
        "brokerName": "LAIDLAW & COMPANY (UK) LTD.                                           "
    },
    {
        "type": "CORP",
        "mpid": "LDOT",
        "clearingBroker": "0235",
        "brokerName": "LANDOLT SECURITIES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "LEAD",
        "clearingBroker": "0226",
        "brokerName": "THE LEADERS GROUP, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "LEBO",
        "clearingBroker": "0226",
        "brokerName": "LEIGH BALDWIN & CO., LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "LEER",
        "clearingBroker": "0443",
        "brokerName": "LEERINK SWANN & COMPANY                                               "
    },
    {
        "type": "CORP",
        "mpid": "LENX",
        "clearingBroker": "0279",
        "brokerName": "LENOX FINANCIAL SERVICES, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "LEXI",
        "clearingBroker": "0226",
        "brokerName": "LEXINGTON INVESTMENT COMPANY, INC.                                    "
    },
    {
        "type": "CORP",
        "mpid": "LEYA",
        "clearingBroker": "0235",
        "brokerName": "LEMLEY, YARLING & CO.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "LFAC",
        "clearingBroker": "0226",
        "brokerName": "OSAIC FA, INC.                                                        "
    },
    {
        "type": "CORP",
        "mpid": "LFRO",
        "clearingBroker": "0235",
        "brokerName": "LF ROTHSCHILD, LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "LGNT",
        "clearingBroker": "0052",
        "brokerName": "AXOS CLEARING LLC                                                     "
    },
    {
        "type": "CORP",
        "mpid": "LGSA",
        "clearingBroker": "0158",
        "brokerName": "WOORI INVESTMENT AND SECURITIES AMERICA, INC.                         "
    },
    {
        "type": "CORP",
        "mpid": "LIFG",
        "clearingBroker": "0279",
        "brokerName": "LONG ISLAND FINANCIAL GROUP, INC.                                     "
    },
    {
        "type": "CORP",
        "mpid": "LIIS",
        "clearingBroker": "0226",
        "brokerName": "USAA FINANCIAL ADVISORS, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "LINC",
        "clearingBroker": "0158",
        "brokerName": "LIBERUM                                                               "
    },
    {
        "type": "CORP",
        "mpid": "LISI",
        "clearingBroker": "0443",
        "brokerName": "LEUMI INVESTMENT SERVICES, INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "LMAR",
        "clearingBroker": "0226",
        "brokerName": "LIFEMARK SECURITIES CORP.                                             "
    },
    {
        "type": "CORP",
        "mpid": "LMBD",
        "clearingBroker": "0443",
        "brokerName": "LAZARD ASSET MANAGEMENT SECURITIES LLC                                "
    },
    {
        "type": "CORP",
        "mpid": "LMKO",
        "clearingBroker": "0235",
        "brokerName": "KOHN (L.M.) & COMPANY                                                 "
    },
    {
        "type": "CORP",
        "mpid": "LMNX",
        "clearingBroker": "0226",
        "brokerName": "LUMINEX TRADING & ANALYTICS LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "LNCL",
        "clearingBroker": "0443",
        "brokerName": "LINCOLN INVESTMENT                                                    "
    },
    {
        "type": "CORP",
        "mpid": "LNKS",
        "clearingBroker": "0443",
        "brokerName": "GUGGENHEIM SECURITIES, LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "LOMB",
        "clearingBroker": "0141",
        "brokerName": "LOMBARD SECURITIES INCORPORATED                                       "
    },
    {
        "type": "CORP",
        "mpid": "LOOP",
        "clearingBroker": "0443",
        "brokerName": "LOOP CAPITAL MARKETS, LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "LOUE",
        "clearingBroker": "0161",
        "brokerName": "ICAP CORPORATES LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "LOUI",
        "clearingBroker": "0005",
        "brokerName": "LOUIS CAPITAL MARKETS, LP                                             "
    },
    {
        "type": "CORP",
        "mpid": "LPCM",
        "clearingBroker": "0103",
        "brokerName": "LAMPERT CAPITAL MARKETS INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "LPFS",
        "clearingBroker": "0235",
        "brokerName": "LIBERTY PARTNERS FINANCIAL SERVICES, INC.                             "
    },
    {
        "type": "CORP",
        "mpid": "LPLE",
        "clearingBroker": "0075",
        "brokerName": "LPL ENTERPRISE, LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "LPSP",
        "clearingBroker": "1043",
        "brokerName": "LPS CAPITAL LLC                                                       "
    },
    {
        "type": "CORP",
        "mpid": "LQNA",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "CORP",
        "mpid": "LQNB",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "CORP",
        "mpid": "LQNF",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "CORP",
        "mpid": "LQNT",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "CORP",
        "mpid": "LQPT",
        "clearingBroker": "0161",
        "brokerName": "DASH FINANCIAL TECHNOLOGIES LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "LRBC",
        "clearingBroker": "0235",
        "brokerName": "LIBERTY ASSOCIATES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "LRCM",
        "clearingBroker": "0279",
        "brokerName": "LOCKTON RE CAPITAL MARKETS, LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "LSCM",
        "clearingBroker": "0235",
        "brokerName": "LAKE STREET CAPITAL MARKETS, LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "LSFB",
        "clearingBroker": "0443",
        "brokerName": "LION STREET FINANCIAL, LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "LSKO",
        "clearingBroker": "0226",
        "brokerName": "LESKO SECURITIES INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "LSPI",
        "clearingBroker": "0141",
        "brokerName": "LAFAYETTE INVESTMENTS                                                 "
    },
    {
        "type": "CORP",
        "mpid": "LSSI",
        "clearingBroker": "0750",
        "brokerName": "EJ STERLING INC.                                                      "
    },
    {
        "type": "CORP",
        "mpid": "LSUS",
        "clearingBroker": "0443",
        "brokerName": "LATIN SECURITIES INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "LTAA",
        "clearingBroker": "0226",
        "brokerName": "LUMINEX TRADING & ANALYTICS LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "LTCO",
        "clearingBroker": "0226",
        "brokerName": "LADENBURG, THALMANN & CO., INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "LTIN",
        "clearingBroker": "2786",
        "brokerName": "BBVA SECURITIES INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "LVAR",
        "clearingBroker": "0443",
        "brokerName": "LARRAINVIAL SECURITIES US LLC                                         "
    },
    {
        "type": "CORP",
        "mpid": "LVMR",
        "clearingBroker": "0235",
        "brokerName": "LIVERMORE TRADING GROUP, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "LWFL",
        "clearingBroker": "0443",
        "brokerName": "LAWSON FINANCIAL CORPORATION                                          "
    },
    {
        "type": "CORP",
        "mpid": "LYON",
        "clearingBroker": "0651",
        "brokerName": "CREDIT AGRICOLE SECURITIES (USA) INC.                                 "
    },
    {
        "type": "CORP",
        "mpid": "LYSI",
        "clearingBroker": "0443",
        "brokerName": "LLOYDS SECURITIES INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "MACC",
        "clearingBroker": "0226",
        "brokerName": "NEWEDGE SECURITIES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "MADV",
        "clearingBroker": "0443",
        "brokerName": "MILLENNIUM ADVISORS, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "MAMA",
        "clearingBroker": "0443",
        "brokerName": "SECUREVEST FINANCIAL GROUP                                            "
    },
    {
        "type": "CORP",
        "mpid": "MAPA",
        "clearingBroker": "0279",
        "brokerName": "MADISON PAIGE SECURITIES LLC                                          "
    },
    {
        "type": "CORP",
        "mpid": "MASE",
        "clearingBroker": "0141",
        "brokerName": "MANAGED ACCOUNT SERVICES, LLC                                         "
    },
    {
        "type": "CORP",
        "mpid": "MAVS",
        "clearingBroker": "0443",
        "brokerName": "MADISON AVENUE SECURITIES                                             "
    },
    {
        "type": "CORP",
        "mpid": "MAXM",
        "clearingBroker": "0443",
        "brokerName": "MAXIM GROUP LLC                                                       "
    },
    {
        "type": "CORP",
        "mpid": "MBBS",
        "clearingBroker": "0443",
        "brokerName": "INFINEX INVESTMENTS                                                   "
    },
    {
        "type": "CORP",
        "mpid": "MBSA",
        "clearingBroker": "0052",
        "brokerName": "MBS SOURCE ETRADING, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "MBSE",
        "clearingBroker": "0052",
        "brokerName": "MBS SOURCE ETRADING, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "MBSL",
        "clearingBroker": "0443",
        "brokerName": "MBS CAPITAL MARKETS, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "MBUS",
        "clearingBroker": "0052",
        "brokerName": "MEDIOBANCA SECURITIES USA LLC                                         "
    },
    {
        "type": "CORP",
        "mpid": "MCAP",
        "clearingBroker": "1043",
        "brokerName": "MCAP LLC                                                              "
    },
    {
        "type": "CORP",
        "mpid": "MCBT",
        "clearingBroker": "0235",
        "brokerName": "MOORS & CABOT, INC.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "MCCL",
        "clearingBroker": "0443",
        "brokerName": "MCCLURG CAPITAL CORPORATION                                           "
    },
    {
        "type": "CORP",
        "mpid": "MCMG",
        "clearingBroker": "0279",
        "brokerName": "MUNICIPAL CAPITAL MARKETS GROUP, INC.                                 "
    },
    {
        "type": "CORP",
        "mpid": "MCNA",
        "clearingBroker": "0443",
        "brokerName": "MCNALLY FINANCIAL SERVICES CORPORATION                                "
    },
    {
        "type": "CORP",
        "mpid": "MDGP",
        "clearingBroker": "0235",
        "brokerName": "MD GLOBAL PARTNERS, LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "MEAL",
        "clearingBroker": "0226",
        "brokerName": "M. E. ALLISON & CO., INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "MERP",
        "clearingBroker": "0235",
        "brokerName": "MERIDIAN EQUITY PARTNERS, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "MERQ",
        "clearingBroker": "0052",
        "brokerName": "MERCATOR ASSOCIATES LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "MESF",
        "clearingBroker": "0443",
        "brokerName": "MESIROW FINANCIAL, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "MFGX",
        "clearingBroker": "0443",
        "brokerName": "MISCHLER FINANCIAL GROUP, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "MFRS",
        "clearingBroker": "0443",
        "brokerName": "MFR SECURITIES, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "MHFI",
        "clearingBroker": "0226",
        "brokerName": "M HOLDINGS SECURITIES, INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "MHSI",
        "clearingBroker": "0443",
        "brokerName": "M HOLDINGS SECURITIES                                                 "
    },
    {
        "type": "CORP",
        "mpid": "MIAM",
        "clearingBroker": "0141",
        "brokerName": "FMSBONDS, INC.                                                        "
    },
    {
        "type": "CORP",
        "mpid": "MIBS",
        "clearingBroker": "0443",
        "brokerName": "BMO HARRIS FINANCIAL ADVISORS                                         "
    },
    {
        "type": "CORP",
        "mpid": "MIDA",
        "clearingBroker": "0725",
        "brokerName": "MID-ATLANTIC SECURITIES, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "MIDL",
        "clearingBroker": "0226",
        "brokerName": "MIDDLEGATE SECURITIES LTD.                                            "
    },
    {
        "type": "CORP",
        "mpid": "MIFI",
        "clearingBroker": "0226",
        "brokerName": "MILKIE FERGUSON INVESTMENTS, INC.                                     "
    },
    {
        "type": "CORP",
        "mpid": "MILE",
        "clearingBroker": "0052",
        "brokerName": "I-BANKERS SECURITIES INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "MILN",
        "clearingBroker": "1767",
        "brokerName": "MILLENNIUM ADVISORS, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "MINP",
        "clearingBroker": "0235",
        "brokerName": "MINISTRY PARTNERS SECURITIES, LLC                                     "
    },
    {
        "type": "CORP",
        "mpid": "MINV",
        "clearingBroker": "0235",
        "brokerName": "MACK INVESTMENTS SECURITIES, INC.                                     "
    },
    {
        "type": "CORP",
        "mpid": "MIRA",
        "clearingBroker": "1043",
        "brokerName": "MIRAE ASSET SECURITIES (USA) INC.                                     "
    },
    {
        "type": "CORP",
        "mpid": "MISL",
        "clearingBroker": "0161",
        "brokerName": "MISCHLER FINANCIAL GROUP, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "MITR",
        "clearingBroker": "0443",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "MJDW",
        "clearingBroker": "0279",
        "brokerName": "MURRAY SECURITIES                                                     "
    },
    {
        "type": "CORP",
        "mpid": "MJWH",
        "clearingBroker": "0235",
        "brokerName": "ETICO PARTNERS LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "MKMP",
        "clearingBroker": "0161",
        "brokerName": "ROTH CAPITAL PARTNERS, LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "MKRT",
        "clearingBroker": "0235",
        "brokerName": "MARKET SECURITIES, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "MKTI",
        "clearingBroker": "0226",
        "brokerName": "U.S. BANCORP ADVISORS, LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "MKTX",
        "clearingBroker": "4265",
        "brokerName": "MARKETAXESS CORPORATION                                               "
    },
    {
        "type": "CORP",
        "mpid": "MKTY",
        "clearingBroker": "4265",
        "brokerName": "MARKETAXESS CORPORATION                                               "
    },
    {
        "type": "CORP",
        "mpid": "MLCO",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "MLEX",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "MLMA",
        "clearingBroker": "0671",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "CORP",
        "mpid": "MLMS",
        "clearingBroker": "0279",
        "brokerName": "MAINLINE WEST MUNICIPAL SECURITIES, LLC                               "
    },
    {
        "type": "CORP",
        "mpid": "MLTX",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "MLWM",
        "clearingBroker": "0671",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "CORP",
        "mpid": "MMCS",
        "clearingBroker": "0443",
        "brokerName": "MMC SECURITIES CORP.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "MMNT",
        "clearingBroker": "0158",
        "brokerName": "MOMENT MARKETS, LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "MNCC",
        "clearingBroker": "0443",
        "brokerName": "MONEY CONCEPTS CAPITAL CORP.                                          "
    },
    {
        "type": "CORP",
        "mpid": "MNCO",
        "clearingBroker": "0279",
        "brokerName": "NELSON (MARTIN) & CO., INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "MNRC",
        "clearingBroker": "0443",
        "brokerName": "MONARCH CAPITAL GROUP LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "MNXS",
        "clearingBroker": "0443",
        "brokerName": "MUNIAXIS LEBENTHAL LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "MOCM",
        "clearingBroker": "0235",
        "brokerName": "MORETON CAPITAL MARKETS, LLC                                          "
    },
    {
        "type": "CORP",
        "mpid": "MOFI",
        "clearingBroker": "0158",
        "brokerName": "M1 FINANCE LLC                                                        "
    },
    {
        "type": "CORP",
        "mpid": "MOIS",
        "clearingBroker": "0443",
        "brokerName": "MUTUAL OF OMAHA INVESTOR SERVICES INC.                                "
    },
    {
        "type": "CORP",
        "mpid": "MOLO",
        "clearingBroker": "0235",
        "brokerName": "MOLONEY SECURITIES                                                    "
    },
    {
        "type": "CORP",
        "mpid": "MOMS",
        "clearingBroker": "0750",
        "brokerName": "MOMENTUS SECURITIES LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "MONE",
        "clearingBroker": "0443",
        "brokerName": "MONERE INVESTMENTS, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "MONR",
        "clearingBroker": "0226",
        "brokerName": "MONROE FINANCIAL PARTNERS, INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "MONX",
        "clearingBroker": "0443",
        "brokerName": "MONEX SECURITIES INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "MORA",
        "clearingBroker": "0443",
        "brokerName": "MORA WM SECURITIES                                                    "
    },
    {
        "type": "CORP",
        "mpid": "MPLA",
        "clearingBroker": "0158",
        "brokerName": "EMPALA SECURITIES, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "MPLW",
        "clearingBroker": "0226",
        "brokerName": "MAPLEWOOD INVESTMENT ADVISORS, INC.                                   "
    },
    {
        "type": "CORP",
        "mpid": "MPSG",
        "clearingBroker": "0161",
        "brokerName": "ED & F MAN CAPITAL MARKETS INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "MRBA",
        "clearingBroker": "0052",
        "brokerName": "IBN FINANCIAL SERVICES, INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "MRIS",
        "clearingBroker": "0443",
        "brokerName": "BMO HARRIS FINANCIAL ADVISORS                                         "
    },
    {
        "type": "CORP",
        "mpid": "MRKS",
        "clearingBroker": "0443",
        "brokerName": "M. RAMSEY KING                                                        "
    },
    {
        "type": "CORP",
        "mpid": "MRNA",
        "clearingBroker": "0161",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "MRPH",
        "clearingBroker": "0226",
        "brokerName": "WM FINANCIAL SERVICES, INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "MRSC",
        "clearingBroker": "0287",
        "brokerName": "TRADEUP SECURITIES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "MSCB",
        "clearingBroker": "0279",
        "brokerName": "MAINE SECURITIES CORPORATION                                          "
    },
    {
        "type": "CORP",
        "mpid": "MSCO",
        "clearingBroker": "0050",
        "brokerName": "MORGAN STANLEY & CO. LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "MSEC",
        "clearingBroker": "0235",
        "brokerName": "MSEC, LLC                                                             "
    },
    {
        "type": "CORP",
        "mpid": "MSII",
        "clearingBroker": "0226",
        "brokerName": "MSI FINANCIAL SERVICES, INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "MSRO",
        "clearingBroker": "0226",
        "brokerName": "MESIROW FINANCIAL, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "MSTC",
        "clearingBroker": "0226",
        "brokerName": "MIDWESTERN SECURITIES TRADING COMPANY, LLC                            "
    },
    {
        "type": "CORP",
        "mpid": "MTBK",
        "clearingBroker": "0443",
        "brokerName": "MULTI-BANK SECURITIES, INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "MTDB",
        "clearingBroker": "0443",
        "brokerName": "M&T SECURITIES, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "MTGO",
        "clearingBroker": "0158",
        "brokerName": "MTG, LLC                                                              "
    },
    {
        "type": "CORP",
        "mpid": "MTHN",
        "clearingBroker": "0005",
        "brokerName": "MARATHON TRADING GROUP LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "MTLE",
        "clearingBroker": "0235",
        "brokerName": "MTL EQUITY PRODUCTS, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "MTSL",
        "clearingBroker": "0226",
        "brokerName": "MSEC, LLC                                                             "
    },
    {
        "type": "CORP",
        "mpid": "MUFG",
        "clearingBroker": "0076",
        "brokerName": "MUFG SECURITIES AMERICAS INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "MULT",
        "clearingBroker": "0443",
        "brokerName": "MULTI-FINANCIAL SECURITIES GROUP                                      "
    },
    {
        "type": "CORP",
        "mpid": "MURJ",
        "clearingBroker": "0750",
        "brokerName": "COMMERCE ONE FINANCIAL INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "MWAF",
        "clearingBroker": "0443",
        "brokerName": "MWA FINANCIAL SERVICES, INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "MWCC",
        "clearingBroker": "0235",
        "brokerName": "MONNESS CRESPI HARDT & CO., INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "MWIL",
        "clearingBroker": "0235",
        "brokerName": "MORGAN WILSHIRE SECURITIES, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "MWMS",
        "clearingBroker": "0443",
        "brokerName": "MUREX CAPITAL LLC                                                     "
    },
    {
        "type": "CORP",
        "mpid": "MYSS",
        "clearingBroker": "0158",
        "brokerName": "M.Y. SAFRA SECURITIES, INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "MZHO",
        "clearingBroker": "0892",
        "brokerName": "MIZUHO SECURITIES USA LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "MZHO",
        "clearingBroker": "2396",
        "brokerName": "MIZUHO SECURITIES USA LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "NACM",
        "clearingBroker": "0161",
        "brokerName": "NABSECURITIES, LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "NADL",
        "clearingBroker": "0235",
        "brokerName": "WARREN D. NADEL & COMPANY                                             "
    },
    {
        "type": "CORP",
        "mpid": "NAPK",
        "clearingBroker": "0052",
        "brokerName": "B. RILEY WEALTH MANAGEMENT                                            "
    },
    {
        "type": "CORP",
        "mpid": "NASC",
        "clearingBroker": "0235",
        "brokerName": "NATALLIANCE SECURITIES, LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "NAVC",
        "clearingBroker": "0235",
        "brokerName": "NAVIAN CAPITAL SECURITIES LLC                                         "
    },
    {
        "type": "CORP",
        "mpid": "NBAR",
        "clearingBroker": "0226",
        "brokerName": "NANCY BARRON & ASSOCIATES, INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "NBCS",
        "clearingBroker": "0235",
        "brokerName": "NBC SECURITIES, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "NBLB",
        "clearingBroker": "0226",
        "brokerName": "NEUBERGER BERMAN BD LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "NBSL",
        "clearingBroker": "0226",
        "brokerName": "BMO NESBITT BURNS SECURITIES LTD.                                     "
    },
    {
        "type": "CORP",
        "mpid": "NEED",
        "clearingBroker": "0443",
        "brokerName": "NEEDHAM & COMPANY, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "NEPP",
        "clearingBroker": "0226",
        "brokerName": "N.E. PRIVATE CLIENT ADVISORS, LTD.                                    "
    },
    {
        "type": "CORP",
        "mpid": "NEST",
        "clearingBroker": "0235",
        "brokerName": "NEST INVESTMENTS BD LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "NEXT",
        "clearingBroker": "0443",
        "brokerName": "NEXT FINANCIAL GROUP, INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "NFGR",
        "clearingBroker": "0141",
        "brokerName": "NATIONS FINANCIAL GROUP, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "NFSC",
        "clearingBroker": "0226",
        "brokerName": "NATIONAL FINANCIAL SERVICES LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "NFTY",
        "clearingBroker": "0235",
        "brokerName": "INFINITY FINANCIAL SERVICES                                           "
    },
    {
        "type": "CORP",
        "mpid": "NHFS",
        "clearingBroker": "0443",
        "brokerName": "ALIGHT FINANCIAL SOLUTIONS, LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "NHWI",
        "clearingBroker": "0141",
        "brokerName": "HENNION & WALSH, INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "NIAD",
        "clearingBroker": "0052",
        "brokerName": "NI ADVISORS                                                           "
    },
    {
        "type": "CORP",
        "mpid": "NILL",
        "clearingBroker": "0725",
        "brokerName": "NIAGARA INTERNATIONAL CAPITAL LIMITED                                 "
    },
    {
        "type": "CORP",
        "mpid": "NITE",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "NLOV",
        "clearingBroker": "0279",
        "brokerName": "NORTLOV SECURITIES LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "NMRA",
        "clearingBroker": "0180",
        "brokerName": "NOMURA SECURITIES INTERNATIONAL, INC./FIXED INCOME                    "
    },
    {
        "type": "CORP",
        "mpid": "NMRA",
        "clearingBroker": "5222",
        "brokerName": "NOMURA SECURITIES INTERNATIONAL, INC./FIXED INCOME                    "
    },
    {
        "type": "CORP",
        "mpid": "NOBL",
        "clearingBroker": "0750",
        "brokerName": "NOBLE FINANCIAL CAPITAL MARKETS                                       "
    },
    {
        "type": "CORP",
        "mpid": "NORC",
        "clearingBroker": "0235",
        "brokerName": "NORTHERN CAPITAL SEC. CORP.                                           "
    },
    {
        "type": "CORP",
        "mpid": "NORP",
        "clearingBroker": "0443",
        "brokerName": "PARETO SECURITIES INC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "NORT",
        "clearingBroker": "0443",
        "brokerName": "NORTHLAND SECURITIES, INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "NOSO",
        "clearingBroker": "0443",
        "brokerName": "NORTH SOUTH CAPITAL LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "NPAI",
        "clearingBroker": "0443",
        "brokerName": "NATIONWIDE PLANNING ASSOCIATES                                        "
    },
    {
        "type": "CORP",
        "mpid": "NPBF",
        "clearingBroker": "0443",
        "brokerName": "NPB FINANCIAL GROUP, LLC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "NPNT",
        "clearingBroker": "0005",
        "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "NPTP",
        "clearingBroker": "0443",
        "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "NRAM",
        "clearingBroker": "0443",
        "brokerName": "CANACCORD WEALTH MANAGEMENT (USA) INC.                                "
    },
    {
        "type": "CORP",
        "mpid": "NSFP",
        "clearingBroker": "0235",
        "brokerName": "NORTHSTAR FINANCIAL PARTNERS, INC.                                    "
    },
    {
        "type": "CORP",
        "mpid": "NSRD",
        "clearingBroker": "0235",
        "brokerName": "NESTLERODE & CO., INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "NTFN",
        "clearingBroker": "0052",
        "brokerName": "NETWORK 1 FINANCIAL SECURITIES INC.                                   "
    },
    {
        "type": "CORP",
        "mpid": "NTRC",
        "clearingBroker": "0226",
        "brokerName": "NORTHERN TRUST SECURITIES, INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "NTSI",
        "clearingBroker": "0443",
        "brokerName": "NESBITT THOMSON SECURITIES, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "NVEN",
        "clearingBroker": "0448",
        "brokerName": "NUVEEN SECURITIES, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "NWCM",
        "clearingBroker": "0235",
        "brokerName": "NW CAPITAL MARKETS INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "NWIA",
        "clearingBroker": "0750",
        "brokerName": "NORTHWEST INVESTMENT ADVISORS, INC.                                   "
    },
    {
        "type": "CORP",
        "mpid": "NWML",
        "clearingBroker": "0443",
        "brokerName": "NORTHWESTERN MUTUAL INVESTMENT SERVICES, LLC                          "
    },
    {
        "type": "CORP",
        "mpid": "NYLS",
        "clearingBroker": "0226",
        "brokerName": "NYLIFE SECURITIES INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "OAKR",
        "clearingBroker": "0235",
        "brokerName": "THE OAK RIDGE FINANCIAL SERVICES GROUP, INC.                          "
    },
    {
        "type": "CORP",
        "mpid": "OBWS",
        "clearingBroker": "0226",
        "brokerName": "OBERWEIS SECURITIES, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "OCAC",
        "clearingBroker": "0235",
        "brokerName": "OLSON, CROSS & ALAMO LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "OCEA",
        "clearingBroker": "0052",
        "brokerName": "OCEAN FINANCIAL SERVICES, LLC                                         "
    },
    {
        "type": "CORP",
        "mpid": "OCON",
        "clearingBroker": "0103",
        "brokerName": "O'CONNOR & CO SECURITIES                                              "
    },
    {
        "type": "CORP",
        "mpid": "ODEO",
        "clearingBroker": "0388",
        "brokerName": "ODEON CAP                                                             "
    },
    {
        "type": "CORP",
        "mpid": "ODNC",
        "clearingBroker": "0235",
        "brokerName": "ODEON CAPITAL GROUP LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "OFGF",
        "clearingBroker": "0235",
        "brokerName": "OFG FINANCIAL SERVICES INC                                            "
    },
    {
        "type": "CORP",
        "mpid": "OGTL",
        "clearingBroker": "0005",
        "brokerName": "OUTSET GLOBAL TRADING LIMITED                                         "
    },
    {
        "type": "CORP",
        "mpid": "OHIO",
        "clearingBroker": "0443",
        "brokerName": "FIFTH THIRD SECURITIES, INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "OLDM",
        "clearingBroker": "0005",
        "brokerName": "OLD MISSION CAPITAL, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "OLNE",
        "clearingBroker": "0279",
        "brokerName": "OLDEN LANE SECURITIES, LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "OMSL",
        "clearingBroker": "0158",
        "brokerName": "OM SECURITIES, LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "ONEL",
        "clearingBroker": "0161",
        "brokerName": "O'NEIL (WILLIAM) & CO                                                 "
    },
    {
        "type": "CORP",
        "mpid": "ONES",
        "clearingBroker": "0443",
        "brokerName": "O N EQUITY SALES CO.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "OPCO",
        "clearingBroker": "0571",
        "brokerName": "OPPENHEIMER & CO. INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "OPTF",
        "clearingBroker": "0005",
        "brokerName": "OPTIVER US LLC                                                        "
    },
    {
        "type": "CORP",
        "mpid": "ORTL",
        "clearingBroker": "0443",
        "brokerName": "ORIENTAL FINANCIAL SERVICES                                           "
    },
    {
        "type": "CORP",
        "mpid": "OSIC",
        "clearingBroker": "0226",
        "brokerName": "OSAIC INSTITUTIONS, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "OTCN",
        "clearingBroker": "0158",
        "brokerName": "OTC LINK LLC                                                          "
    },
    {
        "type": "CORP",
        "mpid": "OYLD",
        "clearingBroker": "0235",
        "brokerName": "OPENYIELD TRADING LLC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "PACK",
        "clearingBroker": "0279",
        "brokerName": "PACKERLAND BROKERAGE SERVICES                                         "
    },
    {
        "type": "CORP",
        "mpid": "PACT",
        "clearingBroker": "0443",
        "brokerName": "BTG PACTUAL US CAPITAL LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "PAMC",
        "clearingBroker": "0226",
        "brokerName": "PROGRESSIVE ASSET MANAGEMENT                                          "
    },
    {
        "type": "CORP",
        "mpid": "PAPA",
        "clearingBroker": "0443",
        "brokerName": "PAPAMARKOU WELLNER & CO., INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "PARI",
        "clearingBroker": "0630",
        "brokerName": "BNP PARIBAS SECURITIES CORP.                                          "
    },
    {
        "type": "CORP",
        "mpid": "PARK",
        "clearingBroker": "0750",
        "brokerName": "PARK WALK CAPITAL MARKETS, LLC                                        "
    },
    {
        "type": "CORP",
        "mpid": "PARV",
        "clearingBroker": "0443",
        "brokerName": "PAR5 CAPITAL & CO LLC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "PASC",
        "clearingBroker": "0443",
        "brokerName": "PARK AVENUE SECURITIES LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "PASL",
        "clearingBroker": "0443",
        "brokerName": "PERSHING ADVISOR SOLUTIONS, LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "PATR",
        "clearingBroker": "0624",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "CORP",
        "mpid": "PAUL",
        "clearingBroker": "0595",
        "brokerName": "PAULSON INVESTMENT COMPANY, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "PBON",
        "clearingBroker": "0161",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "CORP",
        "mpid": "PBSL",
        "clearingBroker": "0725",
        "brokerName": "PEAK BROKERAGE SERVICES, LLC                                          "
    },
    {
        "type": "CORP",
        "mpid": "PCCA",
        "clearingBroker": "0279",
        "brokerName": "PEACHCAP SECURITIES, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "PCIS",
        "clearingBroker": "0226",
        "brokerName": "BANKOH INVESTMENT SERVICES, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "PCSB",
        "clearingBroker": "0443",
        "brokerName": "PRIVATE CLIENT SERVICES, LLC                                          "
    },
    {
        "type": "CORP",
        "mpid": "PEER",
        "clearingBroker": "0226",
        "brokerName": "AMERICAN TRUST INVESTMENT SERVICES, INC.                              "
    },
    {
        "type": "CORP",
        "mpid": "PENG",
        "clearingBroker": "0443",
        "brokerName": "PENNSYLVANIA GROUP INCORPORATED (THE)                                 "
    },
    {
        "type": "CORP",
        "mpid": "PERC",
        "clearingBroker": "0279",
        "brokerName": "PERCIVAL FINANCIAL PARTNERS, LTD.                                     "
    },
    {
        "type": "CORP",
        "mpid": "PERS",
        "clearingBroker": "0443",
        "brokerName": "PERSHING LLC                                                          "
    },
    {
        "type": "CORP",
        "mpid": "PFCG",
        "clearingBroker": "0279",
        "brokerName": "PREFERRED CLIENT GROUP, INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "PFCL",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "CORP",
        "mpid": "PFDC",
        "clearingBroker": "0235",
        "brokerName": "PREFERRED CAPITAL SECURITIES, LLC                                     "
    },
    {
        "type": "CORP",
        "mpid": "PFPI",
        "clearingBroker": "0161",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC                                   "
    },
    {
        "type": "CORP",
        "mpid": "PHBP",
        "clearingBroker": "0052",
        "brokerName": "PENNHAVEN BROKERAGE PARTNERS, LLC                                     "
    },
    {
        "type": "CORP",
        "mpid": "PHIN",
        "clearingBroker": "0443",
        "brokerName": "PHILADELPHIA INVESTORS, LTD.                                          "
    },
    {
        "type": "CORP",
        "mpid": "PHRS",
        "clearingBroker": "0279",
        "brokerName": "NAVAID FINANCIAL SERVICES, INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "PICE",
        "clearingBroker": "0443",
        "brokerName": "T ROWE PRICE INVESTMENT SERV                                          "
    },
    {
        "type": "CORP",
        "mpid": "PICI",
        "clearingBroker": "0279",
        "brokerName": "POLAR INVESTMENT COUNSEL, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "PICL",
        "clearingBroker": "0052",
        "brokerName": "PAULSON INVESTMENT COMPANY LLC                                        "
    },
    {
        "type": "CORP",
        "mpid": "PIMS",
        "clearingBroker": "0226",
        "brokerName": "PRUDENTIAL INVESTMENT MANAGEMENT SERVICES, LLC                        "
    },
    {
        "type": "CORP",
        "mpid": "PINA",
        "clearingBroker": "0141",
        "brokerName": "PINNACLE INVESTMENTS, LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "PIPR",
        "clearingBroker": "0443",
        "brokerName": "PIPER SANDLER & CO.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "PIRR",
        "clearingBroker": "0443",
        "brokerName": "PIRRONE & CO., INC.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "PISC",
        "clearingBroker": "0750",
        "brokerName": "PACIFIC INVESTMENT SECURITIES CORP.                                   "
    },
    {
        "type": "CORP",
        "mpid": "PJEF",
        "clearingBroker": "0443",
        "brokerName": "JEFFERIES LLC                                                         "
    },
    {
        "type": "CORP",
        "mpid": "PKAX",
        "clearingBroker": "0158",
        "brokerName": "PEAK6 CAPITAL MANAGEMENT LLC                                          "
    },
    {
        "type": "CORP",
        "mpid": "PLAT",
        "clearingBroker": "0443",
        "brokerName": "CLARKSONS PLATOU SECURITIES, INC.                                     "
    },
    {
        "type": "CORP",
        "mpid": "PMAS",
        "clearingBroker": "0443",
        "brokerName": "PMA SECURITIES, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "PNCC",
        "clearingBroker": "0226",
        "brokerName": "PNC INVESTMENTS                                                       "
    },
    {
        "type": "CORP",
        "mpid": "PNCM",
        "clearingBroker": "2835",
        "brokerName": "PNC CAPITAL MARKETS LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "PNFP",
        "clearingBroker": "0279",
        "brokerName": "PNFP CAPITAL MARKETS, INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "PNSA",
        "clearingBroker": "0235",
        "brokerName": "PENSERRA SECURITIES, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "PNSR",
        "clearingBroker": "0161",
        "brokerName": "PENSERRA SECURITIES, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "PODE",
        "clearingBroker": "0235",
        "brokerName": "PODESTA & CO.                                                         "
    },
    {
        "type": "CORP",
        "mpid": "POOH",
        "clearingBroker": "0443",
        "brokerName": "QUESTAR CAPITAL CORPORATION                                           "
    },
    {
        "type": "CORP",
        "mpid": "POPS",
        "clearingBroker": "0226",
        "brokerName": "POPULAR SECURITIES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "POWL",
        "clearingBroker": "0443",
        "brokerName": "POWELL (ELMER E.) COMPANY                                             "
    },
    {
        "type": "CORP",
        "mpid": "PPSI",
        "clearingBroker": "0235",
        "brokerName": "PENSION PLANNERS SECURITIES, INC.                                     "
    },
    {
        "type": "CORP",
        "mpid": "PPSL",
        "clearingBroker": "0413",
        "brokerName": "SANTANDER US CAPITAL MARKETS LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "PREB",
        "clearingBroker": "0005",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "CORP",
        "mpid": "PRFA",
        "clearingBroker": "0235",
        "brokerName": "PROOF SERVICES LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "PRGI",
        "clearingBroker": "0443",
        "brokerName": "PORTFOLIO RESOURCES GROUP, INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "PROE",
        "clearingBroker": "0443",
        "brokerName": "PROEQUITIES, INC.                                                     "
    },
    {
        "type": "CORP",
        "mpid": "PRPO",
        "clearingBroker": "0443",
        "brokerName": "PRIVATE PORTFOLIO, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "PRSB",
        "clearingBroker": "0141",
        "brokerName": "PRESIDENTIAL BROKERAGE, INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "PRSI",
        "clearingBroker": "0103",
        "brokerName": "GLOBALINK SECURITIES                                                  "
    },
    {
        "type": "CORP",
        "mpid": "PRST",
        "clearingBroker": "0551",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "PSII",
        "clearingBroker": "0226",
        "brokerName": "KESTRA INVESTMENT SERVICES, LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "PSIM",
        "clearingBroker": "0226",
        "brokerName": "PRINCIPAL SECURITIES, INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "PSIN",
        "clearingBroker": "0443",
        "brokerName": "LUMENT SECURITIES, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "PSUT",
        "clearingBroker": "0235",
        "brokerName": "INNOVATION PARTNERS LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "PTCM",
        "clearingBroker": "0443",
        "brokerName": "CAVU SECURITIES LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "PTIS",
        "clearingBroker": "0235",
        "brokerName": "PTI SECURITIES & FUTURES L.P.                                         "
    },
    {
        "type": "CORP",
        "mpid": "PUPL",
        "clearingBroker": "0226",
        "brokerName": "PUPLAVA SECURITIES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "PURP",
        "clearingBroker": "0279",
        "brokerName": "LIBERTY CAPITAL INVESTMENT CORPORATION                                "
    },
    {
        "type": "CORP",
        "mpid": "PWAS",
        "clearingBroker": "0443",
        "brokerName": "PWA SECURITIES, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "PWJC",
        "clearingBroker": "0221",
        "brokerName": "UBS FINANCIAL SERVICES INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "PXGJ",
        "clearingBroker": "0352",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "CORP",
        "mpid": "QBND",
        "clearingBroker": "0161",
        "brokerName": "MCAP LLC                                                              "
    },
    {
        "type": "CORP",
        "mpid": "QBSI",
        "clearingBroker": "0226",
        "brokerName": "GLEN EAGLE WEALTH, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "QCAP",
        "clearingBroker": "0235",
        "brokerName": "QUINT CAPITAL CORPORATION                                             "
    },
    {
        "type": "CORP",
        "mpid": "QCAS",
        "clearingBroker": "0226",
        "brokerName": "QUINCY CASS ASSOCIATES, INCORPORATED                                  "
    },
    {
        "type": "CORP",
        "mpid": "QMSR",
        "clearingBroker": "0235",
        "brokerName": "QUATTRO M SECURITIES INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "QUOI",
        "clearingBroker": "0279",
        "brokerName": "QUOIN CAPITAL LLC                                                     "
    },
    {
        "type": "CORP",
        "mpid": "QWIK",
        "clearingBroker": "0161",
        "brokerName": "MCAP LLC                                                              "
    },
    {
        "type": "CORP",
        "mpid": "RAAA",
        "clearingBroker": "0052",
        "brokerName": "RICHARD JAMES & ASSOCIATES, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "RAAI",
        "clearingBroker": "0226",
        "brokerName": "OSAIC WEALTH, INC.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "RABO",
        "clearingBroker": "0443",
        "brokerName": "RABO SECURITIES USA, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "RACO",
        "clearingBroker": "0158",
        "brokerName": "SHEARMAN, RALSTON, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "RAJA",
        "clearingBroker": "0725",
        "brokerName": "RAYMOND JAMES & ASSOCIATES, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "RAJC",
        "clearingBroker": "0443",
        "brokerName": "RAYMOND JAMES USA                                                     "
    },
    {
        "type": "CORP",
        "mpid": "RAYG",
        "clearingBroker": "0443",
        "brokerName": "BOLTON GLOBAL CAPITAL                                                 "
    },
    {
        "type": "CORP",
        "mpid": "RBAC",
        "clearingBroker": "0443",
        "brokerName": "ROBERT B. AUSDAL & CO. INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "RBCD",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS CORPORATION                                       "
    },
    {
        "type": "CORP",
        "mpid": "RBCM",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS CORPORATION                                       "
    },
    {
        "type": "CORP",
        "mpid": "RBCX",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS CORPORATION                                       "
    },
    {
        "type": "CORP",
        "mpid": "RBII",
        "clearingBroker": "0279",
        "brokerName": "REGIONAL BROKERS, INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "RCMA",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS ARBITRAGE, S.A.                                   "
    },
    {
        "type": "CORP",
        "mpid": "RCRS",
        "clearingBroker": "0226",
        "brokerName": "ROOSEVELT & CROSS, INCORPORATED                                       "
    },
    {
        "type": "CORP",
        "mpid": "RDSS",
        "clearingBroker": "0141",
        "brokerName": "RDSC, LLC                                                             "
    },
    {
        "type": "CORP",
        "mpid": "REGN",
        "clearingBroker": "0443",
        "brokerName": "REGIONS SECURITIES LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "REGR",
        "clearingBroker": "0141",
        "brokerName": "REGISTER & AKERS INVESTMENTS, INC.                                    "
    },
    {
        "type": "CORP",
        "mpid": "REVL",
        "clearingBroker": "0750",
        "brokerName": "REVL SECURITIES, LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "RFAI",
        "clearingBroker": "0725",
        "brokerName": "RYAN FINANCIAL, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "RFRC",
        "clearingBroker": "0279",
        "brokerName": "THE ROCKWELL FINANCIAL GROUP, INC.                                    "
    },
    {
        "type": "CORP",
        "mpid": "RGLD",
        "clearingBroker": "0279",
        "brokerName": "REGAL SECURITIES, INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "RGLS",
        "clearingBroker": "0235",
        "brokerName": "REGAL SECURITIES, INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "RHDS",
        "clearingBroker": "0141",
        "brokerName": "RHODES SECURITIES, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "RHOX",
        "clearingBroker": "0005",
        "brokerName": "XR SECURITIES LLC                                                     "
    },
    {
        "type": "CORP",
        "mpid": "RIAP",
        "clearingBroker": "0443",
        "brokerName": "OSAIC SERVICES, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "RICE",
        "clearingBroker": "0235",
        "brokerName": "RICE FINANCIAL PRODUCTS COMPANY                                       "
    },
    {
        "type": "CORP",
        "mpid": "RICJ",
        "clearingBroker": "0235",
        "brokerName": "RICE SECURITIES, LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "RICM",
        "clearingBroker": "0595",
        "brokerName": "RICE FINANCIAL PRODUCTS COMPANY                                       "
    },
    {
        "type": "CORP",
        "mpid": "RIED",
        "clearingBroker": "0235",
        "brokerName": "RIEDL, FIRST SECURITIES COMPANY OF KANSAS                             "
    },
    {
        "type": "CORP",
        "mpid": "RILY",
        "clearingBroker": "0226",
        "brokerName": "B. RILEY FBR, INC.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "RJFI",
        "clearingBroker": "0390",
        "brokerName": "RAYMOND JAMES & ASSOCIATES, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "RJFS",
        "clearingBroker": "0725",
        "brokerName": "RAYMOND JAMES FINANCIAL SVCS. INC.                                    "
    },
    {
        "type": "CORP",
        "mpid": "RKWS",
        "clearingBroker": "0235",
        "brokerName": "ROCKWELL SECURITIES LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "RLIN",
        "clearingBroker": "0005",
        "brokerName": "WELLS FARGO SECURITIES, LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "RMAC",
        "clearingBroker": "0235",
        "brokerName": "RENAISSANCE MACRO SECURITIES, LLC                                     "
    },
    {
        "type": "CORP",
        "mpid": "RMPI",
        "clearingBroker": "0141",
        "brokerName": "RICHARDS, MERRILL & PETERSON, INC.                                    "
    },
    {
        "type": "CORP",
        "mpid": "RMST",
        "clearingBroker": "0443",
        "brokerName": "R.M. STARK & CO., INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "ROAR",
        "clearingBroker": "0103",
        "brokerName": "DINOSAUR SECURITIES                                                   "
    },
    {
        "type": "CORP",
        "mpid": "ROBT",
        "clearingBroker": "0443",
        "brokerName": "ROBOTTI & COMPANY, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "ROCK",
        "clearingBroker": "0226",
        "brokerName": "ROCKEFELLER FINANCIAL LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "ROCM",
        "clearingBroker": "0443",
        "brokerName": "RIM SECURITIES LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "ROMO",
        "clearingBroker": "0141",
        "brokerName": "ROMANO BROTHERS AND COMPANY                                           "
    },
    {
        "type": "CORP",
        "mpid": "RONI",
        "clearingBroker": "0005",
        "brokerName": "RONIN CAPITAL, LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "ROTB",
        "clearingBroker": "0235",
        "brokerName": "ROTH CAPITAL PARTNERS, LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "ROTH",
        "clearingBroker": "0161",
        "brokerName": "ROTH CAPITAL PARTNERS, LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "ROYL",
        "clearingBroker": "0443",
        "brokerName": "ROYAL ALLIANCE ASSOCIATES, INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "RPTR",
        "clearingBroker": "0235",
        "brokerName": "DINOSAUR SECURITIES, L.L.C.                                           "
    },
    {
        "type": "CORP",
        "mpid": "RQDR",
        "clearingBroker": "0235",
        "brokerName": "RQD* CLEARING LLC                                                     "
    },
    {
        "type": "CORP",
        "mpid": "RREZ",
        "clearingBroker": "0443",
        "brokerName": "SAMUEL A RAMIREZ & CO., INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "RRII",
        "clearingBroker": "0388",
        "brokerName": "ROBERTS & RYAN INVESTMENTS, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "RRUD",
        "clearingBroker": "0235",
        "brokerName": "REID & RUDIGER, LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "RSCM",
        "clearingBroker": "0235",
        "brokerName": "ROBERTSON STEPHENS CAPITAL MARKETS, LLC                               "
    },
    {
        "type": "CORP",
        "mpid": "RSSE",
        "clearingBroker": "0443",
        "brokerName": "RUSSELL IMPLEMENTATION SERVICES INC. PART OF RUSSE                    "
    },
    {
        "type": "CORP",
        "mpid": "RTHS",
        "clearingBroker": "0443",
        "brokerName": "ROTHSCHILD INVESTMENT CORPORATION                                     "
    },
    {
        "type": "CORP",
        "mpid": "RWSM",
        "clearingBroker": "0279",
        "brokerName": "R.W. SMITH & ASSOCIATES, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "RYDS",
        "clearingBroker": "0235",
        "brokerName": "RBC DOMINION SECURITIES CORPORATION                                   "
    },
    {
        "type": "CORP",
        "mpid": "SABS",
        "clearingBroker": "0443",
        "brokerName": "SABADELL SECURITIES USA, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "SAFX",
        "clearingBroker": "0235",
        "brokerName": "SAF FINANCIAL SECURITIES LLC                                          "
    },
    {
        "type": "CORP",
        "mpid": "SAGE",
        "clearingBroker": "0141",
        "brokerName": "SAGE, RUTTY & CO., INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "SALB",
        "clearingBroker": "0274",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC./SALOMON BROTHERS                        "
    },
    {
        "type": "CORP",
        "mpid": "SALI",
        "clearingBroker": "0750",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "SAMI",
        "clearingBroker": "0226",
        "brokerName": "SAMI BROKERAGE LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "SANT",
        "clearingBroker": "0443",
        "brokerName": "SANTANDER US CAPITAL MARKETS LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "SAPA",
        "clearingBroker": "0141",
        "brokerName": "SAPERSTON ASSET MANAGEMENT INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "SARG",
        "clearingBroker": "0226",
        "brokerName": "PURSHE KAPLAN STERLING INVESTMENTS, INC.                              "
    },
    {
        "type": "CORP",
        "mpid": "SAXO",
        "clearingBroker": "0443",
        "brokerName": "SAXONY SECURITIES                                                     "
    },
    {
        "type": "CORP",
        "mpid": "SBAM",
        "clearingBroker": "0443",
        "brokerName": "INVESTMENT PROFESSIONALS, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "SBLS",
        "clearingBroker": "0235",
        "brokerName": "SAN BLAS SECURITIES LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "SBLT",
        "clearingBroker": "0226",
        "brokerName": "SUNBELT SECURITIES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "SBRO",
        "clearingBroker": "0443",
        "brokerName": "STERN BROTHERS & CO.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "SBRT",
        "clearingBroker": "0226",
        "brokerName": "SIEBERT(MURIEL) & CO.,INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "SBRX",
        "clearingBroker": "0445",
        "brokerName": "MURIEL SIEBERT & CO., INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "SBSC",
        "clearingBroker": "0226",
        "brokerName": "SIEBERT CISNEROS SHANK & CO., L.L.C.                                  "
    },
    {
        "type": "CORP",
        "mpid": "SBSI",
        "clearingBroker": "0103",
        "brokerName": "SUN'S BROTHERS SECURITIES INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "SBSL",
        "clearingBroker": "1043",
        "brokerName": "STOCKBLOCK SECURITIES LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "SCAP",
        "clearingBroker": "0595",
        "brokerName": "STRONG CAPITAL MARKETS, LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "SCIL",
        "clearingBroker": "0052",
        "brokerName": "STRATEGIC CAPITAL INVESTMENTS, LLC                                    "
    },
    {
        "type": "CORP",
        "mpid": "SCMC",
        "clearingBroker": "0096",
        "brokerName": "SCOTIA CAPITAL MARKETS (USA) INC.                                     "
    },
    {
        "type": "CORP",
        "mpid": "SCSS",
        "clearingBroker": "0750",
        "brokerName": "STONECASTLE SECURITIES, LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "SCTI",
        "clearingBroker": "0443",
        "brokerName": "SECURITY CAPITAL BROKERAGE, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "SCTL",
        "clearingBroker": "0443",
        "brokerName": "SENTINEL SECURITIES, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "SDDC",
        "clearingBroker": "0443",
        "brokerName": "SDDCO BROKERAGE AQDVISORS                                             "
    },
    {
        "type": "CORP",
        "mpid": "SDIC",
        "clearingBroker": "0235",
        "brokerName": "SAUER DAZEY INVESTMENT CO.                                            "
    },
    {
        "type": "CORP",
        "mpid": "SEAP",
        "clearingBroker": "0226",
        "brokerName": "SEAPORT SECURITIES CORP.                                              "
    },
    {
        "type": "CORP",
        "mpid": "SEBS",
        "clearingBroker": "0443",
        "brokerName": "SECU BROKERAGE SERVICES                                               "
    },
    {
        "type": "CORP",
        "mpid": "SEEL",
        "clearingBroker": "0443",
        "brokerName": "R. SEELAUS & CO., INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "SEFB",
        "clearingBroker": "0052",
        "brokerName": "SOUTHEAST INVESTMENTS, N.C., INC.                                     "
    },
    {
        "type": "CORP",
        "mpid": "SEIB",
        "clearingBroker": "0158",
        "brokerName": "SEIBERT (J.D.) & COMPANY INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "SEMI",
        "clearingBroker": "0443",
        "brokerName": "SEMINARIO SECURITIES                                                  "
    },
    {
        "type": "CORP",
        "mpid": "SEMT",
        "clearingBroker": "7311",
        "brokerName": "MINT BROKERS                                                          "
    },
    {
        "type": "CORP",
        "mpid": "SEND",
        "clearingBroker": "0443",
        "brokerName": "SENDERO SECURITIES                                                    "
    },
    {
        "type": "CORP",
        "mpid": "SERL",
        "clearingBroker": "0443",
        "brokerName": "SEARLE & CO.                                                          "
    },
    {
        "type": "CORP",
        "mpid": "SEVN",
        "clearingBroker": "0443",
        "brokerName": "NATIONWIDE SECURITIES                                                 "
    },
    {
        "type": "CORP",
        "mpid": "SFGB",
        "clearingBroker": "0161",
        "brokerName": "SUSQUEHANNA FINANCIAL GROUP, LLP                                      "
    },
    {
        "type": "CORP",
        "mpid": "SFPS",
        "clearingBroker": "0443",
        "brokerName": "SF INVESTMENTS, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "SFSI",
        "clearingBroker": "0235",
        "brokerName": "SUPERIOR FINANCIAL SERVICES, INC.                                     "
    },
    {
        "type": "CORP",
        "mpid": "SGAS",
        "clearingBroker": "0286",
        "brokerName": "SG AMERICAS SECURITIES, LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "SGBI",
        "clearingBroker": "0226",
        "brokerName": "SMITH, BROWN & GROOVER, INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "SGFC",
        "clearingBroker": "0226",
        "brokerName": "SIGMA FINANCIAL CORPORATION                                           "
    },
    {
        "type": "CORP",
        "mpid": "SGLC",
        "clearingBroker": "0235",
        "brokerName": "S.G. LONG & COMPANY                                                   "
    },
    {
        "type": "CORP",
        "mpid": "SGNL",
        "clearingBroker": "0279",
        "brokerName": "SIGNAL SECURITIES, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "SGSM",
        "clearingBroker": "1043",
        "brokerName": "SEAPORT GLOBAL SECURITIES LLC                                         "
    },
    {
        "type": "CORP",
        "mpid": "SHMR",
        "clearingBroker": "0443",
        "brokerName": "ABN AMRO CLEARING USA LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "SHOT",
        "clearingBroker": "0005",
        "brokerName": "SCHOTTENFELD GROUP LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "SIAN",
        "clearingBroker": "0443",
        "brokerName": "SECURIAN FINANCIAL SERVICES                                           "
    },
    {
        "type": "CORP",
        "mpid": "SJGM",
        "clearingBroker": "0443",
        "brokerName": "SCOTT JAMES GROUP, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "SKTR",
        "clearingBroker": "0279",
        "brokerName": "STOCK TRADERS                                                         "
    },
    {
        "type": "CORP",
        "mpid": "SLRD",
        "clearingBroker": "0226",
        "brokerName": "S.L. REED & COMPANY                                                   "
    },
    {
        "type": "CORP",
        "mpid": "SMCO",
        "clearingBroker": "0235",
        "brokerName": "SMITH, MOORE & CO.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "SMHI",
        "clearingBroker": "0443",
        "brokerName": "SANDERS MORRIS HARRIS INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "SMNS",
        "clearingBroker": "0226",
        "brokerName": "PARKLAND SECURITIES, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "SMPR",
        "clearingBroker": "0443",
        "brokerName": "SUMMIT BROKERAGE SERVICES, INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "SMRD",
        "clearingBroker": "0443",
        "brokerName": "SUMRIDGE PARTNERS, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "SMRI",
        "clearingBroker": "0226",
        "brokerName": "SECURITIES MANAGEMENT & RESEARCH, INC.                                "
    },
    {
        "type": "CORP",
        "mpid": "SNEX",
        "clearingBroker": "0750",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "SNWS",
        "clearingBroker": "0443",
        "brokerName": "SNOWDEN ACCOUNT SERVICES, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "SOCO",
        "clearingBroker": "0443",
        "brokerName": "CAPITAL ONE SECURITIES, INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "SOFI",
        "clearingBroker": "0158",
        "brokerName": "SOFI SECURITIES LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "SOGO",
        "clearingBroker": "0158",
        "brokerName": "WANG INVESTMENT ASSOCIATES, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "SORS",
        "clearingBroker": "0235",
        "brokerName": "SORSBY FINANCIAL CORP.                                                "
    },
    {
        "type": "CORP",
        "mpid": "SOVG",
        "clearingBroker": "8199",
        "brokerName": "SOVEREIGN GLOBAL ADVISORS, LLC                                        "
    },
    {
        "type": "CORP",
        "mpid": "SPAC",
        "clearingBroker": "0793",
        "brokerName": "SIERRA PACIFIC SECURITIES, LLC                                        "
    },
    {
        "type": "CORP",
        "mpid": "SPCS",
        "clearingBroker": "0052",
        "brokerName": "SPARTAN CAPITAL SECURITIES, LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "SPEX",
        "clearingBroker": "0235",
        "brokerName": "INSPEREX LLC                                                          "
    },
    {
        "type": "CORP",
        "mpid": "SPGS",
        "clearingBroker": "0443",
        "brokerName": "SEAPORT GLOBAL SECURITIES LLC                                         "
    },
    {
        "type": "CORP",
        "mpid": "SPHN",
        "clearingBroker": "0443",
        "brokerName": "STEPHENS INC.                                                         "
    },
    {
        "type": "CORP",
        "mpid": "SPLC",
        "clearingBroker": "0226",
        "brokerName": "SPIRE SECURITIES, LLC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "SPLD",
        "clearingBroker": "0443",
        "brokerName": "SPIRE SECURITIES, LLC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "SPLN",
        "clearingBroker": "8199",
        "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "SPOT",
        "clearingBroker": "0005",
        "brokerName": "SPOT TRADING                                                          "
    },
    {
        "type": "CORP",
        "mpid": "SPTD",
        "clearingBroker": "0052",
        "brokerName": "MINT GLOBAL MARKETS, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "SPTS",
        "clearingBroker": "0158",
        "brokerName": "SEVEN POINTS CAPITAL, LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "SRAM",
        "clearingBroker": "0443",
        "brokerName": "SAMCO CAPITAL MARKETS, INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "SRBC",
        "clearingBroker": "0235",
        "brokerName": "SPIDERROCK EXS, LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "SSBS",
        "clearingBroker": "0443",
        "brokerName": "STATE STREET GLOBAL MARKETS, LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "SSCO",
        "clearingBroker": "8457",
        "brokerName": "SAFRA SECURITIES LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "SSGC",
        "clearingBroker": "0226",
        "brokerName": "SIGNATURE SECURITIES                                                  "
    },
    {
        "type": "CORP",
        "mpid": "SSGM",
        "clearingBroker": "0226",
        "brokerName": "STATE STREET GLOBAL MARKETS, LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "SSGR",
        "clearingBroker": "0443",
        "brokerName": "SHAREHOLDERS SERVICES GROUP INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "SSIN",
        "clearingBroker": "0226",
        "brokerName": "TRUIST INVESTMENT SERVICES, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "SSLC",
        "clearingBroker": "0279",
        "brokerName": "SANDERLIN SECURITIES, LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "SSLL",
        "clearingBroker": "0189",
        "brokerName": "STATE STREET GLOBAL MARKETS, LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "SSNE",
        "clearingBroker": "0226",
        "brokerName": "SANTANDER SECURITIES LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "SSNG",
        "clearingBroker": "0443",
        "brokerName": "SISUNG SECURITIES CORPORATION                                         "
    },
    {
        "type": "CORP",
        "mpid": "STCM",
        "clearingBroker": "2095",
        "brokerName": "TRUIST SECURITIES, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "STEP",
        "clearingBroker": "0235",
        "brokerName": "FERRETTI GROUP, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "STFC",
        "clearingBroker": "0443",
        "brokerName": "STUART FRANKEL & CO., INCORPORATED                                    "
    },
    {
        "type": "CORP",
        "mpid": "STFG",
        "clearingBroker": "0443",
        "brokerName": "STANFORD GROUP COMPANY                                                "
    },
    {
        "type": "CORP",
        "mpid": "STFL",
        "clearingBroker": "0793",
        "brokerName": "STIFEL, NICOLAUS & COMPANY, INCORPORATED                              "
    },
    {
        "type": "CORP",
        "mpid": "STGC",
        "clearingBroker": "0279",
        "brokerName": "STERLING GRACE MUNICIPAL SECURITIES CO                                "
    },
    {
        "type": "CORP",
        "mpid": "STKP",
        "clearingBroker": "0158",
        "brokerName": "STOCKPILE INVESTMENTS, INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "STOX",
        "clearingBroker": "0445",
        "brokerName": "MURIEL SIEBERT & CO., LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "STRM",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "CORP",
        "mpid": "STRS",
        "clearingBroker": "0161",
        "brokerName": "STRATEGAS RESEARCH PARTNERS, LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "STSM",
        "clearingBroker": "0443",
        "brokerName": "STERLING SMITH CORPORATION                                            "
    },
    {
        "type": "CORP",
        "mpid": "STTT",
        "clearingBroker": "0052",
        "brokerName": "STATETRUST INVESTMENTS INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "STUR",
        "clearingBroker": "0158",
        "brokerName": "STURDIVANT & CO., INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "STXG",
        "clearingBroker": "0445",
        "brokerName": "MURIEL SIEBERT & CO., INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "STXW",
        "clearingBroker": "0443",
        "brokerName": "SA STONE WEALTH MANAGEMENT INC.                                       "
    },
    {
        "type": "CORP",
        "mpid": "SUFI",
        "clearingBroker": "0551",
        "brokerName": "SUSQUEHANNA FINANCIAL GROUP, LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "SUMI",
        "clearingBroker": "0443",
        "brokerName": "SMBC NIKKO SECURITIES AMERICA, INC.                                   "
    },
    {
        "type": "CORP",
        "mpid": "SUSQ",
        "clearingBroker": "0551",
        "brokerName": "SUSQUEHANNA CAPITAL GROUP                                             "
    },
    {
        "type": "CORP",
        "mpid": "SUST",
        "clearingBroker": "0235",
        "brokerName": "SUNSTREET SECURITIES, LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "SVSI",
        "clearingBroker": "0725",
        "brokerName": "SILICON VALLEY SECURITIES, INC                                        "
    },
    {
        "type": "CORP",
        "mpid": "SWBC",
        "clearingBroker": "0443",
        "brokerName": "SWBC INVESTMENT SERVICES, LLC                                         "
    },
    {
        "type": "CORP",
        "mpid": "SWSS",
        "clearingBroker": "0443",
        "brokerName": "SANCTUARY SECURITIES, INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "SWST",
        "clearingBroker": "0279",
        "brokerName": "HILLTOP SECURITIES INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "SYCA",
        "clearingBroker": "0443",
        "brokerName": "SYNDICATED CAPITAL, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "TAFI",
        "clearingBroker": "0443",
        "brokerName": "NATHAN HALE CAPITAL, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "TAGB",
        "clearingBroker": "0052",
        "brokerName": "TAGLICH BROTHERS, INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "TAGC",
        "clearingBroker": "1043",
        "brokerName": "TELSEY ADVISORY GROUP LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "TAGD",
        "clearingBroker": "1043",
        "brokerName": "TELSEY ADVISORY GROUP LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "TALR",
        "clearingBroker": "0725",
        "brokerName": "TAYLOR SECURITIES, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "TBCL",
        "clearingBroker": "0750",
        "brokerName": "TRADE BRIDGE CAPITAL LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "TBCR",
        "clearingBroker": "0235",
        "brokerName": "TRADE BRIDGE CAPITAL LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "TBIA",
        "clearingBroker": "0158",
        "brokerName": "TRADIER BROKERAGE, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "TBIS",
        "clearingBroker": "0158",
        "brokerName": "TRADIER BROKERAGE, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "TBRD",
        "clearingBroker": "0226",
        "brokerName": "THOROUGHBRED FINANCIAL SERVICES, LLC                                  "
    },
    {
        "type": "CORP",
        "mpid": "TCBI",
        "clearingBroker": "0443",
        "brokerName": "TCBI SECURITIES, INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "TDCO",
        "clearingBroker": "0235",
        "brokerName": "THOMPSON DAVIS & CO., INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "TDFS",
        "clearingBroker": "0052",
        "brokerName": "TRADERFIELD SECURITIES INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "TDNF",
        "clearingBroker": "2568",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "TDPA",
        "clearingBroker": "0226",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "TDPW",
        "clearingBroker": "0443",
        "brokerName": "TD PRIVATE CLIENT WEALTH, LLC                                         "
    },
    {
        "type": "CORP",
        "mpid": "TDSI",
        "clearingBroker": "2568",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "TEDP",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "TERA",
        "clearingBroker": "0443",
        "brokerName": "CETERA FINANCIAL SPECIALISTS                                          "
    },
    {
        "type": "CORP",
        "mpid": "TFAI",
        "clearingBroker": "0226",
        "brokerName": "TRANSAMERICA FINANCIAL ADVISORS, INC.                                 "
    },
    {
        "type": "CORP",
        "mpid": "TFAS",
        "clearingBroker": "0443",
        "brokerName": "TRADITION SECURITIES AND DERIVATIVES LLC                              "
    },
    {
        "type": "CORP",
        "mpid": "TFSL",
        "clearingBroker": "0235",
        "brokerName": "TECKMEYER FINANCIAL SERVICES                                          "
    },
    {
        "type": "CORP",
        "mpid": "TFSS",
        "clearingBroker": "0443",
        "brokerName": "TFS SECURITIES, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "TGHS",
        "clearingBroker": "0443",
        "brokerName": "TGH SECURITIES, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "THEM",
        "clearingBroker": "0235",
        "brokerName": "THEMIS TRADING LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "THNK",
        "clearingBroker": "0052",
        "brokerName": "THINKEQUITY, LLC                                                      "
    },
    {
        "type": "CORP",
        "mpid": "TIAD",
        "clearingBroker": "8199",
        "brokerName": "TRIAD SECURITIES                                                      "
    },
    {
        "type": "CORP",
        "mpid": "TIAN",
        "clearingBroker": "0226",
        "brokerName": "TRIAD SECURITIES CORP                                                 "
    },
    {
        "type": "CORP",
        "mpid": "TIGC",
        "clearingBroker": "0235",
        "brokerName": "NELSONREID, INC.                                                      "
    },
    {
        "type": "CORP",
        "mpid": "TIGE",
        "clearingBroker": "1043",
        "brokerName": "US TIGER SECURITIES, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "TJMB",
        "clearingBroker": "1043",
        "brokerName": "TJM INVESTMENTS, LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "TKNG",
        "clearingBroker": "0158",
        "brokerName": "TRADEKING LLC                                                         "
    },
    {
        "type": "CORP",
        "mpid": "TMAS",
        "clearingBroker": "0235",
        "brokerName": "TRADEMAS INC.                                                         "
    },
    {
        "type": "CORP",
        "mpid": "TMCC",
        "clearingBroker": "4264",
        "brokerName": "ICE BONDS SECURITIES CORPORATION                                      "
    },
    {
        "type": "CORP",
        "mpid": "TMCD",
        "clearingBroker": "0235",
        "brokerName": "MCDONALD PARTNERS LLC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "TOCQ",
        "clearingBroker": "0443",
        "brokerName": "TOCQUEVILLE SECURITIES L.P.                                           "
    },
    {
        "type": "CORP",
        "mpid": "TONE",
        "clearingBroker": "8199",
        "brokerName": "2021 CAPITAL                                                          "
    },
    {
        "type": "CORP",
        "mpid": "TORO",
        "clearingBroker": "0279",
        "brokerName": "VALDES & MORENO, INC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "TOUR",
        "clearingBroker": "0005",
        "brokerName": "TOURMALINE PARTNERS, LLC                                              "
    },
    {
        "type": "CORP",
        "mpid": "TOYS",
        "clearingBroker": "0443",
        "brokerName": "TOYOTA FINANCIAL SERVICES SECURITIES USA CORPORATION                  "
    },
    {
        "type": "CORP",
        "mpid": "TPCD",
        "clearingBroker": "0624",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "CORP",
        "mpid": "TPIS",
        "clearingBroker": "0161",
        "brokerName": "TULLETT PREBON FINANCIAL SERVICES, LLC                                "
    },
    {
        "type": "CORP",
        "mpid": "TPMG",
        "clearingBroker": "0005",
        "brokerName": "TOWER PRINCIPAL MARKETS LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "TPMR",
        "clearingBroker": "0141",
        "brokerName": "TRADE-PMR INC.                                                        "
    },
    {
        "type": "CORP",
        "mpid": "TRAD",
        "clearingBroker": "0271",
        "brokerName": "TRADESTATION SECURITIES, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "TRCG",
        "clearingBroker": "0005",
        "brokerName": "TRC MARKETS LLC                                                       "
    },
    {
        "type": "CORP",
        "mpid": "TRCS",
        "clearingBroker": "0388",
        "brokerName": "TIGERRISK CAPITAL MARKETS & ADVISORY                                  "
    },
    {
        "type": "CORP",
        "mpid": "TREX",
        "clearingBroker": "1043",
        "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
    },
    {
        "type": "CORP",
        "mpid": "TRIB",
        "clearingBroker": "0235",
        "brokerName": "TRIBAL CAPITAL MARKETS, LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "TRIP",
        "clearingBroker": "0235",
        "brokerName": "TRIDENT PARTNERS LTD                                                  "
    },
    {
        "type": "CORP",
        "mpid": "TRSH",
        "clearingBroker": "0279",
        "brokerName": "THRASHER & CHAMBERS, INC.                                             "
    },
    {
        "type": "CORP",
        "mpid": "TRUB",
        "clearingBroker": "0141",
        "brokerName": "TRUBEE, COLLINS & CO., INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "TRWN",
        "clearingBroker": "0443",
        "brokerName": "T.R. WINSTON & COMPANY, LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "TRYC",
        "clearingBroker": "0158",
        "brokerName": "SIXTEEN SECURITIES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "TRYN",
        "clearingBroker": "0279",
        "brokerName": "FIRST TRYON SECURITIES, LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "TSCD",
        "clearingBroker": "0235",
        "brokerName": "STURGES COMPANY (THE)                                                 "
    },
    {
        "type": "CORP",
        "mpid": "TSER",
        "clearingBroker": "0161",
        "brokerName": "TWO SIGMA EXECUTION SERVICES, LLC                                     "
    },
    {
        "type": "CORP",
        "mpid": "TSFA",
        "clearingBroker": "0443",
        "brokerName": "STRATEGIC FINANCIAL ALLIANCE (THE)                                    "
    },
    {
        "type": "CORP",
        "mpid": "TSSM",
        "clearingBroker": "0161",
        "brokerName": "TWO SIGMA SECURITIES, LLC                                             "
    },
    {
        "type": "CORP",
        "mpid": "TTSC",
        "clearingBroker": "0052",
        "brokerName": "TREND TRADE SECURITIES LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "TTSI",
        "clearingBroker": "0158",
        "brokerName": "T3 SECURITIES, INC.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "TWCM",
        "clearingBroker": "0443",
        "brokerName": "TOWERS WATSON CAPITAL MARKETS                                         "
    },
    {
        "type": "CORP",
        "mpid": "TWDI",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "TWDL",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "TWDP",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "TWDR",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "TWDS",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "TWTT",
        "clearingBroker": "0158",
        "brokerName": "TASTYWORKS, INC.                                                      "
    },
    {
        "type": "CORP",
        "mpid": "UBSI",
        "clearingBroker": "0141",
        "brokerName": "UNITED BROKERAGE SERVICES, INC                                        "
    },
    {
        "type": "CORP",
        "mpid": "UBSW",
        "clearingBroker": "0642",
        "brokerName": "UBS SECURITIES LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "UCAP",
        "clearingBroker": "0750",
        "brokerName": "UCAP SECURITIES LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "UCCM",
        "clearingBroker": "0279",
        "brokerName": "CU INVESTMENT SOLUTIONS, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "UCML",
        "clearingBroker": "0052",
        "brokerName": "UNITED CAPITAL MARKETS, INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "UFPF",
        "clearingBroker": "0226",
        "brokerName": "UNITED FIRST PARTNERS, LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "UHLM",
        "clearingBroker": "0235",
        "brokerName": "UHLMANN PRICE SECURITIES, LLC                                         "
    },
    {
        "type": "CORP",
        "mpid": "UMBF",
        "clearingBroker": "0226",
        "brokerName": "UMB FINANCIAL SERVICES, INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "UNIB",
        "clearingBroker": "0443",
        "brokerName": "UNIBANCO SECURITIES INC                                               "
    },
    {
        "type": "CORP",
        "mpid": "UNIV",
        "clearingBroker": "0595",
        "brokerName": "UNIVEST SECURITIES, LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "UNTD",
        "clearingBroker": "0443",
        "brokerName": "WADDELL & REED, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "UPLN",
        "clearingBroker": "0443",
        "brokerName": "UNITED PLANNERS FINANCIAL SERVICES OF AMERICA                         "
    },
    {
        "type": "CORP",
        "mpid": "USAF",
        "clearingBroker": "0443",
        "brokerName": "USA FINANCIAL SECURITIES CORP.                                        "
    },
    {
        "type": "CORP",
        "mpid": "USCA",
        "clearingBroker": "0226",
        "brokerName": "USCA SECURITIES LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "USDB",
        "clearingBroker": "0279",
        "brokerName": "U.S. BROKERAGE, INC.                                                  "
    },
    {
        "type": "CORP",
        "mpid": "USIC",
        "clearingBroker": "0226",
        "brokerName": "U.S. SECURITIES, INTL. CORP.                                          "
    },
    {
        "type": "CORP",
        "mpid": "USSI",
        "clearingBroker": "0279",
        "brokerName": "U.S. STERLING SECURITIES, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "USTZ",
        "clearingBroker": "0595",
        "brokerName": "TRADEZERO AMERINCA, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "UVST",
        "clearingBroker": "0443",
        "brokerName": "UVEST FINANCIAL SERVICES GROUP, INC.                                  "
    },
    {
        "type": "CORP",
        "mpid": "VABD",
        "clearingBroker": "4264",
        "brokerName": "ICE BONDS SECURITIES CORPORATION                                      "
    },
    {
        "type": "CORP",
        "mpid": "VALI",
        "clearingBroker": "0226",
        "brokerName": "VALLEY NATIONAL INVESTMENTS, INC.                                     "
    },
    {
        "type": "CORP",
        "mpid": "VALM",
        "clearingBroker": "0443",
        "brokerName": "VALMARK SECURITIES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "VBCS",
        "clearingBroker": "0279",
        "brokerName": "VBC SECURITIES                                                        "
    },
    {
        "type": "CORP",
        "mpid": "VBLT",
        "clearingBroker": "0226",
        "brokerName": "VANDERBILT SECURITIES, LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "VBSL",
        "clearingBroker": "0595",
        "brokerName": "VISION BROKERAGE SERVICES, LLC                                        "
    },
    {
        "type": "CORP",
        "mpid": "VCAP",
        "clearingBroker": "0443",
        "brokerName": "VANGUARD CAPITAL                                                      "
    },
    {
        "type": "CORP",
        "mpid": "VCAS",
        "clearingBroker": "0443",
        "brokerName": "VCA SECURITIES, LP                                                    "
    },
    {
        "type": "CORP",
        "mpid": "VCFN",
        "clearingBroker": "0235",
        "brokerName": "VAN CLEMENS & CO. INCORPORATED                                        "
    },
    {
        "type": "CORP",
        "mpid": "VCPL",
        "clearingBroker": "0443",
        "brokerName": "VELOCITY CLEARING, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "VCSV",
        "clearingBroker": "0052",
        "brokerName": "PRIMARY CAPITAL, LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "VENE",
        "clearingBroker": "0443",
        "brokerName": "VENECREDIT SECURITIES                                                 "
    },
    {
        "type": "CORP",
        "mpid": "VERF",
        "clearingBroker": "0235",
        "brokerName": "THE VERTICAL TRADING GROUP, LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "VERT",
        "clearingBroker": "8199",
        "brokerName": "THE VERTICAL TRADING GROUP, LLC                                       "
    },
    {
        "type": "CORP",
        "mpid": "VEST",
        "clearingBroker": "0750",
        "brokerName": "VESTECH SECURITIES, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "VETS",
        "clearingBroker": "0235",
        "brokerName": "AMERICAN VETERANS GROUP, PBC                                          "
    },
    {
        "type": "CORP",
        "mpid": "VFSL",
        "clearingBroker": "0443",
        "brokerName": "VALOR FINANCIAL SECURITIES LLC                                        "
    },
    {
        "type": "CORP",
        "mpid": "VGRD",
        "clearingBroker": "0062",
        "brokerName": "VANGUARD MARKETING CORPORATION                                        "
    },
    {
        "type": "CORP",
        "mpid": "VISI",
        "clearingBroker": "0443",
        "brokerName": "VISION INVESTMENT SERVICES, INC.                                      "
    },
    {
        "type": "CORP",
        "mpid": "VKMI",
        "clearingBroker": "0692",
        "brokerName": "INVESCO CAPITAL MARKETS, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "VLEO",
        "clearingBroker": "0158",
        "brokerName": "VOLEO USA, INC                                                        "
    },
    {
        "type": "CORP",
        "mpid": "VMDI",
        "clearingBroker": "0443",
        "brokerName": "DESJARDINS SECURITIES INTERNATIONAL INC.                              "
    },
    {
        "type": "CORP",
        "mpid": "VMEX",
        "clearingBroker": "0443",
        "brokerName": "VECTORGLOBAL WMG                                                      "
    },
    {
        "type": "CORP",
        "mpid": "VPEW",
        "clearingBroker": "0158",
        "brokerName": "VPE WERTPAPIERHANDELSBANK AG                                          "
    },
    {
        "type": "CORP",
        "mpid": "VSIN",
        "clearingBroker": "0595",
        "brokerName": "VISION FINANCIAL MARKETS LLC                                          "
    },
    {
        "type": "CORP",
        "mpid": "VSRF",
        "clearingBroker": "0141",
        "brokerName": "VSR FINANCIAL SERVICES                                                "
    },
    {
        "type": "CORP",
        "mpid": "VTDT",
        "clearingBroker": "0158",
        "brokerName": "VIEWTRADE SECURITIES, INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "VTRN",
        "clearingBroker": "0443",
        "brokerName": "BANCROFT CAPITAL, LLC                                                 "
    },
    {
        "type": "CORP",
        "mpid": "WABR",
        "clearingBroker": "0443",
        "brokerName": "WALL STREET ACCESS                                                    "
    },
    {
        "type": "CORP",
        "mpid": "WACC",
        "clearingBroker": "0279",
        "brokerName": "MIDLAND SECURITIES, LTD                                               "
    },
    {
        "type": "CORP",
        "mpid": "WACL",
        "clearingBroker": "0709",
        "brokerName": "WACHTEL & CO., INC.                                                   "
    },
    {
        "type": "CORP",
        "mpid": "WAIN",
        "clearingBroker": "0443",
        "brokerName": "H.C. WAINWRIGHT & CO., INC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "WBAX",
        "clearingBroker": "0052",
        "brokerName": "WALLACHBETH CAPITAL LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "WBBC",
        "clearingBroker": "0226",
        "brokerName": "WBB SECURITIES, LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "WBET",
        "clearingBroker": "0161",
        "brokerName": "WALLACHBETH CAPITAL LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "WBFS",
        "clearingBroker": "0443",
        "brokerName": "WOODBURY FINANCIAL SERVICES, INC.                                     "
    },
    {
        "type": "CORP",
        "mpid": "WBLR",
        "clearingBroker": "0771",
        "brokerName": "WILLIAM BLAIR & COMPANY, L.L.C.                                       "
    },
    {
        "type": "CORP",
        "mpid": "WBNA",
        "clearingBroker": "2072",
        "brokerName": "WELLS FARGO BANK, N.A./SIG                                            "
    },
    {
        "type": "CORP",
        "mpid": "WBNF",
        "clearingBroker": "0226",
        "brokerName": "WILLIAM BLAIR & COMPANY L.L.C.                                        "
    },
    {
        "type": "CORP",
        "mpid": "WBRO",
        "clearingBroker": "0443",
        "brokerName": "WILEY BROS.-AINTREE CAPITAL, LLC                                      "
    },
    {
        "type": "CORP",
        "mpid": "WBUL",
        "clearingBroker": "0158",
        "brokerName": "WEBULL FINANCIAL LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "WCHV",
        "clearingBroker": "0250",
        "brokerName": "WELLS FARGO SECURITIES, LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "WCIG",
        "clearingBroker": "0750",
        "brokerName": "WILLOW COVE INVESTMENT GROUP, INC.                                    "
    },
    {
        "type": "CORP",
        "mpid": "WCSC",
        "clearingBroker": "0235",
        "brokerName": "WILMINGTON CAPITAL SECURITIES, LLC                                    "
    },
    {
        "type": "CORP",
        "mpid": "WCSF",
        "clearingBroker": "0235",
        "brokerName": "WORLD CHOICE SECURITIES, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "WEBS",
        "clearingBroker": "0226",
        "brokerName": "WEALTH ENHANCEMENT BROKERAGE SERVICES, LLC                            "
    },
    {
        "type": "CORP",
        "mpid": "WEDB",
        "clearingBroker": "0103",
        "brokerName": "WEDBUSH SECURITIES INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "WEGE",
        "clearingBroker": "0443",
        "brokerName": "WORLD EQUITY GROUP, INC.                                              "
    },
    {
        "type": "CORP",
        "mpid": "WEGI",
        "clearingBroker": "0235",
        "brokerName": "WORLD EQUITY GROUP INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "WEGP",
        "clearingBroker": "0235",
        "brokerName": "WESTERN EQUITY GROUP, INC.                                            "
    },
    {
        "type": "CORP",
        "mpid": "WESC",
        "clearingBroker": "0443",
        "brokerName": "WELLINGTON SHIELDS & CO., LLC                                         "
    },
    {
        "type": "CORP",
        "mpid": "WEST",
        "clearingBroker": "0443",
        "brokerName": "WESTERN GROWERS FINANCIAL SERVICES, INC.                              "
    },
    {
        "type": "CORP",
        "mpid": "WEXM",
        "clearingBroker": "0161",
        "brokerName": "W OLVERINE EXECUTION SERVICES LLC                                     "
    },
    {
        "type": "CORP",
        "mpid": "WEXR",
        "clearingBroker": "0235",
        "brokerName": "WOLVERINE EXECUTION SERVICES, LLC                                     "
    },
    {
        "type": "CORP",
        "mpid": "WEXX",
        "clearingBroker": "0005",
        "brokerName": "WOLVERINE EXECUTION SERVICES                                          "
    },
    {
        "type": "CORP",
        "mpid": "WHAE",
        "clearingBroker": "0443",
        "brokerName": "WHARTON EQUITY CORPORATION                                            "
    },
    {
        "type": "CORP",
        "mpid": "WHCG",
        "clearingBroker": "0388",
        "brokerName": "WHITAKER                                                              "
    },
    {
        "type": "CORP",
        "mpid": "WHOT",
        "clearingBroker": "0595",
        "brokerName": "JUST2TRADE, INC.                                                      "
    },
    {
        "type": "CORP",
        "mpid": "WIDS",
        "clearingBroker": "0279",
        "brokerName": "WISCONSIN DISCOUNT SECURITIES CORP.                                   "
    },
    {
        "type": "CORP",
        "mpid": "WING",
        "clearingBroker": "0443",
        "brokerName": "ING FINANCIAL PARTNERS, INC.                                          "
    },
    {
        "type": "CORP",
        "mpid": "WISC",
        "clearingBroker": "0235",
        "brokerName": "WINDSOR, SHEFFIELD & CO., INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "WISE",
        "clearingBroker": "0052",
        "brokerName": "AXOS INVEST LLC                                                       "
    },
    {
        "type": "CORP",
        "mpid": "WISP",
        "clearingBroker": "0443",
        "brokerName": "WESTERN INTERNATIONAL SECURITIES, INC.                                "
    },
    {
        "type": "CORP",
        "mpid": "WJBI",
        "clearingBroker": "0443",
        "brokerName": "WJB CAPITAL GROUP                                                     "
    },
    {
        "type": "CORP",
        "mpid": "WLMS",
        "clearingBroker": "0443",
        "brokerName": "SIEBERT CISNEROS SHANK & CO., L.L.C.                                  "
    },
    {
        "type": "CORP",
        "mpid": "WLTH",
        "clearingBroker": "0235",
        "brokerName": "WEALTHFRONT BROKERAGE CORPORATION                                     "
    },
    {
        "type": "CORP",
        "mpid": "WMCL",
        "clearingBroker": "0279",
        "brokerName": "WHITE MOUNTAIN CAPITAL, LLC                                           "
    },
    {
        "type": "CORP",
        "mpid": "WMFS",
        "clearingBroker": "0226",
        "brokerName": "WESTMINSTER FINANCIAL SECURITIES, INC.                                "
    },
    {
        "type": "CORP",
        "mpid": "WMLL",
        "clearingBroker": "0005",
        "brokerName": "WATERMILL INSTITUTIONAL TRADING LLC                                   "
    },
    {
        "type": "CORP",
        "mpid": "WOOD",
        "clearingBroker": "0725",
        "brokerName": "ARTHUR W WOOD COMPANY                                                 "
    },
    {
        "type": "CORP",
        "mpid": "WPCC",
        "clearingBroker": "0052",
        "brokerName": "WESTPARK CAPITAL, INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "WPCI",
        "clearingBroker": "0595",
        "brokerName": "WESTPARK CAPITAL, INC.                                                "
    },
    {
        "type": "CORP",
        "mpid": "WPSG",
        "clearingBroker": "0005",
        "brokerName": "WEEDEN PRIME SERVICES, LLC.                                           "
    },
    {
        "type": "CORP",
        "mpid": "WPSX",
        "clearingBroker": "0445",
        "brokerName": "RISE FINANCIAL SERVICES, LLC                                          "
    },
    {
        "type": "CORP",
        "mpid": "WRET",
        "clearingBroker": "0141",
        "brokerName": "WELLS FARGO CLEARING SERVICES, LLC                                    "
    },
    {
        "type": "CORP",
        "mpid": "WSBI",
        "clearingBroker": "0443",
        "brokerName": "W&S BROKERAGE SVCS                                                    "
    },
    {
        "type": "CORP",
        "mpid": "WSCC",
        "clearingBroker": "0235",
        "brokerName": "WASHINGTON SECURITIES CORPORATION                                     "
    },
    {
        "type": "CORP",
        "mpid": "WSCX",
        "clearingBroker": "0235",
        "brokerName": "WORKMAN SECURITIES CORP                                               "
    },
    {
        "type": "CORP",
        "mpid": "WSEC",
        "clearingBroker": "0443",
        "brokerName": "WILLIS SECURITIES, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "WSGD",
        "clearingBroker": "8199",
        "brokerName": "WEDBUSH SECURITIES INC./P3                                            "
    },
    {
        "type": "CORP",
        "mpid": "WSIW",
        "clearingBroker": "8199",
        "brokerName": "WEDBUSH SECURITIES INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "WSRP",
        "clearingBroker": "0052",
        "brokerName": "WESTROCK CAPITAL MANAGEMENT, INC.                                     "
    },
    {
        "type": "CORP",
        "mpid": "WSTI",
        "clearingBroker": "0226",
        "brokerName": "WESTERN INTERNATIONAL SECURITIES, INC.                                "
    },
    {
        "type": "CORP",
        "mpid": "WTCO",
        "clearingBroker": "0005",
        "brokerName": "WILLIAMS TRADING LLC                                                  "
    },
    {
        "type": "CORP",
        "mpid": "WTFS",
        "clearingBroker": "0052",
        "brokerName": "LIME TRADING CORP                                                     "
    },
    {
        "type": "CORP",
        "mpid": "WTKR",
        "clearingBroker": "0388",
        "brokerName": "WHITAKER                                                              "
    },
    {
        "type": "CORP",
        "mpid": "WTLP",
        "clearingBroker": "0388",
        "brokerName": "WOLVERINE TRADING, LLC                                                "
    },
    {
        "type": "CORP",
        "mpid": "WTRI",
        "clearingBroker": "0235",
        "brokerName": "WATERFORD INVESTORS SERVICES, INC.                                    "
    },
    {
        "type": "CORP",
        "mpid": "WUND",
        "clearingBroker": "0141",
        "brokerName": "B. RILEY WEALTH MANAGEMENT                                            "
    },
    {
        "type": "CORP",
        "mpid": "WVBD",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "WZVB",
        "clearingBroker": "0725",
        "brokerName": "IMPACTIVE ADVISORS, LLC                                               "
    },
    {
        "type": "CORP",
        "mpid": "XCNC",
        "clearingBroker": "0005",
        "brokerName": "C&C TRADING L.L.C.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "XPUS",
        "clearingBroker": "0443",
        "brokerName": "XP SECURITIES, LLC                                                    "
    },
    {
        "type": "CORP",
        "mpid": "XRVR",
        "clearingBroker": "0279",
        "brokerName": "CRB SECURITIES, LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "XTLS",
        "clearingBroker": "0052",
        "brokerName": "XTELLUS CAPITAL PARTNERS, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "XTLW",
        "clearingBroker": "0052",
        "brokerName": "XTELLUS CAPITAL PARTNERS, INC.                                        "
    },
    {
        "type": "CORP",
        "mpid": "XTXE",
        "clearingBroker": "0161",
        "brokerName": "XTX EXECUTION SERVICES LLC                                            "
    },
    {
        "type": "CORP",
        "mpid": "YLPL",
        "clearingBroker": "0075",
        "brokerName": "LPL FINANCIAL LLC                                                     "
    },
    {
        "type": "CORP",
        "mpid": "YOSE",
        "clearingBroker": "0052",
        "brokerName": "YORK SECURITIES, INC.                                                 "
    },
    {
        "type": "CORP",
        "mpid": "ZAHK",
        "clearingBroker": "0443",
        "brokerName": "TRANSAMERICA FINANCIAL ADVISORS                                       "
    },
    {
        "type": "CORP",
        "mpid": "ZAND",
        "clearingBroker": "0443",
        "brokerName": "MCLAUGHLIN RYDER INVESTMENTS                                          "
    },
    {
        "type": "CORP",
        "mpid": "ZEDB",
        "clearingBroker": "0161",
        "brokerName": "INVESCO CAPITAL MARKETS, INC.                                         "
    },
    {
        "type": "CORP",
        "mpid": "ZERO",
        "clearingBroker": "0158",
        "brokerName": "TRADEZERO AMERICA, INC.                                               "
    },
    {
        "type": "CORP",
        "mpid": "ZEUS",
        "clearingBroker": "0443",
        "brokerName": "ZEUS FINANCIAL, LLC                                                   "
    },
    {
        "type": "CORP",
        "mpid": "ZION",
        "clearingBroker": "0065",
        "brokerName": "ZIONS DIRECT, INC.                                                    "
    },
    {
        "type": "CORP",
        "mpid": "ZIVI",
        "clearingBroker": "0235",
        "brokerName": "ZIV INVESTMENT COMPANY                                                "
    },
    {
        "type": "CORP",
        "mpid": "ZOUL",
        "clearingBroker": "0235",
        "brokerName": "N.B. ZOULLAS SECURITIES, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "AALC",
        "clearingBroker": "0226",
        "brokerName": "THRIVENT INVESTMENT MANAGEMENT, INC.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "ABAI",
        "clearingBroker": "0279",
        "brokerName": "ABACUS INVESTMENTS, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "ABBA",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "MUNI",
        "mpid": "ABBK",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "MUNI",
        "mpid": "ABDA",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "MUNI",
        "mpid": "ABDW",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "MUNI",
        "mpid": "ABEA",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "MUNI",
        "mpid": "ABEN",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "MUNI",
        "mpid": "ABHE",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "MUNI",
        "mpid": "ABIG",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "MUNI",
        "mpid": "ABLE",
        "clearingBroker": "0031",
        "brokerName": "NATIXIS SECURITIES AMERICAS LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "ABPI",
        "clearingBroker": "0235",
        "brokerName": "ALLIED BEACON PARTNERS, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "ABPR",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "MUNI",
        "mpid": "ABRP",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "MUNI",
        "mpid": "ABST",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "MUNI",
        "mpid": "ACAD",
        "clearingBroker": "0443",
        "brokerName": "ACADEMY SECURITIES, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "ACAP",
        "clearingBroker": "0235",
        "brokerName": "ALAMO CAPITAL                                                         "
    },
    {
        "type": "MUNI",
        "mpid": "ACCP",
        "clearingBroker": "0158",
        "brokerName": "AEGIS CAPITAL CORP.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "ACLP",
        "clearingBroker": "0235",
        "brokerName": "ALEXANDER CAPITAL, L.P.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "ACTI",
        "clearingBroker": "0443",
        "brokerName": "ACTIVNER SECURITIES, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "ADAM",
        "clearingBroker": "0161",
        "brokerName": "CANACCORD GENUITY INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "ADSO",
        "clearingBroker": "0141",
        "brokerName": "PROSPERA FINANCIAL SERVICES, INC.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "AEFS",
        "clearingBroker": "0226",
        "brokerName": "AE FINANCIAL SERVICES, LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "AETL",
        "clearingBroker": "0158",
        "brokerName": "AET INVESTMENT SERVICES, LLC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "AFBS",
        "clearingBroker": "0158",
        "brokerName": "APEX FINTECH BROKERAGE SERVICES LLC                                   "
    },
    {
        "type": "MUNI",
        "mpid": "AFCO",
        "clearingBroker": "0284",
        "brokerName": "TD PRIME SERVICES LLC                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "AFGT",
        "clearingBroker": "0052",
        "brokerName": "J. ALDEN ASSOCIATES, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "AGCO",
        "clearingBroker": "0052",
        "brokerName": "AUERBACH GRAYSON & COMPANY LLC                                        "
    },
    {
        "type": "MUNI",
        "mpid": "AGCP",
        "clearingBroker": "0052",
        "brokerName": "AEGIS CAPITAL CORP.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "AGES",
        "clearingBroker": "0750",
        "brokerName": "ADVISORY GROUP EQUITY SERVICES LTD.                                   "
    },
    {
        "type": "MUNI",
        "mpid": "AGFA",
        "clearingBroker": "0226",
        "brokerName": "VALIC FINANCIAL ADVISORS, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "AGIS",
        "clearingBroker": "0235",
        "brokerName": "AEGIS CAPITAL CORP.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "AGPM",
        "clearingBroker": "1043",
        "brokerName": "A.G.P. / ALLIANCE GLOBAL PARTNERS                                     "
    },
    {
        "type": "MUNI",
        "mpid": "AGSS",
        "clearingBroker": "0443",
        "brokerName": "GREAT AMERICAN ADVISORS, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "AHSI",
        "clearingBroker": "0141",
        "brokerName": "AMERICAN HERITAGE SECURITIES, INC.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "AIGF",
        "clearingBroker": "0443",
        "brokerName": "OSAIC WEALTH, INC.                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "AIGN",
        "clearingBroker": "0226",
        "brokerName": "OSAIC WEALTH, INC.                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "AIRS",
        "clearingBroker": "0279",
        "brokerName": "HAND SECURITIES, INC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "AISG",
        "clearingBroker": "0235",
        "brokerName": "AMERICAN INDEPENDENT SECURITIES GROUP, LLC                            "
    },
    {
        "type": "MUNI",
        "mpid": "AJCO",
        "clearingBroker": "0443",
        "brokerName": "IDB CAPITAL CORP.                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "ALAD",
        "clearingBroker": "0235",
        "brokerName": "ALLIANCE ADVISORY & SECURITIES, INC.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "ALCG",
        "clearingBroker": "0235",
        "brokerName": "ALTITUDE CAPITAL GROUP LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "ALCM",
        "clearingBroker": "0279",
        "brokerName": "ALPHALEDGER MARKETS, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "ALDN",
        "clearingBroker": "0052",
        "brokerName": "J. ALDEN ASSOCIATES, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "ALGP",
        "clearingBroker": "0235",
        "brokerName": "A.G.P. / ALLIANCE GLOBAL PARTNERS                                     "
    },
    {
        "type": "MUNI",
        "mpid": "ALIS",
        "clearingBroker": "0235",
        "brokerName": "ALEXANDER INVESTMENT SERVICES CO.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "ALLS",
        "clearingBroker": "0443",
        "brokerName": "ALLARIA SECURITIES, LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "ALNC",
        "clearingBroker": "0226",
        "brokerName": "A.G.P./ALLIANCE GLOBAL PARTNERS                                       "
    },
    {
        "type": "MUNI",
        "mpid": "ALTR",
        "clearingBroker": "3164",
        "brokerName": "ALTRUIST FINANCIAL LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "AMBB",
        "clearingBroker": "0141",
        "brokerName": "ALLEN, MOONEY & BARNES BROKERAGE SERVICES, LLC                        "
    },
    {
        "type": "MUNI",
        "mpid": "AMER",
        "clearingBroker": "0235",
        "brokerName": "AMERICAN TRUST INVESTMENT SERVICES, INC.                              "
    },
    {
        "type": "MUNI",
        "mpid": "AMGN",
        "clearingBroker": "0443",
        "brokerName": "AMERICAN GENERAL SECURITIES INCORPORATED                              "
    },
    {
        "type": "MUNI",
        "mpid": "AMIC",
        "clearingBroker": "0226",
        "brokerName": "AMERICAN INVESTORS COMPANY                                            "
    },
    {
        "type": "MUNI",
        "mpid": "AMLU",
        "clearingBroker": "3652",
        "brokerName": "LUCID CAPITAL MARKETS, LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "AMMI",
        "clearingBroker": "0443",
        "brokerName": "AM&M INVESTMENT BROKERS, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "AMMS",
        "clearingBroker": "0141",
        "brokerName": "AMUNI FINANCIAL, INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "ANDB",
        "clearingBroker": "0443",
        "brokerName": "ANDBANC BROKERAGE, LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "ANDG",
        "clearingBroker": "0235",
        "brokerName": "GARRETT (ANDREW), INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "ANOS",
        "clearingBroker": "0235",
        "brokerName": "ABEL NOSER, LLC.                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "ANOV",
        "clearingBroker": "0750",
        "brokerName": "ANOVEST FINANCIAL SERVICES, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "ANSR",
        "clearingBroker": "0443",
        "brokerName": "ANDERSON & STRUDWICK, INCORPORATED                                    "
    },
    {
        "type": "MUNI",
        "mpid": "AORP",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "MUNI",
        "mpid": "APBD",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "MUNI",
        "mpid": "APBO",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "MUNI",
        "mpid": "APFS",
        "clearingBroker": "0443",
        "brokerName": "AMERICA'S PORTFOLIO'S                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "APRT",
        "clearingBroker": "0226",
        "brokerName": "PARTNERS                                                              "
    },
    {
        "type": "MUNI",
        "mpid": "APTO",
        "clearingBroker": "0103",
        "brokerName": "APTO PARTNERS, LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "APXO",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "MUNI",
        "mpid": "APXS",
        "clearingBroker": "0052",
        "brokerName": "APEXUS CAPITAL LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "AQUB",
        "clearingBroker": "0197",
        "brokerName": "AQUA SECURITIES L.P.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "ARBC",
        "clearingBroker": "0235",
        "brokerName": "ARKADIOS CAPITAL                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "ARBR",
        "clearingBroker": "6783",
        "brokerName": "ARBOR RESEARCH & TRADING, LLC                                         "
    },
    {
        "type": "MUNI",
        "mpid": "ARGA",
        "clearingBroker": "0443",
        "brokerName": "AURIGA USA, INC.                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "ARKA",
        "clearingBroker": "0443",
        "brokerName": "ARKA SECURITIES, INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "ARKI",
        "clearingBroker": "0226",
        "brokerName": "ARKADIOS CAPITAL                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "ARTI",
        "clearingBroker": "1043",
        "brokerName": "ARBOR RESEARCH & TRADING, LLC                                         "
    },
    {
        "type": "MUNI",
        "mpid": "ARVS",
        "clearingBroker": "0443",
        "brokerName": "ARVEST WEALTH MANAGEMENT                                              "
    },
    {
        "type": "MUNI",
        "mpid": "ASCM",
        "clearingBroker": "0052",
        "brokerName": "ASCENDIANT CAPITAL MARKETS, LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "ASEL",
        "clearingBroker": "0370",
        "brokerName": "TRADITION SECURITIES AND DERIVATIVES LLC                              "
    },
    {
        "type": "MUNI",
        "mpid": "ASII",
        "clearingBroker": "0226",
        "brokerName": "AURORA SECURITIES                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "ASKR",
        "clearingBroker": "0141",
        "brokerName": "ASKAR CORP.                                                           "
    },
    {
        "type": "MUNI",
        "mpid": "ASOI",
        "clearingBroker": "0226",
        "brokerName": "ASSOCIATED INVESTMENT SERVICES, INC.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "ATIS",
        "clearingBroker": "0052",
        "brokerName": "AMERICAN TRUST INVESTMENT SERVICES, INC.                              "
    },
    {
        "type": "MUNI",
        "mpid": "ATMC",
        "clearingBroker": "0100",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "ATVT",
        "clearingBroker": "0443",
        "brokerName": "ATOMIC BROKERAGE LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "AVEN",
        "clearingBroker": "0226",
        "brokerName": "AVENTURA SECURITIES, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "AVEW",
        "clearingBroker": "8199",
        "brokerName": "AVENTURA SECURITIES, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "AVIA",
        "clearingBroker": "0443",
        "brokerName": "AVIAN SECURITIES, L.L.C.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "AVIL",
        "clearingBroker": "0158",
        "brokerName": "AVANZA CAPITAL MARKETS INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "AVSI",
        "clearingBroker": "0443",
        "brokerName": "AMERIVET SECURITIES, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "AVST",
        "clearingBroker": "0235",
        "brokerName": "ATOMIC BROKERAGE LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "AXAA",
        "clearingBroker": "0075",
        "brokerName": "AXA ADVISORS LLC                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "AXCL",
        "clearingBroker": "0052",
        "brokerName": "AXOS CLEARING LLC                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "AXIO",
        "clearingBroker": "0279",
        "brokerName": "AXIOM CAPITAL MANAGEMENT, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "AXOS",
        "clearingBroker": "0052",
        "brokerName": "AXOS CLEARING LLC                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "BAKR",
        "clearingBroker": "6069",
        "brokerName": "JAMES BAKER & ASSOCIATES, L.P.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "BALS",
        "clearingBroker": "0750",
        "brokerName": "BRUCE A. LEFAVI SECURITIES, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "BANK",
        "clearingBroker": "0701",
        "brokerName": "CETERA INVESTMENT SERVICES LLC                                        "
    },
    {
        "type": "MUNI",
        "mpid": "BARD",
        "clearingBroker": "0547",
        "brokerName": "ROBERT W. BAIRD & CO. INCORPORATED                                    "
    },
    {
        "type": "MUNI",
        "mpid": "BARR",
        "clearingBroker": "0226",
        "brokerName": "BARRETT & COMPANY                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "BAYC",
        "clearingBroker": "0161",
        "brokerName": "BAY CREST PARTNERS,  LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "BAYP",
        "clearingBroker": "0161",
        "brokerName": "BAY CREST PARTNERS, LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "BBAR",
        "clearingBroker": "0595",
        "brokerName": "BUCKMAN, BUCKMAN & REID, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "BBBI",
        "clearingBroker": "0443",
        "brokerName": "BLUEBID BROKERAGE, LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "BBCM",
        "clearingBroker": "1608",
        "brokerName": "BRYANT BANK                                                           "
    },
    {
        "type": "MUNI",
        "mpid": "BBGC",
        "clearingBroker": "0235",
        "brokerName": "GRAHAM (B.B.) & COMPANY                                               "
    },
    {
        "type": "MUNI",
        "mpid": "BBID",
        "clearingBroker": "2557",
        "brokerName": "BANKERS' BANK                                                         "
    },
    {
        "type": "MUNI",
        "mpid": "BBNI",
        "clearingBroker": "0443",
        "brokerName": "PERFORMANCE TRUST CAPITAL PARTNERS, INC.                              "
    },
    {
        "type": "MUNI",
        "mpid": "BCAP",
        "clearingBroker": "7256",
        "brokerName": "BARCLAYS CAPITAL, INC./FIXED INCOME                                   "
    },
    {
        "type": "MUNI",
        "mpid": "BCCS",
        "clearingBroker": "0443",
        "brokerName": "BAC FLORIDA INVESTMENTS CORP.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "BCIB",
        "clearingBroker": "0443",
        "brokerName": "BCI SECURITIES, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "BCLE",
        "clearingBroker": "0229",
        "brokerName": "BARCLAYS CAPITAL INC./BARCLAYS CAPITAL INC.                           "
    },
    {
        "type": "MUNI",
        "mpid": "BCPI",
        "clearingBroker": "0279",
        "brokerName": "GVC CAPITAL LLC                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "BCRK",
        "clearingBroker": "0279",
        "brokerName": "BEAR CREEK SECURITIES, LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "BCWM",
        "clearingBroker": "4077",
        "brokerName": "BETA CAPITAL SECURITIES LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "BCZC",
        "clearingBroker": "0443",
        "brokerName": "ZIEGLER (B.C.) & COMPANY                                              "
    },
    {
        "type": "MUNI",
        "mpid": "BDDK",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "BDTR",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "BEAF",
        "clearingBroker": "0235",
        "brokerName": "BEACONSFIELD FINANCIAL SERV.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "BEAL",
        "clearingBroker": "0443",
        "brokerName": "M.R. BEAL & COMPANY                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "BEAR",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "BECS",
        "clearingBroker": "0443",
        "brokerName": "BECKER & SUFFERN LTD.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "BELS",
        "clearingBroker": "0443",
        "brokerName": "BEL AIR SECURITIES LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "BERM",
        "clearingBroker": "0443",
        "brokerName": "BERMUDA INVESTMENT ADVISORY SERVICES                                  "
    },
    {
        "type": "MUNI",
        "mpid": "BERN",
        "clearingBroker": "0013",
        "brokerName": "SANFORD C. BERNSTEIN & CO., LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "BERS",
        "clearingBroker": "0235",
        "brokerName": "BESTEX RESEARCH SECURITIES, LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "BEST",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "BFCM",
        "clearingBroker": "1043",
        "brokerName": "BLUEFIN CAPITAL MANAGEMENT, LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "BFEW",
        "clearingBroker": "0443",
        "brokerName": "BILL FEW ASSOCIATES, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "BFFI",
        "clearingBroker": "0226",
        "brokerName": "BERTHEL, FISHER & COMPANY FINANCIAL SERVICES, INC.                    "
    },
    {
        "type": "MUNI",
        "mpid": "BFMA",
        "clearingBroker": "1043",
        "brokerName": "BLUEFIN CAPITAL MANAGEMENT, LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "BFSL",
        "clearingBroker": "0235",
        "brokerName": "BRIGGS-FICKS SECURITIES, LLC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "BGCF",
        "clearingBroker": "0537",
        "brokerName": "BGC FINANCIAL, L.P.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "BGHT",
        "clearingBroker": "0141",
        "brokerName": "BRIGHTON SECURITIES CORP.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "BGMI",
        "clearingBroker": "0158",
        "brokerName": "BRICKELL GLOBAL MARKETS, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "BGSG",
        "clearingBroker": "0226",
        "brokerName": "CBIZ FINANCIAL SOLUTIONS, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "BGVS",
        "clearingBroker": "0443",
        "brokerName": "BGV SECURITIES                                                        "
    },
    {
        "type": "MUNI",
        "mpid": "BHII",
        "clearingBroker": "0443",
        "brokerName": "BELLE HAVEN INVESTMENTS, LP                                           "
    },
    {
        "type": "MUNI",
        "mpid": "BHKS",
        "clearingBroker": "0141",
        "brokerName": "BHK SECURITIES, LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "BICA",
        "clearingBroker": "0443",
        "brokerName": "BEACON INVESTMENT COMPANY                                             "
    },
    {
        "type": "MUNI",
        "mpid": "BIDS",
        "clearingBroker": "0161",
        "brokerName": "BIDS TRADING L.P.                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "BIGP",
        "clearingBroker": "0443",
        "brokerName": "BROWNSTONE INVESTMENT GROUP, LLC                                      "
    },
    {
        "type": "MUNI",
        "mpid": "BIGZ",
        "clearingBroker": "0443",
        "brokerName": "BROWNSTONE INVESTMENT GROUP, LLC                                      "
    },
    {
        "type": "MUNI",
        "mpid": "BIMI",
        "clearingBroker": "0136",
        "brokerName": "INTESA SANPAOLO IMI SECURITIES CORP.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "BISI",
        "clearingBroker": "0443",
        "brokerName": "BANORTE SECURITIES INTERNATIONAL, LTD.                                "
    },
    {
        "type": "MUNI",
        "mpid": "BJCM",
        "clearingBroker": "0235",
        "brokerName": "ESSEX SECURITIES LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "BJRC",
        "clearingBroker": "0235",
        "brokerName": "CASCADE INVESTMENT GROUP, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "BKCM",
        "clearingBroker": "0443",
        "brokerName": "BNY CAPITAL MARKETS INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "BKES",
        "clearingBroker": "0443",
        "brokerName": "BNY MELLON CAPITAL MARKETS, LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "BKRT",
        "clearingBroker": "0235",
        "brokerName": "BUCKMAN, BUCKMAN & REID, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "BLEY",
        "clearingBroker": "0443",
        "brokerName": "BLEY INVESTMENT GROUP, INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "BLKB",
        "clearingBroker": "0642",
        "brokerName": "BLACKBURN & COMPANY                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "BLNI",
        "clearingBroker": "0226",
        "brokerName": "AMERITAS INVESTMENT COMPANY, LLC                                      "
    },
    {
        "type": "MUNI",
        "mpid": "BMCB",
        "clearingBroker": "0103",
        "brokerName": "BACKSTROM MCCARLEY BERRY & CO., LLC                                   "
    },
    {
        "type": "MUNI",
        "mpid": "BMKS",
        "clearingBroker": "0443",
        "brokerName": "BENCHMARK SECURITIES, LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "BMSA",
        "clearingBroker": "0443",
        "brokerName": "MARIVA CAPITAL MARKETS, LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "BMUR",
        "clearingBroker": "0443",
        "brokerName": "BREAN CAPITAL, LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "BNBB",
        "clearingBroker": "0443",
        "brokerName": "INTERCOASTAL CAPITAL MARKETS, INC.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "BNCH",
        "clearingBroker": "0235",
        "brokerName": "THE BENCHMARK COMPANY, LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "BNDI",
        "clearingBroker": "0443",
        "brokerName": "BERNARDI SECURITIES, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "BNDS",
        "clearingBroker": "0226",
        "brokerName": "MTS MARKETS INTERNATIONAL, INC                                        "
    },
    {
        "type": "MUNI",
        "mpid": "BNTE",
        "clearingBroker": "0158",
        "brokerName": "BANORTE-IXE SECURITIES INTERNATIONAL, LTD.                            "
    },
    {
        "type": "MUNI",
        "mpid": "BNYI",
        "clearingBroker": "0443",
        "brokerName": "BNY INVESTMENT CENTERS, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "BNYM",
        "clearingBroker": "8355",
        "brokerName": "BNYM/UIT NSCC CNS CLEARANCE                                           "
    },
    {
        "type": "MUNI",
        "mpid": "BNYN",
        "clearingBroker": "0226",
        "brokerName": "BANYAN SECURITIES, LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "BOFA",
        "clearingBroker": "0773",
        "brokerName": "BOFA SECURITIES, INC./FIXED INCOME                                    "
    },
    {
        "type": "MUNI",
        "mpid": "BOKI",
        "clearingBroker": "0443",
        "brokerName": "BOSC, INC.                                                            "
    },
    {
        "type": "MUNI",
        "mpid": "BOKL",
        "clearingBroker": "6752",
        "brokerName": "BANK OF OKLAHOMA                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "BOSS",
        "clearingBroker": "0158",
        "brokerName": "ALL TIME ATS                                                          "
    },
    {
        "type": "MUNI",
        "mpid": "BOYR",
        "clearingBroker": "0443",
        "brokerName": "MARK BOYAR & CO., INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "BPNS",
        "clearingBroker": "2154",
        "brokerName": "BNP PARIBAS SECURITIES CORP.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "BPSG",
        "clearingBroker": "0443",
        "brokerName": "GLEACHER & COMPANY SECURITIES, INC.                                   "
    },
    {
        "type": "MUNI",
        "mpid": "BPWP",
        "clearingBroker": "0226",
        "brokerName": "BUTTONWOOD PARTNERS, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "BRBR",
        "clearingBroker": "0279",
        "brokerName": "BROWN AND BROWN SECURITIES, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "BRCY",
        "clearingBroker": "0443",
        "brokerName": "BCP SECURITIES, LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "BRGE",
        "clearingBroker": "0052",
        "brokerName": "NEWBRIDGE SECURITIES CORPORATION                                      "
    },
    {
        "type": "MUNI",
        "mpid": "BRKE",
        "clearingBroker": "0443",
        "brokerName": "BIRKELBACH INVESTMENT SECURITIES, INC.                                "
    },
    {
        "type": "MUNI",
        "mpid": "BRLI",
        "clearingBroker": "0226",
        "brokerName": "BROWN, LISLE/CUMMINGS, INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "BRNK",
        "clearingBroker": "0226",
        "brokerName": "BRINKER CAPITAL SECURITIES, LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "BRNT",
        "clearingBroker": "0235",
        "brokerName": "H.D. BRENT & COMPANY, INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "BRRR",
        "clearingBroker": "8199",
        "brokerName": "BARRINGTON RESEARCH ASSOCIATES, INC.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "BRSA",
        "clearingBroker": "0103",
        "brokerName": "BOURSA INVESTMENT                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "BRSE",
        "clearingBroker": "0226",
        "brokerName": "BRADESCO SECURITIES, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "BRVL",
        "clearingBroker": "0443",
        "brokerName": "BLAYLOCK BEAL VAN, LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "BRWM",
        "clearingBroker": "0226",
        "brokerName": "B. RILEY WEALTH MANAGEMENT                                            "
    },
    {
        "type": "MUNI",
        "mpid": "BSAZ",
        "clearingBroker": "0103",
        "brokerName": "BERRY SHINO SECURITIES, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "BSCM",
        "clearingBroker": "0052",
        "brokerName": "BROAD STREET CAPITAL MARKETS, LLC                                     "
    },
    {
        "type": "MUNI",
        "mpid": "BSIS",
        "clearingBroker": "0443",
        "brokerName": "BANCORPSOUTH INVESTMENT SERVICES, INC.                                "
    },
    {
        "type": "MUNI",
        "mpid": "BSPI",
        "clearingBroker": "0235",
        "brokerName": "BALANCED SECURITY PLANNING, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "BSSC",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "BSTO",
        "clearingBroker": "0443",
        "brokerName": "BANESTO SECURITIES, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "BTDG",
        "clearingBroker": "0161",
        "brokerName": "BIDS TRADING LP                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "BTIM",
        "clearingBroker": "1043",
        "brokerName": "BTIG, LLC                                                             "
    },
    {
        "type": "MUNI",
        "mpid": "BTSS",
        "clearingBroker": "0279",
        "brokerName": "HILLTOP SECURITIES INDEPENDENT NETWORK INC.                           "
    },
    {
        "type": "MUNI",
        "mpid": "BURK",
        "clearingBroker": "0141",
        "brokerName": "BURKE, LAWTON, BREWER & BURKE                                         "
    },
    {
        "type": "MUNI",
        "mpid": "BUZZ",
        "clearingBroker": "0141",
        "brokerName": "HEIDTKE & COMPANY, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "BWNA",
        "clearingBroker": "0235",
        "brokerName": "BROWN ASSOCIATES INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "BYAI",
        "clearingBroker": "0226",
        "brokerName": "BRECEK & YOUNG                                                        "
    },
    {
        "type": "MUNI",
        "mpid": "BZCP",
        "clearingBroker": "0443",
        "brokerName": "BALANZ CAPITAL USA LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "BZTN",
        "clearingBroker": "0141",
        "brokerName": "ALLIANT SECURITIES, INC. TURNER, NORD, KIENBAUM                       "
    },
    {
        "type": "MUNI",
        "mpid": "BZWV",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "BZYD",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "BZYF",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "CABA",
        "clearingBroker": "0443",
        "brokerName": "CABRERA CAPITAL MARKETS, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "CABR",
        "clearingBroker": "0161",
        "brokerName": "CABRERA CAPITAL MARKETS, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "CADG",
        "clearingBroker": "0005",
        "brokerName": "WEEDEN PRIME SERVICES, LLC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "CADZ",
        "clearingBroker": "0279",
        "brokerName": "CADZ SECURITIES INC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "CAFS",
        "clearingBroker": "0158",
        "brokerName": "COMMUNITYAMERICA FINANCIAL SOLUTIONS, LLC                             "
    },
    {
        "type": "MUNI",
        "mpid": "CAGI",
        "clearingBroker": "0279",
        "brokerName": "CRESCENT SECURITIES GROUP, INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "CAIX",
        "clearingBroker": "0235",
        "brokerName": "CAIS CAPITAL LLC                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "CALD",
        "clearingBroker": "0103",
        "brokerName": "CALDWELL SUTTER CAPITAL, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "CALT",
        "clearingBroker": "0279",
        "brokerName": "CALTON & ASSOCIATES                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "CAMS",
        "clearingBroker": "0443",
        "brokerName": "COMPREHENSIVE ASSET MANAGEMENT AND SERVICING, INC.                    "
    },
    {
        "type": "MUNI",
        "mpid": "CANR",
        "clearingBroker": "0388",
        "brokerName": "CANTONE RESEARCH INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "CANT",
        "clearingBroker": "0696",
        "brokerName": "CANTOR FITZGERALD & CO.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "CAPC",
        "clearingBroker": "0235",
        "brokerName": "CAPITAL CITY SECURITIES, LLC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "CAPE",
        "clearingBroker": "0279",
        "brokerName": "CAPE SECURITIES, INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "CAPI",
        "clearingBroker": "0443",
        "brokerName": "CAPITAL ANALYSTS INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "CARL",
        "clearingBroker": "0443",
        "brokerName": "BASE SECURITIES LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "CART",
        "clearingBroker": "0443",
        "brokerName": "CARTY & COMPANY, INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "CARY",
        "clearingBroker": "0141",
        "brokerName": "CARY STREET PARTNERS                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "CATC",
        "clearingBroker": "0443",
        "brokerName": "CHICAGO ANALYTIC TRADING COMPANY, LLC                                 "
    },
    {
        "type": "MUNI",
        "mpid": "CATE",
        "clearingBroker": "0235",
        "brokerName": "CARTER, TERRY & COMPANY, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "CAVU",
        "clearingBroker": "0443",
        "brokerName": "CAVU SECURITIES LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "CBAL",
        "clearingBroker": "0443",
        "brokerName": "ACCESS SECURITIES, INC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "CBEV",
        "clearingBroker": "0226",
        "brokerName": "CITY NATIONAL BANK, BEVERLY HILLS, CALIFORNIA                         "
    },
    {
        "type": "MUNI",
        "mpid": "CBII",
        "clearingBroker": "0443",
        "brokerName": "WESBANCO SECURITIES, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "CBIN",
        "clearingBroker": "0443",
        "brokerName": "COMPASS BROKERAGE, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "CBKC",
        "clearingBroker": "2170",
        "brokerName": "COMMERCE BANK                                                         "
    },
    {
        "type": "MUNI",
        "mpid": "CBNA",
        "clearingBroker": "0950",
        "brokerName": "CITIBANK N.A./DEALER                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "CBOL",
        "clearingBroker": "0226",
        "brokerName": "MUTUAL SECURITIES, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "CBSE",
        "clearingBroker": "1043",
        "brokerName": "CAMBRIDGE INTERNATIONAL SECURITIES, LLC                               "
    },
    {
        "type": "MUNI",
        "mpid": "CBTD",
        "clearingBroker": "0226",
        "brokerName": "SYNOVOUS SECURITIES INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "CCBI",
        "clearingBroker": "6744",
        "brokerName": "COUNTRY CLUB BANK, KANSAS, KANSAS CITY, MO.                           "
    },
    {
        "type": "MUNI",
        "mpid": "CCCO",
        "clearingBroker": "0226",
        "brokerName": "CARNES CAPITAL CORPORATION                                            "
    },
    {
        "type": "MUNI",
        "mpid": "CCIG",
        "clearingBroker": "0235",
        "brokerName": "CINCAP INVESTMENT GROUP, INC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "CCMC",
        "clearingBroker": "0443",
        "brokerName": "COMMERZEBANK CAPITAL CORP.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "CCPM",
        "clearingBroker": "0595",
        "brokerName": "CAMBRIA CAPITAL, LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "CCSS",
        "clearingBroker": "0443",
        "brokerName": "CROWN CAPITAL SECURITIES, L.P.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "CERS",
        "clearingBroker": "0226",
        "brokerName": "CEROS FINANCIAL SERVICES, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "CESI",
        "clearingBroker": "0235",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "CFCO",
        "clearingBroker": "7311",
        "brokerName": "CANTOR FITZGERALD & CO.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "CFGM",
        "clearingBroker": "0235",
        "brokerName": "TRUSTMONT FINANCIAL GROUP, INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "CFGO",
        "clearingBroker": "0161",
        "brokerName": "CF GLOBAL TRADING, LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "CFGT",
        "clearingBroker": "0235",
        "brokerName": "CF GLOBAL TRADING, LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "CFII",
        "clearingBroker": "0235",
        "brokerName": "CONSOLIDATED FINANCIAL INVESTMENTS, INC.                              "
    },
    {
        "type": "MUNI",
        "mpid": "CFIN",
        "clearingBroker": "0279",
        "brokerName": "CHELSEA FINANCIAL SERVICES                                            "
    },
    {
        "type": "MUNI",
        "mpid": "CFSI",
        "clearingBroker": "0052",
        "brokerName": "CEROS FINANCIAL SERVICES, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "CFSX",
        "clearingBroker": "0794",
        "brokerName": "CF SECURED, LLC                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "CGAT",
        "clearingBroker": "0443",
        "brokerName": "CADARET, GRANT & CO., INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "CGCO",
        "clearingBroker": "0443",
        "brokerName": "CG COMPASS (USA) LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "CGLN",
        "clearingBroker": "0103",
        "brokerName": "COUGHLIN & CO                                                         "
    },
    {
        "type": "MUNI",
        "mpid": "CGMI",
        "clearingBroker": "0505",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "CHAS",
        "clearingBroker": "0164",
        "brokerName": "CHARLES SCHWAB & CO., INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "CHBC",
        "clearingBroker": "0235",
        "brokerName": "PENSERRA SECURITIES, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "CHCH",
        "clearingBroker": "0226",
        "brokerName": "CHURCHILL FINANCIAL, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "CHCK",
        "clearingBroker": "0226",
        "brokerName": "CHICKASAW SECURITIES, LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "CHDA",
        "clearingBroker": "0141",
        "brokerName": "CHAPIN, DAVIS                                                         "
    },
    {
        "type": "MUNI",
        "mpid": "CHPP",
        "clearingBroker": "0624",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "CHSI",
        "clearingBroker": "0187",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "CHUB",
        "clearingBroker": "0226",
        "brokerName": "OSAIC FS, INC.                                                        "
    },
    {
        "type": "MUNI",
        "mpid": "CICI",
        "clearingBroker": "0443",
        "brokerName": "COMMERCE BANK INVESTMENT SERVICES, INC.                               "
    },
    {
        "type": "MUNI",
        "mpid": "CICL",
        "clearingBroker": "0141",
        "brokerName": "CAROLINAS INVESTMENT CONSULTING                                       "
    },
    {
        "type": "MUNI",
        "mpid": "CIIV",
        "clearingBroker": "0052",
        "brokerName": "CORPORATE INVESTMENTS GROUP, INC.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "CIMB",
        "clearingBroker": "0005",
        "brokerName": "CIMB SECURITIES (USA), INC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "CINV",
        "clearingBroker": "0158",
        "brokerName": "CORPORATE INVESTMENTS GROUP, INC.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "CIRI",
        "clearingBroker": "0443",
        "brokerName": "CAMBRIDGE INVESTMENT RESEARCH, INC.                                   "
    },
    {
        "type": "MUNI",
        "mpid": "CISI",
        "clearingBroker": "0352",
        "brokerName": "CHASE INVESTMENT SERVICES CORP.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "CIST",
        "clearingBroker": "0161",
        "brokerName": "CAPITAL INSTITUTIONAL SERVICES, INC.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "CISV",
        "clearingBroker": "0226",
        "brokerName": "CITIZENS SECURITIES, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "CLDN",
        "clearingBroker": "0235",
        "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "CLRK",
        "clearingBroker": "0235",
        "brokerName": "CLARK DODGE & CO, INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "CLRT",
        "clearingBroker": "1043",
        "brokerName": "ARBOR RESEARCH & TRADING, LLC                                         "
    },
    {
        "type": "MUNI",
        "mpid": "CLSA",
        "clearingBroker": "0161",
        "brokerName": "CLSA AMERICAS, LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "CLSS",
        "clearingBroker": "0443",
        "brokerName": "CABOT LODGE SECURITIES LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "CLTN",
        "clearingBroker": "0226",
        "brokerName": "CALTON & ASSOCIATES, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "CLYN",
        "clearingBroker": "0443",
        "brokerName": "CARLIN EQUITIES, LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "CMCE",
        "clearingBroker": "0226",
        "brokerName": "COMMERCE BROKERAGE SERVICES                                           "
    },
    {
        "type": "MUNI",
        "mpid": "CMCX",
        "clearingBroker": "0624",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC                                   "
    },
    {
        "type": "MUNI",
        "mpid": "CMGF",
        "clearingBroker": "0443",
        "brokerName": "CMG SECURITIES LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "CMMB",
        "clearingBroker": "2781",
        "brokerName": "U.S. BANK N.A./U.S. BANK MUNICIPAL SECURITIES GROUP                   "
    },
    {
        "type": "MUNI",
        "mpid": "CMMW",
        "clearingBroker": "0226",
        "brokerName": "COMMONWEALTH FINANCIAL NETWORK                                        "
    },
    {
        "type": "MUNI",
        "mpid": "CNCD",
        "clearingBroker": "0235",
        "brokerName": "CONCORDE INVESTMENT SERVICES, LLC                                     "
    },
    {
        "type": "MUNI",
        "mpid": "CNFI",
        "clearingBroker": "0443",
        "brokerName": "CENTAURUS FINANCIAL INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "CNFR",
        "clearingBroker": "0443",
        "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "CNSI",
        "clearingBroker": "0226",
        "brokerName": "CITY NATIONAL SECURITIES, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "COAK",
        "clearingBroker": "0443",
        "brokerName": "CASTLE OAK SECURITIES, L.P.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "COAS",
        "clearingBroker": "0443",
        "brokerName": "REALTA EQUITIES, INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "CODA",
        "clearingBroker": "0161",
        "brokerName": "CODA MARKETS, INC.                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "COEI",
        "clearingBroker": "0052",
        "brokerName": "COASTAL EQUITIES, INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "COEX",
        "clearingBroker": "0161",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "COFS",
        "clearingBroker": "0279",
        "brokerName": "COLORADO FINANCIAL SERVICE CORPORATION                                "
    },
    {
        "type": "MUNI",
        "mpid": "COHN",
        "clearingBroker": "0235",
        "brokerName": "COHEN BROS. & COMPANY                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "COLS",
        "clearingBroker": "0279",
        "brokerName": "COLONIAL SECURITIES INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "COMP",
        "clearingBroker": "0595",
        "brokerName": "COMPASS POINT RESEARCH & TRADING, LLC                                 "
    },
    {
        "type": "MUNI",
        "mpid": "CONI",
        "clearingBroker": "0235",
        "brokerName": "CONTINENTAL INVESTORS SERVICES, INC.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "CONS",
        "clearingBroker": "0141",
        "brokerName": "CONSULTIVA SECURITIES, INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "COOR",
        "clearingBroker": "0141",
        "brokerName": "COORDINATED CAPITAL SECURITIES, INC.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "COWN",
        "clearingBroker": "0100",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "COWP",
        "clearingBroker": "0226",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "COWX",
        "clearingBroker": "0161",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "COYL",
        "clearingBroker": "0235",
        "brokerName": "COYLE SECURITIES LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "CPAM",
        "clearingBroker": "0141",
        "brokerName": "CAPITAL SECURITIES OF AMERICA, INC.                                   "
    },
    {
        "type": "MUNI",
        "mpid": "CPEM",
        "clearingBroker": "0161",
        "brokerName": "CLEARPOOL EXECUTION SERVICES, LLC                                     "
    },
    {
        "type": "MUNI",
        "mpid": "CPGL",
        "clearingBroker": "0226",
        "brokerName": "CONTINUITY PARTNERS GROUP, LLC                                        "
    },
    {
        "type": "MUNI",
        "mpid": "CPLC",
        "clearingBroker": "0595",
        "brokerName": "COVA CAPITAL PARTNERS LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "CPPM",
        "clearingBroker": "0443",
        "brokerName": "COKER & PALMER                                                        "
    },
    {
        "type": "MUNI",
        "mpid": "CPRC",
        "clearingBroker": "0235",
        "brokerName": "CORINTHIAN PARTNERS, L.L.C.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "CPRM",
        "clearingBroker": "8199",
        "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "CQSI",
        "clearingBroker": "0443",
        "brokerName": "CAPITALQUEST SECURITIES, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "CRCM",
        "clearingBroker": "0235",
        "brokerName": "COHNREZNICK CAPITAL                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "CRDL",
        "clearingBroker": "0235",
        "brokerName": "CARDINAL INVESTMENTS, INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "CRED",
        "clearingBroker": "0443",
        "brokerName": "CREDICORP CAPITAL LLC                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "CREF",
        "clearingBroker": "0443",
        "brokerName": "TIAA-CREF INDIVIDUAL AND INSTITUTIONAL SERVICES, LLC                  "
    },
    {
        "type": "MUNI",
        "mpid": "CREW",
        "clearingBroker": "0443",
        "brokerName": "CREWS & ASSOCIATES, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "CRII",
        "clearingBroker": "0443",
        "brokerName": "CRI SECURITIES INC.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "CRIS",
        "clearingBroker": "0443",
        "brokerName": "CARIS & COMPANY, INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "CRNJ",
        "clearingBroker": "0103",
        "brokerName": "CANTONE RESEARCH                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "CRON",
        "clearingBroker": "0443",
        "brokerName": "CRONIN & CO., INC.                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "CRPT",
        "clearingBroker": "0235",
        "brokerName": "CROSS POINT CAPITAL LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "CRRT",
        "clearingBroker": "0443",
        "brokerName": "BREAN MURRAY, CARRET & CO., LLC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "CRTH",
        "clearingBroker": "0443",
        "brokerName": "CORINTHIAN PARTNERS, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "CRYN",
        "clearingBroker": "0235",
        "brokerName": "BRENDAN E. CRYAN AND COMPANY, L.L.C.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "CSAI",
        "clearingBroker": "0793",
        "brokerName": "STIFEL INDEPENDENT ADVISORS, LLC                                      "
    },
    {
        "type": "MUNI",
        "mpid": "CSCA",
        "clearingBroker": "4264",
        "brokerName": "ICE BONDS SECURITIES CORPORATION                                      "
    },
    {
        "type": "MUNI",
        "mpid": "CSCB",
        "clearingBroker": "0161",
        "brokerName": "COMPUTERSHARE SECURITIES, CORP.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "CSCM",
        "clearingBroker": "0279",
        "brokerName": "CENTRAL STATES CAPITAL MARKETS, LLC                                   "
    },
    {
        "type": "MUNI",
        "mpid": "CSFL",
        "clearingBroker": "6770",
        "brokerName": "SOUTH STATE BANK, NATIONAL ASSOCIATION                                "
    },
    {
        "type": "MUNI",
        "mpid": "CSIB",
        "clearingBroker": "0443",
        "brokerName": "RBC CENTURA SECURITIES, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "CSII",
        "clearingBroker": "0443",
        "brokerName": "COMMONWEALTH SECURITIES AND INVESTMENTS, INC.                         "
    },
    {
        "type": "MUNI",
        "mpid": "CSIN",
        "clearingBroker": "0161",
        "brokerName": "CITADEL SECURITIES INSTITUTIONAL LLC                                  "
    },
    {
        "type": "MUNI",
        "mpid": "CSOA",
        "clearingBroker": "0443",
        "brokerName": "CLEARING SERVICES OF AMERICA                                          "
    },
    {
        "type": "MUNI",
        "mpid": "CSPA",
        "clearingBroker": "0226",
        "brokerName": "CREDIT SUISSE PRIVATE ADVISORS                                        "
    },
    {
        "type": "MUNI",
        "mpid": "CSPD",
        "clearingBroker": "0197",
        "brokerName": "CANTOR FITZGERALD & CO.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "CSPI",
        "clearingBroker": "0235",
        "brokerName": "CAPITAL SYNERGY PARTNERS                                              "
    },
    {
        "type": "MUNI",
        "mpid": "CSTI",
        "clearingBroker": "0161",
        "brokerName": "CANACCORD GENUITY INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "CTBK",
        "clearingBroker": "4270",
        "brokerName": "CENTRAL TRUST BANK                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "CTNL",
        "clearingBroker": "0235",
        "brokerName": "CENTENNIAL SECURITIES COMPANY LLC                                     "
    },
    {
        "type": "MUNI",
        "mpid": "CTSC",
        "clearingBroker": "4264",
        "brokerName": "ICE BONDS SECURITIES CORPORATION                                      "
    },
    {
        "type": "MUNI",
        "mpid": "CUEF",
        "clearingBroker": "0443",
        "brokerName": "CUE FINANCIAL GROUP, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "CUFT",
        "clearingBroker": "0226",
        "brokerName": "FROST BROKERAGE SERVICES, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "CUSO",
        "clearingBroker": "0443",
        "brokerName": "CUSO FINANCIAL SERVICES, L.P.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "CUTW",
        "clearingBroker": "0235",
        "brokerName": "PROSPERA FINANCIAL SERVICES, INC.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "CUWB",
        "clearingBroker": "0103",
        "brokerName": "DRIVEWEALTH INSTITUTIONAL, LLC                                        "
    },
    {
        "type": "MUNI",
        "mpid": "CWEI",
        "clearingBroker": "0443",
        "brokerName": "BEECH HILL SECURITIES, INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "CWMK",
        "clearingBroker": "0438",
        "brokerName": "CIBC WORLD MARKETS CORP.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "DADA",
        "clearingBroker": "0361",
        "brokerName": "D. A. DAVIDSON & CO.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "DAGH",
        "clearingBroker": "0443",
        "brokerName": "DAUGHERTY COLE, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "DAIS",
        "clearingBroker": "0052",
        "brokerName": "DAI SECURITIES, LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "DARA",
        "clearingBroker": "0235",
        "brokerName": "DARWOOD ASSOCIATES, INC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "DART",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "DASH",
        "clearingBroker": "0161",
        "brokerName": "DASH FINANCIAL TECHNOLOGIES LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "DAVA",
        "clearingBroker": "0443",
        "brokerName": "DAVENPORT & COMPANY LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "DAWA",
        "clearingBroker": "0647",
        "brokerName": "DAIWA CAPITAL MARKETS AMERICA INC.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "DBAB",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "DBCC",
        "clearingBroker": "0235",
        "brokerName": "D. BORAL CAPITAL                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "DBCH",
        "clearingBroker": "0052",
        "brokerName": "D. BORAL CAPITAL                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "DBIB",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "DBKS",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "DBMC",
        "clearingBroker": "0725",
        "brokerName": "D.B. MCKENNA & CO., INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "DBPC",
        "clearingBroker": "0443",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "DCAN",
        "clearingBroker": "0279",
        "brokerName": "R. M. DUNCAN SECURITIES, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "DCSD",
        "clearingBroker": "0235",
        "brokerName": "DAIN CORRESPONDENT SERVICES                                           "
    },
    {
        "type": "MUNI",
        "mpid": "DCVL",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "DEAN",
        "clearingBroker": "0015",
        "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "DEFA",
        "clearingBroker": "0443",
        "brokerName": "JEFFERIES LLC                                                         "
    },
    {
        "type": "MUNI",
        "mpid": "DEGS",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "DELA",
        "clearingBroker": "0443",
        "brokerName": "DELAFIELD & HAMBRECHT, INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "DEMF",
        "clearingBroker": "0443",
        "brokerName": "DEMPSEY FINANCIAL NETWORK                                             "
    },
    {
        "type": "MUNI",
        "mpid": "DENI",
        "clearingBroker": "0279",
        "brokerName": "H.C. DENISON CO.                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "DETF",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "DIDI",
        "clearingBroker": "0443",
        "brokerName": "DWS INVESTMENT DISTRIBUTORS INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "DIGG",
        "clearingBroker": "0595",
        "brokerName": "BOUSTEAD SECURITIES, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "DINO",
        "clearingBroker": "0103",
        "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
    },
    {
        "type": "MUNI",
        "mpid": "DKEI",
        "clearingBroker": "0141",
        "brokerName": "DALE K. EHRHART, INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "DLAI",
        "clearingBroker": "0235",
        "brokerName": "DAVID LERNER ASSOCIATES, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "DLPS",
        "clearingBroker": "0595",
        "brokerName": "DLP SECURITIES,.LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "DLSI",
        "clearingBroker": "0226",
        "brokerName": "DEMPSEY LORD SMITH, LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "DLTA",
        "clearingBroker": "0161",
        "brokerName": "DEALERWEB INC.                                                        "
    },
    {
        "type": "MUNI",
        "mpid": "DMCD",
        "clearingBroker": "0279",
        "brokerName": "MCDERMOTT INVESTMENT SERVICES, LLC                                    "
    },
    {
        "type": "MUNI",
        "mpid": "DMKC",
        "clearingBroker": "0141",
        "brokerName": "D.M. KELLY & COMPANY                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "DNOR",
        "clearingBroker": "0005",
        "brokerName": "DNB MARKETS, INC.                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "DNSR",
        "clearingBroker": "0158",
        "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
    },
    {
        "type": "MUNI",
        "mpid": "DNWL",
        "clearingBroker": "0443",
        "brokerName": "DUNCAN & WILLIAMS, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "DOFT",
        "clearingBroker": "0443",
        "brokerName": "DOFT & CO., INC.                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "DOMI",
        "clearingBroker": "0279",
        "brokerName": "DOMINION INVESTOR SERVICES, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "DOMK",
        "clearingBroker": "0443",
        "brokerName": "DOMINICK & DOMINICK LLC/CDS                                           "
    },
    {
        "type": "MUNI",
        "mpid": "DOMS",
        "clearingBroker": "0235",
        "brokerName": "DOMINARI SECURITIES LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "DOTC",
        "clearingBroker": "0226",
        "brokerName": "COLLIERS SECURITIES LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "DOVE",
        "clearingBroker": "0226",
        "brokerName": "SECURITIES EQUITY GROUP                                               "
    },
    {
        "type": "MUNI",
        "mpid": "DOWD",
        "clearingBroker": "0161",
        "brokerName": "WALTER J. DOWD, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "DRAT",
        "clearingBroker": "0571",
        "brokerName": "DRATEL GROUP (THE)                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "DREX",
        "clearingBroker": "0443",
        "brokerName": "DREXEL HAMILTON, LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "DRTG",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "DRTR",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "DRVW",
        "clearingBroker": "0235",
        "brokerName": "DRIVEWEALTH, LLC                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "DRWM",
        "clearingBroker": "0005",
        "brokerName": "DRW SECURITIES, L.L.C.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "DSGG",
        "clearingBroker": "0226",
        "brokerName": "DMG SECURITIES, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "DSTR",
        "clearingBroker": "0443",
        "brokerName": "DESTRA CAPITAL INVESTMENTS LLC                                        "
    },
    {
        "type": "MUNI",
        "mpid": "DTAP",
        "clearingBroker": "0161",
        "brokerName": "DIRECT TRADING INSTITUTIONAL L.P.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "DTEX",
        "clearingBroker": "0235",
        "brokerName": "INSTITUTIONAL SECURITIES CORPORATION                                  "
    },
    {
        "type": "MUNI",
        "mpid": "DUST",
        "clearingBroker": "0161",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "DVES",
        "clearingBroker": "0005",
        "brokerName": "DV EQUITIES                                                           "
    },
    {
        "type": "MUNI",
        "mpid": "DWFN",
        "clearingBroker": "0443",
        "brokerName": "DEWAY FINANCIAL NETWORK, LLC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "DWIZ",
        "clearingBroker": "0235",
        "brokerName": "DRIVEWEALTH INSTITUTIONAL LLC                                         "
    },
    {
        "type": "MUNI",
        "mpid": "EAMC",
        "clearingBroker": "0235",
        "brokerName": "EMPIRE ASSET MANAGEMENT COMPANY                                       "
    },
    {
        "type": "MUNI",
        "mpid": "EAMG",
        "clearingBroker": "0235",
        "brokerName": "EMPIRE ASSET MANAGEMENT COMPANY                                       "
    },
    {
        "type": "MUNI",
        "mpid": "EAST",
        "clearingBroker": "6742",
        "brokerName": "EASTERN BANK CAPITAL MARKETS                                          "
    },
    {
        "type": "MUNI",
        "mpid": "EBRD",
        "clearingBroker": "0103",
        "brokerName": "EARLYBIRD CAPITAL, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "ECCC",
        "clearingBroker": "0226",
        "brokerName": "EAGLES COAST CAPITAL, LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "ECUT",
        "clearingBroker": "0100",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "EDFC",
        "clearingBroker": "0443",
        "brokerName": "E D & F MAN CAPITAL MARKETS INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "EDJO",
        "clearingBroker": "0057",
        "brokerName": "EDWARD D. JONES & CO.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "EDLR",
        "clearingBroker": "0103",
        "brokerName": "DE LA ROSA (E.J.) & CO., INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "EGLE",
        "clearingBroker": "1043",
        "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
    },
    {
        "type": "MUNI",
        "mpid": "EGMT",
        "clearingBroker": "0005",
        "brokerName": "EG MARKET TECHNOLOGIES LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "ELEQ",
        "clearingBroker": "0551",
        "brokerName": "ELEQUIN SECURITIES LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "ELEV",
        "clearingBroker": "0235",
        "brokerName": "ELEVATION, LLC                                                        "
    },
    {
        "type": "MUNI",
        "mpid": "ELQN",
        "clearingBroker": "0443",
        "brokerName": "ELEQUIN SECURITIES LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "EMOC",
        "clearingBroker": "0750",
        "brokerName": "E. MAGNUS OPPENHIEM & CO. INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "EMPR",
        "clearingBroker": "0279",
        "brokerName": "SELKIRK INVESTMENTS, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "ENTR",
        "clearingBroker": "0235",
        "brokerName": "ENTRUSTODY FINANCIAL, LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "EPIC",
        "clearingBroker": "0443",
        "brokerName": "EPIC CAPITAL SECURITIES                                               "
    },
    {
        "type": "MUNI",
        "mpid": "EQHA",
        "clearingBroker": "0075",
        "brokerName": "EQUITABLE ADVISORS, LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "EQSV",
        "clearingBroker": "0226",
        "brokerName": "EQUITY SERVICES, INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "EQUA",
        "clearingBroker": "0443",
        "brokerName": "EQUITAS AMERICA, L.L.C.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "ESBD",
        "clearingBroker": "0235",
        "brokerName": "EASTDIL SECURED ADVISORS LLC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "ESHC",
        "clearingBroker": "0443",
        "brokerName": "FIRST SOUTHERN, LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "ESUS",
        "clearingBroker": "0443",
        "brokerName": "EVOLUTION SECURITIES US INC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "ETCB",
        "clearingBroker": "3505",
        "brokerName": "ETC BROKERAGE SERVICES, LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "ETCL",
        "clearingBroker": "0015",
        "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "ETRF",
        "clearingBroker": "0161",
        "brokerName": "G1 EXECUTION SERVICES, LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "ETRS",
        "clearingBroker": "0015",
        "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "EVOL",
        "clearingBroker": "0226",
        "brokerName": "EVOLVE SECURITIES, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "EWMX",
        "clearingBroker": "0279",
        "brokerName": "EAST WEST MARKETS, LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "EXCS",
        "clearingBroker": "0443",
        "brokerName": "EXCEL SECURITIES AND ASSOCIATES, INC.                                 "
    },
    {
        "type": "MUNI",
        "mpid": "EXCU",
        "clearingBroker": "0443",
        "brokerName": "XCU CAPITAL CORPORATION, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "FACA",
        "clearingBroker": "0443",
        "brokerName": "FINANCIAL ASSETS CORPORATION                                          "
    },
    {
        "type": "MUNI",
        "mpid": "FAFT",
        "clearingBroker": "0161",
        "brokerName": "FACTFET SYSTEMS, INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "FALC",
        "clearingBroker": "0103",
        "brokerName": "FALCON SQUARE CAPITAL, LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "FAMI",
        "clearingBroker": "0235",
        "brokerName": "FIRST AMERICAN MUNICIPALS, INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "FARA",
        "clearingBroker": "8199",
        "brokerName": "FARINA & ASSOCIATES, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "FATS",
        "clearingBroker": "0443",
        "brokerName": "FIRST BROKERS SECURITIES LLC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "FBLM",
        "clearingBroker": "0235",
        "brokerName": "FBL MARKETING SERVICES LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "FBLT",
        "clearingBroker": "8199",
        "brokerName": "FIRST BALLANTYNE, LLC                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "FBNS",
        "clearingBroker": "0235",
        "brokerName": "FBN SECURITIES, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "FBPC",
        "clearingBroker": "0443",
        "brokerName": "CREDIT SUISSE SECURITIES (USA) LLC                                    "
    },
    {
        "type": "MUNI",
        "mpid": "FBSB",
        "clearingBroker": "0280",
        "brokerName": "U.S. BANCORP INVESTMENTS, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "FCCP",
        "clearingBroker": "0141",
        "brokerName": "WELLS FARGO CLEARING SERVICES, LLC                                    "
    },
    {
        "type": "MUNI",
        "mpid": "FCIT",
        "clearingBroker": "0443",
        "brokerName": "FIRST CITIZENS INVESTOR SERVICES, INC.                                "
    },
    {
        "type": "MUNI",
        "mpid": "FCML",
        "clearingBroker": "0279",
        "brokerName": "FNBB CAPITAL MARKETS, LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "FCMP",
        "clearingBroker": "0595",
        "brokerName": "PRIME EXECUTIONS, INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "FDMI",
        "clearingBroker": "0571",
        "brokerName": "FREEDOM INVESTMENTS, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "FDSC",
        "clearingBroker": "0158",
        "brokerName": "1ST DISCOUNT BROKERAGE INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "FDSI",
        "clearingBroker": "0141",
        "brokerName": "FIRST DALLAS SECURITIES, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "FENX",
        "clearingBroker": "0595",
        "brokerName": "FENIX SECURITIES, LLC                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "FFCI",
        "clearingBroker": "0443",
        "brokerName": "FRONTIER FINANCIAL CONSULTANTS, INC.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "FFCM",
        "clearingBroker": "0235",
        "brokerName": "FOREFRONT CAPITAL MARKETS LLC                                         "
    },
    {
        "type": "MUNI",
        "mpid": "FFGI",
        "clearingBroker": "0235",
        "brokerName": "FELDSTEIN FINANCIAL GROUP, LLC                                        "
    },
    {
        "type": "MUNI",
        "mpid": "FFPS",
        "clearingBroker": "0443",
        "brokerName": "FFP SECURITIES                                                        "
    },
    {
        "type": "MUNI",
        "mpid": "FGOE",
        "clearingBroker": "0226",
        "brokerName": "FIRST GEORGETOWN SECURITIES, INC.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "FHCI",
        "clearingBroker": "0443",
        "brokerName": "FIRST HEARTLAND CAPITAL, INC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "FHON",
        "clearingBroker": "0235",
        "brokerName": "FIRST HONOLULU SECURITIES INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "FIAF",
        "clearingBroker": "0443",
        "brokerName": "FLORIDA INVESTMENT ADVISERS                                           "
    },
    {
        "type": "MUNI",
        "mpid": "FIBS",
        "clearingBroker": "0226",
        "brokerName": "FIDELITY BROKERAGE SERVICES LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "FINC",
        "clearingBroker": "0443",
        "brokerName": "AWM SECURITIES, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "FISA",
        "clearingBroker": "0443",
        "brokerName": "ADVISORS ASSET MANAGEMENT, INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "FISB",
        "clearingBroker": "0226",
        "brokerName": "ADVISORS ASSET MANAGEMENT, INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "FISH",
        "clearingBroker": "0235",
        "brokerName": "L.B. FISHER & COMPANY                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "FITE",
        "clearingBroker": "0443",
        "brokerName": "FORESIGHT INVESTMENTS, LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "FJRF",
        "clearingBroker": "0052",
        "brokerName": "PARITER SECURITIES, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "FKSC",
        "clearingBroker": "0235",
        "brokerName": "FIRST KENTUCKY SECURITIES CORP.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "FLAT",
        "clearingBroker": "0226",
        "brokerName": "FLORIDA ATLANTIC SECURITIES CORP.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "FLEX",
        "clearingBroker": "0158",
        "brokerName": "GWM GROUP, INC.                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "FLIB",
        "clearingBroker": "0235",
        "brokerName": "FIRST LIBERTIES FINANCIAL                                             "
    },
    {
        "type": "MUNI",
        "mpid": "FLOU",
        "clearingBroker": "0443",
        "brokerName": "FIRST ST. LOUIS SECURITIES, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "FLTL",
        "clearingBroker": "0235",
        "brokerName": "FELTL & COMPANY                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "FLTU",
        "clearingBroker": "0551",
        "brokerName": "FLOW TRADERS US LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "FLWT",
        "clearingBroker": "0161",
        "brokerName": "FLOW TRADERS U.S. INSTITUTIONAL TRADING LLC                           "
    },
    {
        "type": "MUNI",
        "mpid": "FMAT",
        "clearingBroker": "0608",
        "brokerName": "SG AMERICAS SECURITIES, LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "FMCO",
        "clearingBroker": "0443",
        "brokerName": "FIRST MANHATTAN CO.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "FMFS",
        "clearingBroker": "0226",
        "brokerName": "FISRT MERIT FINANCIAL SERVICES, INC                                   "
    },
    {
        "type": "MUNI",
        "mpid": "FMGT",
        "clearingBroker": "0443",
        "brokerName": "FAMILY MANAGEMENT SECURITIES, LLC                                     "
    },
    {
        "type": "MUNI",
        "mpid": "FNBB",
        "clearingBroker": "6753",
        "brokerName": "FIRST NATIONAL BANKERS BANK                                           "
    },
    {
        "type": "MUNI",
        "mpid": "FNET",
        "clearingBroker": "0141",
        "brokerName": "WACHOVIA SECURITIES FINANCIAL NETWORK, LLC                            "
    },
    {
        "type": "MUNI",
        "mpid": "FNFD",
        "clearingBroker": "0443",
        "brokerName": "FOLGER NOLAN FLEMING DOUGLAS INCORPORATED                             "
    },
    {
        "type": "MUNI",
        "mpid": "FNIC",
        "clearingBroker": "0443",
        "brokerName": "FINANCIAL NETWORK INVESTMENT CORP.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "FNSJ",
        "clearingBroker": "0443",
        "brokerName": "FINANCIAL NORTHEASTERN SECURITIES, INC.                               "
    },
    {
        "type": "MUNI",
        "mpid": "FOGS",
        "clearingBroker": "0235",
        "brokerName": "FOG EQUITIES LLC                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "FORD",
        "clearingBroker": "0052",
        "brokerName": "THINKEQUITY, LLC                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "FORT",
        "clearingBroker": "0443",
        "brokerName": "FORTE SECURITIES LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "FRLZ",
        "clearingBroker": "0103",
        "brokerName": "FRIEDMAN LUZZATTO & CO                                                "
    },
    {
        "type": "MUNI",
        "mpid": "FROS",
        "clearingBroker": "6751",
        "brokerName": "FROST BANK                                                            "
    },
    {
        "type": "MUNI",
        "mpid": "FRSE",
        "clearingBroker": "0443",
        "brokerName": "FRANKLIN SECURITIES, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "FSCN",
        "clearingBroker": "0226",
        "brokerName": "OSAIC WEALTH, INC.                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "FSCS",
        "clearingBroker": "0443",
        "brokerName": "OSAIC WEALTH, INC.                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "FSEC",
        "clearingBroker": "0161",
        "brokerName": "FRS SECURITIES, LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "FSFA",
        "clearingBroker": "0443",
        "brokerName": "FIRST SECURITY FINANCIAL ADVISORS, INC.                               "
    },
    {
        "type": "MUNI",
        "mpid": "FSRP",
        "clearingBroker": "0443",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "FSST",
        "clearingBroker": "0443",
        "brokerName": "FRANKLIN STREET SECURITIES, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "FTCM",
        "clearingBroker": "2445",
        "brokerName": "FHN FINANCIAL CAPITAL MARKETS A DIVISION OF FIRST HORIZON BANK-DTC 244"
    },
    {
        "type": "MUNI",
        "mpid": "FTEN",
        "clearingBroker": "0226",
        "brokerName": "FTB ADVISORS, INC.                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "FTLP",
        "clearingBroker": "8244",
        "brokerName": "FIRST TRUST PORTFOLIOS, L.P.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "FTSC",
        "clearingBroker": "0202",
        "brokerName": "FHN FINANCIAL SECURITIES CORP.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "FTSR",
        "clearingBroker": "0226",
        "brokerName": "FIFTH THIRD SECURITIES, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "FUJI",
        "clearingBroker": "0443",
        "brokerName": "MIZUHO SECURITIES USA INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "FWCO",
        "clearingBroker": "0443",
        "brokerName": "FIRST WASHINGTON CORPORATION                                          "
    },
    {
        "type": "MUNI",
        "mpid": "FWSI",
        "clearingBroker": "0141",
        "brokerName": "FIRST WESTERN SECURITIES, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "GABE",
        "clearingBroker": "0141",
        "brokerName": "G. RESEARCH, INC.                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "GAFI",
        "clearingBroker": "0235",
        "brokerName": "GARDNER FINANCIAL SERVICES INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "GARB",
        "clearingBroker": "0148",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC                                   "
    },
    {
        "type": "MUNI",
        "mpid": "GARC",
        "clearingBroker": "0161",
        "brokerName": "ICAP CORPORATES LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "GARQ",
        "clearingBroker": "0161",
        "brokerName": "ICAP CORPORATES, LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "GARR",
        "clearingBroker": "0226",
        "brokerName": "GARRETT NAGLE & CO., INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "GARW",
        "clearingBroker": "0595",
        "brokerName": "GAR WOOD SECURITIES, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "GBMT",
        "clearingBroker": "0443",
        "brokerName": "GBM INTERNATIONAL, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "GBSI",
        "clearingBroker": "0443",
        "brokerName": "GREENTREE BROKERAGE SERVICES, INC.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "GBTS",
        "clearingBroker": "0005",
        "brokerName": "GTS SECURITIES, LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "GCMC",
        "clearingBroker": "0443",
        "brokerName": "GLADOWSKY CAPITAL MANAGEMENT CORP.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "GCMT",
        "clearingBroker": "0443",
        "brokerName": "GOLD CAPITAL MANAGEMENT, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "GDCO",
        "clearingBroker": "0443",
        "brokerName": "GILBERT, DONIGER CO., INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "GFBD",
        "clearingBroker": "0226",
        "brokerName": "G. F. INVESTMENT SERVICES, LLC                                        "
    },
    {
        "type": "MUNI",
        "mpid": "GFIG",
        "clearingBroker": "0537",
        "brokerName": "GFI SECURITIES LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "GFSI",
        "clearingBroker": "0443",
        "brokerName": "GLOBAL FINANCIAL SERVICES, L.L.C.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "GGWI",
        "clearingBroker": "0141",
        "brokerName": "GAGE-WILEY & COMPANY INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "GHCC",
        "clearingBroker": "0226",
        "brokerName": "GORDON, HASKETT CAPITAL CORPORATION                                   "
    },
    {
        "type": "MUNI",
        "mpid": "GILG",
        "clearingBroker": "0226",
        "brokerName": "GILDER GAGNON HOWE & CO. LLC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "GJSS",
        "clearingBroker": "0235",
        "brokerName": "SCHWARTZ, GREGORY J & CO. INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "GLBZ",
        "clearingBroker": "0443",
        "brokerName": "ONLINE BROKERAGE SERVICES                                             "
    },
    {
        "type": "MUNI",
        "mpid": "GLII",
        "clearingBroker": "5005",
        "brokerName": "TD SECURITIES INC./CDS                                                "
    },
    {
        "type": "MUNI",
        "mpid": "GLIR",
        "clearingBroker": "5021",
        "brokerName": "TD WATERHOUSE CANADA INC. #5/CDS                                      "
    },
    {
        "type": "MUNI",
        "mpid": "GLLL",
        "clearingBroker": "0279",
        "brokerName": "GILL CAPITAL PARTNERS                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "GLYN",
        "clearingBroker": "0443",
        "brokerName": "GLYNN (J.A.) & CO.                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "GMSG",
        "clearingBroker": "0443",
        "brokerName": "GMS GROUP (THE), L.L.C.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "GPCA",
        "clearingBroker": "0158",
        "brokerName": "GREAT POINT CAPITAL LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "GPCG",
        "clearingBroker": "0443",
        "brokerName": "GREENMAN, PARKER, CONNALLY, GREENMAN, INC.                            "
    },
    {
        "type": "MUNI",
        "mpid": "GPSS",
        "clearingBroker": "0443",
        "brokerName": "GREAT PACIFIC SECURITIES                                              "
    },
    {
        "type": "MUNI",
        "mpid": "GRBD",
        "clearingBroker": "0052",
        "brokerName": "GREENBIRD CAPITAL LLC                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "GRCF",
        "clearingBroker": "0443",
        "brokerName": "GREATER COMMUNITY FINANCIAL L.L.C.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "GRIN",
        "clearingBroker": "0443",
        "brokerName": "SANDGRAIN SECURITIES, INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "GROD",
        "clearingBroker": "0226",
        "brokerName": "GRODSKY ASSOCIATES, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "GRPS",
        "clearingBroker": "0226",
        "brokerName": "MML INVESTORS SERVICES, LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "GRWC",
        "clearingBroker": "0443",
        "brokerName": "GRW CAPITAL CORPORATION                                               "
    },
    {
        "type": "MUNI",
        "mpid": "GRWD",
        "clearingBroker": "0052",
        "brokerName": "GAR WOOD SECURITIES, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "GRYG",
        "clearingBroker": "0226",
        "brokerName": "GOLDBERG (GARY) & CO., INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "GSAD",
        "clearingBroker": "0235",
        "brokerName": "GATTEN SADOWSKI INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "GSBI",
        "clearingBroker": "0279",
        "brokerName": "GLOBAL BROKERAGE SERVICES, INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "GSCO",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "GSIL",
        "clearingBroker": "0158",
        "brokerName": "GLOBAL STRATEGIC INVESTMENTS, LLC                                     "
    },
    {
        "type": "MUNI",
        "mpid": "GSMM",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "GSQQ",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "GSRI",
        "clearingBroker": "0443",
        "brokerName": "GLOBAL STRATEGIC INVESTMENTS, LLC                                     "
    },
    {
        "type": "MUNI",
        "mpid": "GSSC",
        "clearingBroker": "0161",
        "brokerName": "GEORGESON SHAREHOLDER SECURITIES CORP.                                "
    },
    {
        "type": "MUNI",
        "mpid": "GSSI",
        "clearingBroker": "0052",
        "brokerName": "GARDEN STATE SECURITIES, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "GSUU",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "GSVV",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "GTNB",
        "clearingBroker": "0595",
        "brokerName": "GTN AMERICAS FINANCIAL SERVICES, INC.                                 "
    },
    {
        "type": "MUNI",
        "mpid": "GTSM",
        "clearingBroker": "0005",
        "brokerName": "GTS SECURITIES LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "GUGI",
        "clearingBroker": "0526",
        "brokerName": "GUGGENHEIM FUNDS DISTRIBUTORS, LLC                                    "
    },
    {
        "type": "MUNI",
        "mpid": "GWFS",
        "clearingBroker": "0443",
        "brokerName": "GWFS EQUITIES, INC.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "GWNS",
        "clearingBroker": "0226",
        "brokerName": "GWN SECURITIES INC.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "GZML",
        "clearingBroker": "0161",
        "brokerName": "GUZMAN & COMPANY                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "HACA",
        "clearingBroker": "0701",
        "brokerName": "HARVEST CAPITAL LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "HALO",
        "clearingBroker": "0235",
        "brokerName": "HALO SECURITIES, LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "HARB",
        "clearingBroker": "0443",
        "brokerName": "HARBOUR INVESTMENTS INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "HARC",
        "clearingBroker": "0235",
        "brokerName": "HARLEY CAPITAL LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "HARS",
        "clearingBroker": "8199",
        "brokerName": "HARVESTONS SECURITIES, INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "HAVK",
        "clearingBroker": "0235",
        "brokerName": "EMPIRE STATE FINANCIAL, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "HAZL",
        "clearingBroker": "0226",
        "brokerName": "HAZLETT, BURT AND WATSON, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "HBCO",
        "clearingBroker": "0443",
        "brokerName": "GLOBAL INVESTOR SERVICES, L.C.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "HBKI",
        "clearingBroker": "0352",
        "brokerName": "HBK FINANCE, LP                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "HBUS",
        "clearingBroker": "0443",
        "brokerName": "HOLISTIC BROKERAGE, LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "HCGC",
        "clearingBroker": "0103",
        "brokerName": "FALCON SQUARE CAPITAL, LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "HCMX",
        "clearingBroker": "0235",
        "brokerName": "HOOPOE CAPITAL MARKETS, LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "HCTA",
        "clearingBroker": "0005",
        "brokerName": "PEAK6 CAPITAL MANAGEMENT LLC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "HCWW",
        "clearingBroker": "0235",
        "brokerName": "H.C.WAINWRIGHT & CO., LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "HDVS",
        "clearingBroker": "0226",
        "brokerName": "AVANTAX INVESTMENT SERVICES, INC.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "HEAD",
        "clearingBroker": "0443",
        "brokerName": "TD SECURITIES AUTOMATED TRADING LLC                                   "
    },
    {
        "type": "MUNI",
        "mpid": "HEGS",
        "clearingBroker": "1043",
        "brokerName": "HEG SECURITIES, LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "HENN",
        "clearingBroker": "0235",
        "brokerName": "CARL M. HENNIG, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "HENY",
        "clearingBroker": "0443",
        "brokerName": "HENLEY & COMPANY LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "HFIS",
        "clearingBroker": "0141",
        "brokerName": "HFI SECURITIES, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "HFLD",
        "clearingBroker": "0279",
        "brokerName": "HARTFIELD, TITUS & DONNELLY, LLC                                      "
    },
    {
        "type": "MUNI",
        "mpid": "HIGG",
        "clearingBroker": "0235",
        "brokerName": "HIGGINS CAPITAL MANAGEMENT, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "HIGH",
        "clearingBroker": "0443",
        "brokerName": "HIGHLANDER CAPITAL GROUP, INC                                         "
    },
    {
        "type": "MUNI",
        "mpid": "HILF",
        "clearingBroker": "0443",
        "brokerName": "HILL THOMPSON MAGID & CO INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "HINO",
        "clearingBroker": "0235",
        "brokerName": "TRB CAPITAL MARKETS,LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "HJSC",
        "clearingBroker": "0443",
        "brokerName": "SIMS (HERBERT J.) & CO., INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "HMRB",
        "clearingBroker": "0235",
        "brokerName": "W.R. HAMBRECHT + CO., LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "HNTR",
        "clearingBroker": "0443",
        "brokerName": "HUNTER ASSOCIATES, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "HONR",
        "clearingBroker": "0235",
        "brokerName": "ROBERTS & RYAN INVESTMENTS INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "HOPK",
        "clearingBroker": "0750",
        "brokerName": "SILVER OAK SECURITIES, INCORPORATED                                   "
    },
    {
        "type": "MUNI",
        "mpid": "HOTO",
        "clearingBroker": "0443",
        "brokerName": "HORNOR, TOWNSEND & KENT, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "HPOM",
        "clearingBroker": "0235",
        "brokerName": "HERNDON PLANT OAKLEY, LTD.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "HPWD",
        "clearingBroker": "0443",
        "brokerName": "PIPER SANDLER & CO.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "HRBF",
        "clearingBroker": "0756",
        "brokerName": "AMERICAN ENTERPRISE INVESTMENT SERVICES INC.                          "
    },
    {
        "type": "MUNI",
        "mpid": "HRCS",
        "clearingBroker": "0443",
        "brokerName": "HRC INVESTMENT SERVICES, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "HRGR",
        "clearingBroker": "0235",
        "brokerName": "HARGER AND COMPANY, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "HRRS",
        "clearingBroker": "0443",
        "brokerName": "HARRIS INVESTORS SERVICES, INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "HSBM",
        "clearingBroker": "0486",
        "brokerName": "HSBC SECURITIES (USA), INC/ FIXED INCOME SECS                         "
    },
    {
        "type": "MUNI",
        "mpid": "HTCM",
        "clearingBroker": "0235",
        "brokerName": "HOWDEN TIGER CAPITAL MARKETS & ADVISOF LLC                            "
    },
    {
        "type": "MUNI",
        "mpid": "HTIS",
        "clearingBroker": "0443",
        "brokerName": "HAITONG INTERNATIONAL SECURITIES (USA) INC.                           "
    },
    {
        "type": "MUNI",
        "mpid": "HTPS",
        "clearingBroker": "0443",
        "brokerName": "HIGHTOWER SECURITIES, LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "HTWR",
        "clearingBroker": "0226",
        "brokerName": "HIGHTOWER SECURITIES, LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "HUCO",
        "clearingBroker": "0226",
        "brokerName": "HUNTINGTON INVESTMENT COMPANY                                         "
    },
    {
        "type": "MUNI",
        "mpid": "HUTC",
        "clearingBroker": "0443",
        "brokerName": "HUNTINGTON SECURITIES, INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "HWLS",
        "clearingBroker": "0443",
        "brokerName": "M.S. HOWELLS & CO.                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "HXGN",
        "clearingBroker": "0443",
        "brokerName": "HEXAGON SECURITIES, LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "IAAK",
        "clearingBroker": "0279",
        "brokerName": "ISAAK BOND INVESTMENT, INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "IAEW",
        "clearingBroker": "0595",
        "brokerName": "SRT SECURITIES LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "IAEX",
        "clearingBroker": "0235",
        "brokerName": "SRT SECURITIES LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "IBCO",
        "clearingBroker": "0534",
        "brokerName": "INTERACTIVE BROKERS CORP.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "IBFS",
        "clearingBroker": "0824",
        "brokerName": "INDUSTRIAL AND COMMERCIAL BANK OF CHINA FINANCIAL SERVICES LLC        "
    },
    {
        "type": "MUNI",
        "mpid": "IBKR",
        "clearingBroker": "0534",
        "brokerName": "INTERACTIVE BROKERS LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "IBND",
        "clearingBroker": "0103",
        "brokerName": "INSTITUTIONAL BOND NETWORK, LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "IBPR",
        "clearingBroker": "0052",
        "brokerName": "IB CAPITAL LLC                                                        "
    },
    {
        "type": "MUNI",
        "mpid": "IBSH",
        "clearingBroker": "0595",
        "brokerName": "INTEGRITY BROKERAGE SERVICES, INC.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "IBSJ",
        "clearingBroker": "0052",
        "brokerName": "INTEGRITY BROKERAGE                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "ICAN",
        "clearingBroker": "0226",
        "brokerName": "CETERA ADVISOR NETWORKS LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "ICBK",
        "clearingBroker": "0388",
        "brokerName": "INDUSTRIAL AND COMMERCIAL BANK OF CHINA FINANCIAL SERVICES LLC        "
    },
    {
        "type": "MUNI",
        "mpid": "ICCP",
        "clearingBroker": "0443",
        "brokerName": "INVESTORS CAPITAL CORPORATION                                         "
    },
    {
        "type": "MUNI",
        "mpid": "ICEX",
        "clearingBroker": "4264",
        "brokerName": "ICE SECURITIES EXECUTION & CLEARING, LLC                              "
    },
    {
        "type": "MUNI",
        "mpid": "ICMH",
        "clearingBroker": "0235",
        "brokerName": "INSTITUTIONAL CAPITAL MANAGEMENT, INC.                                "
    },
    {
        "type": "MUNI",
        "mpid": "ICMI",
        "clearingBroker": "0279",
        "brokerName": "INTERCOASTAL CAPITAL MARKETS, INC.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "ICON",
        "clearingBroker": "0595",
        "brokerName": "ICON CAPITAL GROUP, LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "ICPX",
        "clearingBroker": "0443",
        "brokerName": "ICP SECURITIES LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "ICRL",
        "clearingBroker": "0443",
        "brokerName": "RIDEAU (I.C.) LYONS AND CO.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "ICTI",
        "clearingBroker": "0158",
        "brokerName": "INTERNATIONAL CORRESPONDENT TRADING, INC.                             "
    },
    {
        "type": "MUNI",
        "mpid": "IESI",
        "clearingBroker": "0443",
        "brokerName": "ITAU EUROPA SECURITIES INC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "IFCS",
        "clearingBroker": "0161",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "IMCC",
        "clearingBroker": "0005",
        "brokerName": "IMC FINANCIAL MARKETS                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "IMPC",
        "clearingBroker": "0443",
        "brokerName": "IMPERIAL CAPITAL, LLC                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "INGS",
        "clearingBroker": "0124",
        "brokerName": "INGALLS & SNYDER, LLC                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "INGW",
        "clearingBroker": "0443",
        "brokerName": "ING PRIVATE WEALTH MANAGEMENT LLC                                     "
    },
    {
        "type": "MUNI",
        "mpid": "INNO",
        "clearingBroker": "0052",
        "brokerName": "ETC BROKERAGE SERVICES, LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "INPI",
        "clearingBroker": "0235",
        "brokerName": "INVESTMENT PLANNERS INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "INPS",
        "clearingBroker": "0235",
        "brokerName": "INDEPENDENCE POINT SECURITIES LLC                                     "
    },
    {
        "type": "MUNI",
        "mpid": "INTL",
        "clearingBroker": "0750",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "INTX",
        "clearingBroker": "0235",
        "brokerName": "INTERNATIONAL ASSETS ADVISORY, LLC                                    "
    },
    {
        "type": "MUNI",
        "mpid": "IPGR",
        "clearingBroker": "0443",
        "brokerName": "INVESTMENT PLACEMENT GROUP                                            "
    },
    {
        "type": "MUNI",
        "mpid": "IRIS",
        "clearingBroker": "0279",
        "brokerName": "IRIS TRADING, INC.                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "ISCN",
        "clearingBroker": "0235",
        "brokerName": "INSTITUTIONAL SECURITIES CORPORATION                                  "
    },
    {
        "type": "MUNI",
        "mpid": "ISIG",
        "clearingBroker": "0226",
        "brokerName": "EVERCORE GROUP L.L.C.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "ISLL",
        "clearingBroker": "0052",
        "brokerName": "INLET SECURITIES LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "ISSB",
        "clearingBroker": "0443",
        "brokerName": "IRONSTONE SECURITIES INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "ISSC",
        "clearingBroker": "0443",
        "brokerName": "INVESTORS SECURITIES SERVICES, LLC                                    "
    },
    {
        "type": "MUNI",
        "mpid": "ISSI",
        "clearingBroker": "0052",
        "brokerName": "INSIGHT SECURITIES, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "ITCC",
        "clearingBroker": "0750",
        "brokerName": "STERNE AGEE FINANCIAL SERVICES, INC.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "ITFS",
        "clearingBroker": "0226",
        "brokerName": "KEEL POINT CAPITAL, LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "IVEX",
        "clearingBroker": "0443",
        "brokerName": "INVEX, INC.                                                           "
    },
    {
        "type": "MUNI",
        "mpid": "IVNT",
        "clearingBroker": "0235",
        "brokerName": "INVESTMENT NETWORK, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "IVOL",
        "clearingBroker": "0235",
        "brokerName": "UNION CAPITAL COMPANY                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "IVST",
        "clearingBroker": "0443",
        "brokerName": "INTERVEST INTERNATIONAL EQUITIES CORPORATION                          "
    },
    {
        "type": "MUNI",
        "mpid": "JACK",
        "clearingBroker": "0443",
        "brokerName": "JACKSON SECURITIES LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "JANC",
        "clearingBroker": "0443",
        "brokerName": "JANCO PARTNERS INC.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "JANE",
        "clearingBroker": "0352",
        "brokerName": "JANE STREET MARKETS, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "JANY",
        "clearingBroker": "0374",
        "brokerName": "JANNEY MONTGOMERY SCOTT LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "JASC",
        "clearingBroker": "0352",
        "brokerName": "JANE STREET CAPITAL, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "JDAA",
        "clearingBroker": "0443",
        "brokerName": "DARDIS (JACK) & ASSOCIATES                                            "
    },
    {
        "type": "MUNI",
        "mpid": "JDRB",
        "clearingBroker": "0595",
        "brokerName": "J.H. DARBIE & CO., INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "JEFF",
        "clearingBroker": "0019",
        "brokerName": "JEFFERIES LLC                                                         "
    },
    {
        "type": "MUNI",
        "mpid": "JEFM",
        "clearingBroker": "0235",
        "brokerName": "JEFFREY MATTHEWS FINANCIAL GROUP, L.L.C.                              "
    },
    {
        "type": "MUNI",
        "mpid": "JEVO",
        "clearingBroker": "0235",
        "brokerName": "ATIS, INC                                                             "
    },
    {
        "type": "MUNI",
        "mpid": "JGUN",
        "clearingBroker": "0235",
        "brokerName": "JOSEPH GUNNAR & CO. LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "JHDR",
        "clearingBroker": "0052",
        "brokerName": "JH DARBIE & CO. INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "JHYT",
        "clearingBroker": "0019",
        "brokerName": "JEFFERIES PARTNER OPPORTUNITY FUND II, LLC                            "
    },
    {
        "type": "MUNI",
        "mpid": "JJKE",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "JKCA",
        "clearingBroker": "0103",
        "brokerName": "J.K. CHILTON & ASSOCIATES, INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "JKFS",
        "clearingBroker": "0279",
        "brokerName": "J.K. FINANCIAL SERVICES INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "JKRC",
        "clearingBroker": "0443",
        "brokerName": "J.K.R. & CO., INC.                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "JLEQ",
        "clearingBroker": "0161",
        "brokerName": "JUMP EXECUTION, LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "JMFL",
        "clearingBroker": "0235",
        "brokerName": "THE JEFFREY MATTHEWS FINANCIAL GROUP, L.L.C.                          "
    },
    {
        "type": "MUNI",
        "mpid": "JMLS",
        "clearingBroker": "0235",
        "brokerName": "J.M LUMMIS SECURITIES, INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "JNST",
        "clearingBroker": "0352",
        "brokerName": "JANE STREET CAPITAL LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "JNWS",
        "clearingBroker": "0443",
        "brokerName": "WHIPPLE (J.N.) INC.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "JONE",
        "clearingBroker": "0161",
        "brokerName": "JONESTRADING                                                          "
    },
    {
        "type": "MUNI",
        "mpid": "JPMC",
        "clearingBroker": "0443",
        "brokerName": "MCGOWAN (J.P.) & COMPANY, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "JPMT",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "JPPB",
        "clearingBroker": "0443",
        "brokerName": "JEFFERIES LLC                                                         "
    },
    {
        "type": "MUNI",
        "mpid": "JRCO",
        "clearingBroker": "0226",
        "brokerName": "JOHNSON RICE & COMPANY L.L.C.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "JSAP",
        "clearingBroker": "8497",
        "brokerName": "JANE STREET CAPITAL, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "JSBA",
        "clearingBroker": "0161",
        "brokerName": "JANE STREET CAPITAL, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "JSCT",
        "clearingBroker": "0005",
        "brokerName": "JANE STREET CAPITAL LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "JSEB",
        "clearingBroker": "0161",
        "brokerName": "JANE STREET EXECUTION SERVICES, LLC                                   "
    },
    {
        "type": "MUNI",
        "mpid": "JSEG",
        "clearingBroker": "0161",
        "brokerName": "JANE STREET EXECUTION SERVICES, LLC                                   "
    },
    {
        "type": "MUNI",
        "mpid": "JSSF",
        "clearingBroker": "0226",
        "brokerName": "JMP SECURITIES LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "JVBF",
        "clearingBroker": "0235",
        "brokerName": "JACK V. BUTTERFIELD INVESTMENT COMPANY                                "
    },
    {
        "type": "MUNI",
        "mpid": "JVBG",
        "clearingBroker": "0443",
        "brokerName": "J.V.B. FINANCIAL GROUP LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "JWCF",
        "clearingBroker": "0226",
        "brokerName": "J. W. COLE FINANCIAL, INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "KALA",
        "clearingBroker": "0226",
        "brokerName": "KA ASSOCIATES, INC.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "KALS",
        "clearingBroker": "0235",
        "brokerName": "KALOS CAPITAL, INC.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "KART",
        "clearingBroker": "0750",
        "brokerName": "REVERE SECURITIES CORP.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "KAWM",
        "clearingBroker": "0443",
        "brokerName": "ARETE WEALTH MANAGEMENT, LLC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "KBWI",
        "clearingBroker": "0793",
        "brokerName": "KEEFE, BRUYETTE & WOODS, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "KCAM",
        "clearingBroker": "0052",
        "brokerName": "K2 CAPITAL ASSET MANAGEMENT, LLC                                      "
    },
    {
        "type": "MUNI",
        "mpid": "KCIM",
        "clearingBroker": "0235",
        "brokerName": "INVESTMENT MANAGEMENT CORPORATION                                     "
    },
    {
        "type": "MUNI",
        "mpid": "KCIX",
        "clearingBroker": "0279",
        "brokerName": "KILEY PARTNERS, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "KCRD",
        "clearingBroker": "0052",
        "brokerName": "PHX FINANCIAL, INC.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "KENY",
        "clearingBroker": "0443",
        "brokerName": "KENNY SECURITIES CORP.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "KEYB",
        "clearingBroker": "0443",
        "brokerName": "KEYBANC CAPITAL MARKETS INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "KILD",
        "clearingBroker": "0103",
        "brokerName": "KILDARE CAPITAL, INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "KIML",
        "clearingBroker": "0226",
        "brokerName": "KIMELMAN & BAIRD, LLC                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "KING",
        "clearingBroker": "0235",
        "brokerName": "C. L. KING & ASSOCIATES, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "KISL",
        "clearingBroker": "0443",
        "brokerName": "KEY INVESTMENT SERVICES LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "KMSF",
        "clearingBroker": "0443",
        "brokerName": "KMS FINANCIAL SERVICES                                                "
    },
    {
        "type": "MUNI",
        "mpid": "KNGS",
        "clearingBroker": "0235",
        "brokerName": "KINGSWOOD CAPITAL PARTNERS, LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "KOVP",
        "clearingBroker": "0443",
        "brokerName": "KOVACK SECURITIES INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "KOVS",
        "clearingBroker": "0226",
        "brokerName": "KOVACK SECURITIES, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "KRAM",
        "clearingBroker": "0141",
        "brokerName": "KRAMER SECURITIES CORP.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "KRCO",
        "clearingBroker": "0235",
        "brokerName": "KR SECURITIES, LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "KRSH",
        "clearingBroker": "0005",
        "brokerName": "KERSHNER SECURITIES, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "KRTH",
        "clearingBroker": "0235",
        "brokerName": "J.W. KORTH & COMPANY                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "KRUG",
        "clearingBroker": "0235",
        "brokerName": "KRUEGER BROKERAGE, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "KUYK",
        "clearingBroker": "0279",
        "brokerName": "KUYKENDALL & SCHNEIDER, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "LAFB",
        "clearingBroker": "0235",
        "brokerName": "LAFFERTY (R.F.) & CO., INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "LAFC",
        "clearingBroker": "0443",
        "brokerName": "R.F. LAFFERTY & CO., INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "LAFF",
        "clearingBroker": "0443",
        "brokerName": "R.F. LAFFERTY & CO., INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "LAGI",
        "clearingBroker": "0226",
        "brokerName": "ALLSTATE FINANCIAL SERVICES, LLC                                      "
    },
    {
        "type": "MUNI",
        "mpid": "LAMA",
        "clearingBroker": "0141",
        "brokerName": "XML SECURITIES                                                        "
    },
    {
        "type": "MUNI",
        "mpid": "LANE",
        "clearingBroker": "0235",
        "brokerName": "MARC J. LANE & COMPANY                                                "
    },
    {
        "type": "MUNI",
        "mpid": "LARC",
        "clearingBroker": "0235",
        "brokerName": "LARIMER CAPITAL CORPORATION                                           "
    },
    {
        "type": "MUNI",
        "mpid": "LASE",
        "clearingBroker": "0235",
        "brokerName": "LEGACY ASSET SECURITIES, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "LASI",
        "clearingBroker": "0141",
        "brokerName": "LIEBLONG & ASSOCIATES, INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "LASS",
        "clearingBroker": "0226",
        "brokerName": "LASALLE ST. SECURITIES, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "LATG",
        "clearingBroker": "0537",
        "brokerName": "GFI SECURITIES LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "LATN",
        "clearingBroker": "0443",
        "brokerName": "HEROLD & LANTERN INVESTMENTS, INC.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "LBKI",
        "clearingBroker": "0235",
        "brokerName": "LIBUCKI & CO., LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "LDIL",
        "clearingBroker": "0226",
        "brokerName": "LINCOLN DOUGLAS INVESTMENTS, LLC                                      "
    },
    {
        "type": "MUNI",
        "mpid": "LDLW",
        "clearingBroker": "0750",
        "brokerName": "LAIDLAW & COMPANY (UK) LTD.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "LDOT",
        "clearingBroker": "0235",
        "brokerName": "LANDOLT SECURITIES, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "LEAD",
        "clearingBroker": "0226",
        "brokerName": "THE LEADERS GROUP, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "LEBO",
        "clearingBroker": "0226",
        "brokerName": "LEIGH BALDWIN & CO., LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "LEDG",
        "clearingBroker": "0443",
        "brokerName": "LEDGEWOOD CAPITAL MANAGEMENT, LLC                                     "
    },
    {
        "type": "MUNI",
        "mpid": "LEER",
        "clearingBroker": "0443",
        "brokerName": "LEERINK SWANN & COMPANY                                               "
    },
    {
        "type": "MUNI",
        "mpid": "LENX",
        "clearingBroker": "0279",
        "brokerName": "LENOX FINANCIAL SERVICES, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "LEON",
        "clearingBroker": "0235",
        "brokerName": "LEONARD SECURITIES, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "LESW",
        "clearingBroker": "0443",
        "brokerName": "LEERINK SWANN & COMPANY                                               "
    },
    {
        "type": "MUNI",
        "mpid": "LEXI",
        "clearingBroker": "0226",
        "brokerName": "LEXINGTON INVESTMENT COMPANY, INC.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "LEYA",
        "clearingBroker": "0235",
        "brokerName": "LEMLEY, YARLING & CO.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "LFAC",
        "clearingBroker": "0226",
        "brokerName": "OSAIC FA, INC.                                                        "
    },
    {
        "type": "MUNI",
        "mpid": "LFIN",
        "clearingBroker": "0161",
        "brokerName": "LIGHTHOUSE FINANCIAL GROUP, LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "LFRO",
        "clearingBroker": "0235",
        "brokerName": "LF ROTHSCHILD, LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "LGLL",
        "clearingBroker": "0141",
        "brokerName": "MM GLOBAL SECURITIES, INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "LGNT",
        "clearingBroker": "0052",
        "brokerName": "AXOS CLEARING LLC                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "LGSA",
        "clearingBroker": "0443",
        "brokerName": "WOORI INVESTMENT AND SECURITIES AMERICA, INC.                         "
    },
    {
        "type": "MUNI",
        "mpid": "LIBE",
        "clearingBroker": "0443",
        "brokerName": "KCG AMERICAS LLC                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "LIFG",
        "clearingBroker": "0279",
        "brokerName": "LONG ISLAND FINANCIAL GROUP, INC.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "LIIS",
        "clearingBroker": "0226",
        "brokerName": "USAA FINANCIAL ADVISORS, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "LINQ",
        "clearingBroker": "0443",
        "brokerName": "LINKBROKERS DERIVATIVES CORPORATION                                   "
    },
    {
        "type": "MUNI",
        "mpid": "LISI",
        "clearingBroker": "0443",
        "brokerName": "LEUMI INVESTMENT SERVICES, INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "LMAR",
        "clearingBroker": "0226",
        "brokerName": "LIFEMARK SECURITIES CORP.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "LMKO",
        "clearingBroker": "0235",
        "brokerName": "KOHN (L.M.) & COMPANY                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "LMSC",
        "clearingBroker": "0235",
        "brokerName": "BAY COLONY SECURITIES CO., INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "LNKS",
        "clearingBroker": "0443",
        "brokerName": "GUGGENHEIM SECURITIES, LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "LOMB",
        "clearingBroker": "0141",
        "brokerName": "LOMBARD SECURITIES INCORPORATED                                       "
    },
    {
        "type": "MUNI",
        "mpid": "LOOP",
        "clearingBroker": "0443",
        "brokerName": "LOOP CAPITAL MARKETS, LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "LOUE",
        "clearingBroker": "0161",
        "brokerName": "ICAP CORPORATES LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "LOUI",
        "clearingBroker": "0005",
        "brokerName": "LOUIS CAPITAL MARKETS, LP                                             "
    },
    {
        "type": "MUNI",
        "mpid": "LPCM",
        "clearingBroker": "0103",
        "brokerName": "LAMPERT CAPITAL MARKETS INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "LPFS",
        "clearingBroker": "0235",
        "brokerName": "LIBERTY PARTNERS FINANCIAL SERVICES, INC.                             "
    },
    {
        "type": "MUNI",
        "mpid": "LPLE",
        "clearingBroker": "0075",
        "brokerName": "LPL ENTERPRISE, LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "LPSP",
        "clearingBroker": "1043",
        "brokerName": "LPS CAPITAL LLC                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "LQNA",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "LQNB",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "LQNF",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "LQNT",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "LQPT",
        "clearingBroker": "0161",
        "brokerName": "DASH FINANCIAL TECHNOLOGIES LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "LRBC",
        "clearingBroker": "0235",
        "brokerName": "LIBERTY ASSOCIATES, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "LRCM",
        "clearingBroker": "0279",
        "brokerName": "LOCKTON RE CAPITAL MARKETS, LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "LSCM",
        "clearingBroker": "0235",
        "brokerName": "LAKE STREET CAPITAL MARKETS, LLC                                      "
    },
    {
        "type": "MUNI",
        "mpid": "LSKO",
        "clearingBroker": "0226",
        "brokerName": "LESKO SECURITIES INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "LSPI",
        "clearingBroker": "0141",
        "brokerName": "LAFAYETTE INVESTMENTS                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "LSSM",
        "clearingBroker": "0443",
        "brokerName": "LOCUST STREET SECURITIES, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "LSUS",
        "clearingBroker": "0443",
        "brokerName": "LATIN SECURITIES INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "LTCO",
        "clearingBroker": "0226",
        "brokerName": "LADENBURG, THALMANN & CO., INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "LTCS",
        "clearingBroker": "0141",
        "brokerName": "LINDEN THOMAS AND COMPANY SECURITIES, LLC                             "
    },
    {
        "type": "MUNI",
        "mpid": "LTIN",
        "clearingBroker": "2786",
        "brokerName": "BBVA SECURITIES INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "LTLI",
        "clearingBroker": "0141",
        "brokerName": "L.P. LITTLEWOOD & ASSOCIATES, INC.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "LVMR",
        "clearingBroker": "0235",
        "brokerName": "LIVERMORE TRADING GROUP, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "LYON",
        "clearingBroker": "0651",
        "brokerName": "CREDIT AGRICOLE SECURITIES (USA) INC.                                 "
    },
    {
        "type": "MUNI",
        "mpid": "LYSI",
        "clearingBroker": "0443",
        "brokerName": "LLOYDS SECURITIES INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "MACC",
        "clearingBroker": "0226",
        "brokerName": "NEWEDGE SECURITIES, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "MACP",
        "clearingBroker": "0443",
        "brokerName": "GRIFFON MAY, INC.                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "MADV",
        "clearingBroker": "0443",
        "brokerName": "MILLENNIUM ADVISORS, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "MAMA",
        "clearingBroker": "0443",
        "brokerName": "SECUREVEST FINANCIAL GROUP                                            "
    },
    {
        "type": "MUNI",
        "mpid": "MASE",
        "clearingBroker": "0141",
        "brokerName": "MANAGED ACCOUNT SERVICES, LLC                                         "
    },
    {
        "type": "MUNI",
        "mpid": "MAVS",
        "clearingBroker": "0443",
        "brokerName": "MADISON AVENUE SECURITIES                                             "
    },
    {
        "type": "MUNI",
        "mpid": "MAXM",
        "clearingBroker": "0443",
        "brokerName": "MAXIM GROUP LLC                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "MBSA",
        "clearingBroker": "0052",
        "brokerName": "MBS SOURCE ETRADING, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "MBSE",
        "clearingBroker": "0052",
        "brokerName": "MBS SOURCE ETRADING, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "MBSL",
        "clearingBroker": "0443",
        "brokerName": "MBS CAPITAL MARKETS, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "MBTS",
        "clearingBroker": "0158",
        "brokerName": "MB TRADING                                                            "
    },
    {
        "type": "MUNI",
        "mpid": "MBUS",
        "clearingBroker": "0052",
        "brokerName": "MEDIOBANCA SECURITIES USA LLC                                         "
    },
    {
        "type": "MUNI",
        "mpid": "MCAP",
        "clearingBroker": "0161",
        "brokerName": "MCAP LLC                                                              "
    },
    {
        "type": "MUNI",
        "mpid": "MCBT",
        "clearingBroker": "0235",
        "brokerName": "MOORS & CABOT, INC.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "MCCL",
        "clearingBroker": "0443",
        "brokerName": "MCCLURG CAPITAL CORPORATION                                           "
    },
    {
        "type": "MUNI",
        "mpid": "MCMG",
        "clearingBroker": "0279",
        "brokerName": "MUNICIPAL CAPITAL MARKETS GROUP, INC.                                 "
    },
    {
        "type": "MUNI",
        "mpid": "MDGP",
        "clearingBroker": "0235",
        "brokerName": "MD GLOBAL PARTNERS, LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "MDGS",
        "clearingBroker": "0103",
        "brokerName": "MIDDLEGATE SECURITIES LTD.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "MDTH",
        "clearingBroker": "0443",
        "brokerName": "MEREDITH (ROBERT R.) & CO.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "MEAL",
        "clearingBroker": "0226",
        "brokerName": "M. E. ALLISON & CO., INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "MERP",
        "clearingBroker": "0235",
        "brokerName": "MERIDIAN EQUITY PARTNERS, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "MERQ",
        "clearingBroker": "0161",
        "brokerName": "MERCATOR ASSOCIATES LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "MESF",
        "clearingBroker": "0443",
        "brokerName": "MESIROW FINANCIAL, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "MFCA",
        "clearingBroker": "0141",
        "brokerName": "MONARCH FINANCIAL CORPORATION OF AMERICA                              "
    },
    {
        "type": "MUNI",
        "mpid": "MFGX",
        "clearingBroker": "0443",
        "brokerName": "MISCHLER FINANCIAL GROUP, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "MFRS",
        "clearingBroker": "0443",
        "brokerName": "MFR SECURITIES, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "MHFI",
        "clearingBroker": "0226",
        "brokerName": "M HOLDINGS SECURITIES, INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "MIAM",
        "clearingBroker": "6440",
        "brokerName": "FMSBONDS, INC.                                                        "
    },
    {
        "type": "MUNI",
        "mpid": "MICG",
        "clearingBroker": "0141",
        "brokerName": "MICG INVESTMENT MANAGEMENT                                            "
    },
    {
        "type": "MUNI",
        "mpid": "MIDL",
        "clearingBroker": "0226",
        "brokerName": "MIDDLEGATE SECURITIES LTD.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "MIFI",
        "clearingBroker": "0226",
        "brokerName": "MILKIE FERGUSON INVESTMENTS, INC.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "MILN",
        "clearingBroker": "1767",
        "brokerName": "MILLENNIUM ADVISORS, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "MINV",
        "clearingBroker": "0235",
        "brokerName": "MACK INVESTMENTS SECURITIES, INC.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "MIRA",
        "clearingBroker": "1043",
        "brokerName": "MIRAE ASSET SECURITIES (USA) INC.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "MISL",
        "clearingBroker": "0161",
        "brokerName": "MISCHLER FINANCIAL GROUP, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "MISM",
        "clearingBroker": "0161",
        "brokerName": "MISMI, INC.                                                           "
    },
    {
        "type": "MUNI",
        "mpid": "MITR",
        "clearingBroker": "0443",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "MJWH",
        "clearingBroker": "0235",
        "brokerName": "ETICO PARTNERS LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "MKRT",
        "clearingBroker": "0235",
        "brokerName": "MARKET SECURITIES, LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "MKTI",
        "clearingBroker": "0226",
        "brokerName": "U.S. BANCORP ADVISORS, LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "MKTX",
        "clearingBroker": "4265",
        "brokerName": "MARKETAXESS CORPORATION                                               "
    },
    {
        "type": "MUNI",
        "mpid": "MKTY",
        "clearingBroker": "4265",
        "brokerName": "MARKETAXESS CORPORATION                                               "
    },
    {
        "type": "MUNI",
        "mpid": "MLCO",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "MLMA",
        "clearingBroker": "0671",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "MUNI",
        "mpid": "MLMS",
        "clearingBroker": "0279",
        "brokerName": "MAINLINE WEST MUNICIPAL SECURITIES, LLC                               "
    },
    {
        "type": "MUNI",
        "mpid": "MLWM",
        "clearingBroker": "0671",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "MUNI",
        "mpid": "MMAN",
        "clearingBroker": "0443",
        "brokerName": "MCMAHAN SECURITIES CO. L.P.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "MMNT",
        "clearingBroker": "0158",
        "brokerName": "MOMENT MARKETS, LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "MNCO",
        "clearingBroker": "0279",
        "brokerName": "NELSON (MARTIN) & CO., INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "MNRC",
        "clearingBroker": "0443",
        "brokerName": "MONARCH CAPITAL GROUP LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "MNXS",
        "clearingBroker": "0443",
        "brokerName": "MUNIAXIS LEBENTHAL LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "MOCM",
        "clearingBroker": "0235",
        "brokerName": "MORETON CAPITAL MARKETS, LLC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "MOJO",
        "clearingBroker": "0103",
        "brokerName": "MONTAG & JOSELSON                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "MOLO",
        "clearingBroker": "0235",
        "brokerName": "MOLONEY SECURITIES                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "MOMS",
        "clearingBroker": "0750",
        "brokerName": "MOMENTUS SECURITIES LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "MONR",
        "clearingBroker": "0226",
        "brokerName": "MONROE FINANCIAL PARTNERS, INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "MORA",
        "clearingBroker": "0443",
        "brokerName": "MORA WM SECURITIES                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "MPLA",
        "clearingBroker": "0158",
        "brokerName": "EMPALA SECURITIES, LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "MPLM",
        "clearingBroker": "0651",
        "brokerName": "MOMENTUM TRADING PARTNERS, LLC                                        "
    },
    {
        "type": "MUNI",
        "mpid": "MPLW",
        "clearingBroker": "0226",
        "brokerName": "MAPLEWOOD INVESTMENT ADVISORS, INC.                                   "
    },
    {
        "type": "MUNI",
        "mpid": "MPSG",
        "clearingBroker": "0161",
        "brokerName": "ED & F MAN CAPITAL MARKETS INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "MRBA",
        "clearingBroker": "0052",
        "brokerName": "IBN FINANCIAL SERVICES, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "MRNA",
        "clearingBroker": "0161",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "MRPH",
        "clearingBroker": "0226",
        "brokerName": "WM FINANCIAL SERVICES, INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "MRSC",
        "clearingBroker": "0287",
        "brokerName": "TRADEUP SECURITIES, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "MSCH",
        "clearingBroker": "0443",
        "brokerName": "MAGNA SECURITIES CORP.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "MSCO",
        "clearingBroker": "0050",
        "brokerName": "MORGAN STANLEY & CO. LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "MSEC",
        "clearingBroker": "0235",
        "brokerName": "MSEC, LLC                                                             "
    },
    {
        "type": "MUNI",
        "mpid": "MSII",
        "clearingBroker": "0226",
        "brokerName": "MSI FINANCIAL SERVICES, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "MSNY",
        "clearingBroker": "0015",
        "brokerName": "MORGAN STANLEY & CO. LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "MSPW",
        "clearingBroker": "0050",
        "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "MSRO",
        "clearingBroker": "0226",
        "brokerName": "MESIROW FINANCIAL, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "MSSS",
        "clearingBroker": "0050",
        "brokerName": "MS SECURITIES SERVICES, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "MSTC",
        "clearingBroker": "0226",
        "brokerName": "MIDWESTERN SECURITIES TRADING COMPANY, LLC                            "
    },
    {
        "type": "MUNI",
        "mpid": "MTBK",
        "clearingBroker": "0443",
        "brokerName": "MULTI-BANK SECURITIES, INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "MTCN",
        "clearingBroker": "0443",
        "brokerName": "MILLER TABAK & CO., LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "MTDB",
        "clearingBroker": "0443",
        "brokerName": "M&T SECURITIES, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "MTHN",
        "clearingBroker": "0005",
        "brokerName": "MARATHON TRADING GROUP LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "MTLE",
        "clearingBroker": "0235",
        "brokerName": "MTL EQUITY PRODUCTS, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "MTNS",
        "clearingBroker": "0443",
        "brokerName": "MOUNTAINSIDE SECURITIES LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "MTRN",
        "clearingBroker": "0443",
        "brokerName": "MULTITRADE SECURITIES LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "MTSL",
        "clearingBroker": "0226",
        "brokerName": "MSEC, LLC                                                             "
    },
    {
        "type": "MUNI",
        "mpid": "MUFG",
        "clearingBroker": "0076",
        "brokerName": "MUFG SECURITIES AMERICAS INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "MULT",
        "clearingBroker": "0443",
        "brokerName": "MULTI-FINANCIAL SECURITIES GROUP                                      "
    },
    {
        "type": "MUNI",
        "mpid": "MUNP",
        "clearingBroker": "0443",
        "brokerName": "MUNICIPAL PARTNERS                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "MURF",
        "clearingBroker": "0443",
        "brokerName": "MURPHY & DURIEU                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "MVII",
        "clearingBroker": "0235",
        "brokerName": "MINNESOTA VALLEY INVESTMENTS                                          "
    },
    {
        "type": "MUNI",
        "mpid": "MWCC",
        "clearingBroker": "0235",
        "brokerName": "MONNESS CRESPI HARDT & CO., INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "MWCO",
        "clearingBroker": "0443",
        "brokerName": "MADISON WILLIAMS AND COMPANY                                          "
    },
    {
        "type": "MUNI",
        "mpid": "MWIL",
        "clearingBroker": "0235",
        "brokerName": "MORGAN WILSHIRE SECURITIES, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "MYMK",
        "clearingBroker": "0443",
        "brokerName": "MONEY MARKET 1 INSTITUTIONAL INVESTMENT DEALER                        "
    },
    {
        "type": "MUNI",
        "mpid": "MYSS",
        "clearingBroker": "0158",
        "brokerName": "M.Y. SAFRA SECURITIES, INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "MZHO",
        "clearingBroker": "2396",
        "brokerName": "MIZUHO SECURITIES USA LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "NACM",
        "clearingBroker": "0161",
        "brokerName": "NABSECURITIES, LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "NADL",
        "clearingBroker": "0235",
        "brokerName": "WARREN D. NADEL & COMPANY                                             "
    },
    {
        "type": "MUNI",
        "mpid": "NAIS",
        "clearingBroker": "0443",
        "brokerName": "NORTH AMERICAN CAPITAL MARKETS                                        "
    },
    {
        "type": "MUNI",
        "mpid": "NAPK",
        "clearingBroker": "0052",
        "brokerName": "B. RILEY WEALTH MANAGEMENT                                            "
    },
    {
        "type": "MUNI",
        "mpid": "NASC",
        "clearingBroker": "0235",
        "brokerName": "NATALLIANCE SECURITIES, LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "NAVC",
        "clearingBroker": "0235",
        "brokerName": "NAVIAN CAPITAL SECURITIES LLC                                         "
    },
    {
        "type": "MUNI",
        "mpid": "NBAR",
        "clearingBroker": "0226",
        "brokerName": "NANCY BARRON & ASSOCIATES, INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "NBCS",
        "clearingBroker": "0235",
        "brokerName": "NBC SECURITIES, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "NBLB",
        "clearingBroker": "0226",
        "brokerName": "NEUBERGER BERMAN BD LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "NBNA",
        "clearingBroker": "6737",
        "brokerName": "BANK OF AMERICA, N.A.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "NBSL",
        "clearingBroker": "0226",
        "brokerName": "BMO NESBITT BURNS SECURITIES LTD.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "NBST",
        "clearingBroker": "0103",
        "brokerName": "BRANDIS TALLMAN LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "NEPP",
        "clearingBroker": "0226",
        "brokerName": "N.E. PRIVATE CLIENT ADVISORS, LTD.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "NEST",
        "clearingBroker": "0235",
        "brokerName": "NEST INVESTMENTS BD LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "NEXT",
        "clearingBroker": "0443",
        "brokerName": "NEXT FINANCIAL GROUP, INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "NFGR",
        "clearingBroker": "0141",
        "brokerName": "NATIONS FINANCIAL GROUP, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "NFSC",
        "clearingBroker": "0226",
        "brokerName": "NATIONAL FINANCIAL SERVICES LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "NFTY",
        "clearingBroker": "0235",
        "brokerName": "INFINITY FINANCIAL SERVICES                                           "
    },
    {
        "type": "MUNI",
        "mpid": "NHWI",
        "clearingBroker": "0141",
        "brokerName": "HENNION & WALSH, INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "NIAD",
        "clearingBroker": "0052",
        "brokerName": "NI ADVISORS                                                           "
    },
    {
        "type": "MUNI",
        "mpid": "NITC",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "NLOV",
        "clearingBroker": "0279",
        "brokerName": "NORTLOV SECURITIES LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "NOBL",
        "clearingBroker": "0443",
        "brokerName": "NOBLE FINANCIAL CAPITAL MARKETS                                       "
    },
    {
        "type": "MUNI",
        "mpid": "NORC",
        "clearingBroker": "0235",
        "brokerName": "NORTHERN CAPITAL SEC. CORP.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "NORP",
        "clearingBroker": "0443",
        "brokerName": "PARETO SECURITIES INC                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "NORT",
        "clearingBroker": "0443",
        "brokerName": "NORTHLAND SECURITIES, INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "NORW",
        "clearingBroker": "0250",
        "brokerName": "WELLS FARGO BROKERAGE SERVICES, LLC                                   "
    },
    {
        "type": "MUNI",
        "mpid": "NQBX",
        "clearingBroker": "0163",
        "brokerName": "NASDAQ BX, INC.                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "NSFP",
        "clearingBroker": "0235",
        "brokerName": "NORTHSTAR FINANCIAL PARTNERS, INC.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "NSRD",
        "clearingBroker": "0235",
        "brokerName": "NESTLERODE & CO., INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "NTFN",
        "clearingBroker": "0052",
        "brokerName": "NETWORK 1 FINANCIAL SECURITIES INC.                                   "
    },
    {
        "type": "MUNI",
        "mpid": "NTRC",
        "clearingBroker": "0226",
        "brokerName": "NORTHERN TRUST SECURITIES, INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "NTSI",
        "clearingBroker": "0443",
        "brokerName": "NESBITT THOMSON SECURITIES, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "NVEN",
        "clearingBroker": "0448",
        "brokerName": "NUVEEN SECURITIES, LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "NVGT",
        "clearingBroker": "0388",
        "brokerName": "NAVIGATE ADVISORS LLC                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "NWCM",
        "clearingBroker": "0235",
        "brokerName": "NW CAPITAL MARKETS INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "NWIA",
        "clearingBroker": "0750",
        "brokerName": "NORTHWEST INVESTMENT ADVISORS, INC.                                   "
    },
    {
        "type": "MUNI",
        "mpid": "NYLS",
        "clearingBroker": "0226",
        "brokerName": "NYLIFE SECURITIES INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "OAKR",
        "clearingBroker": "0235",
        "brokerName": "THE OAK RIDGE FINANCIAL SERVICES GROUP, INC.                          "
    },
    {
        "type": "MUNI",
        "mpid": "OBWS",
        "clearingBroker": "0226",
        "brokerName": "OBERWEIS SECURITIES, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "OCAC",
        "clearingBroker": "0235",
        "brokerName": "OLSON, CROSS & ALAMO LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "OCON",
        "clearingBroker": "0103",
        "brokerName": "O'CONNOR & CO SECURITIES                                              "
    },
    {
        "type": "MUNI",
        "mpid": "ODEO",
        "clearingBroker": "0388",
        "brokerName": "ODEON CAP                                                             "
    },
    {
        "type": "MUNI",
        "mpid": "ODNC",
        "clearingBroker": "0235",
        "brokerName": "ODEON CAPITAL GROUP LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "OFGF",
        "clearingBroker": "0235",
        "brokerName": "OFG FINANCIAL SERVICES INC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "OGRU",
        "clearingBroker": "0161",
        "brokerName": "OSCAR GRUSS & SON, INCORPORATED                                       "
    },
    {
        "type": "MUNI",
        "mpid": "OGTL",
        "clearingBroker": "0005",
        "brokerName": "OUTSET GLOBAL TRADING LIMITED                                         "
    },
    {
        "type": "MUNI",
        "mpid": "OHIO",
        "clearingBroker": "0443",
        "brokerName": "FIFTH THIRD SECURITIES, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "OLDM",
        "clearingBroker": "0005",
        "brokerName": "OLD MISSION CAPITAL, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "OLNE",
        "clearingBroker": "0279",
        "brokerName": "OLDEN LANE SECURITIES, LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "OMMA",
        "clearingBroker": "0005",
        "brokerName": "OLD MISSION MARKETS LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "ONEL",
        "clearingBroker": "0161",
        "brokerName": "O'NEIL (WILLIAM) & CO                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "ONES",
        "clearingBroker": "0443",
        "brokerName": "O N EQUITY SALES CO.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "OPCO",
        "clearingBroker": "0571",
        "brokerName": "OPPENHEIMER & CO. INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "OPTF",
        "clearingBroker": "0005",
        "brokerName": "OPTIVER US LLC                                                        "
    },
    {
        "type": "MUNI",
        "mpid": "ORTL",
        "clearingBroker": "0443",
        "brokerName": "ORIENTAL FINANCIAL SERVICES                                           "
    },
    {
        "type": "MUNI",
        "mpid": "OSIC",
        "clearingBroker": "0226",
        "brokerName": "OSAIC INSTITUTIONS, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "OTCN",
        "clearingBroker": "0158",
        "brokerName": "OTC LINK LLC                                                          "
    },
    {
        "type": "MUNI",
        "mpid": "OTSC",
        "clearingBroker": "0443",
        "brokerName": "OGILVIE SECURITY ADVISORS CORPORATION                                 "
    },
    {
        "type": "MUNI",
        "mpid": "OYLD",
        "clearingBroker": "0235",
        "brokerName": "OPENYIELD TRADING LLC                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "PAFA",
        "clearingBroker": "0443",
        "brokerName": "PAN-AMERICAN FINANCIAL ADVISORS                                       "
    },
    {
        "type": "MUNI",
        "mpid": "PAMC",
        "clearingBroker": "0226",
        "brokerName": "PROGRESSIVE ASSET MANAGEMENT                                          "
    },
    {
        "type": "MUNI",
        "mpid": "PAMI",
        "clearingBroker": "0141",
        "brokerName": "PROFESSIONAL ASSET MANAGEMENT, INC.                                   "
    },
    {
        "type": "MUNI",
        "mpid": "PAMS",
        "clearingBroker": "0443",
        "brokerName": "PACIFIC AMERICAN SECURITIES, LLC                                      "
    },
    {
        "type": "MUNI",
        "mpid": "PANA",
        "clearingBroker": "0443",
        "brokerName": "PANAMERICA CAPITAL GROUP INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "PAPA",
        "clearingBroker": "0443",
        "brokerName": "PAPAMARKOU WELLNER & CO., INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "PARI",
        "clearingBroker": "0630",
        "brokerName": "BNP PARIBAS SECURITIES CORP.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "PARK",
        "clearingBroker": "0443",
        "brokerName": "PARK WALK CAPITAL MARKETS, LLC                                        "
    },
    {
        "type": "MUNI",
        "mpid": "PARV",
        "clearingBroker": "0443",
        "brokerName": "PAR5 CAPITAL & CO LLC                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "PASC",
        "clearingBroker": "0443",
        "brokerName": "PARK AVENUE SECURITIES LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "PASL",
        "clearingBroker": "0443",
        "brokerName": "PERSHING ADVISOR SOLUTIONS, LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "PASQ",
        "clearingBroker": "0443",
        "brokerName": "DUPASQUIER & CO., INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "PATR",
        "clearingBroker": "0624",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "PAUL",
        "clearingBroker": "0595",
        "brokerName": "PAULSON INVESTMENT COMPANY, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "PBON",
        "clearingBroker": "0161",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "PCAP",
        "clearingBroker": "0608",
        "brokerName": "SG AMERICAS SECURITIES, LLC/SUB 608                                   "
    },
    {
        "type": "MUNI",
        "mpid": "PCCA",
        "clearingBroker": "0279",
        "brokerName": "PEACHCAP SECURITIES, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "PCCN",
        "clearingBroker": "0443",
        "brokerName": "PACTUAL CAPITAL CORPORATION                                           "
    },
    {
        "type": "MUNI",
        "mpid": "PCIS",
        "clearingBroker": "0226",
        "brokerName": "BANKOH INVESTMENT SERVICES, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "PEER",
        "clearingBroker": "0226",
        "brokerName": "AMERICAN TRUST INVESTMENT SERVICES, INC.                              "
    },
    {
        "type": "MUNI",
        "mpid": "PENG",
        "clearingBroker": "0443",
        "brokerName": "PENNSYLVANIA GROUP INCORPORATED (THE)                                 "
    },
    {
        "type": "MUNI",
        "mpid": "PERC",
        "clearingBroker": "0279",
        "brokerName": "PERCIVAL FINANCIAL PARTNERS, LTD.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "PERS",
        "clearingBroker": "0443",
        "brokerName": "PERSHING LLC                                                          "
    },
    {
        "type": "MUNI",
        "mpid": "PFCG",
        "clearingBroker": "0279",
        "brokerName": "PREFERRED CLIENT GROUP, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "PFCL",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "MUNI",
        "mpid": "PFDC",
        "clearingBroker": "0235",
        "brokerName": "PREFERRED CAPITAL SECURITIES, LLC                                     "
    },
    {
        "type": "MUNI",
        "mpid": "PFPI",
        "clearingBroker": "0443",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC                                   "
    },
    {
        "type": "MUNI",
        "mpid": "PGRS",
        "clearingBroker": "0443",
        "brokerName": "PGR SECURITIES, LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "PGSI",
        "clearingBroker": "0443",
        "brokerName": "PRIME GLOBAL SECURITIES, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "PHBP",
        "clearingBroker": "0052",
        "brokerName": "PENNHAVEN BROKERAGE PARTNERS, LLC                                     "
    },
    {
        "type": "MUNI",
        "mpid": "PHIN",
        "clearingBroker": "0443",
        "brokerName": "PHILADELPHIA INVESTORS, LTD.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "PHRS",
        "clearingBroker": "0279",
        "brokerName": "NAVAID FINANCIAL SERVICES, INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "PICI",
        "clearingBroker": "0279",
        "brokerName": "POLAR INVESTMENT COUNSEL, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "PICL",
        "clearingBroker": "0052",
        "brokerName": "PAULSON INVESTMENT COMPANY LLC                                        "
    },
    {
        "type": "MUNI",
        "mpid": "PIGS",
        "clearingBroker": "0443",
        "brokerName": "PENN INVESTMENT GROUP, INC. (THE)                                     "
    },
    {
        "type": "MUNI",
        "mpid": "PIMS",
        "clearingBroker": "0226",
        "brokerName": "PRUDENTIAL INVESTMENT MANAGEMENT SERVICES, LLC                        "
    },
    {
        "type": "MUNI",
        "mpid": "PINA",
        "clearingBroker": "0141",
        "brokerName": "PINNACLE INVESTMENTS, LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "PIPR",
        "clearingBroker": "0443",
        "brokerName": "PIPER SANDLER & CO.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "PIRR",
        "clearingBroker": "0443",
        "brokerName": "PIRRONE & CO., INC.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "PJEF",
        "clearingBroker": "0443",
        "brokerName": "JEFFERIES LLC                                                         "
    },
    {
        "type": "MUNI",
        "mpid": "PKAX",
        "clearingBroker": "0158",
        "brokerName": "PEAK6 CAPITAL MANAGEMENT LLC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "PMAS",
        "clearingBroker": "0443",
        "brokerName": "PMA SECURITIES, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "PMKS",
        "clearingBroker": "0141",
        "brokerName": "PMK SECURITIES & RESEARCH, INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "PNCC",
        "clearingBroker": "0226",
        "brokerName": "PNC INVESTMENTS                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "PNCM",
        "clearingBroker": "2835",
        "brokerName": "PNC CAPITAL MARKETS LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "PNFP",
        "clearingBroker": "0279",
        "brokerName": "PNFP CAPITAL MARKETS, INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "PNSA",
        "clearingBroker": "0235",
        "brokerName": "PENSERRA SECURITIES, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "PNSR",
        "clearingBroker": "0161",
        "brokerName": "PENSERRA SECURITIES, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "PODE",
        "clearingBroker": "0235",
        "brokerName": "PODESTA & CO.                                                         "
    },
    {
        "type": "MUNI",
        "mpid": "POND",
        "clearingBroker": "0141",
        "brokerName": "POND EQUITIES                                                         "
    },
    {
        "type": "MUNI",
        "mpid": "POOH",
        "clearingBroker": "0443",
        "brokerName": "QUESTAR CAPITAL CORPORATION                                           "
    },
    {
        "type": "MUNI",
        "mpid": "POPS",
        "clearingBroker": "0226",
        "brokerName": "POPULAR SECURITIES, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "POWL",
        "clearingBroker": "0443",
        "brokerName": "POWELL (ELMER E.) COMPANY                                             "
    },
    {
        "type": "MUNI",
        "mpid": "PPSI",
        "clearingBroker": "0235",
        "brokerName": "PENSION PLANNERS SECURITIES, INC.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "PPSL",
        "clearingBroker": "0413",
        "brokerName": "SANTANDER US CAPITAL MARKETS LLC                                      "
    },
    {
        "type": "MUNI",
        "mpid": "PREB",
        "clearingBroker": "0005",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "PRFA",
        "clearingBroker": "0235",
        "brokerName": "PROOF SERVICES LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "PRGL",
        "clearingBroker": "0141",
        "brokerName": "PRUDENTIAL EQUITY GROUP, LLC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "PROE",
        "clearingBroker": "0443",
        "brokerName": "PROEQUITIES, INC.                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "PRPO",
        "clearingBroker": "0443",
        "brokerName": "PRIVATE PORTFOLIO, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "PRSB",
        "clearingBroker": "0141",
        "brokerName": "PRESIDENTIAL BROKERAGE, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "PRST",
        "clearingBroker": "0551",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "PSAE",
        "clearingBroker": "0141",
        "brokerName": "PSA EQUITIES, INC.                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "PSII",
        "clearingBroker": "0226",
        "brokerName": "KESTRA INVESTMENT SERVICES, LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "PSIM",
        "clearingBroker": "0226",
        "brokerName": "PRINCIPAL SECURITIES, INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "PSIN",
        "clearingBroker": "0443",
        "brokerName": "LUMENT SECURITIES, LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "PSRI",
        "clearingBroker": "0103",
        "brokerName": "GLOBALINK SECURITIES, INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "PSUT",
        "clearingBroker": "0235",
        "brokerName": "INNOVATION PARTNERS LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "PTCM",
        "clearingBroker": "0443",
        "brokerName": "CAVU SECURITIES LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "PTIS",
        "clearingBroker": "0235",
        "brokerName": "PTI SECURITIES & FUTURES L.P.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "PTRI",
        "clearingBroker": "0443",
        "brokerName": "PETRIE PARKMAN & CO.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "PULB",
        "clearingBroker": "0052",
        "brokerName": "PULASKI BANK                                                          "
    },
    {
        "type": "MUNI",
        "mpid": "PUMP",
        "clearingBroker": "0141",
        "brokerName": "C.E. GAYE & SONS SECURITIES LTD.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "PUPL",
        "clearingBroker": "0226",
        "brokerName": "PUPLAVA SECURITIES, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "PURP",
        "clearingBroker": "0279",
        "brokerName": "LIBERTY CAPITAL INVESTMENT CORPORATION                                "
    },
    {
        "type": "MUNI",
        "mpid": "PWJC",
        "clearingBroker": "0221",
        "brokerName": "UBS FINANCIAL SERVICES INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "PWPR",
        "clearingBroker": "0221",
        "brokerName": "UBS FINANCIAL SERVICE INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "PXGJ",
        "clearingBroker": "0352",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "QBND",
        "clearingBroker": "0161",
        "brokerName": "MCAP LLC                                                              "
    },
    {
        "type": "MUNI",
        "mpid": "QBSI",
        "clearingBroker": "0226",
        "brokerName": "GLEN EAGLE WEALTH, LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "QCAP",
        "clearingBroker": "0235",
        "brokerName": "QUINT CAPITAL CORPORATION                                             "
    },
    {
        "type": "MUNI",
        "mpid": "QCAS",
        "clearingBroker": "0226",
        "brokerName": "QUINCY CASS ASSOCIATES, INCORPORATED                                  "
    },
    {
        "type": "MUNI",
        "mpid": "QMSR",
        "clearingBroker": "0235",
        "brokerName": "QUATTRO M SECURITIES INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "QUOI",
        "clearingBroker": "0279",
        "brokerName": "QUOIN CAPITAL LLC                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "QWIK",
        "clearingBroker": "0161",
        "brokerName": "MCAP LLC                                                              "
    },
    {
        "type": "MUNI",
        "mpid": "RAAA",
        "clearingBroker": "0052",
        "brokerName": "RICHARD JAMES & ASSOCIATES, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "RAAI",
        "clearingBroker": "0226",
        "brokerName": "OSAIC WEALTH, INC.                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "RACO",
        "clearingBroker": "0158",
        "brokerName": "SHEARMAN, RALSTON, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "RAIS",
        "clearingBroker": "0443",
        "brokerName": "ROYAL AMERICAN INVESTMENT SERVICES, INC.                              "
    },
    {
        "type": "MUNI",
        "mpid": "RAIT",
        "clearingBroker": "0161",
        "brokerName": "RAIT SECURITIES                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "RAJA",
        "clearingBroker": "0725",
        "brokerName": "RAYMOND JAMES & ASSOCIATES, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "RAYG",
        "clearingBroker": "0443",
        "brokerName": "BOLTON GLOBAL CAPITAL                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "RBAC",
        "clearingBroker": "0235",
        "brokerName": "ROBERT B. AUSDAL & CO. INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "RBCD",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS CORPORATION                                       "
    },
    {
        "type": "MUNI",
        "mpid": "RBCX",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS CORPORATION                                       "
    },
    {
        "type": "MUNI",
        "mpid": "RBII",
        "clearingBroker": "0279",
        "brokerName": "REGIONAL BROKERS, INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "RBMU",
        "clearingBroker": "0279",
        "brokerName": "BLUM (ROBERT) MUNICIPALS INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "RCRS",
        "clearingBroker": "0226",
        "brokerName": "ROOSEVELT & CROSS, INCORPORATED                                       "
    },
    {
        "type": "MUNI",
        "mpid": "RCSK",
        "clearingBroker": "0642",
        "brokerName": "RUANE, CUNNIFF & GOLDBARB LLC                                         "
    },
    {
        "type": "MUNI",
        "mpid": "RDSS",
        "clearingBroker": "0141",
        "brokerName": "RDSC, LLC                                                             "
    },
    {
        "type": "MUNI",
        "mpid": "REID",
        "clearingBroker": "0141",
        "brokerName": "REID AND ASSOCIATES LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "REPG",
        "clearingBroker": "0443",
        "brokerName": "FIRST REPUBLIC GROUP, LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "REVL",
        "clearingBroker": "0750",
        "brokerName": "REVL SECURITIES, LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "RFRC",
        "clearingBroker": "0279",
        "brokerName": "THE ROCKWELL FINANCIAL GROUP, INC.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "RGIC",
        "clearingBroker": "0443",
        "brokerName": "R-G INVESTMENTS CORPORATION                                           "
    },
    {
        "type": "MUNI",
        "mpid": "RGLD",
        "clearingBroker": "0279",
        "brokerName": "REGAL SECURITIES, INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "RGLS",
        "clearingBroker": "0235",
        "brokerName": "REGAL SECURITIES, INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "RGWD",
        "clearingBroker": "0141",
        "brokerName": "RIDGEWOOD ASSOCIATES INC., NJ                                         "
    },
    {
        "type": "MUNI",
        "mpid": "RHCO",
        "clearingBroker": "0505",
        "brokerName": "TRUIST SECURITIES, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "RHDS",
        "clearingBroker": "0141",
        "brokerName": "RHODES SECURITIES, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "RHOX",
        "clearingBroker": "0005",
        "brokerName": "XR SECURITIES LLC                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "RIAP",
        "clearingBroker": "0443",
        "brokerName": "OSAIC SERVICES, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "RICE",
        "clearingBroker": "0235",
        "brokerName": "RICE FINANCIAL PRODUCTS COMPANY                                       "
    },
    {
        "type": "MUNI",
        "mpid": "RICJ",
        "clearingBroker": "0235",
        "brokerName": "RICE SECURITIES, LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "RICM",
        "clearingBroker": "0595",
        "brokerName": "RICE FINANCIAL PRODUCTS COMPANY                                       "
    },
    {
        "type": "MUNI",
        "mpid": "RIED",
        "clearingBroker": "0235",
        "brokerName": "RIEDL, FIRST SECURITIES COMPANY OF KANSAS                             "
    },
    {
        "type": "MUNI",
        "mpid": "RILY",
        "clearingBroker": "0226",
        "brokerName": "B. RILEY FBR, INC.                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "RINO",
        "clearingBroker": "0019",
        "brokerName": "RHINO TRADING PARTNERS, LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "RJFI",
        "clearingBroker": "0390",
        "brokerName": "RAYMOND JAMES & ASSOCIATES, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "RKWS",
        "clearingBroker": "0235",
        "brokerName": "ROCKWELL SECURITIES LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "RMAC",
        "clearingBroker": "0235",
        "brokerName": "RENAISSANCE MACRO SECURITIES, LLC                                     "
    },
    {
        "type": "MUNI",
        "mpid": "RMPI",
        "clearingBroker": "0141",
        "brokerName": "RICHARDS, MERRILL & PETERSON, INC.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "RMST",
        "clearingBroker": "0443",
        "brokerName": "R.M. STARK & CO., INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "ROAR",
        "clearingBroker": "0103",
        "brokerName": "DINOSAUR SECURITIES                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "ROBT",
        "clearingBroker": "0443",
        "brokerName": "ROBOTTI & COMPANY, LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "ROCH",
        "clearingBroker": "0443",
        "brokerName": "ROCHDALE SECURITIES, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "ROCK",
        "clearingBroker": "0226",
        "brokerName": "ROCKEFELLER FINANCIAL LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "RODE",
        "clearingBroker": "0443",
        "brokerName": "RODECKER & COMPANY, INVESTMENT BROKERS, INC.                          "
    },
    {
        "type": "MUNI",
        "mpid": "ROMO",
        "clearingBroker": "0141",
        "brokerName": "ROMANO BROTHERS AND COMPANY                                           "
    },
    {
        "type": "MUNI",
        "mpid": "RONI",
        "clearingBroker": "0005",
        "brokerName": "RONIN CAPITAL, LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "ROPK",
        "clearingBroker": "0443",
        "brokerName": "REINOSO & COMPANY, INCORPORATED                                       "
    },
    {
        "type": "MUNI",
        "mpid": "ROTB",
        "clearingBroker": "0235",
        "brokerName": "ROTH CAPITAL PARTNERS, LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "ROTH",
        "clearingBroker": "0161",
        "brokerName": "ROTH CAPITAL PARTNERS, LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "ROYL",
        "clearingBroker": "0443",
        "brokerName": "ROYAL ALLIANCE ASSOCIATES, INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "RQDR",
        "clearingBroker": "0235",
        "brokerName": "RQD* CLEARING LLC                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "RREZ",
        "clearingBroker": "0443",
        "brokerName": "SAMUEL A RAMIREZ & CO., INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "RRII",
        "clearingBroker": "0388",
        "brokerName": "ROBERTS & RYAN INVESTMENTS, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "RRPR",
        "clearingBroker": "0443",
        "brokerName": "SAMUEL A RAMIREZ, & CO., INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "RRUD",
        "clearingBroker": "0235",
        "brokerName": "REID & RUDIGER, LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "RSCM",
        "clearingBroker": "0235",
        "brokerName": "ROBERTSON STEPHENS CAPITAL MARKETS, LLC                               "
    },
    {
        "type": "MUNI",
        "mpid": "RSCO",
        "clearingBroker": "0443",
        "brokerName": "RAMIUS SECURITIES, LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "RSSE",
        "clearingBroker": "0443",
        "brokerName": "RUSSELL IMPLEMENTATION SERVICES INC. PART OF RUSSE                    "
    },
    {
        "type": "MUNI",
        "mpid": "RSWM",
        "clearingBroker": "0141",
        "brokerName": "RIVERSTONE WEALTH MANAGEMENT, INC.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "RVSI",
        "clearingBroker": "0103",
        "brokerName": "ROBERT VAN SECURITIES, INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "RWPS",
        "clearingBroker": "0443",
        "brokerName": "R.W. PRESSPRICH & CO.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "RWSM",
        "clearingBroker": "0279",
        "brokerName": "R.W. SMITH & ASSOCIATES, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "RYAN",
        "clearingBroker": "0443",
        "brokerName": "RYAN, BECK & CO.                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "SABF",
        "clearingBroker": "0161",
        "brokerName": "SAUDI AMERICAN BANK                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "SABS",
        "clearingBroker": "0443",
        "brokerName": "SABADELL SECURITIES USA, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "SAFS",
        "clearingBroker": "0750",
        "brokerName": "STERNE AGEE FINANCIAL SERVICES, INC.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "SAFX",
        "clearingBroker": "0235",
        "brokerName": "SAF FINANCIAL SECURITIES LLC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "SAGE",
        "clearingBroker": "0141",
        "brokerName": "SAGE, RUTTY & CO., INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "SALB",
        "clearingBroker": "0274",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC./SALOMON BROTHERS                        "
    },
    {
        "type": "MUNI",
        "mpid": "SALI",
        "clearingBroker": "0750",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "SAMI",
        "clearingBroker": "0226",
        "brokerName": "SAMI BROKERAGE LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "SAPA",
        "clearingBroker": "0141",
        "brokerName": "SAPERSTON ASSET MANAGEMENT INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "SARG",
        "clearingBroker": "0226",
        "brokerName": "PURSHE KAPLAN STERLING INVESTMENTS, INC.                              "
    },
    {
        "type": "MUNI",
        "mpid": "SAYB",
        "clearingBroker": "0103",
        "brokerName": "SAYBROOK CAPITAL CORPORATION                                          "
    },
    {
        "type": "MUNI",
        "mpid": "SBAM",
        "clearingBroker": "0443",
        "brokerName": "INVESTMENT PROFESSIONALS, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "SBER",
        "clearingBroker": "0013",
        "brokerName": "SANFORD C. BERNSTEIN & CO., LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "SBLS",
        "clearingBroker": "0235",
        "brokerName": "SAN BLAS SECURITIES LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "SBLT",
        "clearingBroker": "0226",
        "brokerName": "SUNBELT SECURITIES, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "SBRO",
        "clearingBroker": "0443",
        "brokerName": "STERN BROTHERS & CO.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "SBRT",
        "clearingBroker": "0226",
        "brokerName": "SIEBERT(MURIEL) & CO.,INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "SBRX",
        "clearingBroker": "0445",
        "brokerName": "MURIEL SIEBERT & CO., INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "SBSC",
        "clearingBroker": "0226",
        "brokerName": "SIEBERT CISNEROS SHANK & CO., L.L.C.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "SBSL",
        "clearingBroker": "1043",
        "brokerName": "STOCKBLOCK SECURITIES LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "SCAP",
        "clearingBroker": "0595",
        "brokerName": "STRONG CAPITAL MARKETS, LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "SCFL",
        "clearingBroker": "0443",
        "brokerName": "STANCHART SECURITES INTL, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "SCHM",
        "clearingBroker": "0443",
        "brokerName": "A. R. SCHMEIDLER & CO., INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "SCIL",
        "clearingBroker": "0052",
        "brokerName": "STRATEGIC CAPITAL INVESTMENTS, LLC                                    "
    },
    {
        "type": "MUNI",
        "mpid": "SCMC",
        "clearingBroker": "0096",
        "brokerName": "SCOTIA CAPITAL MARKETS (USA) INC.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "SCSI",
        "clearingBroker": "0370",
        "brokerName": "STANDARD CREDIT SECURITIES INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "SCSS",
        "clearingBroker": "0161",
        "brokerName": "STONECASTLE SECURITIES, LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "SCTI",
        "clearingBroker": "0443",
        "brokerName": "SECURITY CAPITAL BROKERAGE, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "SDIC",
        "clearingBroker": "0235",
        "brokerName": "SAUER DAZEY INVESTMENT CO.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "SEAP",
        "clearingBroker": "0226",
        "brokerName": "SEAPORT SECURITIES CORP.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "SEBR",
        "clearingBroker": "0158",
        "brokerName": "SENTINEL BROKERS COMPANY, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "SECS",
        "clearingBroker": "0161",
        "brokerName": "SECOND STREET SECURITIES, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "SEEL",
        "clearingBroker": "0443",
        "brokerName": "R. SEELAUS & CO., INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "SEFB",
        "clearingBroker": "0052",
        "brokerName": "SOUTHEAST INVESTMENTS, N.C., INC.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "SEGE",
        "clearingBroker": "0443",
        "brokerName": "SEGERDAHL & CO.                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "SEIB",
        "clearingBroker": "0158",
        "brokerName": "SEIBERT (J.D.) & COMPANY INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "SEMT",
        "clearingBroker": "7311",
        "brokerName": "MINT BROKERS                                                          "
    },
    {
        "type": "MUNI",
        "mpid": "SEPN",
        "clearingBroker": "0161",
        "brokerName": "SEAPINE SECURITIES LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "SERL",
        "clearingBroker": "0443",
        "brokerName": "SEARLE & CO.                                                          "
    },
    {
        "type": "MUNI",
        "mpid": "SESL",
        "clearingBroker": "0158",
        "brokerName": "SESLIA SECURITIES                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "SFCO",
        "clearingBroker": "0443",
        "brokerName": "SYMETRA INVESTMENT SERVICES, INC.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "SFGB",
        "clearingBroker": "0161",
        "brokerName": "SUSQUEHANNA FINANCIAL GROUP, LLP                                      "
    },
    {
        "type": "MUNI",
        "mpid": "SFPS",
        "clearingBroker": "0443",
        "brokerName": "SF INVESTMENTS, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "SFSI",
        "clearingBroker": "0235",
        "brokerName": "SUPERIOR FINANCIAL SERVICES, INC.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "SGAS",
        "clearingBroker": "0286",
        "brokerName": "SG AMERICAS SECURITIES, LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "SGBI",
        "clearingBroker": "0226",
        "brokerName": "SMITH, BROWN & GROOVER, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "SGFC",
        "clearingBroker": "0226",
        "brokerName": "SIGMA FINANCIAL CORPORATION                                           "
    },
    {
        "type": "MUNI",
        "mpid": "SGLC",
        "clearingBroker": "0235",
        "brokerName": "S.G. LONG & COMPANY                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "SGNL",
        "clearingBroker": "0279",
        "brokerName": "SIGNAL SECURITIES, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "SGOV",
        "clearingBroker": "0286",
        "brokerName": "SG AMERICAS SECURITIES, LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "SGSM",
        "clearingBroker": "1043",
        "brokerName": "SEAPORT GLOBAL SECURITIES LLC                                         "
    },
    {
        "type": "MUNI",
        "mpid": "SHOT",
        "clearingBroker": "0005",
        "brokerName": "SCHOTTENFELD GROUP LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "SHRR",
        "clearingBroker": "0443",
        "brokerName": "CARL P. SHERR AND CO., LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "SIBI",
        "clearingBroker": "0573",
        "brokerName": "SUNGARD INSITUTIONAL BROKERAGE, INC.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "SILK",
        "clearingBroker": "0161",
        "brokerName": "GOLDMAN SACHS EXECUTION & CLEARING, L.P.                              "
    },
    {
        "type": "MUNI",
        "mpid": "SIMC",
        "clearingBroker": "0443",
        "brokerName": "SECURITIES INDUSTRY MANAGEMENT CORP.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "SKFS",
        "clearingBroker": "0443",
        "brokerName": "HEFREN-TILLOTSON/SHELBY, KERN, FREDERICK AND SHELB                    "
    },
    {
        "type": "MUNI",
        "mpid": "SKTR",
        "clearingBroker": "0279",
        "brokerName": "STOCK TRADERS                                                         "
    },
    {
        "type": "MUNI",
        "mpid": "SLRD",
        "clearingBroker": "0226",
        "brokerName": "S.L. REED & COMPANY                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "SMCO",
        "clearingBroker": "0235",
        "brokerName": "SMITH, MOORE & CO.                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "SMHI",
        "clearingBroker": "0443",
        "brokerName": "SANDERS MORRIS HARRIS INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "SMHJ",
        "clearingBroker": "0141",
        "brokerName": "SANDERS MORRIS HARRIS INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "SMNS",
        "clearingBroker": "0226",
        "brokerName": "PARKLAND SECURITIES, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "SMPR",
        "clearingBroker": "0443",
        "brokerName": "SUMMIT BROKERAGE SERVICES, INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "SMRD",
        "clearingBroker": "0443",
        "brokerName": "SUMRIDGE PARTNERS, LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "SMRI",
        "clearingBroker": "0226",
        "brokerName": "SECURITIES MANAGEMENT & RESEARCH, INC.                                "
    },
    {
        "type": "MUNI",
        "mpid": "SNEX",
        "clearingBroker": "0750",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "SNTE",
        "clearingBroker": "0279",
        "brokerName": "SENATE SECURITIES                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "SNWS",
        "clearingBroker": "0443",
        "brokerName": "SNOWDEN ACCOUNT SERVICES, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "SOCO",
        "clearingBroker": "0443",
        "brokerName": "CAPITAL ONE SECURITIES, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "SORS",
        "clearingBroker": "0235",
        "brokerName": "SORSBY FINANCIAL CORP.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "SOVG",
        "clearingBroker": "8199",
        "brokerName": "SOVEREIGN GLOBAL ADVISORS, LLC                                        "
    },
    {
        "type": "MUNI",
        "mpid": "SPAC",
        "clearingBroker": "0793",
        "brokerName": "SIERRA PACIFIC SECURITIES, LLC                                        "
    },
    {
        "type": "MUNI",
        "mpid": "SPCS",
        "clearingBroker": "0052",
        "brokerName": "SPARTAN CAPITAL SECURITIES, LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "SPEN",
        "clearingBroker": "0443",
        "brokerName": "SPENCER CLARKE LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "SPEX",
        "clearingBroker": "0235",
        "brokerName": "INSPEREX LLC                                                          "
    },
    {
        "type": "MUNI",
        "mpid": "SPGS",
        "clearingBroker": "0443",
        "brokerName": "SEAPORT GLOBAL SECURITIES LLC                                         "
    },
    {
        "type": "MUNI",
        "mpid": "SPHN",
        "clearingBroker": "0443",
        "brokerName": "STEPHENS INC.                                                         "
    },
    {
        "type": "MUNI",
        "mpid": "SPLC",
        "clearingBroker": "0226",
        "brokerName": "SPIRE SECURITIES, LLC                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "SPLN",
        "clearingBroker": "8199",
        "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "SPOT",
        "clearingBroker": "0005",
        "brokerName": "SPOT TRADING                                                          "
    },
    {
        "type": "MUNI",
        "mpid": "SPSR",
        "clearingBroker": "0279",
        "brokerName": "STARK MUNICIPAL BROKERS                                               "
    },
    {
        "type": "MUNI",
        "mpid": "SPTD",
        "clearingBroker": "0052",
        "brokerName": "MINT GLOBAL MARKETS, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "SPTS",
        "clearingBroker": "0158",
        "brokerName": "SEVEN POINTS CAPITAL, LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "SPWM",
        "clearingBroker": "0443",
        "brokerName": "STILLPOINT WEALTH MANAGEMENT, LLC                                     "
    },
    {
        "type": "MUNI",
        "mpid": "SRAM",
        "clearingBroker": "0443",
        "brokerName": "SAMCO CAPITAL MARKETS, INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "SRBC",
        "clearingBroker": "0235",
        "brokerName": "SPIDERROCK EXS, LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "SSBS",
        "clearingBroker": "0189",
        "brokerName": "STATE STREET GLOBAL MARKETS, LLC                                      "
    },
    {
        "type": "MUNI",
        "mpid": "SSCO",
        "clearingBroker": "8457",
        "brokerName": "SAFRA SECURITIES LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "SSET",
        "clearingBroker": "0226",
        "brokerName": "SUNSET FINANCIAL SERVICES, INC                                        "
    },
    {
        "type": "MUNI",
        "mpid": "SSGC",
        "clearingBroker": "0226",
        "brokerName": "SIGNATURE SECURITIES                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "SSGI",
        "clearingBroker": "0443",
        "brokerName": "SETON SECURITIES GROUP, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "SSGM",
        "clearingBroker": "0226",
        "brokerName": "STATE STREET GLOBAL MARKETS, LLC                                      "
    },
    {
        "type": "MUNI",
        "mpid": "SSGR",
        "clearingBroker": "0443",
        "brokerName": "SHAREHOLDERS SERVICES GROUP INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "SSIN",
        "clearingBroker": "0226",
        "brokerName": "TRUIST INVESTMENT SERVICES, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "SSLC",
        "clearingBroker": "0279",
        "brokerName": "SANDERLIN SECURITIES, LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "SSLL",
        "clearingBroker": "0189",
        "brokerName": "STATE STREET GLOBAL MARKETS, LLC                                      "
    },
    {
        "type": "MUNI",
        "mpid": "SSNE",
        "clearingBroker": "0226",
        "brokerName": "SANTANDER SECURITIES LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "SSNG",
        "clearingBroker": "0443",
        "brokerName": "SISUNG SECURITIES CORPORATION                                         "
    },
    {
        "type": "MUNI",
        "mpid": "STAD",
        "clearingBroker": "0141",
        "brokerName": "STEELE ADVISORS, INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "STCM",
        "clearingBroker": "2095",
        "brokerName": "TRUIST SECURITIES, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "STEP",
        "clearingBroker": "0235",
        "brokerName": "FERRETTI GROUP, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "STFL",
        "clearingBroker": "0793",
        "brokerName": "STIFEL, NICOLAUS & COMPANY, INCORPORATED                              "
    },
    {
        "type": "MUNI",
        "mpid": "STGC",
        "clearingBroker": "0279",
        "brokerName": "STERLING GRACE MUNICIPAL SECURITIES CO                                "
    },
    {
        "type": "MUNI",
        "mpid": "STHR",
        "clearingBroker": "0388",
        "brokerName": "STORMHARBOUR SECURITIES LP                                            "
    },
    {
        "type": "MUNI",
        "mpid": "STND",
        "clearingBroker": "0279",
        "brokerName": "FIRST STANDARD FINANCIAL COMPANY LLC                                  "
    },
    {
        "type": "MUNI",
        "mpid": "STOX",
        "clearingBroker": "0445",
        "brokerName": "MURIEL SIEBERT & CO., LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "STRM",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "STRS",
        "clearingBroker": "0161",
        "brokerName": "STRATEGAS RESEARCH PARTNERS, LLC                                      "
    },
    {
        "type": "MUNI",
        "mpid": "STRT",
        "clearingBroker": "0352",
        "brokerName": "OCTAVUS, LLC                                                          "
    },
    {
        "type": "MUNI",
        "mpid": "STSI",
        "clearingBroker": "0235",
        "brokerName": "SPENCER TRASK VENTURES, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "STTR",
        "clearingBroker": "0443",
        "brokerName": "STATE TRUST INVESTMENTS INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "STTT",
        "clearingBroker": "0052",
        "brokerName": "STATETRUST INVESTMENTS INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "STUR",
        "clearingBroker": "0158",
        "brokerName": "STURDIVANT & CO., INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "STXW",
        "clearingBroker": "0443",
        "brokerName": "SA STONE WEALTH MANAGEMENT INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "STYO",
        "clearingBroker": "0443",
        "brokerName": "STONE & YOUNGBERG L.L.C.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "SUFI",
        "clearingBroker": "0551",
        "brokerName": "SUSQUEHANNA FINANCIAL GROUP, LLC                                      "
    },
    {
        "type": "MUNI",
        "mpid": "SUSQ",
        "clearingBroker": "0551",
        "brokerName": "SUSQUEHANNA CAPITAL GROUP                                             "
    },
    {
        "type": "MUNI",
        "mpid": "SUST",
        "clearingBroker": "0235",
        "brokerName": "SUNSTREET SECURITIES, LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "SWBC",
        "clearingBroker": "0443",
        "brokerName": "SWBC INVESTMENT SERVICES, LLC                                         "
    },
    {
        "type": "MUNI",
        "mpid": "SWSS",
        "clearingBroker": "0443",
        "brokerName": "SANCTUARY SECURITIES, INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "SWST",
        "clearingBroker": "0279",
        "brokerName": "HILLTOP SECURITIES INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "SWTX",
        "clearingBroker": "0443",
        "brokerName": "SWBT SECURITIES, INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "SYCA",
        "clearingBroker": "0443",
        "brokerName": "SYNDICATED CAPITAL, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "SZZI",
        "clearingBroker": "0141",
        "brokerName": "STOFAN, AGAZZI & COMPANY INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "TAFI",
        "clearingBroker": "0443",
        "brokerName": "NATHAN HALE CAPITAL, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "TAGB",
        "clearingBroker": "0052",
        "brokerName": "TAGLICH BROTHERS, INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "TAGC",
        "clearingBroker": "1043",
        "brokerName": "TELSEY ADVISORY GROUP LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "TAGD",
        "clearingBroker": "1043",
        "brokerName": "TELSEY ADVISORY GROUP LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "TASE",
        "clearingBroker": "0443",
        "brokerName": "TRADITION ASIEL SECURITIES INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "TBCL",
        "clearingBroker": "0750",
        "brokerName": "TRADE BRIDGE CAPITAL LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "TBCR",
        "clearingBroker": "0235",
        "brokerName": "TRADE BRIDGE CAPITAL LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "TBIA",
        "clearingBroker": "0158",
        "brokerName": "TRADIER BROKERAGE, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "TBRD",
        "clearingBroker": "0226",
        "brokerName": "THOROUGHBRED FINANCIAL SERVICES, LLC                                  "
    },
    {
        "type": "MUNI",
        "mpid": "TCBI",
        "clearingBroker": "0443",
        "brokerName": "TCBI SECURITIES, INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "TCMU",
        "clearingBroker": "0443",
        "brokerName": "TCM CAPITAL, INC.                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "TCPX",
        "clearingBroker": "0443",
        "brokerName": "TOUSSAINT CAPITAL PARTNERS, LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "TDCO",
        "clearingBroker": "0235",
        "brokerName": "THOMPSON DAVIS & CO., INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "TDNF",
        "clearingBroker": "2568",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "TDPA",
        "clearingBroker": "0226",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "TDSI",
        "clearingBroker": "2568",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "TFAI",
        "clearingBroker": "0226",
        "brokerName": "TRANSAMERICA FINANCIAL ADVISORS, INC.                                 "
    },
    {
        "type": "MUNI",
        "mpid": "TFAS",
        "clearingBroker": "0443",
        "brokerName": "TRADITION SECURITIES AND DERIVATIVES LLC                              "
    },
    {
        "type": "MUNI",
        "mpid": "TFSL",
        "clearingBroker": "0235",
        "brokerName": "TECKMEYER FINANCIAL SERVICES                                          "
    },
    {
        "type": "MUNI",
        "mpid": "TFSS",
        "clearingBroker": "0443",
        "brokerName": "TFS SECURITIES, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "TGHS",
        "clearingBroker": "0443",
        "brokerName": "TGH SECURITIES, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "THEM",
        "clearingBroker": "0235",
        "brokerName": "THEMIS TRADING LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "THIM",
        "clearingBroker": "0443",
        "brokerName": "LONGVIEW FINANCIAL GROUP INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "TIAN",
        "clearingBroker": "0226",
        "brokerName": "TRIAD SECURITIES CORP                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "TIBD",
        "clearingBroker": "6412",
        "brokerName": "TIB THE INDEPENDENT BANKERS BANK                                      "
    },
    {
        "type": "MUNI",
        "mpid": "TIBS",
        "clearingBroker": "0443",
        "brokerName": "TELEMUS INVESTMENT BROKERS, LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "TIGC",
        "clearingBroker": "0235",
        "brokerName": "NELSONREID, INC.                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "TIGE",
        "clearingBroker": "1043",
        "brokerName": "US TIGER SECURITIES, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "TLDX",
        "clearingBroker": "0226",
        "brokerName": "TULLETT LIBERTY SECURITIES, INC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "TMAS",
        "clearingBroker": "0235",
        "brokerName": "TRADEMAS INC.                                                         "
    },
    {
        "type": "MUNI",
        "mpid": "TMBI",
        "clearingBroker": "0141",
        "brokerName": "THURSTON SPRINGER FINANCIAL                                           "
    },
    {
        "type": "MUNI",
        "mpid": "TMBR",
        "clearingBroker": "0534",
        "brokerName": "IBKR SECURITIES SERVICES LLC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "TMBS",
        "clearingBroker": "0443",
        "brokerName": "TRADITION ASIEL SECURITIES INC.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "TMCC",
        "clearingBroker": "4264",
        "brokerName": "ICE BONDS SECURITIES CORPORATION                                      "
    },
    {
        "type": "MUNI",
        "mpid": "TMCD",
        "clearingBroker": "0235",
        "brokerName": "MCDONALD PARTNERS LLC                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "TOCQ",
        "clearingBroker": "0443",
        "brokerName": "TOCQUEVILLE SECURITIES L.P.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "TONE",
        "clearingBroker": "8199",
        "brokerName": "2021 CAPITAL                                                          "
    },
    {
        "type": "MUNI",
        "mpid": "TONG",
        "clearingBroker": "0443",
        "brokerName": "TONGE (R.M.) & COMPANY                                                "
    },
    {
        "type": "MUNI",
        "mpid": "TORO",
        "clearingBroker": "0279",
        "brokerName": "VALDES & MORENO, INC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "TOUR",
        "clearingBroker": "0005",
        "brokerName": "TOURMALINE PARTNERS, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "TOVC",
        "clearingBroker": "0235",
        "brokerName": "TOV CAPITAL MARKETS, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "TPIS",
        "clearingBroker": "0161",
        "brokerName": "TULLETT PREBON FINANCIAL SERVICES, LLC                                "
    },
    {
        "type": "MUNI",
        "mpid": "TPMG",
        "clearingBroker": "0005",
        "brokerName": "TOWER PRINCIPAL MARKETS LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "TPMR",
        "clearingBroker": "0141",
        "brokerName": "TRADE-PMR INC.                                                        "
    },
    {
        "type": "MUNI",
        "mpid": "TRAD",
        "clearingBroker": "0271",
        "brokerName": "TRADESTATION SECURITIES, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "TRCG",
        "clearingBroker": "0005",
        "brokerName": "TRC MARKETS LLC                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "TREX",
        "clearingBroker": "1043",
        "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
    },
    {
        "type": "MUNI",
        "mpid": "TRIB",
        "clearingBroker": "0235",
        "brokerName": "TRIBAL CAPITAL MARKETS, LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "TRIM",
        "clearingBroker": "0161",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "TRIN",
        "clearingBroker": "0141",
        "brokerName": "TRIANGLE SECURITIES, LLC                                              "
    },
    {
        "type": "MUNI",
        "mpid": "TRIP",
        "clearingBroker": "0235",
        "brokerName": "TRIDENT PARTNERS LTD                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "TRSH",
        "clearingBroker": "0279",
        "brokerName": "THRASHER & CHAMBERS, INC.                                             "
    },
    {
        "type": "MUNI",
        "mpid": "TRSQ",
        "clearingBroker": "0443",
        "brokerName": "TOWER SQUARE SECURITIES, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "TRUB",
        "clearingBroker": "0141",
        "brokerName": "TRUBEE, COLLINS & CO., INC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "TRWN",
        "clearingBroker": "0443",
        "brokerName": "T.R. WINSTON & COMPANY, LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "TRYN",
        "clearingBroker": "0279",
        "brokerName": "FIRST TRYON SECURITIES, LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "TSCD",
        "clearingBroker": "0235",
        "brokerName": "STURGES COMPANY (THE)                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "TSER",
        "clearingBroker": "0161",
        "brokerName": "TWO SIGMA EXECUTION SERVICES, LLC                                     "
    },
    {
        "type": "MUNI",
        "mpid": "TSFA",
        "clearingBroker": "0443",
        "brokerName": "STRATEGIC FINANCIAL ALLIANCE (THE)                                    "
    },
    {
        "type": "MUNI",
        "mpid": "TSSM",
        "clearingBroker": "0161",
        "brokerName": "TWO SIGMA SECURITIES, LLC                                             "
    },
    {
        "type": "MUNI",
        "mpid": "TTSC",
        "clearingBroker": "0052",
        "brokerName": "TREND TRADE SECURITIES LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "TTSI",
        "clearingBroker": "0158",
        "brokerName": "T3 SECURITIES, INC.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "TWDI",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "TWDL",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "TWDP",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "TWDR",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "TWDS",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "TWPL",
        "clearingBroker": "0793",
        "brokerName": "STIFEL, NICOLAUS & COMPANY, INCORPORATED                              "
    },
    {
        "type": "MUNI",
        "mpid": "UBII",
        "clearingBroker": "0221",
        "brokerName": "UBS INTERNATIONAL, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "UBKR",
        "clearingBroker": "6732",
        "brokerName": "UNITED BANKERS' BANK                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "UBSI",
        "clearingBroker": "0141",
        "brokerName": "UNITED BROKERAGE SERVICES, INC                                        "
    },
    {
        "type": "MUNI",
        "mpid": "UBSW",
        "clearingBroker": "0642",
        "brokerName": "UBS SECURITIES LLC                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "UMBF",
        "clearingBroker": "0226",
        "brokerName": "UMB FINANCIAL SERVICES, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "UMBI",
        "clearingBroker": "2451",
        "brokerName": "UMB BANK, NATIONAL ASSOCIATION                                        "
    },
    {
        "type": "MUNI",
        "mpid": "UNIB",
        "clearingBroker": "0443",
        "brokerName": "UNIBANCO SECURITIES INC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "UNIV",
        "clearingBroker": "0595",
        "brokerName": "UNIVEST SECURITIES, LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "UPLN",
        "clearingBroker": "0443",
        "brokerName": "UNITED PLANNERS FINANCIAL SERVICES OF AMERICA                         "
    },
    {
        "type": "MUNI",
        "mpid": "USCA",
        "clearingBroker": "0226",
        "brokerName": "USCA SECURITIES LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "USDB",
        "clearingBroker": "0279",
        "brokerName": "U.S. BROKERAGE, INC.                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "USFB",
        "clearingBroker": "0595",
        "brokerName": "U.S. FINANCIAL INVESTMENTS, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "USIC",
        "clearingBroker": "0226",
        "brokerName": "U.S. SECURITIES, INTL. CORP.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "USSI",
        "clearingBroker": "0279",
        "brokerName": "U.S. STERLING SECURITIES, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "USTZ",
        "clearingBroker": "0595",
        "brokerName": "TRADEZERO AMERINCA, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "UVST",
        "clearingBroker": "0443",
        "brokerName": "UVEST FINANCIAL SERVICES GROUP, INC.                                  "
    },
    {
        "type": "MUNI",
        "mpid": "VABD",
        "clearingBroker": "4264",
        "brokerName": "ICE BONDS SECURITIES CORPORATION                                      "
    },
    {
        "type": "MUNI",
        "mpid": "VALI",
        "clearingBroker": "0226",
        "brokerName": "VALLEY NATIONAL INVESTMENTS, INC.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "VBCS",
        "clearingBroker": "0279",
        "brokerName": "VBC SECURITIES                                                        "
    },
    {
        "type": "MUNI",
        "mpid": "VBLT",
        "clearingBroker": "0226",
        "brokerName": "VANDERBILT SECURITIES, LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "VCAS",
        "clearingBroker": "0443",
        "brokerName": "VCA SECURITIES, LP                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "VCFN",
        "clearingBroker": "0235",
        "brokerName": "VAN CLEMENS & CO. INCORPORATED                                        "
    },
    {
        "type": "MUNI",
        "mpid": "VCMM",
        "clearingBroker": "0279",
        "brokerName": "VIRTUS CAPITAL MARKETS LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "VCMS",
        "clearingBroker": "0443",
        "brokerName": "VCM SECURITIES, LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "VCSV",
        "clearingBroker": "0052",
        "brokerName": "PRIMARY CAPITAL, LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "VERF",
        "clearingBroker": "0235",
        "brokerName": "THE VERTICAL TRADING GROUP, LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "VERT",
        "clearingBroker": "8199",
        "brokerName": "THE VERTICAL TRADING GROUP, LLC                                       "
    },
    {
        "type": "MUNI",
        "mpid": "VEST",
        "clearingBroker": "0750",
        "brokerName": "VESTECH SECURITIES, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "VETS",
        "clearingBroker": "0235",
        "brokerName": "AMERICAN VETERANS GROUP, PBC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "VGRD",
        "clearingBroker": "0062",
        "brokerName": "VANGUARD MARKETING CORPORATION                                        "
    },
    {
        "type": "MUNI",
        "mpid": "VISI",
        "clearingBroker": "0443",
        "brokerName": "VISION INVESTMENT SERVICES, INC.                                      "
    },
    {
        "type": "MUNI",
        "mpid": "VKMI",
        "clearingBroker": "0692",
        "brokerName": "INVESCO CAPITAL MARKETS, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "VLYF",
        "clearingBroker": "0443",
        "brokerName": "VALLEY FORGE ASSET MANAGEMENT                                         "
    },
    {
        "type": "MUNI",
        "mpid": "VMEX",
        "clearingBroker": "0443",
        "brokerName": "VECTORGLOBAL WMG                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "VOLS",
        "clearingBroker": "2447",
        "brokerName": "HOME FINANCIAL SERVICES INC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "VPEW",
        "clearingBroker": "0158",
        "brokerName": "VPE WERTPAPIERHANDELSBANK AG                                          "
    },
    {
        "type": "MUNI",
        "mpid": "VSIN",
        "clearingBroker": "0595",
        "brokerName": "VISION FINANCIAL MARKETS LLC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "VSLP",
        "clearingBroker": "6043",
        "brokerName": "VINING-SPARKS IBG, L.P.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "VTDT",
        "clearingBroker": "0158",
        "brokerName": "VIEWTRADE SECURITIES, INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "VTRN",
        "clearingBroker": "0443",
        "brokerName": "BANCROFT CAPITAL, LLC                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "WABR",
        "clearingBroker": "0443",
        "brokerName": "WALL STREET ACCESS                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "WACC",
        "clearingBroker": "0279",
        "brokerName": "MIDLAND SECURITIES, LTD                                               "
    },
    {
        "type": "MUNI",
        "mpid": "WACL",
        "clearingBroker": "0709",
        "brokerName": "WACHTEL & CO., INC.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "WARF",
        "clearingBroker": "0235",
        "brokerName": "WARD'S FINANCIAL SERVICES, LTD.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "WBAX",
        "clearingBroker": "0052",
        "brokerName": "WALLACHBETH CAPITAL LLC                                               "
    },
    {
        "type": "MUNI",
        "mpid": "WBBC",
        "clearingBroker": "0226",
        "brokerName": "WBB SECURITIES, LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "WBFS",
        "clearingBroker": "0443",
        "brokerName": "WOODBURY FINANCIAL SERVICES, INC.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "WBLR",
        "clearingBroker": "0771",
        "brokerName": "WILLIAM BLAIR & COMPANY, L.L.C.                                       "
    },
    {
        "type": "MUNI",
        "mpid": "WBNA",
        "clearingBroker": "2072",
        "brokerName": "WELLS FARGO BANK, N.A./SIG                                            "
    },
    {
        "type": "MUNI",
        "mpid": "WBNF",
        "clearingBroker": "0226",
        "brokerName": "WILLIAM BLAIR & COMPANY L.L.C.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "WBRO",
        "clearingBroker": "0443",
        "brokerName": "WILEY BROS.-AINTREE CAPITAL, LLC                                      "
    },
    {
        "type": "MUNI",
        "mpid": "WCHV",
        "clearingBroker": "0250",
        "brokerName": "WELLS FARGO SECURITIES, LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "WCIG",
        "clearingBroker": "0750",
        "brokerName": "WILLOW COVE INVESTMENT GROUP, INC.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "WCIS",
        "clearingBroker": "0443",
        "brokerName": "WESCORP INVESTMENT SERVICES, LLC                                      "
    },
    {
        "type": "MUNI",
        "mpid": "WCSC",
        "clearingBroker": "0235",
        "brokerName": "WILMINGTON CAPITAL SECURITIES, LLC                                    "
    },
    {
        "type": "MUNI",
        "mpid": "WCSF",
        "clearingBroker": "0235",
        "brokerName": "WORLD CHOICE SECURITIES, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "WEBS",
        "clearingBroker": "0226",
        "brokerName": "WEALTH ENHANCEMENT BROKERAGE SERVICES, LLC                            "
    },
    {
        "type": "MUNI",
        "mpid": "WEDB",
        "clearingBroker": "0103",
        "brokerName": "WEDBUSH SECURITIES INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "WEGE",
        "clearingBroker": "0443",
        "brokerName": "WORLD EQUITY GROUP, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "WEGI",
        "clearingBroker": "0235",
        "brokerName": "WORLD EQUITY GROUP INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "WEGP",
        "clearingBroker": "0235",
        "brokerName": "WESTERN EQUITY GROUP, INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "WEIL",
        "clearingBroker": "0226",
        "brokerName": "THE WEIL COMPANY, INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "WELD",
        "clearingBroker": "0443",
        "brokerName": "WHITE, WELD & CO. SECURITIES, LLC                                     "
    },
    {
        "type": "MUNI",
        "mpid": "WESC",
        "clearingBroker": "0443",
        "brokerName": "WELLINGTON SHIELDS & CO., LLC                                         "
    },
    {
        "type": "MUNI",
        "mpid": "WEXR",
        "clearingBroker": "0235",
        "brokerName": "WOLVERINE EXECUTION SERVICES, LLC                                     "
    },
    {
        "type": "MUNI",
        "mpid": "WEXX",
        "clearingBroker": "0005",
        "brokerName": "WOLVERINE EXECUTION SERVICES                                          "
    },
    {
        "type": "MUNI",
        "mpid": "WFPB",
        "clearingBroker": "0250",
        "brokerName": "WELLS FARGO SECURITIES, LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "WGWD",
        "clearingBroker": "0158",
        "brokerName": "WEDGEWOOD PARTNERS, INC.                                              "
    },
    {
        "type": "MUNI",
        "mpid": "WHAE",
        "clearingBroker": "0158",
        "brokerName": "WHARTON EQUITY CORPORATION                                            "
    },
    {
        "type": "MUNI",
        "mpid": "WHBB",
        "clearingBroker": "0537",
        "brokerName": "BGC FINANCIAL INC.                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "WHOT",
        "clearingBroker": "0595",
        "brokerName": "JUST2TRADE, INC.                                                      "
    },
    {
        "type": "MUNI",
        "mpid": "WIDS",
        "clearingBroker": "0279",
        "brokerName": "WISCONSIN DISCOUNT SECURITIES CORP.                                   "
    },
    {
        "type": "MUNI",
        "mpid": "WING",
        "clearingBroker": "0443",
        "brokerName": "ING FINANCIAL PARTNERS, INC.                                          "
    },
    {
        "type": "MUNI",
        "mpid": "WISC",
        "clearingBroker": "0226",
        "brokerName": "WINDSOR, SHEFFIELD & CO., INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "WISE",
        "clearingBroker": "0052",
        "brokerName": "AXOS INVEST LLC                                                       "
    },
    {
        "type": "MUNI",
        "mpid": "WISP",
        "clearingBroker": "0443",
        "brokerName": "WESTERN INTERNATIONAL SECURITIES, INC.                                "
    },
    {
        "type": "MUNI",
        "mpid": "WLTH",
        "clearingBroker": "0235",
        "brokerName": "WEALTHFRONT BROKERAGE CORPORATION                                     "
    },
    {
        "type": "MUNI",
        "mpid": "WMCL",
        "clearingBroker": "0279",
        "brokerName": "WHITE MOUNTAIN CAPITAL, LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "WMFS",
        "clearingBroker": "0226",
        "brokerName": "WESTMINSTER FINANCIAL SECURITIES, INC.                                "
    },
    {
        "type": "MUNI",
        "mpid": "WMLL",
        "clearingBroker": "0005",
        "brokerName": "WATERMILL INSTITUTIONAL TRADING LLC                                   "
    },
    {
        "type": "MUNI",
        "mpid": "WNUT",
        "clearingBroker": "0443",
        "brokerName": "WALNUT STREET SECURITIES, INC.                                        "
    },
    {
        "type": "MUNI",
        "mpid": "WOHU",
        "clearingBroker": "0537",
        "brokerName": "BGC FINANCIAL, L.P.                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "WPCC",
        "clearingBroker": "0052",
        "brokerName": "WESTPARK CAPITAL, INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "WPCI",
        "clearingBroker": "0595",
        "brokerName": "WESTPARK CAPITAL, INC.                                                "
    },
    {
        "type": "MUNI",
        "mpid": "WPSG",
        "clearingBroker": "0005",
        "brokerName": "WEEDEN PRIME SERVICES, LLC.                                           "
    },
    {
        "type": "MUNI",
        "mpid": "WPST",
        "clearingBroker": "0443",
        "brokerName": "W.P. STEWART SECURITIES LIMITED                                       "
    },
    {
        "type": "MUNI",
        "mpid": "WPSX",
        "clearingBroker": "0445",
        "brokerName": "RISE FINANCIAL SERVICES, LLC                                          "
    },
    {
        "type": "MUNI",
        "mpid": "WRET",
        "clearingBroker": "0141",
        "brokerName": "WELLS FARGO CLEARING SERVICES, LLC                                    "
    },
    {
        "type": "MUNI",
        "mpid": "WRIS",
        "clearingBroker": "0141",
        "brokerName": "SMH CAPITAL INVESTMENTS LLC                                           "
    },
    {
        "type": "MUNI",
        "mpid": "WRLD",
        "clearingBroker": "0235",
        "brokerName": "HUNTER WORLD MARKETS, INC.                                            "
    },
    {
        "type": "MUNI",
        "mpid": "WSCC",
        "clearingBroker": "0235",
        "brokerName": "WASHINGTON SECURITIES CORPORATION                                     "
    },
    {
        "type": "MUNI",
        "mpid": "WSCX",
        "clearingBroker": "0235",
        "brokerName": "WORKMAN SECURITIES CORP                                               "
    },
    {
        "type": "MUNI",
        "mpid": "WSEC",
        "clearingBroker": "0443",
        "brokerName": "WILLIS SECURITIES, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "WSGD",
        "clearingBroker": "8199",
        "brokerName": "WEDBUSH SECURITIES INC./P3                                            "
    },
    {
        "type": "MUNI",
        "mpid": "WSIW",
        "clearingBroker": "8199",
        "brokerName": "WEDBUSH SECURITIES INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "WSMC",
        "clearingBroker": "0443",
        "brokerName": "WALL STREET MANAGEMENT CORPORATION                                    "
    },
    {
        "type": "MUNI",
        "mpid": "WSRP",
        "clearingBroker": "0052",
        "brokerName": "WESTROCK CAPITAL MANAGEMENT, INC.                                     "
    },
    {
        "type": "MUNI",
        "mpid": "WSTI",
        "clearingBroker": "0226",
        "brokerName": "WESTERN INTERNATIONAL SECURITIES, INC.                                "
    },
    {
        "type": "MUNI",
        "mpid": "WSWW",
        "clearingBroker": "0443",
        "brokerName": "WESTMINSTER SECURITIES CORPORATION                                    "
    },
    {
        "type": "MUNI",
        "mpid": "WTCO",
        "clearingBroker": "0050",
        "brokerName": "WILLIAMS TRADING LLC                                                  "
    },
    {
        "type": "MUNI",
        "mpid": "WTFS",
        "clearingBroker": "0052",
        "brokerName": "LIME TRADING CORP                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "WTLP",
        "clearingBroker": "0388",
        "brokerName": "WOLVERINE TRADING, LLC                                                "
    },
    {
        "type": "MUNI",
        "mpid": "WTRI",
        "clearingBroker": "0235",
        "brokerName": "WATERFORD INVESTORS SERVICES, INC.                                    "
    },
    {
        "type": "MUNI",
        "mpid": "WUND",
        "clearingBroker": "0141",
        "brokerName": "B. RILEY WEALTH MANAGEMENT                                            "
    },
    {
        "type": "MUNI",
        "mpid": "WVBD",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "WVEX",
        "clearingBroker": "0161",
        "brokerName": "MERRILL LYNCH PIERCE FENNER & SMITH INCORPOTATED                      "
    },
    {
        "type": "MUNI",
        "mpid": "XCNC",
        "clearingBroker": "0005",
        "brokerName": "C&C TRADING L.L.C.                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "XRVR",
        "clearingBroker": "0279",
        "brokerName": "CRB SECURITIES, LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "XTXE",
        "clearingBroker": "0161",
        "brokerName": "XTX EXECUTION SERVICES LLC                                            "
    },
    {
        "type": "MUNI",
        "mpid": "YLPL",
        "clearingBroker": "0075",
        "brokerName": "LPL FINANCIAL LLC                                                     "
    },
    {
        "type": "MUNI",
        "mpid": "YOSE",
        "clearingBroker": "0052",
        "brokerName": "YORK SECURITIES, INC.                                                 "
    },
    {
        "type": "MUNI",
        "mpid": "ZEDB",
        "clearingBroker": "0161",
        "brokerName": "INVESCO CAPITAL MARKETS, INC.                                         "
    },
    {
        "type": "MUNI",
        "mpid": "ZERO",
        "clearingBroker": "0158",
        "brokerName": "TRADEZERO AMERICA, INC.                                               "
    },
    {
        "type": "MUNI",
        "mpid": "ZEUS",
        "clearingBroker": "0443",
        "brokerName": "ZEUS FINANCIAL, LLC                                                   "
    },
    {
        "type": "MUNI",
        "mpid": "ZFNB",
        "clearingBroker": "2104",
        "brokerName": "ZB, NATIONAL ASSOCIATION                                              "
    },
    {
        "type": "MUNI",
        "mpid": "ZION",
        "clearingBroker": "0065",
        "brokerName": "ZIONS DIRECT, INC.                                                    "
    },
    {
        "type": "MUNI",
        "mpid": "ZIVI",
        "clearingBroker": "0235",
        "brokerName": "ZIV INVESTMENT COMPANY                                                "
    },
    {
        "type": "MUNI",
        "mpid": "ZOUL",
        "clearingBroker": "0235",
        "brokerName": "N.B. ZOULLAS SECURITIES, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "AALC",
        "clearingBroker": "0226",
        "brokerName": "THRIVENT INVESTMENT MANAGEMENT, INC.                                  "
    },
    {
        "type": "UIT",
        "mpid": "ABAI",
        "clearingBroker": "0279",
        "brokerName": "ABACUS INVESTMENTS, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "ABBA",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "UIT",
        "mpid": "ABBK",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "UIT",
        "mpid": "ABDA",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "UIT",
        "mpid": "ABDW",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "UIT",
        "mpid": "ABEA",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "UIT",
        "mpid": "ABEN",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "UIT",
        "mpid": "ABHE",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "UIT",
        "mpid": "ABIG",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "UIT",
        "mpid": "ABPR",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "UIT",
        "mpid": "ABRP",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "UIT",
        "mpid": "ABST",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "UIT",
        "mpid": "ACAP",
        "clearingBroker": "0235",
        "brokerName": "ALAMO CAPITAL                                                         "
    },
    {
        "type": "UIT",
        "mpid": "ACCP",
        "clearingBroker": "0158",
        "brokerName": "AEGIS CAPITAL CORP.                                                   "
    },
    {
        "type": "UIT",
        "mpid": "ACCU",
        "clearingBroker": "0052",
        "brokerName": "ATB CAPITAL MARKETS USA INC.                                          "
    },
    {
        "type": "UIT",
        "mpid": "ACII",
        "clearingBroker": "0158",
        "brokerName": "ARCA CAPITAL INVESTMENTS, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "ACLP",
        "clearingBroker": "0235",
        "brokerName": "ALEXANDER CAPITAL, L.P.                                               "
    },
    {
        "type": "UIT",
        "mpid": "ACPL",
        "clearingBroker": "0235",
        "brokerName": "AMERICAN CAPITAL PARTNERS                                             "
    },
    {
        "type": "UIT",
        "mpid": "ACPS",
        "clearingBroker": "0443",
        "brokerName": "ACP SECURITIES LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "ACRN",
        "clearingBroker": "0235",
        "brokerName": "ACORNS SECURITIES, LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "ACTI",
        "clearingBroker": "0443",
        "brokerName": "ACTIVNER SECURITIES, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "ADSO",
        "clearingBroker": "0141",
        "brokerName": "PROSPERA FINANCIAL SERVICES, INC.                                     "
    },
    {
        "type": "UIT",
        "mpid": "AEFS",
        "clearingBroker": "0226",
        "brokerName": "AE FINANCIAL SERVICES, LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "AEXG",
        "clearingBroker": "0158",
        "brokerName": "ALTERNATIVE EXECUTION GROUP                                           "
    },
    {
        "type": "UIT",
        "mpid": "AFBS",
        "clearingBroker": "0158",
        "brokerName": "APEX FINTECH BROKERAGE SERVICES LLC                                   "
    },
    {
        "type": "UIT",
        "mpid": "AFSL",
        "clearingBroker": "0443",
        "brokerName": "SORRENTO PACIFIC FINANCIAL                                            "
    },
    {
        "type": "UIT",
        "mpid": "AFSS",
        "clearingBroker": "0750",
        "brokerName": "FOUR POINTS CAPITAL PARTNERS LLC                                      "
    },
    {
        "type": "UIT",
        "mpid": "AGCO",
        "clearingBroker": "0052",
        "brokerName": "AUERBACH GRAYSON & COMPANY LLC                                        "
    },
    {
        "type": "UIT",
        "mpid": "AGCP",
        "clearingBroker": "0052",
        "brokerName": "AEGIS CAPITAL CORP.                                                   "
    },
    {
        "type": "UIT",
        "mpid": "AGES",
        "clearingBroker": "0750",
        "brokerName": "ADVISORY GROUP EQUITY SERVICES LTD.                                   "
    },
    {
        "type": "UIT",
        "mpid": "AGIS",
        "clearingBroker": "0235",
        "brokerName": "AEGIS CAPITAL CORP.                                                   "
    },
    {
        "type": "UIT",
        "mpid": "AGSS",
        "clearingBroker": "0443",
        "brokerName": "GREAT AMERICAN ADVISORS, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "AHSI",
        "clearingBroker": "0141",
        "brokerName": "AMERICAN HERITAGE SECURITIES, INC.                                    "
    },
    {
        "type": "UIT",
        "mpid": "AIGF",
        "clearingBroker": "0443",
        "brokerName": "OSAIC WEALTH, INC.                                                    "
    },
    {
        "type": "UIT",
        "mpid": "AIGN",
        "clearingBroker": "0226",
        "brokerName": "OSAIC WEALTH, INC.                                                    "
    },
    {
        "type": "UIT",
        "mpid": "AISG",
        "clearingBroker": "0235",
        "brokerName": "AMERICAN INDEPENDENT SECURITIES GROUP, LLC                            "
    },
    {
        "type": "UIT",
        "mpid": "AJCO",
        "clearingBroker": "0443",
        "brokerName": "IDB CAPITAL CORP.                                                     "
    },
    {
        "type": "UIT",
        "mpid": "ALCG",
        "clearingBroker": "0235",
        "brokerName": "ALTITUDE CAPITAL GROUP LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "ALCM",
        "clearingBroker": "0279",
        "brokerName": "ALPHALEDGER MARKETS, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "ALDN",
        "clearingBroker": "0052",
        "brokerName": "J. ALDEN ASSOCIATES, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "ALGP",
        "clearingBroker": "0235",
        "brokerName": "A.G.P. / ALLIANCE GLOBAL PARTNERS                                     "
    },
    {
        "type": "UIT",
        "mpid": "ALGR",
        "clearingBroker": "0158",
        "brokerName": "ALGER (FRED) & CO INC                                                 "
    },
    {
        "type": "UIT",
        "mpid": "ALIS",
        "clearingBroker": "0235",
        "brokerName": "ALEXANDER INVESTMENT SERVICES CO.                                     "
    },
    {
        "type": "UIT",
        "mpid": "ALLN",
        "clearingBroker": "0443",
        "brokerName": "ALLEN & COMPANY LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "ALNC",
        "clearingBroker": "0226",
        "brokerName": "A.G.P./ALLIANCE GLOBAL PARTNERS                                       "
    },
    {
        "type": "UIT",
        "mpid": "ALTR",
        "clearingBroker": "3164",
        "brokerName": "ALTRUIST FINANCIAL LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "AMBB",
        "clearingBroker": "0141",
        "brokerName": "ALLEN, MOONEY & BARNES BROKERAGE SERVICES, LLC                        "
    },
    {
        "type": "UIT",
        "mpid": "AMER",
        "clearingBroker": "0235",
        "brokerName": "AMERICAN TRUST INVESTMENT SERVICES, INC.                              "
    },
    {
        "type": "UIT",
        "mpid": "AMIC",
        "clearingBroker": "0226",
        "brokerName": "AMERICAN INVESTORS COMPANY                                            "
    },
    {
        "type": "UIT",
        "mpid": "AMLU",
        "clearingBroker": "3652",
        "brokerName": "LUCID CAPITAL MARKETS, LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "AMMS",
        "clearingBroker": "0141",
        "brokerName": "AMUNI FINANCIAL, INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "AMRG",
        "clearingBroker": "0443",
        "brokerName": "WORLD CAPITAL BROKERAGE, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "ANDB",
        "clearingBroker": "0443",
        "brokerName": "ANDBANC BROKERAGE, LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "ANDG",
        "clearingBroker": "0235",
        "brokerName": "GARRETT (ANDREW), INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "ANOS",
        "clearingBroker": "0235",
        "brokerName": "ABEL NOSER, LLC.                                                      "
    },
    {
        "type": "UIT",
        "mpid": "ANOV",
        "clearingBroker": "0750",
        "brokerName": "ANOVEST FINANCIAL SERVICES, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "AOCS",
        "clearingBroker": "0388",
        "brokerName": "AOC SECURITIES                                                        "
    },
    {
        "type": "UIT",
        "mpid": "AONC",
        "clearingBroker": "0443",
        "brokerName": "AON BENFIELD SECURITIES                                               "
    },
    {
        "type": "UIT",
        "mpid": "AORP",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "UIT",
        "mpid": "AOSD",
        "clearingBroker": "0158",
        "brokerName": "TRADING BLOCK                                                         "
    },
    {
        "type": "UIT",
        "mpid": "APBD",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "UIT",
        "mpid": "APBO",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "UIT",
        "mpid": "APFS",
        "clearingBroker": "0443",
        "brokerName": "AMERICA'S PORTFOLIO'S                                                 "
    },
    {
        "type": "UIT",
        "mpid": "APRT",
        "clearingBroker": "0226",
        "brokerName": "PARTNERS                                                              "
    },
    {
        "type": "UIT",
        "mpid": "APXO",
        "clearingBroker": "0158",
        "brokerName": "APEX CLEARING CORPORATION                                             "
    },
    {
        "type": "UIT",
        "mpid": "APXS",
        "clearingBroker": "0052",
        "brokerName": "APEXUS CAPITAL LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "ARBC",
        "clearingBroker": "0235",
        "brokerName": "ARKADIOS CAPITAL                                                      "
    },
    {
        "type": "UIT",
        "mpid": "ARCD",
        "clearingBroker": "0443",
        "brokerName": "ARCADIA SECURITIES, LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "ARKA",
        "clearingBroker": "0443",
        "brokerName": "ARKA SECURITIES, INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "ARKI",
        "clearingBroker": "0226",
        "brokerName": "ARKADIOS CAPITAL                                                      "
    },
    {
        "type": "UIT",
        "mpid": "ARUS",
        "clearingBroker": "0158",
        "brokerName": "AUTONOMOUS RESEARCH US LP                                             "
    },
    {
        "type": "UIT",
        "mpid": "ARVS",
        "clearingBroker": "0443",
        "brokerName": "ARVEST WEALTH MANAGEMENT                                              "
    },
    {
        "type": "UIT",
        "mpid": "ASCM",
        "clearingBroker": "0052",
        "brokerName": "ASCENDIANT CAPITAL MARKETS, LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "ASCP",
        "clearingBroker": "0443",
        "brokerName": "BOK FINANCIAL SECURITIES                                              "
    },
    {
        "type": "UIT",
        "mpid": "ASII",
        "clearingBroker": "0226",
        "brokerName": "AURORA SECURITIES                                                     "
    },
    {
        "type": "UIT",
        "mpid": "ASOI",
        "clearingBroker": "0226",
        "brokerName": "ASSOCIATED INVESTMENT SERVICES, INC.                                  "
    },
    {
        "type": "UIT",
        "mpid": "ATIS",
        "clearingBroker": "0052",
        "brokerName": "AMERICAN TRUST INVESTMENT SERVICES, INC.                              "
    },
    {
        "type": "UIT",
        "mpid": "ATMC",
        "clearingBroker": "0100",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "ATRU",
        "clearingBroker": "0158",
        "brokerName": "ATREYU TRADING                                                        "
    },
    {
        "type": "UIT",
        "mpid": "ATVT",
        "clearingBroker": "0443",
        "brokerName": "ATOMIC BROKERAGE LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "AULC",
        "clearingBroker": "0443",
        "brokerName": "ONEAMERICA SECURITIES, INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "AVEN",
        "clearingBroker": "0226",
        "brokerName": "AVENTURA SECURITIES, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "AVIL",
        "clearingBroker": "0158",
        "brokerName": "AVANZA CAPITAL MARKETS INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "AVML",
        "clearingBroker": "0443",
        "brokerName": "AVM, L.P.                                                             "
    },
    {
        "type": "UIT",
        "mpid": "AVST",
        "clearingBroker": "0235",
        "brokerName": "ATOMIC BROKERAGE LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "AXAA",
        "clearingBroker": "0075",
        "brokerName": "AXA ADVISORS LLC                                                      "
    },
    {
        "type": "UIT",
        "mpid": "AXCB",
        "clearingBroker": "0443",
        "brokerName": "ACCESS SECURITIES                                                     "
    },
    {
        "type": "UIT",
        "mpid": "AXCL",
        "clearingBroker": "0052",
        "brokerName": "AXOS CLEARING LLC                                                     "
    },
    {
        "type": "UIT",
        "mpid": "AXCS",
        "clearingBroker": "0443",
        "brokerName": "ACCESS SECURITIES INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "AXGP",
        "clearingBroker": "0443",
        "brokerName": "ACCESS SECURITIES, LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "AXIO",
        "clearingBroker": "0279",
        "brokerName": "AXIOM CAPITAL MANAGEMENT, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "AXOS",
        "clearingBroker": "0052",
        "brokerName": "AXOS CLEARING LLC                                                     "
    },
    {
        "type": "UIT",
        "mpid": "AXTN",
        "clearingBroker": "0052",
        "brokerName": "AX TRADING, LLC                                                       "
    },
    {
        "type": "UIT",
        "mpid": "BAKR",
        "clearingBroker": "0443",
        "brokerName": "JAMES BAKER & ASSOCIATES, L.P.                                        "
    },
    {
        "type": "UIT",
        "mpid": "BALE",
        "clearingBroker": "0443",
        "brokerName": "M&T SECURITIES, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "BALS",
        "clearingBroker": "0750",
        "brokerName": "BRUCE A. LEFAVI SECURITIES, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "BANK",
        "clearingBroker": "0701",
        "brokerName": "CETERA INVESTMENT SERVICES LLC                                        "
    },
    {
        "type": "UIT",
        "mpid": "BARC",
        "clearingBroker": "0388",
        "brokerName": "BARCLAY                                                               "
    },
    {
        "type": "UIT",
        "mpid": "BARD",
        "clearingBroker": "0547",
        "brokerName": "ROBERT W. BAIRD & CO. INCORPORATED                                    "
    },
    {
        "type": "UIT",
        "mpid": "BARR",
        "clearingBroker": "0226",
        "brokerName": "BARRETT & COMPANY                                                     "
    },
    {
        "type": "UIT",
        "mpid": "BAYP",
        "clearingBroker": "0161",
        "brokerName": "BAY CREST PARTNERS, LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "BBAR",
        "clearingBroker": "0595",
        "brokerName": "BUCKMAN, BUCKMAN & REID, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "BBGC",
        "clearingBroker": "0235",
        "brokerName": "GRAHAM (B.B.) & COMPANY                                               "
    },
    {
        "type": "UIT",
        "mpid": "BBNI",
        "clearingBroker": "0443",
        "brokerName": "PERFORMANCE TRUST CAPITAL PARTNERS, INC.                              "
    },
    {
        "type": "UIT",
        "mpid": "BCCS",
        "clearingBroker": "0443",
        "brokerName": "BAC FLORIDA INVESTMENTS CORP.                                         "
    },
    {
        "type": "UIT",
        "mpid": "BCGS",
        "clearingBroker": "0443",
        "brokerName": "BCG SECURITIES, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "BCIB",
        "clearingBroker": "0443",
        "brokerName": "BCI SECURITIES, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "BCSA",
        "clearingBroker": "0443",
        "brokerName": "BCS AMERICAS, INC.                                                    "
    },
    {
        "type": "UIT",
        "mpid": "BCWM",
        "clearingBroker": "4077",
        "brokerName": "BETA CAPITAL SECURITIES LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "BCZC",
        "clearingBroker": "0443",
        "brokerName": "ZIEGLER (B.C.) & COMPANY                                              "
    },
    {
        "type": "UIT",
        "mpid": "BDBS",
        "clearingBroker": "0443",
        "brokerName": "BANCO DO BRASIL SECURITIES                                            "
    },
    {
        "type": "UIT",
        "mpid": "BDDK",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "BDIR",
        "clearingBroker": "0443",
        "brokerName": "JEFFERIES LLC                                                         "
    },
    {
        "type": "UIT",
        "mpid": "BDTR",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "BEAF",
        "clearingBroker": "0235",
        "brokerName": "BEACONSFIELD FINANCIAL SERV.                                          "
    },
    {
        "type": "UIT",
        "mpid": "BELS",
        "clearingBroker": "0443",
        "brokerName": "BEL AIR SECURITIES LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "BERN",
        "clearingBroker": "0013",
        "brokerName": "SANFORD C. BERNSTEIN & CO., LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "BERS",
        "clearingBroker": "0235",
        "brokerName": "BESTEX RESEARCH SECURITIES, LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "BEST",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "BFEC",
        "clearingBroker": "0443",
        "brokerName": "BENJAMIN F. EDWARDS & COMPANY                                         "
    },
    {
        "type": "UIT",
        "mpid": "BFEW",
        "clearingBroker": "0443",
        "brokerName": "BILL FEW ASSOCIATES, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "BFFI",
        "clearingBroker": "0226",
        "brokerName": "BERTHEL, FISHER & COMPANY FINANCIAL SERVICES, INC.                    "
    },
    {
        "type": "UIT",
        "mpid": "BFSL",
        "clearingBroker": "0235",
        "brokerName": "BRIGGS-FICKS SECURITIES, LLC                                          "
    },
    {
        "type": "UIT",
        "mpid": "BGHT",
        "clearingBroker": "0141",
        "brokerName": "BRIGHTON SECURITIES CORP.                                             "
    },
    {
        "type": "UIT",
        "mpid": "BGIS",
        "clearingBroker": "0443",
        "brokerName": "BLACKROCK EXECUTION SERVICES                                          "
    },
    {
        "type": "UIT",
        "mpid": "BGSG",
        "clearingBroker": "0226",
        "brokerName": "CBIZ FINANCIAL SOLUTIONS, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "BGVS",
        "clearingBroker": "0443",
        "brokerName": "BGV SECURITIES                                                        "
    },
    {
        "type": "UIT",
        "mpid": "BHII",
        "clearingBroker": "0443",
        "brokerName": "BELLE HAVEN INVESTMENTS, LP                                           "
    },
    {
        "type": "UIT",
        "mpid": "BHKS",
        "clearingBroker": "0141",
        "brokerName": "BHK SECURITIES, LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "BIFS",
        "clearingBroker": "0443",
        "brokerName": "BROKERS INTERNATIONAL FINANCIAL SERVICES, LLC                         "
    },
    {
        "type": "UIT",
        "mpid": "BIGG",
        "clearingBroker": "0005",
        "brokerName": "BROWNSTONE INVESTMENT GROUP                                           "
    },
    {
        "type": "UIT",
        "mpid": "BIGP",
        "clearingBroker": "0443",
        "brokerName": "BROWNSTONE INVESTMENT GROUP, LLC                                      "
    },
    {
        "type": "UIT",
        "mpid": "BISI",
        "clearingBroker": "0443",
        "brokerName": "BANORTE SECURITIES INTERNATIONAL, LTD.                                "
    },
    {
        "type": "UIT",
        "mpid": "BJCM",
        "clearingBroker": "0235",
        "brokerName": "ESSEX SECURITIES LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "BJRC",
        "clearingBroker": "0235",
        "brokerName": "CASCADE INVESTMENT GROUP, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "BKCM",
        "clearingBroker": "0443",
        "brokerName": "BNY CAPITAL MARKETS INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "BKES",
        "clearingBroker": "0443",
        "brokerName": "BNY MELLON CAPITAL MARKETS, LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "BKRT",
        "clearingBroker": "0235",
        "brokerName": "BUCKMAN, BUCKMAN & REID, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "BLNI",
        "clearingBroker": "0226",
        "brokerName": "AMERITAS INVESTMENT COMPANY, LLC                                      "
    },
    {
        "type": "UIT",
        "mpid": "BLOC",
        "clearingBroker": "0158",
        "brokerName": "TRADING BLOCK                                                         "
    },
    {
        "type": "UIT",
        "mpid": "BLTK",
        "clearingBroker": "0443",
        "brokerName": "BULLTICK, LLC                                                         "
    },
    {
        "type": "UIT",
        "mpid": "BMSA",
        "clearingBroker": "0443",
        "brokerName": "MARIVA CAPITAL MARKETS, LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "BMUR",
        "clearingBroker": "0443",
        "brokerName": "BREAN CAPITAL, LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "BNBB",
        "clearingBroker": "0750",
        "brokerName": "INTERCOASTAL CAPITAL MARKETS, INC.                                    "
    },
    {
        "type": "UIT",
        "mpid": "BNCH",
        "clearingBroker": "0235",
        "brokerName": "THE BENCHMARK COMPANY, LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "BNDI",
        "clearingBroker": "0443",
        "brokerName": "BERNARDI SECURITIES, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "BNDS",
        "clearingBroker": "0226",
        "brokerName": "MTS MARKETS INTERNATIONAL, INC                                        "
    },
    {
        "type": "UIT",
        "mpid": "BNJM",
        "clearingBroker": "0235",
        "brokerName": "BENJAMIN SECURITIES, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "BNPS",
        "clearingBroker": "2154",
        "brokerName": "BNP PARIBAS SECURITIES CORP.                                          "
    },
    {
        "type": "UIT",
        "mpid": "BNPX",
        "clearingBroker": "2154",
        "brokerName": "BNP PARIBAS SECURITIES CORP.                                          "
    },
    {
        "type": "UIT",
        "mpid": "BNTE",
        "clearingBroker": "0158",
        "brokerName": "BANORTE-IXE SECURITIES INTERNATIONAL, LTD.                            "
    },
    {
        "type": "UIT",
        "mpid": "BNYM",
        "clearingBroker": "8355",
        "brokerName": "BNYM/UIT NSCC CNS CLEARANCE                                           "
    },
    {
        "type": "UIT",
        "mpid": "BNYN",
        "clearingBroker": "0226",
        "brokerName": "BANYAN SECURITIES, LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "BOFA",
        "clearingBroker": "0773",
        "brokerName": "BOFA SECURITIES, INC./FIXED INCOME                                    "
    },
    {
        "type": "UIT",
        "mpid": "BOKI",
        "clearingBroker": "0443",
        "brokerName": "BOSC, INC.                                                            "
    },
    {
        "type": "UIT",
        "mpid": "BOSE",
        "clearingBroker": "0443",
        "brokerName": "BOE SECURITIES INC.                                                   "
    },
    {
        "type": "UIT",
        "mpid": "BOSS",
        "clearingBroker": "0158",
        "brokerName": "ALL TIME ATS                                                          "
    },
    {
        "type": "UIT",
        "mpid": "BOTS",
        "clearingBroker": "0052",
        "brokerName": "C A BOTZUM & CO                                                       "
    },
    {
        "type": "UIT",
        "mpid": "BPWP",
        "clearingBroker": "0226",
        "brokerName": "BUTTONWOOD PARTNERS, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "BRAD",
        "clearingBroker": "0443",
        "brokerName": "BERNARD HEROLD & CO                                                   "
    },
    {
        "type": "UIT",
        "mpid": "BRBR",
        "clearingBroker": "0279",
        "brokerName": "BROWN AND BROWN SECURITIES, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "BRCY",
        "clearingBroker": "0443",
        "brokerName": "BCP SECURITIES, LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "BRGE",
        "clearingBroker": "0052",
        "brokerName": "NEWBRIDGE SECURITIES CORPORATION                                      "
    },
    {
        "type": "UIT",
        "mpid": "BRLI",
        "clearingBroker": "0226",
        "brokerName": "BROWN, LISLE/CUMMINGS, INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "BRNK",
        "clearingBroker": "0226",
        "brokerName": "BRINKER CAPITAL SECURITIES, LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "BROC",
        "clearingBroker": "0443",
        "brokerName": "PAVILION GLOBAL MARKETS LTD                                           "
    },
    {
        "type": "UIT",
        "mpid": "BRRR",
        "clearingBroker": "8199",
        "brokerName": "BARRINGTON RESEARCH ASSOCIATES, INC.                                  "
    },
    {
        "type": "UIT",
        "mpid": "BRSE",
        "clearingBroker": "0226",
        "brokerName": "BRADESCO SECURITIES, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "BRVL",
        "clearingBroker": "0443",
        "brokerName": "BLAYLOCK BEAL VAN, LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "BRWM",
        "clearingBroker": "0226",
        "brokerName": "B. RILEY WEALTH MANAGEMENT                                            "
    },
    {
        "type": "UIT",
        "mpid": "BSCM",
        "clearingBroker": "0052",
        "brokerName": "BROAD STREET CAPITAL MARKETS, LLC                                     "
    },
    {
        "type": "UIT",
        "mpid": "BSPI",
        "clearingBroker": "0235",
        "brokerName": "BALANCED SECURITY PLANNING, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "BTDG",
        "clearingBroker": "0161",
        "brokerName": "BIDS TRADING LP                                                       "
    },
    {
        "type": "UIT",
        "mpid": "BTIM",
        "clearingBroker": "1043",
        "brokerName": "BTIG, LLC                                                             "
    },
    {
        "type": "UIT",
        "mpid": "BTIS",
        "clearingBroker": "0443",
        "brokerName": "BTIG, LLC                                                             "
    },
    {
        "type": "UIT",
        "mpid": "BTSS",
        "clearingBroker": "0279",
        "brokerName": "HILLTOP SECURITIES INDEPENDENT NETWORK INC.                           "
    },
    {
        "type": "UIT",
        "mpid": "BURK",
        "clearingBroker": "0141",
        "brokerName": "BURKE, LAWTON, BREWER & BURKE                                         "
    },
    {
        "type": "UIT",
        "mpid": "BWNA",
        "clearingBroker": "0235",
        "brokerName": "BROWN ASSOCIATES INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "BYAI",
        "clearingBroker": "0226",
        "brokerName": "BRECEK & YOUNG                                                        "
    },
    {
        "type": "UIT",
        "mpid": "BZTN",
        "clearingBroker": "0141",
        "brokerName": "ALLIANT SECURITIES, INC. TURNER, NORD, KIENBAUM                       "
    },
    {
        "type": "UIT",
        "mpid": "BZWV",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "BZYD",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "BZYF",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "CADG",
        "clearingBroker": "0005",
        "brokerName": "WEEDEN PRIME SERVICES, LLC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "CADZ",
        "clearingBroker": "0279",
        "brokerName": "CADZ SECURITIES INC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "CAGI",
        "clearingBroker": "0279",
        "brokerName": "CRESCENT SECURITIES GROUP, INC.                                       "
    },
    {
        "type": "UIT",
        "mpid": "CAIX",
        "clearingBroker": "0235",
        "brokerName": "CAIS CAPITAL LLC                                                      "
    },
    {
        "type": "UIT",
        "mpid": "CALD",
        "clearingBroker": "0103",
        "brokerName": "CALDWELL SUTTER CAPITAL, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "CALT",
        "clearingBroker": "0279",
        "brokerName": "CALTON & ASSOCIATES                                                   "
    },
    {
        "type": "UIT",
        "mpid": "CAMS",
        "clearingBroker": "0443",
        "brokerName": "COMPREHENSIVE ASSET MANAGEMENT AND SERVICING, INC.                    "
    },
    {
        "type": "UIT",
        "mpid": "CANA",
        "clearingBroker": "0443",
        "brokerName": "CANACCORD GENUITY INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "CAPC",
        "clearingBroker": "0235",
        "brokerName": "CAPITAL CITY SECURITIES, LLC                                          "
    },
    {
        "type": "UIT",
        "mpid": "CAPE",
        "clearingBroker": "0279",
        "brokerName": "CAPE SECURITIES, INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "CAPF",
        "clearingBroker": "0443",
        "brokerName": "CAPITAL FINANCIAL SERVICES, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "CAPP",
        "clearingBroker": "0443",
        "brokerName": "CAPTRUST FINANCIAL ADVISORS                                           "
    },
    {
        "type": "UIT",
        "mpid": "CARG",
        "clearingBroker": "0141",
        "brokerName": "CARTHAGE GROUP INC.                                                   "
    },
    {
        "type": "UIT",
        "mpid": "CART",
        "clearingBroker": "0443",
        "brokerName": "CARTY & COMPANY, INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "CARY",
        "clearingBroker": "0141",
        "brokerName": "CARY STREET PARTNERS                                                  "
    },
    {
        "type": "UIT",
        "mpid": "CASH",
        "clearingBroker": "0158",
        "brokerName": "PLANNER SECURITIES LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "CATE",
        "clearingBroker": "0235",
        "brokerName": "CARTER, TERRY & COMPANY, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "CAVU",
        "clearingBroker": "0443",
        "brokerName": "CAVU SECURITIES LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "CBEV",
        "clearingBroker": "0226",
        "brokerName": "CITY NATIONAL BANK, BEVERLY HILLS, CALIFORNIA                         "
    },
    {
        "type": "UIT",
        "mpid": "CBII",
        "clearingBroker": "0443",
        "brokerName": "WESBANCO SECURITIES, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "CBIN",
        "clearingBroker": "0443",
        "brokerName": "COMPASS BROKERAGE, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "CBOL",
        "clearingBroker": "0226",
        "brokerName": "MUTUAL SECURITIES, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "CBTD",
        "clearingBroker": "0226",
        "brokerName": "SYNOVOUS SECURITIES INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "CCCO",
        "clearingBroker": "0226",
        "brokerName": "CARNES CAPITAL CORPORATION                                            "
    },
    {
        "type": "UIT",
        "mpid": "CCIG",
        "clearingBroker": "0235",
        "brokerName": "CINCAP INVESTMENT GROUP, INC                                          "
    },
    {
        "type": "UIT",
        "mpid": "CCMB",
        "clearingBroker": "0443",
        "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "CCMC",
        "clearingBroker": "0443",
        "brokerName": "COMMERZEBANK CAPITAL CORP.                                            "
    },
    {
        "type": "UIT",
        "mpid": "CCMM",
        "clearingBroker": "0235",
        "brokerName": "CRAFT CAPITAL MANAGEMENT LLC                                          "
    },
    {
        "type": "UIT",
        "mpid": "CCPM",
        "clearingBroker": "0595",
        "brokerName": "CAMBRIA CAPITAL, LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "CCRD",
        "clearingBroker": "0443",
        "brokerName": "CONCORDE INVESTMENT SERVICES, LLC                                     "
    },
    {
        "type": "UIT",
        "mpid": "CCSS",
        "clearingBroker": "0443",
        "brokerName": "CROWN CAPITAL SECURITIES, L.P.                                        "
    },
    {
        "type": "UIT",
        "mpid": "CDFS",
        "clearingBroker": "0052",
        "brokerName": "NAVIAN CAPITAL SECURITIES, LLC                                        "
    },
    {
        "type": "UIT",
        "mpid": "CDMA",
        "clearingBroker": "0505",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "CERS",
        "clearingBroker": "0226",
        "brokerName": "CEROS FINANCIAL SERVICES, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "CFCS",
        "clearingBroker": "0005",
        "brokerName": "CANTOR FITZGERALD & CO                                                "
    },
    {
        "type": "UIT",
        "mpid": "CFGM",
        "clearingBroker": "0235",
        "brokerName": "TRUSTMONT FINANCIAL GROUP, INC.                                       "
    },
    {
        "type": "UIT",
        "mpid": "CFGT",
        "clearingBroker": "0235",
        "brokerName": "CF GLOBAL TRADING, LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "CFII",
        "clearingBroker": "0235",
        "brokerName": "CONSOLIDATED FINANCIAL INVESTMENTS, INC.                              "
    },
    {
        "type": "UIT",
        "mpid": "CFIN",
        "clearingBroker": "0279",
        "brokerName": "CHELSEA FINANCIAL SERVICES                                            "
    },
    {
        "type": "UIT",
        "mpid": "CFSC",
        "clearingBroker": "0443",
        "brokerName": "INSIGNEO SECURITIES LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "CFSI",
        "clearingBroker": "0052",
        "brokerName": "CEROS FINANCIAL SERVICES, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "CFSX",
        "clearingBroker": "0794",
        "brokerName": "CF SECURED, LLC                                                       "
    },
    {
        "type": "UIT",
        "mpid": "CGAM",
        "clearingBroker": "0443",
        "brokerName": "CGIS SECURITIES LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "CGAT",
        "clearingBroker": "0443",
        "brokerName": "CADARET, GRANT & CO., INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "CGCO",
        "clearingBroker": "0443",
        "brokerName": "CG COMPASS (USA) LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "CGLN",
        "clearingBroker": "0103",
        "brokerName": "COUGHLIN & CO                                                         "
    },
    {
        "type": "UIT",
        "mpid": "CGWM",
        "clearingBroker": "0443",
        "brokerName": "CITIGROUP GLOBAL MARKETS INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "CHAS",
        "clearingBroker": "0164",
        "brokerName": "CHARLES SCHWAB & CO., INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "CHBC",
        "clearingBroker": "0235",
        "brokerName": "PENSERRA SECURITIES, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "CHCH",
        "clearingBroker": "0226",
        "brokerName": "CHURCHILL FINANCIAL, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "CHCK",
        "clearingBroker": "0226",
        "brokerName": "CHICKASAW SECURITIES, LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "CHDA",
        "clearingBroker": "0141",
        "brokerName": "CHAPIN, DAVIS                                                         "
    },
    {
        "type": "UIT",
        "mpid": "CHHS",
        "clearingBroker": "0141",
        "brokerName": "CHESTER HARRIS & CO., INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "CHLC",
        "clearingBroker": "0443",
        "brokerName": "CHURCHILL CAPITAL USA, INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "CHPP",
        "clearingBroker": "0624",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "UIT",
        "mpid": "CICC",
        "clearingBroker": "0443",
        "brokerName": "CICC US SECURITIES, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "CICI",
        "clearingBroker": "0443",
        "brokerName": "COMMERCE BANK INVESTMENT SERVICES, INC.                               "
    },
    {
        "type": "UIT",
        "mpid": "CICL",
        "clearingBroker": "0141",
        "brokerName": "CAROLINAS INVESTMENT CONSULTING                                       "
    },
    {
        "type": "UIT",
        "mpid": "CIIV",
        "clearingBroker": "0052",
        "brokerName": "CORPORATE INVESTMENTS GROUP, INC.                                     "
    },
    {
        "type": "UIT",
        "mpid": "CIMB",
        "clearingBroker": "0005",
        "brokerName": "CIMB SECURITIES (USA), INC                                            "
    },
    {
        "type": "UIT",
        "mpid": "CIRI",
        "clearingBroker": "0443",
        "brokerName": "CAMBRIDGE INVESTMENT RESEARCH, INC.                                   "
    },
    {
        "type": "UIT",
        "mpid": "CISV",
        "clearingBroker": "0226",
        "brokerName": "CITIZENS SECURITIES, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "CJSC",
        "clearingBroker": "0443",
        "brokerName": "CJS SECURITIES, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "CLDN",
        "clearingBroker": "0235",
        "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "CLRK",
        "clearingBroker": "0235",
        "brokerName": "CLARK DODGE & CO, INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "CLSC",
        "clearingBroker": "0235",
        "brokerName": "CABOT LODGE SECURITIES LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "CLSS",
        "clearingBroker": "0235",
        "brokerName": "CABOT LODGE SECURITIES LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "CLTN",
        "clearingBroker": "0226",
        "brokerName": "CALTON & ASSOCIATES, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "CMCE",
        "clearingBroker": "0226",
        "brokerName": "COMMERCE BROKERAGE SERVICES                                           "
    },
    {
        "type": "UIT",
        "mpid": "CMFS",
        "clearingBroker": "0443",
        "brokerName": "BNY MELLON CAP MKTS                                                   "
    },
    {
        "type": "UIT",
        "mpid": "CMGF",
        "clearingBroker": "0443",
        "brokerName": "CMG SECURITIES LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "CMMW",
        "clearingBroker": "0226",
        "brokerName": "COMMONWEALTH FINANCIAL NETWORK                                        "
    },
    {
        "type": "UIT",
        "mpid": "CNCD",
        "clearingBroker": "0235",
        "brokerName": "CONCORDE INVESTMENT SERVICES, LLC                                     "
    },
    {
        "type": "UIT",
        "mpid": "CNFI",
        "clearingBroker": "0443",
        "brokerName": "CENTAURUS FINANCIAL INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "CNFR",
        "clearingBroker": "0443",
        "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "CNSI",
        "clearingBroker": "0226",
        "brokerName": "CITY NATIONAL SECURITIES, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "COAS",
        "clearingBroker": "0443",
        "brokerName": "REALTA EQUITIES, INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "CODA",
        "clearingBroker": "0161",
        "brokerName": "CODA MARKETS, INC.                                                    "
    },
    {
        "type": "UIT",
        "mpid": "COEI",
        "clearingBroker": "0052",
        "brokerName": "COASTAL EQUITIES, INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "COEX",
        "clearingBroker": "0161",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "UIT",
        "mpid": "COFS",
        "clearingBroker": "0279",
        "brokerName": "COLORADO FINANCIAL SERVICE CORPORATION                                "
    },
    {
        "type": "UIT",
        "mpid": "COHN",
        "clearingBroker": "0235",
        "brokerName": "COHEN BROS. & COMPANY                                                 "
    },
    {
        "type": "UIT",
        "mpid": "COKE",
        "clearingBroker": "0235",
        "brokerName": "COKER & PALMER, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "COMP",
        "clearingBroker": "0595",
        "brokerName": "COMPASS POINT RESEARCH & TRADING, LLC                                 "
    },
    {
        "type": "UIT",
        "mpid": "CONI",
        "clearingBroker": "0235",
        "brokerName": "CONTINENTAL INVESTORS SERVICES, INC.                                  "
    },
    {
        "type": "UIT",
        "mpid": "CONR",
        "clearingBroker": "0235",
        "brokerName": "CONNERS & CO., INC.                                                   "
    },
    {
        "type": "UIT",
        "mpid": "CONS",
        "clearingBroker": "0141",
        "brokerName": "CONSULTIVA SECURITIES, INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "COOR",
        "clearingBroker": "0141",
        "brokerName": "COORDINATED CAPITAL SECURITIES, INC.                                  "
    },
    {
        "type": "UIT",
        "mpid": "COSL",
        "clearingBroker": "0443",
        "brokerName": "CLIENT ONE SECURITIES, LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "COWN",
        "clearingBroker": "0100",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "COWP",
        "clearingBroker": "0226",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "COWR",
        "clearingBroker": "0443",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "COYL",
        "clearingBroker": "0235",
        "brokerName": "COYLE SECURITIES LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "CPGL",
        "clearingBroker": "0226",
        "brokerName": "CONTINUITY PARTNERS GROUP, LLC                                        "
    },
    {
        "type": "UIT",
        "mpid": "CPRC",
        "clearingBroker": "0235",
        "brokerName": "CORINTHIAN PARTNERS, L.L.C.                                           "
    },
    {
        "type": "UIT",
        "mpid": "CPRM",
        "clearingBroker": "8199",
        "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "CRCM",
        "clearingBroker": "0235",
        "brokerName": "COHNREZNICK CAPITAL                                                   "
    },
    {
        "type": "UIT",
        "mpid": "CRDL",
        "clearingBroker": "0235",
        "brokerName": "CARDINAL INVESTMENTS, INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "CRED",
        "clearingBroker": "0443",
        "brokerName": "CREDICORP CAPITAL LLC                                                 "
    },
    {
        "type": "UIT",
        "mpid": "CREF",
        "clearingBroker": "0443",
        "brokerName": "TIAA-CREF INDIVIDUAL AND INSTITUTIONAL SERVICES, LLC                  "
    },
    {
        "type": "UIT",
        "mpid": "CREW",
        "clearingBroker": "0443",
        "brokerName": "CREWS & ASSOCIATES, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "CRFN",
        "clearingBroker": "6769",
        "brokerName": "ROBINHOOD FINANCIAL, LLC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "CRII",
        "clearingBroker": "0443",
        "brokerName": "CRI SECURITIES INC.                                                   "
    },
    {
        "type": "UIT",
        "mpid": "CRNJ",
        "clearingBroker": "0103",
        "brokerName": "CANTONE RESEARCH                                                      "
    },
    {
        "type": "UIT",
        "mpid": "CRON",
        "clearingBroker": "0443",
        "brokerName": "CRONIN & CO., INC.                                                    "
    },
    {
        "type": "UIT",
        "mpid": "CRPT",
        "clearingBroker": "0235",
        "brokerName": "CROSS POINT CAPITAL LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "CRTH",
        "clearingBroker": "0443",
        "brokerName": "CORINTHIAN PARTNERS, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "CRYN",
        "clearingBroker": "0235",
        "brokerName": "BRENDAN E. CRYAN AND COMPANY, L.L.C.                                  "
    },
    {
        "type": "UIT",
        "mpid": "CSAI",
        "clearingBroker": "0793",
        "brokerName": "STIFEL INDEPENDENT ADVISORS, LLC                                      "
    },
    {
        "type": "UIT",
        "mpid": "CSAP",
        "clearingBroker": "0141",
        "brokerName": "CRESAP, INC.                                                          "
    },
    {
        "type": "UIT",
        "mpid": "CSCA",
        "clearingBroker": "4264",
        "brokerName": "ICE BONDS SECURITIES CORPORATION                                      "
    },
    {
        "type": "UIT",
        "mpid": "CSCM",
        "clearingBroker": "0279",
        "brokerName": "CENTRAL STATES CAPITAL MARKETS, LLC                                   "
    },
    {
        "type": "UIT",
        "mpid": "CSPA",
        "clearingBroker": "0226",
        "brokerName": "CREDIT SUISSE PRIVATE ADVISORS                                        "
    },
    {
        "type": "UIT",
        "mpid": "CSPI",
        "clearingBroker": "0235",
        "brokerName": "CAPITAL SYNERGY PARTNERS                                              "
    },
    {
        "type": "UIT",
        "mpid": "CTAS",
        "clearingBroker": "0443",
        "brokerName": "OSAIC INSTITUTIONS, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "CTBK",
        "clearingBroker": "4270",
        "brokerName": "CENTRAL TRUST BANK                                                    "
    },
    {
        "type": "UIT",
        "mpid": "CTNL",
        "clearingBroker": "0235",
        "brokerName": "CENTENNIAL SECURITIES COMPANY LLC                                     "
    },
    {
        "type": "UIT",
        "mpid": "CTSC",
        "clearingBroker": "4264",
        "brokerName": "ICE BONDS SECURITIES CORPORATION                                      "
    },
    {
        "type": "UIT",
        "mpid": "CUFT",
        "clearingBroker": "0226",
        "brokerName": "FROST BROKERAGE SERVICES, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "CUSO",
        "clearingBroker": "0443",
        "brokerName": "CUSO FINANCIAL SERVICES, L.P.                                         "
    },
    {
        "type": "UIT",
        "mpid": "CUTW",
        "clearingBroker": "0235",
        "brokerName": "PROSPERA FINANCIAL SERVICES, INC.                                     "
    },
    {
        "type": "UIT",
        "mpid": "CUWB",
        "clearingBroker": "0103",
        "brokerName": "DRIVEWEALTH INSTITUTIONAL, LLC                                        "
    },
    {
        "type": "UIT",
        "mpid": "CVGP",
        "clearingBroker": "0443",
        "brokerName": "COWEN AND COMPANY LLC                                                 "
    },
    {
        "type": "UIT",
        "mpid": "CWEI",
        "clearingBroker": "0443",
        "brokerName": "BEECH HILL SECURITIES, INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "CWMK",
        "clearingBroker": "0438",
        "brokerName": "CIBC WORLD MARKETS CORP.                                              "
    },
    {
        "type": "UIT",
        "mpid": "CYND",
        "clearingBroker": "0443",
        "brokerName": "TIGRESS FINANCIAL PARTNERS LLC                                        "
    },
    {
        "type": "UIT",
        "mpid": "DADA",
        "clearingBroker": "0361",
        "brokerName": "D. A. DAVIDSON & CO.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "DAII",
        "clearingBroker": "0235",
        "brokerName": "ALEXANDER (DON) INVESTMENTS, INC.                                     "
    },
    {
        "type": "UIT",
        "mpid": "DAIN",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "DAIS",
        "clearingBroker": "0052",
        "brokerName": "DAI SECURITIES, LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "DARA",
        "clearingBroker": "0235",
        "brokerName": "DARWOOD ASSOCIATES, INC                                               "
    },
    {
        "type": "UIT",
        "mpid": "DART",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "DASH",
        "clearingBroker": "0161",
        "brokerName": "DASH FINANCIAL TECHNOLOGIES LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "DAVA",
        "clearingBroker": "0443",
        "brokerName": "DAVENPORT & COMPANY LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "DAWA",
        "clearingBroker": "0647",
        "brokerName": "DAIWA CAPITAL MARKETS AMERICA INC.                                    "
    },
    {
        "type": "UIT",
        "mpid": "DBCC",
        "clearingBroker": "0235",
        "brokerName": "D. BORAL CAPITAL                                                      "
    },
    {
        "type": "UIT",
        "mpid": "DBCH",
        "clearingBroker": "0052",
        "brokerName": "D. BORAL CAPITAL                                                      "
    },
    {
        "type": "UIT",
        "mpid": "DBKS",
        "clearingBroker": "0573",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "DBPC",
        "clearingBroker": "0443",
        "brokerName": "DEUTSCHE BANK SECURITIES INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "DCAN",
        "clearingBroker": "0279",
        "brokerName": "R. M. DUNCAN SECURITIES, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "DCSD",
        "clearingBroker": "0235",
        "brokerName": "DAIN CORRESPONDENT SERVICES                                           "
    },
    {
        "type": "UIT",
        "mpid": "DCVL",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "DEAN",
        "clearingBroker": "0015",
        "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "DEGS",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "DENI",
        "clearingBroker": "0279",
        "brokerName": "H.C. DENISON CO.                                                      "
    },
    {
        "type": "UIT",
        "mpid": "DETF",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "DFPG",
        "clearingBroker": "0235",
        "brokerName": "DFPG INVESTMENTS, INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "DIBS",
        "clearingBroker": "0226",
        "brokerName": "DIGITAL BROKERAGE SERVICES LLC                                        "
    },
    {
        "type": "UIT",
        "mpid": "DIGG",
        "clearingBroker": "0595",
        "brokerName": "BOUSTEAD SECURITIES, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "DINO",
        "clearingBroker": "0103",
        "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
    },
    {
        "type": "UIT",
        "mpid": "DJSA",
        "clearingBroker": "0750",
        "brokerName": "DAWSON JAMES SECURITIES, INC                                          "
    },
    {
        "type": "UIT",
        "mpid": "DLAI",
        "clearingBroker": "0235",
        "brokerName": "DAVID LERNER ASSOCIATES, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "DLPS",
        "clearingBroker": "0595",
        "brokerName": "DLP SECURITIES,.LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "DLSI",
        "clearingBroker": "0226",
        "brokerName": "DEMPSEY LORD SMITH, LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "DMCD",
        "clearingBroker": "0279",
        "brokerName": "MCDERMOTT INVESTMENT SERVICES, LLC                                    "
    },
    {
        "type": "UIT",
        "mpid": "DMKC",
        "clearingBroker": "0141",
        "brokerName": "D.M. KELLY & COMPANY                                                  "
    },
    {
        "type": "UIT",
        "mpid": "DNOR",
        "clearingBroker": "0005",
        "brokerName": "DNB MARKETS, INC.                                                     "
    },
    {
        "type": "UIT",
        "mpid": "DNSR",
        "clearingBroker": "0158",
        "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
    },
    {
        "type": "UIT",
        "mpid": "DNWL",
        "clearingBroker": "0443",
        "brokerName": "DUNCAN & WILLIAMS, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "DOFT",
        "clearingBroker": "0443",
        "brokerName": "DOFT & CO., INC.                                                      "
    },
    {
        "type": "UIT",
        "mpid": "DOMI",
        "clearingBroker": "0279",
        "brokerName": "DOMINION INVESTOR SERVICES, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "DOMS",
        "clearingBroker": "0235",
        "brokerName": "DOMINARI SECURITIES LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "DORN",
        "clearingBroker": "0235",
        "brokerName": "DORN & CO., INC.                                                      "
    },
    {
        "type": "UIT",
        "mpid": "DOTC",
        "clearingBroker": "0226",
        "brokerName": "COLLIERS SECURITIES LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "DOVE",
        "clearingBroker": "0226",
        "brokerName": "SECURITIES EQUITY GROUP                                               "
    },
    {
        "type": "UIT",
        "mpid": "DOWL",
        "clearingBroker": "0443",
        "brokerName": "DOWLING & PARTNERS SECURITIES LLC                                     "
    },
    {
        "type": "UIT",
        "mpid": "DREX",
        "clearingBroker": "0443",
        "brokerName": "DREXEL HAMILTON, LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "DRSC",
        "clearingBroker": "0443",
        "brokerName": "BNY MELLON SECURITIES CORPORATION                                     "
    },
    {
        "type": "UIT",
        "mpid": "DRTG",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "DRTR",
        "clearingBroker": "0005",
        "brokerName": "DART EXECUTIONS, LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "DRVW",
        "clearingBroker": "0235",
        "brokerName": "DRIVEWEALTH, LLC                                                      "
    },
    {
        "type": "UIT",
        "mpid": "DSAI",
        "clearingBroker": "0443",
        "brokerName": "DAEWOO SECURITIES (AMERICA) INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "DSGG",
        "clearingBroker": "0226",
        "brokerName": "DMG SECURITIES, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "DTEX",
        "clearingBroker": "0235",
        "brokerName": "INSTITUTIONAL SECURITIES CORPORATION                                  "
    },
    {
        "type": "UIT",
        "mpid": "DUST",
        "clearingBroker": "0161",
        "brokerName": "JUMP TRADING, LLC                                                     "
    },
    {
        "type": "UIT",
        "mpid": "DWIZ",
        "clearingBroker": "0235",
        "brokerName": "DRIVEWEALTH INSTITUTIONAL LLC                                         "
    },
    {
        "type": "UIT",
        "mpid": "EAMC",
        "clearingBroker": "0235",
        "brokerName": "EMPIRE ASSET MANAGEMENT COMPANY                                       "
    },
    {
        "type": "UIT",
        "mpid": "EAMG",
        "clearingBroker": "0235",
        "brokerName": "EMPIRE ASSET MANAGEMENT COMPANY                                       "
    },
    {
        "type": "UIT",
        "mpid": "ECCC",
        "clearingBroker": "0226",
        "brokerName": "EAGLES COAST CAPITAL, LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "EDFC",
        "clearingBroker": "0443",
        "brokerName": "E D & F MAN CAPITAL MARKETS INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "EDFO",
        "clearingBroker": "0158",
        "brokerName": "E D & F MAN CAPITAL MARKETS INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "EDIR",
        "clearingBroker": "0235",
        "brokerName": "EDI FINANCIAL, INC.                                                   "
    },
    {
        "type": "UIT",
        "mpid": "EDJO",
        "clearingBroker": "0057",
        "brokerName": "EDWARD D. JONES & CO.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "EFGC",
        "clearingBroker": "0443",
        "brokerName": "EFG CAPITAL INTERNATIONAL                                             "
    },
    {
        "type": "UIT",
        "mpid": "EFSP",
        "clearingBroker": "0443",
        "brokerName": "ESSEX FINANCIAL SERVICES, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "EGLE",
        "clearingBroker": "1043",
        "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
    },
    {
        "type": "UIT",
        "mpid": "EGMT",
        "clearingBroker": "0005",
        "brokerName": "EG MARKET TECHNOLOGIES LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "ELET",
        "clearingBroker": "0388",
        "brokerName": "ELECTRONIFIE SECURITIES LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "ELEV",
        "clearingBroker": "0235",
        "brokerName": "ELEVATION, LLC                                                        "
    },
    {
        "type": "UIT",
        "mpid": "EMER",
        "clearingBroker": "0443",
        "brokerName": "EMERSON EQUITY LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "EMOC",
        "clearingBroker": "0750",
        "brokerName": "E. MAGNUS OPPENHIEM & CO. INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "EMPR",
        "clearingBroker": "0279",
        "brokerName": "SELKIRK INVESTMENTS, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "ENTR",
        "clearingBroker": "0235",
        "brokerName": "ENTRUSTODY FINANCIAL, LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "EPIC",
        "clearingBroker": "0443",
        "brokerName": "EPIC CAPITAL SECURITIES                                               "
    },
    {
        "type": "UIT",
        "mpid": "EQHA",
        "clearingBroker": "0075",
        "brokerName": "EQUITABLE ADVISORS, LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "EQSV",
        "clearingBroker": "0226",
        "brokerName": "EQUITY SERVICES, INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "EROP",
        "clearingBroker": "0158",
        "brokerName": "EROOM SECURITIES LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "ESBD",
        "clearingBroker": "0235",
        "brokerName": "EASTDIL SECURED ADVISORS LLC                                          "
    },
    {
        "type": "UIT",
        "mpid": "ETCB",
        "clearingBroker": "3505",
        "brokerName": "ETC BROKERAGE SERVICES, LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "ETCL",
        "clearingBroker": "0015",
        "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "ETRS",
        "clearingBroker": "0015",
        "brokerName": "MORGAN STANLEY SMITH BARNEY LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "EVOL",
        "clearingBroker": "0226",
        "brokerName": "EVOLVE SECURITIES, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "EXCS",
        "clearingBroker": "0443",
        "brokerName": "EXCEL SECURITIES AND ASSOCIATES, INC.                                 "
    },
    {
        "type": "UIT",
        "mpid": "FAFI",
        "clearingBroker": "0279",
        "brokerName": "FIRST ASSET FINANCIAL                                                 "
    },
    {
        "type": "UIT",
        "mpid": "FALC",
        "clearingBroker": "0103",
        "brokerName": "FALCON SQUARE CAPITAL, LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "FANC",
        "clearingBroker": "0235",
        "brokerName": "FINANCE 500, INC.                                                     "
    },
    {
        "type": "UIT",
        "mpid": "FATS",
        "clearingBroker": "0443",
        "brokerName": "FIRST BROKERS SECURITIES LLC                                          "
    },
    {
        "type": "UIT",
        "mpid": "FBLM",
        "clearingBroker": "0235",
        "brokerName": "FBL MARKETING SERVICES LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "FBLT",
        "clearingBroker": "8199",
        "brokerName": "FIRST BALLANTYNE, LLC                                                 "
    },
    {
        "type": "UIT",
        "mpid": "FBNS",
        "clearingBroker": "0235",
        "brokerName": "FBN SECURITIES, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "FBPC",
        "clearingBroker": "0443",
        "brokerName": "CREDIT SUISSE SECURITIES (USA) LLC                                    "
    },
    {
        "type": "UIT",
        "mpid": "FBSB",
        "clearingBroker": "0280",
        "brokerName": "U.S. BANCORP INVESTMENTS, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "FCFP",
        "clearingBroker": "0141",
        "brokerName": "FIRST CITIZENS FINANCIAL PLUS, INC.                                   "
    },
    {
        "type": "UIT",
        "mpid": "FCFS",
        "clearingBroker": "0443",
        "brokerName": "FIRST COMMAND FINANCIAL PLANNING, INC.                                "
    },
    {
        "type": "UIT",
        "mpid": "FCIT",
        "clearingBroker": "0443",
        "brokerName": "FIRST CITIZENS INVESTOR SERVICES, INC.                                "
    },
    {
        "type": "UIT",
        "mpid": "FCML",
        "clearingBroker": "0279",
        "brokerName": "FNBB CAPITAL MARKETS, LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "FCMP",
        "clearingBroker": "0595",
        "brokerName": "PRIME EXECUTIONS, INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "FCST",
        "clearingBroker": "0443",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "FDSC",
        "clearingBroker": "0158",
        "brokerName": "1ST DISCOUNT BROKERAGE INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "FDSI",
        "clearingBroker": "0141",
        "brokerName": "FIRST DALLAS SECURITIES, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "FEDR",
        "clearingBroker": "0235",
        "brokerName": "FEDERATED SECURITIES INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "FENX",
        "clearingBroker": "0595",
        "brokerName": "FENIX SECURITIES, LLC                                                 "
    },
    {
        "type": "UIT",
        "mpid": "FERN",
        "clearingBroker": "0443",
        "brokerName": "FEARNLEY SECURITIES                                                   "
    },
    {
        "type": "UIT",
        "mpid": "FFCM",
        "clearingBroker": "0235",
        "brokerName": "FOREFRONT CAPITAL MARKETS LLC                                         "
    },
    {
        "type": "UIT",
        "mpid": "FFGI",
        "clearingBroker": "0235",
        "brokerName": "FELDSTEIN FINANCIAL GROUP, LLC                                        "
    },
    {
        "type": "UIT",
        "mpid": "FFSI",
        "clearingBroker": "0158",
        "brokerName": "FIRSTRADE SECURITIES INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "FHCI",
        "clearingBroker": "0443",
        "brokerName": "FIRST HEARTLAND CAPITAL, INC                                          "
    },
    {
        "type": "UIT",
        "mpid": "FHON",
        "clearingBroker": "0235",
        "brokerName": "FIRST HONOLULU SECURITIES INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "FIBS",
        "clearingBroker": "0226",
        "brokerName": "FIDELITY BROKERAGE SERVICES LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "FISA",
        "clearingBroker": "0443",
        "brokerName": "ADVISORS ASSET MANAGEMENT, INC.                                       "
    },
    {
        "type": "UIT",
        "mpid": "FISB",
        "clearingBroker": "0226",
        "brokerName": "ADVISORS ASSET MANAGEMENT, INC.                                       "
    },
    {
        "type": "UIT",
        "mpid": "FISH",
        "clearingBroker": "0235",
        "brokerName": "L.B. FISHER & COMPANY                                                 "
    },
    {
        "type": "UIT",
        "mpid": "FJRF",
        "clearingBroker": "0052",
        "brokerName": "PARITER SECURITIES, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "FKSC",
        "clearingBroker": "0235",
        "brokerName": "FIRST KENTUCKY SECURITIES CORP.                                       "
    },
    {
        "type": "UIT",
        "mpid": "FLAT",
        "clearingBroker": "0226",
        "brokerName": "FLORIDA ATLANTIC SECURITIES CORP.                                     "
    },
    {
        "type": "UIT",
        "mpid": "FLIB",
        "clearingBroker": "0235",
        "brokerName": "FIRST LIBERTIES FINANCIAL                                             "
    },
    {
        "type": "UIT",
        "mpid": "FLOU",
        "clearingBroker": "0443",
        "brokerName": "FIRST ST. LOUIS SECURITIES, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "FLTG",
        "clearingBroker": "0005",
        "brokerName": "FLOW TRADERS U.S. LLC                                                 "
    },
    {
        "type": "UIT",
        "mpid": "FLTL",
        "clearingBroker": "0235",
        "brokerName": "FELTL & COMPANY                                                       "
    },
    {
        "type": "UIT",
        "mpid": "FMAT",
        "clearingBroker": "0608",
        "brokerName": "SG AMERICAS SECURITIES, LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "FMCO",
        "clearingBroker": "0443",
        "brokerName": "FIRST MANHATTAN CO.                                                   "
    },
    {
        "type": "UIT",
        "mpid": "FMEX",
        "clearingBroker": "0750",
        "brokerName": "FINAMEX INTERNATIONAL, LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "FMFS",
        "clearingBroker": "0226",
        "brokerName": "FISRT MERIT FINANCIAL SERVICES, INC                                   "
    },
    {
        "type": "UIT",
        "mpid": "FMGT",
        "clearingBroker": "0443",
        "brokerName": "FAMILY MANAGEMENT SECURITIES, LLC                                     "
    },
    {
        "type": "UIT",
        "mpid": "FNFD",
        "clearingBroker": "0443",
        "brokerName": "FOLGER NOLAN FLEMING DOUGLAS INCORPORATED                             "
    },
    {
        "type": "UIT",
        "mpid": "FNIC",
        "clearingBroker": "0443",
        "brokerName": "FINANCIAL NETWORK INVESTMENT CORP.                                    "
    },
    {
        "type": "UIT",
        "mpid": "FNPN",
        "clearingBroker": "0443",
        "brokerName": "UNIVEST INVESTMENTS                                                   "
    },
    {
        "type": "UIT",
        "mpid": "FNSJ",
        "clearingBroker": "0443",
        "brokerName": "FINANCIAL NORTHEASTERN SECURITIES, INC.                               "
    },
    {
        "type": "UIT",
        "mpid": "FOGS",
        "clearingBroker": "0235",
        "brokerName": "FOG EQUITIES LLC                                                      "
    },
    {
        "type": "UIT",
        "mpid": "FOXC",
        "clearingBroker": "0443",
        "brokerName": "FOX CHASE CAPITAL PARTNERS, LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "FSCS",
        "clearingBroker": "0443",
        "brokerName": "OSAIC WEALTH, INC.                                                    "
    },
    {
        "type": "UIT",
        "mpid": "FSRP",
        "clearingBroker": "0443",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "FTBR",
        "clearingBroker": "0728",
        "brokerName": "FOLIO INVESTMENTS, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "FTEN",
        "clearingBroker": "0226",
        "brokerName": "FTB ADVISORS, INC.                                                    "
    },
    {
        "type": "UIT",
        "mpid": "FTLP",
        "clearingBroker": "8244",
        "brokerName": "FIRST TRUST PORTFOLIOS, L.P.                                          "
    },
    {
        "type": "UIT",
        "mpid": "FTSR",
        "clearingBroker": "0226",
        "brokerName": "FIFTH THIRD SECURITIES, INC.                                          "
    },
    {
        "type": "UIT",
        "mpid": "FUBO",
        "clearingBroker": "0443",
        "brokerName": "GRIFFINEST ASIA SECURITIES, LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "FWSI",
        "clearingBroker": "0141",
        "brokerName": "FIRST WESTERN SECURITIES, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "GABE",
        "clearingBroker": "0141",
        "brokerName": "G. RESEARCH, INC.                                                     "
    },
    {
        "type": "UIT",
        "mpid": "GAFI",
        "clearingBroker": "0235",
        "brokerName": "GARDNER FINANCIAL SERVICES INC.                                       "
    },
    {
        "type": "UIT",
        "mpid": "GAGN",
        "clearingBroker": "0226",
        "brokerName": "GAGNON SECURITIES, LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "GAII",
        "clearingBroker": "0279",
        "brokerName": "GREAT AMERICAN INVESTORS, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "GARB",
        "clearingBroker": "0148",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC                                   "
    },
    {
        "type": "UIT",
        "mpid": "GARC",
        "clearingBroker": "0161",
        "brokerName": "ICAP CORPORATES LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "GARE",
        "clearingBroker": "0148",
        "brokerName": "GARE                                                                  "
    },
    {
        "type": "UIT",
        "mpid": "GARR",
        "clearingBroker": "0226",
        "brokerName": "GARRETT NAGLE & CO., INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "GARW",
        "clearingBroker": "0595",
        "brokerName": "GAR WOOD SECURITIES, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "GBMS",
        "clearingBroker": "0158",
        "brokerName": "GBM INTERNATIONAL, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "GBMT",
        "clearingBroker": "0443",
        "brokerName": "GBM INTERNATIONAL, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "GCMC",
        "clearingBroker": "0443",
        "brokerName": "GLADOWSKY CAPITAL MANAGEMENT CORP.                                    "
    },
    {
        "type": "UIT",
        "mpid": "GDCO",
        "clearingBroker": "0443",
        "brokerName": "GILBERT, DONIGER CO., INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "GELP",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "GENS",
        "clearingBroker": "0279",
        "brokerName": "GENERAL SECURITIES CORP                                               "
    },
    {
        "type": "UIT",
        "mpid": "GENW",
        "clearingBroker": "0443",
        "brokerName": "GENEOS WEALTH MANAGEMENT, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "GFBD",
        "clearingBroker": "0226",
        "brokerName": "G. F. INVESTMENT SERVICES, LLC                                        "
    },
    {
        "type": "UIT",
        "mpid": "GFSI",
        "clearingBroker": "0443",
        "brokerName": "GLOBAL FINANCIAL SERVICES, L.L.C.                                     "
    },
    {
        "type": "UIT",
        "mpid": "GGWI",
        "clearingBroker": "0141",
        "brokerName": "GAGE-WILEY & COMPANY INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "GHCC",
        "clearingBroker": "0226",
        "brokerName": "GORDON, HASKETT CAPITAL CORPORATION                                   "
    },
    {
        "type": "UIT",
        "mpid": "GILG",
        "clearingBroker": "0226",
        "brokerName": "GILDER GAGNON HOWE & CO. LLC                                          "
    },
    {
        "type": "UIT",
        "mpid": "GJSS",
        "clearingBroker": "0235",
        "brokerName": "SCHWARTZ, GREGORY J & CO. INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "GLCM",
        "clearingBroker": "0443",
        "brokerName": "GREENSLEDGE CAPITAL MARKETS                                           "
    },
    {
        "type": "UIT",
        "mpid": "GLYN",
        "clearingBroker": "0443",
        "brokerName": "GLYNN (J.A.) & CO.                                                    "
    },
    {
        "type": "UIT",
        "mpid": "GMSG",
        "clearingBroker": "0443",
        "brokerName": "GMS GROUP (THE), L.L.C.                                               "
    },
    {
        "type": "UIT",
        "mpid": "GPCA",
        "clearingBroker": "0235",
        "brokerName": "GREAT POINT CAPITAL LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "GPCG",
        "clearingBroker": "0443",
        "brokerName": "GREENMAN, PARKER, CONNALLY, GREENMAN, INC.                            "
    },
    {
        "type": "UIT",
        "mpid": "GRAD",
        "clearingBroker": "0235",
        "brokerName": "GRADIENT SECURITIES, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "GRBD",
        "clearingBroker": "0052",
        "brokerName": "GREENBIRD CAPITAL LLC                                                 "
    },
    {
        "type": "UIT",
        "mpid": "GRIL",
        "clearingBroker": "0235",
        "brokerName": "GLOBAL RESOURCE INVESTMENTS, LTD.                                     "
    },
    {
        "type": "UIT",
        "mpid": "GROD",
        "clearingBroker": "0226",
        "brokerName": "GRODSKY ASSOCIATES, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "GRPS",
        "clearingBroker": "0226",
        "brokerName": "MML INVESTORS SERVICES, LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "GRWD",
        "clearingBroker": "0052",
        "brokerName": "GAR WOOD SECURITIES, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "GRYG",
        "clearingBroker": "0226",
        "brokerName": "GOLDBERG (GARY) & CO., INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "GSBI",
        "clearingBroker": "0279",
        "brokerName": "GLOBAL BROKERAGE SERVICES, INC.                                       "
    },
    {
        "type": "UIT",
        "mpid": "GSCO",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "GSIL",
        "clearingBroker": "0158",
        "brokerName": "GLOBAL STRATEGIC INVESTMENTS, LLC                                     "
    },
    {
        "type": "UIT",
        "mpid": "GSMM",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "GSQQ",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "GSSI",
        "clearingBroker": "0052",
        "brokerName": "GARDEN STATE SECURITIES, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "GSUU",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "GSVV",
        "clearingBroker": "0005",
        "brokerName": "GOLDMAN SACHS & CO. LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "GTNB",
        "clearingBroker": "0595",
        "brokerName": "GTN AMERICAS FINANCIAL SERVICES, INC.                                 "
    },
    {
        "type": "UIT",
        "mpid": "GUGI",
        "clearingBroker": "0526",
        "brokerName": "GUGGENHEIM FUNDS DISTRIBUTORS, LLC                                    "
    },
    {
        "type": "UIT",
        "mpid": "GWFS",
        "clearingBroker": "0443",
        "brokerName": "GWFS EQUITIES, INC.                                                   "
    },
    {
        "type": "UIT",
        "mpid": "GWNS",
        "clearingBroker": "0443",
        "brokerName": "GWN SECURITIES INC.                                                   "
    },
    {
        "type": "UIT",
        "mpid": "HAFS",
        "clearingBroker": "0279",
        "brokerName": "HANTZ FINANCIAL SERVICES, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "HALO",
        "clearingBroker": "0235",
        "brokerName": "HALO SECURITIES, LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "HARB",
        "clearingBroker": "0443",
        "brokerName": "HARBOUR INVESTMENTS INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "HARC",
        "clearingBroker": "0235",
        "brokerName": "HARLEY CAPITAL LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "HAVK",
        "clearingBroker": "0235",
        "brokerName": "EMPIRE STATE FINANCIAL, INC.                                          "
    },
    {
        "type": "UIT",
        "mpid": "HAZL",
        "clearingBroker": "0226",
        "brokerName": "HAZLETT, BURT AND WATSON, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "HBCO",
        "clearingBroker": "0443",
        "brokerName": "GLOBAL INVESTOR SERVICES, L.C.                                        "
    },
    {
        "type": "UIT",
        "mpid": "HBUS",
        "clearingBroker": "0443",
        "brokerName": "HOLISTIC BROKERAGE, LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "HCMX",
        "clearingBroker": "0235",
        "brokerName": "HOOPOE CAPITAL MARKETS, LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "HCTA",
        "clearingBroker": "0005",
        "brokerName": "PEAK6 CAPITAL MANAGEMENT LLC                                          "
    },
    {
        "type": "UIT",
        "mpid": "HCWW",
        "clearingBroker": "0235",
        "brokerName": "H.C.WAINWRIGHT & CO., LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "HDVS",
        "clearingBroker": "0226",
        "brokerName": "AVANTAX INVESTMENT SERVICES, INC.                                     "
    },
    {
        "type": "UIT",
        "mpid": "HEAD",
        "clearingBroker": "0443",
        "brokerName": "TD SECURITIES AUTOMATED TRADING LLC                                   "
    },
    {
        "type": "UIT",
        "mpid": "HENN",
        "clearingBroker": "0235",
        "brokerName": "CARL M. HENNIG, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "HENY",
        "clearingBroker": "0443",
        "brokerName": "HENLEY & COMPANY LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "HIAL",
        "clearingBroker": "0443",
        "brokerName": "HARBOR INVESTMENT ADVISORY, LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "HIGG",
        "clearingBroker": "0235",
        "brokerName": "HIGGINS CAPITAL MANAGEMENT, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "HINO",
        "clearingBroker": "0235",
        "brokerName": "TRB CAPITAL MARKETS,LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "HITS",
        "clearingBroker": "0443",
        "brokerName": "HEIGHT SECURITIES, LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "HJSC",
        "clearingBroker": "0443",
        "brokerName": "SIMS (HERBERT J.) & CO., INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "HNTR",
        "clearingBroker": "0443",
        "brokerName": "HUNTER ASSOCIATES, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "HONR",
        "clearingBroker": "0235",
        "brokerName": "ROBERTS & RYAN INVESTMENTS INC.                                       "
    },
    {
        "type": "UIT",
        "mpid": "HOOD",
        "clearingBroker": "6769",
        "brokerName": "ROBINHOOD SECURITIES, LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "HOPK",
        "clearingBroker": "0750",
        "brokerName": "SILVER OAK SECURITIES, INCORPORATED                                   "
    },
    {
        "type": "UIT",
        "mpid": "HOTO",
        "clearingBroker": "0443",
        "brokerName": "HORNOR, TOWNSEND & KENT, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "HPOM",
        "clearingBroker": "0235",
        "brokerName": "HERNDON PLANT OAKLEY, LTD.                                            "
    },
    {
        "type": "UIT",
        "mpid": "HRBF",
        "clearingBroker": "0756",
        "brokerName": "AMERICAN ENTERPRISE INVESTMENT SERVICES INC.                          "
    },
    {
        "type": "UIT",
        "mpid": "HRCS",
        "clearingBroker": "0443",
        "brokerName": "HRC INVESTMENT SERVICES, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "HRGR",
        "clearingBroker": "0235",
        "brokerName": "HARGER AND COMPANY, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "HRRS",
        "clearingBroker": "0443",
        "brokerName": "HARRIS INVESTORS SERVICES, INC.                                       "
    },
    {
        "type": "UIT",
        "mpid": "HSAI",
        "clearingBroker": "0443",
        "brokerName": "INDEPENDENT FINANCIAL GROUP, LLC                                      "
    },
    {
        "type": "UIT",
        "mpid": "HSBK",
        "clearingBroker": "0443",
        "brokerName": "HSBC SECURITIES (USA) INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "HSBM",
        "clearingBroker": "0486",
        "brokerName": "HSBC SECURITIES (USA), INC/ FIXED INCOME SECS                         "
    },
    {
        "type": "UIT",
        "mpid": "HTCM",
        "clearingBroker": "0235",
        "brokerName": "HOWDEN TIGER CAPITAL MARKETS & ADVISOF LLC                            "
    },
    {
        "type": "UIT",
        "mpid": "HTPS",
        "clearingBroker": "0443",
        "brokerName": "HIGHTOWER SECURITIES, LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "HTWR",
        "clearingBroker": "0226",
        "brokerName": "HIGHTOWER SECURITIES, LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "HUCO",
        "clearingBroker": "0226",
        "brokerName": "HUNTINGTON INVESTMENT COMPANY                                         "
    },
    {
        "type": "UIT",
        "mpid": "HUNT",
        "clearingBroker": "0141",
        "brokerName": "HUNTLEIGH SECURITIES CORPORATION                                      "
    },
    {
        "type": "UIT",
        "mpid": "HWJC",
        "clearingBroker": "0052",
        "brokerName": "HWJ CAPITAL PARTNERS II, LLC                                          "
    },
    {
        "type": "UIT",
        "mpid": "HWLS",
        "clearingBroker": "0443",
        "brokerName": "M.S. HOWELLS & CO.                                                    "
    },
    {
        "type": "UIT",
        "mpid": "IAAK",
        "clearingBroker": "0279",
        "brokerName": "ISAAK BOND INVESTMENT, INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "IAEW",
        "clearingBroker": "0595",
        "brokerName": "SRT SECURITIES LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "IAEX",
        "clearingBroker": "0235",
        "brokerName": "SRT SECURITIES LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "IBND",
        "clearingBroker": "0103",
        "brokerName": "INSTITUTIONAL BOND NETWORK, LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "IBOT",
        "clearingBroker": "0279",
        "brokerName": "INVESTORS BROKERAGE OF TEXAS, INC                                     "
    },
    {
        "type": "UIT",
        "mpid": "IBPR",
        "clearingBroker": "0052",
        "brokerName": "IB CAPITAL LLC                                                        "
    },
    {
        "type": "UIT",
        "mpid": "IBSJ",
        "clearingBroker": "0052",
        "brokerName": "INTEGRITY BROKERAGE                                                   "
    },
    {
        "type": "UIT",
        "mpid": "ICAN",
        "clearingBroker": "0226",
        "brokerName": "CETERA ADVISOR NETWORKS LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "ICBK",
        "clearingBroker": "0388",
        "brokerName": "INDUSTRIAL AND COMMERCIAL BANK OF CHINA FINANCIAL SERVICES LLC        "
    },
    {
        "type": "UIT",
        "mpid": "ICCI",
        "clearingBroker": "0279",
        "brokerName": "INDEPENDENCE CAPITAL CO.                                              "
    },
    {
        "type": "UIT",
        "mpid": "ICDS",
        "clearingBroker": "0750",
        "brokerName": "ICD SECURITIES                                                        "
    },
    {
        "type": "UIT",
        "mpid": "ICEX",
        "clearingBroker": "4264",
        "brokerName": "ICE SECURITIES EXECUTION & CLEARING, LLC                              "
    },
    {
        "type": "UIT",
        "mpid": "ICMH",
        "clearingBroker": "0235",
        "brokerName": "INSTITUTIONAL CAPITAL MANAGEMENT, INC.                                "
    },
    {
        "type": "UIT",
        "mpid": "ICMI",
        "clearingBroker": "0279",
        "brokerName": "INTERCOASTAL CAPITAL MARKETS, INC.                                    "
    },
    {
        "type": "UIT",
        "mpid": "ICON",
        "clearingBroker": "0595",
        "brokerName": "ICON CAPITAL GROUP, LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "ICRL",
        "clearingBroker": "0443",
        "brokerName": "RIDEAU (I.C.) LYONS AND CO.                                           "
    },
    {
        "type": "UIT",
        "mpid": "ICTI",
        "clearingBroker": "0158",
        "brokerName": "INTERNATIONAL CORRESPONDENT TRADING, INC.                             "
    },
    {
        "type": "UIT",
        "mpid": "IDAY",
        "clearingBroker": "0103",
        "brokerName": "BROKERAGESELECT                                                       "
    },
    {
        "type": "UIT",
        "mpid": "IESI",
        "clearingBroker": "0443",
        "brokerName": "ITAU EUROPA SECURITIES INC                                            "
    },
    {
        "type": "UIT",
        "mpid": "IFCS",
        "clearingBroker": "0161",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "IMCC",
        "clearingBroker": "0005",
        "brokerName": "IMC FINANCIAL MARKETS                                                 "
    },
    {
        "type": "UIT",
        "mpid": "IMPC",
        "clearingBroker": "0443",
        "brokerName": "IMPERIAL CAPITAL, LLC                                                 "
    },
    {
        "type": "UIT",
        "mpid": "INCC",
        "clearingBroker": "0443",
        "brokerName": "SATURNA BROKERAGE SERVICES, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "INFI",
        "clearingBroker": "0279",
        "brokerName": "INTEGRAL FINANCIAL, LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "INGS",
        "clearingBroker": "0124",
        "brokerName": "INGALLS & SNYDER, LLC                                                 "
    },
    {
        "type": "UIT",
        "mpid": "INNO",
        "clearingBroker": "0052",
        "brokerName": "ETC BROKERAGE SERVICES, LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "INPI",
        "clearingBroker": "0235",
        "brokerName": "INVESTMENT PLANNERS INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "INPS",
        "clearingBroker": "0235",
        "brokerName": "INDEPENDENCE POINT SECURITIES LLC                                     "
    },
    {
        "type": "UIT",
        "mpid": "INTX",
        "clearingBroker": "0235",
        "brokerName": "INTERNATIONAL ASSETS ADVISORY, LLC                                    "
    },
    {
        "type": "UIT",
        "mpid": "IPGR",
        "clearingBroker": "0443",
        "brokerName": "INVESTMENT PLACEMENT GROUP                                            "
    },
    {
        "type": "UIT",
        "mpid": "IRMD",
        "clearingBroker": "0443",
        "brokerName": "PLANMEMBER SECURITIES CORP                                            "
    },
    {
        "type": "UIT",
        "mpid": "ISCN",
        "clearingBroker": "0235",
        "brokerName": "INSTITUTIONAL SECURITIES CORPORATION                                  "
    },
    {
        "type": "UIT",
        "mpid": "ISIG",
        "clearingBroker": "0226",
        "brokerName": "EVERCORE GROUP L.L.C.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "ISLL",
        "clearingBroker": "0052",
        "brokerName": "INLET SECURITIES LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "ISSI",
        "clearingBroker": "0052",
        "brokerName": "INSIGHT SECURITIES, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "ITAU",
        "clearingBroker": "0443",
        "brokerName": "ITAU BBA USA SECURITIES INC.                                          "
    },
    {
        "type": "UIT",
        "mpid": "ITCC",
        "clearingBroker": "0750",
        "brokerName": "STERNE AGEE FINANCIAL SERVICES, INC.                                  "
    },
    {
        "type": "UIT",
        "mpid": "ITCM",
        "clearingBroker": "0443",
        "brokerName": "INTERCAM SECURITIES, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "ITFS",
        "clearingBroker": "0226",
        "brokerName": "KEEL POINT CAPITAL, LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "IVEX",
        "clearingBroker": "0443",
        "brokerName": "INVEX, INC.                                                           "
    },
    {
        "type": "UIT",
        "mpid": "IVNT",
        "clearingBroker": "0235",
        "brokerName": "INVESTMENT NETWORK, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "IVOL",
        "clearingBroker": "0235",
        "brokerName": "UNION CAPITAL COMPANY                                                 "
    },
    {
        "type": "UIT",
        "mpid": "IVST",
        "clearingBroker": "0443",
        "brokerName": "INTERVEST INTERNATIONAL EQUITIES CORPORATION                          "
    },
    {
        "type": "UIT",
        "mpid": "JANY",
        "clearingBroker": "0374",
        "brokerName": "JANNEY MONTGOMERY SCOTT LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "JDRB",
        "clearingBroker": "0595",
        "brokerName": "J.H. DARBIE & CO., INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "JEFF",
        "clearingBroker": "0019",
        "brokerName": "JEFFERIES LLC                                                         "
    },
    {
        "type": "UIT",
        "mpid": "JEFM",
        "clearingBroker": "0235",
        "brokerName": "JEFFREY MATTHEWS FINANCIAL GROUP, L.L.C.                              "
    },
    {
        "type": "UIT",
        "mpid": "JEVO",
        "clearingBroker": "0235",
        "brokerName": "ATIS, INC                                                             "
    },
    {
        "type": "UIT",
        "mpid": "JGUN",
        "clearingBroker": "0235",
        "brokerName": "JOSEPH GUNNAR & CO. LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "JHDR",
        "clearingBroker": "0052",
        "brokerName": "JH DARBIE & CO. INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "JJKE",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "JKFS",
        "clearingBroker": "0279",
        "brokerName": "J.K. FINANCIAL SERVICES INC.                                          "
    },
    {
        "type": "UIT",
        "mpid": "JKRC",
        "clearingBroker": "0443",
        "brokerName": "J.K.R. & CO., INC.                                                    "
    },
    {
        "type": "UIT",
        "mpid": "JLEQ",
        "clearingBroker": "0161",
        "brokerName": "JUMP EXECUTION, LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "JMLS",
        "clearingBroker": "0235",
        "brokerName": "J.M LUMMIS SECURITIES, INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "JNSN",
        "clearingBroker": "0443",
        "brokerName": "D A DAVIDSON                                                          "
    },
    {
        "type": "UIT",
        "mpid": "JNST",
        "clearingBroker": "0352",
        "brokerName": "JANE STREET CAPITAL LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "JPMS",
        "clearingBroker": "0352",
        "brokerName": "J.P. MORGAN SECURITIES LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "JPPB",
        "clearingBroker": "0443",
        "brokerName": "JEFFERIES LLC                                                         "
    },
    {
        "type": "UIT",
        "mpid": "JQII",
        "clearingBroker": "0443",
        "brokerName": "THE GARBACZ GROUP                                                     "
    },
    {
        "type": "UIT",
        "mpid": "JRCO",
        "clearingBroker": "0226",
        "brokerName": "JOHNSON RICE & COMPANY L.L.C.                                         "
    },
    {
        "type": "UIT",
        "mpid": "JSAP",
        "clearingBroker": "8497",
        "brokerName": "JANE STREET CAPITAL, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "JSBA",
        "clearingBroker": "0161",
        "brokerName": "JANE STREET CAPITAL, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "JSCL",
        "clearingBroker": "0052",
        "brokerName": "JOSEPH STONE CAPITAL L.L.C.                                           "
    },
    {
        "type": "UIT",
        "mpid": "JSCT",
        "clearingBroker": "0005",
        "brokerName": "JANE STREET CAPITAL LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "JSEG",
        "clearingBroker": "0161",
        "brokerName": "JANE STREET EXECUTION SERVICES, LLC                                   "
    },
    {
        "type": "UIT",
        "mpid": "JSSF",
        "clearingBroker": "0226",
        "brokerName": "JMP SECURITIES LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "JVBF",
        "clearingBroker": "0235",
        "brokerName": "JACK V. BUTTERFIELD INVESTMENT COMPANY                                "
    },
    {
        "type": "UIT",
        "mpid": "JVBG",
        "clearingBroker": "0443",
        "brokerName": "J.V.B. FINANCIAL GROUP LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "JWCF",
        "clearingBroker": "0226",
        "brokerName": "J. W. COLE FINANCIAL, INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "JWML",
        "clearingBroker": "0235",
        "brokerName": "MILLEGAN (J.W.), INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "KALS",
        "clearingBroker": "0235",
        "brokerName": "KALOS CAPITAL, INC.                                                   "
    },
    {
        "type": "UIT",
        "mpid": "KAPG",
        "clearingBroker": "0158",
        "brokerName": "KAPITALL GENERATION, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "KART",
        "clearingBroker": "0750",
        "brokerName": "REVERE SECURITIES CORP.                                               "
    },
    {
        "type": "UIT",
        "mpid": "KAWM",
        "clearingBroker": "0443",
        "brokerName": "ARETE WEALTH MANAGEMENT, LLC                                          "
    },
    {
        "type": "UIT",
        "mpid": "KBCO",
        "clearingBroker": "0443",
        "brokerName": "KAHN BROTHERS LLC                                                     "
    },
    {
        "type": "UIT",
        "mpid": "KCAM",
        "clearingBroker": "0052",
        "brokerName": "K2 CAPITAL ASSET MANAGEMENT, LLC                                      "
    },
    {
        "type": "UIT",
        "mpid": "KCIM",
        "clearingBroker": "0235",
        "brokerName": "INVESTMENT MANAGEMENT CORPORATION                                     "
    },
    {
        "type": "UIT",
        "mpid": "KCIX",
        "clearingBroker": "0279",
        "brokerName": "KILEY PARTNERS, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "KCRD",
        "clearingBroker": "0052",
        "brokerName": "PHX FINANCIAL, INC.                                                   "
    },
    {
        "type": "UIT",
        "mpid": "KEEN",
        "clearingBroker": "0279",
        "brokerName": "ST. BERNARD FINANCIAL SERVICES, INC.                                  "
    },
    {
        "type": "UIT",
        "mpid": "KEYB",
        "clearingBroker": "0443",
        "brokerName": "KEYBANC CAPITAL MARKETS INC.                                          "
    },
    {
        "type": "UIT",
        "mpid": "KIML",
        "clearingBroker": "0226",
        "brokerName": "KIMELMAN & BAIRD, LLC                                                 "
    },
    {
        "type": "UIT",
        "mpid": "KING",
        "clearingBroker": "0235",
        "brokerName": "C. L. KING & ASSOCIATES, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "KISL",
        "clearingBroker": "0443",
        "brokerName": "KEY INVESTMENT SERVICES LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "KMSF",
        "clearingBroker": "0443",
        "brokerName": "KMS FINANCIAL SERVICES                                                "
    },
    {
        "type": "UIT",
        "mpid": "KNGS",
        "clearingBroker": "0235",
        "brokerName": "KINGSWOOD CAPITAL PARTNERS, LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "KOVP",
        "clearingBroker": "0443",
        "brokerName": "KOVACK SECURITIES INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "KOVS",
        "clearingBroker": "0226",
        "brokerName": "KOVACK SECURITIES, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "KRCO",
        "clearingBroker": "0235",
        "brokerName": "KR SECURITIES, LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "KRSH",
        "clearingBroker": "0005",
        "brokerName": "KERSHNER SECURITIES, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "KRTH",
        "clearingBroker": "0235",
        "brokerName": "J.W. KORTH & COMPANY                                                  "
    },
    {
        "type": "UIT",
        "mpid": "LADY",
        "clearingBroker": "0443",
        "brokerName": "TRUSTFIRST, INC.                                                      "
    },
    {
        "type": "UIT",
        "mpid": "LAFB",
        "clearingBroker": "0235",
        "brokerName": "LAFFERTY (R.F.) & CO., INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "LAFC",
        "clearingBroker": "0443",
        "brokerName": "R.F. LAFFERTY & CO., INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "LAFF",
        "clearingBroker": "0443",
        "brokerName": "R.F. LAFFERTY & CO., INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "LAGI",
        "clearingBroker": "0226",
        "brokerName": "ALLSTATE FINANCIAL SERVICES, LLC                                      "
    },
    {
        "type": "UIT",
        "mpid": "LANE",
        "clearingBroker": "0235",
        "brokerName": "MARC J. LANE & COMPANY                                                "
    },
    {
        "type": "UIT",
        "mpid": "LARC",
        "clearingBroker": "0235",
        "brokerName": "LARIMER CAPITAL CORPORATION                                           "
    },
    {
        "type": "UIT",
        "mpid": "LASI",
        "clearingBroker": "0141",
        "brokerName": "LIEBLONG & ASSOCIATES, INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "LASS",
        "clearingBroker": "0226",
        "brokerName": "LASALLE ST. SECURITIES, INC.                                          "
    },
    {
        "type": "UIT",
        "mpid": "LATN",
        "clearingBroker": "0443",
        "brokerName": "HEROLD & LANTERN INVESTMENTS, INC.                                    "
    },
    {
        "type": "UIT",
        "mpid": "LBKI",
        "clearingBroker": "0235",
        "brokerName": "LIBUCKI & CO., LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "LDAS",
        "clearingBroker": "0443",
        "brokerName": "LANDAAS & CO.                                                         "
    },
    {
        "type": "UIT",
        "mpid": "LDIL",
        "clearingBroker": "0226",
        "brokerName": "LINCOLN DOUGLAS INVESTMENTS, LLC                                      "
    },
    {
        "type": "UIT",
        "mpid": "LDLW",
        "clearingBroker": "0750",
        "brokerName": "LAIDLAW & COMPANY (UK) LTD.                                           "
    },
    {
        "type": "UIT",
        "mpid": "LDOT",
        "clearingBroker": "0235",
        "brokerName": "LANDOLT SECURITIES, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "LEAD",
        "clearingBroker": "0226",
        "brokerName": "THE LEADERS GROUP, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "LEBO",
        "clearingBroker": "0226",
        "brokerName": "LEIGH BALDWIN & CO., LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "LEER",
        "clearingBroker": "0443",
        "brokerName": "LEERINK SWANN & COMPANY                                               "
    },
    {
        "type": "UIT",
        "mpid": "LENX",
        "clearingBroker": "0279",
        "brokerName": "LENOX FINANCIAL SERVICES, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "LEXI",
        "clearingBroker": "0226",
        "brokerName": "LEXINGTON INVESTMENT COMPANY, INC.                                    "
    },
    {
        "type": "UIT",
        "mpid": "LEYA",
        "clearingBroker": "0235",
        "brokerName": "LEMLEY, YARLING & CO.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "LFAC",
        "clearingBroker": "0226",
        "brokerName": "OSAIC FA, INC.                                                        "
    },
    {
        "type": "UIT",
        "mpid": "LFRO",
        "clearingBroker": "0235",
        "brokerName": "LF ROTHSCHILD, LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "LGNT",
        "clearingBroker": "0052",
        "brokerName": "AXOS CLEARING LLC                                                     "
    },
    {
        "type": "UIT",
        "mpid": "LGSA",
        "clearingBroker": "0158",
        "brokerName": "WOORI INVESTMENT AND SECURITIES AMERICA, INC.                         "
    },
    {
        "type": "UIT",
        "mpid": "LIIS",
        "clearingBroker": "0226",
        "brokerName": "USAA FINANCIAL ADVISORS, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "LINC",
        "clearingBroker": "0158",
        "brokerName": "LIBERUM                                                               "
    },
    {
        "type": "UIT",
        "mpid": "LISI",
        "clearingBroker": "0443",
        "brokerName": "LEUMI INVESTMENT SERVICES, INC.                                       "
    },
    {
        "type": "UIT",
        "mpid": "LMAR",
        "clearingBroker": "0226",
        "brokerName": "LIFEMARK SECURITIES CORP.                                             "
    },
    {
        "type": "UIT",
        "mpid": "LMBD",
        "clearingBroker": "0443",
        "brokerName": "LAZARD ASSET MANAGEMENT SECURITIES LLC                                "
    },
    {
        "type": "UIT",
        "mpid": "LMKO",
        "clearingBroker": "0235",
        "brokerName": "KOHN (L.M.) & COMPANY                                                 "
    },
    {
        "type": "UIT",
        "mpid": "LMNX",
        "clearingBroker": "0226",
        "brokerName": "LUMINEX TRADING & ANALYTICS LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "LNCL",
        "clearingBroker": "0443",
        "brokerName": "LINCOLN INVESTMENT                                                    "
    },
    {
        "type": "UIT",
        "mpid": "LNKS",
        "clearingBroker": "0443",
        "brokerName": "GUGGENHEIM SECURITIES, LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "LOMB",
        "clearingBroker": "0141",
        "brokerName": "LOMBARD SECURITIES INCORPORATED                                       "
    },
    {
        "type": "UIT",
        "mpid": "LOOP",
        "clearingBroker": "0443",
        "brokerName": "LOOP CAPITAL MARKETS, LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "LOUE",
        "clearingBroker": "0161",
        "brokerName": "ICAP CORPORATES LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "LOUI",
        "clearingBroker": "0005",
        "brokerName": "LOUIS CAPITAL MARKETS, LP                                             "
    },
    {
        "type": "UIT",
        "mpid": "LPFS",
        "clearingBroker": "0235",
        "brokerName": "LIBERTY PARTNERS FINANCIAL SERVICES, INC.                             "
    },
    {
        "type": "UIT",
        "mpid": "LPLE",
        "clearingBroker": "0075",
        "brokerName": "LPL ENTERPRISE, LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "LQNA",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "UIT",
        "mpid": "LQNB",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "UIT",
        "mpid": "LQNF",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "UIT",
        "mpid": "LQNT",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "UIT",
        "mpid": "LQPT",
        "clearingBroker": "0161",
        "brokerName": "DASH FINANCIAL TECHNOLOGIES LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "LRBC",
        "clearingBroker": "0235",
        "brokerName": "LIBERTY ASSOCIATES, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "LRCM",
        "clearingBroker": "0279",
        "brokerName": "LOCKTON RE CAPITAL MARKETS, LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "LSCM",
        "clearingBroker": "0235",
        "brokerName": "LAKE STREET CAPITAL MARKETS, LLC                                      "
    },
    {
        "type": "UIT",
        "mpid": "LSFB",
        "clearingBroker": "0443",
        "brokerName": "LION STREET FINANCIAL, LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "LSKO",
        "clearingBroker": "0226",
        "brokerName": "LESKO SECURITIES INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "LSPI",
        "clearingBroker": "0141",
        "brokerName": "LAFAYETTE INVESTMENTS                                                 "
    },
    {
        "type": "UIT",
        "mpid": "LSSI",
        "clearingBroker": "0750",
        "brokerName": "EJ STERLING INC.                                                      "
    },
    {
        "type": "UIT",
        "mpid": "LSUS",
        "clearingBroker": "0443",
        "brokerName": "LATIN SECURITIES INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "LTAA",
        "clearingBroker": "0226",
        "brokerName": "LUMINEX TRADING & ANALYTICS LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "LTCO",
        "clearingBroker": "0226",
        "brokerName": "LADENBURG, THALMANN & CO., INC.                                       "
    },
    {
        "type": "UIT",
        "mpid": "LVAR",
        "clearingBroker": "0443",
        "brokerName": "LARRAINVIAL SECURITIES US LLC                                         "
    },
    {
        "type": "UIT",
        "mpid": "LVMR",
        "clearingBroker": "0235",
        "brokerName": "LIVERMORE TRADING GROUP, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "LWFL",
        "clearingBroker": "0443",
        "brokerName": "LAWSON FINANCIAL CORPORATION                                          "
    },
    {
        "type": "UIT",
        "mpid": "LYSI",
        "clearingBroker": "0443",
        "brokerName": "LLOYDS SECURITIES INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "MACC",
        "clearingBroker": "0226",
        "brokerName": "NEWEDGE SECURITIES, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "MADV",
        "clearingBroker": "0443",
        "brokerName": "MILLENNIUM ADVISORS, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "MAMA",
        "clearingBroker": "0443",
        "brokerName": "SECUREVEST FINANCIAL GROUP                                            "
    },
    {
        "type": "UIT",
        "mpid": "MAPA",
        "clearingBroker": "0279",
        "brokerName": "MADISON PAIGE SECURITIES LLC                                          "
    },
    {
        "type": "UIT",
        "mpid": "MASE",
        "clearingBroker": "0141",
        "brokerName": "MANAGED ACCOUNT SERVICES, LLC                                         "
    },
    {
        "type": "UIT",
        "mpid": "MAVS",
        "clearingBroker": "0443",
        "brokerName": "MADISON AVENUE SECURITIES                                             "
    },
    {
        "type": "UIT",
        "mpid": "MAXM",
        "clearingBroker": "0443",
        "brokerName": "MAXIM GROUP LLC                                                       "
    },
    {
        "type": "UIT",
        "mpid": "MBBS",
        "clearingBroker": "0443",
        "brokerName": "INFINEX INVESTMENTS                                                   "
    },
    {
        "type": "UIT",
        "mpid": "MBSE",
        "clearingBroker": "0052",
        "brokerName": "MBS SOURCE ETRADING, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "MBSL",
        "clearingBroker": "0443",
        "brokerName": "MBS CAPITAL MARKETS, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "MBUS",
        "clearingBroker": "0052",
        "brokerName": "MEDIOBANCA SECURITIES USA LLC                                         "
    },
    {
        "type": "UIT",
        "mpid": "MCAP",
        "clearingBroker": "1043",
        "brokerName": "MCAP LLC                                                              "
    },
    {
        "type": "UIT",
        "mpid": "MCBT",
        "clearingBroker": "0235",
        "brokerName": "MOORS & CABOT, INC.                                                   "
    },
    {
        "type": "UIT",
        "mpid": "MCCL",
        "clearingBroker": "0443",
        "brokerName": "MCCLURG CAPITAL CORPORATION                                           "
    },
    {
        "type": "UIT",
        "mpid": "MCNA",
        "clearingBroker": "0443",
        "brokerName": "MCNALLY FINANCIAL SERVICES CORPORATION                                "
    },
    {
        "type": "UIT",
        "mpid": "MDGP",
        "clearingBroker": "0235",
        "brokerName": "MD GLOBAL PARTNERS, LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "MEAL",
        "clearingBroker": "0226",
        "brokerName": "M. E. ALLISON & CO., INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "MERP",
        "clearingBroker": "0235",
        "brokerName": "MERIDIAN EQUITY PARTNERS, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "MERQ",
        "clearingBroker": "0052",
        "brokerName": "MERCATOR ASSOCIATES LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "MESF",
        "clearingBroker": "0443",
        "brokerName": "MESIROW FINANCIAL, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "MFGX",
        "clearingBroker": "0443",
        "brokerName": "MISCHLER FINANCIAL GROUP, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "MFRS",
        "clearingBroker": "0443",
        "brokerName": "MFR SECURITIES, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "MHFI",
        "clearingBroker": "0226",
        "brokerName": "M HOLDINGS SECURITIES, INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "MHSI",
        "clearingBroker": "0443",
        "brokerName": "M HOLDINGS SECURITIES                                                 "
    },
    {
        "type": "UIT",
        "mpid": "MIAM",
        "clearingBroker": "0141",
        "brokerName": "FMSBONDS, INC.                                                        "
    },
    {
        "type": "UIT",
        "mpid": "MIBS",
        "clearingBroker": "0443",
        "brokerName": "BMO HARRIS FINANCIAL ADVISORS                                         "
    },
    {
        "type": "UIT",
        "mpid": "MIFI",
        "clearingBroker": "0226",
        "brokerName": "MILKIE FERGUSON INVESTMENTS, INC.                                     "
    },
    {
        "type": "UIT",
        "mpid": "MILE",
        "clearingBroker": "0052",
        "brokerName": "I-BANKERS SECURITIES INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "MILN",
        "clearingBroker": "1767",
        "brokerName": "MILLENNIUM ADVISORS, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "MINP",
        "clearingBroker": "0235",
        "brokerName": "MINISTRY PARTNERS SECURITIES, LLC                                     "
    },
    {
        "type": "UIT",
        "mpid": "MINV",
        "clearingBroker": "0235",
        "brokerName": "MACK INVESTMENTS SECURITIES, INC.                                     "
    },
    {
        "type": "UIT",
        "mpid": "MIRA",
        "clearingBroker": "1043",
        "brokerName": "MIRAE ASSET SECURITIES (USA) INC.                                     "
    },
    {
        "type": "UIT",
        "mpid": "MITR",
        "clearingBroker": "0443",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "MJDW",
        "clearingBroker": "0279",
        "brokerName": "MURRAY SECURITIES                                                     "
    },
    {
        "type": "UIT",
        "mpid": "MJWH",
        "clearingBroker": "0235",
        "brokerName": "ETICO PARTNERS LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "MKRT",
        "clearingBroker": "0235",
        "brokerName": "MARKET SECURITIES, LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "MKTI",
        "clearingBroker": "0226",
        "brokerName": "U.S. BANCORP ADVISORS, LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "MKTX",
        "clearingBroker": "4265",
        "brokerName": "MARKETAXESS CORPORATION                                               "
    },
    {
        "type": "UIT",
        "mpid": "MKTY",
        "clearingBroker": "4265",
        "brokerName": "MARKETAXESS CORPORATION                                               "
    },
    {
        "type": "UIT",
        "mpid": "MLCO",
        "clearingBroker": "0161",
        "brokerName": "BOFA SECURITIES, INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "MLMS",
        "clearingBroker": "0279",
        "brokerName": "MAINLINE WEST MUNICIPAL SECURITIES, LLC                               "
    },
    {
        "type": "UIT",
        "mpid": "MLWM",
        "clearingBroker": "0671",
        "brokerName": "MERRILL LYNCH, PIERCE, FENNER & SMITH INCORPORATED                    "
    },
    {
        "type": "UIT",
        "mpid": "MMCS",
        "clearingBroker": "0443",
        "brokerName": "MMC SECURITIES CORP.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "MNCC",
        "clearingBroker": "0443",
        "brokerName": "MONEY CONCEPTS CAPITAL CORP.                                          "
    },
    {
        "type": "UIT",
        "mpid": "MNCO",
        "clearingBroker": "0279",
        "brokerName": "NELSON (MARTIN) & CO., INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "MNRC",
        "clearingBroker": "0443",
        "brokerName": "MONARCH CAPITAL GROUP LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "MNXS",
        "clearingBroker": "0443",
        "brokerName": "MUNIAXIS LEBENTHAL LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "MOCM",
        "clearingBroker": "0235",
        "brokerName": "MORETON CAPITAL MARKETS, LLC                                          "
    },
    {
        "type": "UIT",
        "mpid": "MOFI",
        "clearingBroker": "0158",
        "brokerName": "M1 FINANCE LLC                                                        "
    },
    {
        "type": "UIT",
        "mpid": "MOIS",
        "clearingBroker": "0443",
        "brokerName": "MUTUAL OF OMAHA INVESTOR SERVICES INC.                                "
    },
    {
        "type": "UIT",
        "mpid": "MOLO",
        "clearingBroker": "0235",
        "brokerName": "MOLONEY SECURITIES                                                    "
    },
    {
        "type": "UIT",
        "mpid": "MONE",
        "clearingBroker": "0443",
        "brokerName": "MONERE INVESTMENTS, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "MONR",
        "clearingBroker": "0226",
        "brokerName": "MONROE FINANCIAL PARTNERS, INC.                                       "
    },
    {
        "type": "UIT",
        "mpid": "MONX",
        "clearingBroker": "0443",
        "brokerName": "MONEX SECURITIES INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "MORA",
        "clearingBroker": "0443",
        "brokerName": "MORA WM SECURITIES                                                    "
    },
    {
        "type": "UIT",
        "mpid": "MPLW",
        "clearingBroker": "0226",
        "brokerName": "MAPLEWOOD INVESTMENT ADVISORS, INC.                                   "
    },
    {
        "type": "UIT",
        "mpid": "MRAD",
        "clearingBroker": "0052",
        "brokerName": "MACRO RISK ADVISORS LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "MRBA",
        "clearingBroker": "0052",
        "brokerName": "IBN FINANCIAL SERVICES, INC.                                          "
    },
    {
        "type": "UIT",
        "mpid": "MRIS",
        "clearingBroker": "0443",
        "brokerName": "BMO HARRIS FINANCIAL ADVISORS                                         "
    },
    {
        "type": "UIT",
        "mpid": "MRKS",
        "clearingBroker": "0443",
        "brokerName": "M. RAMSEY KING                                                        "
    },
    {
        "type": "UIT",
        "mpid": "MRNA",
        "clearingBroker": "0161",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "MRPH",
        "clearingBroker": "0226",
        "brokerName": "WM FINANCIAL SERVICES, INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "MRSC",
        "clearingBroker": "0287",
        "brokerName": "TRADEUP SECURITIES, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "MSCB",
        "clearingBroker": "0279",
        "brokerName": "MAINE SECURITIES CORPORATION                                          "
    },
    {
        "type": "UIT",
        "mpid": "MSEC",
        "clearingBroker": "0235",
        "brokerName": "MSEC, LLC                                                             "
    },
    {
        "type": "UIT",
        "mpid": "MSII",
        "clearingBroker": "0226",
        "brokerName": "MSI FINANCIAL SERVICES, INC.                                          "
    },
    {
        "type": "UIT",
        "mpid": "MSRO",
        "clearingBroker": "0226",
        "brokerName": "MESIROW FINANCIAL, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "MSTC",
        "clearingBroker": "0226",
        "brokerName": "MIDWESTERN SECURITIES TRADING COMPANY, LLC                            "
    },
    {
        "type": "UIT",
        "mpid": "MTBK",
        "clearingBroker": "0443",
        "brokerName": "MULTI-BANK SECURITIES, INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "MTDB",
        "clearingBroker": "0443",
        "brokerName": "M&T SECURITIES, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "MTGO",
        "clearingBroker": "0158",
        "brokerName": "MTG, LLC                                                              "
    },
    {
        "type": "UIT",
        "mpid": "MTHN",
        "clearingBroker": "0005",
        "brokerName": "MARATHON TRADING GROUP LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "MTLE",
        "clearingBroker": "0235",
        "brokerName": "MTL EQUITY PRODUCTS, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "MTSL",
        "clearingBroker": "0226",
        "brokerName": "MSEC, LLC                                                             "
    },
    {
        "type": "UIT",
        "mpid": "MUFG",
        "clearingBroker": "0076",
        "brokerName": "MUFG SECURITIES AMERICAS INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "MULT",
        "clearingBroker": "0443",
        "brokerName": "MULTI-FINANCIAL SECURITIES GROUP                                      "
    },
    {
        "type": "UIT",
        "mpid": "MURJ",
        "clearingBroker": "0750",
        "brokerName": "COMMERCE ONE FINANCIAL INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "MWAF",
        "clearingBroker": "0443",
        "brokerName": "MWA FINANCIAL SERVICES, INC.                                          "
    },
    {
        "type": "UIT",
        "mpid": "MWCC",
        "clearingBroker": "0235",
        "brokerName": "MONNESS CRESPI HARDT & CO., INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "MWIL",
        "clearingBroker": "0235",
        "brokerName": "MORGAN WILSHIRE SECURITIES, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "MWMS",
        "clearingBroker": "0443",
        "brokerName": "MUREX CAPITAL LLC                                                     "
    },
    {
        "type": "UIT",
        "mpid": "MZHO",
        "clearingBroker": "2396",
        "brokerName": "MIZUHO SECURITIES USA LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "NACM",
        "clearingBroker": "0161",
        "brokerName": "NABSECURITIES, LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "NADL",
        "clearingBroker": "0235",
        "brokerName": "WARREN D. NADEL & COMPANY                                             "
    },
    {
        "type": "UIT",
        "mpid": "NAPK",
        "clearingBroker": "0052",
        "brokerName": "B. RILEY WEALTH MANAGEMENT                                            "
    },
    {
        "type": "UIT",
        "mpid": "NASC",
        "clearingBroker": "0235",
        "brokerName": "NATALLIANCE SECURITIES, LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "NAVC",
        "clearingBroker": "0235",
        "brokerName": "NAVIAN CAPITAL SECURITIES LLC                                         "
    },
    {
        "type": "UIT",
        "mpid": "NBAR",
        "clearingBroker": "0226",
        "brokerName": "NANCY BARRON & ASSOCIATES, INC.                                       "
    },
    {
        "type": "UIT",
        "mpid": "NBCS",
        "clearingBroker": "0235",
        "brokerName": "NBC SECURITIES, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "NBLB",
        "clearingBroker": "0226",
        "brokerName": "NEUBERGER BERMAN BD LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "NBSL",
        "clearingBroker": "0226",
        "brokerName": "BMO NESBITT BURNS SECURITIES LTD.                                     "
    },
    {
        "type": "UIT",
        "mpid": "NEED",
        "clearingBroker": "0443",
        "brokerName": "NEEDHAM & COMPANY, LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "NEPP",
        "clearingBroker": "0226",
        "brokerName": "N.E. PRIVATE CLIENT ADVISORS, LTD.                                    "
    },
    {
        "type": "UIT",
        "mpid": "NEST",
        "clearingBroker": "0235",
        "brokerName": "NEST INVESTMENTS BD LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "NEXT",
        "clearingBroker": "0443",
        "brokerName": "NEXT FINANCIAL GROUP, INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "NFGR",
        "clearingBroker": "0141",
        "brokerName": "NATIONS FINANCIAL GROUP, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "NFSC",
        "clearingBroker": "0226",
        "brokerName": "NATIONAL FINANCIAL SERVICES LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "NFTY",
        "clearingBroker": "0235",
        "brokerName": "INFINITY FINANCIAL SERVICES                                           "
    },
    {
        "type": "UIT",
        "mpid": "NHFS",
        "clearingBroker": "0443",
        "brokerName": "ALIGHT FINANCIAL SOLUTIONS, LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "NHWI",
        "clearingBroker": "0141",
        "brokerName": "HENNION & WALSH, INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "NIAD",
        "clearingBroker": "0052",
        "brokerName": "NI ADVISORS                                                           "
    },
    {
        "type": "UIT",
        "mpid": "NITE",
        "clearingBroker": "0295",
        "brokerName": "VIRTU AMERICAS LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "NLOV",
        "clearingBroker": "0279",
        "brokerName": "NORTLOV SECURITIES LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "NOBL",
        "clearingBroker": "0750",
        "brokerName": "NOBLE FINANCIAL CAPITAL MARKETS                                       "
    },
    {
        "type": "UIT",
        "mpid": "NORC",
        "clearingBroker": "0235",
        "brokerName": "NORTHERN CAPITAL SEC. CORP.                                           "
    },
    {
        "type": "UIT",
        "mpid": "NORP",
        "clearingBroker": "0443",
        "brokerName": "PARETO SECURITIES INC                                                 "
    },
    {
        "type": "UIT",
        "mpid": "NORT",
        "clearingBroker": "0443",
        "brokerName": "NORTHLAND SECURITIES, INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "NOSO",
        "clearingBroker": "0443",
        "brokerName": "NORTH SOUTH CAPITAL LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "NPAI",
        "clearingBroker": "0443",
        "brokerName": "NATIONWIDE PLANNING ASSOCIATES                                        "
    },
    {
        "type": "UIT",
        "mpid": "NPBF",
        "clearingBroker": "0443",
        "brokerName": "NPB FINANCIAL GROUP, LLC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "NPNT",
        "clearingBroker": "0005",
        "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "NPTP",
        "clearingBroker": "0443",
        "brokerName": "MAREX CAPITAL MARKETS INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "NRAM",
        "clearingBroker": "0443",
        "brokerName": "CANACCORD WEALTH MANAGEMENT (USA) INC.                                "
    },
    {
        "type": "UIT",
        "mpid": "NSFP",
        "clearingBroker": "0235",
        "brokerName": "NORTHSTAR FINANCIAL PARTNERS, INC.                                    "
    },
    {
        "type": "UIT",
        "mpid": "NSRD",
        "clearingBroker": "0235",
        "brokerName": "NESTLERODE & CO., INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "NTFN",
        "clearingBroker": "0052",
        "brokerName": "NETWORK 1 FINANCIAL SECURITIES INC.                                   "
    },
    {
        "type": "UIT",
        "mpid": "NTRC",
        "clearingBroker": "0226",
        "brokerName": "NORTHERN TRUST SECURITIES, INC.                                       "
    },
    {
        "type": "UIT",
        "mpid": "NTSI",
        "clearingBroker": "0443",
        "brokerName": "NESBITT THOMSON SECURITIES, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "NVEN",
        "clearingBroker": "0448",
        "brokerName": "NUVEEN SECURITIES, LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "NWCM",
        "clearingBroker": "0235",
        "brokerName": "NW CAPITAL MARKETS INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "NWIA",
        "clearingBroker": "0750",
        "brokerName": "NORTHWEST INVESTMENT ADVISORS, INC.                                   "
    },
    {
        "type": "UIT",
        "mpid": "NWML",
        "clearingBroker": "0443",
        "brokerName": "NORTHWESTERN MUTUAL INVESTMENT SERVICES, LLC                          "
    },
    {
        "type": "UIT",
        "mpid": "NYLS",
        "clearingBroker": "0226",
        "brokerName": "NYLIFE SECURITIES INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "OAKR",
        "clearingBroker": "0235",
        "brokerName": "THE OAK RIDGE FINANCIAL SERVICES GROUP, INC.                          "
    },
    {
        "type": "UIT",
        "mpid": "OBWS",
        "clearingBroker": "0226",
        "brokerName": "OBERWEIS SECURITIES, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "OCAC",
        "clearingBroker": "0235",
        "brokerName": "OLSON, CROSS & ALAMO LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "OCEA",
        "clearingBroker": "0052",
        "brokerName": "OCEAN FINANCIAL SERVICES, LLC                                         "
    },
    {
        "type": "UIT",
        "mpid": "OCON",
        "clearingBroker": "0103",
        "brokerName": "O'CONNOR & CO SECURITIES                                              "
    },
    {
        "type": "UIT",
        "mpid": "ODEO",
        "clearingBroker": "0388",
        "brokerName": "ODEON CAP                                                             "
    },
    {
        "type": "UIT",
        "mpid": "ODNC",
        "clearingBroker": "0235",
        "brokerName": "ODEON CAPITAL GROUP LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "OFGF",
        "clearingBroker": "0235",
        "brokerName": "OFG FINANCIAL SERVICES INC                                            "
    },
    {
        "type": "UIT",
        "mpid": "OLNE",
        "clearingBroker": "0279",
        "brokerName": "OLDEN LANE SECURITIES, LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "OMSL",
        "clearingBroker": "0158",
        "brokerName": "OM SECURITIES, LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "ONES",
        "clearingBroker": "0443",
        "brokerName": "O N EQUITY SALES CO.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "OPCO",
        "clearingBroker": "0571",
        "brokerName": "OPPENHEIMER & CO. INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "ORTL",
        "clearingBroker": "0443",
        "brokerName": "ORIENTAL FINANCIAL SERVICES                                           "
    },
    {
        "type": "UIT",
        "mpid": "OTCN",
        "clearingBroker": "0158",
        "brokerName": "OTC LINK LLC                                                          "
    },
    {
        "type": "UIT",
        "mpid": "OYLD",
        "clearingBroker": "0235",
        "brokerName": "OPENYIELD TRADING LLC                                                 "
    },
    {
        "type": "UIT",
        "mpid": "PACK",
        "clearingBroker": "0279",
        "brokerName": "PACKERLAND BROKERAGE SERVICES                                         "
    },
    {
        "type": "UIT",
        "mpid": "PACT",
        "clearingBroker": "0443",
        "brokerName": "BTG PACTUAL US CAPITAL LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "PAMC",
        "clearingBroker": "0226",
        "brokerName": "PROGRESSIVE ASSET MANAGEMENT                                          "
    },
    {
        "type": "UIT",
        "mpid": "PAPA",
        "clearingBroker": "0443",
        "brokerName": "PAPAMARKOU WELLNER & CO., INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "PARI",
        "clearingBroker": "0630",
        "brokerName": "BNP PARIBAS SECURITIES CORP.                                          "
    },
    {
        "type": "UIT",
        "mpid": "PASC",
        "clearingBroker": "0443",
        "brokerName": "PARK AVENUE SECURITIES LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "PASL",
        "clearingBroker": "0443",
        "brokerName": "PERSHING ADVISOR SOLUTIONS, LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "PATR",
        "clearingBroker": "0624",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "UIT",
        "mpid": "PAUL",
        "clearingBroker": "0595",
        "brokerName": "PAULSON INVESTMENT COMPANY, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "PBON",
        "clearingBroker": "0161",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "UIT",
        "mpid": "PCCA",
        "clearingBroker": "0279",
        "brokerName": "PEACHCAP SECURITIES, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "PCIS",
        "clearingBroker": "0226",
        "brokerName": "BANKOH INVESTMENT SERVICES, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "PCSB",
        "clearingBroker": "0443",
        "brokerName": "PRIVATE CLIENT SERVICES, LLC                                          "
    },
    {
        "type": "UIT",
        "mpid": "PENG",
        "clearingBroker": "0443",
        "brokerName": "PENNSYLVANIA GROUP INCORPORATED (THE)                                 "
    },
    {
        "type": "UIT",
        "mpid": "PERC",
        "clearingBroker": "0279",
        "brokerName": "PERCIVAL FINANCIAL PARTNERS, LTD.                                     "
    },
    {
        "type": "UIT",
        "mpid": "PERS",
        "clearingBroker": "0443",
        "brokerName": "PERSHING LLC                                                          "
    },
    {
        "type": "UIT",
        "mpid": "PFCG",
        "clearingBroker": "0279",
        "brokerName": "PREFERRED CLIENT GROUP, INC.                                          "
    },
    {
        "type": "UIT",
        "mpid": "PFDC",
        "clearingBroker": "0235",
        "brokerName": "PREFERRED CAPITAL SECURITIES, LLC                                     "
    },
    {
        "type": "UIT",
        "mpid": "PHBP",
        "clearingBroker": "0052",
        "brokerName": "PENNHAVEN BROKERAGE PARTNERS, LLC                                     "
    },
    {
        "type": "UIT",
        "mpid": "PHIN",
        "clearingBroker": "0443",
        "brokerName": "PHILADELPHIA INVESTORS, LTD.                                          "
    },
    {
        "type": "UIT",
        "mpid": "PICE",
        "clearingBroker": "0443",
        "brokerName": "T ROWE PRICE INVESTMENT SERV                                          "
    },
    {
        "type": "UIT",
        "mpid": "PICI",
        "clearingBroker": "0279",
        "brokerName": "POLAR INVESTMENT COUNSEL, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "PICL",
        "clearingBroker": "0052",
        "brokerName": "PAULSON INVESTMENT COMPANY LLC                                        "
    },
    {
        "type": "UIT",
        "mpid": "PIMS",
        "clearingBroker": "0226",
        "brokerName": "PRUDENTIAL INVESTMENT MANAGEMENT SERVICES, LLC                        "
    },
    {
        "type": "UIT",
        "mpid": "PINA",
        "clearingBroker": "0141",
        "brokerName": "PINNACLE INVESTMENTS, LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "PIPR",
        "clearingBroker": "0443",
        "brokerName": "PIPER SANDLER & CO.                                                   "
    },
    {
        "type": "UIT",
        "mpid": "PIRR",
        "clearingBroker": "0443",
        "brokerName": "PIRRONE & CO., INC.                                                   "
    },
    {
        "type": "UIT",
        "mpid": "PISC",
        "clearingBroker": "0750",
        "brokerName": "PACIFIC INVESTMENT SECURITIES CORP.                                   "
    },
    {
        "type": "UIT",
        "mpid": "PJEF",
        "clearingBroker": "0443",
        "brokerName": "JEFFERIES LLC                                                         "
    },
    {
        "type": "UIT",
        "mpid": "PKAX",
        "clearingBroker": "0158",
        "brokerName": "PEAK6 CAPITAL MANAGEMENT LLC                                          "
    },
    {
        "type": "UIT",
        "mpid": "PLAT",
        "clearingBroker": "0443",
        "brokerName": "CLARKSONS PLATOU SECURITIES, INC.                                     "
    },
    {
        "type": "UIT",
        "mpid": "PMAS",
        "clearingBroker": "0443",
        "brokerName": "PMA SECURITIES, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "PNCC",
        "clearingBroker": "0226",
        "brokerName": "PNC INVESTMENTS                                                       "
    },
    {
        "type": "UIT",
        "mpid": "PNCM",
        "clearingBroker": "2835",
        "brokerName": "PNC CAPITAL MARKETS LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "PNFP",
        "clearingBroker": "0279",
        "brokerName": "PNFP CAPITAL MARKETS, INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "PNSA",
        "clearingBroker": "0235",
        "brokerName": "PENSERRA SECURITIES, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "PODE",
        "clearingBroker": "0235",
        "brokerName": "PODESTA & CO.                                                         "
    },
    {
        "type": "UIT",
        "mpid": "POOH",
        "clearingBroker": "0443",
        "brokerName": "QUESTAR CAPITAL CORPORATION                                           "
    },
    {
        "type": "UIT",
        "mpid": "POPS",
        "clearingBroker": "0226",
        "brokerName": "POPULAR SECURITIES, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "POWL",
        "clearingBroker": "0443",
        "brokerName": "POWELL (ELMER E.) COMPANY                                             "
    },
    {
        "type": "UIT",
        "mpid": "PPSI",
        "clearingBroker": "0235",
        "brokerName": "PENSION PLANNERS SECURITIES, INC.                                     "
    },
    {
        "type": "UIT",
        "mpid": "PPSL",
        "clearingBroker": "0413",
        "brokerName": "SANTANDER US CAPITAL MARKETS LLC                                      "
    },
    {
        "type": "UIT",
        "mpid": "PREB",
        "clearingBroker": "0005",
        "brokerName": "TP ICAP GLOBAL MARKETS AMERICAS LLC.                                  "
    },
    {
        "type": "UIT",
        "mpid": "PRFA",
        "clearingBroker": "0235",
        "brokerName": "PROOF SERVICES LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "PRGI",
        "clearingBroker": "0443",
        "brokerName": "PORTFOLIO RESOURCES GROUP, INC.                                       "
    },
    {
        "type": "UIT",
        "mpid": "PROE",
        "clearingBroker": "0443",
        "brokerName": "PROEQUITIES, INC.                                                     "
    },
    {
        "type": "UIT",
        "mpid": "PRPO",
        "clearingBroker": "0443",
        "brokerName": "PRIVATE PORTFOLIO, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "PRSB",
        "clearingBroker": "0141",
        "brokerName": "PRESIDENTIAL BROKERAGE, INC.                                          "
    },
    {
        "type": "UIT",
        "mpid": "PSII",
        "clearingBroker": "0226",
        "brokerName": "KESTRA INVESTMENT SERVICES, LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "PSIM",
        "clearingBroker": "0226",
        "brokerName": "PRINCIPAL SECURITIES, INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "PSIN",
        "clearingBroker": "0443",
        "brokerName": "LUMENT SECURITIES, LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "PSUT",
        "clearingBroker": "0235",
        "brokerName": "INNOVATION PARTNERS LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "PTCM",
        "clearingBroker": "0443",
        "brokerName": "CAVU SECURITIES LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "PTIS",
        "clearingBroker": "0235",
        "brokerName": "PTI SECURITIES & FUTURES L.P.                                         "
    },
    {
        "type": "UIT",
        "mpid": "PUPL",
        "clearingBroker": "0226",
        "brokerName": "PUPLAVA SECURITIES, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "PWAS",
        "clearingBroker": "0443",
        "brokerName": "PWA SECURITIES, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "PWJC",
        "clearingBroker": "0221",
        "brokerName": "UBS FINANCIAL SERVICES INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "QBND",
        "clearingBroker": "0161",
        "brokerName": "MCAP LLC                                                              "
    },
    {
        "type": "UIT",
        "mpid": "QBSI",
        "clearingBroker": "0226",
        "brokerName": "GLEN EAGLE WEALTH, LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "QCAP",
        "clearingBroker": "0235",
        "brokerName": "QUINT CAPITAL CORPORATION                                             "
    },
    {
        "type": "UIT",
        "mpid": "QCAS",
        "clearingBroker": "0226",
        "brokerName": "QUINCY CASS ASSOCIATES, INCORPORATED                                  "
    },
    {
        "type": "UIT",
        "mpid": "QMSR",
        "clearingBroker": "0235",
        "brokerName": "QUATTRO M SECURITIES INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "QWIK",
        "clearingBroker": "0161",
        "brokerName": "MCAP LLC                                                              "
    },
    {
        "type": "UIT",
        "mpid": "RAAA",
        "clearingBroker": "0052",
        "brokerName": "RICHARD JAMES & ASSOCIATES, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "RAAI",
        "clearingBroker": "0226",
        "brokerName": "OSAIC WEALTH, INC.                                                    "
    },
    {
        "type": "UIT",
        "mpid": "RABO",
        "clearingBroker": "0443",
        "brokerName": "RABO SECURITIES USA, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "RACO",
        "clearingBroker": "0158",
        "brokerName": "SHEARMAN, RALSTON, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "RAJA",
        "clearingBroker": "0725",
        "brokerName": "RAYMOND JAMES & ASSOCIATES, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "RAJC",
        "clearingBroker": "0443",
        "brokerName": "RAYMOND JAMES USA                                                     "
    },
    {
        "type": "UIT",
        "mpid": "RAYG",
        "clearingBroker": "0443",
        "brokerName": "BOLTON GLOBAL CAPITAL                                                 "
    },
    {
        "type": "UIT",
        "mpid": "RBAC",
        "clearingBroker": "0443",
        "brokerName": "ROBERT B. AUSDAL & CO. INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "RBCD",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS CORPORATION                                       "
    },
    {
        "type": "UIT",
        "mpid": "RBCM",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS CORPORATION                                       "
    },
    {
        "type": "UIT",
        "mpid": "RBCX",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS CORPORATION                                       "
    },
    {
        "type": "UIT",
        "mpid": "RBII",
        "clearingBroker": "0279",
        "brokerName": "REGIONAL BROKERS, INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "RCMA",
        "clearingBroker": "0235",
        "brokerName": "RBC CAPITAL MARKETS ARBITRAGE, S.A.                                   "
    },
    {
        "type": "UIT",
        "mpid": "RCRS",
        "clearingBroker": "0226",
        "brokerName": "ROOSEVELT & CROSS, INCORPORATED                                       "
    },
    {
        "type": "UIT",
        "mpid": "RDSS",
        "clearingBroker": "0141",
        "brokerName": "RDSC, LLC                                                             "
    },
    {
        "type": "UIT",
        "mpid": "REGR",
        "clearingBroker": "0141",
        "brokerName": "REGISTER & AKERS INVESTMENTS, INC.                                    "
    },
    {
        "type": "UIT",
        "mpid": "RGLD",
        "clearingBroker": "0279",
        "brokerName": "REGAL SECURITIES, INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "RGLS",
        "clearingBroker": "0235",
        "brokerName": "REGAL SECURITIES, INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "RHDS",
        "clearingBroker": "0141",
        "brokerName": "RHODES SECURITIES, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "RHOX",
        "clearingBroker": "0005",
        "brokerName": "XR SECURITIES LLC                                                     "
    },
    {
        "type": "UIT",
        "mpid": "RIAP",
        "clearingBroker": "0443",
        "brokerName": "OSAIC SERVICES, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "RICE",
        "clearingBroker": "0235",
        "brokerName": "RICE FINANCIAL PRODUCTS COMPANY                                       "
    },
    {
        "type": "UIT",
        "mpid": "RICJ",
        "clearingBroker": "0235",
        "brokerName": "RICE SECURITIES, LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "RICM",
        "clearingBroker": "0595",
        "brokerName": "RICE FINANCIAL PRODUCTS COMPANY                                       "
    },
    {
        "type": "UIT",
        "mpid": "RIED",
        "clearingBroker": "0235",
        "brokerName": "RIEDL, FIRST SECURITIES COMPANY OF KANSAS                             "
    },
    {
        "type": "UIT",
        "mpid": "RILY",
        "clearingBroker": "0226",
        "brokerName": "B. RILEY FBR, INC.                                                    "
    },
    {
        "type": "UIT",
        "mpid": "RJFI",
        "clearingBroker": "0390",
        "brokerName": "RAYMOND JAMES & ASSOCIATES, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "RKWS",
        "clearingBroker": "0235",
        "brokerName": "ROCKWELL SECURITIES LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "RLIN",
        "clearingBroker": "0005",
        "brokerName": "WELLS FARGO SECURITIES, LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "RMAC",
        "clearingBroker": "0235",
        "brokerName": "RENAISSANCE MACRO SECURITIES, LLC                                     "
    },
    {
        "type": "UIT",
        "mpid": "RMPI",
        "clearingBroker": "0141",
        "brokerName": "RICHARDS, MERRILL & PETERSON, INC.                                    "
    },
    {
        "type": "UIT",
        "mpid": "RMST",
        "clearingBroker": "0443",
        "brokerName": "R.M. STARK & CO., INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "ROAR",
        "clearingBroker": "0103",
        "brokerName": "DINOSAUR SECURITIES                                                   "
    },
    {
        "type": "UIT",
        "mpid": "ROBT",
        "clearingBroker": "0443",
        "brokerName": "ROBOTTI & COMPANY, LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "ROCK",
        "clearingBroker": "0226",
        "brokerName": "ROCKEFELLER FINANCIAL LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "ROCM",
        "clearingBroker": "0443",
        "brokerName": "RIM SECURITIES LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "ROMO",
        "clearingBroker": "0141",
        "brokerName": "ROMANO BROTHERS AND COMPANY                                           "
    },
    {
        "type": "UIT",
        "mpid": "RONI",
        "clearingBroker": "0005",
        "brokerName": "RONIN CAPITAL, LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "ROTB",
        "clearingBroker": "0235",
        "brokerName": "ROTH CAPITAL PARTNERS, LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "ROYL",
        "clearingBroker": "0443",
        "brokerName": "ROYAL ALLIANCE ASSOCIATES, INC.                                       "
    },
    {
        "type": "UIT",
        "mpid": "RPTR",
        "clearingBroker": "0235",
        "brokerName": "DINOSAUR SECURITIES, L.L.C.                                           "
    },
    {
        "type": "UIT",
        "mpid": "RQDR",
        "clearingBroker": "0235",
        "brokerName": "RQD* CLEARING LLC                                                     "
    },
    {
        "type": "UIT",
        "mpid": "RREZ",
        "clearingBroker": "0443",
        "brokerName": "SAMUEL A RAMIREZ & CO., INC.                                          "
    },
    {
        "type": "UIT",
        "mpid": "RRUD",
        "clearingBroker": "0235",
        "brokerName": "REID & RUDIGER, LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "RSCM",
        "clearingBroker": "0235",
        "brokerName": "ROBERTSON STEPHENS CAPITAL MARKETS, LLC                               "
    },
    {
        "type": "UIT",
        "mpid": "RSSE",
        "clearingBroker": "0443",
        "brokerName": "RUSSELL IMPLEMENTATION SERVICES INC. PART OF RUSSE                    "
    },
    {
        "type": "UIT",
        "mpid": "RTHS",
        "clearingBroker": "0443",
        "brokerName": "ROTHSCHILD INVESTMENT CORPORATION                                     "
    },
    {
        "type": "UIT",
        "mpid": "RWPC",
        "clearingBroker": "0443",
        "brokerName": "R.W. PRESSPRICH & CO.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "RWSM",
        "clearingBroker": "0279",
        "brokerName": "R.W. SMITH & ASSOCIATES, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "RYDS",
        "clearingBroker": "0235",
        "brokerName": "RBC DOMINION SECURITIES CORPORATION                                   "
    },
    {
        "type": "UIT",
        "mpid": "SABS",
        "clearingBroker": "0443",
        "brokerName": "SABADELL SECURITIES USA, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "SAFX",
        "clearingBroker": "0235",
        "brokerName": "SAF FINANCIAL SECURITIES LLC                                          "
    },
    {
        "type": "UIT",
        "mpid": "SAGE",
        "clearingBroker": "0141",
        "brokerName": "SAGE, RUTTY & CO., INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "SALI",
        "clearingBroker": "0750",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "SAMI",
        "clearingBroker": "0226",
        "brokerName": "SAMI BROKERAGE LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "SANT",
        "clearingBroker": "0443",
        "brokerName": "SANTANDER US CAPITAL MARKETS LLC                                      "
    },
    {
        "type": "UIT",
        "mpid": "SAPA",
        "clearingBroker": "0141",
        "brokerName": "SAPERSTON ASSET MANAGEMENT INC.                                       "
    },
    {
        "type": "UIT",
        "mpid": "SARG",
        "clearingBroker": "0226",
        "brokerName": "PURSHE KAPLAN STERLING INVESTMENTS, INC.                              "
    },
    {
        "type": "UIT",
        "mpid": "SAXO",
        "clearingBroker": "0443",
        "brokerName": "SAXONY SECURITIES                                                     "
    },
    {
        "type": "UIT",
        "mpid": "SBAM",
        "clearingBroker": "0443",
        "brokerName": "INVESTMENT PROFESSIONALS, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "SBLS",
        "clearingBroker": "0235",
        "brokerName": "SAN BLAS SECURITIES LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "SBLT",
        "clearingBroker": "0226",
        "brokerName": "SUNBELT SECURITIES, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "SBRO",
        "clearingBroker": "0443",
        "brokerName": "STERN BROTHERS & CO.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "SBRT",
        "clearingBroker": "0226",
        "brokerName": "SIEBERT(MURIEL) & CO.,INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "SBRX",
        "clearingBroker": "0445",
        "brokerName": "MURIEL SIEBERT & CO., INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "SBSC",
        "clearingBroker": "0226",
        "brokerName": "SIEBERT CISNEROS SHANK & CO., L.L.C.                                  "
    },
    {
        "type": "UIT",
        "mpid": "SCAP",
        "clearingBroker": "0595",
        "brokerName": "STRONG CAPITAL MARKETS, LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "SCIL",
        "clearingBroker": "0052",
        "brokerName": "STRATEGIC CAPITAL INVESTMENTS, LLC                                    "
    },
    {
        "type": "UIT",
        "mpid": "SCSS",
        "clearingBroker": "0750",
        "brokerName": "STONECASTLE SECURITIES, LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "SCTI",
        "clearingBroker": "0443",
        "brokerName": "SECURITY CAPITAL BROKERAGE, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "SCTL",
        "clearingBroker": "0443",
        "brokerName": "SENTINEL SECURITIES, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "SDDC",
        "clearingBroker": "0443",
        "brokerName": "SDDCO BROKERAGE AQDVISORS                                             "
    },
    {
        "type": "UIT",
        "mpid": "SDIC",
        "clearingBroker": "0235",
        "brokerName": "SAUER DAZEY INVESTMENT CO.                                            "
    },
    {
        "type": "UIT",
        "mpid": "SEAP",
        "clearingBroker": "0226",
        "brokerName": "SEAPORT SECURITIES CORP.                                              "
    },
    {
        "type": "UIT",
        "mpid": "SEBS",
        "clearingBroker": "0443",
        "brokerName": "SECU BROKERAGE SERVICES                                               "
    },
    {
        "type": "UIT",
        "mpid": "SEEL",
        "clearingBroker": "0443",
        "brokerName": "R. SEELAUS & CO., INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "SEFB",
        "clearingBroker": "0052",
        "brokerName": "SOUTHEAST INVESTMENTS, N.C., INC.                                     "
    },
    {
        "type": "UIT",
        "mpid": "SEIB",
        "clearingBroker": "0158",
        "brokerName": "SEIBERT (J.D.) & COMPANY INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "SEIC",
        "clearingBroker": "0443",
        "brokerName": "SEI INVESTMENTS DISTRIBUTION CO.                                      "
    },
    {
        "type": "UIT",
        "mpid": "SEMI",
        "clearingBroker": "0443",
        "brokerName": "SEMINARIO SECURITIES                                                  "
    },
    {
        "type": "UIT",
        "mpid": "SEND",
        "clearingBroker": "0443",
        "brokerName": "SENDERO SECURITIES                                                    "
    },
    {
        "type": "UIT",
        "mpid": "SERL",
        "clearingBroker": "0443",
        "brokerName": "SEARLE & CO.                                                          "
    },
    {
        "type": "UIT",
        "mpid": "SEVN",
        "clearingBroker": "0443",
        "brokerName": "NATIONWIDE SECURITIES                                                 "
    },
    {
        "type": "UIT",
        "mpid": "SFPS",
        "clearingBroker": "0443",
        "brokerName": "SF INVESTMENTS, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "SFSI",
        "clearingBroker": "0235",
        "brokerName": "SUPERIOR FINANCIAL SERVICES, INC.                                     "
    },
    {
        "type": "UIT",
        "mpid": "SGAS",
        "clearingBroker": "0286",
        "brokerName": "SG AMERICAS SECURITIES, LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "SGBI",
        "clearingBroker": "0226",
        "brokerName": "SMITH, BROWN & GROOVER, INC.                                          "
    },
    {
        "type": "UIT",
        "mpid": "SGFC",
        "clearingBroker": "0226",
        "brokerName": "SIGMA FINANCIAL CORPORATION                                           "
    },
    {
        "type": "UIT",
        "mpid": "SGLC",
        "clearingBroker": "0235",
        "brokerName": "S.G. LONG & COMPANY                                                   "
    },
    {
        "type": "UIT",
        "mpid": "SGNL",
        "clearingBroker": "0279",
        "brokerName": "SIGNAL SECURITIES, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "SGSM",
        "clearingBroker": "1043",
        "brokerName": "SEAPORT GLOBAL SECURITIES LLC                                         "
    },
    {
        "type": "UIT",
        "mpid": "SHMR",
        "clearingBroker": "0443",
        "brokerName": "ABN AMRO CLEARING USA LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "SHOT",
        "clearingBroker": "0005",
        "brokerName": "SCHOTTENFELD GROUP LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "SIAN",
        "clearingBroker": "0443",
        "brokerName": "SECURIAN FINANCIAL SERVICES                                           "
    },
    {
        "type": "UIT",
        "mpid": "SJGM",
        "clearingBroker": "0443",
        "brokerName": "SCOTT JAMES GROUP, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "SKTR",
        "clearingBroker": "0279",
        "brokerName": "STOCK TRADERS                                                         "
    },
    {
        "type": "UIT",
        "mpid": "SLRD",
        "clearingBroker": "0226",
        "brokerName": "S.L. REED & COMPANY                                                   "
    },
    {
        "type": "UIT",
        "mpid": "SMCO",
        "clearingBroker": "0235",
        "brokerName": "SMITH, MOORE & CO.                                                    "
    },
    {
        "type": "UIT",
        "mpid": "SMHI",
        "clearingBroker": "0443",
        "brokerName": "SANDERS MORRIS HARRIS INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "SMNS",
        "clearingBroker": "0226",
        "brokerName": "PARKLAND SECURITIES, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "SMPR",
        "clearingBroker": "0443",
        "brokerName": "SUMMIT BROKERAGE SERVICES, INC.                                       "
    },
    {
        "type": "UIT",
        "mpid": "SMRD",
        "clearingBroker": "0443",
        "brokerName": "SUMRIDGE PARTNERS, LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "SMRI",
        "clearingBroker": "0226",
        "brokerName": "SECURITIES MANAGEMENT & RESEARCH, INC.                                "
    },
    {
        "type": "UIT",
        "mpid": "SNEX",
        "clearingBroker": "0750",
        "brokerName": "STONEX FINANCIAL INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "SNWS",
        "clearingBroker": "0443",
        "brokerName": "SNOWDEN ACCOUNT SERVICES, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "SOCO",
        "clearingBroker": "0443",
        "brokerName": "CAPITAL ONE SECURITIES, INC.                                          "
    },
    {
        "type": "UIT",
        "mpid": "SOFI",
        "clearingBroker": "0158",
        "brokerName": "SOFI SECURITIES LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "SOGO",
        "clearingBroker": "0158",
        "brokerName": "WANG INVESTMENT ASSOCIATES, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "SORS",
        "clearingBroker": "0235",
        "brokerName": "SORSBY FINANCIAL CORP.                                                "
    },
    {
        "type": "UIT",
        "mpid": "SOVG",
        "clearingBroker": "8199",
        "brokerName": "SOVEREIGN GLOBAL ADVISORS, LLC                                        "
    },
    {
        "type": "UIT",
        "mpid": "SPCS",
        "clearingBroker": "0052",
        "brokerName": "SPARTAN CAPITAL SECURITIES, LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "SPEX",
        "clearingBroker": "0235",
        "brokerName": "INSPEREX LLC                                                          "
    },
    {
        "type": "UIT",
        "mpid": "SPGS",
        "clearingBroker": "0443",
        "brokerName": "SEAPORT GLOBAL SECURITIES LLC                                         "
    },
    {
        "type": "UIT",
        "mpid": "SPHN",
        "clearingBroker": "0443",
        "brokerName": "STEPHENS INC.                                                         "
    },
    {
        "type": "UIT",
        "mpid": "SPLC",
        "clearingBroker": "0226",
        "brokerName": "SPIRE SECURITIES, LLC                                                 "
    },
    {
        "type": "UIT",
        "mpid": "SPLD",
        "clearingBroker": "0443",
        "brokerName": "SPIRE SECURITIES, LLC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "SPLN",
        "clearingBroker": "8199",
        "brokerName": "CELADON FINANCIAL GROUP LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "SPOT",
        "clearingBroker": "0005",
        "brokerName": "SPOT TRADING                                                          "
    },
    {
        "type": "UIT",
        "mpid": "SPTD",
        "clearingBroker": "0052",
        "brokerName": "MINT GLOBAL MARKETS, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "SPTS",
        "clearingBroker": "0158",
        "brokerName": "SEVEN POINTS CAPITAL, LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "SRAM",
        "clearingBroker": "0443",
        "brokerName": "SAMCO CAPITAL MARKETS, INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "SRBC",
        "clearingBroker": "0235",
        "brokerName": "SPIDERROCK EXS, LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "SSBS",
        "clearingBroker": "0443",
        "brokerName": "STATE STREET GLOBAL MARKETS, LLC                                      "
    },
    {
        "type": "UIT",
        "mpid": "SSCO",
        "clearingBroker": "8457",
        "brokerName": "SAFRA SECURITIES LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "SSGC",
        "clearingBroker": "0226",
        "brokerName": "SIGNATURE SECURITIES                                                  "
    },
    {
        "type": "UIT",
        "mpid": "SSGM",
        "clearingBroker": "0226",
        "brokerName": "STATE STREET GLOBAL MARKETS, LLC                                      "
    },
    {
        "type": "UIT",
        "mpid": "SSGR",
        "clearingBroker": "0443",
        "brokerName": "SHAREHOLDERS SERVICES GROUP INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "SSIN",
        "clearingBroker": "0226",
        "brokerName": "TRUIST INVESTMENT SERVICES, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "SSLL",
        "clearingBroker": "0189",
        "brokerName": "STATE STREET GLOBAL MARKETS, LLC                                      "
    },
    {
        "type": "UIT",
        "mpid": "SSNE",
        "clearingBroker": "0226",
        "brokerName": "SANTANDER SECURITIES LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "SSNG",
        "clearingBroker": "0443",
        "brokerName": "SISUNG SECURITIES CORPORATION                                         "
    },
    {
        "type": "UIT",
        "mpid": "STCM",
        "clearingBroker": "2095",
        "brokerName": "TRUIST SECURITIES, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "STEP",
        "clearingBroker": "0235",
        "brokerName": "FERRETTI GROUP, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "STFC",
        "clearingBroker": "0443",
        "brokerName": "STUART FRANKEL & CO., INCORPORATED                                    "
    },
    {
        "type": "UIT",
        "mpid": "STFG",
        "clearingBroker": "0443",
        "brokerName": "STANFORD GROUP COMPANY                                                "
    },
    {
        "type": "UIT",
        "mpid": "STFL",
        "clearingBroker": "0793",
        "brokerName": "STIFEL, NICOLAUS & COMPANY, INCORPORATED                              "
    },
    {
        "type": "UIT",
        "mpid": "STGC",
        "clearingBroker": "0279",
        "brokerName": "STERLING GRACE MUNICIPAL SECURITIES CO                                "
    },
    {
        "type": "UIT",
        "mpid": "STKP",
        "clearingBroker": "0158",
        "brokerName": "STOCKPILE INVESTMENTS, INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "STND",
        "clearingBroker": "0279",
        "brokerName": "FIRST STANDARD FINANCIAL COMPANY LLC                                  "
    },
    {
        "type": "UIT",
        "mpid": "STOX",
        "clearingBroker": "0445",
        "brokerName": "MURIEL SIEBERT & CO., LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "STRM",
        "clearingBroker": "0005",
        "brokerName": "LIQUIDNET, INC.                                                       "
    },
    {
        "type": "UIT",
        "mpid": "STSM",
        "clearingBroker": "0443",
        "brokerName": "STERLING SMITH CORPORATION                                            "
    },
    {
        "type": "UIT",
        "mpid": "STTT",
        "clearingBroker": "0052",
        "brokerName": "STATETRUST INVESTMENTS INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "STUR",
        "clearingBroker": "0158",
        "brokerName": "STURDIVANT & CO., INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "STXG",
        "clearingBroker": "0445",
        "brokerName": "MURIEL SIEBERT & CO., INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "STXW",
        "clearingBroker": "0443",
        "brokerName": "SA STONE WEALTH MANAGEMENT INC.                                       "
    },
    {
        "type": "UIT",
        "mpid": "SUMI",
        "clearingBroker": "0443",
        "brokerName": "SMBC NIKKO SECURITIES AMERICA, INC.                                   "
    },
    {
        "type": "UIT",
        "mpid": "SUST",
        "clearingBroker": "0235",
        "brokerName": "SUNSTREET SECURITIES, LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "SWBC",
        "clearingBroker": "0443",
        "brokerName": "SWBC INVESTMENT SERVICES, LLC                                         "
    },
    {
        "type": "UIT",
        "mpid": "SWSS",
        "clearingBroker": "0443",
        "brokerName": "SANCTUARY SECURITIES, INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "SWST",
        "clearingBroker": "0279",
        "brokerName": "HILLTOP SECURITIES INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "SYCA",
        "clearingBroker": "0443",
        "brokerName": "SYNDICATED CAPITAL, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "TAFI",
        "clearingBroker": "0443",
        "brokerName": "NATHAN HALE CAPITAL, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "TAGB",
        "clearingBroker": "0052",
        "brokerName": "TAGLICH BROTHERS, INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "TAGC",
        "clearingBroker": "1043",
        "brokerName": "TELSEY ADVISORY GROUP LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "TAGD",
        "clearingBroker": "1043",
        "brokerName": "TELSEY ADVISORY GROUP LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "TBCL",
        "clearingBroker": "0750",
        "brokerName": "TRADE BRIDGE CAPITAL LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "TBCR",
        "clearingBroker": "0235",
        "brokerName": "TRADE BRIDGE CAPITAL LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "TBIA",
        "clearingBroker": "0158",
        "brokerName": "TRADIER BROKERAGE, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "TBIS",
        "clearingBroker": "0158",
        "brokerName": "TRADIER BROKERAGE, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "TBRD",
        "clearingBroker": "0226",
        "brokerName": "THOROUGHBRED FINANCIAL SERVICES, LLC                                  "
    },
    {
        "type": "UIT",
        "mpid": "TCBI",
        "clearingBroker": "0443",
        "brokerName": "TCBI SECURITIES, INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "TDCO",
        "clearingBroker": "0235",
        "brokerName": "THOMPSON DAVIS & CO., INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "TDFS",
        "clearingBroker": "0052",
        "brokerName": "TRADERFIELD SECURITIES INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "TDNF",
        "clearingBroker": "2568",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "TDPA",
        "clearingBroker": "0226",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "TDPW",
        "clearingBroker": "0443",
        "brokerName": "TD PRIVATE CLIENT WEALTH, LLC                                         "
    },
    {
        "type": "UIT",
        "mpid": "TDSI",
        "clearingBroker": "2568",
        "brokerName": "TD SECURITIES (USA) LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "TERA",
        "clearingBroker": "0443",
        "brokerName": "CETERA FINANCIAL SPECIALISTS                                          "
    },
    {
        "type": "UIT",
        "mpid": "TFAI",
        "clearingBroker": "0226",
        "brokerName": "TRANSAMERICA FINANCIAL ADVISORS, INC.                                 "
    },
    {
        "type": "UIT",
        "mpid": "TFAS",
        "clearingBroker": "0443",
        "brokerName": "TRADITION SECURITIES AND DERIVATIVES LLC                              "
    },
    {
        "type": "UIT",
        "mpid": "TFSL",
        "clearingBroker": "0235",
        "brokerName": "TECKMEYER FINANCIAL SERVICES                                          "
    },
    {
        "type": "UIT",
        "mpid": "TFSS",
        "clearingBroker": "0443",
        "brokerName": "TFS SECURITIES, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "TGHS",
        "clearingBroker": "0443",
        "brokerName": "TGH SECURITIES, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "THEM",
        "clearingBroker": "0235",
        "brokerName": "THEMIS TRADING LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "THNK",
        "clearingBroker": "0052",
        "brokerName": "THINKEQUITY, LLC                                                      "
    },
    {
        "type": "UIT",
        "mpid": "TIAN",
        "clearingBroker": "0226",
        "brokerName": "TRIAD SECURITIES CORP                                                 "
    },
    {
        "type": "UIT",
        "mpid": "TIGC",
        "clearingBroker": "0235",
        "brokerName": "NELSONREID, INC.                                                      "
    },
    {
        "type": "UIT",
        "mpid": "TKGA",
        "clearingBroker": "0226",
        "brokerName": "KELT (THE) GROUP, LLC                                                 "
    },
    {
        "type": "UIT",
        "mpid": "TKNG",
        "clearingBroker": "0158",
        "brokerName": "TRADEKING LLC                                                         "
    },
    {
        "type": "UIT",
        "mpid": "TMAS",
        "clearingBroker": "0235",
        "brokerName": "TRADEMAS INC.                                                         "
    },
    {
        "type": "UIT",
        "mpid": "TMCC",
        "clearingBroker": "4264",
        "brokerName": "ICE BONDS SECURITIES CORPORATION                                      "
    },
    {
        "type": "UIT",
        "mpid": "TMCD",
        "clearingBroker": "0235",
        "brokerName": "MCDONALD PARTNERS LLC                                                 "
    },
    {
        "type": "UIT",
        "mpid": "TOCQ",
        "clearingBroker": "0443",
        "brokerName": "TOCQUEVILLE SECURITIES L.P.                                           "
    },
    {
        "type": "UIT",
        "mpid": "TOUR",
        "clearingBroker": "0005",
        "brokerName": "TOURMALINE PARTNERS, LLC                                              "
    },
    {
        "type": "UIT",
        "mpid": "TOYS",
        "clearingBroker": "0443",
        "brokerName": "TOYOTA FINANCIAL SERVICES SECURITIES USA CORPORATION                  "
    },
    {
        "type": "UIT",
        "mpid": "TPIS",
        "clearingBroker": "0161",
        "brokerName": "TULLETT PREBON FINANCIAL SERVICES, LLC                                "
    },
    {
        "type": "UIT",
        "mpid": "TPMR",
        "clearingBroker": "0141",
        "brokerName": "TRADE-PMR INC.                                                        "
    },
    {
        "type": "UIT",
        "mpid": "TRAD",
        "clearingBroker": "0271",
        "brokerName": "TRADESTATION SECURITIES, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "TRCG",
        "clearingBroker": "0005",
        "brokerName": "TRC MARKETS LLC                                                       "
    },
    {
        "type": "UIT",
        "mpid": "TRCS",
        "clearingBroker": "0388",
        "brokerName": "TIGERRISK CAPITAL MARKETS & ADVISORY                                  "
    },
    {
        "type": "UIT",
        "mpid": "TREX",
        "clearingBroker": "1043",
        "brokerName": "DINOSAUR FINANCIAL GROUP, L.L.C                                       "
    },
    {
        "type": "UIT",
        "mpid": "TRIB",
        "clearingBroker": "0235",
        "brokerName": "TRIBAL CAPITAL MARKETS, LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "TRIP",
        "clearingBroker": "0235",
        "brokerName": "TRIDENT PARTNERS LTD                                                  "
    },
    {
        "type": "UIT",
        "mpid": "TRSH",
        "clearingBroker": "0279",
        "brokerName": "THRASHER & CHAMBERS, INC.                                             "
    },
    {
        "type": "UIT",
        "mpid": "TRUB",
        "clearingBroker": "0141",
        "brokerName": "TRUBEE, COLLINS & CO., INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "TRWN",
        "clearingBroker": "0443",
        "brokerName": "T.R. WINSTON & COMPANY, LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "TRYC",
        "clearingBroker": "0158",
        "brokerName": "SIXTEEN SECURITIES, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "TRYN",
        "clearingBroker": "0279",
        "brokerName": "FIRST TRYON SECURITIES, LLC                                           "
    },
    {
        "type": "UIT",
        "mpid": "TSCD",
        "clearingBroker": "0235",
        "brokerName": "STURGES COMPANY (THE)                                                 "
    },
    {
        "type": "UIT",
        "mpid": "TSER",
        "clearingBroker": "0161",
        "brokerName": "TWO SIGMA EXECUTION SERVICES, LLC                                     "
    },
    {
        "type": "UIT",
        "mpid": "TSFA",
        "clearingBroker": "0443",
        "brokerName": "STRATEGIC FINANCIAL ALLIANCE (THE)                                    "
    },
    {
        "type": "UIT",
        "mpid": "TSSM",
        "clearingBroker": "0161",
        "brokerName": "TWO SIGMA SECURITIES, LLC                                             "
    },
    {
        "type": "UIT",
        "mpid": "TTSC",
        "clearingBroker": "0052",
        "brokerName": "TREND TRADE SECURITIES LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "TTSI",
        "clearingBroker": "0158",
        "brokerName": "T3 SECURITIES, INC.                                                   "
    },
    {
        "type": "UIT",
        "mpid": "TWCM",
        "clearingBroker": "0443",
        "brokerName": "TOWERS WATSON CAPITAL MARKETS                                         "
    },
    {
        "type": "UIT",
        "mpid": "TWDI",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "TWDL",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "TWDP",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "TWDR",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "TWDS",
        "clearingBroker": "0443",
        "brokerName": "TRADEWEB DIRECT LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "TWTT",
        "clearingBroker": "0158",
        "brokerName": "TASTYWORKS, INC.                                                      "
    },
    {
        "type": "UIT",
        "mpid": "UBSI",
        "clearingBroker": "0141",
        "brokerName": "UNITED BROKERAGE SERVICES, INC                                        "
    },
    {
        "type": "UIT",
        "mpid": "UBSW",
        "clearingBroker": "0642",
        "brokerName": "UBS SECURITIES LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "UCAP",
        "clearingBroker": "0750",
        "brokerName": "UCAP SECURITIES LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "UCCM",
        "clearingBroker": "0279",
        "brokerName": "CU INVESTMENT SOLUTIONS, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "UCML",
        "clearingBroker": "0052",
        "brokerName": "UNITED CAPITAL MARKETS, INC.                                          "
    },
    {
        "type": "UIT",
        "mpid": "UHLM",
        "clearingBroker": "0235",
        "brokerName": "UHLMANN PRICE SECURITIES, LLC                                         "
    },
    {
        "type": "UIT",
        "mpid": "UMBF",
        "clearingBroker": "0226",
        "brokerName": "UMB FINANCIAL SERVICES, INC.                                          "
    },
    {
        "type": "UIT",
        "mpid": "UNIB",
        "clearingBroker": "0443",
        "brokerName": "UNIBANCO SECURITIES INC                                               "
    },
    {
        "type": "UIT",
        "mpid": "UNIV",
        "clearingBroker": "0595",
        "brokerName": "UNIVEST SECURITIES, LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "UNTD",
        "clearingBroker": "0443",
        "brokerName": "WADDELL & REED, INC.                                                  "
    },
    {
        "type": "UIT",
        "mpid": "UPLN",
        "clearingBroker": "0443",
        "brokerName": "UNITED PLANNERS FINANCIAL SERVICES OF AMERICA                         "
    },
    {
        "type": "UIT",
        "mpid": "USAF",
        "clearingBroker": "0443",
        "brokerName": "USA FINANCIAL SECURITIES CORP.                                        "
    },
    {
        "type": "UIT",
        "mpid": "USCA",
        "clearingBroker": "0226",
        "brokerName": "USCA SECURITIES LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "USIC",
        "clearingBroker": "0226",
        "brokerName": "U.S. SECURITIES, INTL. CORP.                                          "
    },
    {
        "type": "UIT",
        "mpid": "USTZ",
        "clearingBroker": "0595",
        "brokerName": "TRADEZERO AMERINCA, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "UVST",
        "clearingBroker": "0443",
        "brokerName": "UVEST FINANCIAL SERVICES GROUP, INC.                                  "
    },
    {
        "type": "UIT",
        "mpid": "VABD",
        "clearingBroker": "4264",
        "brokerName": "ICE BONDS SECURITIES CORPORATION                                      "
    },
    {
        "type": "UIT",
        "mpid": "VALI",
        "clearingBroker": "0226",
        "brokerName": "VALLEY NATIONAL INVESTMENTS, INC.                                     "
    },
    {
        "type": "UIT",
        "mpid": "VALM",
        "clearingBroker": "0443",
        "brokerName": "VALMARK SECURITIES, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "VBCS",
        "clearingBroker": "0279",
        "brokerName": "VBC SECURITIES                                                        "
    },
    {
        "type": "UIT",
        "mpid": "VBLT",
        "clearingBroker": "0226",
        "brokerName": "VANDERBILT SECURITIES, LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "VBSL",
        "clearingBroker": "0595",
        "brokerName": "VISION BROKERAGE SERVICES, LLC                                        "
    },
    {
        "type": "UIT",
        "mpid": "VCAP",
        "clearingBroker": "0443",
        "brokerName": "VANGUARD CAPITAL                                                      "
    },
    {
        "type": "UIT",
        "mpid": "VCAS",
        "clearingBroker": "0443",
        "brokerName": "VCA SECURITIES, LP                                                    "
    },
    {
        "type": "UIT",
        "mpid": "VCFN",
        "clearingBroker": "0235",
        "brokerName": "VAN CLEMENS & CO. INCORPORATED                                        "
    },
    {
        "type": "UIT",
        "mpid": "VCSV",
        "clearingBroker": "0052",
        "brokerName": "PRIMARY CAPITAL, LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "VENE",
        "clearingBroker": "0443",
        "brokerName": "VENECREDIT SECURITIES                                                 "
    },
    {
        "type": "UIT",
        "mpid": "VERF",
        "clearingBroker": "0235",
        "brokerName": "THE VERTICAL TRADING GROUP, LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "VERT",
        "clearingBroker": "8199",
        "brokerName": "THE VERTICAL TRADING GROUP, LLC                                       "
    },
    {
        "type": "UIT",
        "mpid": "VEST",
        "clearingBroker": "0750",
        "brokerName": "VESTECH SECURITIES, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "VETS",
        "clearingBroker": "0235",
        "brokerName": "AMERICAN VETERANS GROUP, PBC                                          "
    },
    {
        "type": "UIT",
        "mpid": "VFSL",
        "clearingBroker": "0443",
        "brokerName": "VALOR FINANCIAL SECURITIES LLC                                        "
    },
    {
        "type": "UIT",
        "mpid": "VGRD",
        "clearingBroker": "0062",
        "brokerName": "VANGUARD MARKETING CORPORATION                                        "
    },
    {
        "type": "UIT",
        "mpid": "VISI",
        "clearingBroker": "0443",
        "brokerName": "VISION INVESTMENT SERVICES, INC.                                      "
    },
    {
        "type": "UIT",
        "mpid": "VKMI",
        "clearingBroker": "0692",
        "brokerName": "INVESCO CAPITAL MARKETS, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "VLEO",
        "clearingBroker": "0158",
        "brokerName": "VOLEO USA, INC                                                        "
    },
    {
        "type": "UIT",
        "mpid": "VMDI",
        "clearingBroker": "0443",
        "brokerName": "DESJARDINS SECURITIES INTERNATIONAL INC.                              "
    },
    {
        "type": "UIT",
        "mpid": "VMEX",
        "clearingBroker": "0443",
        "brokerName": "VECTORGLOBAL WMG                                                      "
    },
    {
        "type": "UIT",
        "mpid": "VPEW",
        "clearingBroker": "0158",
        "brokerName": "VPE WERTPAPIERHANDELSBANK AG                                          "
    },
    {
        "type": "UIT",
        "mpid": "VSIN",
        "clearingBroker": "0595",
        "brokerName": "VISION FINANCIAL MARKETS LLC                                          "
    },
    {
        "type": "UIT",
        "mpid": "VSRF",
        "clearingBroker": "0141",
        "brokerName": "VSR FINANCIAL SERVICES                                                "
    },
    {
        "type": "UIT",
        "mpid": "VTDT",
        "clearingBroker": "0158",
        "brokerName": "VIEWTRADE SECURITIES, INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "WABR",
        "clearingBroker": "0443",
        "brokerName": "WALL STREET ACCESS                                                    "
    },
    {
        "type": "UIT",
        "mpid": "WACC",
        "clearingBroker": "0279",
        "brokerName": "MIDLAND SECURITIES, LTD                                               "
    },
    {
        "type": "UIT",
        "mpid": "WACL",
        "clearingBroker": "0709",
        "brokerName": "WACHTEL & CO., INC.                                                   "
    },
    {
        "type": "UIT",
        "mpid": "WAIN",
        "clearingBroker": "0443",
        "brokerName": "H.C. WAINWRIGHT & CO., INC.                                           "
    },
    {
        "type": "UIT",
        "mpid": "WBAX",
        "clearingBroker": "0052",
        "brokerName": "WALLACHBETH CAPITAL LLC                                               "
    },
    {
        "type": "UIT",
        "mpid": "WBBC",
        "clearingBroker": "0226",
        "brokerName": "WBB SECURITIES, LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "WBFS",
        "clearingBroker": "0443",
        "brokerName": "WOODBURY FINANCIAL SERVICES, INC.                                     "
    },
    {
        "type": "UIT",
        "mpid": "WBLR",
        "clearingBroker": "0771",
        "brokerName": "WILLIAM BLAIR & COMPANY, L.L.C.                                       "
    },
    {
        "type": "UIT",
        "mpid": "WBNF",
        "clearingBroker": "0226",
        "brokerName": "WILLIAM BLAIR & COMPANY L.L.C.                                        "
    },
    {
        "type": "UIT",
        "mpid": "WBRO",
        "clearingBroker": "0443",
        "brokerName": "WILEY BROS.-AINTREE CAPITAL, LLC                                      "
    },
    {
        "type": "UIT",
        "mpid": "WCIG",
        "clearingBroker": "0750",
        "brokerName": "WILLOW COVE INVESTMENT GROUP, INC.                                    "
    },
    {
        "type": "UIT",
        "mpid": "WCSC",
        "clearingBroker": "0235",
        "brokerName": "WILMINGTON CAPITAL SECURITIES, LLC                                    "
    },
    {
        "type": "UIT",
        "mpid": "WCSF",
        "clearingBroker": "0235",
        "brokerName": "WORLD CHOICE SECURITIES, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "WEBS",
        "clearingBroker": "0226",
        "brokerName": "WEALTH ENHANCEMENT BROKERAGE SERVICES, LLC                            "
    },
    {
        "type": "UIT",
        "mpid": "WEDB",
        "clearingBroker": "0103",
        "brokerName": "WEDBUSH SECURITIES INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "WEGE",
        "clearingBroker": "0443",
        "brokerName": "WORLD EQUITY GROUP, INC.                                              "
    },
    {
        "type": "UIT",
        "mpid": "WEGI",
        "clearingBroker": "0235",
        "brokerName": "WORLD EQUITY GROUP INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "WEGP",
        "clearingBroker": "0235",
        "brokerName": "WESTERN EQUITY GROUP, INC.                                            "
    },
    {
        "type": "UIT",
        "mpid": "WESC",
        "clearingBroker": "0443",
        "brokerName": "WELLINGTON SHIELDS & CO., LLC                                         "
    },
    {
        "type": "UIT",
        "mpid": "WEST",
        "clearingBroker": "0443",
        "brokerName": "WESTERN GROWERS FINANCIAL SERVICES, INC.                              "
    },
    {
        "type": "UIT",
        "mpid": "WEXR",
        "clearingBroker": "0235",
        "brokerName": "WOLVERINE EXECUTION SERVICES, LLC                                     "
    },
    {
        "type": "UIT",
        "mpid": "WEXX",
        "clearingBroker": "0005",
        "brokerName": "WOLVERINE EXECUTION SERVICES                                          "
    },
    {
        "type": "UIT",
        "mpid": "WHAE",
        "clearingBroker": "0443",
        "brokerName": "WHARTON EQUITY CORPORATION                                            "
    },
    {
        "type": "UIT",
        "mpid": "WHCG",
        "clearingBroker": "0388",
        "brokerName": "WHITAKER                                                              "
    },
    {
        "type": "UIT",
        "mpid": "WHOT",
        "clearingBroker": "0595",
        "brokerName": "JUST2TRADE, INC.                                                      "
    },
    {
        "type": "UIT",
        "mpid": "WIDS",
        "clearingBroker": "0279",
        "brokerName": "WISCONSIN DISCOUNT SECURITIES CORP.                                   "
    },
    {
        "type": "UIT",
        "mpid": "WING",
        "clearingBroker": "0443",
        "brokerName": "ING FINANCIAL PARTNERS, INC.                                          "
    },
    {
        "type": "UIT",
        "mpid": "WISC",
        "clearingBroker": "0235",
        "brokerName": "WINDSOR, SHEFFIELD & CO., INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "WISE",
        "clearingBroker": "0052",
        "brokerName": "AXOS INVEST LLC                                                       "
    },
    {
        "type": "UIT",
        "mpid": "WISP",
        "clearingBroker": "0443",
        "brokerName": "WESTERN INTERNATIONAL SECURITIES, INC.                                "
    },
    {
        "type": "UIT",
        "mpid": "WJBI",
        "clearingBroker": "0443",
        "brokerName": "WJB CAPITAL GROUP                                                     "
    },
    {
        "type": "UIT",
        "mpid": "WLMS",
        "clearingBroker": "0443",
        "brokerName": "SIEBERT CISNEROS SHANK & CO., L.L.C.                                  "
    },
    {
        "type": "UIT",
        "mpid": "WLTH",
        "clearingBroker": "0235",
        "brokerName": "WEALTHFRONT BROKERAGE CORPORATION                                     "
    },
    {
        "type": "UIT",
        "mpid": "WMFS",
        "clearingBroker": "0226",
        "brokerName": "WESTMINSTER FINANCIAL SECURITIES, INC.                                "
    },
    {
        "type": "UIT",
        "mpid": "WMLL",
        "clearingBroker": "0005",
        "brokerName": "WATERMILL INSTITUTIONAL TRADING LLC                                   "
    },
    {
        "type": "UIT",
        "mpid": "WPCC",
        "clearingBroker": "0052",
        "brokerName": "WESTPARK CAPITAL, INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "WPCI",
        "clearingBroker": "0595",
        "brokerName": "WESTPARK CAPITAL, INC.                                                "
    },
    {
        "type": "UIT",
        "mpid": "WPSX",
        "clearingBroker": "0445",
        "brokerName": "RISE FINANCIAL SERVICES, LLC                                          "
    },
    {
        "type": "UIT",
        "mpid": "WRET",
        "clearingBroker": "0141",
        "brokerName": "WELLS FARGO CLEARING SERVICES, LLC                                    "
    },
    {
        "type": "UIT",
        "mpid": "WSBI",
        "clearingBroker": "0443",
        "brokerName": "W&S BROKERAGE SVCS                                                    "
    },
    {
        "type": "UIT",
        "mpid": "WSCC",
        "clearingBroker": "0235",
        "brokerName": "WASHINGTON SECURITIES CORPORATION                                     "
    },
    {
        "type": "UIT",
        "mpid": "WSCX",
        "clearingBroker": "0235",
        "brokerName": "WORKMAN SECURITIES CORP                                               "
    },
    {
        "type": "UIT",
        "mpid": "WSEC",
        "clearingBroker": "0443",
        "brokerName": "WILLIS SECURITIES, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "WSGD",
        "clearingBroker": "8199",
        "brokerName": "WEDBUSH SECURITIES INC./P3                                            "
    },
    {
        "type": "UIT",
        "mpid": "WSIW",
        "clearingBroker": "8199",
        "brokerName": "WEDBUSH SECURITIES INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "WSRP",
        "clearingBroker": "0052",
        "brokerName": "WESTROCK CAPITAL MANAGEMENT, INC.                                     "
    },
    {
        "type": "UIT",
        "mpid": "WSTI",
        "clearingBroker": "0226",
        "brokerName": "WESTERN INTERNATIONAL SECURITIES, INC.                                "
    },
    {
        "type": "UIT",
        "mpid": "WTCO",
        "clearingBroker": "0005",
        "brokerName": "WILLIAMS TRADING LLC                                                  "
    },
    {
        "type": "UIT",
        "mpid": "WTFS",
        "clearingBroker": "0052",
        "brokerName": "LIME TRADING CORP                                                     "
    },
    {
        "type": "UIT",
        "mpid": "WTKR",
        "clearingBroker": "0388",
        "brokerName": "WHITAKER                                                              "
    },
    {
        "type": "UIT",
        "mpid": "WTLP",
        "clearingBroker": "0388",
        "brokerName": "WOLVERINE TRADING, LLC                                                "
    },
    {
        "type": "UIT",
        "mpid": "WTRI",
        "clearingBroker": "0235",
        "brokerName": "WATERFORD INVESTORS SERVICES, INC.                                    "
    },
    {
        "type": "UIT",
        "mpid": "WUND",
        "clearingBroker": "0141",
        "brokerName": "B. RILEY WEALTH MANAGEMENT                                            "
    },
    {
        "type": "UIT",
        "mpid": "XPUS",
        "clearingBroker": "0443",
        "brokerName": "XP SECURITIES, LLC                                                    "
    },
    {
        "type": "UIT",
        "mpid": "XRVR",
        "clearingBroker": "0279",
        "brokerName": "CRB SECURITIES, LLC                                                   "
    },
    {
        "type": "UIT",
        "mpid": "XTLS",
        "clearingBroker": "0052",
        "brokerName": "XTELLUS CAPITAL PARTNERS, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "XTLW",
        "clearingBroker": "0052",
        "brokerName": "XTELLUS CAPITAL PARTNERS, INC.                                        "
    },
    {
        "type": "UIT",
        "mpid": "XTXE",
        "clearingBroker": "0161",
        "brokerName": "XTX EXECUTION SERVICES LLC                                            "
    },
    {
        "type": "UIT",
        "mpid": "YLPL",
        "clearingBroker": "0075",
        "brokerName": "LPL FINANCIAL LLC                                                     "
    },
    {
        "type": "UIT",
        "mpid": "YOSE",
        "clearingBroker": "0052",
        "brokerName": "YORK SECURITIES, INC.                                                 "
    },
    {
        "type": "UIT",
        "mpid": "ZAHK",
        "clearingBroker": "0443",
        "brokerName": "TRANSAMERICA FINANCIAL ADVISORS                                       "
    },
    {
        "type": "UIT",
        "mpid": "ZAND",
        "clearingBroker": "0443",
        "brokerName": "MCLAUGHLIN RYDER INVESTMENTS                                          "
    },
    {
        "type": "UIT",
        "mpid": "ZEDB",
        "clearingBroker": "0161",
        "brokerName": "INVESCO CAPITAL MARKETS, INC.                                         "
    },
    {
        "type": "UIT",
        "mpid": "ZERO",
        "clearingBroker": "0158",
        "brokerName": "TRADEZERO AMERICA, INC.                                               "
    },
    {
        "type": "UIT",
        "mpid": "ZION",
        "clearingBroker": "0065",
        "brokerName": "ZIONS DIRECT, INC.                                                    "
    },
    {
        "type": "UIT",
        "mpid": "ZIVI",
        "clearingBroker": "0235",
        "brokerName": "ZIV INVESTMENT COMPANY                                                "
    },
    {
        "type": "UIT",
        "mpid": "ZOUL",
        "clearingBroker": "0235",
        "brokerName": "N.B. ZOULLAS SECURITIES, INC.                                         "
    }
];
const $401c39894fc2759b$export$4d75181863a19b8c = "2025-06-06T21:50:06.884Z";


let $9af4149271f95228$var$_ = (t)=>t, $9af4149271f95228$var$t, $9af4149271f95228$var$t1, $9af4149271f95228$var$t2, $9af4149271f95228$var$t3, $9af4149271f95228$var$t4, $9af4149271f95228$var$t5, $9af4149271f95228$var$t6, $9af4149271f95228$var$t7, $9af4149271f95228$var$t8;
const $9af4149271f95228$var$Wrapper = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).header($9af4149271f95228$var$t || ($9af4149271f95228$var$t = $9af4149271f95228$var$_`
  padding: 1rem 1rem 16px 24px;
  line-height: 1;
  border-bottom: 1px solid var(--border-color);
  font-family: monospace;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  position: relative;

  @media ${0} {
    flex-direction: column;
    gap: 1.5rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
`), (0, $576749860f83a2d7$export$3d5e80817e1f8611));
const $9af4149271f95228$var$TitleSubhead = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).div($9af4149271f95228$var$t1 || ($9af4149271f95228$var$t1 = $9af4149271f95228$var$_`
  display: flex;
  gap: 0.25rem;
  flex-direction: column;

  @media ${0} {
    align-items: center;
  }
`), (0, $576749860f83a2d7$export$3d5e80817e1f8611));
const $9af4149271f95228$var$Subhead = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).div($9af4149271f95228$var$t2 || ($9af4149271f95228$var$t2 = $9af4149271f95228$var$_`
  font-size: 0.875rem;
  opacity: 0.7;
  transform: translateX(1px);
`));
const $9af4149271f95228$var$Title = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).h1($9af4149271f95228$var$t3 || ($9af4149271f95228$var$t3 = $9af4149271f95228$var$_`
  font-size: 1.5rem;
  margin: 0;
`));
const $9af4149271f95228$var$Link = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).a($9af4149271f95228$var$t4 || ($9af4149271f95228$var$t4 = $9af4149271f95228$var$_`
  color: inherit;
  display: inline;
  transition: color 0.1s ease-in-out;

  @media (hover: hover) {
    &:hover {
      color: var(--neutral-500);
    }
  }
`));
const $9af4149271f95228$var$SelfPromotion = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).div($9af4149271f95228$var$t5 || ($9af4149271f95228$var$t5 = $9af4149271f95228$var$_`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.5rem;

  @media ${0} {
    flex-direction: row-reverse;
    width: 100%;
    justify-content: space-between;
    align-items: center;
  }
`), (0, $576749860f83a2d7$export$3d5e80817e1f8611));
const $9af4149271f95228$var$TitleLink = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).a($9af4149271f95228$var$t6 || ($9af4149271f95228$var$t6 = $9af4149271f95228$var$_`
  text-decoration: none;
  color: inherit;

  @media (hover: hover) {
    &:hover {
      text-decoration: underline;
    }
  }
`));
const $9af4149271f95228$var$SocialLink = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).a($9af4149271f95228$var$t7 || ($9af4149271f95228$var$t7 = $9af4149271f95228$var$_`
  display: inline-flex;
  align-items: center;
  width: 1.5em;
  height: 1.5em;
  color: var(--slate-500);

  transition: color 0.1s ease-in-out;
  @media (hover: hover) {
    &:hover {
      color: var(--slate-700);
    }
  }
`));
const $9af4149271f95228$var$Socials = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).div($9af4149271f95228$var$t8 || ($9af4149271f95228$var$t8 = $9af4149271f95228$var$_`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  justify-content: flex-end;
  align-items: center;

  @media (max-width: ${0}px) {
    transform: translateY(-1px);
  }
`), (0, $576749860f83a2d7$export$83e664a9d119a376));
function $9af4149271f95228$var$Header() {
    return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)($9af4149271f95228$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)($9af4149271f95228$var$TitleSubhead, {
                children: [
                    /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($9af4149271f95228$var$TitleLink, {
                        href: "/",
                        children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($9af4149271f95228$var$Title, {
                            children: "MPID Tracker"
                        })
                    }),
                    /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($9af4149271f95228$var$Subhead, {
                        children: "An MPID is a Market Participant Identifier, used to identify firms in the stock market."
                    }),
                    /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)($9af4149271f95228$var$Subhead, {
                        children: [
                            "Data is sourced from the",
                            " ",
                            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($9af4149271f95228$var$Link, {
                                href: "https://www.dtcc.com",
                                children: "Depository Trust & Clearing Corporation (DTCC)"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)($9af4149271f95228$var$Subhead, {
                        children: [
                            "Data last refreshed: ",
                            new Date((0, $401c39894fc2759b$export$4d75181863a19b8c)).toLocaleString()
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)($9af4149271f95228$var$SelfPromotion, {
                children: [
                    /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)($9af4149271f95228$var$Socials, {
                        children: [
                            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($9af4149271f95228$var$SocialLink, {
                                href: "https://github.com/davidawad/mpid-base",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)((0, $8c0ce35eac81a929$export$52f0f02147b12c03), {})
                            }),
                            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($9af4149271f95228$var$SocialLink, {
                                href: "https://twitter.com/realdavidawad",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)((0, $8c0ce35eac81a929$export$9e389cdad32a5b7a), {})
                            }),
                            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($9af4149271f95228$var$SocialLink, {
                                href: "https://bsky.app/profile/davidawad.bsky.social",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)((0, $8c0ce35eac81a929$export$128fdd60f6c96030), {})
                            }),
                            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($9af4149271f95228$var$SocialLink, {
                                href: "https://www.linkedin.com/in/davidaawad/",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)((0, $8c0ce35eac81a929$export$60f7169f5ee875bc), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)("p", {
                        children: [
                            "A website by ",
                            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($9af4149271f95228$var$Link, {
                                href: "https://davidawad.com",
                                children: "davidawad"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $9af4149271f95228$export$2e2bcd8739ae039 = $9af4149271f95228$var$Header;




var $aEMJz = parcelRequire("aEMJz");


let $8326a0f291697a14$var$_ = (t)=>t, $8326a0f291697a14$var$t;
const $8326a0f291697a14$var$UnstyledButton = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).button($8326a0f291697a14$var$t || ($8326a0f291697a14$var$t = $8326a0f291697a14$var$_`
  border: none;
  background: none;
  padding: 0;
  align-items: center;
  justify-content: center;
`));
var $8326a0f291697a14$export$2e2bcd8739ae039 = $8326a0f291697a14$var$UnstyledButton;






let $f1ae136eedada039$var$_ = (t)=>t, $f1ae136eedada039$var$t, $f1ae136eedada039$var$t1, $f1ae136eedada039$var$t2, $f1ae136eedada039$var$t3, $f1ae136eedada039$var$t4, $f1ae136eedada039$var$t5, $f1ae136eedada039$var$t6, $f1ae136eedada039$var$t7, $f1ae136eedada039$var$t8, $f1ae136eedada039$var$t9, $f1ae136eedada039$var$t10, $f1ae136eedada039$var$t11, $f1ae136eedada039$var$t12;
const $f1ae136eedada039$var$BaseButton = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039)((0, $8326a0f291697a14$export$2e2bcd8739ae039))($f1ae136eedada039$var$t || ($f1ae136eedada039$var$t = $f1ae136eedada039$var$_`
  height: 100%;
  aspect-ratio: 1;
  cursor: pointer;
  padding: 0;
  transition:
    transform 0.1s ease-in-out,
    color 0.1s ease-in-out;

  @media ${0} {
    height: 60%;
  }

  &:focus {
    outline: none;
    background-color: transparent;
  }

  &:selected {
    background-color: transparent;
  }

  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-tap-highlight-color: transparent;
`), (0, $576749860f83a2d7$export$3d5e80817e1f8611));
const $f1ae136eedada039$var$CopyButton = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039)($f1ae136eedada039$var$BaseButton)($f1ae136eedada039$var$t1 || ($f1ae136eedada039$var$t1 = $f1ae136eedada039$var$_`
  grid-area: copy;

  color: var(--slate-700);

  @media (hover: hover) {
    &:hover {
      color: var(--slate-900);
    }
  }

  transform: ${0};

  &:active {
    transform: scale(0.8);
  }

  @media ${0} {
    height: 1.5rem;
  }
`), (props)=>props.$rowMouseDown ? "scale(0.8)" : "none", (0, $576749860f83a2d7$export$3d5e80817e1f8611));
const $f1ae136eedada039$var$SpinStretch = (0, $4a95c28624d97f2e$export$d25ddfdf17c3ad3e)($f1ae136eedada039$var$t2 || ($f1ae136eedada039$var$t2 = $f1ae136eedada039$var$_`
  0% {
    transform: scale(1) rotate(0deg);
  }

  20% {
    transform: scale(0.8) rotate(-40deg);
  }


  100% {
    transform: scale(1) rotate(360deg);
  }
`));
const $f1ae136eedada039$var$FavoriteButton = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039)($f1ae136eedada039$var$BaseButton)($f1ae136eedada039$var$t3 || ($f1ae136eedada039$var$t3 = $f1ae136eedada039$var$_`
  grid-area: favorite;

  color: var(--yellow-700);

  --fill-color: ${0};

  &[data-just-faved="true"] {
    animation: ${0} 0.8s cubic-bezier(0.25, 0.8, 0.25, 1) both;
  }

  @media (hover: hover) {
    &:hover {
      color: ${0};
    }
  }

  @media ${0} {
    height: 1.5rem;
  }
`), (props)=>props.$isFaved ? "var(--yellow-500)" : "transparent", $f1ae136eedada039$var$SpinStretch, (props)=>props.$isFaved ? "var(--yellow-100)" : "var(--yellow-500)", (0, $576749860f83a2d7$export$3d5e80817e1f8611));
const $f1ae136eedada039$var$Wrapper = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).div($f1ae136eedada039$var$t4 || ($f1ae136eedada039$var$t4 = $f1ae136eedada039$var$_`
  flex: 1;
  min-height: 0;
  position: relative;
  outline: none;
  overflow-y: auto;
  margin: 0 18rem;

  --text-size: 0.875rem;

  @media ${0} {
    margin: 0 1rem;
  }

  @media ${0} {
    --text-size: 0.75rem;
  }
`), (0, $576749860f83a2d7$export$3d5e80817e1f8611), (0, $576749860f83a2d7$export$57b55975112d979e));
const $f1ae136eedada039$var$List = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).div($f1ae136eedada039$var$t5 || ($f1ae136eedada039$var$t5 = $f1ae136eedada039$var$_`
  height: 100%;
  padding-bottom: 2rem;
`));
const $f1ae136eedada039$var$HeaderRow = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).div($f1ae136eedada039$var$t6 || ($f1ae136eedada039$var$t6 = $f1ae136eedada039$var$_`
  display: grid;
  padding: 0.25rem 0;
  grid-template-areas: "type mpid brokerName clearingBroker favorite copy";
  grid-template-columns: 0.5fr 1fr 3fr 1fr 0.5fr 0.5fr;
  gap: 0.25rem 0.5rem;
  align-items: center;
  font-family: monospace;
  white-space: nowrap;
  font-size: var(--text-size);
  border-bottom: 1px solid var(--border-color);
  height: ${0}px;
  position: sticky;
  top: 0;
  background: var(--slate-200);
  z-index: 1;

  @media ${0} {
    grid-template-areas: "type mpid brokerName clearingBroker";
    grid-template-columns: 1fr 1fr 2fr 1fr;

    & > [style*="grid-area: favorite"],
    & > [style*="grid-area: copy"] {
      display: none;
    }
  }
`), (0, $576749860f83a2d7$export$cba6217a006ba569), (0, $576749860f83a2d7$export$3d5e80817e1f8611));
const $f1ae136eedada039$var$RowWrapper = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).div($f1ae136eedada039$var$t7 || ($f1ae136eedada039$var$t7 = $f1ae136eedada039$var$_`
  display: grid;
  padding: 0.25rem 0;

  grid-template-areas: "type mpid brokerName clearingBroker favorite copy copied";
  grid-template-rows: 100%;
  grid-template-columns: 0.5fr 1fr 3fr 1fr 0.5fr 0.5fr 0.5fr;
  gap: 0.25rem 0.5rem;
  align-items: center;

  font-family: monospace;
  white-space: nowrap;
  font-size: var(--text-size);
  border-bottom: 1px solid var(--border-color);
  height: ${0}px;

  @media (hover: hover) {
    &:hover {
      background-color: var(--slate-400);
    }
  }

  background-color: var(--row-background, transparent);
  transition: background-color 0.1s ease-in-out;

  @media ${0} {
    grid-template-columns: 0.5fr 1fr 2fr 1fr;
    grid-template-areas:
      "type mpid brokerName clearingBroker"
      "favorite copy . .";
    grid-template-rows: auto auto;
    height: auto;
    justify-content: center;
    gap: 0.25rem 0.5rem;
    padding: 0.5rem 0;
    margin-left: 0;
    white-space: normal;
  }
`), (0, $576749860f83a2d7$export$cba6217a006ba569), (0, $576749860f83a2d7$export$3d5e80817e1f8611));
const $f1ae136eedada039$var$FadeOutDown = (0, $4a95c28624d97f2e$export$d25ddfdf17c3ad3e)($f1ae136eedada039$var$t8 || ($f1ae136eedada039$var$t8 = $f1ae136eedada039$var$_`
  0% {
    opacity: 0;
  }

  15% {
    opacity: 1;
  }

  40% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $f1ae136eedada039$var$FadeOutSide = (0, $4a95c28624d97f2e$export$d25ddfdf17c3ad3e)($f1ae136eedada039$var$t9 || ($f1ae136eedada039$var$t9 = $f1ae136eedada039$var$_`
  0% {
    opacity: 0;
    transform: translateX(0);
  }

  30% {
    opacity: 1;
    transform: translateX(-110%);
  }

  50% {
    opacity: 1;
    transform: translateX(-110%);
  }

  100% {
    transform: translateX(0);
  }
`));
const $f1ae136eedada039$var$CopiedText = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).div($f1ae136eedada039$var$t10 || ($f1ae136eedada039$var$t10 = $f1ae136eedada039$var$_`
  grid-area: copied;
  font-size: var(--text-size);
  color: var(--green-900);
  animation: ${0} 0.6s ease-in both;
  user-select: none;

  @media ${0} {
    position: absolute;
    backdrop-filter: blur(10px);
    background-color: var(--slate-100);
    border-radius: 0.5rem;
    padding: 0.5rem;
    left: 100%;
    animation: ${0} 1s ease-out both;
  }
`), $f1ae136eedada039$var$FadeOutDown, (0, $576749860f83a2d7$export$3d5e80817e1f8611), $f1ae136eedada039$var$FadeOutSide);
const $f1ae136eedada039$var$Cell = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).span($f1ae136eedada039$var$t11 || ($f1ae136eedada039$var$t11 = $f1ae136eedada039$var$_`
  display: block;
  width: fit-content;
`));
const $f1ae136eedada039$var$Highlight = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).span($f1ae136eedada039$var$t12 || ($f1ae136eedada039$var$t12 = $f1ae136eedada039$var$_`
  background-color: yellow;
`));
function $f1ae136eedada039$var$Row({ mpid: mpid, isFaved: isFaved, toggleFavedMPID: toggleFavedMPID, search: search }) {
    const [justFaved, setJustFaved] = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useState(null);
    const [mouseDown, setMouseDown] = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useState(false);
    const [justCopied, setJustCopied] = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useState(0);
    const timeoutRef = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useRef(null);
    const handleCopy = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useCallback(async ()=>{
        clearTimeout(timeoutRef.current);
        await navigator.clipboard.writeText(mpid.brokerName.trim()).catch((e)=>{
            console.error("error copying to clipboard", e);
            setJustCopied(0);
        }).then(()=>{
            setJustCopied((prev)=>prev + 1);
            timeoutRef.current = setTimeout(()=>{
                setJustCopied(0);
            }, 1000);
        });
    }, [
        mpid.mpid
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useEffect(()=>{
        if (justFaved && justFaved !== mpid.mpid) setJustFaved(null);
    }, [
        justFaved,
        mpid.mpid
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useEffect(()=>{
        const handleMouseUp = ()=>{
            if (mouseDown) {
                setMouseDown(false);
                handleCopy();
            }
        };
        window.addEventListener("mouseup", handleMouseUp);
        return ()=>{
            window.removeEventListener("mouseup", handleMouseUp);
        };
    }, [
        mouseDown,
        handleCopy
    ]);
    const highlight = (text)=>{
        if (!search || !text.toLowerCase().includes(search.toLowerCase())) return text;
        const start = text.toLowerCase().indexOf(search.toLowerCase());
        const end = start + search.length;
        return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)((0, $fe3e626085e1e6b8$exports.Fragment), {
            children: [
                text.slice(0, start),
                /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($f1ae136eedada039$var$Highlight, {
                    children: text.slice(start, end)
                }),
                text.slice(end)
            ]
        });
    };
    return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)($f1ae136eedada039$var$RowWrapper, {
        onMouseDown: (e)=>{
            if (e.target === e.currentTarget) setMouseDown(true);
        },
        style: {
            backgroundColor: mouseDown ? "var(--slate-500)" : null
        },
        children: [
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($f1ae136eedada039$var$Cell, {
                style: {
                    gridArea: "type"
                },
                children: highlight(mpid.type)
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($f1ae136eedada039$var$Cell, {
                style: {
                    gridArea: "mpid"
                },
                children: highlight(mpid.mpid)
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($f1ae136eedada039$var$Cell, {
                style: {
                    gridArea: "brokerName"
                },
                children: highlight(mpid.brokerName)
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($f1ae136eedada039$var$Cell, {
                style: {
                    gridArea: "clearingBroker"
                },
                children: highlight(mpid.clearingBroker)
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($f1ae136eedada039$var$CopyButton, {
                onClick: handleCopy,
                $rowMouseDown: mouseDown,
                children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)((0, $8c0ce35eac81a929$export$ea3b71af1761ff40), {
                    style: {
                        height: "100%",
                        aspectRatio: 1
                    }
                })
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($f1ae136eedada039$var$FavoriteButton, {
                $isFaved: isFaved,
                "data-just-faved": isFaved && justFaved === mpid.mpid,
                onClick: ()=>{
                    if (!isFaved) setJustFaved(mpid.mpid);
                    toggleFavedMPID(mpid.mpid);
                },
                children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)((0, $8c0ce35eac81a929$export$1644ba17714857f1), {
                    fill: "var(--fill-color)",
                    style: {
                        height: "100%",
                        aspectRatio: 1
                    }
                })
            }),
            justCopied !== 0 && /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($f1ae136eedada039$var$CopiedText, {
                children: "copied!"
            }, justCopied)
        ]
    });
}
function $f1ae136eedada039$var$MPIDDisplay({ mpids: mpids, favedMPIDs: favedMPIDs, toggleFavedMPID: toggleFavedMPID, search: search }) {
    return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)($f1ae136eedada039$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)($f1ae136eedada039$var$HeaderRow, {
                children: [
                    /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($f1ae136eedada039$var$Cell, {
                        style: {
                            gridArea: "type"
                        },
                        children: "Type"
                    }),
                    /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($f1ae136eedada039$var$Cell, {
                        style: {
                            gridArea: "mpid"
                        },
                        children: "MPID"
                    }),
                    /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($f1ae136eedada039$var$Cell, {
                        style: {
                            gridArea: "brokerName"
                        },
                        children: "Broker Name"
                    }),
                    /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($f1ae136eedada039$var$Cell, {
                        style: {
                            gridArea: "clearingBroker"
                        },
                        children: "Clearing Broker"
                    }),
                    /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($f1ae136eedada039$var$Cell, {
                        style: {
                            gridArea: "favorite"
                        },
                        children: "Favorite"
                    }),
                    /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($f1ae136eedada039$var$Cell, {
                        style: {
                            gridArea: "copy"
                        },
                        children: "Copy"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($f1ae136eedada039$var$List, {
                children: mpids.map((mpid, index)=>{
                    return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($f1ae136eedada039$var$Row, {
                        mpid: mpid,
                        isFaved: favedMPIDs[mpid.mpid],
                        toggleFavedMPID: toggleFavedMPID,
                        search: search
                    }, `${mpid.mpid}-${index}`);
                })
            })
        ]
    });
}
var $f1ae136eedada039$export$2e2bcd8739ae039 = $f1ae136eedada039$var$MPIDDisplay;




var $aEMJz = parcelRequire("aEMJz");




let $8c61e0cf04238a32$var$_ = (t)=>t, $8c61e0cf04238a32$var$t, $8c61e0cf04238a32$var$t1, $8c61e0cf04238a32$var$t2, $8c61e0cf04238a32$var$t3, $8c61e0cf04238a32$var$t4;
const $8c61e0cf04238a32$var$Button = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039)((0, $8326a0f291697a14$export$2e2bcd8739ae039))($8c61e0cf04238a32$var$t || ($8c61e0cf04238a32$var$t = $8c61e0cf04238a32$var$_`
  font-size: 0.875rem;
  aspect-ratio: 1;
  max-height: 80%;
  padding: 4px;
  color: var(--neutral-700);
  flex-shrink: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  @media (hover: hover) {
    &:hover {
      background-color: var(--slate-200);
    }
  }
`));
const $8c61e0cf04238a32$var$Wrapper = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).div($8c61e0cf04238a32$var$t1 || ($8c61e0cf04238a32$var$t1 = $8c61e0cf04238a32$var$_`
  display: flex;
  flex-direction: row;
  gap: 0.25rem;
  height: 2rem;
  position: fixed;
  top: 0;
  right: 4rem;
  padding: 0 0.5rem;

  max-width: calc(100vw - ${0}px);

  @media ${0} {
    right: calc(${0}px);
  }

  transform: translateY(var(--y-offset));
  transition: transform 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);
  z-index: 1000;
  background-color: var(--slate-50);
  align-items: center;
`), (0, $576749860f83a2d7$export$9a6bb2acef5e644a), (0, $576749860f83a2d7$export$3d5e80817e1f8611), (0, $576749860f83a2d7$export$9a6bb2acef5e644a));
const $8c61e0cf04238a32$var$ShowSearchButton = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039)((0, $8326a0f291697a14$export$2e2bcd8739ae039))($8c61e0cf04238a32$var$t2 || ($8c61e0cf04238a32$var$t2 = $8c61e0cf04238a32$var$_`
  background-color: var(--slate-50);
  border-radius: 0 0 8px 8px;
  font-size: 0.875rem;
  font-family: monospace;
  padding: 0rem 1rem;

  display: flex;
  align-items: center;

  position: absolute;
  z-index: 999;
  right: 10rem;
  color: inherit;
  @media ${0} {
    right: calc(${0}px);
    bottom: 0;
    border-radius: 8px 0 0 8px;
  }

  outline: none;
  &:focus {
    outline: none;
  }
  cursor: pointer;
  transition: background-color 0.1s ease-in-out;
  @media (hover: hover) {
    &:hover {
      background-color: var(--slate-400);
    }
  }
`), (0, $576749860f83a2d7$export$3d5e80817e1f8611), (0, $576749860f83a2d7$export$9a6bb2acef5e644a));
const $8c61e0cf04238a32$var$Input = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).input($8c61e0cf04238a32$var$t3 || ($8c61e0cf04238a32$var$t3 = $8c61e0cf04238a32$var$_`
  font-family: monospace;
  font-size: 1rem;
  width: 100%;
  padding: 0.25rem;
  outline: none;
  border: none;
  background-color: var(--slate-50);

  &:focus {
    outline: none;
  }
`));
const $8c61e0cf04238a32$var$Form = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).form($8c61e0cf04238a32$var$t4 || ($8c61e0cf04238a32$var$t4 = $8c61e0cf04238a32$var$_`
  flex: 1 1 38ch;
  width: 38ch;
  min-width: 6ch;
`));
function $8c61e0cf04238a32$var$SearchWidget({ search: search, setSearch: setSearch }) {
    const [searchDisplayed, setSearchDisplayed] = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useState(false);
    const inputRef = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useRef(null);
    const cmdKey = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useMemo(()=>{
        const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
        return isMac ? "metaKey" : "ctrlKey";
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useEffect(()=>{
        const handleKeyDown = (e)=>{
            if (e[cmdKey] && e.key === "f") {
                var _inputRef_current;
                e.preventDefault();
                setSearchDisplayed(true);
                (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
            } else if (e.key === "Escape") setSearchDisplayed(false);
        };
        window.addEventListener("keydown", handleKeyDown);
        return ()=>window.removeEventListener("keydown", handleKeyDown);
    }, [
        cmdKey
    ]);
    return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)((0, $fe3e626085e1e6b8$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($8c61e0cf04238a32$var$ShowSearchButton, {
                onClick: ()=>{
                    setSearchDisplayed((prev)=>!prev);
                },
                children: "search!"
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)($8c61e0cf04238a32$var$Wrapper, {
                style: {
                    "--y-offset": searchDisplayed ? "0" : "-110%"
                },
                children: [
                    /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($8c61e0cf04238a32$var$Form, {
                        onSubmit: (e)=>{
                            e.preventDefault();
                        },
                        children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($8c61e0cf04238a32$var$Input, {
                            ref: inputRef,
                            type: "text",
                            placeholder: "Search for an MPID",
                            value: search,
                            onChange: (e)=>{
                                setSearch(e.target.value);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($8c61e0cf04238a32$var$Button, {
                        onClick: ()=>setSearchDisplayed(false),
                        children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)((0, $8c0ce35eac81a929$export$78acf4525d8a74c4), {
                            style: {
                                height: "100%",
                                width: "100%"
                            }
                        })
                    })
                ]
            })
        ]
    });
}
var $8c61e0cf04238a32$export$2e2bcd8739ae039 = $8c61e0cf04238a32$var$SearchWidget;



parcelRequire("aEMJz");




let $5a79d22fa1db84b7$var$_ = (t)=>t, $5a79d22fa1db84b7$var$t;
const $5a79d22fa1db84b7$var$FavoritesButton = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039)((0, $8326a0f291697a14$export$2e2bcd8739ae039))($5a79d22fa1db84b7$var$t || ($5a79d22fa1db84b7$var$t = $5a79d22fa1db84b7$var$_`
  background-color: var(--slate-50);
  border-radius: 0 0 8px 8px;
  font-size: 0.875rem;
  font-family: monospace;
  padding: 0.15rem 1rem;
  height: 2rem;
  display: flex;
  align-items: center;
  position: absolute;
  z-index: 999;
  right: 16rem;
  color: inherit;

  --fill-color: ${0};

  @media ${0} {
    right: 8rem;
    bottom: 0;
    border-radius: 8px 8px 0 0;
  }
  outline: none;
  &:focus {
    outline: none;
  }
  cursor: pointer;
  transition: background-color 0.1s ease-in-out;
  @media (hover: hover) {
    &:hover {
      background-color: var(--slate-400);
    }
  }
`), (props)=>props.$isShowingFavorites ? "var(--yellow-500)" : "transparent", (0, $576749860f83a2d7$export$3d5e80817e1f8611));
function $5a79d22fa1db84b7$var$FavoritesWidget({ setShowFavorites: setShowFavorites, isShowingFavorites: isShowingFavorites }) {
    return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)((0, $fe3e626085e1e6b8$exports.Fragment), {
        children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($5a79d22fa1db84b7$var$FavoritesButton, {
            onClick: ()=>{
                setShowFavorites((prev)=>!prev);
            },
            $isShowingFavorites: isShowingFavorites,
            children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)((0, $8c0ce35eac81a929$export$1644ba17714857f1), {
                fill: "var(--fill-color)",
                style: {
                    height: "100%",
                    aspectRatio: 1
                }
            })
        })
    });
}
var $5a79d22fa1db84b7$export$2e2bcd8739ae039 = $5a79d22fa1db84b7$var$FavoritesWidget;





var $aEMJz = parcelRequire("aEMJz");

function $21b562c584c8b026$export$7b1c8a0f149af98a() {
    const [search, setSearch] = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useState("");
    const [results, setResults] = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useState([]);
    const searchMpins = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useCallback((input)=>{
        setSearch(input);
        if (!input) {
            setResults([]);
            return;
        }
        const lowercasedInput = input.toLowerCase();
        const filtered = (0, $401c39894fc2759b$export$51fe096c4db50bc8).filter((mpid)=>mpid.mpid.toLowerCase().includes(lowercasedInput) || mpid.brokerName.toLowerCase().includes(lowercasedInput) || mpid.clearingBroker.toLowerCase().includes(lowercasedInput) || mpid.type.toLowerCase().includes(lowercasedInput));
        setResults(filtered);
    }, []);
    return {
        search: search,
        results: results,
        searchMpins: searchMpins
    };
}



let $9fabe43002b5eff3$var$_ = (t)=>t, $9fabe43002b5eff3$var$t, $9fabe43002b5eff3$var$t1, $9fabe43002b5eff3$var$t2;
const $9fabe43002b5eff3$var$Wrapper = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).div($9fabe43002b5eff3$var$t || ($9fabe43002b5eff3$var$t = $9fabe43002b5eff3$var$_`
  display: flex;
  flex-direction: row;
  height: 100svh;
  max-height: 100svh;
  height: 100dvh;
  max-height: 100dvh;
  overflow: hidden;
  overscroll-behavior: none;
`));
const $9fabe43002b5eff3$var$HeaderAndContent = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).div($9fabe43002b5eff3$var$t1 || ($9fabe43002b5eff3$var$t1 = $9fabe43002b5eff3$var$_`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`));
const $9fabe43002b5eff3$var$Content = (0, $4a95c28624d97f2e$export$2e2bcd8739ae039).div($9fabe43002b5eff3$var$t2 || ($9fabe43002b5eff3$var$t2 = $9fabe43002b5eff3$var$_`
  overflow: hidden;
  display: flex;
  flex-direction: row;
  flex: 1;
  min-height: 0;
  overscroll-behavior: none;
`));
function $9fabe43002b5eff3$var$App() {
    const [showFavorites, setShowFavorites] = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useState(false);
    const { search: search, results: results, searchMpins: searchMpins } = (0, $21b562c584c8b026$export$7b1c8a0f149af98a)();
    const [favedMPIDs, setFavedMPIDs] = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useState(localStorage.getItem("favedMPIDs") ? JSON.parse(localStorage.getItem("favedMPIDs")) : {});
    const toggleFavedMPID = (mpid)=>{
        setFavedMPIDs((prev)=>{
            const newFavedMPIDs = (0, $c28f73f96bffd3b9$export$71511d61b312f219)({}, prev);
            if (newFavedMPIDs[mpid]) delete newFavedMPIDs[mpid];
            else newFavedMPIDs[mpid] = true;
            localStorage.setItem("favedMPIDs", JSON.stringify(newFavedMPIDs));
            return newFavedMPIDs;
        });
    };
    const displayedMpids = (0, (/*@__PURE__*/$parcel$interopDefault($aEMJz))).useMemo(()=>{
        if (search) return results;
        if (showFavorites) return (0, $401c39894fc2759b$export$51fe096c4db50bc8).filter((mpid)=>favedMPIDs[mpid.mpid]);
        return 0, $401c39894fc2759b$export$51fe096c4db50bc8;
    }, [
        search,
        results,
        showFavorites,
        favedMPIDs
    ]);
    return /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)((0, $fe3e626085e1e6b8$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)((0, $8c61e0cf04238a32$export$2e2bcd8739ae039), {
                search: search,
                setSearch: searchMpins
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)((0, $5a79d22fa1db84b7$export$2e2bcd8739ae039), {
                setShowFavorites: setShowFavorites,
                isShowingFavorites: showFavorites
            }),
            /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($9fabe43002b5eff3$var$Wrapper, {
                children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsxs)($9fabe43002b5eff3$var$HeaderAndContent, {
                    children: [
                        /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)((0, $9af4149271f95228$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)($9fabe43002b5eff3$var$Content, {
                            children: /*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)((0, $f1ae136eedada039$export$2e2bcd8739ae039), {
                                mpids: displayedMpids,
                                favedMPIDs: favedMPIDs,
                                toggleFavedMPID: toggleFavedMPID,
                                search: search
                            })
                        })
                    ]
                })
            })
        ]
    });
}
var $9fabe43002b5eff3$export$2e2bcd8739ae039 = $9fabe43002b5eff3$var$App;




const $a1f42903098844e9$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($8779a10718613263$exports))).createRoot(document.getElementById('root'));
$a1f42903098844e9$var$root.render(/*#__PURE__*/ (0, $fe3e626085e1e6b8$exports.jsx)((0, $9fabe43002b5eff3$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=index.cf5f604b.js.map
